{
  "common": {
    "cancel": "Cancel"
  },
  "settings": {
    "language": {
      "label": "Language",
      "helper": "Choose the language for menus, reports, and other app text. Saved to your account on all devices.",
      "options": {
        "en": "English",
        "tl": "Tagalog"
      },
      "savedEn": "Language set to English.",
      "savedTl": "Language set to Tagalog."
    }
  },
  "commandPalette": {
    "placeholder": "Search pages, book refs (INV-001), GL:, cust:, supp:, or email…",
    "empty": "No results found",
    "sections": {
      "bookReferences": "Book references",
      "accounts": "Accounts",
      "contacts": "Contacts",
      "emailMatches": "Email matches",
      "pages": "Pages",
      "actions": "Actions",
      "reports": "Reports",
      "account": "Account"
    },
    "items": {
      "dashboard": "Dashboard",
      "requests": "Requests",
      "taxCalendar": "Tax Calendar",
      "eisTransmissionsLog": "EIS Transmissions Log",
      "help": "Help",
      "downloadables": {
        "title": "Downloadables"
      },
      "newCashReceipt": "Record cash receipt",
      "cashReceiptTips": "Cash receipt tips",
      "transactionLocking": "Transaction locking",
      "generalSettings": "General Settings",
      "notificationSettings": "Notification Settings",
      "categories": {
        "title": "Accounts"
      },
      "transactions": {
        "title": "All Transactions"
      },
      "addTransaction": {
        "title": "New Transaction"
      },
      "journalsHub": {
        "title": "Journals"
      },
      "instoreqrMenuImport": {
        "title": "Import products from photo"
      },
      "nonVatBooksHub": {
        "title": "Cash Books"
      },
      "customers": {
        "title": "Customers"
      },
      "suppliers": {
        "title": "Suppliers"
      },
      "billerManagement": {
        "title": "Bills"
      },
      "arInvoices": {
        "title": "Invoices"
      },
      "equipmentManagement": {
        "title": "PPE"
      },
      "hris": {
        "title": "HRIS"
      },
      "capitalManagement": {
        "title": "Capitals"
      },
      "cashReceiptsJournal": {
        "title": "Cash Receipts Journal"
      },
      "uploadReceipt": {
        "title": "Upload Receipt"
      },
      "trialBalance": {
        "title": "Trial Balance"
      },
      "incomeStatement": {
        "title": "Income Statement"
      },
      "balanceSheet": {
        "title": "Balance Sheet"
      },
      "cashFlowStatement": {
        "title": "Cash Flow"
      },
      "statementOfChangesInEquity": {
        "title": "Changes in Equity"
      },
      "financialStatementGeneration": {
        "title": "Financial Statements"
      },
      "generalLedger": {
        "title": "General Ledger"
      },
      "itemsSoldLedger": {
        "title": "Items Sold Ledger"
      },
      "generalJournal": {
        "title": "General Journal"
      },
      "cashReceiptsJournalReport": {
        "title": "Cash Receipts Journal"
      },
      "cashDisbursementJournalReport": {
        "title": "Cash Disbursements Journal"
      },
      "companies": {
        "title": "All Companies"
      },
      "companyDetails": {
        "title": "Company Information"
      },
      "viewProfile": {
        "title": "My Profile"
      },
      "businessCalendar": "Business Calendar",
      "events": "Events",
      "reserve": "Reserve",
      "fileManager": "File Manager"
    },
    "bookReference": {
      "awaitingDigits": "Continue typing after {{prefix}}- to search book references.",
      "searching": "Searching book references…",
      "searchFailed": "Could not search book references. Try again.",
      "noResults": "No book reference found for \"{{query}}\".",
      "arInvoiceSubtitle": "{{customer}} · Invoice {{invoiceNumber}}",
      "cashReceiptSubtitle": "{{customer}} · OR# {{orNumber}}",
      "cashDisbursementSubtitle": "{{supplier}} · OR# {{orNumber}}",
      "apBillSubtitle": "{{supplier}} · Ref. {{referenceNumber}}",
      "apBillPaymentSubtitle": "{{supplier}} · Bill {{billReference}}",
      "arInvoicePaymentSubtitle": "{{customer}} · Invoice {{invoiceNumber}}",
      "capitalSubtitle": "{{capitalType}} · {{description}}",
      "equipmentSubtitle": "{{name}} · {{acquisitionDate}}",
      "equipmentDepreciationSubtitle": "{{equipment}} · FY {{fiscalYear}}",
      "fxRevaluationSubtitle": "{{bill}} · {{date}}",
      "journalVoucherSubtitle": "{{description}} · {{date}}"
    },
    "directed": {
      "awaitingSearchText": "Type at least 2 characters after {{prefix}} to search.",
      "searching": "Searching…",
      "searchFailed": "Could not complete search. Try again.",
      "noResults": "No results for \"{{query}}\".",
      "viewAllCustomers": "View all customers matching \"{{query}}\"",
      "viewAllSuppliers": "View all suppliers matching \"{{query}}\"",
      "kindCustomer": "Customer",
      "kindSupplier": "Supplier",
      "kindCompanyUser": "User",
      "kindAccount": "Account",
      "kindCustomersList": "Customers",
      "kindSuppliersList": "Suppliers"
    }
  },
  "statementOfComprehensiveIncome": "Income Statement",
  "trialBalance": "Trial Balance",
  "statementOfFinancialPosition": "Balance Sheet",
  "cashFlowStatement": "Cash Flow",
  "statementOfChangesInEquity": "Changes in Equity",
  "financialStatementGeneration": "Financial Statements",
  "generalJournal": "General Journal",
  "generalLedger": "General Ledger",
  "itemsSoldLedger": "Items Sold Ledger",
  "cashReceiptsJournalReport": "Cash Receipts Journal",
  "cashDisbursementJournalReport": "Cash Disbursements Journal",
  "journals": {
    "title": "Journals",
    "cash_receipts": {
      "title": "Cash Received List",
      "description": "Log cash sales with manual official receipt (OR#) numbers for each line"
    },
    "cash_disbursements": {
      "title": "Expenses List",
      "description": "Record cash payments and disbursements with check numbers and expense categories"
    },
    "transactions": {
      "title": "All Transactions",
      "description": "Record and manage day-to-day transactions with debits and credits"
    },
    "categories": {
      "title": "Categories",
      "description": "Set up and maintain your categories for reporting"
    }
  },
  "categories": {
    "pageTitle": "Categories"
  },
  "reports": {
    "title": "Reports",
    "groups": {
      "financial": "Financial Reports",
      "journals": "Journals"
    },
    "balance_sheet": {
      "description": "Assets, liabilities, and equity for a date range"
    },
    "income_statement": {
      "description": "Revenue and expenses for a date range, with net income"
    },
    "trial_balance": {
      "description": "Total debits and credits by category for a selected period"
    },
    "statement_of_changes_in_equity": {
      "description": "How equity changed over a reporting period"
    },
    "cash_flow_statement": {
      "description": "Operating, investing, and financing cash movements for a period"
    },
    "financial_statement_generation": {
      "description": "Full financial statement package with management notes and disclosures"
    },
    "cash_receipts_journal": {
      "description": "Printable report of sales by date, sales category, and amount"
    },
    "cash_disbursement_journal": {
      "description": "Printable report of expenses by date, expense category, and amount"
    },
    "general_journal": {
      "description": "All transactions in date order with debit and credit entries"
    },
    "general_ledger": {
      "description": "Transaction history for a category with running balances"
    }
  },
  "pages": {
    "requests": {
      "pageTitle": "Requests",
      "pageSubtitle": "Log client requests and follow the company timeline.",
      "newRequestButton": "New Request",
      "loading": "Loading requests…",
      "loadFailedFallback": "Failed to load requests.",
      "loadErrorMessage": "Failed to load requests.",
      "staleLoadErrorMessage": "Failed to load requests.",
      "retryButton": "Try again",
      "staleRetryButton": "Try again",
      "timelineTitle": "Timeline",
      "timelineEmpty": "No updates yet.",
      "listTitle": "Requests",
      "listEmpty": "No requests yet.",
      "columnTitle": "Title",
      "columnStatus": "Status",
      "columnRequestedBy": "Requested by",
      "listStatusEmpty": "—",
      "detailDescriptionLabel": "Description",
      "detailRequestedByLabel": "Requested by",
      "detailStatusLabel": "Status",
      "detailStatusEmpty": "—",
      "newUpdateButton": "New Update",
      "requestNotFound": "That request is not in this company.",
      "editUpdateButton": "Edit",
      "deleteUpdateButton": "Delete",
      "deleteConfirm": "Delete this update?",
      "deleteConfirmButton": "Delete",
      "deleteCancelButton": "Cancel",
      "deletingButton": "Deleting…",
      "deletingToast": "Deleting…",
      "deletedToast": "Update deleted.",
      "deleteFailedToast": "Failed to delete the update.",
      "authorUnknown": "—",
      "modalLeadLabel": "Company notes and temporary uploads",
      "newRequestModal": {
        "title": "New Request",
        "titleLabel": "Title",
        "descriptionLabel": "Description",
        "requestedByLabel": "Requested by",
        "saveButton": "Save",
        "savingButton": "Saving…",
        "savingToast": "Saving…",
        "cancelButton": "Cancel",
        "titleRequiredToast": "Enter a title.",
        "descriptionRequiredToast": "Enter a description.",
        "requestedByRequiredToast": "Enter who requested this.",
        "savedToast": "Request saved.",
        "saveFailedToast": "Failed to save the request."
      },
      "updateModal": {
        "newTitle": "New Update",
        "editTitle": "Edit Update",
        "labelLabel": "Label",
        "descriptionLabel": "Description",
        "saveButton": "Save",
        "savingButton": "Saving…",
        "savingToast": "Saving…",
        "cancelButton": "Cancel",
        "labelRequiredToast": "Enter a label.",
        "descriptionRequiredToast": "Enter a description.",
        "noChangesToast": "No changes to save.",
        "savedToast": "Update saved.",
        "saveFailedToast": "Failed to save the update."
      }
    },
    "activityLogs": {
      "title": "Activity Logs",
      "subtitle": "Track user actions and system events across the organization.",
      "filtersButton": "Filters",
      "filtersActiveLabel": "Active",
      "userEmailLabel": "User Email",
      "userEmailPlaceholder": "Filter by email…",
      "actionCategoryLabel": "Action Category",
      "allCategoriesOption": "All Categories",
      "fromDateLabel": "From Date",
      "fromDatePlaceholder": "From date",
      "toDateLabel": "To Date",
      "toDatePlaceholder": "To date",
      "exportingButton": "Exporting…",
      "exportCsvButton": "Export CSV",
      "clearFiltersButton": "Clear Filters",
      "timestampColumn": "Timestamp",
      "userColumn": "User",
      "actionColumn": "Action",
      "detailsColumn": "Details",
      "loadingMessage": "Loading activity logs…",
      "emptyMessage": "No logs found matching your filters.",
      "viewDetailsTitle": "View details",
      "noDetails": "No additional details"
    },
    "superDashboardActivityLogs": {
      "title": "Activity Logs Across Companies",
      "subtitle": "Review activity from every company where you have audit access.",
      "companyLabel": "Company",
      "allCompaniesOption": "All Companies",
      "companyColumn": "Company",
      "emptyMessage": "No accessible activity logs match your filters."
    },
    "dashboard": {
      "appsRecommend": {
        "ariaLabel": "Recommended apps to get started",
        "title": "Recommended apps",
        "body": "This company has no apps installed yet. Start with these modules, or browse the Apps Store to see everything available.",
        "browseStore": "Browse Apps Store",
        "apps": {
          "accounting": {
            "title": "Accounting",
            "shortDescription": "Journals, invoices, bills, and the books of accounts."
          },
          "tax-calendar": {
            "title": "Tax Calendar",
            "shortDescription": "BIR deadlines, reminders, and compliance tracking."
          },
          "non-vat-books": {
            "title": "Cash Books",
            "shortDescription": "A complete, customizable cash-basis bookkeeping bundle."
          },
          "non-vat-accrual-books": {
            "title": "Accrual Books",
            "shortDescription": "Cash Books plus supplier bills and customer invoices."
          },
          "invoices": {
            "title": "Invoices",
            "shortDescription": "Accounts receivable invoices and customer billing."
          },
          "journals": {
            "title": "Journals",
            "shortDescription": "Sales, expenses, bills, customers, suppliers, and more."
          },
          "reports": {
            "title": "Reports",
            "shortDescription": "Financial statements and journal reports."
          },
          "pos": {
            "title": "POS System",
            "shortDescription": "Point of sale, inventory, registers, and BIR-oriented retail flows."
          }
        }
      },
      "nonVatBooks": {
        "ariaLabel": "Cash Books statistics",
        "title": "Cash Books",
        "body": "Period statistics for your installed books modules. Open a card for the full book or report.",
        "bodyWithPeriod": "Statistics for {{period}}. Open a card for the full book or report.",
        "openHub": "Open Journals",
        "modulesGroupTitle": "Books & equity",
        "booksGroupTitle": "Books",
        "reportsGroupTitle": "Reports",
        "loadFailed": "Failed to load Cash Books statistics.",
        "kpis": {
          "netProfit": "Net profit",
          "netProfitHint": "From income statement",
          "revenue": "Revenue",
          "revenueHint": "Period sales & income",
          "expenses": "Expenses",
          "expensesHint": "Period operating costs",
          "cashChange": "Cash change",
          "cashChangeHint": "Closing cash {{closing}}"
        },
        "charts": {
          "cashActivityTitle": "Cash activity",
          "cashActivitySubtitle": "Receipts vs disbursements for the selected period",
          "receipts": "Cash receipts",
          "disbursements": "Cash disbursements",
          "balanceCompositionTitle": "Balance sheet mix",
          "balanceCompositionSubtitle": "Assets, liabilities, and equity at period end",
          "assets": "Assets",
          "liabilities": "Liabilities",
          "equity": "Equity",
          "trialBalanceTitle": "Trial balance",
          "trialBalanceSubtitle": "Debit and credit totals for the period",
          "debits": "Debits",
          "credits": "Credits",
          "accountsCount_one": "{{count}} account",
          "accountsCount_other": "{{count}} accounts",
          "accountsCount": "AccountsCount"
        },
        "stats": {
          "entriesCount_one": "{{count}} entry",
          "entriesCount_other": "{{count}} entries",
          "accountsCount_one": "{{count}} account",
          "accountsCount_other": "{{count}} accounts",
          "transactionsCount_one": "{{count}} transaction",
          "transactionsCount_other": "{{count}} transactions",
          "creditsAmount": "{{credits}} credits",
          "ledgerCreditsAccounts_one": "{{credits}} credits · {{count}} account",
          "ledgerCreditsAccounts_other": "{{credits}} credits · {{count}} accounts",
          "journalCreditsTxns_one": "{{credits}} credits · {{count}} transaction",
          "journalCreditsTxns_other": "{{credits}} credits · {{count}} transactions",
          "activeAssetsCount_one": "{{count}} active asset",
          "activeAssetsCount_other": "{{count}} active assets",
          "incomeBreakdown": "Revenue {{revenue}} · Expenses {{expenses}}",
          "balanceSheetBreakdown": "Liabilities {{liabilities}} · Equity {{equity}}",
          "equityBreakdown": "Beginning {{beginning}} · Net {{net}}",
          "endingEquityLabel": "Ending equity",
          "cashFlowBreakdown": "Opening {{opening}} · Closing {{closing}}",
          "trialBalanceBreakdown": "Credits {{credits}} · {{balanced}}",
          "balanced": "Balanced",
          "outOfBalance": "Out of balance",
          "entriesCount": "EntriesCount",
          "accountsCount": "AccountsCount",
          "transactionsCount": "TransactionsCount",
          "activeAssetsCount": "ActiveAssetsCount"
        },
        "items": {
          "cashReceiptsJournal": {
            "title": "Cash Receipts Journal"
          },
          "cashDisbursementJournal": {
            "title": "Cash Disbursement Journal"
          },
          "generalLedger": {
            "title": "General Ledger"
          },
          "generalJournal": {
            "title": "General Journal"
          },
          "equipment": {
            "title": "PPE"
          },
          "capitals": {
            "title": "Capitals"
          },
          "incomeStatement": {
            "title": "Income Statement"
          },
          "balanceSheet": {
            "title": "Balance Sheet"
          },
          "statementOfChangesInEquity": {
            "title": "Statement of Changes in Equity"
          },
          "cashFlowStatement": {
            "title": "Cash Flow Statement"
          },
          "trialBalance": {
            "title": "Trial Balance"
          }
        }
      },
      "DashboardLedgerProjectionPieChart": {
        "total_chart_1": "Total chart"
      },
      "DashboardRevenueExpensesAreaChart": {
        "title": "Revenue vs Operating Expenses",
        "subtitleForPeriod": "{{period}}",
        "legendRevenue": "Revenue",
        "legendOperatingExpenses": "Operating Expenses",
        "no_monthly_comparison_data_yet_2": "No monthly comparison data yet",
        "monthly_area_chart_comparing_revenue_and_operati_1": "Monthly area chart comparing revenue and operati"
      },
      "DashboardTaxReminders": {
        "supporting_documents_attached_3": "Supporting documents attached",
        "tax_reminders_1": "Tax reminders",
        "could_not_load_tax_reminders_2": "Could not load tax reminders"
      },
      "DashboardTransactionsBarChart": {
        "transactions_for_the_month_1": "Transactions for the month",
        "no_transaction_data_yet_4": "No transaction data yet"
      },
      "Dashboard": {
        "expense_breakdown_1": "Expense breakdown",
        "expenseBreakdownHint": "Same lines as Less: Operating Expenses on the Statement of Comprehensive Income for the selected period.",
        "dashboard_2": "Dashboard",
        "overview_of_your_business_3": "Overview of your business",
        "receivables_4": "Receivables",
        "payables_5": "Payables",
        "income_6": "Income",
        "expenses_7": "Expenses",
        "total_profit_8": "Total Profit",
        "totalIncomeForPeriod": "Total Income for {{period}}",
        "totalExpensesForPeriod": "Total Expenses for {{period}}",
        "totalProfitForPeriod": "Total Profit for {{period}}",
        "pnlSummaryTitle": "Profit & Loss Summary",
        "pnlSummaryForPeriod": "Profit & Loss Summary for {{period}}",
        "recent_transactions_9": "Recent Transactions",
        "cancelledBillTransactionTooltip": "This transaction is linked to a cancelled bill.",
        "tips_best_practices_10": "Tips & Best Practices",
        "record_transactions_regularly_11": "Record Transactions Regularly:",
        "review_reports_12": "Review Reports:",
        "organize_categories_13": "Organize Categories:",
        "track_sales_expenses_14": "Track Sales & Expenses:"
      },
      "dateRange": {
        "sectionLabel": "Dashboard date range",
        "showingStatsFor": "Showing stats for: {{period}}",
        "presetGroupLabel": "Quick period presets",
        "showCustomRange": "Custom range",
        "hideCustomRange": "Hide custom range",
        "customRangeLegend": "Custom date range",
        "fromLabel": "From",
        "toLabel": "To",
        "applyCustomRange": "Apply range",
        "vsPriorPeriod": "vs prior period",
        "metricForPeriod": "for {{period}}",
        "presets": {
          "today": "Today",
          "thisWeek": "This Week",
          "thisMonth": "This Month",
          "lastMonth": "Last Month",
          "thisYear": "This Year"
        }
      },
      "metricModal": {
        "defaultTitle": "Report details",
        "incomeTitle": "Total Income",
        "expenseTitle": "Total Expenses",
        "profitTitle": "Total Profit",
        "receivablesTitle": "Total Receivables",
        "payablesTitle": "Total Payables",
        "cashFlowTitle": "Cash change",
        "balanceSheetTitle": "Balance sheet",
        "trialBalanceTitle": "Trial balance",
        "cashReceiptsTitle": "Cash receipts",
        "cashDisbursementsTitle": "Cash disbursements",
        "generalLedgerTitle": "General ledger",
        "generalJournalTitle": "General journal",
        "equipmentTitle": "PPE",
        "capitalsTitle": "Capitals",
        "equityChangesTitle": "Statement of changes in equity",
        "incomeDescription": "This represents all income earned during the selected period.",
        "expenseDescription": "This represents all operating and non-operating expenses during the selected period.",
        "profitDescription": "This represents the net income (or loss) for the selected period.",
        "receivablesDescription": "This represents the total amount the company is expected to collect from customers.",
        "payablesDescription": "This represents the total amount the company owes to its suppliers and creditors.",
        "cashFlowDescription": "This summarizes the change in cash for the selected period.",
        "balanceSheetDescription": "This summarizes assets, liabilities, and equity as of the selected date.",
        "trialBalanceDescription": "This summarizes debit and credit totals for the selected period.",
        "moduleDescription": "Summary for this dashboard card for the selected period.",
        "cashReceiptsDescription": "Cash receipts recorded during the selected period.",
        "cashDisbursementsDescription": "Cash disbursements recorded during the selected period.",
        "generalLedgerDescription": "Accounts with activity during the selected period.",
        "generalJournalDescription": "Journal transactions recorded during the selected period.",
        "equipmentDescription": "Active PPE assets and their current book values.",
        "capitalsDescription": "Capital entries recorded during the selected period.",
        "equityChangesDescription": "Changes in equity for the selected period.",
        "fromToPeriod": "From: {{from}} To: {{to}}",
        "asOfPeriod": "As of: {{date}}",
        "incomeStatementBreakdown": "Income statement breakdown",
        "incomeStatementSummary": "Income statement summary",
        "balanceSheetBreakdown": "Balance sheet breakdown",
        "cashFlowBreakdown": "Cash flow summary",
        "trialBalanceBreakdown": "Trial balance summary",
        "cashJournalBreakdown": "Entries in this period",
        "generalLedgerBreakdown": "Accounts in this period",
        "generalJournalBreakdown": "Transactions in this period",
        "equipmentBreakdown": "Active assets",
        "equityChangesBreakdown": "Equity changes",
        "moduleBreakdown": "Summary",
        "descriptionColumn": "Description",
        "amountColumn": "Amount",
        "loading": "Loading report details…",
        "loadFailed": "Could not load report details.",
        "permissionDenied": "You do not have permission to view this report.",
        "empty": "No report lines to show for this metric.",
        "retry": "Try again",
        "close": "Close",
        "viewFullReport": "View full report",
        "viewAllEntries": "View all entries",
        "footerNote": "This total is reflected in the dashboard as \"{{metric}}\".",
        "rows": {
          "grossProfitSection": "Gross Profit",
          "grossProfitSubtotal": "Gross Profit",
          "otherIncomeSection": "Other Income",
          "revenueSection": "Revenue",
          "totalIncome": "TOTAL INCOME",
          "lessCogs": "Less: Cost of Goods Sold",
          "lessCostOfServices": "Less: Cost of Services",
          "lessCostOfSales": "Less: Cost of Sales",
          "operatingExpensesSection": "Operating Expenses",
          "nonOperatingExpensesSection": "Non-operating Expenses",
          "totalExpenses": "TOTAL EXPENSES",
          "totalIncomeLine": "Total Income",
          "lessTotalExpenses": "Less: Total Expenses",
          "netProfitBeforeTax": "Net Profit Before Tax",
          "lessIncomeTax": "Less: Income Tax Expense",
          "netProfitAfterTax": "Net Profit (After Tax)",
          "totalProfit": "TOTAL PROFIT",
          "currentAssets": "Current Assets",
          "currentLiabilities": "Current Liabilities",
          "accountsReceivable": "Accounts Receivable",
          "totalReceivables": "TOTAL RECEIVABLES",
          "accountsPayable": "Accounts Payable",
          "totalPayables": "TOTAL PAYABLES",
          "openingCash": "Opening cash",
          "operatingActivities": "Operating activities",
          "investingActivities": "Investing activities",
          "financingActivities": "Financing activities",
          "netChangeInCash": "Net change in cash",
          "closingCash": "Closing cash",
          "totalAssets": "Total assets",
          "totalLiabilities": "Total liabilities",
          "totalEquity": "Total equity",
          "totalLiabilitiesAndEquity": "Total liabilities and equity",
          "totalDebits": "Total debits",
          "totalCredits": "Total credits",
          "trialDifference": "Difference",
          "accountsCount": "{{count}} accounts",
          "moduleAmount": "Amount",
          "cashJournalTotal": "TOTAL",
          "cashJournalShowingPartial": "Showing {{shown}} of {{total}} entries",
          "beginningEquity": "Beginning equity",
          "netIncomeLoss": "Net income (loss)",
          "ownerContributions": "Owner contributions",
          "ownerWithdrawals": "Owner withdrawals",
          "endingEquity": "ENDING EQUITY",
          "equipmentBookValueTotal": "TOTAL BOOK VALUE",
          "generalJournalDebitTotal": "TOTAL DEBITS",
          "generalLedgerDebitTotal": "TOTAL DEBITS"
        }
      }
    },
    "superDashboard": {
      "title": "Super Dashboard",
      "healthChecks": {
        "pageTitle": "Health Checks",
        "loading": "Loading health checks.",
        "loadError": "Could not load health checks.",
        "empty": "You are not linked to any companies yet.",
        "healthAria": "{{name}} health {{percent}}%",
        "healthRingAria": "{{name}} health {{percent}}%. Official {{official}}%, provisional {{provisional}}%, waived {{waived}}%.",
        "healthRingLegendOfficial": "Official points",
        "healthRingLegendProvisional": "Provisional points",
        "healthRingLegendWaived": "Waived points",
        "healthRingOfficialTitle": "Official points",
        "healthRingProvisionalTitle": "Provisional points",
        "healthRingWaivedTitle": "Waived points",
        "healthPercent": "{{percent}}%",
        "healthScoreLabel": "Health: {{percent}}%",
        "openCompany": "Open the health check for {{name}}",
        "openCompanyProvisional": "Open the health check for {{name}}, health {{percent}}%, {{official}}% official, {{provisional}}% provisional, {{waived}}% waived",
        "companyPageTitle": "Health Check",
        "pointsSummary": "{{earned}} of {{total}} points",
        "criterionPoints": "{{earned}} of {{total}}",
        "groupProfile": "Company information",
        "groupDocuments": "Documents",
        "groupUploads": "Upload entries",
        "groupTax": "Tax calendar",
        "itemName": "Company name",
        "itemAddress": "Company address",
        "itemTin": "Company TIN",
        "itemEmail": "Company email",
        "itemTel": "Company telephone",
        "itemBirRdo": "RDO number",
        "itemTaxRegime": "Tax regime",
        "itemIncomeClassification": "Income classification",
        "itemVatStatus": "VAT registration",
        "itemEntityType": "Type of entity",
        "itemLineOfBusiness": "Line of Business",
        "itemBmbe": "BMBE",
        "itemCor": "BIR Certificate of Registration 2303 (COR)",
        "itemRegistration": "Registration certificate and number",
        "itemRegistrationWithNumber": "Certificate and {{numberLabel}}",
        "itemMayorsPermit": "Mayor's Permit / Business Permit",
        "itemBarangayPermit": "Barangay Business Permit",
        "itemAtp": "Authority to Print (ATP)",
        "itemBooks": "Book of accounts registration",
        "itemUploadQueue": "Upload queue is clear",
        "itemTaxStarted": "No tax filing is Started",
        "itemTaxOverdue": "No tax filing is Overdue",
        "itemTaxPartial": "No tax filing is Partial",
        "fix": "Fix",
        "fixAria": "Fix {{item}}",
        "fixTitle": "How to fix {{item}}",
        "fixClose": "Close",
        "fixOpenCompanyInformation": "Open Company Information",
        "fixOpenUploadEntry": "Open Upload Entry",
        "fixOpenTaxCalendar": "Open Tax Calendar",
        "fixName": "Enter the company name.",
        "fixAddress": "Enter the company address.",
        "fixTin": "Enter the company TIN.",
        "fixEmail": "Enter the company email.",
        "fixTel": "Enter the company telephone.",
        "fixBirRdo": "Enter the BIR Regional District Office (RDO).",
        "fixTaxRegime": "Choose the tax regime: 8%, graduated itemized, or graduated OSD.",
        "fixIncomeClassification": "Choose business income only, professional income, or mixed income.",
        "fixVatStatus": "Set the VAT registration.",
        "fixEntityType": "Set the type of entity.",
        "fixLineOfBusiness": "Enter the line of business.",
        "fixBmbe": "If the company is BMBE-registered, enter the BMBE registration number.",
        "fixCor": "Upload the BIR Certificate of Registration 2303 (COR).",
        "fixRegistration": "Upload the registration certificate and enter its registration number. The number is the DTI, SEC, or CDA number for the type of entity. The file alone does not earn the points, and the number alone does not earn the points.",
        "fixRegistrationWithNumber": "Upload the registration certificate and enter the {{numberLabel}}. The file alone does not earn the points, and the number alone does not earn the points.",
        "fixMayorsPermit": "Upload the Mayor's Permit / Business Permit.",
        "fixBarangayPermit": "Upload the Barangay Business Permit.",
        "fixAtp": "Upload the latest Authority to Print (ATP).",
        "fixBooks": "Upload the latest book stamp or ORUS screenshot for Cash Receipts Journal, Cash Disbursement Journal, General Journal, and General Ledger. A VAT-registered or zero-rated company also needs Sales Journal and Purchases Journal. One missing stamp scores 0 for the whole set.",
        "fixUploadQueue": "Finish every receipt that is still in Uploaded status.",
        "fixTaxStarted": "Complete every tax filing that is still Started.",
        "fixTaxOverdue": "Complete every tax filing that is Overdue.",
        "fixTaxPartial": "Finish every tax filing that is Partial.",
        "pointsSummaryOfficial": "Official {{earned}} of {{total}}",
        "pointsSummaryProvisional": "Provisional {{points}}",
        "documentsSectionScore": "Official {{official}} of {{total}}. Provisional {{provisional}}.",
        "criterionOfficial": "Official {{earned}} of {{total}}",
        "criterionProvisional": "Provisional {{points}}",
        "overrideUpload": "Override upload",
        "overrideUploadAria": "Override upload for {{item}}",
        "overrideReasonLabel": "Override reason",
        "overrideReasonPlaceholder": "Why this document cannot be uploaded",
        "overrideSave": "Save override",
        "overrideSaving": "Saving…",
        "overrideCancel": "Cancel",
        "overrideRemove": "Remove override",
        "overrideRemoveAria": "Remove the override for {{item}}",
        "overrideRemoving": "Removing…",
        "overrideReasonRequired": "Enter a reason for the override.",
        "overrideSaved": "Override saved. Provisional points updated.",
        "overrideRemoved": "Override removed.",
        "overrideSaveFailed": "Could not save the override.",
        "overrideRemoveFailed": "Could not remove the override.",
        "overrideActor": "{{name}} · {{when}}",
        "overrideActorWithEmail": "{{name}} ({{email}}) · {{when}}",
        "overrideNotCounted": "A real upload is on file, so this override is not counted.",
        "waivedBadge": "Waived",
        "waivedTooltip": "Counted in score but not complied.",
        "markWaived": "Mark as Waived",
        "markWaivedAria": "Mark {{item}} as waived",
        "waivedReasonLabel": "Waive reason",
        "waivedReasonPlaceholder": "Why this document will not be complied with",
        "waivedReasonRequired": "Enter a reason to waive this document.",
        "markingWaived": "Marking…",
        "waivedSaved": "Marked as waived. The score includes this item.",
        "waivedSaveFailed": "Could not mark this item as waived.",
        "removeWaived": "Remove Waived",
        "removeWaivedAria": "Remove the waived status for {{item}}",
        "removingWaived": "Removing…",
        "waivedRemoved": "Waived status removed.",
        "criterionWaived": "Waived {{points}}",
        "barAria": "{{name}} health. Official {{official}} of {{total}}. Provisional {{provisional}}. Waived {{waived}}.",
        "barLegendOfficial": "Official points",
        "barLegendProvisional": "Provisional points",
        "barLegendWaived": "Waived points",
        "barSegmentOfficialTitle": "Official points",
        "barSegmentProvisionalTitle": "Provisional points",
        "barSegmentWaivedTitle": "Waived points"
      },
      "uploadedEntriesEmail": {
        "title": "Uploaded entries email notification",
        "subtitle": "Send yourself a daily email when your companies have upload entries waiting in Uploaded status.",
        "setupNote": "This digest covers the same companies your super dashboard shows under Upload Entries.",
        "infoBulletScope": "Only upload entries in Uploaded status are counted; other statuses are ignored.",
        "infoBulletNoHeartbeat": "If none of your companies has Uploaded entries at the send time, no email is sent.",
        "infoBulletOncePerDay": "At most one email per day, with the affected companies and their entry counts.",
        "mailNotConfigured": "Email delivery is not configured on this server, so nothing will be sent until SMTP credentials are set.",
        "lastSent": "Last sent on {{date}}.",
        "lastUpdated": "Last updated by {{email}} on {{date}}.",
        "formHeading": "Notification settings",
        "enabledLabel": "Send the daily notification",
        "enabledHint": "Turning this off keeps the saved recipients and send time.",
        "sendTimeLabel": "Daily send time ({{timeZone}})",
        "sendTimeHint": "The digest is sent at this time in {{timeZone}}.",
        "addEmailLabel": "Add a recipient",
        "addEmailPlaceholder": "name@example.com",
        "addEmailButton": "Add",
        "editEmailLabel": "Edit recipient",
        "updateEmailButton": "Update",
        "cancelEditButton": "Cancel",
        "editEmailAria": "Edit {{email}}",
        "recipientsEmpty": "No recipients yet. Add at least one email address before enabling the notification.",
        "removeEmailAria": "Remove {{email}}",
        "pendingEmailToast": "Add or update the email address before saving.",
        "saveButton": "Save settings",
        "savingButton": "Saving…",
        "openSuperDashboardButton": "Open super dashboard upload entries",
        "loadingMessage": "Loading notification settings…",
        "loadFailedMessage": "Failed to load notification settings.",
        "retryButton": "Try again",
        "savingToast": "Saving notification settings…",
        "savedToast": "Notification settings saved.",
        "noChangesToast": "No changes to save.",
        "recipientsRequiredToast": "Add at least one recipient before enabling the notification.",
        "emailRequiredToast": "Enter an email address to add.",
        "emailInvalidToast": "Enter a valid email address.",
        "emailDuplicateToast": "That email address is already on the list."
      },
      "taxReminders": {
        "title": "Tax reminders",
        "pageTitle": "Tax reminders",
        "loadError": "Could not load tax reminders.",
        "empty": "You are not a member of any companies.",
        "overviewEmpty": "No upcoming tax reminders across your companies.",
        "notSetMessage": "Tax reminders is not set.",
        "noAccessMessage": "You do not have permission to view tax reminders for this company.",
        "setUpCta": "Set up tax reminders",
        "viewAllCta": "View all",
        "statusNotStarted": "Not Started",
        "statusPartiallyCompleted": "Partially Completed",
        "statusStarted": "Started",
        "statusOverdue": "Overdue",
        "statusPrepare": "Prepare"
      },
      "uploadEntries": {
        "title": "Upload Entries",
        "pageTitle": "Upload Entries",
        "loadError": "Could not load upload entries.",
        "empty": "You are not a member of any companies.",
        "overviewEmpty": "No upload entries across your companies.",
        "notSetMessage": "No upload entries yet.",
        "noAccessMessage": "You do not have permission to view upload entries for this company.",
        "viewAllCta": "View all",
        "statusAria": "Status: {{status}}",
        "relative": {
          "seconds": "Uploaded {{count}}s ago",
          "minutes": "Uploaded {{count}}mins ago",
          "hours": "Uploaded {{count}}hrs ago",
          "days_one": "Uploaded {{count}} day ago",
          "days_other": "Uploaded {{count}} days ago",
          "weeks_one": "Uploaded {{count}} week ago",
          "weeks_other": "Uploaded {{count}} weeks ago",
          "months_one": "Uploaded {{count}} month ago",
          "months_other": "Uploaded {{count}} months ago",
          "years_one": "Uploaded {{count}} year ago",
          "years_other": "Uploaded {{count}} years ago"
        }
      },
      "companies": {
        "title": "Companies",
        "loadError": "Could not load companies.",
        "detailLoadError": "Could not load company details.",
        "empty": "You are not linked to any companies yet.",
        "logoFallback": "Logo",
        "columnName": "Name",
        "columnDescription": "Description",
        "columnOwnership": "Ownership",
        "columnCreatedAt": "Created At",
        "roleOwner": "Owner",
        "roleMember": "Member",
        "mobileDescriptionLabel": "Description",
        "mobileCreatedAtLabel": "Created",
        "fieldPlaceholder": "—"
      }
    },
    "journals": {
      "index": {
        "pageTitle": "Journals",
        "primaryBooksGroupTitle": "Primary books",
        "ppeAndCapitalsGroupTitle": "PPE & Capitals",
        "otherGroupTitle": "Other",
        "cards": {
          "cashReceiptsJournal": {
            "title": "Sales",
            "subtitle": "Cash Receipts Journal",
            "description": "View all sales, use filters to find specific sales, and record or import sales"
          },
          "cashDisbursementJournal": {
            "title": "Expenses",
            "subtitle": "Cash Disbursement Journal",
            "description": "View all expenses, use filters to find specific expenses, and record or import expenses"
          },
          "generalJournal": {
            "title": "General Journal",
            "subtitle": "Chronological entries",
            "description": "All transactions in date order with debit and credit entries"
          },
          "generalLedger": {
            "title": "General Ledger",
            "subtitle": "Account running balances",
            "description": "Transaction history for a category with running balances"
          },
          "transactions": {
            "title": "Transactions",
            "subtitle": "General Journal",
            "description": "Record and manage day-to-day transactions with debits and credits"
          },
          "arInvoices": {
            "title": "Invoices",
            "subtitle": "Accounts Receivable",
            "description": "Create and manage customer invoices and payment history"
          },
          "categories": {
            "title": "Categories",
            "subtitle": "Chart of Accounts",
            "description": "Set up and maintain your categories for reporting"
          },
          "customers": {
            "title": "Customers",
            "subtitle": "Sales customers",
            "description": "View and manage customers used on sales receipts"
          },
          "suppliers": {
            "title": "Suppliers",
            "subtitle": "Expense suppliers",
            "description": "View and manage suppliers used on expense entries"
          },
          "bills": {
            "title": "Bills",
            "subtitle": "Accounts Payable",
            "description": "Track supplier bills, payments, and outstanding payables"
          },
          "billPayments": {
            "title": "Bill Payments",
            "subtitle": "Supplier payments",
            "description": "View all supplier bill payments and open payment details"
          },
          "fxRevaluations": {
            "title": "FX Revaluations",
            "subtitle": "Foreign currency revaluation",
            "description": "View period-end foreign currency bill revaluations across all bills"
          },
          "invoicePayments": {
            "title": "Invoice Payments",
            "subtitle": "Customer collections",
            "description": "View all customer invoice payments and collection receipts"
          },
          "equipment": {
            "title": "PPE",
            "subtitle": "Property, Plant and Equipment",
            "description": "Record PPE purchases and depreciation"
          },
          "capitals": {
            "title": "Capitals",
            "subtitle": "Manage Capital Entries",
            "description": "Record owner investments and withdrawals"
          }
        }
      }
    },
    "nonVatBooks": {
      "pageTitle": "Cash Books",
      "booksGroupTitle": "Books",
      "reportsGroupTitle": "Reports",
      "cards": {
        "cashReceiptsJournal": {
          "title": "Cash Receipts Journal",
          "description": "Record and review cash receipts and sales entries"
        },
        "cashDisbursementJournal": {
          "title": "Cash Disbursement Journal",
          "description": "Record and review cash disbursements and expense entries"
        },
        "incomeStatement": {
          "title": "Income Statement",
          "description": "Statement of comprehensive income for the selected period"
        },
        "balanceSheet": {
          "title": "Balance Sheet",
          "description": "Statement of financial position as of a selected date"
        },
        "statementOfChangesInEquity": {
          "title": "Statement of Changes in Equity",
          "description": "Owner equity movements for the selected period"
        },
        "cashFlowStatement": {
          "title": "Cash Flow Statement",
          "description": "Cash inflows and outflows for the selected period"
        },
        "trialBalance": {
          "title": "Trial Balance",
          "description": "Debit and credit totals by account for the selected period"
        },
        "generalLedger": {
          "title": "General Ledger",
          "description": "View account activity in the general ledger report"
        },
        "generalJournal": {
          "title": "General Journal",
          "description": "View chronological general journal entries"
        },
        "equipment": {
          "title": "PPE",
          "description": "Record property, plant and equipment purchases and depreciation"
        },
        "capitals": {
          "title": "Capitals",
          "description": "Record owner investments and withdrawals"
        }
      }
    },
    "customers": {
      "Customers": {
        "title": "Customers",
        "summary": "Manage customer names and contact details for your sales journal.",
        "newCustomer": "New customer",
        "searchPlaceholder": "Search by name, account number, email, phone, or address…",
        "includeVoided": "Include voided",
        "loading": "Loading customers…",
        "retry": "Try again",
        "empty": "No customers yet. Add your first customer to use on sales.",
        "emptyFiltered": "No customers match your search or filters.",
        "columnName": "Name",
        "columnAccountNumber": "Account #",
        "columnEmail": "Email",
        "columnPhone": "Phone",
        "columnAddress": "Address",
        "columnStatus": "Status",
        "columnActions": "Actions",
        "statusActive": "Active",
        "statusVoided": "Voided",
        "viewCustomerAria": "View {{name}}",
        "editCustomerAria": "Edit {{name}}",
        "voidCustomerAria": "Void {{name}}",
        "restoreCustomerAria": "Restore {{name}}",
        "createSuccess": "Customer created.",
        "updateSuccess": "Customer updated.",
        "voidSuccess": "Customer voided.",
        "restoreSuccess": "Customer restored.",
        "manageGroups": "Manage groups",
        "columnGroups": "Groups",
        "selectAllAria": "Select all customers",
        "selectCustomerAria": "Select {{name}}",
        "selectedCount": "{{count}} selected",
        "addToGroup": "Add to group",
        "clearSelection": "Clear selection",
        "bulkAssignSuccess": "Customers added to selected groups.",
        "groupCreateSuccess": "Group created.",
        "groupUpdateSuccess": "Group updated.",
        "groupDeleteSuccess": "Group deleted.",
        "emailCustomersButton": "Email customers",
        "billInvoiceButton": "Bill Invoice",
        "emailSelected": "Email selected",
        "emailSelectedOptOutOnly": "Selected customers opted out of bulk email or have no email.",
        "emailCustomerAria": "Email {{name}}",
        "bulkOptOutEmail": "Opt out of bulk email",
        "bulkOptOutLoading": "Updating opt-out…",
        "bulkOptOutSuccess": "Marked {{count}} customer(s) as opted out of bulk email.",
        "optOutBulkEmailBadge": "Opted out",
        "gmailConnected": "Gmail connected. You can draft and send your email.",
        "gmailDenied": "Gmail access was not granted.",
        "gmailConnectFailed": "Could not connect Gmail. Try again."
      },
      "BillInvoiceSettings": {
        "title": "Bill Invoice",
        "subtitle": "Personalize your billing invoice and email templates for your customers.",
        "backToCustomers": "Back to customers",
        "selectCompany": "Select a company to manage bill invoice settings.",
        "loading": "Loading bill invoice settings…",
        "retryButton": "Try again",
        "tabsLabel": "Bill invoice sections",
        "settingsTab": "Settings",
        "historyTab": "Billing History",
        "issueInvoiceButton": "Issue Invoice",
        "numberingSectionTitle": "Billing invoice numbering",
        "numberingSectionHint": "Optional prefix and suffix wrap an automatic serial that starts at 1 and increases with each issued invoice.",
        "numberPrefixLabel": "Number prefix",
        "numberPrefixPlaceholder": "e.g. BILL-",
        "numberSuffixLabel": "Number suffix (optional)",
        "numberSuffixPlaceholder": "e.g. -A",
        "nextNumberLabel": "Next number",
        "nextNumberHint": "Assigned automatically by the system. Starts at 1 for new setups.",
        "nextNumberPreview": "Next invoice number: {{number}}",
        "numberingErrors": {
          "prefixOrSuffixTooLong": "Prefix and suffix must be at most 50 characters."
        },
        "templateSectionTitle": "Set Up PDF Invoice",
        "templateSectionHint": "Configure the PDF invoice content. Notes appear directly below the line-item table on the generated PDF. Use square-bracket placeholders such as [customer's name] — they are replaced with customer and billing details when invoices are generated.",
        "companyInfo": {
          "sectionTitle": "Company Information",
          "sectionHint": "Company name, address, TIN, contact details, and logo on billing invoices come from your company profile.",
          "settingsMessage": "Edit company details and logo in Settings — not on this page. Billing invoices use whatever is saved there.",
          "step1": "Open Settings from the sidebar.",
          "step2": "Go to Company details.",
          "step3": "Update your company information and logo, then save.",
          "openSettingsLink": "Open Company details"
        },
        "attachPdfLabel": "Attach PDF to email",
        "attachPdfHint": "When enabled, the generated billing invoice PDF is attached to customer emails. This setting is shared with Issue Invoice preview.",
        "emailToolbarUndo": "Undo",
        "emailToolbarRedo": "Redo",
        "invoiceTemplateLabel": "Invoice notes text",
        "billingDueDaysLabel": "Billing due date",
        "billingDueDaysPlaceholder": "Days",
        "billingDueDaysHint": "Optional days after the billing date (the date the invoice email is sent). Leave blank for no company default.",
        "billingDueDaysPreview": "Example: billed {{billingDate}} + {{days}} days → due {{dueDate}}.",
        "billingDueDaysInvalidToast": "Billing due date days must be a whole number from 0 to 3650, or left blank.",
        "includeBillingDueDateOnPdfLabel": "Show on PDF",
        "emailSectionTitle": "Email to customer",
        "emailSectionHint": "Compose the email that will accompany the generated billing invoice PDF. Use the toolbar to bold, italicize, underline, resize, or align text. The same placeholder tokens are supported.",
        "emailSubjectLabel": "Email subject",
        "emailBodyLabel": "Email body",
        "emailToolbarLabel": "Email formatting",
        "emailToolbarBold": "Bold",
        "emailToolbarItalic": "Italic",
        "emailToolbarUnderline": "Underline",
        "emailToolbarFontSize": "Text size",
        "emailToolbarAlignLeft": "Align left",
        "emailToolbarAlignCenter": "Align center",
        "emailToolbarAlignRight": "Align right",
        "emailToolbar": {
          "fontSizeSmall": "Small",
          "fontSizeNormal": "Normal",
          "fontSizeLarge": "Large",
          "fontSizeExtraLarge": "Extra large"
        },
        "emailPreviewTitle": "Email preview with sample data",
        "placeholdersTitle": "Available placeholders",
        "placeholdersHint": "Copy these tokens into the invoice notes or email fields.",
        "cancelButton": "Cancel",
        "resetDefaultsButton": "Reset to default",
        "resetDefaultsToast": "Defaults restored — click Save to apply.",
        "saveButton": "Save",
        "savingButton": "Saving…",
        "noChangesToast": "No changes to save.",
        "savingToast": "Saving bill invoice settings…",
        "savedToast": "Bill invoice settings saved.",
        "issue": {
          "selectTitle": "Issue billing invoices",
          "previewTitle": "Preview invoices",
          "resultTitle": "Issue results",
          "gmailTitle": "Gmail connection",
          "gmailChecking": "Checking Gmail connection…",
          "gmailConnectedAs": "Sending from",
          "gmailNotConnected": "Connect Gmail to send billing invoices from your mailbox.",
          "gmailNotConfigured": "Gmail sending is not configured on this server. Contact your administrator.",
          "gmailDevMockNotice": "Local dev: emails are simulated only (nothing is sent).",
          "gmailDevMockNotConnected": "Connect a simulated Gmail sender to try issuing invoices locally.",
          "connectGmailButton": "Connect Gmail",
          "connectGmailDevMockButton": "Connect Gmail (dev simulation)",
          "gmailConnectedToast": "Gmail connected.",
          "gmailDeniedToast": "Gmail access was not granted.",
          "gmailConnectFailedToast": "Could not connect Gmail. Try again.",
          "gmailDevMockConnectedToast": "Dev Gmail connected.",
          "gmailPopupBlockedToast": "Allow pop-ups for this site to connect Gmail.",
          "gmailRequiredToast": "Connect Gmail before continuing.",
          "numberingNotConfiguredToast": "Configure billing invoice numbering in Settings before issuing invoices.",
          "customersTitle": "Select customers",
          "customersLoading": "Loading customers…",
          "noEligibleCustomers": "No eligible customers found. Customers need an email address.",
          "selectAllEligible": "Select all eligible",
          "selectedCount": "{{count}} selected",
          "remainingNumbersCount": "{{count}} invoice number(s) remaining",
          "notEnoughNumbersToast": "Only {{remaining}} invoice number(s) remaining. Select fewer customers or configure a new number range.",
          "noCustomersSelectedToast": "Select at least one customer.",
          "lineItemsTitle": "Invoice line items",
          "lineItemsHint": "Edit this customer's line items. A new blank row appears when the last row is complete.",
          "lineItemsColDescription": "Description",
          "lineItemsColQuantity": "Quantity",
          "lineItemsColUnitPrice": "Unit price",
          "lineItemsColAmount": "Amount",
          "lineItemsTotal": "Total: {{total}}",
          "lineItemsRequiredToast": "Add at least one complete line item.",
          "incompleteLineItemsToast": "Finish or clear incomplete line items before saving.",
          "lineItemsRequiredForCustomerToast": "Customer \"{{name}}\" requires a description and amount before sending.",
          "lineItemsMissingHint": "No line items yet. Edit this customer to add a description and amount.",
          "attachPdfLabel": "Attach PDF to email",
          "includeBillingDateOnPdfLabel": "Include billing period on PDF",
          "includeBillingDueDateOnPdfLabel": "Include billing due date on PDF",
          "editButton": "Edit",
          "saveEditsButton": "Save",
          "cancelEditButton": "Cancel edit",
          "resetCustomerButton": "Reset",
          "editingHint": "Editing this customer only. Switching customers discards unsaved changes.",
          "overrideSavedToast": "Customer invoice override saved.",
          "overrideResetToast": "Customer invoice override reset.",
          "retryButton": "Try again",
          "cancelButton": "Cancel",
          "continueButton": "Continue",
          "previewLoadingButton": "Preparing preview…",
          "previewLoadingToast": "Preparing invoice preview…",
          "previewReadyToast": "Preview ready.",
          "previewListLabel": "Invoice preview list",
          "previewEmpty": "No preview items available.",
          "detailRecipient": "Recipient",
          "detailAmount": "Amount due",
          "detailBillingDate": "Billing date",
          "detailBillingPeriod": "Billing period",
          "billingPeriodStartLabel": "Period start",
          "detailDueDate": "Billing due date",
          "detailInvoiceNumber": "Invoice number",
          "notAvailable": "—",
          "emailSubjectLabel": "Email subject template",
          "emailBodyLabel": "Email body",
          "emailOverrideHint": "Keep placeholders such as [customer's name] so each customer gets personalized content. Edits apply to every invoice in this batch.",
          "personalizedEmailPreviewTitle": "Email preview",
          "previewEmailSubjectLabel": "Subject",
          "pdfPreviewTitle": "Invoice PDF preview",
          "backButton": "Back",
          "confirmSendButton": "Confirm & send",
          "confirmSendIncompleteLineItemsTitle": "Complete line items for every customer before sending.",
          "sendingButton": "Sending…",
          "sendingToast": "Issuing billing invoices…",
          "sentToast": "Issued {{sent}} invoice(s). {{failed}} failed.",
          "resultSummary": "{{sent}} sent, {{failed}} failed",
          "resultDevMockNotice": "Dev simulation: no real emails were delivered.",
          "statusSent": "Sent",
          "statusFailed": "Failed",
          "doneButton": "Done"
        },
        "history": {
          "title": "Billing history",
          "searchPlaceholder": "Search invoices…",
          "searchButton": "Search",
          "loading": "Loading billing history…",
          "empty": "No billing invoices issued yet.",
          "retryButton": "Try again",
          "colInvoiceNumber": "Invoice #",
          "colCustomer": "Customer",
          "colAmount": "Amount",
          "colBillingDate": "Billing period",
          "colSentAt": "Sent at",
          "colStatus": "Status",
          "colActions": "Actions",
          "viewButton": "View",
          "statusSent": "Sent",
          "statusFailed": "Failed",
          "notAvailable": "—",
          "prevPage": "Previous",
          "nextPage": "Next",
          "pageInfo": "Page {{page}} of {{totalPages}}",
          "detailTitle": "Invoice details",
          "detailLoading": "Loading invoice…",
          "detailInvoiceNumber": "Invoice number",
          "detailCustomer": "Customer",
          "detailBusinessName": "Business name",
          "detailRecipient": "Recipient email",
          "detailAmount": "Amount due",
          "detailBillingDate": "Billing period",
          "detailDueDate": "Billing due date",
          "detailSentAt": "Sent at",
          "detailStatus": "Status",
          "detailIssuedBy": "Issued by",
          "detailError": "Error",
          "detailEmailSubject": "Email subject",
          "detailEmailBody": "Email body",
          "detailLineItemsTitle": "Line items",
          "detailLineItemsColDescription": "Description",
          "detailLineItemsColQuantity": "Quantity",
          "detailLineItemsColUnitPrice": "Unit price",
          "detailLineItemsColAmount": "Amount",
          "detailLineItemsTotal": "Total: {{total}}",
          "detailPdfAttachedYes": "PDF was attached to the email.",
          "detailPdfAttachedNo": "PDF was not attached to the email.",
          "viewPdfButton": "View PDF",
          "openingPdfButton": "Opening…",
          "closeButton": "Close"
        }
      },
      "CustomerEmailPage": {
        "title": "Email customers",
        "hint": "Connect Gmail, choose recipients, then compose in the popup — like Gmail.",
        "composeEmail": "Compose email",
        "backToCustomers": "Back",
        "stepsLabel": "Email steps",
        "steps": {
          "recipients": "1. Recipients",
          "compose": "2. Compose",
          "review": "3. Review & send"
        },
        "connectionTitle": "Gmail connection",
        "connectionLoading": "Checking Gmail connection…",
        "connectedAs": "Sending from",
        "disconnect": "Disconnect Gmail",
        "disconnectSuccess": "Gmail disconnected.",
        "notConnected": "Connect Gmail to send from your own mailbox.",
        "notConfigured": "Gmail sending is not configured on this server. Contact your administrator.",
        "connectGmail": "Connect Gmail",
        "connectGmailDevMock": "Connect Gmail (dev simulation)",
        "devMockNotice": "Local dev: emails are simulated only (nothing is sent).",
        "devMockNotConnected": "Connect a simulated Gmail sender to try the flow locally.",
        "devMockConnected": "Dev Gmail connected. You can draft and simulate sending.",
        "popupBlocked": "Allow pop-ups for this site to connect Gmail.",
        "gmailConnected": "Gmail connected. You can compose and send your email.",
        "gmailDenied": "Gmail access was not granted.",
        "gmailConnectFailed": "Could not connect Gmail. Try again.",
        "recipientsTitle": "Choose recipients",
        "searchPlaceholder": "Search customers…",
        "includeVoided": "Include voided",
        "selectedCount": "{{count}} selected to receive email",
        "selectAllWithEmail": "Select all visible with email",
        "selectAllWithEmailHint": "Adds visible customers to your selection. Imported CSV recipients are kept. Group buttons only select customers currently shown in the list.",
        "clearSelection": "Clear customer selection",
        "clearAllSelection": "Clear all selection",
        "clearCsvImports": "Clear imported recipients",
        "importedRecipientsTitle": "Imported recipients ({{count}} selected)",
        "columnSelect": "Send",
        "columnName": "Name",
        "columnEmail": "Email",
        "selectRecipientRow": "Select {{name}} ({{email}})",
        "loadingCustomers": "Loading customers…",
        "noEmail": "No email",
        "composeTitle": "Compose message",
        "templatesHint": "Start from a template or write your own HTML.",
        "subjectLabel": "Subject",
        "bodyLabel": "Message (HTML)",
        "editorHelpLink": "Email editor guide",
        "htmlHint": "Line breaks are kept when you press Enter. Use HTML for links and buttons. Insert placeholders for each customer's name.",
        "showPreview": "Preview email",
        "hidePreview": "Hide preview",
        "previewTitle": "Email preview",
        "previewCaption": "Preview for {{name}} — links open in a new tab in the real email.",
        "previewSampleName": "Sample Customer",
        "insertTextLink": "Insert text link",
        "insertButtonLink": "Insert button link",
        "insertLink": "Insert link",
        "plainTextMode": "Plain text mode",
        "bodyPlainLabel": "Message (plain text)",
        "plainHint": "Write naturally — line breaks are kept. Placeholders like {{customerName}} still work.",
        "bccSender": "BCC me on every send",
        "includeLogoHeader": "Include company logo header",
        "includeUnsubscribeFooter": "Include unsubscribe footer",
        "attachmentLabel": "Attachments (optional, up to {{count}})",
        "scheduleLabel": "Schedule send (optional)",
        "sendTest": "Send test to my Gmail",
        "sendingTest": "Sending test email…",
        "sendTestSuccess": "Test email sent to your Gmail.",
        "saveAsTemplate": "Save as template",
        "templateSaved": "Template saved.",
        "selectGroup": "Select {{name}}",
        "importCsv": "Paste CSV recipients",
        "importRecipients": "Import recipients",
        "adhocRecipientTag": "(imported)",
        "duplicateEmailWarning": "Duplicate emails in selection (only one send per address): {{emails}}",
        "subjectPreviewTitle": "Subject preview per recipient",
        "progressLabel": "{{done}} / {{total}} processed ({{sent}} sent, {{failed}} failed)",
        "scheduleSuccess": "Emails scheduled. They will send automatically at the chosen time.",
        "resultSummaryScheduled": "Emails scheduled successfully.",
        "retryFailed": "Retry failed recipients",
        "linkModal": {
          "title": "Insert link",
          "urlLabel": "URL",
          "labelLabel": "Link text",
          "labelPlaceholder": "Visit our website",
          "kindLegend": "Link style",
          "kindText": "Plain text link",
          "kindButton": "Button link",
          "cancel": "Cancel",
          "insert": "Insert"
        },
        "csvModal": {
          "title": "Import recipients from CSV",
          "hint": "Paste one recipient per line: Name, email — or email only. These are one-off recipients (not saved as customers). They stay selected when you use Select all visible with email. Use Clear imported recipients to remove them.",
          "placeholder": "Jane Doe, jane@example.com\njohn@example.com",
          "cancel": "Cancel",
          "import": "Add recipients"
        },
        "saveTemplateModal": {
          "title": "Save email template",
          "nameLabel": "Template name",
          "namePlaceholder": "Monthly newsletter",
          "folderLabel": "Folder (optional)",
          "folderPlaceholder": "Newsletters",
          "cancel": "Cancel",
          "save": "Save template"
        },
        "toolbar": {
          "bold": "Bold",
          "italic": "Italic",
          "underline": "Underline",
          "heading": "Heading",
          "bulletList": "Bullet list",
          "numberedList": "Numbered list",
          "insertLink": "Insert link",
          "insertImage": "Insert image"
        },
        "snippets": {
          "customerName": "Full name",
          "customerFirstName": "First name",
          "companyName": "Company name",
          "groupNames": "Group names",
          "tinNumber": "TIN"
        },
        "imageModal": {
          "title": "Insert image",
          "modeUrl": "Image URL",
          "modeUpload": "Upload",
          "urlLabel": "Image URL",
          "fileLabel": "Image file",
          "uploadHint": "JPEG, PNG, GIF, or WebP. Uploaded images are stored for use in your email.",
          "uploading": "Uploading image…",
          "uploaded": "Image uploaded.",
          "chooseFile": "Choose file",
          "altLabel": "Alt text",
          "altPlaceholder": "Describe the image",
          "cancel": "Cancel",
          "insert": "Insert"
        },
        "recentJobs": {
          "title": "Recent sends",
          "loading": "Loading recent sends…",
          "empty": "No recent sends yet.",
          "itemMeta": "{{when}} · {{count}} recipient(s) · {{sent}} sent · {{failed}} failed · {{status}}",
          "status": {
            "completed": "Completed",
            "failed": "Failed",
            "processing": "Processing"
          }
        },
        "jobEdit": {
          "title": "Edit scheduled send",
          "loading": "Loading scheduled send…",
          "recipientCount": "{{count}} recipient(s)",
          "cancel": "Cancel",
          "save": "Save changes",
          "saved": "Scheduled send updated."
        },
        "duplicateJob": {
          "button": "Duplicate as draft",
          "action": "Duplicate as draft",
          "loading": "Loading draft…",
          "success": "Draft loaded. Continue editing your message."
        },
        "batchSplit": {
          "overLimit": "You selected {{count}} recipients, which exceeds the {{limit}}-recipient limit per send. Enable sequential batch scheduling below (requires a schedule date in compose).",
          "sequentialSchedule": "Schedule batches sequentially (one day apart)",
          "scheduleRequired": "Set a schedule date on the compose step to schedule batches.",
          "batchMeta": "Batch {{index}}: {{count}} recipients · {{when}}",
          "blocked": "Too many recipients for a single send. Enable sequential batch scheduling or reduce your selection.",
          "scheduleSuccess": "Scheduled {{count}} batch(es)."
        },
        "templates": {
          "welcome": {
            "label": "Welcome",
            "subject": "Welcome to {{customerName}}",
            "body": "Hi {{customerFirstName}},\n\nThank you for being our customer.\n\n<a href=\"https://abrafi.ph\" style=\"display:inline-block;padding:12px 24px;background:#2563eb;color:#ffffff;text-decoration:none;border-radius:6px;font-weight:600;\">Get Started</a>"
          },
          "followUp": {
            "label": "Follow-up",
            "subject": "Following up, {{customerFirstName}}",
            "body": "Hi {{customerFirstName}},\n\nI wanted to follow up and see if you have any questions.\n\nReply to this email anytime."
          },
          "paymentReminder": {
            "label": "Reminder",
            "subject": "Payment reminder for {{customerName}}",
            "body": "Hi {{customerFirstName}},\n\nThis is a friendly reminder about an outstanding balance. Let us know if you need assistance."
          }
        },
        "reviewTitle": "Review before sending",
        "reviewHint": "You are about to send {{count}} individual emails from your connected Gmail account.",
        "reviewPreviewTitle": "Final email preview",
        "confirmSendTitle": "Send emails now?",
        "confirmSendBody": "This will send {{count}} separate emails. This action cannot be undone.",
        "confirmSendCancel": "Cancel",
        "confirmSendConfirm": "Send now",
        "continueToCompose": "Continue to compose",
        "backToRecipients": "Back to recipients",
        "continueToReview": "Continue to review",
        "backToCompose": "Back to compose",
        "sendEmails": "Send emails",
        "sending": "Sending emails…",
        "sendingProgress": "Sending {{count}} individual emails from your Gmail account…",
        "sendSuccess": "Sent {{sentCount}} email(s).",
        "sendSuccessDevMock": "Simulated {{sentCount}} email(s) (not actually sent).",
        "resultsTitle": "Send results",
        "resultSummary": "Sent {{sentCount}}, failed {{failedCount}}.",
        "resultSummaryDevMock": "Simulated {{sentCount}}, failed {{failedCount}} (dev only).",
        "startOver": "Start over",
        "viewRecentSends": "Recent sends",
        "startOverConfirmTitle": "Start over?",
        "startOverConfirmBody": "This clears your draft, recipients, and message. This cannot be undone.",
        "startOverConfirmCancel": "Keep editing",
        "startOverConfirmConfirm": "Start over",
        "leaveConfirmTitle": "Leave email composer?",
        "leaveConfirmBody": "You have unsaved changes. Leaving this page will keep your draft in this browser, but you will lose in-progress edits on this screen.",
        "leaveConfirmStay": "Stay on page",
        "leaveConfirmLeave": "Leave page",
        "connectionLostBanner": "Gmail is disconnected. Reconnect to send emails.",
        "reconnectGmail": "Reconnect Gmail",
        "continueToRecipients": "Continue to recipients",
        "emptyNoCustomersWithEmail": "No customers have an email address yet. Add emails on the Customers page or import recipients from CSV.",
        "emptyFilteredRecipients": "No customers match your search or filters.",
        "rowLegend": {
          "label": "Recipient row colors",
          "selected": "Selected",
          "selectable": "Can select",
          "unselectable": "No email / cannot select"
        },
        "wizard": {
          "edit": "Edit",
          "editConnection": "Change Gmail",
          "editRecipients": "Edit recipients",
          "editCompose": "Edit message",
          "editReview": "Edit review",
          "notConnectedSummary": "Not connected",
          "recipientsSummary": "{{count}} recipient(s)",
          "composeEmpty": "No subject yet",
          "reviewSummary": "Ready to send to {{count}}",
          "recipientListTitle": "Recipients",
          "confirmRecipients": "I reviewed the {{count}} recipient(s) and subject lines above.",
          "confirmSend": "I am ready to send these emails from my Gmail account.",
          "confirmRequiredHint": "Required before sending.",
          "scheduledFor": "Scheduled for {{when}}",
          "sendingTitle": "Sending",
          "doneSummary": "{{sent}} sent, {{failed}} failed",
          "navRecipients": "Recipients ({{count}})"
        },
        "validation": {
          "connectGmail": "Connect Gmail before choosing recipients.",
          "selectRecipient": "Select at least one recipient with an email address.",
          "subjectRequired": "Enter a subject line.",
          "bodyRequired": "Enter a message body.",
          "confirmRecipientsRequired": "Confirm you reviewed the recipients and subject lines.",
          "confirmSendRequired": "Confirm you are ready to send from your Gmail account."
        },
        "postSend": {
          "sendAnother": "Send another",
          "viewActivityLogs": "View activity logs"
        },
        "filters": {
          "showSelectedOnly": "Show selected only",
          "hideWithoutEmail": "Hide without email"
        },
        "scheduled": {
          "title": "Scheduled sends",
          "loading": "Loading scheduled sends…",
          "empty": "No scheduled or unsent emails.",
          "itemMeta": "{{when}} · {{count}} recipient(s)",
          "itemMetaDue": "Sending soon · {{count}} recipient(s)",
          "viewEdit": "View / edit",
          "cancel": "Cancel",
          "cancelSuccess": "Scheduled send cancelled.",
          "pendingJobBanner": "Your scheduled email is still pending and will send automatically."
        },
        "templatesManage": {
          "title": "Manage saved templates",
          "empty": "No saved templates yet.",
          "edit": "Edit",
          "delete": "Delete",
          "saveChanges": "Save changes",
          "close": "Close",
          "updated": "Template updated.",
          "deleted": "Template deleted.",
          "manageButton": "Manage templates",
          "defaultLabel": "Use as default template when composing",
          "defaultBadge": "Default",
          "ungroupedFolder": "Other templates"
        },
        "signature": {
          "include": "Include email signature",
          "label": "Signature",
          "hint": "Appended to the end of each email when enabled.",
          "saved": "Signature saved."
        },
        "attachment": {
          "tooLarge": "Attachment exceeds the 20 MB limit.",
          "maxCount": "You can attach up to {{count}} files.",
          "remove": "Remove attachment"
        },
        "reviewHints": {
          "duplicateSubjects": "Multiple recipients share the same subject line: {{subjects}}",
          "missingPersonalization": "Some recipients may not receive personalized names: {{names}}"
        },
        "quotaWarning": "You selected {{count}} recipients. Gmail accounts are often limited to about 500 emails per day — consider splitting into smaller batches.",
        "selectFilteredAll": "Select all matching filters",
        "selectAllCompanyWithEmail": "Select all with email (company)",
        "columnGroups": "Groups",
        "optOutExcludedWarning": "{{count}} visible customer(s) opted out of bulk email and cannot be selected.",
        "gmailTokenExpiryWarning": "Your Gmail connection expires soon. Reconnect if sending fails.",
        "previewRecipientLabel": "Preview as recipient",
        "keyboardShortcutHint": "Tip: press Ctrl+Enter (Cmd+Enter on Mac) in the message field to continue to review.",
        "exportFailedCsv": "Export failed recipients (CSV)",
        "scheduleTimezoneHint": "Scheduled time uses your browser's local timezone.",
        "addCustomerLink": "Add a customer with email",
        "scheduleValidation": {
          "past": "Scheduled time must be in the future.",
          "invalid": "Enter a valid date and time for scheduling."
        },
        "recipientsSummaryChip": "{{total}} selected · {{customers}} customers · {{groups}} groups · {{imports}} CSV imports"
      },
      "CustomerEmailRecentSendsPage": {
        "title": "Recent sends",
        "hint": "Your latest send summary appears here after each batch. Manage scheduled or unsent emails below, browse past sends, or duplicate one as a new draft.",
        "latestSendTitle": "Latest send",
        "dismissResult": "Dismiss",
        "backToEmail": "Back to email customers"
      },
      "CustomerEmailComposeModal": {
        "title": "New message",
        "formatMenuLabel": "Text formatting",
        "variablesMenuLabel": "Insert variable",
        "toLabel": "To",
        "subjectLabel": "Subject",
        "subjectPlaceholder": "Subject",
        "noRecipients": "No recipients selected",
        "recipientCount": "{{count}} recipients",
        "send": "Send",
        "sendScheduled": "Send scheduled",
        "pickScheduleFirst": "Choose a date and time, then click Send scheduled again.",
        "scheduleSend": "Schedule",
        "attach": "Attach",
        "minimize": "Minimize",
        "close": "Close",
        "minimizedTitle": "Draft email",
        "restore": "Restore draft email",
        "dismiss": "Hide draft bar"
      },
      "AddCustomerModal": {
        "title": "Add customer",
        "nameLabel": "Customer name",
        "businessNameLabel": "Business Name",
        "businessNamePlaceholder": "e.g. Acme Trading Inc.",
        "nameRequired": "Customer name is required.",
        "accountNumberLabel": "Account number",
        "accountNumberPlaceholder": "e.g. 1001 or 12-34",
        "accountNumberInvalid": "Account number may only contain digits, spaces, and dashes.",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "contactLabel": "Contact number",
        "emailLabel": "Email",
        "invalidEmail": "Enter a valid email address.",
        "notesLabel": "Notes",
        "groupsLabel": "Groups",
        "cancel": "Cancel",
        "save": "Save customer",
        "saving": "Saving…",
        "createFailed": "Could not create customer."
      },
      "CustomerBillingFields": {
        "sectionLabel": "Billing settings",
        "sectionTitle": "Billing settings",
        "amountDueLabel": "Amount",
        "amountDuePlaceholder": "0.00",
        "amountDueInvalid": "Enter a valid billing amount due.",
        "amountDescriptionLabel": "Description",
        "amountDescriptionPlaceholder": "What this amount is for",
        "quantityLabel": "Quantity",
        "quantityPlaceholder": "1",
        "quantityInvalid": "Enter a valid quantity.",
        "unitPriceLabel": "Unit price",
        "unitPricePlaceholder": "0.00",
        "unitPriceInvalid": "Enter a valid unit price.",
        "lineItemsHint": "This line prefills Issue Bill Invoice. Quantity × unit price updates amount.",
        "billingDateLabel": "Billing Period",
        "billingDueDateLabel": "Billing Due Date",
        "dueDateRequiresBillingDate": "Configure Billing Period before setting Billing Due Date.",
        "frequencyLabel": "Schedule",
        "frequencyOnce": "Once",
        "frequencyMonthly": "Monthly",
        "frequencyAnnually": "Annually",
        "monthLabel": "Month",
        "dayLabel": "Day",
        "periodStartDayLabel": "Period start day",
        "periodHint": "Start day begins the period; it ends the day before that date next month (e.g. 2 → ends on the 1st).",
        "months": {
          "1": "January",
          "2": "February",
          "3": "March",
          "4": "April",
          "5": "May",
          "6": "June",
          "7": "July",
          "8": "August",
          "9": "September",
          "10": "October",
          "11": "November",
          "12": "December"
        },
        "scheduleRequiresDay": "{{field}} requires a day between 1 and 31.",
        "scheduleRequiresMonth": "{{field}} requires a valid month."
      },
      "EditCustomerModal": {
        "title": "Edit customer",
        "nameLabel": "Customer name",
        "businessNameLabel": "Business Name",
        "businessNamePlaceholder": "e.g. Acme Trading Inc.",
        "nameRequired": "Customer name is required.",
        "accountNumberLabel": "Account number",
        "accountNumberPlaceholder": "e.g. 1001 or 12-34",
        "accountNumberInvalid": "Account number may only contain digits, spaces, and dashes.",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "contactLabel": "Contact number",
        "emailLabel": "Email",
        "invalidEmail": "Enter a valid email address.",
        "notesLabel": "Notes",
        "groupsLabel": "Groups",
        "cancel": "Cancel",
        "save": "Save changes",
        "saving": "Saving…",
        "updateFailed": "Could not update customer.",
        "protectedCustomer": "The default customer cannot be edited.",
        "optOutBulkEmailLabel": "Opt out of bulk email",
        "optOutBulkEmailHint": "When checked, this customer is excluded from customer bulk email selection."
      },
      "ViewCustomerModal": {
        "title": "Customer details",
        "nameLabel": "Name",
        "accountNumberLabel": "Account number",
        "emailLabel": "Email",
        "contactLabel": "Contact number",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "notesLabel": "Notes",
        "optOutBulkEmailLabel": "Bulk email",
        "optOutBulkEmailYes": "Opted out",
        "statusLabel": "Status",
        "voidedAtLabel": "Voided at",
        "voidReasonLabel": "Void reason",
        "createdByLabel": "Created by",
        "updatedByLabel": "Updated by",
        "voidedByLabel": "Voided by",
        "restoredByLabel": "Restored by",
        "createdLabel": "Created",
        "updatedLabel": "Last updated",
        "close": "Close",
        "edit": "Edit",
        "void": "Void",
        "restore": "Restore",
        "emailCustomer": "Email this customer",
        "emailHistoryTitle": "Bulk email history",
        "emailHistoryLoading": "Loading email history…",
        "emailHistoryEmpty": "No bulk emails sent to this customer yet.",
        "emailHistoryLoadFailed": "Could not load email history.",
        "emailHistoryRetry": "Try again",
        "emailHistoryStatus": {
          "sent": "Sent",
          "failed": "Failed"
        }
      },
      "VoidCustomerModal": {
        "title": "Void customer",
        "confirmMessage": "This customer will be hidden from new sales. Existing sales are not changed.",
        "reasonLabel": "Reason (optional)",
        "reasonPlaceholder": "Why are you voiding this customer?",
        "cancel": "Cancel",
        "confirm": "Void customer",
        "voiding": "Voiding…",
        "voidFailed": "Could not void customer.",
        "protectedCustomer": "The default customer cannot be voided."
      }
    },
    "suppliers": {
      "Suppliers": {
        "title": "Suppliers",
        "summary": "Manage supplier names and contact details for your expenses journal.",
        "backToJournals": "Back",
        "newSupplier": "New supplier",
        "searchPlaceholder": "Search by name, account number, email, phone, or address…",
        "includeVoided": "Include voided",
        "loading": "Loading suppliers…",
        "retry": "Try again",
        "empty": "No suppliers yet. Add your first supplier to use on expenses.",
        "emptyFiltered": "No suppliers match your search or filters.",
        "columnName": "Name",
        "columnAccountNumber": "Account #",
        "columnEmail": "Email",
        "columnPhone": "Phone",
        "columnAddress": "Address",
        "columnStatus": "Status",
        "columnActions": "Actions",
        "statusActive": "Active",
        "statusVoided": "Voided",
        "viewSupplierAria": "View {{name}}",
        "editSupplierAria": "Edit {{name}}",
        "voidSupplierAria": "Void {{name}}",
        "restoreSupplierAria": "Restore {{name}}",
        "createSuccess": "Supplier created.",
        "updateSuccess": "Supplier updated.",
        "voidSuccess": "Supplier voided.",
        "restoreSuccess": "Supplier restored.",
        "manageGroups": "Manage groups",
        "columnGroups": "Groups",
        "selectAllAria": "Select all suppliers",
        "selectSupplierAria": "Select {{name}}",
        "selectedCount": "{{count}} selected",
        "addToGroup": "Add to group",
        "clearSelection": "Clear selection",
        "bulkAssignSuccess": "Suppliers added to selected groups.",
        "groupCreateSuccess": "Group created.",
        "groupUpdateSuccess": "Group updated.",
        "groupDeleteSuccess": "Group deleted."
      },
      "AddSupplierModal": {
        "title": "Add supplier",
        "nameLabel": "Supplier name",
        "nameRequired": "Supplier name is required.",
        "accountNumberLabel": "Account number",
        "accountNumberPlaceholder": "e.g. 1001 or 12-34",
        "accountNumberInvalid": "Account number may only contain digits, spaces, and dashes.",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "contactLabel": "Contact number",
        "emailLabel": "Email",
        "invalidEmail": "Enter a valid email address.",
        "notesLabel": "Notes",
        "groupsLabel": "Groups",
        "cancel": "Cancel",
        "save": "Save supplier",
        "saving": "Saving…",
        "createFailed": "Could not create supplier."
      },
      "EditSupplierModal": {
        "title": "Edit supplier",
        "nameLabel": "Supplier name",
        "nameRequired": "Supplier name is required.",
        "accountNumberLabel": "Account number",
        "accountNumberPlaceholder": "e.g. 1001 or 12-34",
        "accountNumberInvalid": "Account number may only contain digits, spaces, and dashes.",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "contactLabel": "Contact number",
        "emailLabel": "Email",
        "invalidEmail": "Enter a valid email address.",
        "notesLabel": "Notes",
        "groupsLabel": "Groups",
        "cancel": "Cancel",
        "save": "Save changes",
        "saving": "Saving…",
        "updateFailed": "Could not update supplier.",
        "protectedSupplier": "The default supplier cannot be edited."
      },
      "ViewSupplierModal": {
        "title": "Supplier details",
        "nameLabel": "Name",
        "accountNumberLabel": "Account number",
        "emailLabel": "Email",
        "contactLabel": "Contact number",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "notesLabel": "Notes",
        "statusLabel": "Status",
        "voidedAtLabel": "Voided at",
        "voidReasonLabel": "Void reason",
        "createdByLabel": "Created by",
        "updatedByLabel": "Updated by",
        "voidedByLabel": "Voided by",
        "restoredByLabel": "Restored by",
        "createdLabel": "Created",
        "updatedLabel": "Last updated",
        "close": "Close",
        "edit": "Edit",
        "void": "Void",
        "restore": "Restore"
      },
      "VoidSupplierModal": {
        "title": "Void supplier",
        "confirmMessage": "This supplier will be hidden from new expenses. Existing expenses are not changed.",
        "reasonLabel": "Reason (optional)",
        "reasonPlaceholder": "Why are you voiding this supplier?",
        "cancel": "Cancel",
        "confirm": "Void supplier",
        "voiding": "Voiding…",
        "voidFailed": "Could not void supplier.",
        "protectedSupplier": "The default supplier cannot be voided."
      }
    },
    "billsLedger": {
      "BillsLedger": {
        "title": "Bills",
        "summary": "Record supplier bills and track accounts payable balances.",
        "paymentHistory": "Payment History",
        "newBill": "New Bill",
        "scrollToTop": "Scroll to top",
        "loading": "Loading bills…",
        "tryAgain": "Try again",
        "searchPlaceholder": "Search by book ref, supplier ref, supplier, category, or description…",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "clearFiltersButton": "Clear filters",
        "tagsFilterLabel": "Tags",
        "statusFilterLabel": "Filter bills by status",
        "statusFilterAll": "All Statuses",
        "statusFilterUnpaid": "Unpaid Only",
        "statusFilterOverdue": "Overdue Only",
        "statusFilterPaid": "Paid Only",
        "statusFilterCancelled": "Cancelled Only",
        "statusSegmentAll": "All",
        "statusSegmentUnpaid": "Unpaid",
        "statusSegmentPaid": "Paid",
        "mobileDueRefLine": "Due: {{due}} | Ref: {{ref}}",
        "sortLabel": "Sort by",
        "sortCreatedDefault": "Date Created: Default",
        "sortNewest": "Issued Date: Descending",
        "sortOldest": "Issued Date: Ascending",
        "sortDueSoonest": "Due Date: Ascending",
        "sortDueLatest": "Due Date: Descending",
        "sortAmountHigh": "Amount: Descending",
        "sortAmountLow": "Amount: Ascending",
        "empty": "No bills recorded yet. Add your first bill to accrue accounts payable.",
        "emptySearch": "No bills match your search.",
        "colSupplier": "Supplier",
        "colBookReference": "Ref. #",
        "colBillNumber": "Bill #",
        "colRefNumber": "Reference #",
        "colExpenseType": "Bill category",
        "colDates": "Dates (issue / due / paid)",
        "colAmount": "Amount",
        "colAmountWithCurrency": "Amount ({{currency}})",
        "colBalanceAndTotal": "Remaining / Total",
        "colBalanceAndTotalWithCurrency": "Remaining / Total ({{currency}})",
        "remainingBalanceLabel": "Remaining Balance",
        "totalAmountLabel": "Total Amount",
        "colStatus": "Status",
        "colActions": "Actions",
        "termsLabel": "Terms: {{terms}}",
        "issuedLabel": "Issued: {{date}}",
        "dueLabel": "Due: {{date}}",
        "datePaidLabel": "Paid: {{date}}",
        "payNow": "Pay Now",
        "paySelected": "Pay Selected",
        "clearSelection": "Clear Selection",
        "selectionSummary": "{{count}} bills selected for payments run ({{amount}}).",
        "selectionSummary_one": "{{count}} bill selected for payments run ({{amount}}).",
        "selectionSummary_other": "{{count}} bills selected for payments run ({{amount}}).",
        "selectBillAria": "Select bill {{ref}} for payment",
        "selectAllPayableAria": "Select all unpaid bills on this page",
        "selectAllOnPage": "Select all",
        "cancelling": "Cancelling bill…",
        "cancelled": "Bill cancelled.",
        "cancel": "Cancel",
        "payModalTitle": "Execute Payment Run",
        "payModalReviewing": "Reviewing Selected Liabilities ({{count}}):",
        "payModalTotalLabel": "Total Disbursement Run Amount",
        "payModalUseForeignCurrency": "Use foreign currency",
        "payModalFxAmountInvalid": "Enter a valid foreign currency amount and exchange rate.",
        "payModalFxTotalMismatch": "Foreign currency total must match the disbursement run amount.",
        "payModalFcMixedCurrency": "Foreign currency bills in one payment must use the same currency.",
        "payModalFcForeignAmountMismatch": "Foreign amount must match the payment total ({{expected}} {{currency}}).",
        "payModalFcPaymentPercent": "{{percent}}% of {{totalForeign}} {{currency}} open balance",
        "payModalFcSectionTitle": "Payment amount ({{currency}})",
        "payModalFcOpenBalance": "Open: {{amount}} {{currency}}",
        "payModalApClearedLabel": "AP cleared (PHP)",
        "payModalCashDisbursementLabel": "Cash out (PHP)",
        "payModalRealizedFxLossLabel": "Realized FX loss (PHP)",
        "payModalRealizedFxGainLabel": "Realized FX gain (PHP)",
        "payModalRealizedFxLoss": "Realized FX loss (PHP): {{amount}}",
        "payModalRealizedFxGain": "Realized FX gain (PHP): {{amount}}",
        "payModalFcFootnote": "Cash is booked at the payment-date rate. Any difference from AP cleared posts to Foreign Exchange Gain or Loss.",
        "payModalFcNotice": "Foreign currency bills use pro-rata foreign amounts for partial payments. Cash is booked at the payment-date rate; any difference from the AP cleared amount posts to Foreign Exchange Gain or Loss.",
        "fxRevalRun": "Revalue FX bills",
        "fxRevalRunTooltip": "Period-end remeasurement for open foreign currency bills. Top-right of Bills Ledger, next to Payment History.",
        "fxRevalModalTitle": "Period-end FX revaluation",
        "fxRevalModalIntro": "Remeasure {{count}} open foreign currency bill(s) to closing exchange rates. Unrealized gain or loss will post to the ledger.",
        "fxRevalModalAsOfLabel": "As-of date",
        "fxRevalModalClosingRatesTitle": "Closing exchange rates",
        "fxRevalModalRateLoading": "Loading BSP rate for {{currencyCode}}…",
        "fxRevalModalManualRatePlaceholder": "e.g. 58.5000",
        "fxRevalModalManualRateRequired": "Enter a closing exchange rate for {{currencyCode}}.",
        "fxRevalModalUseManualRate": "Enter rate manually",
        "fxRevalModalUseBspRate": "Use BSP rate",
        "fxRevalModalNotice": "Closing rates use BSP for the as-of date when available. Enter a manual rate when BSP has no bulletin for that date.",
        "fxRevalModalConfirm": "Run revaluation",
        "fxRevalModalConfirming": "Running revaluation…",
        "fxRevalModalSuccess": "FX revaluation completed.",
        "fxRevalModalNoBills": "No open foreign currency bills to revalue.",
        "payModalTotalPhpLabel": "Total disbursement (PHP)",
        "payModalAmountHint": "Balance due: {{balance}}. Enter a lower amount for a partial payment.",
        "payModalAmountInvalid": "Enter a payment amount greater than zero.",
        "payModalAmountExceedsBalance": "Amount cannot exceed the balance due ({{max}}).",
        "payModalRowAmountAria": "Payment amount for {{supplier}}",
        "payModalMethodLabel": "Disbursement Method",
        "payModalPaidDateLabel": "Paid Date",
        "payModalNoMethod": "No category is marked Treat as cash. Mark one in Category settings to continue.",
        "payModalNotice": "You can pay the full balance or a partial amount. Bills stay open until the remaining balance is paid.",
        "payModalConfirm": "Confirm & Disburse Funds",
        "payModalConfirming": "Processing disbursement…",
        "payModalSuccess": "Payment recorded.",
        "previewModalTitle": "Bill Preview",
        "closePreview": "Close",
        "cancelModalTitle": "Cancel Bill",
        "cancelModalBody": "Are you sure you want to cancel bill {{ref}} for {{supplier}}? This bill will be marked as Cancelled and kept in the ledger.",
        "cancelBillConfirm": "Yes, Cancel Bill",
        "payNowUnavailable": "Payment runs are not available yet.",
        "deleteUnavailable": "Deleting bills is not available yet.",
        "cancelPaidBillFirstToast": "Cancel Payments First before a bill can be cancelled",
        "deleteBillAria": "Delete bill {{ref}}",
        "status": {
          "unpaid": "Unpaid",
          "partially": "Partially paid",
          "overdue": "Overdue",
          "cancelled": "Cancelled",
          "paid": "Paid",
          "draft": "Draft",
          "voided": "Voided"
        }
      },
      "PaymentHistory": {
        "title": "Payment History",
        "backToBills": "Back",
        "loading": "Loading payment history…",
        "tryAgain": "Try again",
        "empty": "No bill payments recorded yet.",
        "colBill": "Bill",
        "colSupplier": "Supplier",
        "viewBillDetails": "View bill details"
      },
      "BillDetails": {
        "title": "Bill Details",
        "back": "Back",
        "backToLedger": "Back",
        "backToPaymentHistory": "Back",
        "loading": "Loading bill details…",
        "tryAgain": "Try again",
        "notFound": "This bill could not be found.",
        "supplier": "Supplier",
        "bookReferenceNumber": "Book ref. #",
        "billNumber": "Bill #",
        "refNumber": "Reference #",
        "expenseType": "Bill category",
        "issuedDate": "Issued Date",
        "dueDate": "Due Date",
        "paidDate": "Paid Date",
        "amount": "Amount",
        "foreignCurrencySection": "Foreign currency",
        "balanceDue": "Balance Due",
        "status": "Status",
        "description": "Description",
        "editDescriptionAriaLabel": "Edit bill description",
        "notes": "Notes",
        "tagsLabel": "Tags",
        "createdBy": "Created by",
        "cancelledBy": "Cancelled by",
        "viewLinkedTransaction": "View linked transaction",
        "viewLinkedExpense": "View linked expense",
        "viewLinkedCancelledTransaction": "View linked cancelled transaction",
        "cancelledBillLinkedTooltip": "This transaction is linked to a cancelled bill.",
        "delete": "Delete",
        "paidButton": "Paid",
        "receiveStock": "Receive stock",
        "linkedReceivesTitle": "Linked stock receives",
        "linkedReceiveLink": "View linked receive ({{status}}) — {{date}}",
        "linkedReceivesLoadError": "Failed to load linked stock receives.",
        "linkedReceivesRetry": "Try again",
        "alreadyPaidToast": "This bill is already paid",
        "paymentsHistory": {
          "title": "Payments History",
          "loading": "Loading payments history…",
          "empty": "No payments recorded for this bill yet.",
          "colReference": "Reference",
          "colEvent": "Event",
          "colAmount": "Amount",
          "colPaymentDate": "Payment date",
          "colPaymentMethod": "Payment method",
          "colRecordedAt": "Recorded at",
          "colPerformedBy": "Recorded by",
          "performedByLabel": "Recorded by",
          "colActions": "Actions",
          "eventPaymentMade": "Payment made",
          "eventPaymentCancelled": "Payment cancelled",
          "viewDetails": "View details",
          "cancelPayment": "Cancel payment",
          "cancelPaymentConfirm": "Cancel payment",
          "cancellingPayment": "Cancelling payment…",
          "paymentCancelled": "Payment cancelled.",
          "detailsTitle": "Payment details",
          "closeDetails": "Close",
          "viewLinkedTransaction": "View linked transaction",
          "cancelModalTitle": "Cancel payment",
          "cancelModalBody": "Cancel payment {{reference}} ({{amount}})? This adds a cancellation record; the original payment row is kept in history.",
          "openPaymentAria": "Open payment {{reference}}",
          "cancelModalNo": "CancelModalNo",
          "cancelModalYes": "CancelModalYes"
        },
        "fxRevaluationsHistory": {
          "title": "FX revaluations",
          "loading": "Loading FX revaluations…",
          "empty": "No period-end FX revaluations recorded for this bill yet.",
          "colBookReference": "Book ref.",
          "colAsOfDate": "As-of date",
          "colAdjustment": "Unrealized FX",
          "colCarryingBefore": "Carrying before",
          "colCarryingAfter": "Carrying after",
          "colActions": "Linked transaction",
          "adjustmentLoss": "Loss {{amount}}",
          "adjustmentGain": "Gain {{amount}}",
          "viewLinkedTransaction": "View unrealized FX journal"
        }
      },
      "AddBillModal": {
        "title": "Add New Bill",
        "supplierLabel": "Supplier Company Name",
        "supplierRequired": "Select a supplier.",
        "refNumberLabel": "Reference number",
        "refNumberRequired": "Reference number is required.",
        "refNumberHint": "Supplier invoice, bill no., or ref. no. (not the internal bill #).",
        "billingCategoryLabel": "Category",
        "billingCategoryRequired": "Select a category for each Bill For line.",
        "linesLabel": "Bill For",
        "addLine": "Add line",
        "removeLine": "Remove",
        "creditLinesLabel": "Credit Category",
        "creditCategoryLabel": "Category",
        "creditCategoryRequired": "Select a category for each credit line.",
        "creditLinesTotalMismatch": "Bill For and Credit Category totals must match.",
        "splitLinesBalancedStatus": "Bill For and Credit Category lines are balanced.",
        "splitLinesUnbalancedStatus": "Out of balance by {{difference}}.",
        "splitLinesBalanceDetail": "Bill For: {{billForTotal}} · Credit Category: {{creditTotal}}",
        "addCreditLine": "Add credit line",
        "removeCreditLine": "Remove",
        "categoryPlaceholder": "Select category…",
        "linesTotal": "Bill For total: {{amount}}",
        "creditLinesTotal": "Credit Category total: {{amount}}",
        "lineAmountForeignLabel": "Amount ({{currency}})",
        "issueDateLabel": "Issue date",
        "issueDateRequired": "Issue date is required.",
        "dueDateLabel": "Due date",
        "dueDateRequired": "Due date is required.",
        "amountLabel": "Amount",
        "amountLabelWithCurrency": "Amount ({{currency}})",
        "amountInputAria": "Bill amount in {{currency}}",
        "amountInvalid": "Enter a valid positive amount.",
        "useForeignCurrency": "Use foreign currency",
        "amountPhpLabel": "Amount recorded (PHP)",
        "fxAmountInvalid": "Enter a valid foreign amount and exchange rate.",
        "recentSuppliersLabel": "Recently used suppliers",
        "supplierSuggestionWithCategory": "{{supplier}} ({{category}})",
        "relatedCategoriesLabel": "Suggested categories for selected supplier",
        "descriptionLabel": "Notes / description (optional)",
        "tagsLabel": "Tags",
        "tagsHelper": "Optional labels to organize and filter bills.",
        "cancel": "Cancel",
        "recordBill": "Record Bill",
        "saving": "Saving…",
        "saved": "Bill recorded."
      },
      "BillCreate": {
        "backToList": "Back",
        "title": "New Bill",
        "subtitle": "Record a supplier bill and track it in accounts payable.",
        "loading": "Loading bill form…"
      }
    },
    "billPayments": {
      "list": {
        "title": "Bill Payments",
        "loading": "Loading bill payments…",
        "tryAgain": "Try again",
        "empty": "No bill payments recorded yet.",
        "colBill": "Bill",
        "colSupplier": "Supplier",
        "openPaymentAria": "Open payment {{reference}}"
      },
      "details": {
        "backToList": "Back",
        "titleFallback": "Bill payment",
        "loading": "Loading payment…",
        "tryAgain": "Try again",
        "linkedBill": "Bill",
        "viewLinkedBill": "View linked bill",
        "cancelling": "Cancelling payment…",
        "cancelSuccess": "Payment cancelled.",
        "back": "Back"
      }
    },
    "fxRevaluations": {
      "list": {
        "title": "FX Revaluations",
        "loading": "Loading FX revaluations…",
        "tryAgain": "Try again",
        "empty": "No FX revaluations recorded yet.",
        "searchPlaceholder": "Search by FXAP, bill, supplier, or currency…",
        "noSearchResults": "No FX revaluations match your search.",
        "colBookReference": "Book ref.",
        "colBill": "Bill",
        "colSupplier": "Supplier",
        "colCurrency": "Currency",
        "openBillAria": "Open bill {{bill}} for revaluation on {{date}}",
        "openDetailAria": "Open FX revaluation {{reference}}"
      },
      "details": {
        "titleFallback": "FX revaluation",
        "backToList": "Back",
        "loading": "Loading FX revaluation…",
        "tryAgain": "Try again",
        "notAvailable": "—",
        "bookReferenceNumber": "Book reference",
        "asOfDate": "As-of date",
        "linkedBill": "Linked bill",
        "closingRate": "Closing exchange rate",
        "recordedAt": "Recorded",
        "recordedBy": "Recorded by",
        "linkedTransaction": "Linked transaction"
      }
    },
    "invoicePayments": {
      "list": {
        "title": "Invoice Payments",
        "loading": "Loading invoice payments…",
        "tryAgain": "Try again",
        "empty": "No invoice payments recorded yet.",
        "colCustomer": "Customer",
        "colInvoices": "Invoices",
        "openPaymentAria": "Open payment {{reference}}"
      },
      "details": {
        "backToList": "Back",
        "back": "Back",
        "titleFallback": "Invoice payment",
        "loading": "Loading payment…",
        "tryAgain": "Try again",
        "linkedInvoices": "Linked invoices",
        "viewLinkedInvoice": "View linked invoice",
        "viewLinkedInvoiceNamed": "View linked invoice — {{invoiceNumber}}",
        "viewLinkedCashReceipt": "Cash Received {{bookReference}}",
        "viewLinkedCashReceiptFallback": "View cash received",
        "viewLinkedJournal": "View Linked Transaction {{referenceNumber}}",
        "viewLinkedJournalFallback": "View linked transaction",
        "linkedInvoiceCancelledBadge": "Cancelled",
        "cancelBlockedAlreadyCancelled": "This payment has already been cancelled.",
        "cancelBlockedCancelledInvoice": "Cannot cancel this payment because linked invoice {{invoiceNumber}} is already cancelled.",
        "cancelBlockedCancelledInvoices": "Cannot cancel this payment because {{count}} linked invoices are already cancelled.",
        "cancelling": "Cancelling payment…",
        "cancelSuccess": "Payment cancelled."
      }
    },
    "arInvoices": {
      "fieldLengthHint": "{{count}} / {{max}} characters",
      "seriesSetup": {
        "nextSequenceInvalid": "Enter a valid starting invoice number (1 or greater).",
        "saving": "Saving…",
        "saved": "Invoice setup saved.",
        "title": "Setup Invoices before use",
        "settingsTitle": "Sales invoice settings",
        "summary": "Add the required seller and numbering details so you can start issuing invoices.",
        "settingsSummary": "Edit invoice numbering and BIR accreditation used on printed sales invoices. Business name, address, and TIN are managed in company details above.",
        "settingsNumberingHint": "Next invoice number used when issuing sales invoices.",
        "optionalNumberFormatTitle": "Number format",
        "optionalNumberFormatHint": "Optional prefix and suffix for printed invoice numbers",
        "identityIncompleteHint": "Add a business name and address in company details before issuing invoices.",
        "editCompanyDetails": "Edit company details",
        "complianceHint": "Add your BIR Permit to Use and accreditation details to complete invoice compliance.",
        "formHasErrors": "Please fix the highlighted fields before continuing.",
        "companyLoadFailed": "Failed to load company details.",
        "requiredSectionTitle": "Required",
        "requiredSectionHint": "These fields are needed before you can use invoices.",
        "optionalSectionsHint": "Optional details — expand a section to fill them in.",
        "optionalBadge": "Optional",
        "optionalSellerNumberingTitle": "Seller TIN & number format",
        "optionalSellerNumberingHint": "TIN, prefix, and suffix for printed invoices",
        "sellerNameLabel": "Seller business name",
        "sellerNamePlaceholder": "Enter your registered business name",
        "sellerAddressLabel": "Seller business address",
        "sellerAddressPlaceholder": "Enter your business address",
        "sellerTinLabel": "Seller TIN",
        "sellerTinPlaceholder": "000-000-000-00000",
        "sellerNameMissing": "Business name is required.",
        "sellerAddressMissing": "Business address is required.",
        "sellerTinInvalid": "TIN must be exactly 9 or 14 digits.",
        "numberingSectionTitle": "Sales invoice number",
        "prefixLabel": "Prefix",
        "suffixLabel": "Suffix",
        "nextSequenceLabel": "Next invoice number",
        "prefixPlaceholder": "e.g. INV-",
        "suffixPlaceholder": "e.g. -A",
        "nextSequencePlaceholder": "e.g. 1",
        "lockedNotice": "The prefix, suffix, and next number are locked after your first invoice is issued.",
        "birSectionTitle": "BIR Permit & accreditation",
        "birSectionHint": "Complete accreditation (AC No., date issued, and range of series) to print VAT-format invoices.",
        "birPermitGroupTitle": "Permit & acknowledgement",
        "birAccreditationGroupTitle": "Accreditation",
        "birSoftwareSupplierGroupTitle": "Software supplier",
        "softwareSupplierHint": "Software supplier shown on accredited invoice footers",
        "ptuLabel": "Permit to Use (PTU) number",
        "ptuPlaceholder": "Enter PTU number",
        "accnLabel": "Acknowledgement Certificate Control Number (ACCN)",
        "accnPlaceholder": "Enter ACCN",
        "accreditationNumberLabel": "AC No.",
        "accreditationNumberPlaceholder": "Enter accreditation number",
        "accreditationDateIssuedLabel": "Date issued",
        "accreditationValidUntilLabel": "Accreditation valid until",
        "rangeOfSeriesLabel": "Range of series",
        "rangeOfSeriesPlaceholder": "e.g. 000000001-000001000",
        "softwareSupplierNameLabel": "Software supplier name",
        "softwareSupplierNamePlaceholder": "Enter software supplier name",
        "softwareSupplierTinLabel": "Software supplier TIN",
        "softwareSupplierTinPlaceholder": "Enter software supplier TIN",
        "softwareSupplierAddressLabel": "Software supplier address",
        "softwareSupplierAddressPlaceholder": "Enter software supplier address",
        "cancel": "Cancel",
        "skipBirDetails": "Skip BIR details for now",
        "saveAndContinue": "Save and continue",
        "saveSettings": "Save invoice settings"
      },
      "ArInvoices": {
        "collectingPayment": "Recording payment…",
        "collectPaymentSuccess": "Payment recorded.",
        "tryAgain": "Try again",
        "title": "Invoices",
        "summary": "Issue invoices and track accounts receivable balances.",
        "setupRequiredSummary": "Complete the required seller and numbering setup before you can use invoices.",
        "newInvoice": "New Invoice",
        "paymentHistory": "Payment History",
        "newInvoiceRequiresSeries": "Set up invoice numbering before creating an invoice.",
        "loading": "Loading invoices…",
        "birBannerText": "Add your BIR Permit to Use and accreditation details to complete invoice compliance.",
        "completeSetup": "Complete setup",
        "dismiss": "Dismiss",
        "agingCurrent": "Current",
        "aging30": "1–30 days past due",
        "aging60": "31–60 days past due",
        "aging90": "61+ days past due",
        "searchPlaceholder": "Search by ref. #, invoice #, or customer…",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "clearFiltersButton": "Clear filters",
        "filterDateFrom": "Date from",
        "filterDateTo": "Date to",
        "statusFilterLabel": "Status",
        "statusFilterAll": "All",
        "statusFilterUnpaid": "Unpaid",
        "statusFilterPartially": "Partially paid",
        "statusFilterOverdue": "Overdue",
        "statusFilterPaid": "Paid",
        "statusFilterCancelled": "Cancelled",
        "statusFilterDraft": "Draft",
        "dueFilterLabel": "Due",
        "dueFilterAll": "All",
        "dueFilterOverdue": "Overdue",
        "dueFilterDueToday": "Due today",
        "dueFilterUpcoming": "Upcoming",
        "showVoidedLabel": "Show voided invoices",
        "emptySearch": "No invoices match your search.",
        "empty": "No invoices issued yet. Create your first invoice to start tracking receivables.",
        "selectionSummary": "{{count}} selected · {{amount}}",
        "clearSelection": "Clear selection",
        "collectSelected": "Collect Payment",
        "colBookReference": "Ref. #",
        "colInvoiceNumber": "Invoice #",
        "colCustomer": "Customer",
        "colDate": "Date",
        "colDueDate": "Due date",
        "colTotal": "Total",
        "colBalance": "Balance",
        "colStatus": "Status",
        "colActions": "Actions",
        "colSelect": "Select",
        "collect": "Collect",
        "selectAllPayableAria": "Select all payable invoices on this page",
        "selectInvoiceAria": "Select invoice {{invoiceNumber}}",
        "status": {
          "unpaid": "Unpaid",
          "partially": "Partially paid",
          "overdue": "Overdue",
          "paid": "Paid",
          "cancelled": "Cancelled",
          "draft": "Draft"
        }
      },
      "NewArInvoice": {
        "lineDescriptionRequired": "Enter a description for every line item.",
        "lineProductRequired": "Select a product for every line item.",
        "lineQuantityInvalid": "Enter a valid quantity greater than zero for every line item.",
        "lineUnitPriceInvalid": "Enter a valid unit price for every line item.",
        "productMissingSalesCategory": "This product has no sales category. Assign one in Products before using it on an invoice.",
        "customerRequired": "Select a customer.",
        "invoiceDateRequired": "Select an invoice date.",
        "invoiceDateInFuture": "Invoice date cannot be in the future.",
        "invoiceDateLockedHint": "Invoice date is always today when you issue. Backdating is not allowed.",
        "dueDateRequired": "Select a due date.",
        "dueDateBeforeInvoiceDate": "Due date cannot be before the invoice date.",
        "paymentMethodRequired": "Select a payment method.",
        "paymentAmountInvalid": "Enter a valid payment amount.",
        "paymentAmountExceedsTotal": "Amount cannot exceed the invoice total ({{max}}).",
        "paymentAmountHint": "Invoice total: {{balance}}. Enter a lower amount for a partial payment.",
        "paidDateRequired": "Select a payment date.",
        "paymentForRequired": "Enter what this payment is for.",
        "saving": "Saving…",
        "saved": "Invoice issued.",
        "seriesRequired": "Set up invoice numbering before issuing your first invoice.",
        "goToSetup": "Go to setup",
        "loading": "Loading invoice form…",
        "loadFailed": "Failed to load invoice settings.",
        "loadingProducts": "Loading products…",
        "noProducts": "No products found. Add products before creating an invoice.",
        "backToList": "Back",
        "title": "New Invoice",
        "customerSectionTitle": "Customer",
        "customerLabel": "Customer",
        "customerPlaceholder": "Search or add a customer…",
        "referenceLabel": "Reference # (optional)",
        "referencePlaceholder": "e.g. PO-1234",
        "referenceHelp": {
          "openAria": "What is Reference # used for?",
          "title": "Reference #",
          "intro": "Use Reference # for your customer’s or your own external document number so you can match this invoice to their paperwork.",
          "bulletExamples": "Common examples: purchase order (PO), job order, contract ID, or delivery reference.",
          "bulletOptional": "It is optional. The official Invoice # still comes from your BIR invoice series.",
          "bulletWhereShown": "When filled in, it appears on the printed invoice, in invoice search, and in related journal descriptions.",
          "outro": "Leave it blank if you do not have an external reference for this sale."
        },
        "invoiceDateLabel": "Invoice date",
        "dueDateLabel": "Due date",
        "linesSectionTitle": "Line Items",
        "lineProduct": "Product",
        "lineProductPlaceholder": "Search for a product…",
        "lineDescription": "Description",
        "lineDescriptionPlaceholder": "Line description",
        "lineQuantity": "Qty",
        "quantityPlaceholder": "1",
        "lineUnitPrice": "Unit price",
        "unitPricePlaceholder": "0.00",
        "lineVat": "VAT",
        "vatOptional": "VAT (optional)",
        "lineTotal": "Amount",
        "vatVatable": "Vatable",
        "vatExempt": "Exempt",
        "vatZeroRated": "Zero-rated",
        "removeLine": "Remove line",
        "addLine": "Add line",
        "netOfVat": "Net of VAT",
        "vat": "VAT",
        "grandTotal": "Total",
        "notesLabel": "Notes (optional)",
        "notesPlaceholder": "Additional notes for this invoice",
        "paymentSectionTitle": "Payment",
        "collectLater": "Collect payment later",
        "collectNow": "Collect payment now",
        "paymentMethodLabel": "Payment method",
        "paymentAmountLabel": "Amount received",
        "paymentAmountPlaceholder": "0.00",
        "paidDateLabel": "Payment date",
        "paymentForLabel": "Payment For",
        "paymentForPlaceholder": "e.g. Food and office supplies",
        "cancel": "Cancel",
        "issueAndCollect": "Issue and Record Payment",
        "issue": "Issue Invoice",
        "lineItem": "Item",
        "lineItemPlaceholder": "Select product or sales category…",
        "lineItemRequired": "Select a product or sales category for every line item.",
        "loadingLineItems": "Loading products and sales categories…"
      },
      "collectPaymentModal": {
        "title": "Collect Payment",
        "reviewing": "Reviewing {{count}} invoice(s) for payment.",
        "partialNotice": "You can collect the full balance or a partial amount. Invoices stay open until the remaining balance is paid.",
        "amountLabel": "Amount",
        "amountPlaceholder": "0.00",
        "amountAria": "Payment amount for invoice {{invoiceNumber}}",
        "amountHint": "Balance due: {{balance}}. Enter a lower amount for a partial payment.",
        "amountInvalid": "Enter a valid amount greater than zero.",
        "amountExceedsBalance": "Amount cannot exceed the balance due ({{max}}).",
        "totalLabel": "Total to collect",
        "methodLabel": "Payment method",
        "noMethod": "No cash/bank categories available. Add one under Categories first.",
        "paidDateLabel": "Payment date",
        "paymentForLabel": "Payment For",
        "paymentForPlaceholder": "e.g. Food and office supplies",
        "paymentForRequiredToast": "Enter what this payment is for.",
        "cancel": "Cancel",
        "confirming": "Recording…",
        "confirm": "Record Payment"
      },
      "ArInvoiceDetails": {
        "collectingPayment": "Recording payment…",
        "collectPaymentSuccess": "Payment recorded.",
        "cancelling": "Cancelling invoice…",
        "cancelled": "Invoice cancelled.",
        "backToList": "Back",
        "title": "Invoice",
        "printing": "Preparing PDF…",
        "print": "Print",
        "pdfBlocked": "Your browser blocked the invoice PDF. Allow pop-ups and try again.",
        "collectionReceiptPdfBlocked": "Your browser blocked the collection receipt PDF. Allow pop-ups and try again.",
        "collectPayment": "Collect Payment",
        "cancel": "Cancel Invoice",
        "loading": "Loading invoice…",
        "tryAgain": "Try again",
        "notFound": "Invoice not found.",
        "total": "Total",
        "customer": "Customer",
        "invoiceNumber": "Invoice #",
        "bookReferenceNumber": "Book ref. #",
        "refNumber": "Customer reference #",
        "invoiceDate": "Invoice date",
        "dueDate": "Due date",
        "paidDate": "Paid on",
        "balanceDue": "Balance due",
        "status": "Status",
        "createdBy": "Created by",
        "cancelledBy": "Cancelled by",
        "paymentCollectedImmediately": "Payment Collected Immediately",
        "viewLinkedTransaction": "View linked transaction",
        "viewLinkedVoidedTransaction": "See linked voided transaction",
        "cancelledInvoiceLinkedTooltip": "This transaction is linked to a cancelled invoice.",
        "issuedInvoiceNotice": "Issued invoices cannot be edited. Cancel unpaid invoices (after reversing any payments) and reissue if you need changes.",
        "copyVerifyLink": "Copy verify link",
        "copyVerifyLinkSuccess": "Verification link copied.",
        "copyVerifyLinkFailed": "Could not copy the verification link.",
        "copyVerifyLinkUnavailable": "This invoice has no verification link yet.",
        "lineDescription": "Description",
        "lineProduct": "Product",
        "lineCategory": "Revenue category",
        "lineQuantity": "Qty",
        "lineUnitPrice": "Unit price",
        "lineVat": "VAT",
        "lineTotal": "Amount",
        "vatExempt": "VAT exempt",
        "zeroRated": "Zero-rated",
        "description": "Description",
        "editDescriptionAriaLabel": "Edit invoice description",
        "notes": "Notes",
        "paymentHistory": "Payment History",
        "openPaymentAria": "Open payment {{reference}}",
        "eventPaymentMade": "Payment made",
        "eventPaymentCancelled": "Payment cancelled",
        "reprintCollectionReceipt": "Reprint",
        "reprintCollectionReceiptAria": "Reprint collection receipt {{reference}}",
        "reprintCollectionReceiptSuccess": "Collection receipt opened.",
        "printCollectionReceipt": "Print",
        "printCollectionReceiptAria": "Print collection receipt {{reference}}",
        "printCollectionReceiptSuccess": "Collection receipt opened.",
        "printCollectionReceiptFailed": "Failed to print collection receipt.",
        "cancelPayment": "Cancel payment",
        "cancelPaymentConfirm": "Cancel payment",
        "cancellingPayment": "Cancelling payment…",
        "paymentCancelled": "Payment cancelled.",
        "cancelPaymentModalTitle": "Cancel payment",
        "cancelPaymentModalBody": "Cancel payment {{reference}} ({{amount}})? This posts a reversing journal entry and voids the linked cash receipt. The original payment row stays in history.",
        "cancelPaymentDismiss": "Keep payment",
        "cancelPaymentMultiInvoiceWarning": "This payment was applied to {{count}} invoices. Cancelling it will reverse the collection on all of them.",
        "cancelBlockedCancelledInvoice": "Cannot cancel this payment because invoice {{invoiceNumber}} is already cancelled.",
        "cancelModalTitle": "Cancel this invoice?",
        "cancelModalBody": "This will cancel invoice {{invoiceNumber}} for {{customer}}. This action cannot be undone.",
        "cancelDismiss": "Keep invoice",
        "cancelConfirm": "Cancel invoice",
        "cancelPaymentModalNo": "Keep payment",
        "cancelPaymentModalYes": "Cancel payment",
        "back": "Back"
      }
    },
    "instoreqr": {
      "pageTitle": "InStoreQR",
      "pageSubtitle": "QR-based channel ordering and kitchen display for your restaurant.",
      "loadingPage": {
        "brand": "InStoreQR",
        "label": "Loading…",
        "aria": "Loading InStoreQR"
      },
      "nav": {
        "brand": "InStoreQR",
        "hub": "Home",
        "channels": "Channels & QR",
        "orderMenu": "Order Menu",
        "kds": "Kitchen Display",
        "salesReports": "Sales Reports",
        "products": "Manage Products",
        "menuImport": "Import from photo",
        "exitToAbrafi": "Exit to AbraFi",
        "openMenu": "Open navigation",
        "closeMenu": "Close navigation",
        "sidebarAria": "InStoreQR navigation"
      },
      "menuImport": {
        "pageTitle": "Import products from photo",
        "documentTitle": "Import products from photo",
        "backLink": "Back to InStoreQR",
        "subtitle": "AI reads the menu. Nothing is added until you review and import.",
        "choosePhotoButton": "Choose photo",
        "readingButton": "Reading menu…",
        "dropHint": "Take a clear photo of your printed or posted menu.",
        "previewAlt": "Uploaded menu photo",
        "retryButton": "Try again",
        "emptyExtract": "No products were found in this photo. Try a clearer image.",
        "nameLabel": "Name",
        "priceLabel": "Price",
        "categoryLabel": "Category",
        "descriptionLabel": "Description",
        "includeAria": "Include {{name}}",
        "removeAria": "Remove {{name}}",
        "importButton": "Import selected",
        "importingButton": "Importing…",
        "invalidTypeToast": "Use a JPEG, PNG, WebP, or GIF photo.",
        "tooLargeToast": "That photo is too large. Use a file under 10 MB.",
        "noProductsToast": "Select at least one product with a name to import.",
        "importingToast": "Adding products…",
        "successToast": "Imported {{count}} products.",
        "partialSuccessToast": "Imported {{created}} products. {{failed}} could not be added."
      },
      "session": {
        "statusOpen": "Session open",
        "statusClosed": "Session closed",
        "closedHint": "Open a session to accept and process orders.",
        "openButton": "Open session",
        "closeButton": "Close session",
        "openModalTitle": "Open InStoreQR session",
        "openModalBody": "Open this session to accept orders. Order numbers will restart at #1.",
        "closeModalTitle": "Close InStoreQR session",
        "closeModalBody": "All orders must be completed and paid (or deleted) before closing.",
        "opening": "Opening session…",
        "closing": "Closing session…",
        "openSuccess": "Session opened. Order numbers restart at #1.",
        "closeSuccess": "Session closed.",
        "cancelButton": "Cancel",
        "confirmOpenButton": "Open",
        "confirmCloseButton": "Close session"
      },
      "hub": {
        "groups": {
          "ordering": "Ordering",
          "menu": "Menu",
          "kitchen": "Kitchen",
          "reports": "Reports"
        },
        "cards": {
          "tables": {
            "title": "Channel & QR Codes",
            "description": "Register channels, generate and print QR codes for customer self-ordering."
          },
          "products": {
            "title": "Manage Products",
            "description": "Add, edit, and organize items you sell — shared with POS."
          },
          "menuImport": {
            "title": "Import products from photo",
            "description": "Upload a menu photo. Review what AI finds, then add them to your catalog."
          },
          "orderMenu": {
            "title": "Order Menu",
            "description": "Pick a channel and place orders for that table — for staff, not guest QR."
          },
          "kds": {
            "title": "Kitchen Display",
            "description": "Monitor and manage incoming orders in real time."
          },
          "salesReports": {
            "title": "Sales Reports",
            "description": "Review completed and paid orders to track dine-in sales."
          }
        }
      },
      "tables": {
        "pageTitle": "Channel & QR Codes",
        "backLink": "Back to InStoreQR",
        "addButton": "Add Channel",
        "editButton": "Edit",
        "deleteButton": "Delete",
        "viewQrButton": "View QR",
        "printQrButton": "Print QR",
        "tableNumberLabel": "Channel",
        "locationLabel": "Location",
        "tableNumberPlaceholder": "e.g. 1",
        "locationPlaceholder": "e.g. Ground Floor, Patio",
        "emptyState": "No channels registered yet. Add your first channel to get started.",
        "addModal": {
          "title": "Add Channel",
          "saveButton": "Save Channel"
        },
        "editModal": {
          "title": "Edit Channel",
          "saveButton": "Save Changes"
        },
        "deleteConfirmation": "Are you sure you want to delete Channel {{tableNumber}}?",
        "deleteSuccess": "Channel deleted.",
        "saveSuccess": "Channel saved.",
        "saving": "Saving…",
        "loading": "Loading channels…",
        "loadError": "Could not load channels. Try again.",
        "retryButton": "Try again",
        "tableNumberRequiredToast": "Enter a channel name.",
        "migratingLocal": "Restoring channels from this browser…",
        "migrateLocalSuccess": "Restored {{count}} channel(s) to the company.",
        "duplicateError": "A channel with this name already exists.",
        "qrModal": {
          "title": "QR Code — {{tableNumber}}",
          "location": "Location: {{location}}",
          "scanPrompt": "Scan to order",
          "printButton": "Print QR",
          "linkLabel": "Direct link:"
        }
      },
      "orderMenu": {
        "pageTitle": "Order Menu",
        "subtitle": "Choose a channel to open the menu and place orders for that table.",
        "noCompany": "Select a company to use the order menu.",
        "loading": "Loading channels…",
        "loadError": "Could not load channels. Try again.",
        "retryButton": "Try again",
        "emptyChannels": "No channels yet. Add a channel first, then come back to take orders.",
        "goToChannelsButton": "Go to Channels",
        "channelLabel": "Channel {{tableNumber}}",
        "openMenuButton": "Open menu"
      },
      "kds": {
        "pageTitle": "Kitchen Display",
        "backLink": "Back to InStoreQR",
        "columns": {
          "pending": "Pending",
          "preparing": "Preparing",
          "serving": "Now Serving"
        },
        "emptyColumn": "No orders",
        "tableLabel": "{{tableNumber}}",
        "tableBillTotal": "Bill {{total}}",
        "itemNotes": "Note: {{notes}}",
        "moveNext": "Move to next",
        "moveAllNextButton": "Move all to next",
        "movingAllNext": "Updating…",
        "moveAllNextSuccess": "Table {{tableNumber}} — {{count}} order(s) moved to the next step.",
        "markCompleted": "Mark completed",
        "markAllCompletedButton": "Mark all complete",
        "markingAllCompleted": "Completing…",
        "markAllCompletedSuccess": "Table {{tableNumber}} — {{count}} order(s) marked complete.",
        "paymentTagUnpaid": "Unpaid",
        "paymentTagReadyForPayment": "Ready for payment",
        "paymentTagPaid": "Paid",
        "markPaidButton": "Paid",
        "markTablePaidButton": "Pay table ({{count}})",
        "markingPaid": "Marking paid…",
        "markPaidSuccess": "Order marked as paid.",
        "markTablePaidSuccess": "Table {{tableNumber}} paid — {{count}} order(s), {{total}}.",
        "loading": "Loading orders…",
        "moving": "Updating…",
        "loadError": "Could not load kitchen orders. Try again.",
        "retryButton": "Try again",
        "statusUpdateFailed": "Could not update the order status.",
        "deleteOrderAria": "Delete order {{orderNumber}}",
        "deleteConfirmation": "Delete order #{{orderNumber}}? This cannot be undone.",
        "deleting": "Deleting…",
        "deleteSuccess": "Order deleted."
      },
      "salesReports": {
        "pageTitle": "Sales Reports",
        "backLink": "Back to InStoreQR",
        "refreshAria": "Refresh sales report",
        "loading": "Loading completed orders…",
        "loadError": "Could not load sales reports. Try again.",
        "retryButton": "Try again",
        "dateFromLabel": "From",
        "dateToLabel": "To",
        "settledOrdersLabel": "Completed & paid orders",
        "totalSalesLabel": "Total sales",
        "emptyState": "No completed and paid orders yet. Orders appear here after kitchen marks them completed and payment is recorded.",
        "emptyFilteredState": "No completed and paid orders in this date range.",
        "columns": {
          "order": "Order",
          "table": "Channel",
          "items": "Items",
          "completedAt": "Completed",
          "total": "Total"
        }
      },
      "customerMenu": {
        "pageTitle": "Menu",
        "previewBadge": "Preview",
        "previewBanner": "This is a view-only preview. Scan a channel QR code to order.",
        "sessionClosedToast": "This restaurant is not open for ordering yet. Please wait for staff to open a session.",
        "sessionClosedBanner": "Ordering is closed until the restaurant opens a session.",
        "storeClosedModalTitle": "Store is closed",
        "storeClosedModalBody": "This restaurant is not accepting orders right now. Please wait for staff to open a session. This screen will update automatically when ordering is available.",
        "diningEndedBanner": "This table session has ended. All orders were completed and paid. Scan the QR again or start a new session to order.",
        "diningEndedToast": "This table session has ended. Start a new session to order again.",
        "visitRequiredToast": "Connecting to your table session… Try again in a moment.",
        "startNewSessionButton": "Start new session",
        "joiningSessionButton": "Starting…",
        "loadingSession": "Opening your table session…",
        "invalidLinkTitle": "This menu link is not valid.",
        "invalidLinkBody": "Scan the channel QR code again to open the menu.",
        "tableTag": "{{tableNumber}}",
        "locationLabel": "Location: {{location}}",
        "menuTab": "Menu",
        "ordersTab": "My Orders",
        "statusTab": "Review and Payment",
        "searchPlaceholder": "Search menu…",
        "searchAria": "Search products",
        "suggestionsAria": "Product suggestions",
        "noSearchResults": "No products match your search.",
        "uncategorizedCategory": "Other",
        "menuLoading": "Loading menu…",
        "menuLoadError": "Could not load the menu. Try again.",
        "menuEmpty": "No products are available on the menu yet.",
        "menuNeedsCompany": "Scan a channel QR code to view the menu.",
        "reviewTabDisabledAria": "Review and Payment is unavailable until you place an order.",
        "ordersTabDisabledAria": "My Orders is unavailable until you place an order.",
        "ordersTabOrderFirstToast": "Place an order first to view My Orders.",
        "reviewTabOrderFirstToast": "Place an order first to review and pay.",
        "addToCart": "Add to Cart",
        "variantPicker": {
          "title": "Choose options — {{name}}",
          "intro": "Select a variant to continue.",
          "searchPlaceholder": "Search variants…",
          "searchAria": "Search variants",
          "noSearchResults": "No variants match your search.",
          "unavailable": "Combination unavailable",
          "cancel": "Cancel",
          "select": "Continue"
        },
        "addons": {
          "title": "Add-ons — {{name}}",
          "intro": "Choose optional add-ons, then add to cart.",
          "cancel": "Cancel",
          "addToCart": "Add to Cart"
        },
        "itemCustomize": {
          "title": "{{name}}",
          "intro": "Add a note if you like, then add to cart."
        },
        "cart": "Cart",
        "cartEmpty": "Your cart is empty.",
        "specialInstructions": "Special instructions (optional)",
        "specialInstructionsPlaceholder": "Add a note… e.g. No onions, No peppers.",
        "placeOrder": "Place Order",
        "placingOrder": "Placing order…",
        "emptyCartToast": "Add items to your cart before placing an order.",
        "tableRequiredToast": "Scan a channel QR code to place an order.",
        "companyRequiredToast": "This menu link is missing the restaurant. Scan the channel QR again.",
        "ordersLoading": "Loading your orders…",
        "ordersLoadError": "Could not load your orders. Try again.",
        "retryButton": "Try again",
        "statusLoading": "Loading order status…",
        "statusLoadError": "Could not load order status. Try again.",
        "statusRetryButton": "Try again",
        "viewCartAria": "View cart",
        "closeCartAria": "Close cart",
        "removeItemAria": "Remove item",
        "orderPlaced": "Order placed!",
        "orderFailed": "Failed to place order.",
        "noOrders": "No orders yet.",
        "noActiveOrders": "No active orders.",
        "reviewEmpty": "No orders to review yet. Place an order from the menu first.",
        "orderNumber": "Order #{{number}}",
        "total": "Total",
        "payableTotalLabel": "Amount due",
        "tapToPayButton": "Tap to Pay",
        "tapToPayPaying": "Sending to kitchen…",
        "tapToPayEmptyToast": "Place an order first before paying.",
        "tapToPayNothingToMoveToast": "No open orders to send for payment.",
        "tapToPaySuccess": "Your orders are ready for payment.",
        "paymentTagUnpaid": "Unpaid",
        "paymentTagReadyForPayment": "Ready for payment",
        "paymentTagPaid": "Paid",
        "status": {
          "pending": "Pending",
          "preparing": "Preparing",
          "serving": "Now Serving",
          "completed": "Completed"
        }
      }
    },
    "appsStore": {
      "pageTitle": "Apps Store",
      "pageSubtitle": "Discover, install, and manage Abrasoft apps for your company — like an extensions marketplace for your workspace.",
      "onboardingBannerTitle": "Choose your apps to get started",
      "onboardingBannerBody": "This company has no apps installed yet. Browse the catalog below and install the modules you need. Installed apps appear in the sidebar under Advanced.",
      "searchPlaceholder": "Search apps",
      "installedOnlyFilter": "Installed",
      "installedOnlyEmpty": "No installed apps yet. Browse the catalog and install what you need.",
      "installedSectionTitle": "Installed",
      "availableSectionTitle": "Available",
      "loading": "Loading apps…",
      "retryButton": "Try again",
      "emptyState": "No apps match your search.",
      "backToStore": "Back",
      "overviewHeading": "Overview",
      "recommendedHeading": "You may also like",
      "installedBadge": "Installed",
      "customizedBadge": "Customized",
      "availableBadge": "Available",
      "comingSoonBadge": "Coming soon",
      "comingSoonButton": "Coming soon",
      "comingSoonHint": "This app is not available to install yet. You can still preview its details here.",
      "comingSoonToast": "This app is coming soon and cannot be installed yet.",
      "installButton": "Install",
      "restoreBundleButton": "Install missing apps",
      "installingButton": "Installing…",
      "uninstallButton": "Uninstall",
      "uninstallingButton": "Uninstalling…",
      "price": {
        "inYourPlan": "In your plan"
      },
      "ownerHint": "Only the company owner can install or uninstall apps.",
      "ownerOnlyToast": "Only the company owner can install or uninstall apps.",
      "installedToast": "{{name}} was installed for this company.",
      "uninstalledToast": "{{name}} was uninstalled for this company.",
      "actionFailedToast": "Could not update the app. Try again.",
      "bundle": {
        "heading": "Included standalone apps",
        "description": "Install the full bundle, or manage each app separately. Removing one app customizes the bundle without affecting the others.",
        "removeAllButton": "Remove all bundle apps",
        "removeAllConfirmation": "Remove {{name}} and all of its included apps? This cannot be undone."
      },
      "comparison": {
        "eyebrow": "App comparison",
        "heading": "Compared with your installed {{current}}",
        "description": "Here is what {{selected}} adds and how it overlaps with your current books.",
        "additiveNote": "Installing another app is additive. It does not uninstall apps or remove features you already have.",
        "addedHeading": "Added to your setup",
        "addedEmpty": "This app does not add capabilities beyond your current books.",
        "sharedHeading": "Already in your setup",
        "retainedHeading": "Not included, but retained",
        "retainedHint": "These remain available through your currently installed app.",
        "capabilities": {
          "booksHubs": "Journals and Reports hubs",
          "cashJournals": "Cash Receipts and Cash Disbursement Journals",
          "customEntries": "General Journal and all transactions",
          "businessDirectories": "Customers, suppliers, and chart of accounts",
          "uploadAndAudit": "Upload Entry and Activity Logs",
          "financialStatements": "Core financial statements and trial balance",
          "ledgerReports": "General Ledger and General Journal reports",
          "ppeAndCapitals": "PPE and Capitals",
          "supplierBills": "Supplier bills and bill payments",
          "customerInvoices": "Customer invoices and invoice payments"
        }
      },
      "installOverlay": {
        "installingTitle": "Installing {{name}}",
        "doneTitle": "{{name}} is ready",
        "doneSubtitle": "The app is installed and now available in your sidebar.",
        "stagePreparing": "Preparing workspace package…",
        "stageDownloading": "Downloading app modules…",
        "stageConfiguring": "Configuring company access…",
        "stageFinishing": "Almost done — finalizing install…",
        "progressLabel": "{{percent}}%",
        "completeLabel": "Install complete"
      },
      "categories": {
        "all": "All apps",
        "bundles": "Books bundles",
        "bookkeeping": "Bookkeeping modules",
        "productivity": "Productivity",
        "finance": "Finance",
        "operations": "Operations",
        "people": "People"
      },
      "apps": {
        "accounting": {
          "title": "Accounting",
          "shortDescription": "Core bookkeeping for journals, invoices, bills, and the books of accounts your company relies on every day.",
          "description": "Core bookkeeping for your company. Record sales and expenses, manage invoices and bills, and keep a complete general ledger with reports.",
          "features": [
            "Journals hub for sales, expenses, bills, and custom entries",
            "Invoices and customer billing",
            "Financial statements and journal reports",
            "Book reference numbers on posted records"
          ]
        },
        "events": {
          "title": "Events",
          "shortDescription": "Plan events with registration pages, QR tickets, scanner check-in, and optional post-event surveys for attendees.",
          "description": "Plan company events with branded registration pages, channel tracking, walk-in and CSV imports, QR tickets, scanner check-in, and optional post-event surveys.",
          "features": [
            "Public registration links and channel analytics",
            "Walk-in check-in and CSV import",
            "QR tickets and scanner mode",
            "Post-event survey collection"
          ]
        },
        "file-manager": {
          "title": "File Manager",
          "shortDescription": "Company-owned shared storage for folders and files, with owner-only delete and move.",
          "description": "A company Drive for files your team needs to keep together. Members can browse, upload, and create folders. Only the company owner can delete or move items. File names must be unique in each folder.",
          "features": [
            "Shared company folders and files",
            "Upload and download from any member with access",
            "Create folders, including empty folders",
            "Owner-only delete and move"
          ]
        },
        "tax-calendar": {
          "title": "Tax Calendar",
          "shortDescription": "Track BIR filing deadlines, set reminders, and keep your team aligned on tax compliance throughout the year.",
          "description": "Track Philippine tax deadlines, configure reminders, and keep your team aligned on filing obligations throughout the year.",
          "features": [
            "Tax deadline calendar",
            "Reminder notifications",
            "Compliance-oriented workflow"
          ]
        },
        "business-calendar": {
          "title": "Business Calendar",
          "shortDescription": "Manage operational deadlines, renewals, and action items so your team never misses an important business date.",
          "description": "Manage business renewals, internal deadlines, and action items alongside your accounting calendar.",
          "features": [
            "Renewal and deadline tracking",
            "Action items list",
            "Team visibility for operational dates"
          ]
        },
        "invoices": {
          "title": "Invoices",
          "shortDescription": "Create and manage accounts receivable invoices, track balances, and keep customer billing connected to your books.",
          "description": "Create and manage AR invoices, track balances, and connect customer billing to your books.",
          "features": [
            "Invoice creation and editing",
            "Customer-linked billing",
            "Ledger integration"
          ]
        },
        "journals": {
          "title": "Journals",
          "shortDescription": "Open the journals hub for sales, expenses, bills, customers, suppliers, and the daily bookkeeping modules you need.",
          "description": "Access the journals hub for sales, expenses, bills, customers, suppliers, equipment, capitals, and related workflows.",
          "features": [
            "Central hub for journal modules",
            "Permission-aware module cards",
            "Deep links into daily bookkeeping"
          ]
        },
        "non-vat-books": {
          "title": "Cash Books",
          "shortDescription": "Cash journals, General Journal, General Ledger, customers, suppliers, categories, statements, PPE, and capitals in one bundle.",
          "description": "A complete cash-basis bookkeeping bundle. Install all included apps at once, then remove any modules your company does not need.",
          "features": [
            "Journals and Reports hubs with cash-book modules",
            "Cash Receipts and Cash Disbursement Journals",
            "General Journal and all transactions",
            "General Ledger",
            "Chart of accounts, customers, and suppliers",
            "Upload Entry and Activity Logs",
            "Income Statement, Balance Sheet, CIE, Cash Flow, and Trial Balance",
            "General Journal and related journal reports",
            "PPE and Capitals"
          ]
        },
        "non-vat-accrual-books": {
          "title": "Accrual Books",
          "shortDescription": "Everything in Cash Books plus supplier bills and customer invoices in one installable accrual bookkeeping bundle.",
          "description": "Everything in Cash Books, plus supplier bills and customer invoices. Install the complete accrual bundle, then remove any standalone modules your company does not need.",
          "features": [
            "Everything in Cash Books",
            "General Journal, General Ledger, customers, suppliers, and categories",
            "Upload Entry and Activity Logs",
            "Supplier bills and bill payments",
            "Customer invoices and invoice payments",
            "Journals and Reports hubs with matching modules"
          ]
        },
        "cash-receipts-journal": {
          "title": "Cash Receipts Journal",
          "shortDescription": "Record cash sales, customer receipts, and other money received in a dedicated cash receipts journal for your books.",
          "description": "Track customer receipts, cash sales, and other incoming cash in a dedicated journal.",
          "features": [
            "Cash receipt entries",
            "Customer and category assignment",
            "Book reference numbers"
          ]
        },
        "cash-disbursements-journal": {
          "title": "Cash Disbursements Journal",
          "shortDescription": "Record operating expenses, supplier payments, and other cash outflows in a dedicated disbursements journal.",
          "description": "Track operating expenses, supplier payments, and other outgoing cash in a dedicated journal.",
          "features": [
            "Cash expense entries",
            "Supplier and category assignment",
            "Book reference numbers"
          ]
        },
        "custom-entries": {
          "title": "General Journal",
          "shortDescription": "Record flexible debit and credit journal entries for adjustments, transfers, and other non-cash bookkeeping work.",
          "description": "Create general journal entries with custom debit and credit lines, then review them in the all-transactions list.",
          "features": [
            "Debit and credit journal lines",
            "All transactions list",
            "Flexible general journal workflow"
          ]
        },
        "general-ledger": {
          "title": "General Ledger",
          "shortDescription": "Review account-by-account transaction history with running balances across every category in your company books.",
          "description": "Review posted activity for each category with running balances across your books.",
          "features": [
            "Category transaction history",
            "Running balances",
            "Detailed ledger inquiry"
          ]
        },
        "chart-of-accounts": {
          "title": "Chart of Accounts",
          "shortDescription": "Create and organize accounting categories that classify transactions and power your financial statements and reports.",
          "description": "Create and organize the categories used to classify transactions and prepare reports.",
          "features": [
            "Income, expense, asset, liability, and equity categories",
            "Category hierarchy",
            "Shared classification across books"
          ]
        },
        "customers": {
          "title": "Customers",
          "shortDescription": "Maintain customer records used across sales, cash receipts, invoices, and related billing workflows in one place.",
          "description": "Manage the customer directory used across receipts, invoices, and related workflows.",
          "features": [
            "Customer directory",
            "Contact and billing details",
            "Reusable customer records"
          ]
        },
        "suppliers": {
          "title": "Suppliers",
          "shortDescription": "Maintain supplier records used across expenses, cash disbursements, bills, and related payable workflows in one place.",
          "description": "Manage the supplier directory used across expenses, bills, and related workflows.",
          "features": [
            "Supplier directory",
            "Contact and payment details",
            "Reusable supplier records"
          ]
        },
        "financial-statements": {
          "title": "Financial Statements",
          "shortDescription": "Run income statement, balance sheet, cash flow, changes in equity, and trial balance from your posted company books.",
          "description": "Review the core financial statements and trial balance generated from your posted books.",
          "features": [
            "Income Statement and Balance Sheet",
            "Cash Flow and Changes in Equity",
            "Trial Balance"
          ]
        },
        "ledger-reports": {
          "title": "Ledger & Journal Reports",
          "shortDescription": "Review General Ledger, General Journal, cash receipts, and cash disbursements reports for detailed transaction analysis.",
          "description": "Review ledger and journal report views for detailed transaction analysis.",
          "features": [
            "General Ledger",
            "General Journal",
            "Cash Receipts and Cash Disbursements reports"
          ]
        },
        "ppe": {
          "title": "PPE",
          "shortDescription": "Manage property, plant, and equipment records together with depreciation activity and a clear asset history trail.",
          "description": "Manage property, plant, and equipment records together with depreciation activity.",
          "features": [
            "Asset register",
            "Depreciation entries",
            "PPE activity history"
          ]
        },
        "capitals": {
          "title": "Capitals",
          "shortDescription": "Record owner capital contributions and withdrawals so equity movements stay clear and complete in your books.",
          "description": "Record and manage owner capital entries and their effect on company equity.",
          "features": [
            "Capital contributions",
            "Capital withdrawals",
            "Equity-linked entries"
          ]
        },
        "bills": {
          "title": "Bills",
          "shortDescription": "Manage supplier bills from entry through payment, including foreign-currency revaluations whenever your books need them.",
          "description": "Manage accounts payable from supplier bill entry through payment and foreign-currency revaluation.",
          "features": [
            "Supplier bills",
            "Bill payments",
            "Foreign-currency revaluations"
          ]
        },
        "reports": {
          "title": "Reports",
          "shortDescription": "Run financial statements and journal reports from one hub so your team can review performance and activity anytime.",
          "description": "Run balance sheet, income statement, trial balance, cash flow, and journal reports from one hub.",
          "features": [
            "Financial statement reports",
            "Journal and ledger exports",
            "Permission-scoped report access"
          ]
        },
        "pos": {
          "title": "POS System",
          "shortDescription": "Operate point of sale with inventory, registers, and BIR-oriented retail flows in a dedicated company workspace.",
          "description": "Operate retail POS with registers, inventory, purchase orders, transfers, and sales reporting in a dedicated workspace.",
          "features": [
            "Register sessions and sales",
            "Inventory and warehouse tools",
            "BIR-oriented POS reporting"
          ]
        },
        "shop": {
          "title": "Online Shop",
          "shortDescription": "Manage your online shop catalog, orders, and storefront settings for company-branded selling and fulfillment.",
          "description": "Manage your company online shop catalog, orders, and storefront settings.",
          "features": [
            "Product and order management",
            "Storefront configuration",
            "Company-branded online selling"
          ]
        },
        "instoreqr": {
          "title": "InStoreQR",
          "shortDescription": "QR-based channel ordering for dine-in restaurants with a kitchen display system.",
          "description": "Enable customers to scan a channel QR code, browse your menu, and place orders directly from their phone — no app or login required. Staff manage channels and monitor orders through a real-time Kitchen Display System.",
          "features": [
            "Channel registration with QR code generation",
            "Customer self-ordering via QR scan",
            "Menu categories powered by POS products",
            "Special instructions per order item",
            "Kitchen Display System with order status tracking",
            "KDS dark mode for kitchen environments"
          ]
        },
        "reserve": {
          "title": "Reserve",
          "shortDescription": "Let guests book venues and rooms online; staff confirm cash-on-site reservations from Abrafi.",
          "description": "Manage bookable places with slot calendars, pending bookings, confirm/cancel workflows, and a public booking page for customers who do not need an account.",
          "features": [
            "Multiple places with hours, prices, and bookable weekdays",
            "Public calendar booking without customer login",
            "Admin confirm, cancel, and reschedule",
            "Unavailable blocks with required notes",
            "Live availability updates"
          ]
        },
        "hris": {
          "title": "HRIS",
          "shortDescription": "Manage employees, attendance, leave, payroll runs, and HR reports in one people operations workspace for your team.",
          "description": "Manage people operations with employee records, attendance, leave, payroll runs, and HR reporting.",
          "features": [
            "Employee records",
            "Attendance and leave",
            "Payroll and HR reports"
          ]
        },
        "upload-entry": {
          "title": "Upload Entry",
          "shortDescription": "Upload receipts and documents to draft journal entries with assisted extraction and faster review before posting.",
          "description": "Upload receipts and documents to draft journal entries with assisted extraction and review.",
          "features": [
            "Receipt and document upload",
            "Draft journal review",
            "Faster transaction capture"
          ]
        },
        "activity-logs": {
          "title": "Activity Logs",
          "shortDescription": "Search a company-wide audit trail of user actions for accountability, troubleshooting, and day-to-day compliance checks.",
          "description": "Review a searchable timeline of user actions across your company for accountability and troubleshooting.",
          "features": [
            "Company-wide audit timeline",
            "Action categories and filters",
            "Links back to affected records"
          ]
        },
        "api-keys": {
          "title": "API Keys",
          "shortDescription": "Create and manage company API keys so integrations can access this company data with scoped permissions and audit history.",
          "description": "Create and manage company API keys so external tools can access this company's data with scoped permissions.",
          "features": [
            "Create and revoke company API keys",
            "Permission-scoped access for integrations",
            "Audit who created or revoked each key"
          ]
        }
      }
    },
    "fileManager": {
      "pageTitle": "File Manager",
      "pageSubtitle": "Store and organize company files in one shared place.",
      "newFolderButton": "New folder",
      "uploadButton": "Upload",
      "uploadQueueTitle": "{{count}} file(s) ready to upload",
      "uploadQueuedButton": "Upload files",
      "uploadingButton": "Uploading…",
      "clearQueueButton": "Clear",
      "duplicateNameTitle": "That file name already exists in this folder.",
      "duplicateNameGuide": "Please rename the file or upload it to a different folder.",
      "breadcrumbLabel": "Folder path",
      "homeFolder": "Home",
      "thisCompany": "This company",
      "loading": "Loading files…",
      "loadFailed": "Failed to load files.",
      "retryButton": "Try again",
      "emptyState": "This folder is empty. Drag files here, or use New to add a folder.",
      "noSearchResults": "No items match your search.",
      "folderType": "Folder",
      "fileFolderType": "File folder",
      "fileTypeGeneric": "{{ext}} File",
      "fileTypeUnknown": "File",
      "downloadButton": "Download",
      "moveButton": "Move",
      "deleteButton": "Delete",
      "cancelButton": "Cancel",
      "newFolderTitle": "New folder",
      "folderNameLabel": "Folder name",
      "createFolderButton": "Create folder",
      "moveTitle": "Move {{name}}",
      "moveHelp": "Enter a destination folder path. Leave this blank to move the item to Home.",
      "destinationFolderLabel": "Destination folder",
      "deleteTitle": "Delete item",
      "deleteFileConfirm": "Delete {{name}}? This cannot be undone.",
      "deleteFolderConfirm": "Delete folder {{name}} and everything inside it? This cannot be undone.",
      "deleteMultipleConfirm": "Delete {{count}} items? This cannot be undone.",
      "moveMultipleTitle": "Move {{count}} items",
      "fileTooLargeTitle": "That file is larger than 25 MB.",
      "fileTooLargeGuide": "Choose a file that is 25 MB or smaller, then try again.",
      "selectAllAria": "Select all items",
      "selectItemAria": "Select {{name}}",
      "selectIconAria": "Select {{name}} in icon view",
      "previewPaneAria": "Item details",
      "previewPaneMultipleAria": "Selected items details",
      "previewCloseAria": "Close details",
      "previewCloseMultipleAria": "Close selected items details",
      "listGhostNewRow": "+ New",
      "listGhostNewTile": "+ New",
      "listNewMenuFolder": "Folder",
      "listNewMenuUpload": "Upload files",
      "previewMultiple": "{{count}} items selected",
      "previewMultiple_one": "{{count}} item selected",
      "previewMultiple_other": "{{count}} items selected",
      "previewNotAvailable": "—",
      "previewTypeLabel": "Type",
      "previewSizeLabel": "Size",
      "previewMimeLabel": "Content type",
      "previewModifiedLabel": "Date modified",
      "previewLocationLabel": "Location",
      "previewLocationHome": "This company",
      "previewFolderLocationHome": "This company",
      "previewUploadedByLabel": "Uploaded by",
      "previewUploadedEmailLabel": "Uploader email",
      "previewFileType": "{{ext}} File",
      "previewFileTypeUnknown": "File",
      "previewFolderType": "File folder",
      "openInNewTab": "Open in new tab",
      "contextOpenInNewTab": "Open in new tab",
      "uploadFailed": "Failed to upload files.",
      "actionFailed": "That action could not be completed.",
      "shortcutActionFailed": "That action could not be completed.",
      "commandNew": "New",
      "commandFolders": "Folders",
      "commandDownload": "Download",
      "commandMove": "Move to",
      "commandDelete": "Delete",
      "commandRefresh": "Refresh",
      "navBack": "Back",
      "navForward": "Forward",
      "navUp": "Up",
      "viewDetails": "Details view",
      "viewIcons": "Large icons view",
      "searchPlaceholder": "Search {{folder}}",
      "searchAria": "Search this folder",
      "addressBarAria": "Address bar",
      "addressThisCompany": "This company",
      "searchRootFolderName": "This company",
      "navPaneAria": "Folder tree",
      "navPaneLabel": "Quick access",
      "treeThisCompany": "This company",
      "detailsPaneLabel": "Folder contents",
      "toggleThisCompanyAria": "Expand or collapse This company",
      "toggleFolderAria": "Expand or collapse {{name}}",
      "newMenuFolder": "Folder",
      "newMenuUpload": "Upload files",
      "contextNewFolder": "New folder",
      "contextUpload": "Upload files",
      "contextOpen": "Open",
      "contextDownload": "Download",
      "contextMove": "Move to",
      "contextDelete": "Delete",
      "dropOverlay": "Drop files to upload to this folder",
      "noSelectionToast": "Select a file or folder first.",
      "noFileSelectionToast": "Select a file to download.",
      "folderNameRequiredToast": "Enter a folder name.",
      "itemsCount": "{{count}} items",
      "itemsCount_one": "{{count}} item",
      "itemsCount_other": "{{count}} items",
      "selectedCount": "{{count}} items selected",
      "selectedCount_one": "{{count}} item selected",
      "selectedCount_other": "{{count}} items selected",
      "columns": {
        "name": "Name",
        "size": "Size",
        "type": "Type",
        "dateModified": "Date modified",
        "updated": "Added",
        "actions": "Actions"
      }
    },
    "events": {
      "status": {
        "draft": "Draft",
        "published": "Published",
        "completed": "Completed",
        "cancelled": "Cancelled"
      },
      "list": {
        "pageTitle": "Events",
        "createButton": "Create event",
        "importButton": "Import from Google Form",
        "refreshButton": "Refresh events",
        "loading": "Loading events…",
        "loadFailed": "Failed to load events.",
        "retryButton": "Try again",
        "emptyState": "No events yet. Create your first event to start collecting registrations.",
        "openEventAria": "Open event {{title}}",
        "dateTba": "TBA",
        "dateUnavailable": "—",
        "columns": {
          "title": "Event",
          "date": "Date",
          "venue": "Venue",
          "status": "Status",
          "registrations": "Registrations",
          "checkedIn": "Checked in"
        }
      },
      "create": {
        "pageTitle": "Create event"
      },
      "edit": {
        "pageTitle": "Edit event",
        "backToDetailsButton": "Back"
      },
      "form": {
        "backToListButton": "Back",
        "titleLabel": "Event title",
        "titlePlaceholder": "e.g. Annual company town hall",
        "dateLabel": "Event date",
        "scheduleStatusLabel": "Schedule",
        "scheduleStatusScheduled": "Date scheduled",
        "scheduleStatusTba": "Date to be announced (TBA)",
        "scheduleStatusTbaHint": "You can add the date later. Existing registrations will remain linked to this event.",
        "statusLabel": "Status",
        "startTimeLabel": "Start time",
        "endTimeLabel": "End time",
        "venueLabel": "Venue / location",
        "venuePlaceholder": "e.g. Main auditorium, 123 Example Street",
        "bannerLabel": "Event banner image",
        "bannerHint": "Optional image shown on the public registration page. JPG, PNG, or WebP recommended.",
        "customFieldsLabel": "Additional registration fields",
        "customFieldPlaceholder": "Field label (e.g. Company Name)",
        "customFieldDescriptionPlaceholder": "Optional help text shown under the label",
        "registrationDescriptionLabel": "Registration form introduction",
        "registrationDescriptionPlaceholder": "Intro text shown above the registration form (supports multiple paragraphs).",
        "defaultRegistrationFieldsLabel": "Built-in registration fields",
        "defaultRegistrationFieldsHint": "These fields are always included on the public registration form. Do not add them again as custom fields.",
        "defaultRegistrationFieldAlwaysRequired": "Always required",
        "defaultRegistrationFieldRequired": "Required",
        "defaultRegistrationFieldOptional": "Optional",
        "registrationRequirementsLabel": "Built-in field requirements",
        "requireRegistrationEmailLabel": "Require email address",
        "requireRegistrationContactLabel": "Require contact number",
        "customFieldTypeText": "Short text",
        "customFieldTypeTextarea": "Long text",
        "customFieldTypeSingleChoice": "Single choice",
        "customFieldTypeSection": "Section heading",
        "sectionTitlePlaceholder": "Section title (e.g. Personal Information)",
        "singleChoiceOptionsLabel": "Choices",
        "singleChoiceOptionPlaceholder": "Choice label",
        "addSingleChoiceOptionButton": "Add choice",
        "allowOtherChoiceLabel": "Allow \"Other\" with free text",
        "addSectionButton": "Add section",
        "singleChoiceOptionsRequiredToast": "{{label}} needs at least one choice or an Other option.",
        "requiredLabel": "Required",
        "removeFieldButton": "Remove",
        "addCustomFieldButton": "Add field",
        "surveyEnabledLabel": "Send post-event survey to checked-in attendees",
        "surveyQuestionsLabel": "Survey questions",
        "surveyQuestionPlaceholder": "Question label",
        "defaultSurveyRatingLabel": "Overall rating",
        "defaultSurveyFeedbackLabel": "Comments or suggestions",
        "surveyFieldTypeText": "Short text",
        "surveyFieldTypeTextarea": "Long text",
        "surveyFieldTypeRating": "Rating (1–5)",
        "addSurveyQuestionButton": "Add question",
        "reminderHoursLabel": "Send reminder email (hours before event)",
        "reminderHoursPlaceholder": "24",
        "fieldLengthHint": "{{count}} / {{max}} characters",
        "saveButton": "Save event",
        "updateButton": "Update event",
        "savingButton": "Saving…",
        "titleRequiredToast": "Event title is required.",
        "dateRequiredToast": "Event date is required.",
        "createdToast": "Event created.",
        "updatedToast": "Event updated.",
        "saveFailedToast": "Failed to save event."
      },
      "import": {
        "googleFormModalTitle": "Import from Google Form",
        "googleFormModalDescription": "Paste a public Google Form link. We will open the create event page with title, schedule, registration intro, and custom fields pre-filled. Nothing is saved until you click Save event.",
        "googleFormUrlLabel": "Google Form link",
        "googleFormUrlPlaceholder": "https://docs.google.com/forms/d/e/…/viewform",
        "googleFormCancelButton": "Cancel",
        "googleFormContinueButton": "Continue to create event",
        "googleFormLoadingButton": "Reading form…",
        "googleFormUrlRequiredToast": "Paste a Google Form link first.",
        "googleFormFailedToast": "Could not import that Google Form.",
        "googleFormPrefilledToast": "Imported \"{{title}}\" — review the form and save when ready.",
        "googleFormWarningsTitle": "Imported with notes"
      },
      "details": {
        "loading": "Loading event…",
        "loadFailed": "Failed to load event.",
        "retryButton": "Try again",
        "refreshButton": "Refresh",
        "editButton": "Edit event",
        "publishButton": "Publish",
        "unpublishButton": "Unpublish",
        "statusUpdatedToast": "Event status updated.",
        "actionFailedToast": "Action failed. Try again.",
        "bannerUploadLabel": "Event banner image",
        "bannerUploadedToast": "Banner uploaded.",
        "dateTba": "TBA",
        "dateUnavailable": "—",
        "scheduleTbaHint": "To be announced",
        "tabs": {
          "overview": "Overview",
          "channels": "Links & QR",
          "scanner": "Scanner",
          "registrations": "Registrations",
          "analytics": "Analytics"
        },
        "overviewTitle": "Event details",
        "channelsTitle": "Registration links & QR codes",
        "channelsDescription": "Create a unique link and QR code for each promotion channel. Share the link or print the QR so attendees can register.",
        "channelsEmptyState": "No registration links yet. Generate one above to share with attendees.",
        "channelLabelPlaceholder": "Channel label (e.g. facebook, tarpaulin)",
        "generateChannelButton": "Generate link & QR",
        "refreshChannelsButton": "Refresh counts",
        "channelsRefreshing": "Refreshing…",
        "channelRegistrationCount": "{{count}} registrations from this channel",
        "channelLinkHeading": "Shareable link",
        "channelQrHeading": "QR code",
        "linkClickCount": "{{count}} link clicks",
        "qrScanCount": "{{count}} QR scans",
        "channelStats": "{{clicks}} clicks · {{scans}} scans · {{registrations}} registrations",
        "copyLinkButton": "Copy",
        "copyLinkAriaLabel": "Copy link",
        "openLinkButton": "Open link",
        "openLinkAriaLabel": "Open link in new tab",
        "downloadQrButton": "Download QR",
        "copiedToast": "Copied to clipboard.",
        "copyFailedToast": "Could not copy.",
        "channelCreatedToast": "Registration link created.",
        "scannerTitle": "Check-in scanner links",
        "scannerDescription": "Share the scanner link and password with event staff. Volunteers can scan the QR code on their phone to open the check-in page — no account login required.",
        "scannersEmptyState": "No scanner links yet. Generate one above for volunteer check-in.",
        "scannerPasswordPlaceholder": "Scanner password",
        "scannerLabelPlaceholder": "Optional label (e.g. Main entrance)",
        "generateScannerButton": "Generate scanner link",
        "scannerPasswordRequiredToast": "Scanner password is required.",
        "scannerCreatedToast": "Scanner link created.",
        "scannerDefaultLabel": "Scanner",
        "scannerLinkHeading": "Scanner link",
        "scannerQrHeading": "Scanner QR code",
        "scannerQrHint": "Volunteers can scan this QR on their phone to open the check-in page.",
        "disableLinkButton": "Disable",
        "restoreLinkButton": "Restore",
        "disabledChannelsTitle": "Disabled links & QR codes",
        "disabledScannersTitle": "Disabled scanners",
        "channelDisabledToast": "Registration link disabled.",
        "channelRestoredToast": "Registration link restored.",
        "scannerDisabledToast": "Scanner disabled.",
        "scannerRestoredToast": "Scanner restored.",
        "registrationsTitle": "Registrations & walk-ins",
        "walkInFormTitle": "Add walk-in check-in",
        "importRegistrationsTitle": "Import registrations",
        "importRegistrationsButton": "Import registrations",
        "importRegistrationsTab": "Import CSV",
        "importedRegistrationLabel": "Imported",
        "importWalkInsTitle": "Import walk-ins from CSV",
        "importWalkInsButton": "Import walk-ins (CSV)",
        "importWalkInsDescription": "Use this after the event to encode paper attendance sheets or Google Sheets. Each row is saved as a checked-in walk-in, the same as adding them one by one on event day.",
        "importWalkInsDropZoneTitle": "Upload walk-ins CSV",
        "importWalkInsSubmitButton": "Import {{count}} walk-ins",
        "importWalkInsSuccessToast": "Imported {{count}} walk-ins.",
        "importWalkInsPartialSuccessToast": "Imported {{imported}} walk-ins. {{failed}} rows failed.",
        "walkInTabSingle": "Single check-in",
        "walkInImportDescription": "Bring over registrations from Google Forms or another spreadsheet. Imported attendees are saved as registered (not walk-ins and not checked in). Review the preview before importing.",
        "walkInImportSampleTableTitle": "Example CSV layout",
        "walkInImportRequiredLabel": "(required)",
        "walkInImportOptionalLabel": "(optional)",
        "walkInImportHeaderHint": "The sample uses these columns: {{headers}}. Your own column names are supported—map them after uploading.",
        "walkInImportSampleButton": "Download sample CSV",
        "walkInImportDropZoneTitle": "Upload registrations CSV",
        "walkInImportDropZoneText": "Drag and drop your file here, or",
        "walkInImportDropZoneBrowse": "choose a file",
        "walkInImportDropZoneHint": "Accepts .csv files only",
        "walkInImportDropZoneAriaLabel": "Upload CSV file by drag and drop or browse",
        "walkInImportReplaceFileButton": "Choose a different file",
        "walkInImportRemoveFileButton": "Remove selected file",
        "walkInImportFileReadySummary": "{{valid}} valid rows · {{invalid}} with errors",
        "walkInImportInvalidFileTypeToast": "Please choose a .csv file.",
        "walkInImportPreviewSummary": "{{valid}} valid rows · {{invalid}} rows with errors",
        "walkInImportColumnRow": "Row",
        "walkInImportColumnStatus": "Status",
        "walkInImportRowValid": "Ready",
        "walkInImportRowImported": "Imported",
        "walkInImportRowFailed": "Failed",
        "walkInImportResultsButton": "Download import results",
        "walkInImportDoneButton": "Done",
        "walkInImportSubmitButton": "Import {{count}} registrations",
        "walkInImportingButton": "Importing…",
        "walkInImportSuccessToast": "Imported {{count}} registrations.",
        "walkInImportPartialSuccessToast": "Imported {{imported}} registrations. {{failed}} rows failed.",
        "walkInImportAtomicFailureToast": "Nothing was imported because {{failed}} row(s) have errors. Fix all rows and try again.",
        "walkInImportEmptyFileToast": "The CSV file is empty.",
        "walkInImportNoDataRowsToast": "The CSV file has headers but no data rows.",
        "walkInImportMissingHeadersToast": "Missing required column headers: {{headers}}",
        "walkInImportDuplicateHeadersToast": "The CSV has duplicate column headers.",
        "walkInImportReadFailedToast": "Could not read the CSV file.",
        "walkInImportSelectValidFileToast": "Choose a valid CSV file with the required headers first.",
        "walkInImportMappingTitle": "Map your columns",
        "walkInImportMappingDescription": "Choose which CSV column contains each event field. Required fields must be mapped before importing.",
        "walkInImportMappingSkipOption": "Do not import this field",
        "walkInImportMissingMappingsNotice": "Map these required fields: {{fields}}",
        "walkInImportDuplicateMappingsNotice": "Each CSV column can be mapped to only one event field.",
        "walkInImportCompleteMappingToast": "Map each required event field before importing.",
        "walkInImportAiSuggestionsButton": "Improve suggestions with AI",
        "walkInImportAiSuggestionsLoadingButton": "Getting AI suggestions…",
        "walkInImportAiSuggestionsAppliedNotice": "AI added {{count}} mapping suggestions. Review them before importing.",
        "walkInImportAiNoSuggestionsNotice": "AI did not find any additional reliable mappings. You can map the remaining fields manually.",
        "walkInImportAiUnavailableNotice": "AI suggestions are unavailable right now. Your initial suggestions are still available—continue mapping manually.",
        "walkInImportNoValidRowsToast": "Fix row errors in the preview before importing.",
        "walkInImportRowNameRequired": "Row {{row}}: name is required.",
        "walkInImportRowEmailRequired": "Row {{row}}: email is required.",
        "walkInImportRowContactRequired": "Row {{row}}: contact number is required.",
        "walkInImportRowFieldRequired": "Row {{row}}: {{label}} is required.",
        "addWalkInButton": "Add walk-in check-in",
        "addingWalkInButton": "Checking in…",
        "walkInNameRequiredToast": "Name is required.",
        "walkInCustomFieldRequiredToast": "{{label}} is required.",
        "walkInCreatedToast": "Walk-in checked in.",
        "walkInLabel": "Walk-in",
        "duplicateRegistrationBadge": "Duplicate · {{count}} in group",
        "archiveSelectedButton": "Archive selected",
        "archiveButton": "Archive",
        "resendTicketButton": "Resend ticket",
        "resendingTicketButton": "Sending…",
        "resendTicketSendingToast": "Sending ticket email…",
        "resendTicketSuccessToast": "Ticket sent to {{email}}.",
        "resendTicketFailedToast": "Could not resend the ticket email.",
        "resendTicketMissingEmailToast": "This registrant does not have an email address.",
        "resendTicketInvalidEmailToast": "This registrant does not have a valid email address.",
        "archiveRegistrationsTitle": "Archive registrations?",
        "archiveRegistrationsMessage": "Archive {{count}} selected registration(s)? They will be removed from the active registrations list.",
        "archiveConfirmButton": "Archive registrations",
        "archivingButton": "Archiving…",
        "registrationArchiveSuccessToast": "Archived {{count}} registration(s).",
        "registrationArchiveFailedToast": "Could not archive the selected registration(s).",
        "registrationArchiveNoSelectionToast": "Select at least one registration to archive.",
        "registrationRestoreFailedToast": "Could not restore the selected registration(s).",
        "registrationRestoreNoSelectionToast": "Select at least one registration to restore.",
        "registrationRestoreSuccessToast": "Restored {{count}} registration(s).",
        "restoreSelectedButton": "Restore selected",
        "restoreButton": "Restore",
        "restoreRegistrationsTitle": "Restore registrations?",
        "restoreRegistrationsMessage": "Restore {{count}} selected registration(s)? They will return to the active registrations list and analytics.",
        "restoreConfirmButton": "Restore registrations",
        "restoringButton": "Restoring…",
        "registrationViewLabel": "Registration view",
        "activeRegistrationsOption": "Active registrations",
        "archivedRegistrationsOption": "Archived registrations",
        "regColumns": {
          "name": "Name",
          "contact": "Contact",
          "channel": "Channel",
          "status": "Status",
          "checkedIn": "Checked in",
          "actions": "Actions"
        },
        "emailBlast": {
          "button": "Email blast",
          "title": "Email registrants",
          "description": "Compose an email for {{count}} selected registrant(s). Each recipient will receive a separate email.",
          "senderNameLabel": "Sender display name",
          "subjectLabel": "Subject",
          "subjectPlaceholder": "Event update",
          "bodyLabel": "Message",
          "bodyPlaceholder": "Write your message to registrants…",
          "cancelButton": "Cancel",
          "sendButton": "Send email blast",
          "sendingButton": "Sending…",
          "searchLabel": "Search registrants",
          "searchPlaceholder": "Search by name, email, or contact number",
          "sourceFilterLabel": "Registration source",
          "allSources": "All sources",
          "registeredSource": "Registered",
          "walkInSource": "Walk-in",
          "checkInFilterLabel": "Check-in status",
          "allCheckInStatuses": "All check-in statuses",
          "checkedInFilter": "Checked in",
          "notCheckedInFilter": "Not checked in",
          "withEmailOnly": "With email only",
          "selectAllFiltered": "Select all filtered",
          "selectedCount": "{{count}} selected",
          "clearSelection": "Clear selection",
          "selectColumn": "Select",
          "emailColumn": "Email",
          "selectRegistrant": "Select {{name}}",
          "noFilteredResults": "No registrants match these filters.",
          "noRecipientsToast": "Select at least one registrant with an email address.",
          "senderNameRequiredToast": "Sender display name is required.",
          "subjectRequiredToast": "Email subject is required.",
          "bodyRequiredToast": "Email message is required.",
          "failedToast": "Could not send the email blast.",
          "successToast": "Email blast sent to {{count}} registrant(s).",
          "partialSuccessToast": "Sent {{sent}} email(s); {{failed}} failed."
        },
        "analyticsTitle": "Campaign analytics"
      },
      "exports": {
        "sectionTitle": "Export reports",
        "sectionDescription": "Choose a report to preview its data on this page, then export as CSV, Excel, or PDF.",
        "selectReportLabel": "Choose a report",
        "selectReportPrompt": "Select a report above to preview its data.",
        "previewRowCount": "{{count}} rows",
        "previewEmpty": "No data for this report yet.",
        "exportingButton": "Exporting…",
        "successToast": "Report downloaded.",
        "failedToast": "Could not export report.",
        "format": {
          "csv": "CSV",
          "excel": "Excel",
          "pdf": "PDF"
        },
        "reports": {
          "registrations": {
            "title": "Registrations",
            "description": "All registrations including walk-ins, channels, and custom field answers."
          },
          "attendees": {
            "title": "Actual attendees",
            "description": "Checked-in attendees only, with check-in time and staff name."
          },
          "channelConversion": {
            "title": "Channel conversion",
            "description": "Link clicks, QR scans, registrations, and conversion rate per channel."
          },
          "surveyResponses": {
            "title": "Survey responses",
            "description": "Post-event survey answers from checked-in attendees."
          }
        }
      },
      "analytics": {
        "clicks": "Link clicks",
        "scans": "QR scans",
        "registrations": "Registrations",
        "ticketDownloads": "Ticket downloads",
        "checkedIn": "Checked in",
        "walkIns": "Walk-ins",
        "surveyResponses": "Survey responses",
        "channel": "Channel",
        "conversion": "Conversion"
      },
      "public": {
        "loading": "Loading…",
        "loadFailed": "Registration page not found.",
        "nameLabel": "Full name",
        "namePlaceholder": "Jane Doe",
        "emailLabel": "Email address",
        "emailPlaceholder": "jane@example.test",
        "contactLabel": "Contact number",
        "contactPlaceholder": "09170000000",
        "customFieldPlaceholder": "Your answer",
        "otherChoiceLabel": "Other",
        "otherChoicePlaceholder": "Please specify",
        "otherChoiceAriaLabel": "Other answer for {{label}}",
        "otherChoiceRequiredToast": "Please specify your answer for {{label}}.",
        "customFieldRequiredToast": "{{label}} is required.",
        "emailRequiredToast": "Email is required.",
        "contactRequiredToast": "Contact number is required.",
        "registerButton": "Register",
        "submittingButton": "Submitting…",
        "nameRequiredToast": "Name is required.",
        "registerFailedToast": "Registration failed. Try again.",
        "ticketTitle": "Your digital ticket",
        "scheduleTba": "Schedule: To be announced",
        "dateUnavailable": "—",
        "ticketDateUnavailable": "—",
        "ticketScheduleTba": "Schedule: To be announced",
        "ticketSaveReminder": "Save this ticket before event day — take a screenshot of the QR code, bookmark this page, or download the image. You will need it at the entrance, even without internet.",
        "ticketHint": "Show this QR code at the event entrance."
      },
      "scanner": {
        "title": "Event check-in",
        "authDescription": "Enter the scanner password provided by the organizer.",
        "passwordPlaceholder": "Scanner password",
        "unlockButton": "Unlock scanner",
        "authenticatingButton": "Unlocking…",
        "passwordRequiredToast": "Password is required.",
        "authFailedToast": "Invalid password.",
        "scanDescription": "Scan attendee ticket QR codes or enter a ticket token manually.",
        "startCameraButton": "Start camera",
        "stopCameraButton": "Stop camera",
        "cameraUnsupportedToast": "Camera QR scanning is not supported in this browser. Use manual entry.",
        "cameraPermissionToast": "Camera access was denied.",
        "manualTokenLabel": "Ticket token or QR URL",
        "manualTokenPlaceholder": "Paste ticket token or scan URL",
        "manualCheckInButton": "Check in",
        "invalidTicketToast": "Invalid ticket.",
        "checkInSuccessToast": "{{name}} checked in.",
        "alreadyCheckedInToast": "{{name}} was already checked in.",
        "checkInFailedToast": "Check-in failed.",
        "lastResultSuccess": "{{name}} checked in successfully.",
        "lastResultAlready": "{{name}} was already checked in."
      },
      "survey": {
        "title": "Event feedback",
        "ratingLabel": "Overall rating",
        "feedbackLabel": "Comments",
        "answerPlaceholder": "Your answer",
        "feedbackPlaceholder": "Share your comments or suggestions…",
        "questionRequiredToast": "{{label}} is required.",
        "submitButton": "Submit feedback",
        "submittingButton": "Submitting…",
        "submittedToast": "Thank you for your feedback.",
        "submitFailedToast": "Could not submit survey.",
        "thankYouMessage": "Thank you for your feedback!"
      }
    },
    "equipment": {
      "helpLink": {
        "ariaLabel": "Open PPE guide"
      },
      "EquipmentList": {
        "title": "Property, Plant and Equipment (PPE)",
        "summaryHint": "Track property, plant, and equipment (PPE), book value, and straight-line depreciation.",
        "searchPlaceholder": "Search by book ref. or asset name…",
        "tagsFilterLabel": "Tags",
        "tagsCatalogLoadFailed": "Failed to load PPE tags.",
        "tagsCatalogRetry": "Try again",
        "manageTags": "Manage tags",
        "noSearchResults": "No PPE matches your search.",
        "includeCancelled": "Include voided",
        "depreciationReport": "Depreciation report",
        "exportCsv": "Export CSV",
        "addEquipment": "Add PPE",
        "loading": "Loading PPE…",
        "tryAgain": "Try again",
        "empty": "No PPE recorded yet.",
        "status": {
          "active": "Active",
          "cancelled": "Voided"
        },
        "table": {
          "bookReferenceNumber": "Book ref. #",
          "name": "Asset",
          "status": "Status",
          "initialAmount": "Initial amount",
          "accumulatedDepreciation": "Accumulated depreciation",
          "bookValue": "Book value",
          "acquisitionDate": "Acquisition date",
          "actions": "Actions"
        },
        "viewDetailsTitle": "View details",
        "viewEquipmentAria": "View details for {{name}}",
        "editEquipmentTitle": "Edit PPE",
        "editEquipmentAria": "Edit {{name}}",
        "editTagsTitle": "Edit tags",
        "editTagsAria": "Edit tags for {{name}}",
        "editCancelledTitle": "Voided PPE cannot be edited.",
        "editDepreciationRecordedTitle": "Accounting fields are locked after depreciation. You can still edit tags.",
        "cancelEquipmentTitle": "Void PPE",
        "cancelEquipmentAria": "Void {{name}}",
        "cancelCancelledTitle": "This PPE is already voided.",
        "cancelDepreciationRecordedTitle": "PPE with recorded depreciation cannot be voided.",
        "cancelLinkedCapitalTitle": "This asset is linked to a capital entry. Void it from Capitals instead.",
        "cancelDepreciationTitle": "Remove depreciation",
        "cancelDepreciationAria": "Remove depreciation for {{name}}",
        "cancelDepreciationModalTitle": "Remove depreciation",
        "cancelDepreciationModalBody": "Remove the {{date}} depreciation entry for \"{{name}}\"? This reverses the most recently recorded entry and posts a cancelling journal entry.",
        "cancelDepreciationModalDismiss": "Keep depreciation",
        "cancelDepreciationModalConfirm": "Remove depreciation",
        "removingDepreciation": "Removing…",
        "csv": {
          "bookReferenceNumber": "Book ref. #",
          "name": "Asset name",
          "status": "Status",
          "initialAmount": "Initial amount",
          "accumulatedDepreciation": "Accumulated depreciation",
          "bookValue": "Book value",
          "acquisitionDate": "Acquisition date",
          "usefulLifeYears": "Useful life (years)",
          "salvageValue": "Salvage value"
        }
      },
      "AddEquipmentModal": {
        "title": "Add PPE",
        "nameLabel": "Asset name / description",
        "namePlaceholder": "e.g. Delivery van",
        "nameRequired": "Asset name is required.",
        "initialAmountLabel": "Initial amount (purchase cost)",
        "initialAmountInvalid": "Enter a valid positive initial amount.",
        "usefulLifeLabel": "Useful life (years)",
        "usefulLifeInvalid": "Useful life must be at least 1 year.",
        "salvageValueLabel": "Salvage / scrap value",
        "salvageValueInvalid": "Enter a valid salvage value.",
        "salvageMustBeLessThanInitial": "Salvage value must be less than the initial amount.",
        "acquisitionDateLabel": "Acquisition date",
        "acquisitionDateRequired": "Acquisition date is required.",
        "equipmentCategoryLabel": "Equipment account",
        "equipmentCategoryRequired": "Select an equipment account.",
        "sourceCategoryLabel": "Source account (credit)",
        "sourceCategoryRequired": "Select a source account.",
        "sourceMustDifferFromPpeAccount": "Source account must be different from the PPE account (for example Cash or Owner's Capital).",
        "sourceCategoryHint": "Cash, bank, cash equivalents (Treat as cash), owner's equity, or other funding source credited on acquisition.",
        "tagsLabel": "Tags",
        "tagsHelper": "Optional labels to organize and filter PPE.",
        "tagsCatalogLoadFailed": "Failed to load PPE tags.",
        "tagsCatalogRetry": "Try again",
        "useForeignCurrency": "Use foreign currency",
        "fxAmountInvalid": "Enter a valid foreign amount and exchange rate.",
        "initialAmountPhpLabel": "Initial amount (PHP)",
        "cancel": "Cancel",
        "save": "Save PPE",
        "saving": "Saving…"
      },
      "EquipmentCreate": {
        "backToList": "Back",
        "title": "New PPE",
        "subtitle": "Record a fixed asset and its acquisition journal entry.",
        "loading": "Loading…"
      },
      "EquipmentDetails": {
        "backToList": "Back",
        "viewTitle": "PPE details",
        "bookReferenceNumber": "Book reference",
        "editEquipment": "Edit",
        "editTags": "Edit tags",
        "initialAmountSummary": "Initial {{initial}} · Accumulated depreciation {{accumulated}}",
        "loading": "Loading PPE…",
        "tryAgain": "Try again",
        "notFound": "PPE not found.",
        "recordDepreciation": "Record depreciation",
        "cancelEquipment": "Void PPE",
        "initialAmount": "Initial amount",
        "foreignCurrencySection": "Foreign currency",
        "usefulLife": "Useful life (years)",
        "salvageValue": "Salvage value",
        "annualDepreciation": "Annual depreciation (straight-line)",
        "accumulatedDepreciation": "Accumulated depreciation",
        "bookValue": "Book value",
        "status": "Status",
        "acquisitionDate": "Acquisition date",
        "equipmentCategory": "Equipment account",
        "sourceCategory": "Source account",
        "tagsLabel": "Tags",
        "acquisitionTransaction": "Acquisition journal entry",
        "viewTransaction": "View transaction",
        "viewVoidedTransaction": "View voided transaction",
        "linkedCapitalBannerPrefix": "This asset is linked to a capital entry.",
        "linkedCapitalBannerLink": "Open Capitals",
        "linkedCapitalBannerSuffix": "to void or replace the contribution.",
        "pendingDepreciationTitle": "Pending depreciation",
        "pendingDepreciationBody": "Suggested for {{date}}: {{amount}}. You can record depreciation on any date while book value remains above salvage.",
        "depreciationHistoryTitle": "Depreciation history",
        "noDepreciation": "No depreciation recorded yet.",
        "depreciationSortByLabel": "Sort by",
        "depreciationSortFiscalYear": "Fiscal year",
        "depreciationSortCreatedAt": "Date recorded",
        "cancelDepreciation": "Cancel",
        "activityLogTitle": "Activity log",
        "activityMeta": "{{when}} · {{action}} · {{performedBy}}",
        "noActivity": "No activity recorded yet.",
        "cancelModalTitle": "Void PPE",
        "cancelModalBody": "Void \"{{name}}\"? This reverses recorded depreciation (when present) and posts a reversing acquisition journal entry.",
        "cancelModalDismiss": "Keep PPE",
        "cancelModalConfirm": "Void PPE",
        "cancelling": "Cancelling…",
        "salvageValueInvalid": "Enter a valid salvage value.",
        "salvageMustBeLessThanInitial": "Salvage value must be less than the initial amount.",
        "usefulLifeInvalid": "Useful life must be at least 1 year.",
        "depreciationTransactionLink": "Depreciation {{date}}",
        "table": {
          "bookReferenceNumber": "Book ref. #",
          "date": "Date",
          "year": "Year",
          "amount": "Amount",
          "status": "Status",
          "recordedAt": "Date recorded",
          "recordedBy": "Recorded by",
          "journal": "Journal",
          "when": "When",
          "action": "Action",
          "summary": "Summary",
          "performedBy": "Performed by"
        },
        "cancelDepreciationModalTitle": "CancelDepreciationModalTitle",
        "cancelDepreciationModalBody": "CancelDepreciationModalBody",
        "cancelDepreciationModalDismiss": "CancelDepreciationModalDismiss",
        "removingDepreciation": "RemovingDepreciation",
        "cancelDepreciationModalConfirm": "CancelDepreciationModalConfirm"
      },
      "AlreadyRecordedDepreciationModal": {
        "title": "Depreciation already recorded",
        "body": "Depreciation already recorded for this year ({{year}}) for {{name}}.",
        "transactionFallback": "Depreciation FY {{year}}",
        "dismiss": "OK"
      },
      "EquipmentEdit": {
        "title": "Edit PPE",
        "subtitle": "Update asset name, useful life, and salvage value.",
        "subtitleTagsOnly": "Accounting fields are locked after depreciation. You can still update tags.",
        "backToList": "Back",
        "backToDetails": "Back",
        "loading": "Loading PPE…",
        "tryAgain": "Try again",
        "notFound": "PPE not found.",
        "notEditable": "This PPE cannot be edited because it was voided.",
        "saveTags": "Save tags",
        "nameLabel": "Asset name / description",
        "initialAmountLabel": "Initial amount",
        "initialAmountLocked": "Initial amount cannot be changed after creation.",
        "usefulLifeLabel": "Useful life (years)",
        "salvageValueLabel": "Salvage / scrap value",
        "tagsLabel": "Tags",
        "tagsHelper": "Optional labels to organize and filter PPE.",
        "tagsCatalogLoadFailed": "Failed to load PPE tags.",
        "tagsCatalogRetry": "Try again",
        "save": "Save changes",
        "saving": "Saving…",
        "cancel": "Cancel",
        "salvageValueInvalid": "Enter a valid salvage value.",
        "salvageMustBeLessThanInitial": "Salvage value must be less than the initial amount.",
        "usefulLifeInvalid": "Useful life must be at least 1 year.",
        "attachmentsTitle": "Attachments",
        "attachmentsHint": "Receipts and documents linked to the acquisition journal entry.",
        "attachmentsUnavailable": "Attachments cannot be updated because this PPE asset has no acquisition journal entry.",
        "noChangesToSave": "No changes to save."
      },
      "ManageTagsModal": {
        "title": "Manage PPE tags",
        "helper": "Rename tags or delete unused ones. Tags still assigned to PPE must be removed from those assets first.",
        "empty": "No PPE tags yet. Create tags when adding or editing PPE.",
        "rename": "Rename",
        "delete": "Delete",
        "saveRename": "Save",
        "cancelRename": "Cancel",
        "close": "Close",
        "nameRequired": "Tag name is required.",
        "renameAria": "Rename tag {{name}}",
        "deleteAria": "Delete tag {{name}}",
        "renameInputAria": "New name for tag {{name}}",
        "deleteConfirmTitle": "Delete tag?",
        "deleteConfirmBody": "Delete unused tag \"{{name}}\" from the company catalog? This cannot be undone.",
        "deleteConfirm": "Delete tag"
      },
      "RecordDepreciationModal": {
        "title": "Record depreciation",
        "body": "Post depreciation for {{name}} to the ledger.",
        "dateLabel": "Depreciation date",
        "dateInvalid": "Enter a valid depreciation date.",
        "dateInFuture": "Depreciation date cannot be in the future.",
        "amountLabel": "Depreciation amount",
        "amountInvalid": "Enter a valid depreciation amount.",
        "amountHint": "Suggested straight-line amount: {{suggested}}",
        "descriptionLabel": "Description",
        "descriptionRequired": "Enter a description before recording depreciation.",
        "categoryLabel": "Depreciation expense category",
        "categoryPlaceholder": "Select a depreciation expense category",
        "categoryRequired": "Select a depreciation expense category before recording.",
        "accumulatedCategoryLabel": "Accumulated depreciation category",
        "accumulatedCategoryPlaceholder": "Select an accumulated depreciation category",
        "accumulatedCategoryRequired": "Select an accumulated depreciation category before recording.",
        "addNewCategoryLink": "+ Add new depreciation expense category",
        "addNewAccumulatedCategoryLink": "+ Add new accumulated depreciation category",
        "newCategoryTitle": "New depreciation expense category",
        "newAccumulatedCategoryTitle": "New accumulated depreciation category",
        "cancelCreationLink": "Cancel creation",
        "categoryNameLabel": "Category Name",
        "categoryNameRequired": "Enter a category name.",
        "parentCategoryLabel": "Parent Category",
        "parentCategoryPlaceholder": "Select parent category",
        "parentRequired": "Select a parent category.",
        "accountNumberOptionalLabel": "Account Number (Optional)",
        "createCategory": "Create Category",
        "creatingCategory": "Creating…",
        "finishCategoryCreateFirst": "Finish or cancel creating the new category first.",
        "lockedCashParentBlocked": "Cannot use Cash as a parent category. Add cash subaccounts under Cash and Cash Equivalents instead.",
        "companyRequired": "Company ID is required. Please ensure you are part of a company.",
        "cancel": "Cancel",
        "confirm": "Record depreciation",
        "saving": "Recording…"
      },
      "EquipmentDepreciationReport": {
        "title": "PPE depreciation report",
        "subtitle": "Recorded depreciation entries across all PPE.",
        "backToList": "Back",
        "includeCancelled": "Include voided entries",
        "depreciationSortByLabel": "Sort by",
        "depreciationSortFiscalYear": "Fiscal year",
        "depreciationSortCreatedAt": "Date recorded",
        "exportCsv": "Export CSV",
        "loading": "Loading depreciation report…",
        "tryAgain": "Try again",
        "empty": "No depreciation entries recorded yet.",
        "table": {
          "bookReferenceNumber": "Book ref. #",
          "equipment": "PPE",
          "year": "Fiscal year",
          "amount": "Amount",
          "status": "Status",
          "recordedBy": "Recorded by",
          "recordedAt": "Recorded at"
        },
        "csv": {
          "bookReferenceNumber": "Book ref. #",
          "equipment": "PPE",
          "year": "Fiscal year",
          "amount": "Amount",
          "status": "Status",
          "recordedBy": "Recorded by",
          "recordedAt": "Recorded at"
        }
      },
      "EquipmentDepreciationView": {
        "title": "Depreciation entry",
        "loading": "Loading depreciation entry…",
        "loadFailed": "Failed to load depreciation entry.",
        "tryAgain": "Try again",
        "notFound": "Depreciation entry not found.",
        "back": "Back",
        "backToEquipment": "Back",
        "amountLabel": "Depreciation amount",
        "equipmentLabel": "PPE asset",
        "cancelledAt": "Cancelled at",
        "cancelledBy": "Cancelled by",
        "viewTransaction": "View journal entry",
        "viewCancellationTransaction": "View cancellation journal entry",
        "cancelDepreciation": "Remove depreciation"
      }
    },
    "cashVoucher": {
      "create": {
        "title": "New Cash Voucher",
        "subtitle": "Record a cash expense without an official receipt. A serial number is assigned automatically.",
        "backToExpenses": "Back"
      },
      "form": {
        "dateLabel": "Date",
        "datePlaceholder": "Select date…",
        "supplierLabel": "To",
        "supplierPlaceholder": "Select supplier…",
        "particularsLabel": "Particulars",
        "particularsPlaceholder": "e.g. Transport fare",
        "amountLabel": "Amount",
        "amountPlaceholder": "0.00",
        "totalLabel": "Total",
        "categoryLabel": "Category",
        "categoryPlaceholder": "Select expense category…",
        "approvedByLabel": "Approved by",
        "approvedByPlaceholder": "Name of approver…",
        "receivedPaymentLabel": "Received payment",
        "receivedPaymentPlaceholder": "Name of recipient…",
        "saveButton": "Save voucher",
        "cancelButton": "Cancel",
        "saving": "Saving…",
        "saved": "Cash voucher saved.",
        "validationRequired": "Add at least one item with amount, and complete all required fields.",
        "duplicateWarningTitle": "Possible duplicate expense",
        "forceSubmit": "Force submit"
      },
      "view": {
        "title": "Cash Voucher {{serial}}",
        "backToExpenses": "Back",
        "loading": "Loading cash voucher…",
        "notFound": "Cash voucher not found.",
        "retry": "Try again",
        "voidedBadge": "Voided",
        "serialLabel": "Serial no.",
        "dateLabel": "Date",
        "supplierLabel": "To",
        "itemsLabel": "Items",
        "particularsLabel": "Particulars",
        "amountLabel": "Amount",
        "totalLabel": "Total",
        "categoryLabel": "Category",
        "approvedByLabel": "Approved by",
        "receivedPaymentLabel": "Received payment",
        "createdByLabel": "Created by",
        "voidReasonLabel": "Void reason",
        "expenseEntryLink": "View expense entry",
        "transactionLink": "View transaction",
        "printButton": "Print voucher",
        "voidButton": "Void voucher",
        "voiding": "Voiding…",
        "voided": "Cash voucher voided.",
        "voidModalTitle": "Void cash voucher",
        "voidReasonFieldLabel": "Reason (optional)",
        "voidReasonPlaceholder": "Optional reason for voiding…",
        "voidCancelButton": "Cancel",
        "voidConfirmButton": "Void voucher",
        "companyFallback": "Company",
        "notAvailable": "—"
      },
      "printModal": {
        "title": "Download PDF",
        "description": "Preview the voucher and choose what company details to include before downloading.",
        "includeTinLabel": "Include TIN #",
        "includeAddressLabel": "Include Address",
        "downloadPdf": "Download PDF",
        "generatingPdf": "Generating PDF…",
        "loadingPreview": "Loading preview…",
        "previewTitle": "Cash voucher PDF preview",
        "previewFailed": "Could not generate the PDF preview.",
        "retryPreview": "Try again",
        "closeButton": "Close"
      }
    },
    "capitals": {
      "CapitalList": {
        "title": "Capitals",
        "summaryHint": "Record owner investments and withdrawals with immutable audit history.",
        "searchPlaceholder": "Search by reference, description, or category…",
        "searchAria": "Search capital entries",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "filterFromDate": "From date",
        "filterToDate": "To date",
        "filterCapitalType": "Capital type",
        "filterCapitalTypeAll": "All types",
        "quickRangesLabel": "Quick ranges",
        "clearFilters": "Clear filters",
        "emptyFiltered": "No capital entries match your search or filters.",
        "includeVoided": "Include voided",
        "addEntry": "New capital entry",
        "loading": "Loading capital entries…",
        "empty": "No capital entries recorded yet.",
        "editTitle": "Edit entry",
        "editAria": "Edit {{referenceId}}",
        "voidTitle": "Void entry",
        "voidAria": "Void {{referenceId}}",
        "voidModalTitle": "Void capital entry",
        "voidModalBody": "Void capital entry {{referenceId}}? The linked general journal transaction will be reversed.",
        "voidReasonLabel": "Reason (optional)",
        "voidReasonPlaceholder": "Reason for voiding this entry",
        "confirmVoid": "Void entry",
        "voiding": "Voiding…",
        "voided": "Capital entry voided",
        "status": {
          "active": "Active",
          "voided": "Voided"
        },
        "capitalTypes": {
          "owner_investment": "Owner investment",
          "owner_withdrawal": "Owner withdrawal",
          "owner_loan": "Owner loan"
        },
        "subTypes": {
          "invest_cash": "Invest cash in company",
          "invest_expense": "Invest by shouldering expenses",
          "invest_equipment": "Invest assets (equipment)",
          "withdraw_cash": "Withdraw from company cash",
          "withdraw_company_expense": "Personal expense paid by company",
          "loan_from_owner": "Receive loan from owner",
          "loan_repay_owner": "Repay loan to owner"
        },
        "table": {
          "bookReference": "Book reference",
          "date": "Date",
          "capitalType": "Capital type",
          "subType": "Sub-type",
          "description": "Description",
          "account": "Account",
          "amount": "Amount",
          "status": "Status",
          "actions": "Actions"
        }
      },
      "CapitalCreate": {
        "backToList": "Back",
        "title": "New capital entry",
        "subtitle": "Record an owner investment, withdrawal, or loan."
      },
      "CapitalEdit": {
        "backToList": "Back",
        "title": "Edit capital entry",
        "subtitle": "Update {{referenceId}}. Saving voids this entry and posts a replacement with a new book reference.",
        "loading": "Loading capital entry…",
        "loadFailed": "Failed to load capital entry.",
        "tryAgain": "Try again",
        "notFound": "Capital entry not found.",
        "notEditable": "This capital entry cannot be edited because it is voided or already replaced."
      },
      "CapitalView": {
        "backToList": "Back",
        "title": "View capital entry",
        "loading": "Loading capital entry…",
        "loadFailed": "Failed to load capital entry.",
        "tryAgain": "Try again",
        "notFound": "Capital entry not found.",
        "amount": "Amount",
        "bookReference": "Book reference",
        "entryDate": "Entry date",
        "capitalType": "Capital type",
        "subType": "Sub-type",
        "counterpartyAccount": "Account",
        "balancingAccountEquity": "Equity account",
        "balancingAccountLiability": "Liability account",
        "status": "Status",
        "description": "Description",
        "editDescriptionAriaLabel": "Edit capital description",
        "equipmentName": "PPE asset",
        "usefulLifeYears": "Useful life: {{years}} years",
        "salvageValue": "Salvage value: {{amount}}",
        "viewEquipmentLink": "View PPE record",
        "viewCashReceiptLink": "View cash receipt ({{bookReference}})",
        "viewTransactionLink": "View Linked Transaction {{referenceNumber}}",
        "viewTransactionLinkFallback": "View linked transaction",
        "seeSupersededEntry": "See replaced entry",
        "seeReplacementEntry": "See replacement entry",
        "recordInfo": "Record info",
        "edit": "Edit",
        "void": "Void",
        "audit": {
          "status": "Status",
          "created": "Created",
          "createdBy": "Created by",
          "lastUpdated": "Last updated",
          "voided": "Voided",
          "voidedBy": "Voided by",
          "voidReason": "Void reason"
        }
      },
      "AddCapitalModal": {
        "createTitle": "New capital entry",
        "editTitle": "Edit capital entry",
        "editNotice": "Saving changes voids this entry and posts a replacement with a new reference ID. The original row stays in the audit trail.",
        "entryDate": "Entry date",
        "capitalType": "Capital type",
        "subType": "Transaction sub-type",
        "description": "Description",
        "descriptionPlaceholder": "Brief note about this owner equity movement",
        "descriptionEditOnDetailsHint": "Description is read-only here. Edit it on the capital details page.",
        "amount": "Amount (PHP)",
        "amountPhpLabel": "Amount recorded (PHP)",
        "amountPhpHint": "Calculated from foreign amount × exchange rate ({{currency}}).",
        "useForeignCurrency": "Record in foreign currency",
        "categorySuggestedLabel": "Suggested",
        "amountSuggestedLabel": "Recent amounts",
        "categoryPlaceholder": "Select an account",
        "save": "Save entry",
        "saveEdit": "Save changes",
        "saving": "Saving entry…",
        "savingEdit": "Saving changes…",
        "saved": "Capital entry saved",
        "savedEdit": "Capital entry updated",
        "cancel": "Cancel",
        "capitalTypes": {
          "ownerInvestment": "Owner investment",
          "ownerWithdrawal": "Owner withdrawal",
          "ownerLoan": "Owner loan"
        },
        "subTypes": {
          "invest_cash": "Invest cash in company",
          "invest_expense": "Invest by shouldering expenses",
          "invest_equipment": "Invest assets (equipment)",
          "withdraw_cash": "Withdraw from company cash",
          "withdraw_company_expense": "Personal expense paid by company",
          "loan_from_owner": "Receive loan from owner",
          "loan_repay_owner": "Repay loan to owner"
        },
        "counterpartyLabels": {
          "invest_cash": "Cash account",
          "invest_expense": "Expense account",
          "invest_equipment": "Equipment account",
          "withdraw_cash": "Cash account",
          "withdraw_company_expense": "Cash account",
          "loan_from_owner": "Cash account",
          "loan_repay_owner": "Cash account"
        },
        "counterpartyHints": {
          "invest_cash": "Choose the cash account receiving the owner's injection.",
          "invest_expense": "Choose the expense account the owner paid personally.",
          "invest_equipment": "Choose the equipment or asset account being contributed.",
          "withdraw_cash": "Choose the cash account used for the withdrawal. Describe owner draws or personal expenses paid from company cash in the note.",
          "loan_from_owner": "Choose the cash account receiving the owner's loan.",
          "loan_repay_owner": "Choose the cash account paying back the owner loan."
        },
        "equipmentSectionTitle": "PPE record",
        "equipmentSectionHint": "Creates a linked PPE asset for depreciation tracking. View it anytime under PPE.",
        "equipmentName": "Asset name",
        "equipmentNamePlaceholder": "e.g. Delivery van, Office laptop",
        "usefulLifeYears": "Useful life (years)",
        "salvageValue": "Salvage value (PHP)",
        "viewEquipmentLink": "View PPE record",
        "equipmentOpensInNewTab": "Opens the PPE detail page.",
        "errors": {
          "entryDateRequired": "Entry date is required.",
          "descriptionRequired": "Description is required.",
          "amountInvalid": "Enter a valid amount greater than zero.",
          "counterpartyCategoryRequired": "Select an account for this entry.",
          "equipmentNameRequired": "Enter a name for the contributed PPE asset.",
          "usefulLifeRequired": "Enter useful life in years (1–100).",
          "salvageValueInvalid": "Enter a valid salvage value (zero or more).",
          "fxAmountInvalid": "Enter a valid foreign amount and exchange rate, or turn off foreign currency."
        }
      }
    },
    "reports": {
      "index": {
        "pageTitle": "Reports",
        "financialGroupTitle": "Financial Reports",
        "journalsGroupTitle": "List Reports",
        "accessDenied": {
          "title": "Access Denied",
          "message": "You do not have permission to view reports.",
          "goToDashboard": "Go to Dashboard"
        },
        "premiumUpgrade": {
          "crownLabel": "Paid plan feature",
          "modalTitle": "Upgrade to unlock this report",
          "modalBody": "{{reportName}} is included in paid plans.",
          "ownerHint": "Choose a plan on Billing — checkout takes about a minute, and you can return here right after payment.",
          "memberHint": "Ask your company owner to upgrade on Settings → Billing. You will get access as soon as the company plan is active.",
          "viewPlansButton": "View plans",
          "notNowButton": "Not now",
          "genericReportName": "This report"
        },
        "financialCards": {
          "balanceSheet": {
            "title": "Balance Sheet",
            "subtitle": "Statement of Financial Position",
            "description": "Assets, liabilities, and equity for a date range"
          },
          "incomeStatement": {
            "title": "Income Statement",
            "subtitle": "Profit and Loss",
            "description": "Revenue and expenses for a date range, with net income"
          },
          "trialBalance": {
            "title": "Trial Balance",
            "subtitle": "Debits and credits by category",
            "description": "Total debits and credits by category for a selected period"
          },
          "statementOfChangesInEquity": {
            "title": "Changes in Equity",
            "subtitle": "Statement of Changes in Equity",
            "description": "How equity changed over a reporting period"
          },
          "cashFlowStatement": {
            "title": "Cash Flow",
            "subtitle": "Statement of Cash Flows",
            "description": "Operating, investing, and financing cash movements for a period"
          },
          "financialStatementGeneration": {
            "title": "Financial Statements",
            "subtitle": "Complete statement package",
            "description": "Full financial statement package with management notes and disclosures"
          }
        },
        "journalCards": {
          "cashReceiptsJournalReport": {
            "title": "Cash Receipts Journal",
            "subtitle": "Sales list report",
            "description": "Transaction-derived cash receipts register with cash debits and credit account columns"
          },
          "cashDisbursementJournalReport": {
            "title": "Cash Disbursements Journal",
            "subtitle": "Expenses list report",
            "description": "Transaction-derived cash disbursements register with cash credits and debit account columns"
          },
          "generalJournal": {
            "title": "General Journal",
            "subtitle": "Chronological entries",
            "description": "All transactions in date order with debit and credit entries, including voided"
          },
          "generalLedger": {
            "title": "General Ledger",
            "subtitle": "Account running balances",
            "description": "Transaction history for a category with running balances"
          }
        }
      },
      "EditableReportTitleHeading": {
        "void_promise_3": "Void promise",
        "edit_report_title_1": "Edit report title",
        "report_title_2": "Report title"
      },
      "ReportExportPDFModal": {
        "promise_3": "Promise",
        "close_1": "Close",
        "download_pdf_4": "Download pdf",
        "pdf_preview_2": "Pdf preview",
        "loading_preview_5": "Loading preview",
        "previewDescription": "Preview your report, then download when ready."
      },
      "ViewCategoryTransactionsConfirmModal": {
        "view_transactions_1": "View transactions",
        "viewGeneralLedgerTitle": "View general ledger",
        "chooseActionTitle": "Category",
        "changeAccountNumberTitle": "Change account number",
        "choosePrompt": "What would you like to do with {{name}}?",
        "legacyPrompt": "Do you want to view transactions with {{name}}?",
        "legacyGeneralLedgerPrompt": "Open the general ledger for {{name}} to see the transactions that make up this balance?",
        "editAccountNumberPrompt": "Set the account number for {{name}}.",
        "viewTransactionsButton": "View transactions",
        "viewGeneralLedgerButton": "View general ledger",
        "changeAccountNumberButton": "Change account number",
        "accountNumberLabel": "Account number",
        "accountNumberPlaceholder": "e.g. 1100",
        "saveAccountNumberButton": "Save",
        "savingAccountNumber": "Saving…",
        "accountNumberSaved": "Account number saved.",
        "accountNumberSaveFailed": "Failed to save account number.",
        "backButton": "Back",
        "cancelButton": "Cancel",
        "closeButton": "Close",
        "yesButton": "Yes",
        "noButton": "No",
        "asOfBadge": "As of {{asOf}}",
        "periodBadge": "For {{from}} – {{to}}",
        "heroCaption": "Report amount",
        "computationTitle": "How this amount is calculated",
        "debitNormalHint": "Cumulative from the start of the books through {{asOf}}. Debits increase this account; credits decrease it.",
        "creditNormalHint": "Cumulative from the start of the books through {{asOf}}. Credits increase this account; debits decrease it.",
        "rollupHint": "Sum of the accounts and lines that make up this total for the selected period ending {{asOf}}.",
        "periodRollupHint": "Sum of the lines that make up this total for {{asOf}}.",
        "soceNetIncomeHint": "This amount comes from the Income Statement for the same date range. Open the Income Statement to see the full breakdown.",
        "cashFlowEndingHint": "Cash at end of period = cash at beginning + net change in cash.",
        "cashFlowNetChangeHint": "Net change in cash is the sum of net cash from operating, investing, and financing activities.",
        "computationLoading": "Loading ledger totals…",
        "totalDebitsLabel": "Total debits",
        "totalCreditsLabel": "Total credits",
        "minusTotalCreditsLabel": "Minus total credits",
        "minusTotalDebitsLabel": "Minus total debits",
        "balanceLabel": "Balance",
        "totalLabel": "Total",
        "reportAmountLabel": "Report amount",
        "entryCount": "{{count}} ledger line(s) through this date",
        "transactionsTitle": "Transactions",
        "transactionGroupPeriod": "Transactions for {{from}} – {{to}}",
        "transactionGroupAsOf": "Transactions through {{asOf}}",
        "transactionDateColumn": "Date",
        "transactionDescriptionColumn": "Description",
        "transactionAmountColumn": "Amount",
        "transactionRunningBalanceColumn": "Running balance",
        "openLedgerLink": "Open general ledger for line detail",
        "openIncomeStatementLink": "Open Income Statement with the same dates",
        "openSourceReportLink": "Open source report with the same dates",
        "retainedEarningsHint": "Cumulative through {{asOf}}: net income from operations, plus any direct postings to Retained Earnings.",
        "netRevenueLabel": "Net revenue",
        "minusNetExpensesLabel": "Minus net expenses",
        "netIncomeFromOperationsLabel": "Net income (loss) from operations",
        "plusDirectRetainedEarningsLabel": "Plus direct retained earnings entries"
      },
      "reportDateRangePresetButtons": {
        "today": "Today",
        "thisMonth": "This Month",
        "lastMonth": "Last Month",
        "thisYear": "This Year",
        "lastYear": "Last Year",
        "q1": "1st Qtr",
        "q2": "2nd Qtr",
        "q3": "3rd Qtr",
        "q4": "4th Qtr",
        "previousMonth": "Previous Month",
        "nextMonth": "Next Month"
      },
      "reportAccountNumbersToggle": {
        "showAccountNumbers": "Show account numbers",
        "hideAccountNumbers": "Hide account numbers",
        "showAccountNumbersTitle": "Show account numbers in the report",
        "hideAccountNumbersTitle": "Hide account numbers in the report"
      },
      "sharedExport": {
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export report",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file."
      },
      "trialBalance": {
        "pageTitle": "Trial Balance",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "quickRangesLabel": "Quick ranges",
        "customRangeLabel": "Custom range",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "tinPrefix": "TIN:",
        "periodLabel": "Period:",
        "accountColumn": "Account",
        "debitColumn": "Debit",
        "creditColumn": "Credit",
        "totalsRow": "Totals",
        "totalDebitsLabel": "Total Debits:",
        "totalCreditsLabel": "Total Credits:",
        "differenceLabel": "Difference:",
        "balancedStatus": "✓ Balanced",
        "notBalancedStatus": "⚠ Not Balanced",
        "emptyPeriodMessage": "No account activity in this period.",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again."
      },
      "balanceSheet": {
        "pageTitle": "Balance Sheet",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "expenseAmountsLabel": "Expense amounts in report",
        "expenseScopeAll": "All (full books)",
        "expenseScopeDeductible": "Deductible only (tax)",
        "expenseScopeNonDeductible": "Non-deductible only",
        "expenseScopePartiallyDeductible": "Partially deductible items only",
        "asOfLabel": "As of",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "tinPrefix": "TIN:",
        "asOfDatePrefix": "As of {{date}}",
        "noTransactionsMessage": "No transactions found for this company.",
        "goToTransactionsLink": "Go to Transactions",
        "noDataMessage": "No data found for the selected date range.",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again.",
        "totalAssetsRow": "Total Assets",
        "totalLiabilitiesRow": "Total Liabilities",
        "totalEquityRow": "Total Equity",
        "totalLiabilitiesAndEquityRow": "Total Liabilities and Equity",
        "reorderAccounts": "Reorder accounts",
        "reorderSave": "Save order",
        "reorderSaveShort": "Save",
        "reorderSaving": "Saving order…",
        "reorderSavingShort": "Saving…",
        "reorderUndo": "Undo last move",
        "reorderUndoShort": "Undo",
        "reorderCancel": "Cancel reorder",
        "reorderCancelShort": "Cancel",
        "reorderRestoreDefault": "Restore default",
        "reorderRestoreShort": "Restore",
        "reorderSaved": "Balance sheet account order saved.",
        "reorderSaveFailed": "Failed to save balance sheet account order.",
        "reorderMoveUp": "Move {{name}} up",
        "reorderMoveDown": "Move {{name}} down",
        "reorderDragHandle": "Drag to reorder {{name}}",
        "reorderDragOverlayFallback": "Account",
        "reorderUnsavedExitToast": "You have unsaved account order changes. Save, or try leaving again to discard.",
        "backAriaLabel": "Back",
        "backButton": "Back"
      },
      "incomeStatement": {
        "pageTitle": "Income Statement",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "expenseAmountsLabel": "Expense amounts in report",
        "expenseScopeAll": "All (full books)",
        "expenseScopeDeductible": "Deductible only (tax)",
        "expenseScopeNonDeductible": "Non-deductible only",
        "expenseScopePartiallyDeductible": "Partially deductible items only",
        "quickRangesLabel": "Quick ranges",
        "customRangeLabel": "Custom range",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "comparingButton": "Comparing...",
        "hideCompareButton": "Hide Compare",
        "compareButton": "Compare",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "tinPrefix": "TIN:",
        "noTransactionsMessage": "No transactions found for this company.",
        "goToTransactionsLink": "Go to Transactions",
        "noDataMessage": "No data found for the selected date range.",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again.",
        "compareMaxMonths": "Only up to 3 months",
        "compareFromStartOfMonth": "Date From must be first day of month",
        "compareToEndOfMonth": "Date To must be end of month",
        "compareMinTwoMonths": "Select at least 2 months",
        "compareSelectRangeFirst": "Select date range first",
        "compareLoadFailed": "Failed to load month comparison",
        "totalRevenueRow": "Total Revenue",
        "lessCostOfGoodsSoldRow": "Less: Cost of Goods Sold",
        "lessCostOfServicesRow": "Less: Cost of Services",
        "lessCostOfSalesRow": "Less: Cost of Sales",
        "grossProfitRow": "Gross Profit",
        "lessOperatingExpensesRow": "Less: Operating Expenses",
        "totalOperatingExpensesRow": "Total Operating Expenses",
        "otherIncomeSection": "Other Income",
        "totalOtherIncomeRow": "Total Other Income",
        "otherExpensesSection": "Other Expenses",
        "totalOtherExpensesRow": "Total Other Expenses",
        "lessIncomeTaxExpenseRow": "Less: Income Tax Expense",
        "netIncomeLossBeforeTaxCompare": "Net Income (Loss) Before Income Tax",
        "netLossBeforeTaxCompare": "Net Loss Before Income Tax",
        "netIncomeBeforeTaxCompare": "Net Income Before Income Tax",
        "netIncomeLossCompare": "Net Income (Loss)",
        "netLossCompare": "Net Loss",
        "netIncomeCompare": "Net Income",
        "backAriaLabel": "Back",
        "backButton": "Back"
      },
      "cashFlowStatement": {
        "pageTitle": "Cash Flow",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "expenseAmountsLabel": "Expense amounts in report",
        "expenseScopeAll": "All (full books)",
        "expenseScopeDeductible": "Deductible only (tax)",
        "expenseScopeNonDeductible": "Non-deductible only",
        "expenseScopePartiallyDeductible": "Partially deductible items only",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "tinPrefix": "TIN:",
        "operatingActivitiesSection": "Cash flows from operating activities",
        "investingActivitiesSection": "Cash flows from investing activities",
        "financingActivitiesSection": "Cash flows from financing activities",
        "noTransactionsMessage": "No transactions found for this company.",
        "goToTransactionsLink": "Go to Transactions",
        "noDataMessage": "No data found for the selected date range.",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again.",
        "netLossBeforeTax": "Net loss before income tax",
        "netIncomeBeforeTax": "Net income before income tax",
        "netCashUsedOperating": "Net cash used in operating activities",
        "netCashProvidedOperating": "Net cash provided by operating activities",
        "netCashUsedInvesting": "Net cash used in investing activities",
        "netCashProvidedInvesting": "Net cash provided by investing activities",
        "netCashUsedFinancing": "Net cash used in financing activities",
        "netCashProvidedFinancing": "Net cash provided by financing activities",
        "helpButtonAria": "Cash flow statement tips",
        "CashFlowFeatureTip": {
          "title": "Which categories count as cash?",
          "intro": "This report tracks cash movements from your transactions. Only the following asset categories are treated as the cash side of a payment or receipt:",
          "bulletCashAccount": "The Cash category",
          "bulletTreatAsCash": "Categories under Current Assets marked Treat as cash in Categories",
          "bulletCashEquivalents": "Categories under Cash/Cash Equivalents",
          "bulletIndirectOperating": "Operating activities use the indirect method (net income plus adjustments). Everyday expenses paid from a cash wallet affect net income—they do not appear as separate cash-flow lines per category.",
          "bulletIndirectInvesting": "Purchases of property or equipment paid from a cash wallet appear under investing activities when the asset category is on the opposite side of the entry.",
          "outro": "Mark wallets and banks under Current Assets as Treat as cash—or place them under Cash/Cash Equivalents—so they count in cash balances and as the cash leg on this report."
        },
        "backAriaLabel": "Back",
        "backButton": "Back"
      },
      "statementOfChangesInEquity": {
        "pageTitle": "Changes in Equity",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "tinPrefix": "TIN:",
        "subtotalRow": "Subtotal",
        "reconciledTag": "Reconciled",
        "unreconciledTag": "Unreconciled",
        "noTransactionsMessage": "No transactions found for this company.",
        "goToTransactionsLink": "Go to Transactions",
        "noDataMessage": "No data found for the selected date range.",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again."
      },
      "generalLedger": {
        "pageTitle": "General Ledger",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "backToJournalsAriaLabel": "Back",
        "backToJournalsButton": "Back",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export general ledger",
        "exportAllButton": "Export all ledgers",
        "exportAllButtonAriaLabel": "Export all ledgers",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "categoryAccountLabel": "Category (Account)",
        "allLedgersOption": "All Ledgers",
        "noAccountsInPeriodMessage": "No accounts have activity in the selected date range.",
        "searchCategoryPlaceholder": "Search for a category...",
        "fromLabel": "From",
        "toLabel": "To",
        "datePlaceholder": "May 31, 2026",
        "clearDatesButton": "Clear Dates",
        "applyDateRangeButton": "Apply Date Range",
        "exportingAllLedgers": "Exporting…",
        "exportingAllLedgersPdf": "Generating PDF…",
        "downloadAllLedgersCsv": "Download all ledgers (CSV)",
        "downloadAllLedgersPdf": "Download all ledgers (PDF)",
        "downloadAllLedgersPdfAriaLabel": "Download all ledgers PDF",
        "exportAllHint": "Exports every account that has activity in the date range above. Accounts with no rows in the period are omitted. Accounts are ordered by chart liquidity (Assets → Liabilities → Equity → Revenue → Expenses), not A–Z.",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "tinLabel": "TIN:",
        "tinPrefix": "TIN:",
        "accountLabel": "Account:",
        "periodLabel": "Period:",
        "openingBalanceRow": "Opening Balance",
        "openingBalanceLabel": "Opening Balance:",
        "noColumn": "No.",
        "monthColumn": "Mon",
        "dateColumn": "Date",
        "referenceNumberColumn": "Ref No.",
        "viewTransactionLink": "View transaction {{referenceNumber}}",
        "descriptionColumn": "Description",
        "accountColumn": "Account",
        "partyColumn": "Payor/Payee",
        "debitColumn": "Debit",
        "creditColumn": "Credit",
        "runningBalanceColumn": "Running Balance",
        "closingBalanceRow": "Closing Balance",
        "noTransactionsMessage": "No transactions found for this period.",
        "cancelledBillTooltip": "This transaction is linked to a cancelled bill.",
        "selectCategoryError": "Please select a category",
        "datesBothOrNeitherError": "Both date fields must be provided together, or neither",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again.",
        "allLedgersPdfGenerateFailedAlert": "Failed to generate the all-accounts General Ledger PDF. Please try again.",
        "noAccountsExportAlert": "No accounts with activity in this date range. Nothing to export.",
        "backAriaLabel": "Back",
        "backButton": "Back"
      },
      "generalJournal": {
        "pageTitle": "General Journal",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "backToJournalsAriaLabel": "Back",
        "backToJournalsButton": "Back",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "sortByLabel": "Sort by",
        "sortByTransactionDate": "Transaction date",
        "sortByCreatedDate": "Created date",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "tinPrefix": "TIN:",
        "noColumn": "No.",
        "monthColumn": "Mon",
        "dateColumn": "Date",
        "referenceNumberColumn": "Ref. No.",
        "prColumn": "PR",
        "descriptionColumn": "Description",
        "accountColumn": "Account",
        "debitColumn": "Debit",
        "creditColumn": "Credit",
        "grandTotalRow": "Grand Total",
        "noTransactionsMessage": "No transactions found for the selected period.",
        "cancelledBillTooltip": "This transaction is linked to a cancelled bill.",
        "voidedBadge": "Voided",
        "noDataMessage": "No data available",
        "datesRequiredError": "Both date fields are required",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again.",
        "reorderColumn": "Order",
        "reorderHint": "Drag the handle or use the arrows to reorder entries that share the same date.",
        "reorderDragAriaLabel": "Drag to reorder this entry within the same date",
        "reorderMoveUpAriaLabel": "Move entry up within the same date",
        "reorderMoveDownAriaLabel": "Move entry down within the same date",
        "reorderSavingToast": "Saving entry order…",
        "reorderSuccessToast": "Entry order updated.",
        "reorderFailedToast": "Failed to update entry order.",
        "resequenceJvButton": "Resequence JV numbers",
        "resequenceJvBusyButton": "Resequencing…",
        "resequenceJvConfirmTitle": "Resequence JV numbers?",
        "resequenceJvConfirm": "Renumber all journal vouchers for this company as JV-001, JV-002, … in General Journal order (date, then same-day order)? Sales/Expenses CR and CD numbers are not changed. This cannot be undone.",
        "resequenceJvConfirmButton": "Resequence",
        "resequenceJvConfirmCancelButton": "Cancel",
        "resequenceJvSavingToast": "Resequencing JV numbers…",
        "resequenceJvSuccessToast": "Renumbered {{count}} vouchers ({{first}}–{{last}}).",
        "resequenceJvFailedToast": "Failed to resequence JV numbers."
      },
      "cashReceiptsJournalReport": {
        "pageTitle": "Cash Receipts Journal",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "pdfReportTitle": "Cash Receipts Journal",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again.",
        "resequenceCrButton": "Resequence CR numbers",
        "resequenceCrBusyButton": "Resequencing…",
        "resequenceCrConfirmTitle": "Resequence CR numbers?",
        "resequenceCrConfirm": "Renumber all cash receipt book refs for this company as CR-001, CR-002, … in Cash Receipts Journal report order (date, then same-day order)? Journal voucher (JV) numbers are not changed. This cannot be undone.",
        "resequenceCrConfirmButton": "Resequence",
        "resequenceCrConfirmCancelButton": "Cancel",
        "resequenceCrSavingToast": "Resequencing CR numbers…",
        "resequenceCrSuccessToast": "Renumbered {{count}} cash receipts ({{first}}–{{last}}).",
        "resequenceCrFailedToast": "Failed to resequence CR numbers.",
        "revenueAccountLabel": "Revenue account",
        "allAccountsOption": "All accounts",
        "includeVoidedLabel": "Include voided",
        "showVoidedLabel": "Show voided",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "dateColumn": "Date",
        "referenceNumberColumn": "Ref. No.",
        "orColumn": "OR#",
        "particularsColumn": "Particulars",
        "revenueAccountColumn": "Revenue account",
        "amountColumn": "Amount",
        "voidedBadge": "Voided",
        "totalCashReceiptsRow": "Total cash receipts",
        "datesRequiredError": "Both date fields are required",
        "truncatedHint": "Showing {{shown}} of {{total}} receipts. Narrow your date range or filters to load the full report.",
        "emptyStateNoAccount": "No receipts found for the selected period and account.",
        "emptyState": "No cash receipt transactions found for the selected period.",
        "noColumn": "No.",
        "monthColumn": "Mon",
        "dayColumn": "Date",
        "refColumn": "Ref.",
        "payorColumn": "Payor",
        "descriptionColumn": "Description",
        "cashDebitColumn": "Cash (Debit)",
        "debitColumnSuffix": "(Debit)",
        "creditColumnSuffix": "(Credit)",
        "totalDebitColumn": "Total Debit",
        "totalCreditColumn": "Total Credit",
        "totalRowLabel": "Total",
        "periodEndedSingle": "For the period ended {{date}}",
        "periodRange": "For the period {{from}} to {{to}}",
        "periodFrom": "From {{date}}",
        "insights": {
          "sectionTitle": "Insights",
          "loading": "Checking OR numbers…",
          "loadFailed": "Could not load insights.",
          "retryButton": "Retry",
          "missingOrMessage": "Missing OR# {{missing}} between {{before}} and {{after}}. It may have been skipped or not recorded yet.",
          "duplicateOrMessage": "OR# {{orNumber}} appears on {{count}} rows:",
          "outOfSequenceOrMessage": "OR# {{orNumber}} is out of sequence.",
          "scrollToButton": "View",
          "scrollToAriaLabel": "Scroll to OR# {{orNumber}} in the report",
          "scrollNotFoundToast": "That OR# is not in the current report rows.",
          "dismissButton": "Dismiss",
          "dismissAriaLabel": "Dismiss OR# {{orNumber}} insight",
          "dismissTitle": "Dismiss insight?",
          "dismissBody": "Dismiss the OR# {{orNumber}} insight? This will hide it until the sequence changes.",
          "dismissReasonLabel": "Reason",
          "dismissNotesLabel": "Additional notes (optional)",
          "dismissNotesPlaceholder": "Optional details",
          "dismissOtherReasonLabel": "Reason (required)",
          "dismissOtherReasonPlaceholder": "Describe why you are dismissing this insight",
          "dismissOtherReasonRequired": "Enter a reason when Other is selected.",
          "dismissCancelButton": "Cancel",
          "dismissConfirmButton": "Dismiss",
          "dismissBusyButton": "Dismissing…",
          "dismissSuccessToast": "Insight dismissed.",
          "dismissFailedToast": "Failed to dismiss insight.",
          "noActiveInsights": "No open insights for this period.",
          "dismissedSectionTitle": "Dismissed ({{count}})",
          "dismissedReason": "Reason: {{reason}}",
          "dismissedByAt": "Dismissed by {{name}} · {{at}}",
          "dismissedAt": "Dismissed · {{at}}",
          "dismissPresets": {
            "cancelled_or": "Cancelled OR",
            "spoiled_or": "Spoiled / unused OR",
            "not_yet_recorded": "Not yet recorded",
            "duplicate_bookkeeping": "Duplicate bookkeeping",
            "other": "Other"
          }
        }
      },
      "cashDisbursementJournalReport": {
        "pageTitle": "Cash Disbursements Journal",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "downloadCsvAriaLabel": "Download CSV",
        "downloadCsv": "Download CSV",
        "downloadPdfAriaLabel": "Download PDF",
        "generatingPdf": "Generating...",
        "downloadPdf": "Download PDF",
        "pdfReportTitle": "Cash Disbursements Journal",
        "pdfGenerateFailedAlert": "Failed to generate PDF. Please try again.",
        "resequenceCdButton": "Resequence CD numbers",
        "resequenceCdBusyButton": "Resequencing…",
        "resequenceCdConfirmTitle": "Resequence CD numbers?",
        "resequenceCdConfirm": "Renumber all cash disbursement book refs for this company as CD-001, CD-002, … in Cash Disbursements Journal report order (date, then same-day order)? Journal voucher (JV) numbers are not changed. This cannot be undone.",
        "resequenceCdConfirmButton": "Resequence",
        "resequenceCdConfirmCancelButton": "Cancel",
        "resequenceCdSavingToast": "Resequencing CD numbers…",
        "resequenceCdSuccessToast": "Renumbered {{count}} cash disbursements ({{first}}–{{last}}).",
        "resequenceCdFailedToast": "Failed to resequence CD numbers.",
        "expenseAccountLabel": "Expense account",
        "allAccountsOption": "All accounts",
        "includeVoidedLabel": "Include voided",
        "showVoidedLabel": "Show voided",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "applyButton": "Apply",
        "loadingReport": "Loading report...",
        "retryButton": "Retry",
        "dateColumn": "Date",
        "referenceNumberColumn": "Ref. No.",
        "orColumn": "OR#",
        "particularsColumn": "Particulars",
        "expenseAccountColumn": "Expense account",
        "amountColumn": "Amount",
        "voidedBadge": "Voided",
        "totalCashDisbursementsRow": "Total expenses",
        "datesRequiredError": "Both date fields are required",
        "truncatedHint": "Showing {{shown}} of {{total}} expenses. Narrow your date range or filters to load the full report.",
        "emptyStateNoAccount": "No expenses found for the selected period and account.",
        "emptyState": "No expenses found for the selected period.",
        "noColumn": "No.",
        "monthColumn": "Mon",
        "dayColumn": "Date",
        "refColumn": "Ref.",
        "cvColumn": "CV #",
        "payeeColumn": "Payee",
        "descriptionColumn": "Description",
        "debitColumnSuffix": "(Debit)",
        "cashCreditColumn": "Cash (Credit)",
        "totalRowLabel": "Total",
        "periodEndedSingle": "For the period ended {{date}}",
        "periodRange": "For the period {{from}} to {{to}}",
        "periodFrom": "From {{date}}"
      },
      "financialStatementGeneration": {
        "pageTitle": "Financial Statements",
        "backToReportsAriaLabel": "Back",
        "backToReportsButton": "Back",
        "hidePrinciplesToggle": "Hide principles and supporting references",
        "showPrinciplesToggle": "Show principles and supporting references",
        "principlesHeading": "Principles and supporting references",
        "soleProprietorshipBadge": "Sole proprietorship",
        "companySettingsLink": "company settings",
        "section2b": "Section 2(b)",
        "birRevenueRegulations": "BIR Revenue Regulations No. 3-2010",
        "managementStatement": "Management",
        "supportingDocsIntro": "Supporting documents (new tab), tailored to",
        "companyInfoGateIntro": "The following company profile fields are required before you can load data and generate the combined financial statement PDF. Edit the company to fill them in.",
        "companyInfoGateFallback": "Required company details are incomplete. Open company settings to continue.",
        "completeCompanyInfoButton": "Complete Company Info",
        "yearLabel": "Year:",
        "fromLabel": "From:",
        "toLabel": "To:",
        "datePlaceholder": "May 31, 2026",
        "reloadDataButton": "Reload Data",
        "signatoryTitleSuffix": "Title",
        "signatoryNameSuffix": "Name",
        "enterSignatoryNamePlaceholder": "Enter signatory name",
        "auditedWord": "audited",
        "financialStatementsWord": "financial statements",
        "savingSettings": "Saving...",
        "saveSettingsButton": "Save Settings",
        "generatingPdf": "Generating...",
        "generateCombinedPdfButton": "Generate Combined FS PDF",
        "loadingReportData": "Loading report data...",
        "previewModalTitle": "Preview financial statement PDF",
        "previewIframeTitle": "Financial statement PDF preview",
        "previewNote": "Preview only: text in red shows filled-in fields and other highlighted parts. The PDF you download prints everything in black, like a final document.",
        "closeButton": "Close",
        "downloadPdfButton": "Download PDF",
        "companyNameField": "Company name",
        "addressField": "Address",
        "tinField": "TIN",
        "telephoneField": "Telephone",
        "emailField": "Email",
        "reloadBeforeGenerateError": "Please reload data before generating the PDF.",
        "failedSaveSettingsError": "Failed to save settings",
        "failedGeneratePreviewError": "Failed to generate PDF preview",
        "failedPrepareDownloadError": "Failed to prepare PDF download",
        "downloadPdfModalButton": "Download PDF",
        "loadingCompanyProfile": "Loading company profile…",
        "welcome": {
          "title": "Financial Statements",
          "tagline": "Generate BIR-ready financial statement packages from your books.",
          "description": "Answer a short setup about your registered business details. We use this on the cover page, Statement of Management's Responsibility, and PFRS-style statements in your combined PDF.",
          "setupButton": "Set up Financial Statement",
          "featureBirPackage": "Combined PDF with SMR, statements of financial position, comprehensive income, cash flows, and changes in equity",
          "featurePfrsStatements": "PFRS-aligned titles and notes tailored to your entity type from company settings",
          "footerHint": "Requires company name, address, TIN, telephone, and email on file",
          "learnMore": "Learn more",
          "backToReportsLink": "Back to Reports"
        },
        "setup": {
          "heading": "Financial Statements",
          "subheading": "Company details for your financial statement PDF",
          "stepOf": "Step {{current}} of {{total}}",
          "companyProfileLabel": "Company profile",
          "backToWelcome": "Back",
          "backButton": "Back",
          "nextButton": "Next",
          "finishButton": "Finish setup",
          "continueButton": "Continue",
          "saving": "Saving…",
          "allComplete": "Your company profile already has the required details.",
          "invalidEmail": "Enter a valid email address.",
          "steps": {
            "name": {
              "title": "What is your registered business name?",
              "subtitle": "This appears on the cover and signature pages of your financial statements.",
              "fieldLabel": "Registered business name",
              "placeholder": "e.g. Abrasoft Trading"
            },
            "address": {
              "title": "What is your business address?",
              "subtitle": "Use the address shown on your BIR registration or official records.",
              "fieldLabel": "Business address",
              "placeholder": "Street, city, province"
            },
            "tin": {
              "title": "What is your Tax Identification Number (TIN)?",
              "subtitle": "Your TIN is printed on BIR forms and the Statement of Management's Responsibility.",
              "fieldLabel": "TIN"
            },
            "tel": {
              "title": "What telephone number should we show?",
              "subtitle": "A contact number for your business on the financial statement package.",
              "fieldLabel": "Telephone",
              "placeholder": "e.g. +63 912 345 6789"
            },
            "email": {
              "title": "What email address should we show?",
              "subtitle": "Used on the cover page and for correspondence on your statement package.",
              "fieldLabel": "Email",
              "placeholder": "name@company.com"
            }
          }
        }
      }
    },
    "categories": {
      "toolbar": {
        "pageTitle": "Categories",
        "helpButtonAria": "Categories tips",
        "searchLabel": "Search",
        "searchPlaceholder": "Filter by name, number, or path…",
        "searchAriaLabel": "Filter categories",
        "filtersAriaLabel": "Open category filters",
        "filtersButton": "Filters",
        "hideAccountNumbersTitle": "Hide account numbers in the list",
        "showAccountNumbersTitle": "Show account numbers in the list",
        "hideAccountNumbersFull": "Hide account numbers",
        "hideAccountNumbersShort": "Hide Acct #",
        "showAccountNumbersFull": "Show account numbers",
        "showAccountNumbersShort": "Show Acct #",
        "cancelEditingButton": "Cancel editing",
        "editAccountNumbersTitle": "Edit account numbers inline in the list",
        "editAccountNumbersFull": "Edit account numbers",
        "editAccountNumbersShort": "Edit Acct #",
        "deselectAllButton": "Deselect All",
        "selectAllButton": "Select All",
        "deleteSelectedButton": "Delete Selected ({{count}})",
        "markCashSelectedButton": "Treat as cash ({{count}})",
        "clearCashSelectedButton": "Clear cash ({{count}})"
      },
      "CategoriesFeatureTip": {
        "title": "Treat as cash on categories",
        "intro": "Use Treat as cash on Current Assets categories when a wallet or bank should behave like cash in journals and reports.",
        "bulletCurrentAssets": "The toggle appears only when the parent is under Current Assets (including Cash/Cash Equivalents).",
        "bulletTreatAsCash": "Marked categories show a Treat as cash badge in the list and can be filtered with Filters → Treat as cash only.",
        "bulletCashEquivalents": "You can also place categories under Cash/Cash Equivalents instead of using the toggle.",
        "bulletCashFlow": "Cash Flow Statement includes these categories as the cash leg; see that report’s help tips for indirect-method expectations.",
        "outro": "Moving a category outside Current Assets clears Treat as cash automatically (including on save and on history rollback)."
      },
      "BatchCountsAsCashCategoryModal": {
        "titleMark": "Treat selected as cash",
        "titleClear": "Clear cash treatment",
        "confirmMark": "Mark selected Current Assets categories ({{count}}) as cash equivalents for cash flow and balances?",
        "confirmClear": "Clear cash treatment for selected categories ({{count}})?",
        "noneEligible": "None of the selected categories are under Current Assets.",
        "cancelButton": "Cancel",
        "saveButton": "Save",
        "savingButton": "Saving…",
        "errorFallback": "Failed to update cash treatment."
      },
      "deleteModal": {
        "title": "Delete Category",
        "confirmMessage": "Are you sure you want to delete the category \"{{name}}\"?",
        "cancelButton": "Cancel",
        "confirmButton": "Delete",
        "confirmButtonPending": "Deleting...",
        "errorFallback": "Failed to delete category"
      },
      "AddCategoryModal": {
        "category_name_1": "Category Name",
        "search_for_a_parent_category_2": "Search for a parent category...",
        "e_g_6100_3": "e.g. 6100",
        "add_category_4": "Add Category",
        "add_category_5": "Add Category",
        "category_name_6": "Category Name",
        "parent_category_7": "Parent Category",
        "account_number_optional_8": "Account number (optional)",
        "locked_cash_parent_blocked_error_9": "Cannot use Cash as a parent category. Add cash subaccounts under Cash and Cash Equivalents instead.",
        "voidedNameConflict": "This account title belongs to a voided category. Restore the existing category instead of creating a new one.",
        "restoreVoidedButton": "Restore voided category",
        "restoreVoidedConfirmTitle": "Restore voided category",
        "restoreVoidedConfirmSummary": "Review the voided category below. Restore puts it back on the chart with these details.",
        "restoreVoidedConfirmButton": "Restore",
        "restoreVoidedBackButton": "Back",
        "restoreVoidedNotFoundToast": "Voided category not found. Refresh and try again.",
        "restoringVoidedButton": "Restoring…"
      },
      "VoidedCategoriesPanel": {
        "sectionAria": "Voided categories",
        "title": "Voided account titles",
        "summary": "These names are reserved. Restore a category to use it again in the chart.",
        "unknownRoot": "chart of accounts",
        "rootLabel": "Under {{root}}",
        "voidedAtLabel": "Voided {{date}}",
        "restoreButton": "Restore",
        "restoringButton": "Restoring…",
        "restoreSuccess": "Restored \"{{name}}\"."
      },
      "AssignCategoryAccountNumberModal": {
        "assign_account_number_1": "Assign account number",
        "assign_account_number_2": "Assign account number",
        "include_subcategories_3": "Include subcategories"
      },
      "AutoFillAccountNumbersModal": {
        "auto_fill_account_numbers_1": "Auto-fill account numbers",
        "void_promise_2": "void | Promise",
        "void_promise_3": "void | Promise",
        "void_promise_4": "void | Promise",
        "auto_fill_account_numbers_5": "Auto-fill account numbers"
      },
      "BatchCreateCategoryModal": {
        "search_for_a_parent_category_1": "Search for a parent category...",
        "category_name_2": "Category Name",
        "account_optional_3": "Account # (optional)",
        "batch_create_categories_4": "Batch Create Categories",
        "batch_create_categories_5": "Batch Create Categories",
        "parent_category_6": "Parent Category",
        "create_categories_7": "Create Categories",
        "locked_cash_parent_blocked_error_7": "Cannot use Cash as a parent category. Add cash subaccounts under Cash and Cash Equivalents instead."
      },
      "BatchDeleteCategoryModal": {
        "enter_reason_for_deleting_these_categories_1": "Enter reason for deleting these categories...",
        "batch_delete_categories_2": "Batch Delete Categories",
        "batch_delete_categories_3": "Batch Delete Categories",
        "selected_categories_4": "Selected categories:",
        "reason_optional_5": "Reason (optional)"
      },
      "BatchImportCSVCategory": {
        "choose_csv_file_1": "Choose CSV file",
        "drop_csv_file_or_click_to_browse_2": "Drop .csv file or click to browse",
        "remove_file_3": "Remove file",
        "import_categories_from_csv_4": "Import Categories from CSV",
        "import_categories_from_csv_5": "Import Categories from CSV",
        "upload_csv_file_6": "Upload CSV file",
        "columns_name_parent_7": "Columns: Name, Parent. Optional: TreatAsCash (yes/true/1).",
        "name_required_8": "Name (required)",
        "browse_9": "browse",
        "accepts_csv_only_10": "Accepts .csv only",
        "errors_11": "Errors",
        "warnings_12": "Warnings",
        "resolve_parent_same_name_in_multiple_places_13": "Resolve parent (same name in multiple places)",
        "no_valid_categories_to_import_14": "No valid categories to import."
      },
      "Categories": {
        "promise_1": "Promise"
      },
      "CategoriesFiltersModal": {
        "filters_1": "Filters",
        "filters_2": "Filters",
        "hideWithoutBalanceLabel": "Hide unused categories",
        "hideWithoutBalanceHelp": "Hides categories that have never been used and have no balance in their subtree. Categories with a zero balance that already have activity stay visible. Root categories always stay visible, and parents of any shown subcategory are kept up to the root. Balances must finish loading before this filter takes effect.",
        "treatAsCashOnlyLabel": "Treat as cash only",
        "treatAsCashOnlyHelp": "Shows categories marked Treat as cash plus every ancestor up to the root so you can see where they live in the chart."
      },
      "CategoriesListPanel": {
        "clear_all_account_numbers_in_the_list_saved_when_1": "Clear all account numbers in the list (saved when you click Save)",
        "promise_2": "Promise",
        "loading_categories_3": "Loading categories...",
        "retry_4": "Retry"
      },
      "CategoryHistoryModal": {
        "rollback_category_1": "Rollback Category",
        "category_history_2": "Category History",
        "rollback_category_3": "Rollback Category",
        "category_history_4": "Category History",
        "loading_history_5": "Loading history...",
        "no_history_available_6": "No history available",
        "snapshot_7": "Snapshot",
        "current_8": "Current",
        "parent_9": "Parent:",
        "normal_balance_10": "Normal Balance:",
        "countsAsCashLabel": "Cash equivalent:",
        "countsAsCashYes": "Yes",
        "countsAsCashNo": "No"
      },
      "CategoryTableRow": {
        "view_category_1": "View category",
        "view_category_history_2": "View category history",
        "delete_category_3": "Delete category",
        "click_to_view_full_balance_4": "Click to view full balance",
        "ledger_balance_including_subcategories_5": "Ledger balance including subcategories",
        "clear_account_number_6": "Clear account number",
        "swap_account_number_with_sibling_above_7": "Swap account number with sibling above",
        "swap_account_number_with_sibling_below_8": "Swap account number with sibling below",
        "treatAsCashBadge": "Treat as cash"
      },
      "ClearAccountNumbersModal": {
        "clear_all_account_numbers_1": "Clear all account numbers",
        "clear_all_account_numbers_2": "Clear all account numbers"
      },
      "CategoriesModalsHost": {
        "addedSuccess": "Category added successfully",
        "batchCreatedSuccessOne": "Successfully created 1 category",
        "batchCreatedSuccessMany": "Successfully created {{count}} categories",
        "updatedSuccess": "Category updated successfully",
        "restoredSuccess": "{{name}} restored successfully",
        "deletedSuccess": "Category deleted successfully",
        "batchDeletedSuccessOne": "Successfully deleted 1 category",
        "batchDeletedSuccessMany": "Successfully deleted {{count}} categories",
        "rolledBackSuccess": "Category rolled back successfully",
        "clearedAccountNumbers": "Cleared {{count}} account number(s) in the list. Click Save to apply.",
        "noAccountNumbersToClear": "No account numbers to clear.",
        "countsAsCashBulkSuccess": "Cash treatment updated for selected categories."
      },
      "ClearCategoryAccountNumberModal": {
        "clear_account_number_1": "Clear account number",
        "clear_account_number_2": "Clear account number"
      },
      "shared": {
        "locked_cash_parent_blocked_error_1": "Cannot use Cash as a parent category. Add cash subaccounts under Cash and Cash Equivalents instead."
      },
      "EditCategoryModal": {
        "category_name_1": "Category Name",
        "search_for_a_parent_category_2": "Search for a parent category...",
        "e_g_1100_3": "e.g. 1100",
        "category_name_4": "Category Name",
        "category_name_5": "Category Name",
        "account_number_6": "Account number",
        "lockedCategoryHint": "This is a system category. Only the account number and cash treatment can be changed.",
        "countsAsCashLabel": "Treat as cash",
        "countsAsCashDescription": "Include this category in cash flow, cash balance, and cash-side journal pairing.",
        "countsAsCashClearedParentToast": "Treat as cash was cleared because the new parent is outside Current Assets.",
        "locked_cash_parent_blocked_error_7": "Cannot use Cash as a parent category. Add cash subaccounts under Cash and Cash Equivalents instead.",
        "voidedNameConflict": "This account title belongs to a voided category. Restore the existing category instead of renaming to it.",
        "restoreVoidedButton": "Restore voided category",
        "restoreVoidedConfirmTitle": "Restore voided category",
        "restoreVoidedConfirmSummary": "Review the voided category below. Restore puts it back on the chart with these details.",
        "restoreVoidedConfirmButton": "Restore",
        "restoreVoidedBackButton": "Back",
        "restoreVoidedNotFoundToast": "Voided category not found. Refresh and try again.",
        "restoringVoidedButton": "Restoring…",
        "parentCategoryLabel": "Parent Category"
      },
      "ViewCategoryModal": {
        "category_details_2": "Category Details",
        "category_details_3": "Category Details",
        "category_details_4": "Category Details",
        "loading_category_5": "Loading category...",
        "category_details_6": "Category Details",
        "account_7": "Account:",
        "parent_8": "Parent:",
        "root_category_9": "Root Category:",
        "normal_balance_10": "Normal Balance:",
        "countsAsCashLabel": "Treat as cash:",
        "countsAsCashYes": "Yes",
        "countsAsCashNo": "No",
        "locked_11": "Locked:",
        "has_history_12": "Has History:",
        "created_at_13": "Created At:",
        "updated_at_14": "Updated At:",
        "reassign_transactions_15": "Reassign transactions",
        "edit_category_button": "Edit Category",
        "reassign_transaction_button_16": "Reassign Transaction"
      },
      "ReassignCategoryTransactionsModal": {
        "choose_different_target_1": "Choose a different target category.",
        "confirm_message_2": "Move all transaction lines that use \"{{sourceName}}\" to \"{{targetName}}\"? Each affected transaction will get a history snapshot (same as editing a transaction).",
        "confirm_title_12": "Move transactions?",
        "confirm_button_13": "Move all lines",
        "success_message_3": "Updated {{transactionsUpdated}} transaction(s) ({{entriesMatched}} line(s) reassigned).",
        "error_fallback_4": "Failed to move transactions",
        "title_5": "Reassign transactions",
        "from_category_label_6": "From category:",
        "description_7": "Move every journal line that uses this category to another account. If a transaction already had a line for the target account, lines are merged (same as CSV import). Voided transactions and history snapshots are not changed.",
        "search_target_category_8": "Search target category…",
        "cancel_button_9": "Cancel",
        "moving_button_10": "Moving…",
        "move_button_11": "Move all lines to selected category"
      }
    },
    "transactions": {
      "voidModal": {
        "title": "Reverse Transaction",
        "descriptionLabel": "Description:",
        "dateLabel": "Date:",
        "totalAmountLabel": "Total Amount:",
        "reasonLabel": "Reason for reversing",
        "reasonPlaceholder": "Enter the reason for reversing this transaction...",
        "cannotVoidTitle": "Cannot reverse this transaction",
        "cannotVoidBodyPrefix": "This transaction cannot be reversed here because it was created by the",
        "cannotVoidBodyMiddle": "module. To modify or remove this transaction, please use the",
        "cannotVoidBodySuffix": "module instead.",
        "cancelButton": "Cancel",
        "confirmButton": "Post reversal",
        "confirmButtonPending": "Reversing...",
        "helperText": "The original entry stays on the books. A new opposite journal entry is posted to reverse it.",
        "reversalDateLabel": "Reversal date"
      },
      "restoreModal": {
        "title": "Restore Transaction",
        "intro": "Are you sure you want to restore this transaction? This will make the transaction active again.",
        "descriptionLabel": "Description:",
        "dateLabel": "Date:",
        "voidReasonLabel": "Void Reason:",
        "cancelButton": "Cancel",
        "confirmButton": "Restore",
        "confirmButtonPending": "Restoring..."
      },
      "rollbackModal": {
        "title": "Rollback Transaction",
        "emptyTitle": "Rollback Transaction",
        "emptyBody": "No available snapshots to rollback to.",
        "emptyCloseButton": "Close",
        "intro": "Select a snapshot to rollback to. This will create a new snapshot of the current state before applying the rollback.",
        "selectLabel": "Select Snapshot",
        "snapshotOptionLabel": "Snapshot {{number}} - {{date}} {{time}}{{descriptionSuffix}}",
        "descriptionLabel": "Description:",
        "dateLabel": "Date:",
        "totalAmountLabel": "Total Amount:",
        "snapshotDateLabel": "Snapshot Date:",
        "entriesLabel": "Entries:",
        "debitAbbrev": "Db",
        "creditAbbrev": "Cr",
        "unknownCategory": "Unknown Category",
        "cancelButton": "Cancel",
        "confirmButton": "Rollback"
      },
      "nonLeafIssuesModal": {
        "title": "Affected group accounts",
        "lead": "These accounts are parent folders or top-level groups. Journal lines must use a specific sub-account instead.",
        "meta": "{{groupCount}} {{groupLabel}} · {{transactionCount}} {{transactionLabel}} · {{lineCount}} {{lineLabel}}",
        "groupAccountSingular": "group account",
        "groupAccountPlural": "group accounts",
        "transactionSingular": "transaction",
        "transactionPlural": "transactions",
        "lineSingular": "line",
        "linePlural": "lines",
        "columnAccount": "Account",
        "columnIssue": "Issue",
        "columnLines": "Lines",
        "columnTransactions": "Transactions",
        "columnActionsAria": "Actions",
        "reassignButton": "Reassign",
        "transactionsSummary": "Transactions using \"{{categoryName}}\" ({{count}})",
        "closeButton": "Close",
        "chartOfAccountsLink": "Chart of accounts"
      },
      "list": {
        "companyContextLoading": "Loading company...",
        "noCompanySelected": "No company selected",
        "receiptUsageLoadError": "Unable to load receipt usage right now.",
        "toastNoGroupAccount": "No group account found on loaded transactions. Refresh and try again.",
        "toastReceiptVerified": "Receipt transaction verified.",
        "toastRollbackSuccess": "Transaction rolled back successfully",
        "toastRestoreSuccess": "Transaction restored successfully",
        "toastVoidSuccess": "Transaction voided successfully",
        "toastReverseSuccess": "Reversal journal entry posted. The original entry remains on the books.",
        "toastNoExportableRows": "No exportable transactions found.",
        "toastExportSuccess": "Exported {{rows}} transaction row(s) to CSV for import.",
        "toastExportFailedFallback": "Failed to export transactions.",
        "toastCompanyStillLoading": "Active company is still loading. Please try again.",
        "toastReceiptLimitReached": "Monthly receipt upload limit reached ({{used}}/{{limit}}).",
        "toastReceiptPartialUpload": "Only {{count}} receipt(s) can be uploaded right now ({{used}}/{{limit}} used this month).",
        "toastAddedFromReceipt": "Transaction added from receipt.",
        "toastAddedFromReceipts": "{{count}} transactions added from receipts.",
        "toastReceiptUploadPartialResult": "{{created}} uploaded, {{failed}} failed",
        "toastCreateFailedFallback": "Failed to create transaction",
        "accessDeniedTitle": "Access Denied",
        "accessDeniedMessage": "You do not have permission to view transactions.",
        "accessDeniedGoToDashboard": "Go to Dashboard",
        "pageTitle": "All Transactions",
        "refreshAriaLabel": "Refresh transactions",
        "refreshTitle": "Refresh",
        "refreshButton": "Refresh",
        "importExportAriaLabel": "Open import/export options",
        "importExportTitle": "Import/Export",
        "importExportButton": "Import/Export",
        "dateRangeAriaLabel": "Open date range filter",
        "dateRangeTitle": "Open date range filter",
        "dateRangeDialogAriaLabel": "Date range picker",
        "dateRangePrevMonthAriaLabel": "Previous month",
        "dateRangeNextMonthAriaLabel": "Next month",
        "dateRangeWeekdaySu": "Su",
        "dateRangeWeekdayMo": "Mo",
        "dateRangeWeekdayTu": "Tu",
        "dateRangeWeekdayWe": "We",
        "dateRangeWeekdayTh": "Th",
        "dateRangeWeekdayFr": "Fr",
        "dateRangeWeekdaySa": "Sa",
        "dateRangeClearButton": "Clear",
        "dateRangeApplyButton": "Apply",
        "quickRangesLabel": "Quick ranges",
        "newTransactionAriaLabel": "Create new transaction",
        "newTransactionTitle": "New Transaction",
        "newTransactionButton": "New Transaction",
        "statTotalLabel": "Total Transactions",
        "statSalesLabel": "Sales",
        "statExpensesLabel": "Expenses",
        "statOthersLabel": "Others",
        "statTotalInResultsSubtitle": "In results",
        "statSalesInResultsSubtitle": "In results",
        "statExpensesInResultsSubtitle": "In results",
        "statOthersInResultsSubtitle": "In results",
        "searchPlaceholder": "Search transactions by description, date, or category...",
        "includeVoidedToggle": "Include voided",
        "showAllDatesToggle": "Show all dates",
        "showOnlyTodayPastButton": "Show Only Today & Past",
        "showAllButton": "Show All",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "filterFromDateLabel": "From date",
        "filterToDateLabel": "To date",
        "clearFiltersButton": "Clear filters",
        "filtersAriaLabel": "Open filters",
        "categoryFilterChipPrefix": "Category:",
        "categoryFilterClearAriaLabel": "Clear category filter",
        "loadingTitle": "Loading Transactions...",
        "loadingDescription": "Please wait while we fetch your transactions.",
        "emptyTitle": "No Transactions Yet",
        "emptyDescriptionPrefix": "You haven't created any transactions yet. Get started by",
        "emptyAddLink": "Add New Transaction",
        "emptyDescriptionFallback": "adding transactions",
        "emptyDescriptionSuffix": ".",
        "errorPrefix": "Error:",
        "retryButton": "Retry",
        "noResultsMessage": "No transactions found matching your search or filters.",
        "paginationSummary": "Showing {{from}} to {{to}} of {{total}} transaction{{totalSuffix}}",
        "paginationPrevAriaLabel": "Previous page",
        "paginationNextAriaLabel": "Next page",
        "paginationRowsPerPageAriaLabel": "Rows per page",
        "paginationPageSizeOption": "{{size}} / page",
        "filterModalTitle": "Filters",
        "filterTypeLabel": "Type",
        "filterTypeAll": "All types",
        "filterKindLabel": "Kind",
        "filterKindAll": "All",
        "filterKindAssets": "Assets",
        "filterKindLiability": "Liability",
        "filterKindEquity": "Equity",
        "filterKindRevenue": "Revenue",
        "filterCategoryLabel": "Category",
        "filterCategoryPlaceholder": "All categories",
        "filterCategoryClearButton": "Clear",
        "filterMinAmountLabel": "Min amount",
        "filterMaxAmountLabel": "Max amount",
        "filterAmountPlaceholder": "0.00",
        "filterMaxAmountPlaceholder": "0.00",
        "filterUnverifiedReceiptToggle": "Unverified receipts",
        "promotionFiltersAriaLabel": "Promotion filters",
        "promotionFilterSales": "Sales Promotion",
        "promotionFilterExpense": "Expense Promotion",
        "promotionFilterEquipment": "PPE promotion",
        "promotionFilterBill": "Bill Promotion",
        "promotionFilterCapitals": "Capitals Promotion",
        "filterModalClearButton": "Clear",
        "filterModalApplyButton": "Apply",
        "importExportModalTitle": "Import or Export CSV",
        "importExportModalCompanyPrefix": "You are going to import/export transactions for:",
        "importExportModalPrompt": "Choose what you want to do.",
        "importExportImportButton": "Import CSV",
        "importExportExportButton": "Export CSV",
        "importExportModalCancelButton": "Cancel",
        "exportConfirmModalTitle": "Confirm export",
        "exportConfirmModalCompanyPrefix": "You are exporting transactions for:",
        "exportConfirmModalPrompt": "Export current transactions to CSV for import?",
        "exportConfirmModalCancelButton": "Cancel",
        "exportConfirmModalConfirmButton": "Export CSV",
        "addActionModalTitle": "Add Transaction",
        "addActionModalCompanyPrefix": "You are creating transaction for:",
        "addActionModalPrompt": "Choose what you want to do.",
        "addActionModalUploadReceiptButton": "Upload Receipt",
        "addActionModalManualEntryButton": "Manual Entry",
        "addActionModalReceiptUsagePrefix": "Receipt uploads this month:",
        "addActionModalReceiptUsageLoading": "Loading...",
        "addActionModalReceiptUsageUnavailable": "Unavailable",
        "addActionModalRetryButton": "Retry",
        "addActionModalCancelButton": "Cancel",
        "toastVerifyReceiptFailed": "Failed to verify receipt",
        "toastGenericError": "An error occurred",
        "toastUploadReceiptFailed": "Failed to upload receipt.",
        "toastUnsupportedFileType": "Unsupported file type: {{fileName}}. Upload raster image files only (e.g. JPEG, PNG, WebP, AVIF, TIFF, BMP).",
        "toastBrokenPdfFile": "Broken or corrupted PDF file: {{files}}.",
        "toastNoImagesProduced": "\"{{fileName}}\" produced no images to upload.",
        "nonLeafBannerTitle": "Action required: {{transactionCount}} {{transactionLabel}} {{verb}} using group accounts{{groupAccountSuffix}}.",
        "nonLeafBannerVerbIs": "is",
        "nonLeafBannerVerbAre": "are",
        "nonLeafBannerGroupAccountSuffix": " ({{count}} group account{{countSuffix}} involved)",
        "nonLeafBannerLead": "To keep your reporting accurate, entries cannot be booked directly to a parent folder or summary group.",
        "nonLeafBannerChoicesLabel": "Choose a solution to fix this:",
        "nonLeafBannerViewAffectedAccounts": "View affected accounts",
        "nonLeafBannerViewAffectedHint": " to see which group accounts and transactions are involved.",
        "nonLeafBannerReassignEntries": "Reassign affected entries",
        "nonLeafBannerReassignHint": " to a specific sub-account{{startingWithSuffix}}.",
        "nonLeafBannerReassignStartingWithSuffix": " (starting with \"{{name}}\")",
        "nonLeafBannerModifyChartOfAccounts": "Modify your Chart of Accounts",
        "nonLeafBannerModifyChartHint": " to manage or remove nested subcategories.",
        "uploadProgressTitle": "Uploading receipts ({{current}}/{{total}})",
        "uploadProgressStagePreparing": "Preparing file",
        "uploadProgressStageConverting": "Converting PDF pages",
        "uploadProgressStageUploading": "Uploading to server",
        "uploadProgressStageProcessing": "AI is analyzing receipt",
        "uploadProgressSuccessLabel": "Success: {{count}}",
        "uploadProgressFailedLabel": "Failed: {{count}}",
        "uploadProgressEtaLabel": "ETA:",
        "uploadProgressEtaCalculating": "calculating...",
        "uploadProgressEtaFinishing": "finishing...",
        "receiptVerifyModalTitle": "Verify receipt transaction",
        "receiptVerifyModalAttachmentCheckTitle": "Attachment check",
        "receiptVerifyModalAttachmentTitle": "Attachment",
        "receiptVerifyModalDateLabel": "Date:",
        "receiptVerifyModalDescriptionLabel": "Description:",
        "receiptVerifyModalDebitAbbrev": "DR",
        "receiptVerifyModalCreditAbbrev": "CR",
        "receiptVerifyModalTotalPhpLabel": "Total (PHP)",
        "receiptVerifyModalQuestion": "Is the extracted receipt information correct?",
        "receiptVerifyModalEditButton": "Edit",
        "receiptVerifyModalConfirmButton": "Confirm",
        "receiptVerifyModalConfirmingButton": "Confirming..."
      },
      "modernTable": {
        "columnDate": "Date",
        "columnReferenceNumber": "Ref. No.",
        "columnType": "Type",
        "columnDescription": "Description",
        "columnCategory": "Category",
        "columnAmount": "Amount",
        "columnActions": "Actions",
        "journalEntryFallback": "-",
        "lineCount": "{{count}} line{{countSuffix}}",
        "needVerificationAriaLabel": "Need verification",
        "needVerificationTitle": "Need verification",
        "viewAriaLabel": "View transaction",
        "viewTitle": "View",
        "editAriaLabel": "Edit transaction",
        "editTitle": "Edit",
        "voidAriaLabel": "Void transaction",
        "voidTitle": "Void",
        "voidedBadge": "Voided",
        "reversedBadge": "Reversed",
        "cancelledBillTooltip": "This transaction is linked to a cancelled bill.",
        "editVoidedTitle": "Cannot edit voided transaction",
        "editReversedTitle": "Cannot edit a reversed transaction",
        "alreadyVoidedTitle": "Already voided",
        "alreadyReversedTitle": "Already reversed"
      },
      "add": {
        "wizardTitle": "New Custom Entry",
        "toastNoIdReturned": "Transaction save returned no id. Please try again and contact support if this persists.",
        "toastAttachmentsSkippedUnsupported": "unsupported: {{files}}",
        "toastAttachmentsSkippedBrokenPdf": "broken/corrupted PDF: {{files}}",
        "toastSomeAttachmentsSkipped": "Some attachments were skipped ({{details}}).",
        "toastAddedSuccess": "Transaction added successfully",
        "toastAddedWithAttachmentWarning": "Transaction added (see attachment warning above).",
        "duplicateSimilarTitle": "Similar transaction",
        "duplicateForceSubmit": "Force submit",
        "duplicatePendingLabel": "Saving...",
        "saveAsCustomTransactionButton": "Save as custom transaction",
        "saveAsCustomTransactionPending": "Saving...",
        "cdjRedirectModal": {
          "title": "Record this on Expenses instead?",
          "message": "This custom entry looks like a cash expense (cash or treat-as-cash accounts with expense accounts only). For OR#, supplier, tags, and attachments, use New Expense. You can still save it here as a custom transaction if you prefer.",
          "changeEntriesButton": "Change entries",
          "moveToExpensesButton": "Move to Expenses"
        },
        "crjRedirectModal": {
          "title": "Record this on Sales instead?",
          "message": "This custom entry looks like a cash receipt (cash or treat-as-cash accounts with revenue accounts only). For OR#, customer, tags, and attachments, use New Sale. You can still save it here as a custom transaction if you prefer.",
          "changeEntriesButton": "Change entries",
          "moveToSalesButton": "Move to Sales"
        },
        "apBillRedirectModal": {
          "title": "Record this on Bills instead?",
          "message": "This custom entry looks like an AP bill accrual (Expenses + Accounts Payable). For supplier, reference number, dates, tags, and attachments, use Bills. You can still save it here as a custom transaction if you prefer.",
          "changeEntriesButton": "Change entries",
          "moveToBillsButton": "Move to Bills"
        },
        "capitalRedirectModal": {
          "title": "Record this on Capitals instead?",
          "message": "This custom entry looks like an owner capital movement (Cash or Expenses + Equity). For the full capital workflow, use New Capital Entry. You can still save it here as a custom transaction if you prefer.",
          "changeEntriesButton": "Change entries",
          "moveToCapitalsButton": "Move to Capitals"
        },
        "equipmentRedirectModal": {
          "title": "Record this on PPE instead?",
          "message": "This custom entry looks like a PPE acquisition (an account directly under Property, Plant and Equipment plus cash or treat-as-cash). For the full asset record, use Add PPE. You can still save it here as a custom transaction if you prefer.",
          "depreciationMessage": "This custom entry pairs an account under Property, Plant and Equipment with a depreciation account. Depreciation is usually recorded from the PPE module. You can still save it here as a custom transaction if you prefer.",
          "changeEntriesButton": "Change entries",
          "moveToEquipmentButton": "Move to PPE"
        }
      },
      "edit": {
        "loadingMessage": "Loading transaction...",
        "notFoundTitle": "Transaction not found",
        "backToTransactions": "Back",
        "cannotEditVoidedTitle": "Cannot edit voided transaction",
        "cannotEditReversedTitle": "Cannot edit a reversed transaction",
        "backToTransaction": "Back",
        "toastNoChanges": "No changes to save.",
        "toastLoadFailed": "Failed to load transaction",
        "toastAttachmentsSkippedUnsupported": "unsupported: {{files}}",
        "toastAttachmentsSkippedBrokenPdf": "broken/corrupted PDF: {{files}}",
        "toastSomeAttachmentsSkipped": "Some attachments were skipped ({{details}}).",
        "toastUpdatedSuccess": "Transaction updated successfully",
        "toastUpdatedWithAttachmentWarning": "Transaction updated (see attachment warning above).",
        "toastCouldNotIdentifyAttachment": "Could not identify attachment.",
        "confirmDeleteAttachment": "Delete this attachment on save? It will only be deleted after you save this edit.",
        "toastAttachmentMarkedForDeletion": "Attachment marked for deletion. Save to apply.",
        "wizardTitle": "Edit Transaction",
        "confirmDeleteAttachmentTitle": "Delete attachment?",
        "confirmDeleteAttachmentButton": "Delete"
      },
      "view": {
        "loadingMessage": "Loading transaction...",
        "notFoundTitle": "Transaction not found",
        "back": "Back",
        "backToTransactions": "Back",
        "restoredNote": "Last restored {{date}}{{reasonSuffix}}",
        "restoredReasonSuffix": " — {{reason}}",
        "title": "Transaction View",
        "cashReceiptsJournalBannerPrefix": "This transaction is linked to",
        "cashReceiptsJournalBannerLink": "Cash Receipts Journal",
        "cashReceiptsJournalBannerSuffix": ". Edit or void the receipt from that journal.",
        "cashDisbursementsJournalBannerPrefix": "This transaction is linked to",
        "cashDisbursementsJournalBannerLink": "Cash Disbursements Journal",
        "cashDisbursementsJournalBannerSuffix": ". Edit or void the disbursement from that journal.",
        "billsLedgerBannerPrefix": "This transaction is linked to",
        "billsLedgerBannerLink": "Bill Details",
        "billsLedgerBannerSuffix": ". Edit or void the bill from that ledger.",
        "fxRevaluationBannerPrefix": "This transaction is linked to",
        "fxRevaluationBannerLink": "FX revaluation entry",
        "fxRevaluationBannerSuffix": ". View it from the FX Revaluations journal.",
        "cancelledBillTooltip": "This transaction is linked to a cancelled bill.",
        "capitalBannerPrefix": "This transaction is linked to",
        "capitalBannerLink": "Capitals {{bookReference}}",
        "capitalBannerLinkFallback": "Capitals",
        "capitalBannerSuffix": ". Edit or void the entry from that module.",
        "equipmentBannerPrefix": "This transaction is linked to",
        "equipmentBannerLink": "PPE",
        "equipmentBannerSuffix": ". Edit or void the asset from that module.",
        "equipmentDepreciationBannerPrefix": "This transaction is linked to",
        "equipmentDepreciationBannerLink": "Depreciation entry",
        "equipmentDepreciationBannerSuffix": ". Edit or void it from that module.",
        "arInvoiceBannerPrefix": "This transaction is linked to",
        "arInvoiceBannerLink": "Invoice Details",
        "arInvoiceBannerSuffix": ". Edit or void the invoice from that module.",
        "cancelledArInvoiceTooltip": "This transaction is linked to a cancelled invoice.",
        "reversedBanner": "This transaction was reversed.",
        "viewLinkedReversalTransaction": "See linked reversal transaction",
        "reversalEntryBanner": "This entry reverses another transaction.",
        "viewLinkedOriginalTransaction": "See original transaction",
        "metadata": {
          "sectionTitle": "Record info",
          "status": "Status",
          "statusActive": "Active",
          "statusVoided": "Voided",
          "statusReversed": "Reversed",
          "referenceNumber": "Reference no.",
          "created": "Created",
          "createdBy": "Created by",
          "lastUpdated": "Last updated",
          "updatedBy": "Updated by",
          "voided": "Voided",
          "voidedBy": "Voided by",
          "voidReason": "Void reason",
          "lastRestored": "Last restored",
          "restoreReason": "Restore reason",
          "versionHistory": "Version history",
          "versionHistoryAvailable": "Available"
        },
        "referenceNumberLabel": "Reference no.:",
        "createdByLabel": "Created by:",
        "updatedByLabel": "Updated by:",
        "voidedByLabel": "Voided by:",
        "historyAriaLabel": "Transaction history and versions",
        "historyButton": "History",
        "applyingVersionButton": "Applying...",
        "useThisVersionButton": "Use this version",
        "editButton": "Edit",
        "deletingButton": "Deleting...",
        "deleteButton": "Delete",
        "descriptionMustEditInModuleToast": "The description must be edited in {{module}}.",
        "descriptionEditOriginalModuleFallback": "the original module",
        "toastMissingOriginalId": "Unable to apply this version: missing original transaction id.",
        "confirmApplyVersion": "Replace the current transaction with this version? A snapshot of the current state will be kept.",
        "confirmApplyVersionTitle": "Apply this version?",
        "confirmApplyVersionButton": "Use this version",
        "toastVersionApplied": "Version applied successfully",
        "toastApplyVersionFailed": "Failed to apply version",
        "toastLoadFailed": "Failed to load transaction",
        "toastDeleteFailed": "Failed to delete transaction",
        "promoteCalloutTitle": "Record in a journal",
        "promoteCalloutMessage": "This custom entry can be added to an operational journal without posting again.",
        "promoteCalloutAriaLabel": "Journal promotion options",
        "promoteToCdjButton": "Add to Expenses list",
        "promoteToCrjButton": "Add to Sales list",
        "promoteToApBillButton": "Add to Bills list",
        "promoteToCapitalButton": "Add to Capitals list",
        "promoteToEquipmentButton": "Add to PPE list",
        "toastPromotedToCdjSuccess": "Added to Expenses list. Edit or void this expense from Expenses.",
        "toastPromotedToCdjViewExpense": "View expense",
        "toastPromoteToCdjFailed": "Could not add this transaction to Expenses.",
        "toastPromotedToCrjSuccess": "Added to Sales list. Edit or void this sale from Sales.",
        "toastPromotedToCrjViewSale": "View sale",
        "toastPromoteToCrjFailed": "Could not add this transaction to Sales.",
        "toastPromotedToApBillSuccess": "Added to Bills list. Pay or cancel this bill from Bills.",
        "toastPromotedToApBillViewBill": "View bill",
        "toastPromoteToApBillFailed": "Could not add this transaction to Bills.",
        "toastPromotedToCapitalSuccess": "Added to Capitals list. Edit or void this entry from Capitals.",
        "toastPromotedToCapitalViewEntry": "View capital entry",
        "toastPromoteToCapitalFailed": "Could not add this transaction to Capitals.",
        "toastPromotedToEquipmentSuccess": "Added to PPE list. Edit or void this asset from PPE.",
        "toastPromotedToEquipmentViewAsset": "View PPE",
        "toastPromoteToEquipmentFailed": "Could not add this transaction to PPE.",
        "toastPromoteAttachmentsFailed": "Promotion succeeded, but attachments could not be saved. Add them from the promoted entry.",
        "promoteToCdjModal": {
          "title": "Add to Expenses list",
          "message": "This custom entry looks like a cash expense. Enter an OR# to create a linked Expenses (CDJ) row without posting again.",
          "dateLabel": "Date:",
          "descriptionLabel": "Description:",
          "descriptionFieldLabel": "Description",
          "descriptionPlaceholder": "What was purchased or paid for?",
          "descriptionRequired": "Description is required.",
          "descriptionTooLong": "Description must be at most 500 characters.",
          "amountLabel": "Amount:",
          "orLabel": "OR#",
          "orPlaceholder": "Official receipt or voucher number",
          "orSuggestedPlaceholder": "e.g. {{value}}",
          "orSuggestionPill": "Use {{value}}",
          "supplierLabel": "Supplier name",
          "supplierPlaceholder": "Select supplier…",
          "supplierHelper": "Optional. Links this expense to a supplier for reporting.",
          "supplierNotFound": "Selected supplier was not found. Choose another supplier.",
          "tagsLabel": "Tags",
          "tagsHelper": "Optional. Tag this expense for filtering and reports.",
          "cancelButton": "Cancel",
          "submitButton": "Add to Expenses",
          "submittingButton": "Adding…"
        },
        "promoteToCrjModal": {
          "title": "Add to Sales list",
          "message": "This custom entry looks like a cash receipt. Enter an OR# to create a linked Sales (CRJ) row without posting again.",
          "dateLabel": "Date:",
          "descriptionLabel": "Description:",
          "descriptionFieldLabel": "Description",
          "descriptionPlaceholder": "What was sold or collected?",
          "descriptionRequired": "Description is required.",
          "descriptionTooLong": "Description must be at most 500 characters.",
          "amountLabel": "Amount:",
          "orLabel": "OR#",
          "orPlaceholder": "Official receipt or voucher number",
          "orSuggestedPlaceholder": "e.g. {{value}}",
          "orSuggestionPill": "Use {{value}}",
          "customerLabel": "Customer name",
          "customerPlaceholder": "Select customer…",
          "customerHelper": "Optional. Links this sale to a customer for reporting.",
          "customerNotFound": "Selected customer was not found. Choose another customer.",
          "tagsLabel": "Tags",
          "tagsHelper": "Optional. Tag this sale for filtering and reports.",
          "cancelButton": "Cancel",
          "submitButton": "Add to Sales",
          "submittingButton": "Adding…"
        },
        "promoteToApBillModal": {
          "title": "Add to Bills list",
          "message": "This custom entry looks like an AP bill accrual. Enter bill details to create a linked Bills row without posting again.",
          "dateLabel": "Date:",
          "expenseCategoryLabel": "Bill category:",
          "descriptionLabel": "Description:",
          "descriptionFieldLabel": "Description",
          "descriptionPlaceholder": "What is this bill for?",
          "descriptionRequired": "Description is required.",
          "amountLabel": "Amount:",
          "referenceNumberLabel": "Reference number",
          "referenceNumberPlaceholder": "Supplier invoice or bill number",
          "supplierLabel": "Supplier",
          "supplierPlaceholder": "Select supplier…",
          "supplierRequired": "Supplier is required.",
          "supplierNotFound": "Selected supplier was not found. Choose another supplier.",
          "invoiceDateLabel": "Issue date",
          "dueDateLabel": "Due date",
          "datesRequired": "Issue date and due date are required.",
          "tagsLabel": "Tags",
          "tagsHelper": "Optional. Tag this bill for filtering and reports.",
          "cancelButton": "Cancel",
          "submitButton": "Add to Bills",
          "submittingButton": "Adding…"
        },
        "promoteToCapitalModal": {
          "title": "Add to Capitals list",
          "message": "This custom entry looks like an owner capital movement. Confirm details to create a linked Capitals row without posting again.",
          "amountLabel": "Amount:",
          "capitalTypeLabel": "Capital type:",
          "subTypeLabel": "Sub-type:",
          "counterpartyCategoryLabel": "Account:",
          "descriptionLabel": "Description:",
          "descriptionFieldLabel": "Description",
          "descriptionPlaceholder": "Brief note about this owner equity movement",
          "descriptionRequired": "Description is required.",
          "descriptionTooLong": "Description must be at most 500 characters.",
          "entryDateLabel": "Entry date",
          "entryDateHelper": "Capital entry date (currently {{date}}).",
          "cancelButton": "Cancel",
          "submitButton": "Add to Capitals",
          "submittingButton": "Adding…"
        },
        "promoteToEquipmentModal": {
          "title": "Add to PPE list",
          "message": "This custom entry looks like a PPE acquisition. Enter asset details to create a linked PPE row without posting again.",
          "amountLabel": "Amount:",
          "equipmentCategoryLabel": "Equipment account:",
          "sourceCategoryLabel": "Source account:",
          "descriptionLabel": "Description:",
          "descriptionFieldLabel": "Description",
          "descriptionPlaceholder": "Brief note about this PPE purchase",
          "descriptionRequired": "Description is required.",
          "descriptionTooLong": "Description must be at most 2000 characters.",
          "nameLabel": "Asset name",
          "nameRequired": "Asset name is required.",
          "nameTooLong": "Asset name must be at most 255 characters.",
          "usefulLifeLabel": "Useful life (years)",
          "usefulLifeInvalid": "Useful life must be between 1 and 100 years.",
          "salvageValueLabel": "Salvage value",
          "salvageValueInvalid": "Enter a valid salvage value.",
          "salvageValueTooHigh": "Salvage value must be less than the acquisition amount.",
          "acquisitionDateLabel": "Acquisition date",
          "acquisitionDateHelper": "PPE acquisition date (currently {{date}}).",
          "cancelButton": "Cancel",
          "submitButton": "Add to PPE",
          "submittingButton": "Adding…"
        }
      },
      "listHistory": {
        "title": "Transaction History",
        "loadingMessage": "Loading history...",
        "emptyMessage": "No history available",
        "currentBadge": "Current",
        "snapshotBadge": "Snapshot",
        "rollbackButton": "Rollback",
        "dateLabel": "Date:",
        "totalAmountLabel": "Total Amount:",
        "entriesLabel": "Entries:",
        "debitAbbrev": "Db",
        "creditAbbrev": "Cr",
        "unknownCategory": "Unknown Category",
        "toastRollbackSuccess": "Transaction rolled back successfully",
        "toastRollbackFailed": "Failed to rollback transaction",
        "toastLoadFailed": "Failed to load transaction history"
      },
      "viewHistory": {
        "title": "Transaction history",
        "versionPreviewTitle": "Version preview",
        "closeAriaLabel": "Close",
        "backToVersionListAriaLabel": "Back to version list",
        "externalModuleWarning": "This transaction is linked to {{sourceType}}. Void, restore, and version rollback for it must be done from that module, not from the general transaction screen.",
        "loadingPreview": "Loading preview…",
        "loading": "Loading…",
        "loadPreviewFailed": "Failed to load this version",
        "loadHistoryFailed": "Failed to load history",
        "viewOtherVersionButton": "View other version",
        "useThisVersionButton": "Use this version",
        "applyingButton": "Applying…",
        "noOlderVersionsMessage": "No older saved versions yet. Editing or voiding this transaction creates saved versions you can return to. If the transaction is voided, you can undo void below.",
        "previewVersionAriaLabel": "Preview saved version #{{versionNumber}}",
        "noDescriptionFallback": "(no description)",
        "undoVoidButton": "Undo void",
        "undoReasonLabel": "Reason (optional)",
        "undoReasonPlaceholder": "Why are you restoring this transaction?",
        "cancelButton": "Cancel",
        "restoreBusyButton": "Restoring…",
        "confirmUndoVoidButton": "Confirm undo void",
        "invalidTransactionId": "Invalid transaction id. Please refresh and try again.",
        "invalidVersionId": "Invalid version id. Please refresh and try again.",
        "confirmApplyVersion": "Replace the current transaction with this version? A snapshot of the current state will be kept.",
        "confirmApplyVersionTitle": "Apply this version?",
        "confirmApplyVersionButton": "Use this version",
        "toastVersionApplied": "Version applied successfully",
        "restoreFailed": "Restore failed",
        "applyVersionFailed": "Failed to apply this version",
        "closeButton": "Close"
      },
      "transactionListUi": {
        "typeBadgeSale": "Sales",
        "typeBadgeExpense": "Expense",
        "typeBadgeOther": "Others",
        "paymentMethodSales": "Sales",
        "paymentMethodPos": "POS",
        "paymentMethodDisbursement": "Disbursement",
        "paymentMethodCashReceiptsJournal": "Cash receipts",
        "paymentMethodCashDisbursementsJournal": "Cash disbursement",
        "paymentMethodReceipt": "Receipt",
        "paymentMethodInventory": "Inventory",
        "paymentMethodApBill": "Bills",
        "paymentMethodApBillPayment": "Bill payment",
        "paymentMethodApBillFxRevaluation": "Bill FX revaluation",
        "paymentMethodEquipment": "PPE",
        "paymentMethodEquipmentDepreciation": "PPE depreciation",
        "paymentMethodCapital": "Capitals",
        "paymentMethodManualEntry": "Manual entry",
        "primaryCategoryEmpty": "—",
        "dateRangeAllDates": "All dates",
        "dateRangeSameMonth": "{{month}} {{fromDay}} – {{toDay}}, {{year}}",
        "dateRangeCrossMonth": "{{fromMonth}} {{fromDay}}, {{fromYear}} – {{toMonth}} {{toDay}}, {{toYear}}"
      },
      "batchImport": {
        "triggerButton": "Import",
        "modalTitle": "Import Transactions from CSV",
        "companyContextPrefix": "You are importing transactions for:",
        "noCompanySelected": "No company selected",
        "uploadLabel": "Upload CSV file",
        "formatNote": "Columns: Date, Amount, Category, Type. Description is optional. Any date format. Min 2 entries; debits = credits.",
        "formatColumnDate": "Date (any format)",
        "formatColumnDescription": "Description (optional)",
        "formatColumnAmount": "Amount (positive)",
        "formatColumnCategory": "Category (exact name; use \"Name (Parent)\" if duplicated)",
        "formatColumnType": "Type (debit or credit)",
        "chooseFileAriaLabel": "Choose CSV file",
        "dropZoneAriaLabel": "Drop .csv file or click to browse",
        "dropZoneText": "Drag and drop your .csv file here, or",
        "dropZoneBrowse": "browse",
        "dropZoneHint": "Accepts .csv only",
        "removeFileAriaLabel": "Remove file",
        "validatingLabel": "Validating…",
        "errorsHeading": "Errors:",
        "warningsHeading": "Warnings:",
        "moreItems": "… and {{count}} more",
        "missingCategoriesHeading": "Missing categories in this company:",
        "missingCategoryRows": "(rows: {{rows}})",
        "selectParentTitle": "Select parent manually for unresolved categories:",
        "noParentInCsv": " (no parent in CSV)",
        "selectParentPlaceholder": "Select parent category",
        "approveMissingCategoriesLabel": "I approve creating these missing categories in this company BEFORE IMPORTING.",
        "duplicateMergeTitle": "Duplicate category lines",
        "duplicateMergeServerOnlyNote": "The server reported transactions that list the same category more than once (the local preview did not flag them). ",
        "duplicateMergeCountNote": "{{count}} transaction{{countSuffix}} repeat the same category on multiple lines. ",
        "duplicateMergeBody": "Import will merge those lines into one entry per category (net debit or credit). You can adjust transactions in the app after import.",
        "approveDuplicateMergeLabel": "I approve merging duplicate category lines before importing.",
        "resolveAmbiguousTitle": "Resolve category (same name in multiple parents)",
        "chooseCategoryAriaLabel": "Choose category for \"{{category}}\"",
        "undoResolveAriaLabel": "Undo resolve for \"{{category}}\"",
        "undoResolveTitle": "Undo",
        "markResolvedAriaLabel": "Mark \"{{category}}\" as resolved",
        "markResolvedTitle": "Mark as resolved",
        "closeButton": "Close",
        "importButton": "Import",
        "importingButton": "Importing…",
        "toastCsvOnly": "Please upload a .csv file.",
        "toastUploadFirst": "Upload a CSV file first.",
        "toastApproveMissingCategories": "Please approve creating missing categories.",
        "toastApproveDuplicateMerge": "Please approve merging duplicate category lines.",
        "toastImportSuccess": "Successfully imported {{transactions}} transaction(s) and created {{categories}} category(ies){{warningSuffix}}.",
        "toastImportSuccessWarningSuffix": " with {{count}} warning(s)",
        "toastImportFailed": "Import failed.",
        "toastReadFileFailed": "Failed to read file.",
        "parseErrorCsvHeaderAndDataRequired": "CSV must have a header row and at least one data row.",
        "parseErrorCsvHeaderColumnsRequired": "CSV header must include Date, Amount, Category, and Type columns. Description is optional.",
        "parseErrorRowMissingDate": "Row {{row}}: missing date.",
        "parseErrorRowAmountPositive": "Row {{row}}: amount must be positive.",
        "parseErrorRowMissingCategory": "Row {{row}}: missing category.",
        "parseErrorRowTypeDebitOrCredit": "Row {{row}}: type must be \"debit\" or \"credit\".",
        "parseErrorRowExpectedColumnsWithDesc": "Row {{row}}: expected at least 5 columns (Date, Description, Amount, Category, Type).",
        "parseErrorRowExpectedColumnsWithoutDesc": "Row {{row}}: expected at least 4 columns (Date, Amount, Category, Type).",
        "parseWarningCategoryParentIncorrect": "Category \"{{category}}\": parent \"{{parent}}\" is incorrect or misspelled.",
        "parseWarningCategoryAmbiguous": "Category \"{{category}}\" has the same name in other categories; use \"Name (Parent)\" to specify, e.g. {{examples}}.",
        "parseErrorTransactionValidation": "Transaction \"{{title}}\": {{message}}",
        "parseErrorTransactionMinEntries": "Transaction \"{{title}}\" must have at least 2 entries.",
        "parseErrorTransactionNotBalanced": "Transaction \"{{title}}\" is not balanced (debits: {{debits}}, credits: {{credits}}).",
        "parseErrorRowPreviousTransactionUnbalanced": "Row {{row}}: previous transaction on date \"{{date}}\" is not balanced. Add missing counterpart row before changing date.",
        "parseErrorRowsStartingAtNotBalanced": "Rows starting at {{row}}: transaction is not balanced (debits: {{debits}}, credits: {{credits}}).",
        "parseErrorRowDateMismatchCurrentTransaction": "Row {{row}}: date \"{{rowDate}}\" does not match current transaction date \"{{currentDate}}\". Balance the current transaction before changing date."
      },
      "BatchImportCSVTransactions": {
        "2_diff_1": "= 2 && diff"
      },
      "Transactions": {
        "0_c_1": "= '0' && c"
      },
      "View": {
        "TransactionViewHistoryModal": {
          "promise_1": "Promise",
          "endpoint_string_data_record_2": "(endpoint: string, data?: Record",
          "promise_3": "Promise"
        }
      },
      "TransactionEmptyDescriptionModal": {
        "title": "Save without description?",
        "message": "You are saving this transaction without a description. Do you want to continue?",
        "quickInputLabel": "Add a description (optional)",
        "cancelButton": "Cancel",
        "confirmSave": "Confirm save",
        "saveWithDescription": "Save with description",
        "saving": "Saving…"
      }
    },
    "cashReceiptsJournal": {
      "list": {
        "pageTitle": "Cash Received List",
        "summaryHint": "View all cash receipts, use the filters to find specific entries. Record a new receipt or import multiple receipts."
      },
      "BatchImportCSVCashReceiptsJournal": {
        "choose_csv_file_1": "Choose CSV file",
        "drop_csv_file_or_click_to_browse_2": "Drop .csv file or click to browse",
        "remove_file_3": "Remove file",
        "import_receipts_from_csv_4": "Import receipts from CSV",
        "import_csv_5": "Import CSV",
        "import_receipts_from_csv_6": "Import receipts from CSV",
        "or_7": "OR#",
        "date_8": "Date",
        "description_9": "Description",
        "amount_10": "Amount",
        "category_11": "Category",
        "or_must_be_unique_among_active_receipts_in_this__12": "OR# must be unique among active receipts in this company",
        "amount_must_be_positive_with_at_most_2_decimal_p_13": "Amount must be positive with at most 2 decimal places",
        "upload_csv_file_14": "Upload CSV file",
        "browse_15": "browse",
        "accepts_csv_only_16": "Accepts .csv only",
        "errors_17": "Errors"
      },
      "CashReceiptsJournalEntryModal": {
        "recordTitle": "Record Sales",
        "editTitle": "Edit receipt",
        "recordSubtitle": "Type each cash receipt details here instead of writing it in your manual books. Enter the OR# manually."
      },
      "CashReceiptsJournalCreate": {
        "record_receipt_1": "Record Sales",
        "record_subtitle_2": "Type each cash receipt details here instead of writing it in your manual books. Enter the OR# manually.",
        "back_to_sales_list_3": "Back",
        "helpButtonAria": "What is Sales?"
      },
      "SalesFeatureTip": {
        "title": "What is Sales?",
        "intro": "Sales is your digital cash receipts journal. Use it to record money your business receives from customers—one entry per official receipt, instead of writing each sale only in a paper book.",
        "bulletOr": "Enter the OR# (official receipt number), date, description, sales category, and amount for each cash sale.",
        "bulletCategory": "Choose a sales category under Revenue so the sale is grouped correctly in your books.",
        "bulletLedger": "Each recorded sale creates a transaction: Cash is debited and your sales revenue account is credited.",
        "bulletReports": "Cash receipts appear on the Cash Received List and flow into your financial reports.",
        "outro": "Use this page when a customer pays you in cash (or you treat the receipt as a cash sale) and you want that receipt tracked in AbraFi."
      },
      "CashReceiptsJournalEdit": {
        "receipt_not_found_1": "Sale not found.",
        "edit_receipt_2": "Edit Sale",
        "back_to_sales_list_3": "Back",
        "edit_subtitle_4": "Changes void the current sale and create a corrected replacement linked to the original."
      },
      "CashReceiptsJournalEntryForm": {
        "replaceEditInfoBanner": "Editing will void this original record and automatically generate a linked replacement sale.",
        "useSuggestedValueLink": "Use {{value}}",
        "orSuggestedPlaceholder": "e.g. {{value}}",
        "e_g_1042_1": "e.g. 1042",
        "orLastRecordedLabel": "Last recorded",
        "orLastRecordedAria": "Last recorded OR number: {{orNumber}}",
        "orSuggestedLabel": "Suggested",
        "orManualEntryHelper": "Enter the official receipt number from your receipt book (manual).",
        "select_date_2": "Select date",
        "dateSuggestedLabel": "Suggested",
        "dateToday": "Today",
        "dateYesterday": "Yesterday",
        "dateLastSale": "Last sale ({{date}})",
        "dateDayAfterLastSale": "Day after last sale ({{date}})",
        "customer_item_sold_or_note_from_your_book_3": "Customer, item sold, or note from your book",
        "descriptionLabel": "Description",
        "descriptionEditOnDetailsHint": "Description is read-only here. Edit it on the sale details page.",
        "loading_4": "Loading…",
        "revenueAccountLabel": "Revenue Account",
        "revenueAccountPlaceholder": "Select Sales or Accounts Receivable…",
        "categorySuggestedLabel": "Suggested",
        "amountSuggestedLabel": "Suggested",
        "amount_php_6": "Amount (PHP)",
        "amount_recorded_php_11": "Amount recorded (PHP)",
        "amount_recorded_calculation_hint_12": "Amount recorded is calculated from the {{currency}} amount and exchange rate.",
        "use_foreign_currency_7": "Use foreign currency",
        "no_changes_to_save_6": "No changes to save",
        "valid_positive_amount_validation_8": "Enter a valid positive amount.",
        "valid_positive_amount_submit_9": "Enter a valid positive amount.",
        "sales_cash_payment_hint_10": "Deposit into Cash, bank, or any account marked Treat as cash.",
        "depositAccountLabel": "Deposit to",
        "depositAccountPlaceholder": "Select cash or cash equivalent",
        "depositLinesLabel": "Deposit lines",
        "addDepositLine": "Add line",
        "removeDepositLine": "Remove",
        "depositLineAmountLabel": "Amount",
        "depositLinesTotal": "Deposit total: {{amount}}",
        "depositDuplicateAccount": "Each deposit line must use a different account.",
        "depositLineRequired": "Add at least one deposit line.",
        "depositAccountRequired": "Select a deposit account for each line.",
        "depositLineAmountInvalid": "Enter a valid positive amount for each deposit line.",
        "revenueLinesLabel": "Revenue lines",
        "addRevenueLine": "Add line",
        "removeRevenueLine": "Remove",
        "revenueAmountLabel": "Revenue amount",
        "revenueLineRequired": "Add at least one revenue line.",
        "revenueAccountRequired": "Select a revenue account for each line.",
        "revenueAmountInvalid": "Enter a valid positive revenue amount for each line.",
        "revenueDuplicateAccount": "Each revenue line must use a different revenue account.",
        "revenueLinesTotal": "Revenue total: {{amount}}",
        "amountRecordedPhpInline": "Amount recorded (PHP): {{amount}}",
        "revenueLinesTotalMismatch": "Revenue line amounts must total the sale amount.",
        "insufficientArBalanceSingle": "Crediting {{creditAmount}} to {{accountName}} would bring the receivable balance to {{projectedBalance}} as of {{date}}. Available receivable before this receipt: {{ledgerBalance}}.",
        "insufficientArBalanceMultipleHeader": "These Accounts Receivable accounts would go negative on your books as of {{date}}:",
        "insufficientArBalanceMultipleLine": "{{accountName}}: {{ledgerBalance}} − {{creditAmount}} = {{projectedBalance}}",
        "insufficientArBalanceLineAccount": "This Accounts Receivable account does not have enough receivable balance for this credit.",
        "arBalanceLookupFailed": "Could not verify Accounts Receivable balances. Check your connection and try again.",
        "splitLinesBalancedStatus": "Deposit and revenue lines are balanced.",
        "splitLinesUnbalancedStatus": "Out of balance by {{difference}}.",
        "splitLinesBalanceDetail": "Deposits: {{depositTotal}} · Revenue: {{revenueTotal}}",
        "totalAmountLabel": "Total amount (PHP)",
        "totalAmountHint": "Calculated from deposit line amounts. This is the sale amount recorded.",
        "fxAmountInvalid": "Enter a valid foreign amount and exchange rate for this receipt.",
        "createCashCategoryParentHint": "Parent must be Current Assets, Cash and Cash Equivalents, or an account under them. Treat as cash is enabled for bank accounts and e-wallets.",
        "createSalesCategoryParentHint": "Parent must be Sales or an account under the Sales category.",
        "customerNameLabel": "Customer name",
        "customerNamePlaceholder": "Search or add customer…",
        "customerNameHelper": "Optional. Type a new name to add address, TIN, contact, and email.",
        "customer_not_found_submit_11": "Selected customer could not be found. Refresh and try again.",
        "customer_not_found_submit_10": "Selected customer could not be found. Refresh and try again.",
        "tagsLabel": "Tags",
        "tagsHelper": "Optional labels to filter this sale later (for example, neighbor or online)."
      },
      "CashReceiptsJournalEmptyDescriptionModal": {
        "title": "Save without description?",
        "message": "You are saving this transaction without a description. Do you want to continue?",
        "quickInputLabel": "Add a description (optional)",
        "cancelButton": "Cancel",
        "confirmSave": "Confirm save",
        "saveWithDescription": "Save with description",
        "saving": "Saving…"
      },
      "AddSalesCustomerModal": {
        "title": "Add customer",
        "nameLabel": "Customer name",
        "nameRequired": "Customer name is required.",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "contactLabel": "Contact number",
        "emailLabel": "Email",
        "cancel": "Cancel",
        "save": "Save customer",
        "saving": "Saving…",
        "createFailed": "Could not create customer.",
        "invalidEmail": "Enter a valid email address."
      },
      "CashReceiptsJournalHistoryModal": {
        "why_are_you_restoring_this_receipt_1": "Why are you restoring this receipt?",
        "back_to_version_list_2": "Back to version list",
        "close_3": "Close",
        "close_4": "Close",
        "back_to_version_list_5": "Back to version list",
        "close_6": "Close",
        "receipt_history_7": "Receipt history",
        "loading_preview_8": "Loading preview…",
        "date_9": "Date",
        "or_10": "OR#",
        "description_11": "Description",
        "amount_12": "Amount",
        "status_13": "Status",
        "voided_14": "Voided",
        "loading_15": "Loading…",
        "no_saved_versions_yet_16": "No saved versions yet",
        "reason_optional_17": "Reason (optional)",
        "undoVoidButton": "Undo void",
        "repostNotice": "This keeps the voided sale and its ledger transaction unchanged. A new sale and a new ledger transaction will be created with the same details.",
        "repostConfirm": "Confirm undo void",
        "repostPending": "Creating new sale…",
        "emptyHistoryRepostHint": "When you edit or void this sale, earlier versions are saved here. If this sale is voided, you can undo the void below to record a new sale instead.",
        "confirmApplyVersionTitle": "Apply this version?",
        "confirmApplyVersionMessage": "Replace the current receipt with this version? A snapshot of the current state will be kept.",
        "confirmApplyVersionButton": "Use this version",
        "confirmApplyVersionPending": "Applying…"
      },
      "CashReceiptsJournalView": {
        "record_info_1": "Record info",
        "invalid_receipt_link_2": "Invalid receipt link.",
        "loading_receipt_3": "Loading receipt…",
        "view_cash_receipt_4": "Cash Received Details",
        "voided_5": "Voided",
        "or_6": "OR#",
        "bookReferenceNumber": "Book ref. #",
        "date_7": "Date",
        "amount_8": "Amount",
        "revenue_account_9": "Revenue account",
        "revenue_lines_22": "Sales categories",
        "deposit_to_20": "Deposit to",
        "deposit_lines_21": "Deposit lines",
        "customer_name_15": "Customer name",
        "customer_tin_16": "TIN: {{tin}}",
        "customer_address_17": "Address: {{address}}",
        "party_empty_18": "—",
        "description_10": "Description",
        "editDescriptionAriaLabel": "Edit sale description",
        "tags_19": "Tags",
        "record_info_11": "Record info",
        "back_to_sales_list_12": "Back",
        "voiding_sale_13": "Voiding…",
        "void_sale_link_14": "Void sale",
        "seeLinkedVoidedSale": "See linked voided sale",
        "seeRepostedSale": "See reposted sale",
        "undoVoid": "Undo void",
        "repostingSale": "Creating new sale…",
        "viewLinkedTransaction": "View Linked Transaction {{referenceNumber}}",
        "viewLinkedTransactionFallback": "View linked transaction",
        "linkedCapitalBannerPrefix": "This cash receipt is linked to a capital entry.",
        "linkedCapitalBannerLink": "Capitals {{bookReference}}",
        "linkedCapitalBannerLinkFallback": "Capitals",
        "linkedCapitalBannerSuffix": "to void or replace the investment.",
        "linkedArInvoicePaymentBannerPrefix": "This cash receipt is linked to an invoice payment.",
        "linkedArInvoicePaymentBannerLink": "Invoice Payments {{bookReference}}",
        "linkedArInvoicePaymentBannerLinkFallback": "Invoice Payments",
        "linkedArInvoicePaymentBannerSuffix": "to cancel the collection.",
        "actionBlockedLinkedCapital": "This cash receipt is linked to Capitals {{bookReference}}. Edit or void it from Capitals instead.",
        "actionBlockedLinkedCapitalFallback": "This cash receipt is linked to a capital entry. Edit or void it from Capitals instead.",
        "actionBlockedLinkedArInvoicePayment": "This cash receipt is linked to Invoice Payments {{bookReference}}. Cancel it from Invoice Payments instead.",
        "actionBlockedLinkedArInvoicePaymentFallback": "This cash receipt is linked to an invoice payment. Cancel it from Invoice Payments instead."
      },
      "RestoreReceiptModal": {
        "why_are_you_restoring_this_receipt_1": "Why are you reposting this sale?",
        "undo_void_2": "Undo void",
        "undo_void_3": "Undo void",
        "description_4": "Description:",
        "date_5": "Date:",
        "or_6": "OR#:",
        "amount_7": "Amount:",
        "repostNotice": "The voided sale and its ledger transaction stay voided. Undo void creates a new sale and a new ledger transaction with the same details.",
        "reasonLabel": "Reason (optional)",
        "cancelButton": "Cancel",
        "repostConfirm": "Confirm undo void",
        "repostPending": "Creating new sale…"
      },
      "VoidReceiptModal": {
        "enter_the_reason_for_voiding_this_receipt_1": "Enter the reason for voiding this receipt…",
        "void_receipt_2": "Void receipt",
        "void_receipt_3": "Void receipt",
        "description_4": "Description:",
        "date_5": "Date:",
        "or_6": "OR#:",
        "amount_7": "Amount:",
        "reasonLabel": "Reason for voiding",
        "cancelButton": "Cancel",
        "confirmButton": "Void receipt",
        "voidingButton": "Voiding…"
      },
      "CashReceiptsJournalList": {
        "search_by_description_date_or_or_amount_1": "Search by book ref (CR-001), description, OR#, or amount…",
        "receipt_history_2": "Sale history",
        "edit_receipt_3": "Edit sale",
        "void_receipt_4": "Void sale",
        "receipt_history_5": "Sale history",
        "edit_receipt_6": "Edit sale",
        "void_receipt_7": "Void sale",
        "history_8": "History",
        "history_9": "History",
        "active_10": "Active",
        "from_date_11": "From date",
        "to_date_12": "To date",
        "revenueAccountColumn": "Revenue Account",
        "all_accounts_14": "All accounts",
        "tags_filter_label_44": "Tags",
        "tags_filter_all_45": "Any tag",
        "include_voided_15": "Include voided",
        "loading_16": "Loading…",
        "error_17": "Error:",
        "date_18": "Date",
        "colBookReference": "Ref. #",
        "description_19": "Description",
        "voided_20": "Voided",
        "voided_21": "Voided",
        "amount_22": "Amount",
        "record_sales_23": "Record Sales",
        "no_sales_recorded_yet_25": "No sales recorded yet",
        "record_first_sale_26": "Record your first sale",
        "no_sales_match_search_and_filters_27": "No sales match your search and filters.",
        "no_sales_match_search_28": "No sales match your search.",
        "no_sales_match_filters_29": "No sales match your filters.",
        "no_voided_sales_match_filters_30": "No voided sales match your filters.",
        "sales_per_page_31": "Sales per page",
        "mobile_card_fallback_title_32": "Sale",
        "voided_sales_cannot_be_edited_33": "Voided sales cannot be edited",
        "sale_date_in_locked_period_34": "Sale date is in a locked period",
        "refreshing_journal_35": "Refreshing Cash Received List…",
        "customer_column_41": "Customer",
        "party_empty_42": "—",
        "description_empty_43": "—",
        "edit_action_title_36": "Edit",
        "already_voided_title_37": "Already voided",
        "void_action_title_38": "Void",
        "sale_date_in_locked_period_void_39": "Sale date is in a locked period",
        "quick_ranges_label_40": "Quick ranges",
        "edit_blocked_external_title": "Edit from Capitals or Invoice Payments",
        "void_blocked_external_title": "Void from Capitals or Invoice Payments",
        "actionBlockedLinkedCapital": "This cash receipt is linked to Capitals {{bookReference}}. Edit or void it from Capitals instead.",
        "actionBlockedLinkedCapitalFallback": "This cash receipt is linked to a capital entry. Edit or void it from Capitals instead.",
        "actionBlockedLinkedArInvoicePayment": "This cash receipt is linked to Invoice Payments {{bookReference}}. Cancel it from Invoice Payments instead.",
        "actionBlockedLinkedArInvoicePaymentFallback": "This cash receipt is linked to an invoice payment. Cancel it from Invoice Payments instead."
      }
    },
    "cashDisbursementJournal": {
      "list": {
        "pageTitle": "Expenses List",
        "summaryHint": "View all expenses, use the filters to find specific expenses. Record a new expense or import multiple expenses."
      },
      "BatchImportCSVCashDisbursementJournal": {
        "choose_csv_file_1": "Choose CSV file",
        "drop_csv_file_or_click_to_browse_2": "Drop .csv file or click to browse",
        "remove_file_3": "Remove file",
        "import_payments_from_csv_4": "Import expenses from CSV",
        "import_csv_5": "Import CSV",
        "import_payments_from_csv_6": "Import expenses from CSV",
        "or_7": "OR#",
        "date_8": "Date",
        "description_9": "Description",
        "amount_10": "Amount",
        "category_11": "Category",
        "or_must_be_unique_among_active_payments_in_this__12": "OR# must be unique among active payments in this company",
        "amount_must_be_positive_with_at_most_2_decimal_p_13": "Amount must be positive with at most 2 decimal places",
        "upload_csv_file_14": "Upload CSV file",
        "browse_15": "browse",
        "accepts_csv_only_16": "Accepts .csv only",
        "errors_17": "Errors"
      },
      "CashDisbursementJournalHistoryModal": {
        "why_are_you_restoring_this_disbursement_1": "Why are you reposting this expense?",
        "back_to_version_list_2": "Back to version list",
        "close_3": "Close",
        "close_4": "Close",
        "back_to_version_list_5": "Back to version list",
        "close_6": "Close",
        "disbursement_history_7": "Disbursement history",
        "loading_preview_8": "Loading preview…",
        "date_9": "Date",
        "or_10": "OR#",
        "description_11": "Description",
        "amount_12": "Amount",
        "status_13": "Status",
        "voided_14": "Voided",
        "loading_15": "Loading…",
        "no_saved_versions_yet_16": "No saved versions yet",
        "reason_optional_17": "Reason (optional)",
        "undoVoidButton": "Undo void",
        "repostNotice": "The voided expense and its ledger transaction stay voided. Undo void creates a new expense and a new ledger transaction with the same details.",
        "repostConfirm": "Confirm undo void",
        "repostPending": "Creating new expense…",
        "confirmApplyVersionTitle": "Apply this version?",
        "confirmApplyVersionMessage": "Replace the current disbursement with this version? A snapshot of the current state will be kept.",
        "confirmApplyVersionButton": "Use this version",
        "confirmApplyVersionPending": "Applying…"
      },
      "CashDisbursementsJournalCreate": {
        "record_disbursement_1": "Record Expense",
        "record_subtitle_2": "Type each expense here instead of writing it in your manual books. Enter the OR# manually.",
        "back_to_expenses_list_3": "Back",
        "helpButtonAria": "What is Expenses?"
      },
      "ExpensesFeatureTip": {
        "title": "What is Expenses?",
        "intro": "Expenses is your digital cash disbursements journal. Use it to record money your business pays out—one entry per receipt or voucher, instead of logging each payment only in a paper book.",
        "bulletOr": "Enter the OR# or voucher number (use N/A when there is no official number), plus date, description, expense category, and amount.",
        "bulletCategory": "Choose an expense or asset category so the payment is grouped correctly in your books.",
        "bulletLedger": "Each recorded expense creates a transaction: the expense or asset account is debited and Cash is credited.",
        "bulletReports": "Expenses appear on the Expenses List and flow into your financial reports.",
        "outro": "Use this page when you pay cash (or record a cash disbursement) and want that payment tracked in AbraFi."
      },
      "CashDisbursementsJournalEdit": {
        "disbursement_not_found_1": "Expense not found.",
        "edit_disbursement_2": "Edit Expense",
        "back_to_expenses_list_3": "Back",
        "edit_subtitle_4": "Changes void the current expense and create a corrected replacement linked to the original."
      },
      "CashDisbursementsJournalEmptyDescriptionModal": {
        "title": "Save without description?",
        "message": "You are saving this expense without a description. Do you want to continue?",
        "quickInputLabel": "Add a description (optional)",
        "cancelButton": "Cancel",
        "confirmSave": "Confirm save",
        "saveWithDescription": "Save with description",
        "saving": "Saving…"
      },
      "CashDisbursementsJournalEntryForm": {
        "replaceEditInfoBanner": "Editing will void this original record and automatically generate a linked replacement expense.",
        "useSuggestedValueLink": "Use {{value}}",
        "orSuggestedPlaceholder": "e.g. {{value}}",
        "e_g_1042_1": "e.g. 1042",
        "orLastRecordedLabel": "Last recorded",
        "orLastRecordedAria": "Last recorded OR number: {{orNumber}}",
        "orSuggestedLabel": "Suggested",
        "orManualEntryHelper": "Enter the official receipt / voucher number from your disbursement book (manual).",
        "select_date_2": "Select date",
        "dateSuggestedLabel": "Suggested",
        "dateToday": "Today",
        "dateYesterday": "Yesterday",
        "dateLastExpense": "Last expense ({{date}})",
        "dateDayAfterLastExpense": "Day after last expense ({{date}})",
        "customer_item_sold_or_note_from_your_book_3": "What was purchased or paid for?",
        "descriptionLabel": "Description",
        "descriptionEditOnDetailsHint": "Description is read-only here. Edit it on the expense details page.",
        "loading_4": "Loading…",
        "expenseAccountLabel": "Expense Account",
        "categorySuggestedLabel": "Suggested",
        "amountSuggestedLabel": "Suggested",
        "amount_php_6": "Amount (PHP)",
        "use_foreign_currency_7": "Use foreign currency",
        "valid_positive_amount_validation_8": "Enter a valid positive amount.",
        "valid_positive_amount_submit_9": "Enter a valid positive amount.",
        "expense_cash_payment_hint_10": "Pay from Cash, bank, any account marked Treat as cash, or Withholding Taxes Payable.",
        "paymentAccountLabel": "Pay from",
        "paymentAccountPlaceholder": "Select cash, cash equivalent, or withholding taxes payable",
        "createCashCategoryParentHint": "Parent must be Current Assets, Cash and Cash Equivalents, or an account under them. Treat as cash is enabled for bank accounts and e-wallets.",
        "createExpenseCategoryParentHint": "Parent must be Expenses or an account under the Expenses category.",
        "supplierNameLabel": "Supplier name",
        "supplierNamePlaceholder": "Search or add supplier…",
        "supplierNameHelper": "Optional. Type a new name to add address, TIN, contact, and email.",
        "amount_recorded_php_11": "Amount recorded (PHP)",
        "amount_recorded_calculation_hint_12": "Amount recorded is calculated from the {{currency}} amount and exchange rate.",
        "expenseLinesLabel": "Expense lines",
        "addExpenseLine": "Add line",
        "removeExpenseLine": "Remove",
        "expenseAmountLabel": "Expense amount",
        "expenseLineRequired": "Add at least one expense line.",
        "expenseAccountRequired": "Select an expense account for each line.",
        "expenseAmountInvalid": "Enter a valid positive expense amount for each line.",
        "expenseLineAmountInvalid": "Enter a valid expense amount greater than zero.",
        "expenseDuplicateAccount": "Each expense line must use a different expense account.",
        "expenseLinesTotal": "Expense total: {{amount}}",
        "paymentLinesLabel": "Pay from",
        "addPaymentLine": "Add line",
        "removePaymentLine": "Remove",
        "paymentAmountLabel": "Payment amount",
        "paymentLinesTotal": "Pay from total: {{amount}}",
        "amountRecordedPhpInline": "Amount recorded (PHP): {{amount}}",
        "paymentLineRequired": "Add at least one pay-from line.",
        "paymentAccountRequired": "Select a pay-from account for each line.",
        "paymentLineAmountInvalid": "Enter a valid positive amount for each pay-from line.",
        "paymentDuplicateAccount": "Each pay-from line must use a different account.",
        "withholdingTaxDetailsLabel": "Expanded withholding tax",
        "needsBir2307Label": "Do you need a BIR Form 2307 for this expense?",
        "needsBir2307Help": "Turn this on when you withhold expanded withholding tax from the supplier and will issue Form 2307. The pay-from lines split automatically into cash and Withholding Taxes Payable.",
        "withholdingTaxRateLabel": "Withholding tax rate",
        "withholdingTaxRatePlaceholder": "Select rate",
        "withholdingTaxRateOthers": "Others",
        "withholdingTaxCustomRateLabel": "Custom rate (%)",
        "withholdingTaxCustomRatePlaceholder": "e.g. 3",
        "withholdingTaxRateRequired": "Select a withholding tax rate for Form 2307.",
        "withholdingTaxComputedRequired": "Enter a valid gross income payment and rate so tax withheld can be calculated.",
        "withholdingTaxPayableCategoryMissing": "Withholding Taxes Payable account is missing. Refresh categories or contact support.",
        "withholdingTaxToggleOffCleanup": "Turn on BIR Form 2307 or clear withholding tax details and the Withholding Taxes Payable pay-from line.",
        "withholdingTaxWithheldLabel": "Tax withheld (PHP)",
        "withholdingTaxWithheldPlaceholder": "Calculated from rate",
        "bir2307SupplierRequired": "Select a supplier before saving an expense that needs Form 2307.",
        "bir2307SupplierTinModalTitle": "Supplier TIN required for Form 2307",
        "bir2307SupplierTinModalBody": "This expense needs BIR Form 2307. Add the supplier’s TIN before saving so the payee section and accounting entry stay complete.",
        "bir2307CompanyBirModalTitle": "Company BIR details required for Form 2307",
        "bir2307CompanyBirModalBody": "Complete your company BIR taxpayer profile (TIN, address, and ZIP code) before recording an expense that needs Form 2307.",
        "bir2307RequirementsModalClose": "Close",
        "bir2307EditSupplierButton": "Edit supplier",
        "bir2307EditCompanyBirButton": "Edit company BIR profile",
        "bir2307SupplierUpdatedToast": "Supplier updated. You can save the expense again.",
        "withholdingTaxAtcLabel": "ATC",
        "withholdingTaxAtcPlaceholder": "e.g. WC-158",
        "withholdingTaxBaseAmountLabel": "Gross income payment (PHP)",
        "withholdingTaxBaseAmountPlaceholder": "0.00",
        "withholdingTaxDetailsHelp": "Gross income payment defaults to the expense total (PHP). Tax withheld is calculated from the rate and posted to Withholding Taxes Payable for Form 2307 and QAP.",
        "withholdingTaxDetailsOptionalHelp": "Optional. Turn on BIR Form 2307 above to record expanded withholding tax.",
        "withholdingTaxAtcRequired": "Enter the ATC for this withholding tax.",
        "withholdingTaxBaseAmountRequired": "Enter the gross income payment subject to withholding tax.",
        "withholdingTaxAmountExceedsBase": "Withholding tax cannot exceed the gross income payment.",
        "withholdingTaxPaymentLineRequired": "Add a Withholding Taxes Payable line under Pay from before entering withholding details.",
        "splitLinesBalancedStatus": "Expense and pay-from lines are balanced.",
        "splitLinesUnbalancedStatus": "Out of balance by {{difference}}.",
        "splitLinesBalanceDetail": "Expenses: {{expenseTotal}} · Pay from: {{paymentTotal}}",
        "splitLinesTotalMismatch": "Pay-from line amounts must total the expense amount.",
        "totalAmountLabel": "Total amount (PHP)",
        "totalAmountHint": "Calculated from expense line amounts. This is the expense amount recorded.",
        "fxAmountInvalid": "Enter a valid foreign amount and exchange rate for this disbursement.",
        "no_changes_to_save_6": "No changes to save",
        "supplier_not_found_submit_13": "Selected supplier could not be found. Refresh and try again.",
        "insufficientCashWarningTitle": "Insufficient ledger cash balance",
        "insufficientCashWarningSingle": "Paying {{paymentAmount}} from {{accountName}} would bring the ledger balance to {{projectedBalance}} as of {{date}}. Balance on your books before this payment: {{ledgerBalance}}.",
        "insufficientCashWarningMultipleHeader": "These Pay from accounts would go negative on your books as of {{date}}:",
        "insufficientCashWarningMultipleLine": "{{accountName}}: {{ledgerBalance}} − {{paymentAmount}} = {{projectedBalance}}",
        "insufficientCashWarningProceed": "Save anyway",
        "tagsLabel": "Tags",
        "tagsHelper": "Optional labels to filter this expense later (for example, project or vendor type)."
      },
      "AddExpenseSupplierModal": {
        "title": "Add supplier",
        "nameLabel": "Supplier name",
        "nameRequired": "Supplier name is required.",
        "addressLabel": "Address",
        "tinLabel": "TIN",
        "contactLabel": "Contact number",
        "emailLabel": "Email",
        "cancel": "Cancel",
        "save": "Save supplier",
        "saving": "Saving…",
        "createFailed": "Could not create supplier.",
        "invalidEmail": "Enter a valid email address."
      },
      "CashDisbursementsJournalView": {
        "record_info_1": "Record info",
        "invalid_disbursement_link_2": "Invalid disbursement link.",
        "loading_disbursement_3": "Loading disbursement…",
        "view_cash_disbursement_4": "Expense Details",
        "voided_5": "Voided",
        "or_6": "OR#",
        "bookReferenceNumber": "Book ref. #",
        "date_7": "Date",
        "amount_8": "Amount",
        "expense_account_9": "Expense account",
        "expense_lines_20": "Expense lines",
        "payment_account_21": "Pay from",
        "issue2307": "Issue BIR Form 2307",
        "generate2307Link": "Generate BIR Form 2307",
        "withholdingTax": "Expanded withholding tax",
        "supplier_name_15": "Supplier name",
        "supplier_tin_16": "TIN: {{tin}}",
        "supplier_address_17": "Address: {{address}}",
        "party_empty_18": "—",
        "description_10": "Description",
        "editDescriptionAriaLabel": "Edit expense description",
        "tags_19": "Tags",
        "record_info_11": "Record info",
        "back_to_expenses_list_12": "Back",
        "voiding_expense_13": "Voiding…",
        "void_expense_link_14": "Void expense",
        "undoVoid": "Undo void",
        "repostingExpense": "Creating new expense…",
        "seeLinkedVoidedExpense": "See linked voided expense",
        "seeRepostedExpense": "See reposted expense",
        "attachmentsMissingTransaction": "This expense has no linked transaction to attach files to.",
        "billsLedgerBannerPrefix": "This expense is linked to",
        "billsLedgerBannerLink": "Bill Details",
        "billsLedgerBannerSuffix": ". Edit or void the bill from the Bills ledger.",
        "viewLinkedTransaction": "View Linked Transaction {{referenceNumber}}",
        "viewLinkedTransactionFallback": "View linked transaction",
        "linkedBillPaymentBannerPrefix": "This expense is linked to a bill payment.",
        "linkedBillPaymentBannerLink": "Bill Payments {{bookReference}}",
        "linkedBillPaymentBannerLinkFallback": "Bill Payments",
        "linkedBillPaymentBannerSuffix": " to cancel the payment.",
        "linkedCapitalBannerPrefix": "This expense is linked to a capital withdrawal.",
        "linkedCapitalBannerLink": "Capitals {{bookReference}}",
        "linkedCapitalBannerLinkFallback": "Capitals",
        "linkedCapitalBannerSuffix": " to void or replace the withdrawal.",
        "linkedEquipmentBannerPrefix": "This expense is linked to a PPE cash purchase.",
        "linkedEquipmentBannerLink": "PPE {{bookReference}}",
        "linkedEquipmentBannerLinkFallback": "PPE",
        "linkedEquipmentBannerSuffix": " to cancel the acquisition.",
        "linkedPurchaseOrderBannerPrefix": "This expense is linked to a cash purchase order.",
        "linkedPurchaseOrderBannerLink": "Purchase order {{bookReference}}",
        "linkedPurchaseOrderBannerLinkFallback": "Purchase order",
        "linkedPurchaseOrderBannerSuffix": " to void the order."
      },
      "RestoreDisbursementModal": {
        "why_are_you_restoring_this_disbursement_1": "Why are you reposting this expense?",
        "undo_void_2": "Undo void",
        "undo_void_3": "Undo void",
        "repostNotice": "The voided expense and its ledger transaction stay voided. Undo void creates a new expense and a new ledger transaction with the same details.",
        "repostConfirm": "Confirm undo void",
        "repostPending": "Creating new expense…",
        "description_4": "Description:",
        "date_5": "Date:",
        "or_6": "OR#:",
        "amount_7": "Amount:"
      },
      "VoidDisbursementModal": {
        "enter_the_reason_for_voiding_this_disbursement_1": "Enter the reason for voiding this disbursement…",
        "void_disbursement_2": "Void disbursement",
        "description_3": "Description:",
        "date_4": "Date:",
        "or_5": "OR#:",
        "amount_6": "Amount:",
        "reasonLabel": "Reason for voiding",
        "referenceLabel": "Reference:",
        "amountLabel": "Amount:",
        "cancelButton": "Cancel",
        "confirmButton": "Void disbursement",
        "voidingButton": "Voiding…"
      },
      "CashDisbursementJournalList": {
        "search_by_description_date_or_or_amount_1": "Search by book ref (CD-001), description, OR#, or amount…",
        "payment_history_2": "Expense history",
        "edit_payment_3": "Edit expense",
        "void_payment_4": "Void expense",
        "payment_history_5": "Expense history",
        "edit_payment_6": "Edit expense",
        "void_payment_7": "Void expense",
        "history_8": "History",
        "history_9": "History",
        "active_10": "Active",
        "from_date_11": "From date",
        "to_date_12": "To date",
        "expense_account_13": "Expense Category",
        "all_accounts_14": "All accounts",
        "tags_filter_label_44": "Tags",
        "tags_filter_all_45": "Any tag",
        "include_voided_15": "Include voided",
        "loading_16": "Loading…",
        "error_17": "Error:",
        "date_18": "Date",
        "colBookReference": "Ref. #",
        "description_19": "Description",
        "voided_20": "Voided",
        "voided_21": "Voided",
        "amount_22": "Amount",
        "record_expense_23": "Record Expense",
        "no_expenses_recorded_yet_25": "No expenses recorded yet",
        "record_first_expense_26": "Record your first expense",
        "no_expenses_match_search_and_filters_27": "No expenses match your search and filters.",
        "no_expenses_match_search_28": "No expenses match your search.",
        "no_expenses_match_filters_29": "No expenses match your filters.",
        "no_voided_expenses_match_filters_30": "No voided expenses match your filters.",
        "expenses_per_page_31": "Expenses per page",
        "mobile_card_fallback_title_32": "Expense",
        "voided_expenses_cannot_be_edited_33": "Voided expenses cannot be edited",
        "expense_date_in_locked_period_34": "Expense date is in a locked period",
        "refreshing_journal_35": "Refreshing Expenses List…",
        "supplier_column_41": "Supplier",
        "party_empty_42": "—",
        "description_empty_43": "—",
        "edit_action_title_36": "Edit",
        "already_voided_title_37": "Already voided",
        "void_action_title_38": "Void",
        "expense_date_in_locked_period_void_39": "Expense date is in a locked period",
        "bill_managed_edit_blocked_46": "This expense was recorded from Bills. Edit it from the Bills ledger.",
        "bill_managed_void_blocked_47": "This expense was recorded from Bills. Void it from the Bills ledger.",
        "bill_details_link_48": "Open bill details",
        "quick_ranges_label_40": "Quick ranges",
        "externally_sourced_edit_blocked": "This expense is linked to another journal. Open the source record to edit or void it.",
        "externally_sourced_void_blocked": "This expense is linked to another journal. Open the source record to void it.",
        "external_source_link": "Open source record"
      }
    },
    "ReceiptImageTab": {
      "documentTitle": "Receipt"
    },
    "shop": {
      "pageTitle": "Online Shop",
      "hubSubtitle": "Manage your online shop, its public handle, and whether it is live.",
      "subtitle": "{{count}} products available in your shop",
      "loading": "Loading…",
      "retry": "Try again",
      "refresh": "Refresh",
      "loadFailed": "Failed to load your online shop.",
      "searchPlaceholder": "Search products…",
      "searchAriaLabel": "Search shop products",
      "empty": "No products in your shop yet. Import existing products from POS.",
      "emptySearch": "No products match your search.",
      "table": {
        "name": "Product",
        "category": "Category",
        "price": "Price"
      },
      "claim": {
        "title": "Set up your online shop",
        "text": "Choose a handle to create your public shop address. Customers will visit your shop at online-shop/your-handle."
      },
      "handle": {
        "urlLabel": "Shop URL",
        "edit": "Edit handle",
        "inputLabel": "Handle",
        "placeholder": "your-handle",
        "checking": "Checking availability…",
        "available": "Available",
        "unavailableGeneric": "This handle is not available.",
        "previewLabel": "Your shop URL:",
        "rulesHint": "3–63 characters. Lowercase letters, numbers and single hyphens; must start and end with a letter or number.",
        "cancel": "Cancel",
        "save": "Save handle",
        "saving": "Saving…",
        "saveFailed": "Failed to save handle.",
        "saved": "Shop handle saved."
      },
      "live": {
        "title": "Shop live status",
        "stateLive": "Live",
        "stateOffline": "Offline",
        "descLive": "Your shop is live and reachable by the public.",
        "descOffline": "Your shop is offline and hidden from the public.",
        "descLiveDynamic": "Your shop is currently online. To hide your catalog and stop receiving new orders, toggle to go offline.",
        "descOfflineDynamic": "Your shop is currently offline. To publish your catalog and start accepting new orders, toggle to go online.",
        "nowLive": "Your shop is now live.",
        "nowOffline": "Your shop is now offline.",
        "toggleFailed": "Failed to update live status."
      },
      "actions": {
        "manageProducts": "Manage products",
        "manageProductsDesc": "Manage your products in POS.",
        "openInPos": "Manage products",
        "manageOrders": "Manage Orders"
      },
      "logs": {
        "title": "Recent shop activity",
        "loading": "Loading activity…",
        "loadFailed": "Failed to load shop activity.",
        "empty": "No shop activity yet."
      },
      "timeline": {
        "title": "Timeline",
        "subtitle": "Who changed this shop and when.",
        "searchPlaceholder": "Search activity...",
        "searchAriaLabel": "Search activity logs",
        "by": "By {{name}}",
        "changedFields": "Changed fields",
        "noSearchMatch": "No activity matches your search."
      },
      "products": {
        "title": "Manage products",
        "back": "Back to shop",
        "backAriaLabel": "Back to online shop"
      },
      "import": {
        "title": "Import products from POS",
        "description": "Select existing POS products to list in your shop.",
        "loading": "Loading products…",
        "loadFailed": "Failed to load products.",
        "empty": "All eligible products are already in your shop.",
        "searchPlaceholder": "Search products…",
        "searchAriaLabel": "Search products to import",
        "selectAll": "Select all",
        "cancel": "Cancel",
        "importing": "Importing…",
        "confirm": "Import {{count}} product(s)",
        "success": "{{count}} product(s) added to your shop.",
        "failed": "Failed to import products."
      }
    },
    "shopCart": {
      "title": "Your Cart",
      "itemCount": "{{count}} item(s)",
      "shopSubtotal": "Subtotal ({{count}} item(s))",
      "totalItems": "Total items",
      "grandTotal": "Total (all shops)",
      "checkoutTitle": "Checkout",
      "backToCart": "Back to cart",
      "placeAllOrders": "Place all orders",
      "placingOrders": "Placing orders…",
      "ordersPlacedTitle": "Orders placed!",
      "ordersPlacedText": "Your orders have been placed. Each shop fulfils its own order — track them from each shop's order history.",
      "orderNumberLabel": "Order #{{orderNumber}}",
      "viewOrder": "View order",
      "checkoutFailed": "Some orders could not be placed: {{shops}}"
    },
    "shopOnlineShop": {
      "title": "Online Shop",
      "subtitle": "Browse products from every shop",
      "loading": "Loading products…",
      "loadFailed": "Failed to load the online shop.",
      "retry": "Try again",
      "back": "Back to online shop",
      "searchPlaceholder": "Search products or shops…",
      "searchAriaLabel": "Search products or shops",
      "empty": "No products are available yet.",
      "emptySearch": "No products match your search."
    },
    "shopStorefront": {
      "loading": "Loading shop…",
      "loadFailed": "Failed to load this shop.",
      "notFoundTitle": "Shop not found",
      "notFoundText": "This shop does not exist or is not currently available.",
      "empty": "This shop has no products yet.",
      "retry": "Try again",
      "header": {
        "brand": "Online Shop",
        "ordersNav": "Orders",
        "orderHistoryTitle": "Order History",
        "cartTitle": "Shopping Cart"
      },
      "productList": {
        "loading": "Loading products…",
        "notFound": "Shop storefront not found.",
        "loadFailed": "Failed to load products.",
        "searchPlaceholder": "Search products…",
        "searchAriaLabel": "Search products",
        "emptySearch": "No products match your search.",
        "add": "Add to cart",
        "buyNow": "Buy Now"
      },
      "productDetail": {
        "loading": "Loading product details…",
        "notFound": "Product not found.",
        "loadFailed": "Failed to load this product.",
        "back": "Back to Products",
        "descriptionTitle": "Product Description",
        "quantity": "Quantity",
        "addToCart": "Add to Cart",
        "buyNow": "Buy Now"
      },
      "cart": {
        "title": "Shopping Cart",
        "loading": "Loading your cart…",
        "loadFailed": "Failed to load your cart.",
        "emptyTitle": "Your cart is empty",
        "emptyText": "Add some products to start checkout!",
        "continueShopping": "Continue Shopping",
        "summaryTitle": "Order Summary",
        "subtotal": "Subtotal",
        "total": "Total",
        "proceedToCheckout": "Proceed to Checkout",
        "removeItem": "Remove item",
        "decrease": "Decrease quantity",
        "increase": "Increase quantity"
      },
      "checkout": {
        "title": "Checkout",
        "loading": "Loading checkout details…",
        "back": "Back to Cart",
        "emptyTitle": "No items to check out",
        "goBack": "Go back to store",
        "buyerInfo": "Buyer Information",
        "fullName": "Full Name",
        "fullNamePlaceholder": "e.g. Juan dela Cruz",
        "contactNumber": "Contact Number",
        "contactPlaceholder": "e.g. 09171234567",
        "deliveryAddress": "Complete Delivery Address",
        "addressPlaceholder": "Street name, Barangay, City, Province, Postal Code",
        "paymentMethod": "Payment Method",
        "codLabel": "Cash on Delivery (COD)",
        "orderSummary": "Order Summary",
        "qty": "Qty: {{count}}",
        "subtotal": "Subtotal",
        "grandTotal": "Grand Total",
        "placeOrder": "Complete Checkout",
        "placingOrder": "Placing Order…",
        "validationFailed": "Please complete all buyer information fields.",
        "emptyCart": "Your cart is empty.",
        "failed": "Failed to place your order. Please try again."
      },
      "success": {
        "loading": "Loading order confirmation…",
        "loadFailed": "Failed to load your order confirmation.",
        "notFound": "Order confirmation not found.",
        "title": "Thank You for Your Order!",
        "subtitle": "Your order has been placed successfully. Order Number:",
        "buyerDetails": "Buyer Details",
        "name": "Name:",
        "contact": "Contact:",
        "deliveryAddress": "Delivery Address:",
        "paymentDetails": "Payment Details",
        "method": "Method:",
        "initialStatus": "Initial Status:",
        "itemsPurchased": "Items Purchased",
        "qty": "Qty: {{count}}",
        "totalPaid": "Total Amount Paid",
        "continueShopping": "Continue Shopping",
        "viewHistory": "View Order History"
      },
      "history": {
        "title": "Order History",
        "loading": "Loading order history…",
        "loadFailed": "Failed to load your order history.",
        "emptyTitle": "No orders yet",
        "emptyText": "You haven't placed any orders from this storefront yet.",
        "startShopping": "Start Shopping",
        "deliverTo": "Deliver to:",
        "totalAmount": "Total Amount:",
        "viewDetails": "View Details"
      },
      "orderDetail": {
        "loading": "Loading order details…",
        "loadFailed": "Failed to load this order.",
        "notFound": "Order not found.",
        "back": "Back to Orders",
        "title": "Order Details",
        "orderNumberLabel": "Order Number:",
        "placedOn": "Placed on {{date}}",
        "cancelOrder": "Cancel Order",
        "cancelConfirm": "Are you sure you want to cancel this order?",
        "cancelSuccess": "Order cancelled successfully.",
        "cancelFailed": "Failed to cancel order.",
        "deliveryDetails": "Delivery Details",
        "name": "Name:",
        "contact": "Contact:",
        "address": "Address:",
        "itemsOrdered": "Items Ordered",
        "paymentSummary": "Payment Summary",
        "paymentMethod": "Payment Method",
        "totalAmount": "Total Amount"
      },
      "orderStatus": {
        "trackerTitle": "Order Status",
        "cancelledTitle": "Order Cancelled",
        "cancelledText": "This order has been cancelled.",
        "steps": {
          "orderPlaced": "Order Placed",
          "preparing": "Preparing",
          "readyToShip": "Ready to Ship",
          "shipping": "Shipping",
          "outForDelivery": "Out for Delivery",
          "delivered": "Delivered"
        }
      },
      "cartToasts": {
        "added": "Product added to cart.",
        "removed": "Item removed from cart.",
        "addFailed": "Failed to add product to cart.",
        "updateFailed": "Failed to update quantity.",
        "removeFailed": "Failed to remove item."
      }
    },
    "shopOrders": {
      "title": "Shop Orders",
      "subtitle": "Manage customer orders and status updates",
      "backToShop": "Back to Online Shop",
      "backToShopAriaLabel": "Back to online shop",
      "manageProducts": "Manage products",
      "loading": "Loading orders…",
      "loadFailed": "Failed to load orders.",
      "retry": "Try again",
      "empty": "No orders found.",
      "noMatching": "No orders match the selected filters.",
      "filters": {
        "searchPlaceholder": "Search by order number or customer...",
        "statusAll": "All Statuses",
        "paymentMethodAll": "All Payment Methods",
        "minAmount": "Min Amount",
        "maxAmount": "Max Amount",
        "startDate": "Start Date",
        "endDate": "End Date",
        "clear": "Clear Filters"
      },
      "table": {
        "orderNumber": "Order Number",
        "customerName": "Customer Name",
        "dateOrdered": "Date Ordered",
        "paymentMethod": "Payment Method",
        "totalAmount": "Total Amount",
        "status": "Status"
      },
      "detail": {
        "back": "Back to Orders",
        "loading": "Loading order…",
        "loadFailed": "Failed to load this order.",
        "notFound": "Order not found.",
        "placedOn": "Placed on {{date}}",
        "markAs": "Mark as \"{{status}}\"",
        "cancelOrder": "Cancel Order",
        "cancelConfirm": "Are you sure you want to cancel this order?",
        "statusUpdated": "Order status updated to {{status}}",
        "statusFailed": "Failed to update status.",
        "cancelSuccess": "Order cancelled successfully.",
        "cancelFailed": "Failed to cancel order.",
        "customerDetails": "Customer Details",
        "name": "Name:",
        "contactNumber": "Contact Number:",
        "deliveryAddress": "Delivery Address:",
        "orderedProducts": "Ordered Products",
        "orderSummary": "Order Summary",
        "status": "Status:",
        "paymentMethod": "Payment Method:",
        "grandTotal": "Grand Total:"
      }
    },
    "pos": {
      "signedIn": {
        "label": "Signed in as {{name}}",
        "labelPrefix": "Account",
        "companyLabel": "Company: {{name}}",
        "companyPrefix": "Company",
        "allCompanies": "All companies"
      },
      "help": {
        "iconAriaLabel": "How to use POS products, variants, and inventory",
        "modalTitle": "POS catalog help",
        "close": "Close",
        "products": {
          "sectionTitle": "How to create a product",
          "stepOpenHub": "From the POS hub, open the area where you manage your register catalog.",
          "stepManageProducts": "Go to <link>Manage Products</link> to see everything sold at the register.",
          "stepAddProduct": "Click Add product and enter a name. Description and category are optional.",
          "stepFillDetails": "Set a single price, or turn on Sell in variants if the item comes in sizes, colors, or other options.",
          "stepPublish": "Leave Available at register on to publish a live product, or turn it off to save a draft and finish later."
        },
        "variants": {
          "sectionTitle": "How to manage variants",
          "stepToggle": "In the product form, enable Sell in variants (size, color, etc.).",
          "stepAddRows": "Add one row per variant with a label, optional SKU, and its own price.",
          "stepDefault": "Mark one variant as Default. Its price is used when the product is listed with “From” pricing.",
          "stepRegisterPicker": "At the register, tapping a product with variants opens a picker so the cashier chooses the correct option."
        },
        "inventory": {
          "sectionTitle": "How to view inventory",
          "stepOpenInventory": "Open <link>View Inventory</link> from the POS hub.",
          "stepRows": "You will see one row per product, or per variant when variants are enabled. Combo products are not listed here—stock is tracked on each component instead.",
          "stepReceive": "Add stock with Receive Stock (supplier required). You can receive from a purchase order, link an AP bill and enter SKUs manually, or create a standalone receive. Optional expiry, bins, and serials are supported.",
          "stepSaleNote": "Stock is tracked separately from company accounting inventory. Completing a POS sale reduces stock here automatically (combo sales deduct their components).",
          "stepFullGuide": "For the full user manual (warehouses, transfers, counts, and rules), open the <link>POS inventory guide</link>."
        }
      },
      "inventoryTopicHelp": {
        "inventory": {
          "modalTitle": "View Inventory help",
          "whatItIsTitle": "What is View Inventory?",
          "whatItIsBody": "A live view of on-hand POS stock by warehouse and product (or variant). Use Receive Stock, transfers, and counts to change quantities — this page is for viewing and history. Turn on Low stock only to see items below their reorder point.",
          "howToTitle": "How to use it",
          "step1": "Open View Inventory from the POS hub Inventory section.",
          "step2": "Filter by warehouse or search by product name when you have many rows.",
          "step3": "Enable Low stock only to list items below their reorder minimum (set mins under Reorder rules; min and reorder-to columns appear).",
          "step4": "Add stock with Receive Stock — there is no free-form Adjust on this page.",
          "step5": "Open a product’s history to see receives, sales, transfers, and counts."
        },
        "warehouses": {
          "modalTitle": "Warehouses help",
          "whatItIsTitle": "What are warehouses?",
          "whatItIsBody": "Warehouses are stock locations for your company (stores, storerooms, or sites). Each register sells from its home warehouse.",
          "howToTitle": "How to use them",
          "step1": "Every company starts with a default Main warehouse.",
          "step2": "Add more warehouses for other locations, and set one as default for new receives.",
          "step3": "Assign each POS register to a home warehouse in Manage Registers.",
          "step4": "Use bins only when you need shelf-level locations inside a warehouse."
        },
        "bins": {
          "modalTitle": "Bins help",
          "whatItIsTitle": "What are bins?",
          "whatItIsBody": "Bins are optional shelf or location labels inside a warehouse (for example Aisle A / Shelf 2). Stock quantity is still tracked at the warehouse; bins help organize receives and counts.",
          "howToTitle": "How to use them",
          "step1": "Open Bins from a warehouse row when your team needs shelf-level locations.",
          "step2": "Add a short code and a clear name for each bin.",
          "step3": "Skip bins if one location per warehouse is enough — they are optional."
        },
        "transfers": {
          "modalTitle": "Transfers help",
          "whatItIsTitle": "What are transfers?",
          "whatItIsBody": "Transfers move stock between warehouses. While in transit, stock is not sellable at either location.",
          "howToTitle": "How to use them",
          "step1": "Create a transfer from one warehouse to another with product quantities.",
          "step2": "Ship to deduct source stock and put the shipment in transit.",
          "step3": "Receive all or part at the destination; return any remainder to the source if needed.",
          "step4": "Cancel an in-transit transfer to return everything still in transit to the source."
        },
        "stockCounts": {
          "modalTitle": "Stock Counts help",
          "whatItIsTitle": "What are stock counts?",
          "whatItIsBody": "A stock count reconciles system on-hand with what you physically count. Completing posts permanent stock adjustments.",
          "howToTitle": "How to use them",
          "step1": "Choose a warehouse (and optional bin). The form shows system quantity for each tracked product.",
          "step2": "Enter counted quantities. Shortages reduce lots automatically (FEFO/FIFO).",
          "step3": "For overages, pick a supplier (a suggestion may be shown).",
          "step4": "Use Save Draft to keep an in-progress count, or Submit Stock Count to post adjustments immediately. Discard cancels an in-progress count without changing stock."
        },
        "reorderRules": {
          "modalTitle": "Reorder rules help",
          "whatItIsTitle": "What are reorder rules?",
          "whatItIsBody": "A reorder rule sets the minimum on-hand quantity (and optional reorder-to target) for a product at a warehouse. View Inventory’s Low stock filter and the Low Stock report use these rules.",
          "howToTitle": "How to use them",
          "step1": "Open Reorder rules from the POS hub Inventory section.",
          "step2": "Add a rule for each product (and variant, if any) you want to monitor at a warehouse.",
          "step3": "Set the minimum quantity that triggers low stock. Optionally set reorder-to as a restock target.",
          "step4": "Edit or delete rules anytime. Members with POS access get notified when stock falls to or below the minimum."
        },
        "lowStock": {
          "modalTitle": "Low Stock help",
          "whatItIsTitle": "What is Low Stock?",
          "whatItIsBody": "Lists products that are at or below their reorder point for a warehouse, so you know what to restock.",
          "howToTitle": "How to use it",
          "step1": "Set reorder minimums (and optional reorder-to) per warehouse and product.",
          "step2": "Open Low Stock to see current breaches; filter by warehouse if needed.",
          "step3": "Members with POS access (and owners) get an in-app notification once per breach until quantity recovers."
        },
        "import": {
          "modalTitle": "Import Stock help",
          "whatItIsTitle": "What is Import Stock?",
          "whatItIsBody": "Bulk-create receive drafts from a CSV file. Always dry-run first, then commit and post when ready.",
          "howToTitle": "How to use it",
          "step1": "Prepare a CSV with warehouse, supplier, product, quantity, and unit cost columns.",
          "step2": "Run Validate (dry run) and fix any row errors.",
          "step3": "Commit to create draft receives — review them before posting.",
          "step4": "Do not use free-form Adjust; import is the bulk path for opening or additional stock."
        },
        "ordersReceiving": {
          "modalTitle": "Orders & Receiving help",
          "whatItIsTitle": "What is Orders & Receiving?",
          "whatItIsBody": "One place for purchase orders and inbound receives. Create a PO when you place an order; receive against it when goods arrive, or create a standalone receive. Purchase orders are immutable once created — void and recreate to change them.",
          "howToTitle": "How to use it",
          "step1": "Use New purchase order to record what you ordered from a supplier (lines with quantity and optional unit cost).",
          "step2": "Open rows that are still Ordered or Partially received with Receive, or View PO for details and a printable PDF.",
          "step3": "Use New receive for a standalone receive (or from a PO). Optionally link an AP bill to lock the supplier, then enter product lines manually. Partial receives are allowed; do not over-receive a PO line.",
          "step4": "Use View received for draft, posted, or voided receives — and View PO when the receive is linked to a purchase order.",
          "step5": "Void a PO only when it should not be used for further receives."
        }
      },
      "index": {
        "documentTitle": "POS System",
        "pageTitle": "POS System",
        "loading": "Loading POS…",
        "bootstrapping": "Setting up your POS…",
        "retry": "Try again",
        "groups": {
          "selling": "Selling",
          "catalog": "Catalog",
          "inventory": "Inventory",
          "setup": "Setup"
        },
        "setup": {
          "documentTitle": "Set up POS",
          "title": "Set up your first register",
          "tagline": "A checkout station is required before you can sell.",
          "description": "Add a register to open POS, track sales, and run E-Journal and BIR reports. You can add more registers later from Manage Registers."
        },
        "setupProducts": {
          "documentTitle": "Set up products",
          "title": "Add your first product",
          "tagline": "You need at least one product before you can sell at the register.",
          "description": "Add a name, price, and starting stock so you can sell at the register."
        },
        "cards": {
          "products": {
            "title": "Manage Products",
            "description": "Add, edit, and organize items you sell at the register."
          },
          "inventory": {
            "title": "View Inventory",
            "description": "View on-hand stock, or filter to low-stock items."
          },
          "warehouses": {
            "title": "Warehouses",
            "description": "Manage warehouses and storage bins."
          },
          "reorderRules": {
            "title": "Reorder rules",
            "description": "Set minimum stock levels and reorder-to targets per warehouse."
          },
          "transfers": {
            "title": "Transfers",
            "description": "Move stock between warehouses."
          },
          "stockCounts": {
            "title": "Stock Counts",
            "description": "Count and reconcile stock in a warehouse or bin."
          },
          "import": {
            "title": "Import Stock",
            "description": "Bulk import opening or additional stock from a CSV file."
          },
          "registers": {
            "title": "Manage Registers",
            "description": "Add and edit checkout stations and BIR details."
          },
          "receiptLayout": {
            "title": "Receipt layout",
            "description": "Adjust sales invoice font sizes and preview before printing."
          },
          "eisSetup": {
            "title": "EIS Setup",
            "description": "Enable POS EIS reporting and manage BIR transmission settings."
          },
          "machineQrSetup": {
            "title": "Machine QR",
            "description": "Enable milk-tea machine QR codes on products and print them after sales."
          },
          "printerSettings": {
            "title": "Printer settings",
            "description": "Connect or change the receipt printer for this device."
          },
          "openPos": {
            "title": "Open POS",
            "description": "Ring up sales at the register."
          },
          "eJournal": {
            "title": "E-Journal",
            "description": "Export daily receipts, adjustments, and X/Z readings for BIR audit."
          },
          "reports": {
            "title": "Reports",
            "description": "Sales readings, journals, and BIR discount books."
          },
          "birReports": {
            "title": "Reports",
            "description": "Sales summary, void report, and SC/PWD/NAAC/Solo Parent discount books."
          },
          "ordersReceiving": {
            "title": "Orders & Receiving",
            "description": "Create purchase orders and receive inbound stock."
          },
          "inventoryReports": {
            "title": "Inventory Reports",
            "description": "Stock on hand, movements, purchasing, and valuation reports."
          }
        }
      },
      "eisSetup": {
        "documentTitle": "EIS Setup",
        "pageTitle": "EIS Setup",
        "subtitle": "Configure electronic invoice reporting for this company’s POS sales.",
        "backToHub": "Back to POS",
        "reportingHeading": "Reporting",
        "enabledLabel": "POS EIS reporting",
        "enabledDescription": "When enabled, sales and voids in the last 3 business days are transmitted to BIR EIS. Older sales stay in AbraFi only unless caught up later.",
        "enabledToast": "POS EIS reporting enabled.",
        "disabledToast": "POS EIS reporting disabled.",
        "saveFailed": "Failed to save POS EIS setting.",
        "catchingUp": "Transmitting recent unsent sales to EIS…",
        "catchUpNone": "No recent unsent sales to transmit to EIS.",
        "catchUpSuccess": "Transmitted {{sales}} sale(s) and {{voids}} void(s) to EIS.",
        "catchUpPartial": "Transmitted {{sales}} sale(s) and {{voids}} void(s); {{failed}} failed.",
        "catchUpFailed": "Failed to catch up recent sales for EIS.",
        "catchUpRun": "Run catch-up now",
        "transmissionsLogLink": "Open EIS Transmissions Log",
        "catchUpPreview": "{{sales}} sale(s) and {{voids}} void(s) pending from {{start}} to {{end}}.",
        "catchUpPreviewUnavailable": "Catch-up preview unavailable.",
        "credentialsHeading": "BIR EIS credentials",
        "credentialsDescription": "Store the company’s EIS portal credentials used for authentication and signing. Secrets are encrypted at rest and never shown again after save. Leave a secret blank to keep the saved value.",
        "credentialsLoading": "Loading credentials…",
        "credentialsLoadFailed": "Failed to load EIS credentials.",
        "credentialsRetry": "Try again",
        "credentialsSave": "Save credentials",
        "credentialsSaving": "Saving…",
        "credentialsSaved": "EIS credentials saved.",
        "credentialsSaveFailed": "Failed to save EIS credentials.",
        "noChangesToSave": "No changes to save",
        "credentialsResetButton": "Reset all",
        "credentialsResetTitle": "Reset EIS credentials?",
        "credentialsResetMessage": "This permanently removes the company’s stored EIS environment, identifiers, and secrets. Reporting can stay enabled, but credentials will need to be entered again.",
        "credentialsResetConfirm": "Reset credentials",
        "credentialsResetting": "Resetting…",
        "credentialsReset": "EIS credentials reset.",
        "credentialsResetFailed": "Failed to reset EIS credentials.",
        "clearSecret": "Clear saved",
        "secretConfiguredHint": "Saved — leave blank to keep",
        "secretEmptyHint": "Not set",
        "secretClearPendingHint": "Will clear on save",
        "statusUnknown": "Status unknown",
        "statusNotConfigured": "Not configured",
        "statusIncomplete": "Incomplete",
        "statusReady": "Ready for transmission",
        "statusUnreadable": "Saved secrets cannot be read",
        "secretsUnreadableHelp": "Encrypted secrets cannot be decrypted. Check AUTH_ENCRYPTION_KEY on the API, then re-enter secrets.",
        "missingFields": "Still needed: {{fields}}",
        "lastUpdated": "Last updated {{date}}",
        "historyTitle": "Audit history",
        "historySubtitle": "Credential changes, reporting toggles, and catch-up runs for this company.",
        "historyEmpty": "No EIS Setup changes recorded yet.",
        "historyMeta": "{{when}} · {{action}} · {{performedBy}}",
        "historyChangeFromTo": "{{field}}: {{from}} → {{to}}",
        "historyChangeTo": "{{field}}: {{to}}",
        "historyActions": {
          "credentials_created": "Credentials created",
          "credentials_updated": "Credentials updated",
          "credentials_reset": "Credentials reset",
          "reporting_enabled": "Reporting enabled",
          "reporting_disabled": "Reporting disabled",
          "catch_up": "Catch-up run"
        },
        "historyFields": {
          "environment": "Environment",
          "endpointBaseUrl": "EIS endpoint URL",
          "authPath": "Auth API path",
          "submitPath": "Submit API path",
          "userId": "User ID",
          "accreditationId": "Accreditation ID",
          "applicationId": "Application ID",
          "applicationKeyId": "Application key ID",
          "hasPassword": "Password",
          "hasApplicationSecretKey": "Application secret key",
          "hasApplicationPublicKey": "Application public key",
          "hasApplicationPrivateKey": "Application private key",
          "hasEisPublicKey": "EIS public key",
          "posEisEnabled": "POS EIS reporting",
          "windowStartBusinessDate": "Catch-up window start",
          "windowEndBusinessDate": "Catch-up window end",
          "exportedSaleCount": "Sales transmitted",
          "exportedVoidCount": "Voids transmitted",
          "failedCount": "Failures"
        },
        "fields": {
          "environment": "Environment",
          "endpointBaseUrl": "EIS endpoint URL",
          "authPath": "Auth API path",
          "authPathHint": "Relative path on the EIS host for authentication (default /api/authentication).",
          "submitPath": "Submit API path",
          "submitPathHint": "Relative path for signed invoice submission (default /api/invoices).",
          "userId": "User ID",
          "password": "Password",
          "accreditationId": "Accreditation ID",
          "applicationId": "Application ID",
          "applicationKeyId": "Application key ID",
          "applicationSecretKey": "Application secret key",
          "applicationPublicKey": "Application public key",
          "applicationPrivateKey": "Application private key",
          "eisPublicKey": "EIS public key"
        },
        "environment": {
          "cert": "Certification (sandbox)",
          "production": "Production",
          "custom": "Custom URL"
        }
      },
      "machineQrSetup": {
        "documentTitle": "Machine QR",
        "pageTitle": "Machine QR",
        "subtitle": "Encode milk-tea machine codes on products and print QR tickets after each sale.",
        "backToHub": "Back to POS",
        "featureHeading": "Machine QR",
        "enabledLabel": "Milk-tea machine QR",
        "enabledDescription": "When enabled, POS builds a machine QR payload for each sale line that has machine codes, and you can print those QR codes after checkout.",
        "helpText": "Set machine codes on products, variants, option values, and add-ons under Manage Products. Printed tickets show the item description, the code, and a QR at least 30×30 mm (no receipt). After a sale, use Print machine QR on the sale complete screen (one QR per unit).",
        "productsLinkHint": "Do not use “-” inside a machine code — it separates segments in the QR payload.",
        "enabledToast": "Milk-tea machine QR enabled.",
        "disabledToast": "Milk-tea machine QR disabled.",
        "saveFailed": "Failed to save milk-tea machine QR setting.",
        "testPrintHeading": "Test print",
        "testPrintDescription": "Pick a product the same way as on the register (variant and add-ons), then print a machine QR only — no sale and no receipt. The ticket shows the item description, the code, and a QR at least 30×30 mm.",
        "testPrintLoading": "Loading products…",
        "testPrintEmpty": "No products have a printable machine code yet. Add a product machine code (and option/add-on codes as needed) under Manage Products.",
        "testPrintRetry": "Try again",
        "testPrintButton": "Print QR",
        "testPrinting": "Printing…",
        "testPrintFailed": "Failed to print machine QR.",
        "manageProductsLink": "Manage products",
        "selectionPanelAria": "Selected item for machine QR test print",
        "selectionTitle": "Selected item",
        "selectionEmpty": "Select a product to configure variant and add-ons, then print its machine QR.",
        "clearSelection": "Clear",
        "missingMachineCode": "This product has no machine code for the selected options. Add machine codes under Manage Products."
      },
      "reportsHub": {
        "documentTitle": "POS Reports",
        "pageTitle": "POS Reports",
        "subtitle": "Generate and export register reports for audit and day-end close.",
        "backToHub": "Back to POS",
        "comingSoon": "Coming soon",
        "groups": {
          "salesReadings": "Sales readings",
          "journals": "Journals / logs",
          "backend": "Backend reports",
          "statutory": "Statutory discount books",
          "adjustments": "Adjustment reports"
        },
        "cards": {
          "xReading": {
            "title": "X-Reading",
            "description": "Cashier's accountability / end-of-shift report."
          },
          "zReading": {
            "title": "Z-Reading",
            "description": "End-of-day report with AGT, VAT breakdown, and Z-counter."
          },
          "eJournal": {
            "title": "E-Journal / Audit Journal",
            "description": "Daily journal of receipts, adjustments, and X/Z readings."
          },
          "activityLog": {
            "title": "Activity Log / Transaction Log",
            "description": "All POS actions with actor, timestamp, and values."
          },
          "eisTransmissionsLog": {
            "title": "EIS Transmissions Log",
            "description": "Review daily BIR EIS transmissions, signatures, and response statuses."
          },
          "birSalesSummary": {
            "title": "BIR Sales Summary Report",
            "description": "Gross, void, refund, and net sales with VAT breakdown."
          },
          "dailyCash": {
            "title": "Daily Cash Report",
            "description": "Cash accountability for the business day."
          },
          "terminalAccountability": {
            "title": "Terminal Accountability Report",
            "description": "Per-register accountability totals for audit."
          },
          "detailedSales": {
            "title": "Detailed Sales Report",
            "description": "Line-level sales detail for the selected period."
          },
          "itemsSoldLedger": {
            "title": "Items Sold Ledger",
            "description": "Item-wise POS sales with quantity, total sales, and gross profit."
          },
          "salesGeneralLedger": {
            "title": "Sales General Ledger",
            "description": "Review, verify, and post POS sales transactions to Accounting."
          },
          "scSalesBook": {
            "title": "Senior Citizen (SC) Sales Book",
            "description": "Statutory SC discount sales book / report."
          },
          "pwdSalesBook": {
            "title": "PWD Sales Book",
            "description": "Persons with Disability discount sales book."
          },
          "naacSalesBook": {
            "title": "NAAC Sales Book",
            "description": "National Athletes and Coaches (Annex E-4) sales book."
          },
          "soloParentSalesBook": {
            "title": "Solo Parent Sales Book",
            "description": "Solo Parent (Annex E-5) sales book / report."
          },
          "voidReport": {
            "title": "Void Report",
            "description": "Voided invoices and receipts for the period."
          },
          "salesReturnRefund": {
            "title": "Sales Return / Refund Report",
            "description": "Sales return and refund documents for the period."
          }
        }
      },
      "eJournal": {
        "documentTitle": "POS E-Journal",
        "title": "E-Journal / Audit Journal",
        "subtitle": "Export a register's daily audit trail: receipts, voids, refunds, and X/Z readings.",
        "backToHub": "Back to POS",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "businessDateLabel": "Business date",
        "businessDateHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview journal",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export E-Journal",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "pdfBlocked": "Could not open the PDF. Allow pop-ups for this site or try again.",
        "exportCsv": "Export CSV",
        "exportJson": "Export JSON",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load E-Journal.",
        "exportFailed": "Failed to export E-Journal.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before exporting E-Journal.",
        "manageRegisters": "Add register",
        "summaryTitle": "{{name}} — {{date}}",
        "receiptCount": "Receipts",
        "voidCount": "Voids",
        "refundCount": "Refunds",
        "xReadingCount": "X-Readings",
        "zReadingPresent": "Z-Reading",
        "recordCount": "Total records",
        "noRecords": "No journal records for this register and business date.",
        "yes": "Yes",
        "no": "No",
        "columns": {
          "occurredAt": "Occurred at",
          "recordType": "Type",
          "invoiceNumber": "Invoice / OR",
          "amount": "Amount",
          "description": "Description"
        },
        "recordTypes": {
          "receipt": "Receipt",
          "receiptLine": "Receipt line",
          "void": "Void",
          "refund": "Refund",
          "refundLine": "Refund line",
          "xReading": "X-Reading",
          "zReading": "Z-Reading",
          "unknown": "Other"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the E-Journal / Audit Journal?",
          "modalTitle": "About E-Journal / Audit Journal",
          "whatItIsBody": "The E-Journal (Audit Journal) is the chronological, machine-readable audit trail for one register on one business day. It lists every journal record in time order so you can reconstruct what happened at that terminal that day.",
          "uniqueChronological": "Records appear in the order they occurred—receipts, receipt lines, voids, refunds, and reading events—forming a continuous daily trail.",
          "uniqueFullTrail": "It keeps both header and line-level journal rows where applicable, so auditors can follow an invoice from sale through any later void or refund.",
          "uniqueOneDay": "Each preview or export covers a single register and a single Philippines business day.",
          "uniqueExport": "You can preview on screen and export CSV, Excel, Google Sheets, or PDF for offline review or submission packages.",
          "includesBody": "Summary counts (receipts, voids, refunds, reading events) plus a table of timestamped records with type, invoice/OR number when present, amount, and description.",
          "thisPageBody": "Choose a register and business date, preview the journal, then use Export for CSV, Excel, Google Sheets, or PDF when you need a file copy."
        }
      },
      "activityLog": {
        "documentTitle": "POS Activity Log",
        "title": "Activity Log / Transaction Log",
        "subtitle": "Audit trail of POS actions with actor, timestamp, and values involved.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview log",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export activity log",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "exportCsv": "Export CSV",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load activity log.",
        "exportFailed": "Failed to export activity log.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing the activity log.",
        "manageRegisters": "Add register",
        "summaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "totalCount": "Total actions",
        "saleCount": "Sales",
        "voidCount": "Voids",
        "refundCount": "Refunds",
        "reprintCount": "Reprints",
        "eisPushCount": "EIS pushes",
        "noEntries": "No activity for this register and date range.",
        "columns": {
          "occurredAt": "Occurred at",
          "action": "Action",
          "actor": "Actor",
          "invoice": "Invoice / OR",
          "amount": "Amount",
          "values": "Values"
        },
        "actionTypes": {
          "sessionOpen": "Session open",
          "sessionClose": "Session close",
          "sale": "Sale",
          "void": "Void",
          "refund": "Refund",
          "reprint": "Reprint",
          "eisPush": "EIS push",
          "xReading": "X-Reading",
          "zReading": "Z-Reading",
          "unknown": "Other"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the Activity Log / Transaction Log?",
          "modalTitle": "About Activity Log / Transaction Log",
          "whatItIsBody": "The Activity Log is an actor-focused audit trail of POS actions. Each row shows who did what, when, and which amounts or references were involved—useful for investigating operational activity on a register over a date range.",
          "uniqueActorFocused": "Every entry identifies the actor (name and email when available) alongside the action type and timestamp.",
          "uniqueActionTypes": "It covers operational actions such as opening or closing a session, completing a sale, voiding, refunding, reprinting a receipt, and related system pushes when present.",
          "uniqueDateRange": "You can review activity across any start–end date range for one register—not only a single day.",
          "uniqueValues": "Rows include the values involved (amounts, invoice numbers, and related identifiers) so you can trace the action without opening each transaction separately.",
          "includesBody": "A filterable list of activity rows with occurred-at time, action type, actor, amount when applicable, and a short description of what changed.",
          "thisPageBody": "Select a register and date range, preview the activity table, then use Export for CSV, Excel, Google Sheets, or PDF for supervisor review or investigation."
        }
      },
      "eisTransmissionsLog": {
        "documentTitle": "EIS Transmissions Log",
        "title": "EIS Transmissions Log",
        "subtitle": "Confirm BIR EIS transmissions for the 3-day rule: invoice metadata, payload files, digital signatures, and response statuses.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "allRegisters": "All registers",
        "statusLabel": "Status",
        "statusAll": "All statuses",
        "searchLabel": "Search",
        "searchPlaceholder": "Invoice, Unique ID, payload file, or rejection code",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila). End-of-day catch-up runs automatically at 23:59.",
        "preview": "Preview log",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export EIS transmissions log",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "exportFailed": "Failed to export EIS transmissions log.",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load EIS transmissions log.",
        "loadDetailFailed": "Failed to load transmission details.",
        "loadingDetail": "Loading transmission details…",
        "retry": "Try again",
        "retryUnsent": "Retry unsent (3-day window)",
        "catchingUp": "Transmitting unsent sales to EIS…",
        "catchUpDone": "Catch-up finished: {{sales}} sale(s), {{voids}} void(s), {{failed}} failed.",
        "catchUpFailed": "Failed to retry unsent EIS transmissions.",
        "retryTransmission": "Retry this transmission",
        "retrying": "Retrying transmission…",
        "retrySuccess": "Transmission retried.",
        "retryFailed": "Could not retry this transmission.",
        "downloadPayload": "Download payload JSON",
        "downloadingPayload": "Downloading…",
        "payloadDownloadFailed": "Failed to download payload file.",
        "copySignature": "Copy digital signature",
        "signatureCopied": "Digital signature copied.",
        "signatureCopyFailed": "Could not copy the digital signature.",
        "signatureFingerprint": "JWS …{{fingerprint}}",
        "summaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "totalCount": "Total transmissions",
        "acceptedCount": "Accepted",
        "rejectedCount": "Rejected",
        "errorCount": "Errors",
        "noEntries": "No EIS transmissions for this filter. Enable EIS Setup and complete a sale, or wait for the 23:59 catch-up.",
        "detailTitle": "Transmission — {{invoice}}",
        "totalsSummary": "Gross {{gross}} · VAT {{vat}} · Total {{total}}",
        "statuses": {
          "accepted": "Accepted",
          "rejected": "Rejected",
          "error": "Error"
        },
        "eventTypes": {
          "sale": "Sale",
          "void": "Void"
        },
        "columns": {
          "transmittedAt": "Transmitted at",
          "invoice": "Invoice",
          "event": "Event",
          "status": "Status",
          "payloadFile": "Payload file",
          "signature": "Signature",
          "uniqueId": "Unique ID",
          "rejection": "Rejection code"
        },
        "detail": {
          "invoiceNumber": "Invoice number",
          "eventType": "Event",
          "issuedAt": "Issued at",
          "transmittedAt": "Transmission timestamp",
          "status": "Response status",
          "uniqueId": "EIS Unique ID",
          "payloadFile": "Payload file reference",
          "signature": "Digital signature",
          "jwsFull": "Compact JWS",
          "rejectionCode": "Error / rejection code",
          "errorMessage": "Error message",
          "seller": "Seller",
          "buyer": "Buyer",
          "totals": "Tax totals",
          "httpStatus": "HTTP status",
          "responseBody": "Portal response",
          "payloadJson": "Payload JSON (mandatory tax fields)"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the log includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the EIS Transmissions Log?",
          "modalTitle": "About EIS Transmissions Log",
          "whatItIsBody": "This log is the BIR audit trail of every Electronic Invoicing System transmission from this company’s POS. Use it to prove timely filing under the 3-day rule and to diagnose rejected or failed pushes.",
          "uniqueDailyProof": "Each row is an append-only transmission attempt with timestamp, invoice metadata, payload file name, Compact JWS signature, Unique ID, and rejection codes.",
          "uniquePayloadSignature": "Daily sales are packaged as structured JSON (20+ tax fields), signed with JWS (RS256), and sent to the BIR EIS portal. You can download the exact payload file from a row.",
          "uniqueStatuses": "Accepted means BIR returned a Unique ID. Rejected and Error rows include HTTP status plus portal rejection codes when the host sent them.",
          "uniqueThreeDay": "Live transmit happens at sale/void time. At 23:59 Asia/Manila the system automatically retries any unsent sales in the last 3 business days.",
          "includesBody": "Invoice number and issue time, seller/buyer tax details, amounts, payload file reference, digital signature fingerprint, Unique ID, response status, and error/rejection codes.",
          "thisPageBody": "Choose a register or all registers, set the date range, preview the log, open a row for details, download the JSON payload, or retry failed transmissions. Export CSV, Excel, or Google Sheets for an audit package.",
          "sampleExportTitle": "Sample export",
          "sampleExportBody": "Download a fictional example with accepted, rejected, error, and void rows—no live POS sales required.",
          "sampleExportBusy": "Preparing sample…"
        }
      },
      "birSalesSummary": {
        "documentTitle": "POS BIR Sales Summary",
        "title": "BIR Sales Summary Report",
        "subtitle": "Gross, void, refund, and net sales with VAT breakdown for the selected period.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview report",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export BIR sales summary",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "exportCsv": "Export CSV",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load BIR sales summary.",
        "exportFailed": "Failed to export BIR sales summary.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing the sales summary.",
        "manageRegisters": "Add register",
        "summaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "grossSales": "Gross sales",
        "voids": "Voids",
        "refunds": "Refunds",
        "netSales": "Net sales",
        "vatableSales": "VATable sales",
        "vatAmount": "VAT amount",
        "vatExemptSales": "VAT-exempt sales",
        "vatZeroRatedSales": "VAT zero-rated sales",
        "invoiceRange": "Invoice range",
        "noPayments": "No payment totals for this register and date range.",
        "columns": {
          "paymentMethod": "Payment method",
          "total": "Total"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the BIR Sales Summary Report?",
          "modalTitle": "About BIR Sales Summary Report",
          "whatItIsBody": "The BIR Sales Summary Report is a backend sales overview for one register over a chosen date range. It rolls up gross sales, voids, refunds, and net sales, then shows the VAT split and payment-mode totals expected when reviewing POS sales for that period.",
          "uniquePeriod": "It covers any start–end date range for one register, so you can review a day, a week, or a longer evaluation period.",
          "uniqueVatPayments": "It highlights BIR-facing aggregates: VATable / VAT-exempt / zero-rated sales, VAT amount, payment modes, and the first–last invoice range.",
          "uniqueSummaryLevel": "Totals stay at period summary level—no product lines—so you can verify overall sales and VAT figures quickly.",
          "uniqueAnytime": "You can generate it anytime for audit. Viewing or exporting does not close a business day or change register counters.",
          "includesBody": "Gross sale count and total, void and refund counts and totals, net sales, VAT breakdown, payment method totals, and the invoice serial range for sales in the period.",
          "thisPageBody": "Choose a register and date range (Philippines business day), then preview the summary. Use Export for CSV, Excel, Google Sheets, or PDF when you need a printable or file copy for evaluation or TCVD."
        }
      },
      "dailyCashReport": {
        "documentTitle": "POS Daily Cash Report",
        "title": "Daily Cash Report",
        "subtitle": "Cash drawer accountability by session for the selected period.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview report",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export daily cash report",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "exportCsv": "Export CSV",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load daily cash report.",
        "exportFailed": "Failed to export daily cash report.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing the daily cash report.",
        "manageRegisters": "Add register",
        "summaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "sessionCount": "Sessions",
        "closedSessionCount": "Closed sessions",
        "openSessionCount": "Open sessions",
        "openingFloatTotal": "Opening float total",
        "cashSalesTotal": "Cash sales total",
        "refundTotal": "Refund total",
        "expectedCashTotal": "Expected cash total",
        "closingFloatTotal": "Closing float total",
        "overShortTotal": "Over / short total",
        "noEntries": "No sessions for this register and date range.",
        "statusOpen": "Open",
        "statusClosed": "Closed",
        "columns": {
          "openedAt": "Opened",
          "closedAt": "Closed",
          "openedBy": "Opened by",
          "closedBy": "Closed by",
          "status": "Status",
          "openingFloat": "Opening float",
          "cashSales": "Cash sales",
          "refunds": "Refunds",
          "expectedCash": "Expected cash",
          "closingFloat": "Closing float",
          "overShort": "Over / short"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the Daily Cash Report?",
          "modalTitle": "About Daily Cash Report",
          "whatItIsBody": "The Daily Cash Report is a cash-drawer accountability report. For each register session in the date range, it shows opening float, cash sales, refunds, expected cash in the drawer, closing float, and over/short—so you can verify physical cash against what the POS expected.",
          "uniqueCashDrawer": "It focuses on cash accountability: float in, cash movement, expected drawer cash, and float out.",
          "uniquePerSession": "Rows are per session (shift). Each open or closed session that falls in the period appears with its cash figures.",
          "uniqueOverShort": "Over/short is calculated so cashiers and supervisors can see whether the counted cash matched the expected drawer amount.",
          "uniqueCashFocus": "Only cash that feeds the drawer calculation is emphasized—opening float, cash sales, refunds, and closing float.",
          "includesBody": "Session open/close times and actors, opening and closing float, cash sales, refund total, expected cash in drawer, over/short, and period summary totals across those sessions.",
          "thisPageBody": "Pick a register and date range, preview the cash sessions, then use Export for CSV, Excel, Google Sheets, or PDF for audit or end-of-day cash reconciliation."
        }
      },
      "terminalAccountabilityReport": {
        "documentTitle": "POS Terminal Accountability",
        "title": "Terminal Accountability Report",
        "subtitle": "Per-session sales accountability totals for audit.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview report",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export terminal accountability report",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "exportCsv": "Export CSV",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load terminal accountability report.",
        "exportFailed": "Failed to export terminal accountability report.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing terminal accountability.",
        "manageRegisters": "Add register",
        "summaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "sessionCount": "Sessions",
        "grossSales": "Gross sales",
        "voids": "Voids",
        "refunds": "Refunds",
        "netSales": "Net sales",
        "cashSalesTotal": "Cash sales",
        "paymentTotals": "Payment totals",
        "invoiceRange": "Invoice range",
        "noEntries": "No sessions for this register and date range.",
        "statusOpen": "Open",
        "statusClosed": "Closed",
        "columns": {
          "openedAt": "Opened",
          "closedAt": "Closed",
          "openedBy": "Opened by",
          "closedBy": "Closed by",
          "status": "Status",
          "gross": "Gross",
          "voids": "Voids",
          "refunds": "Refunds",
          "net": "Net",
          "cashSales": "Cash sales",
          "payments": "Payments",
          "invoices": "Invoices"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the Terminal Accountability Report?",
          "modalTitle": "About Terminal Accountability Report",
          "whatItIsBody": "The Terminal Accountability Report shows per-session sales performance for a POS register (terminal). For each session in the date range, it lists gross, void, refund, and net sales, cash sales, payment-mode totals, and the invoice range—useful when auditing who ran the terminal and what they sold.",
          "uniquePerSessionSales": "Accountability is broken down by session (shift), then rolled up for the period—ideal when several cashiers used the same register.",
          "uniqueAllPayments": "It includes all payment modes and sales adjustments (voids and refunds) for each session.",
          "uniqueDateRange": "You can list many sessions across a start–end date range in one preview or CSV export.",
          "uniqueSalesFocus": "The focus is sales accountability totals per session—gross through net, payments, and invoice range—not cash-drawer float counting.",
          "includesBody": "Per session: open/close times and actors, gross/void/refund/net counts and amounts, cash sales, payment totals, and first–last invoice numbers. A period summary aggregates those sessions.",
          "thisPageBody": "Select a register and date range, preview session rows, then use Export for CSV, Excel, Google Sheets, or PDF for supervisor review or evaluation of terminal activity."
        }
      },
      "detailedSalesReport": {
        "documentTitle": "POS Detailed Sales Report",
        "title": "Detailed Sales Report",
        "subtitle": "Line-level sales detail for the selected period.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview report",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export detailed sales report",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "exportCsv": "Export CSV",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load detailed sales report.",
        "exportFailed": "Failed to export detailed sales report.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing detailed sales.",
        "manageRegisters": "Add register",
        "summaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "saleCount": "Sales",
        "completedSaleCount": "Completed sales",
        "voidedSaleCount": "Voided sales",
        "lineCount": "Line items",
        "grossSalesTotal": "Gross sales total",
        "completedSalesTotal": "Completed sales total",
        "voidedSalesTotal": "Voided sales total",
        "discountTotal": "Discount total",
        "noEntries": "No sales for this register and date range.",
        "statusVoided": "Voided",
        "statusCompleted": "Completed",
        "saleHeaderMeta": "Subtotal {{subtotal}} · Discount {{discount}}",
        "columns": {
          "soldAt": "Sold at",
          "invoice": "Invoice / OR",
          "customer": "Customer",
          "payment": "Payment",
          "status": "Status",
          "product": "Product",
          "qty": "Qty",
          "unitPrice": "Unit price",
          "lineTotal": "Line total",
          "saleTotal": "Sale total"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the Detailed Sales Report?",
          "modalTitle": "About Detailed Sales Report",
          "whatItIsBody": "The Detailed Sales Report is the line-level backend sales listing for a register and date range. Each sale shows its invoice header and every product line (quantity, unit price, line total, and VAT fields)—the most granular view for tracing what was sold.",
          "uniqueLineLevel": "Each invoice expands into product lines so you can see quantity, price, and tax fields per item.",
          "uniqueInvoiceLines": "You see invoice number, payment method, discounts, customer (when captured), and per-line VATable / VAT / VAT-exempt amounts.",
          "uniqueVoidVisible": "Voided sales stay listed and marked, so cancelled invoices remain visible in the trail.",
          "uniqueGranular": "Use it when you need to investigate individual receipts and items rather than period totals alone.",
          "includesBody": "Sale count, completed vs voided counts and totals, discount total, and a table of sales with nested line items for the selected period.",
          "thisPageBody": "Choose a register and date range, preview the invoice and line table, then use Export for CSV, Excel, Google Sheets, or PDF when you need a full line-level extract for audit or investigation."
        }
      },
      "itemsSoldLedger": {
        "documentTitle": "POS Items Sold Ledger",
        "title": "Items Sold Ledger",
        "subtitle": "Line-level item sales from the Detailed Sales Report, with product costs and gross profit.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "itemFilterLabel": "Item",
        "itemFilterPlaceholder": "Type to search available items",
        "itemFilterAll": "All",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview report",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export items sold ledger",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel (.xlsx)",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "loadFailed": "Failed to load items sold ledger.",
        "exportFailed": "Failed to export items sold ledger.",
        "loadingRegisters": "Loading registers…",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing items sold.",
        "manageRegisters": "Add register",
        "summaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "reconciliationHint": "Total Sales for the period can be compared with Income Statement revenue for the same period when those sales are on the books.",
        "noEntries": "No item sales for this register and date range.",
        "openingBalanceLabel": "Opening Balance",
        "closingBalanceLabel": "Closing Balance",
        "totalWithoutOpeningBalanceLabel": "Total without Opening Balance",
        "columns": {
          "date": "Date",
          "referenceNumber": "Reference Number",
          "itemName": "Item Name",
          "quantitySold": "Quantity Sold",
          "unitPrice": "Unit Price",
          "productCosts": "Product Costs",
          "totalSales": "Total Sales",
          "grossProfit": "Gross Profit"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the Items Sold Ledger?",
          "modalTitle": "About Items Sold Ledger",
          "whatItIsBody": "The Items Sold Ledger lists each item sold on this register for the selected period, including its date, reference number, quantity, product costs, total sales, and gross profit.",
          "uniqueProductAggregate": "One row per sold item line, so each row can be traced to a date and reference number.",
          "uniqueFromDetailedSales": "Quantities and sales come from completed Detailed Sales Report lines (voided sales are excluded).",
          "uniqueTwoTotals": "The screen shows the closing balance with opening sales and the period total without opening sales. Export includes the closing balance.",
          "includesBody": "Opening balance (sales before the start date), line-level item rows, product costs, period totals, and a closing balance. Gross profit is total sales minus product costs.",
          "thisPageBody": "Choose a register, optionally search for an item, and select a date range. Preview the line-level table, then use Export for CSV, Excel, Google Sheets, or PDF.",
          "sampleExportTitle": "Sample export",
          "sampleExportBody": "Download a fictional example with line-level item rows, tracking dates, references, product costs, opening balance, and closing balance—no live POS sales required.",
          "sampleExportBusy": "Preparing sample…"
        }
      },
      "salesGeneralLedger": {
        "documentTitle": "POS Sales General Ledger",
        "title": "Sales General Ledger",
        "subtitle": "Review, verify, and post POS sales transactions to Accounting.",
        "backToReports": "Back to Reports",
        "tinLabel": "TIN: {{tin}}",
        "dateRangeLabel": "Date Range",
        "datePresetToday": "Today",
        "datePresetThisMonth": "This Month",
        "datePresetLastMonth": "Last Month",
        "datePresetThisYear": "This Year",
        "datePresetCustom": "Custom Range",
        "dateFromLabel": "From",
        "dateToLabel": "To",
        "salesCategoryLabel": "Sales Category",
        "allCategories": "All Categories",
        "searchLabel": "Search",
        "searchPlaceholder": "Search sales reference number, item name, or description...",
        "tabUnposted": "Unposted",
        "tabPosted": "Posted",
        "unpostedSectionTitle": "Unposted Sales Transactions",
        "postedSectionTitle": "Posted Sales Transactions",
        "postedSectionHint": "Sales already posted to accounting.",
        "postedByUnknown": "—",
        "selectionSummary": "{{count}} transactions selected · {{amount}}",
        "selectedCount": "{{count}} selected",
        "selectedDebit": "Combined amount: {{amount}}",
        "postButton": "Post to Accounting",
        "posting": "Posting…",
        "selectSalesToPost": "Select at least one sale to post.",
        "postSuccess": "Posted {{posted}} sale(s).",
        "postSuccessWithSkipped": "Posted {{posted}} sale(s). Skipped {{skipped}}.",
        "postFailed": "Failed to post sales to accounting.",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export sales general ledger",
        "exporting": "Exporting…",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "loadFailed": "Failed to load sales general ledger.",
        "loading": "Loading sales…",
        "retry": "Try again",
        "emptyTitle": "No sales to show",
        "empty": "No sales match these filters.",
        "pageTotals": "Page totals",
        "selectAllAria": "Select all sales on this page",
        "selectRowAria": "Select sale {{ref}}",
        "infoTitle": "About the Sales General Ledger",
        "infoFooter": "Each sale shows a summary description. Expand it to see journal lines: debit the payment method account and credit each product’s sales category. Debits are positive; credits show in parentheses. Posting writes the same entries to Accounting.",
        "saleDescription": "POS Sales Revenue",
        "expandDescriptionAria": "Expand journal lines for sale {{ref}}",
        "collapseDescriptionAria": "Collapse journal lines for sale {{ref}}",
        "editProductCategoryAria": "Edit product sales category for {{category}}",
        "loadProductFailed": "Failed to load product for editing.",
        "nonLeafCategoryFallback": "category",
        "nonLeafToastClickHint": "Click to edit the product category",
        "productChooserTitle": "Choose a product to edit",
        "productChooserHint": "More than one product uses “{{category}}”. Select which product to update.",
        "productChooserCancel": "Cancel",
        "columns": {
          "date": "Date",
          "referenceNumber": "Ref. No.",
          "description": "Description",
          "transactionType": "Transaction Type",
          "amount": "Amount",
          "runningBalance": "Running Balance",
          "postedAt": "Posted Date",
          "postedBy": "Posted By"
        }
      },
      "saleDetail": {
        "documentTitle": "POS Sale",
        "title": "POS Sale",
        "subtitle": "Read-only sale detail for ledger review.",
        "backToLedger": "Back to Sales General Ledger",
        "loading": "Loading sale…",
        "loadFailed": "Failed to load sale.",
        "retry": "Try again",
        "missingSaleId": "Sale id is missing from the URL.",
        "missingSessionContext": "Open this sale from the Sales General Ledger so register and session context can be passed. Sale detail is session-scoped on the API.",
        "invoiceNumber": "Invoice #",
        "soldAt": "Date",
        "paymentMethod": "Payment method",
        "total": "Total",
        "customer": "Customer",
        "sessionScopedNote": "Sale detail is loaded with register and session from the ledger link (?registerId=&sessionId=).",
        "columns": {
          "item": "Item",
          "qty": "Qty",
          "unitPrice": "Unit price",
          "lineTotal": "Line total"
        }
      },
      "xReadingReport": {
        "documentTitle": "POS X-Reading",
        "title": "X-Reading",
        "subtitle": "View and print cashier end-of-shift readings for a register and business date.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "businessDateLabel": "Business date",
        "businessDateHint": "Uses Philippines business day (Asia/Manila). Shows sessions closed on that day.",
        "datePlaceholder": "mm/dd/yyyy",
        "search": "Find readings",
        "loadingRegisters": "Loading registers…",
        "loadingReadings": "Loading readings…",
        "loadFailed": "Failed to load X-Readings.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing X-Readings.",
        "manageRegisters": "Add register",
        "resultsTitle": "{{count}} reading(s) on {{date}}",
        "empty": "No X-Readings for this register on the selected date.",
        "columnReport": "Report",
        "columnClosed": "Closed",
        "columnClosedBy": "Closed by",
        "columnNetSales": "Net sales",
        "reportNumber": "X-Reading #{{number}}",
        "closedAt": "Closed {{datetime}}",
        "samplePageHint": "Need to test your printer before any real sessions are closed?",
        "samplePageLink": "Open sample X-Reading",
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is an X-Reading?",
          "modalTitle": "About X-Reading",
          "whatItIsBody": "An X-Reading is the cashier's accountability / end-of-shift report. It summarizes everything that happened during one open register session—sales, voids, refunds, and the cash drawer count—so the cashier and supervisor can verify the shift before the next person takes over.",
          "uniqueSession": "One X-Reading is created automatically when a register session is closed—not on demand for an open shift.",
          "uniqueCash": "It focuses on cashier accountability: opening float, cash sales, expected drawer cash, ending cash count, and over/short.",
          "uniqueAppendOnly": "Each reading is stored once and cannot be overwritten. Closing another session creates a new reading with the next report number for that register.",
          "uniqueShiftScope": "Scope is one closed cashier session. Several sessions on the same business day each produce their own X-Reading.",
          "includesBody": "Gross sales, voids, refunds, net sales, cash sales, who opened and closed the session, open/close times, cash drawer figures (opening float, expected cash, closing float, over/short), and the register's accumulated grand total at the moment the session ended.",
          "thisPageBody": "Pick a register and the day sessions were closed (Philippines calendar day), then find readings. Results appear below—open a reading to view it; print is optional. If you have not closed a session yet, open the sample X-Reading page to test your printer with fictional sample figures—clearly marked so it is never confused with a live reading."
        }
      },
      "xReadingDetail": {
        "documentTitle": "POS X-Reading",
        "title": "X-Reading",
        "titleWithNumber": "X-Reading #{{number}}",
        "subtitle": "{{register}} — closed {{datetime}}",
        "subtitleLoading": "Loading reading…",
        "backToReport": "Back to X-Reading",
        "backToSearch": "Back to search",
        "loading": "Loading…",
        "loadingPreview": "Loading preview…",
        "loadFailed": "Failed to load this X-Reading.",
        "retry": "Try again",
        "registerNotFound": "That register was not found. Choose another register and try again.",
        "print": "Print",
        "printing": "Printing…",
        "printHint": "Review the reading on screen first. Print only if you need a paper copy."
      },
      "xReadingSample": {
        "documentTitle": "POS Sample X-Reading",
        "title": "Sample X-Reading",
        "subtitle": "Preview and print a clearly marked sample X-Reading to test your printer before any real sessions are closed.",
        "backToXReading": "Back to X-Reading",
        "hint": "This uses fictional sample figures only. It is not saved and is not a live reading.",
        "print": "Print sample",
        "printing": "Printing sample…",
        "loadingPreview": "Loading preview…"
      },
      "scSalesBook": {
        "documentTitle": "POS Senior Citizen Sales Book",
        "title": "Senior Citizen (SC) Sales Book",
        "subtitle": "Generate the statutory sales book for Senior Citizen discount transactions by register and date range.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila). Each row is one sales invoice (Annex E-1), not a product line. Voided invoices remain visible for audit.",
        "preview": "Preview report",
        "exportCsv": "Export CSV",
        "openPdf": "Open PDF",
        "showSamplePdf": "Sample PDF",
        "sampleHint": "Sample PDF opens a clearly marked fictional SC Sales Book so you can check the print layout before live SC transactions exist.",
        "pdfFailed": "Failed to open the SC Sales Book PDF.",
        "pdfBlocked": "Pop-up blocked. Allow pop-ups to view the SC Sales Book PDF.",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load the SC Sales Book.",
        "exportFailed": "Failed to export the SC Sales Book.",
        "exportFailedWithStatus": "SC Sales Book export failed ({{status}}).",
        "selectCompanyBeforeExport": "Select a company before exporting.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before generating an SC Sales Book.",
        "manageRegisters": "Add register",
        "reportTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "completedCount": "Completed SC sales",
        "voidedCount": "Voided SC sales",
        "grossTotal": "Gross total",
        "vatExemptTotal": "VAT-exempt total",
        "discountTotal": "SC discount total",
        "netTotal": "Net total",
        "generatedAt": "Generated",
        "totalsHint": "Summary totals include completed invoices only. VAT-exempt is the pre-discount base so VAT exempt − discount = net. Voided SC invoices remain listed and marked for audit.",
        "signatureNote": "The required Senior Citizen signature remains on the original signed sales invoice and is not reproduced in this backend report.",
        "noEntries": "No Senior Citizen discount sales in this period.",
        "status": {
          "completed": "Completed",
          "voided": "Voided"
        },
        "columns": {
          "soldAt": "Sold at",
          "invoiceNumber": "Invoice",
          "customerName": "Senior citizen",
          "tin": "TIN (if any)",
          "oscaId": "OSCA ID",
          "gross": "Gross",
          "vatable": "VATable",
          "vat": "VAT",
          "vatExempt": "VAT exempt",
          "discountRate": "Discount %",
          "discount": "Discount",
          "net": "Net",
          "status": "Status"
        },
        "help": {
          "iconAriaLabel": "What is the Senior Citizen Sales Book?",
          "modalTitle": "About Senior Citizen (SC) Sales Book",
          "close": "Close",
          "whatItIsTitle": "What it is",
          "whatItIsBody": "The Senior Citizen Sales Book lists POS invoices that received a Senior Citizen discount for a register and date range. It is the statutory sales book used to review SC-discounted sales, identity fields, VAT treatment, and discount amounts.",
          "uniqueTitle": "What makes it unique",
          "uniqueScOnly": "Only invoices with a Senior Citizen discount appear—other sales are excluded from this book.",
          "uniqueInvoiceRows": "Each row is one sales invoice for that discount type—not a product line—so the book matches statutory invoice-level listing.",
          "uniqueOscaId": "Rows include the senior citizen name, OSCA ID, and TIN when captured on the sale.",
          "uniqueStatutory": "It supports the statutory sales-book workflow: on-screen preview, sample PDF layout check, live PDF, and CSV export. Layout follows the SC Sales Book (Annex E-1) invoice listing.",
          "includesTitle": "What the report includes",
          "includesBody": "Period summary totals for completed invoices (gross, VAT-exempt base, discount, net) plus a table of invoice rows including customer identity fields, TIN when present, VAT amounts, discount, net, and void status. Voided invoices remain listed and marked.",
          "thisPageTitle": "Using this page",
          "thisPageBody": "Select a register and date range, preview the book, then open Sample PDF, live PDF, or export CSV. Summary totals include completed invoices only."
        }
      },
      "pwdSalesBook": {
        "documentTitle": "POS PWD Sales Book",
        "title": "Persons with Disability (PWD) Sales Book",
        "subtitle": "Generate the statutory sales book for Persons with Disability discount transactions by register and date range.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila). Each row is one sales invoice (Annex E-2), not a product line. Voided invoices remain visible for audit.",
        "preview": "Preview report",
        "exportCsv": "Export CSV",
        "openPdf": "Open PDF",
        "showSamplePdf": "Sample PDF",
        "sampleHint": "Sample PDF opens a clearly marked fictional PWD Sales Book so you can check the print layout before live PWD transactions exist.",
        "pdfFailed": "Failed to open the PWD Sales Book PDF.",
        "pdfBlocked": "Pop-up blocked. Allow pop-ups to view the PWD Sales Book PDF.",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load the PWD Sales Book.",
        "exportFailed": "Failed to export the PWD Sales Book.",
        "exportFailedWithStatus": "PWD Sales Book export failed ({{status}}).",
        "selectCompanyBeforeExport": "Select a company before exporting.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before generating a PWD Sales Book.",
        "manageRegisters": "Add register",
        "reportTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "completedCount": "Completed PWD sales",
        "voidedCount": "Voided PWD sales",
        "grossTotal": "Gross total",
        "vatExemptTotal": "VAT-exempt total",
        "discountTotal": "PWD discount total",
        "netTotal": "Net total",
        "generatedAt": "Generated",
        "totalsHint": "Summary totals include completed invoices only. VAT-exempt is the pre-discount base so VAT exempt − discount = net. Voided PWD invoices remain listed and marked for audit.",
        "signatureNote": "The required PWD signature remains on the original signed sales invoice and is not reproduced in this backend report.",
        "noEntries": "No PWD discount sales in this period.",
        "status": {
          "completed": "Completed",
          "voided": "Voided"
        },
        "columns": {
          "soldAt": "Sold at",
          "invoiceNumber": "Invoice",
          "customerName": "PWD name",
          "tin": "TIN (if any)",
          "pwdId": "PWD ID",
          "gross": "Gross",
          "vatable": "VATable",
          "vat": "VAT",
          "vatExempt": "VAT exempt",
          "discountRate": "Discount %",
          "discount": "Discount",
          "net": "Net",
          "status": "Status"
        },
        "help": {
          "iconAriaLabel": "What is the PWD Sales Book?",
          "modalTitle": "About PWD Sales Book",
          "close": "Close",
          "whatItIsTitle": "What it is",
          "whatItIsBody": "The PWD Sales Book lists POS invoices that received a Persons with Disability discount for a register and date range. It is the statutory sales book used to review PWD-discounted sales, identity fields, VAT treatment, and discount amounts.",
          "uniqueTitle": "What makes it unique",
          "uniquePwdOnly": "Only invoices with a PWD discount appear—other sales are excluded from this book.",
          "uniqueInvoiceRows": "Each row is one sales invoice for that discount type—not a product line—so the book matches statutory invoice-level listing.",
          "uniquePwdId": "Rows include the PWD name, PWD ID, and TIN when captured on the sale.",
          "uniqueStatutory": "It supports the statutory sales-book workflow: on-screen preview, sample PDF layout check, live PDF, and CSV export. Layout follows the PWD Sales Book (Annex E-2) invoice listing.",
          "includesTitle": "What the report includes",
          "includesBody": "Period summary totals for completed invoices (gross, VAT-exempt base, discount, net) plus a table of invoice rows including customer identity fields, TIN when present, VAT amounts, discount, net, and void status. Voided invoices remain listed and marked.",
          "thisPageTitle": "Using this page",
          "thisPageBody": "Select a register and date range, preview the book, then open Sample PDF, live PDF, or export CSV. Summary totals include completed invoices only."
        }
      },
      "naacSalesBook": {
        "documentTitle": "POS NAAC Sales Book",
        "title": "National Athletes and Coaches (NAAC) Sales Book",
        "subtitle": "Generate the statutory sales book for National Athletes and Coaches discount transactions by register and date range.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila). Each row is one sales invoice (Annex E-4), not a product line. Voided invoices remain visible for audit.",
        "preview": "Preview report",
        "exportCsv": "Export CSV",
        "openPdf": "Open PDF",
        "showSamplePdf": "Sample PDF",
        "sampleHint": "Sample PDF opens a clearly marked fictional NAAC Sales Book so you can check the print layout before live NAAC transactions exist.",
        "pdfFailed": "Failed to open the NAAC Sales Book PDF.",
        "pdfBlocked": "Pop-up blocked. Allow pop-ups to view the NAAC Sales Book PDF.",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load the NAAC Sales Book.",
        "exportFailed": "Failed to export the NAAC Sales Book.",
        "exportFailedWithStatus": "NAAC Sales Book export failed ({{status}}).",
        "selectCompanyBeforeExport": "Select a company before exporting.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before generating a NAAC Sales Book.",
        "manageRegisters": "Add register",
        "reportTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "completedCount": "Completed NAAC sales",
        "voidedCount": "Voided NAAC sales",
        "grossTotal": "Gross total",
        "vatExemptTotal": "VAT-exempt total",
        "discountTotal": "NAAC discount total",
        "netTotal": "Net total",
        "generatedAt": "Generated",
        "totalsHint": "Summary totals include completed invoices only. VAT-exempt is the pre-discount base so VAT exempt − discount = net. Voided NAAC invoices remain listed and marked for audit.",
        "signatureNote": "The required NAAC signature remains on the original signed sales invoice and is not reproduced in this backend report.",
        "noEntries": "No NAAC discount sales in this period.",
        "status": {
          "completed": "Completed",
          "voided": "Voided"
        },
        "columns": {
          "soldAt": "Sold at",
          "invoiceNumber": "Invoice",
          "customerName": "National athlete/coach",
          "tin": "TIN (if any)",
          "naacId": "PNSTM ID",
          "gross": "Gross",
          "vatable": "VATable",
          "vat": "VAT",
          "vatExempt": "VAT exempt",
          "discountRate": "Discount %",
          "discount": "Discount",
          "net": "Net",
          "status": "Status"
        },
        "help": {
          "iconAriaLabel": "What is the NAAC Sales Book?",
          "modalTitle": "About NAAC Sales Book",
          "close": "Close",
          "whatItIsTitle": "What it is",
          "whatItIsBody": "The NAAC Sales Book lists POS invoices that received a National Athletes and Coaches (NAAC) discount for a register and date range. It is the statutory sales book used to review NAAC-discounted sales, identity fields, VAT treatment, and discount amounts.",
          "uniqueTitle": "What makes it unique",
          "uniqueNaacOnly": "Only invoices with an NAAC discount appear—other sales are excluded from this book.",
          "uniqueInvoiceRows": "Each row is one sales invoice for that discount type—not a product line—so the book matches statutory invoice-level listing.",
          "uniquePnstmId": "Rows include the beneficiary name, PNSTM ID, and TIN when captured on the sale.",
          "uniqueStatutory": "It supports the statutory sales-book workflow: on-screen preview, sample PDF layout check, live PDF, and CSV export. Layout follows the NAAC Sales Book (Annex E-4) invoice listing.",
          "includesTitle": "What the report includes",
          "includesBody": "Period summary totals for completed invoices (gross, VAT-exempt base, discount, net) plus a table of invoice rows including customer identity fields, TIN when present, VAT amounts, discount, net, and void status. Voided invoices remain listed and marked.",
          "thisPageTitle": "Using this page",
          "thisPageBody": "Select a register and date range, preview the book, then open Sample PDF, live PDF, or export CSV. Summary totals include completed invoices only."
        }
      },
      "soloParentSalesBook": {
        "documentTitle": "POS Solo Parent Sales Book",
        "title": "Solo Parent Sales Book",
        "subtitle": "Generate the statutory sales book for Solo Parent discount transactions by register and date range.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila). Each row is one sales invoice (Annex E-5), not a product line. Voided invoices remain visible for audit.",
        "preview": "Preview report",
        "exportCsv": "Export CSV",
        "openPdf": "Open PDF",
        "showSamplePdf": "Sample PDF",
        "sampleHint": "Sample PDF opens a clearly marked fictional Solo Parent Sales Book so you can check the print layout before live Solo Parent transactions exist.",
        "pdfFailed": "Failed to open the Solo Parent Sales Book PDF.",
        "pdfBlocked": "Pop-up blocked. Allow pop-ups to view the Solo Parent Sales Book PDF.",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load the Solo Parent Sales Book.",
        "exportFailed": "Failed to export the Solo Parent Sales Book.",
        "exportFailedWithStatus": "Solo Parent Sales Book export failed ({{status}}).",
        "selectCompanyBeforeExport": "Select a company before exporting.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before generating a Solo Parent Sales Book.",
        "manageRegisters": "Add register",
        "reportTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "completedCount": "Completed Solo Parent sales",
        "voidedCount": "Voided Solo Parent sales",
        "grossTotal": "Gross total",
        "vatExemptTotal": "VAT-exempt total",
        "discountTotal": "Solo Parent discount total",
        "netTotal": "Net total",
        "generatedAt": "Generated",
        "totalsHint": "Summary totals include completed invoices only. VAT-exempt is the pre-discount base so VAT exempt − discount = net. Voided Solo Parent invoices remain listed and marked for audit.",
        "signatureNote": "The required Solo Parent signature remains on the original signed sales invoice and is not reproduced in this backend report.",
        "noEntries": "No Solo Parent discount sales in this period.",
        "status": {
          "completed": "Completed",
          "voided": "Voided"
        },
        "columns": {
          "soldAt": "Sold at",
          "invoiceNumber": "Invoice",
          "customerName": "Solo parent",
          "tin": "TIN (if any)",
          "soloParentId": "Solo Parent ID",
          "gross": "Gross",
          "vatable": "VATable",
          "vat": "VAT",
          "vatExempt": "VAT exempt",
          "discountRate": "Discount %",
          "discount": "Discount",
          "net": "Net",
          "status": "Status"
        },
        "help": {
          "iconAriaLabel": "What is the Solo Parent Sales Book?",
          "modalTitle": "About Solo Parent Sales Book",
          "close": "Close",
          "whatItIsTitle": "What it is",
          "whatItIsBody": "The Solo Parent Sales Book lists POS invoices that received a Solo Parent discount for a register and date range. It is the statutory sales book used to review Solo Parent-discounted sales, identity fields, VAT treatment, and discount amounts.",
          "uniqueTitle": "What makes it unique",
          "uniqueSoloParentOnly": "Only invoices with a Solo Parent discount appear—other sales are excluded from this book.",
          "uniqueInvoiceRows": "Each row is one sales invoice for that discount type—not a product line—so the book matches statutory invoice-level listing.",
          "uniqueSoloParentId": "Rows include the solo parent name, Solo Parent ID, and TIN when captured on the sale.",
          "uniqueStatutory": "It supports the statutory sales-book workflow: on-screen preview, sample PDF layout check, live PDF, and CSV export. Layout follows the Solo Parent Sales Book (Annex E-5) invoice listing.",
          "includesTitle": "What the report includes",
          "includesBody": "Period summary totals for completed invoices (gross, VAT-exempt base, discount, net) plus a table of invoice rows including customer identity fields, TIN when present, VAT amounts, discount, net, and void status. Voided invoices remain listed and marked.",
          "thisPageTitle": "Using this page",
          "thisPageBody": "Select a register and date range, preview the book, then open Sample PDF, live PDF, or export CSV. Summary totals include completed invoices only."
        }
      },
      "salesBookTable": {
        "expandEntry": "Show full details for invoice {{invoice}}",
        "collapseEntry": "Hide full details for invoice {{invoice}}",
        "paymentMethod": "Payment method",
        "customerAddress": "Customer address",
        "voidedAt": "Voided at",
        "verificationSeal": "Verification seal"
      },
      "adjustmentReportTable": {
        "expandEntry": "Show full details for {{document}}",
        "collapseEntry": "Hide full details for {{document}}",
        "lineItems": "Line items"
      },
      "voidReport": {
        "documentTitle": "POS Void Report",
        "title": "Void Report",
        "subtitle": "List voided invoices for a register and date range. Generate, print, or export anytime for audit.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila). Includes voids by void date, even if the original sale was on an earlier day.",
        "preview": "Preview report",
        "exportCsv": "Export CSV",
        "openPdf": "Open PDF",
        "showSamplePdf": "Sample PDF",
        "sampleHint": "Sample PDF opens a clearly marked fictional Void Report as a PDF so you can check the print layout before any real voids exist.",
        "sampleBanner": "SAMPLE ONLY — fictional data for layout preview. Not a live sales void report.",
        "samplePrintTitle": "POS Void Report (SAMPLE)",
        "sampleSupervisorLabel": "Dummy supervisor",
        "sampleSupervisorHint": "Supervisor void override is not live yet. Sample table uses dummy Authorized by SUP_01 (cashier CASHIER_01).",
        "printTitle": "POS Void Report",
        "pdfFailed": "Failed to open Void Report PDF.",
        "pdfBlocked": "Pop-up blocked. Allow pop-ups to view the Void Report PDF.",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load Void Report.",
        "exportFailed": "Failed to export Void Report.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before generating a Void Report.",
        "manageRegisters": "Add register",
        "reportTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "voidCount": "Void count",
        "voidTotal": "Void total",
        "generatedAt": "Generated",
        "noVoids": "No voids in this period.",
        "columns": {
          "voidedAt": "Voided at",
          "documentNumber": "Void document",
          "invoiceNumber": "Invoice",
          "product": "Product",
          "quantity": "Qty",
          "soldAt": "Sold at",
          "amount": "Amount",
          "paymentMethod": "Payment",
          "voidedBy": "Voided by",
          "authorizedBy": "Authorized by",
          "vatAmount": "VAT",
          "reason": "Reason"
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is the Void Report?",
          "modalTitle": "About Void Report",
          "whatItIsBody": "The Void Report lists cancelled (voided) POS sales for a register over a date range. It is the dedicated audit view for voided invoices—who voided them, when, why, and the amounts removed from sales.",
          "uniqueVoidsOnly": "Only voided sales appear here, so you can review cancellations without scanning completed receipts.",
          "uniqueVoidDate": "Rows are filtered by void date. A sale voided later still appears under the day it was voided.",
          "uniqueReasonActor": "Each void shows the actor, timestamp, reason (when captured), and the original invoice details.",
          "uniqueAuditKeep": "Voided invoices remain listed for audit; they are not hidden after cancellation.",
          "includesBody": "Void count and total amount for the period, plus a table of voided invoices with void time, original sale time, invoice number, amounts, reason, and who performed the void.",
          "thisPageBody": "Choose a register and date range, preview the voids, then open PDF or export CSV when you need a printable audit copy. Use Sample PDF to check layout with fictional figures."
        }
      },
      "refundReport": {
        "documentTitle": "POS Sales Return / Refund Report",
        "title": "Sales Return / Refund Report",
        "subtitle": "List sales returns and refunds for a register and date range. Generate, print, or export anytime for audit.",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila). Includes refunds by refund date, even if the original sale was on an earlier day. Partial refunds are included.",
        "preview": "Preview report",
        "exportCsv": "Export CSV",
        "openPdf": "Open PDF",
        "showSamplePdf": "Sample PDF",
        "sampleHint": "Sample PDF opens a clearly marked fictional Sales Return / Refund Report so you can check the print layout before any real refunds exist.",
        "pdfFailed": "Failed to open the Sales Return / Refund Report PDF.",
        "pdfBlocked": "Pop-up blocked. Allow pop-ups to view the Sales Return / Refund Report PDF.",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load the Sales Return / Refund Report.",
        "exportFailed": "Failed to export the Sales Return / Refund Report.",
        "exportFailedWithStatus": "Sales Return / Refund Report export failed ({{status}}).",
        "selectCompanyBeforeExport": "Select a company before exporting.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before generating a Sales Return / Refund Report.",
        "manageRegisters": "Add register",
        "reportTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "refundCount": "Refund count",
        "refundTotal": "Refund total",
        "generatedAt": "Generated",
        "noRefunds": "No refunds in this period.",
        "restockYes": "Yes",
        "restockNo": "No",
        "columns": {
          "refundedAt": "Refunded at",
          "documentNumber": "Refund document",
          "invoiceNumber": "Invoice",
          "product": "Product",
          "quantity": "Qty",
          "soldAt": "Sold at",
          "amount": "Amount",
          "paymentMethod": "Payment",
          "restock": "Restock",
          "vatAmount": "VAT",
          "reason": "Reason"
        },
        "help": {
          "iconAriaLabel": "What is the Sales Return / Refund Report?",
          "modalTitle": "About Sales Return / Refund Report",
          "close": "Close",
          "whatItIsTitle": "What it is",
          "whatItIsBody": "The Sales Return / Refund Report lists POS refunds and sales returns for a register over a date range. It is the dedicated audit view for money and stock returned after a sale—when the refund happened, which invoice it relates to, amounts, and restock details.",
          "uniqueTitle": "What makes it unique",
          "uniqueRefundsOnly": "Only refund and sales-return rows appear here, so you can review returns without scanning completed sales.",
          "uniqueRefundDate": "Rows are filtered by refund date. A refund posted later still appears under the day it was refunded, even if the original sale was earlier.",
          "uniquePartial": "Partial refunds are included alongside full returns, with quantity and amount for each refunded line.",
          "uniqueRestock": "Each row shows whether inventory was restocked, the refund document number, payment method, VAT, and reason when captured.",
          "includesTitle": "What the report includes",
          "includesBody": "Refund count and total for the period, plus a table of refund lines with refund time, document number, original invoice, product, quantity, original sold-at time, amount, payment method, restock flag, VAT, and reason.",
          "thisPageTitle": "Using this page",
          "thisPageBody": "Choose a register and date range, preview the refunds, then open PDF or export CSV when you need a printable audit copy. Use Sample PDF to check layout with fictional figures."
        }
      },
      "zReadingReport": {
        "documentTitle": "POS Z-Reading",
        "title": "Z-Reading",
        "subtitle": "End-of-day readings for your registers. Filter the table, open any row to view or reprint, or generate a Z for a business date.",
        "backToReports": "Back to Reports",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "registerLabel": "Register",
        "allRegisters": "All registers",
        "businessDateLabel": "Business date",
        "dateFromLabel": "From date",
        "dateToLabel": "To date",
        "zCounterLabel": "Z-counter",
        "zCounterPlaceholder": "Any",
        "datePlaceholder": "mm/dd/yyyy",
        "applyFilters": "Apply filters",
        "clearFilters": "Clear filters",
        "generateButton": "Generate Z-Reading",
        "generateSuccess": "Z-Reading generated.",
        "reprintSuccess": "Opening existing Z-Reading for reprint.",
        "generateFailed": "Failed to generate Z-Reading.",
        "loadingRegisters": "Loading registers…",
        "loadingReadings": "Loading Z-Readings…",
        "loadFailed": "Failed to load Z-Readings.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before viewing Z-Readings.",
        "manageRegisters": "Add register",
        "tableEmpty": "No Z-Readings match these filters. Generate one for a business date after sessions are closed.",
        "columnBusinessDate": "Business date",
        "columnRegister": "Register",
        "columnReport": "Report",
        "columnGenerated": "Generated",
        "columnGeneratedBy": "Generated by",
        "columnNetSales": "Net sales",
        "reportNumber": "Z-Reading #{{number}}",
        "generatedAt": "Generated {{datetime}}",
        "samplePageHint": "Need to test your printer before any day-end close?",
        "samplePageLink": "Open sample Z-Reading",
        "generateModal": {
          "title": "Generate Z-Reading",
          "intro": "Choose the register. The status below shows whether a Z-Reading can be generated and which business date will be closed. The date is set automatically and cannot be changed.",
          "cancel": "Cancel",
          "submit": "Generate Z-Reading",
          "loadingRequiredDate": "Checking this register for the next day that needs a Z-Reading…",
          "requiredDateFailed": "Failed to load the required business date.",
          "noPriorZ": "none yet",
          "statusLoadingTitle": "Checking register…",
          "statusLoadingHeadline": "Checking register…",
          "statusReadyTitle": "Ready to generate",
          "statusReadyHeadline": "Closing {{date}}",
          "statusReadyBody": "This will generate the Z-Reading for that business date (next activity day after last Z: {{lastZ}}). Empty days with no sales or sessions are skipped.",
          "statusOpenSessionTitle": "Cannot generate — session still open",
          "statusOpenSessionHeadline": "Session still open",
          "statusOpenSessionBody": "This register has an open cashier session. Close the session first, then generate the Z-Reading. Last Z: {{lastZ}}.",
          "goToRegisterCta": "Go to register",
          "statusNoActivityTitle": "Cannot generate — no activity yet",
          "statusNoActivityHeadline": "No activity yet",
          "statusNoActivityBody": "This register has no sales and no register sessions. There is nothing to include in a Z-Reading until the register is used.",
          "statusUpToDateTitle": "Cannot generate — already up to date",
          "statusUpToDateHeadline": "Day already closed",
          "statusUpToDateBody": "Every day with sales or sessions already has a Z-Reading. Last Z business date: {{lastZ}}. Generate again only after new activity on a later day.",
          "statusErrorTitle": "Cannot generate — check failed",
          "statusErrorHeadline": "Check failed",
          "statusUnavailableTitle": "Cannot generate",
          "statusUnavailableHeadline": "Cannot generate",
          "statusUnavailableBody": "No business date is available to close for this register right now.",
          "disabledWaiting": "Generate is disabled while the system finds the next required business date.",
          "disabledLoadFailed": "Generate is disabled because the next business date could not be loaded. Close this dialog and try again.",
          "disabledOpenSession": "Generate is disabled because the register session is still open. Close the session first.",
          "disabledNoActivity": "Generate is disabled because this register has no sales or sessions to close.",
          "disabledUpToDate": "Generate is disabled because all activity days already have a Z-Reading.",
          "disabledUnavailable": "Generate is disabled because there is nothing to close."
        },
        "help": {
          "close": "Close",
          "whatItIsTitle": "What it is",
          "uniqueTitle": "What makes it unique",
          "includesTitle": "What the report includes",
          "thisPageTitle": "Using this page",
          "iconAriaLabel": "What is a Z-Reading?",
          "modalTitle": "About Z-Reading",
          "whatItIsBody": "A Z-Reading is the register's end-of-day (EOD) report. It summarizes that business day's sales, voids, refunds, returns, VAT breakdown, payment modes, AGT previous/present, Z-counter, and reset counters when applicable.",
          "uniqueDayEnd": "It closes the business day for the register—covering the whole day's activity, not a single cashier shift.",
          "uniqueOnce": "There is at most one final Z-Reading per register per business date. Generate / Reprint for the same day opens the existing reading and does not advance the Z-counter again.",
          "uniqueDayLock": "After a Z for a business date, that day is locked—no new sales, sessions, voids, or refunds can post to it. Further selling must use a later business date.",
          "uniqueCounters": "The first successful generate for a date advances the Z-counter sequentially and stores present AGT and invoice range for that day only.",
          "uniqueAudit": "The report keeps an audit trail of when it was actually generated and by whom, even if that is after the business date.",
          "includesBody": "Z-counter, business date, AGT before/after, invoice range, gross/void/refund/net sales, VAT breakdown, payment mode totals, and reset counters when used.",
          "thisPageBody": "The table lists every generated Z-Reading, newest business date first. Filter by register, date range, or Z-counter. Click a row to view or reprint. Generate Z-Reading closes the next required activity day after the last Z (date is fixed; empty days are skipped). Prefer closing dates in order. Use the sample page to test your printer with fictional figures.",
          "whenToRunTitle": "When to run it",
          "whenToRunCutoff": "Run it at close of the business day using your store's cutoff—not necessarily midnight. A shop closing at 9 PM can run around 9 PM; a 24-hour store should use one consistent daily cutoff.",
          "whenToRunManual": "Manual generate is fine. The system does not have to auto-run Z at a fixed clock time.",
          "whenToRunLate": "If staff forget, generate it later for the correct business date (for example run July 17's Z on July 18, still tagged as July 17). Do not merge two days into one Z. Each day's Z only includes that day's sales."
        }
      },
      "zReadingDetail": {
        "documentTitle": "POS Z-Reading",
        "title": "Z-Reading",
        "titleWithNumber": "Z-Reading #{{number}}",
        "subtitle": "{{register}} — generated {{datetime}}",
        "subtitleLoading": "Loading reading…",
        "backToReport": "Back to Z-Reading",
        "backToList": "Back to Z-Reading list",
        "loading": "Loading…",
        "loadingPreview": "Loading preview…",
        "loadFailed": "Failed to load this Z-Reading.",
        "retry": "Try again",
        "registerNotFound": "That register was not found. Choose another register and try again.",
        "print": "Print",
        "printing": "Printing…",
        "printHint": "Review the reading on screen first. Print only if you need a paper copy.",
        "printRecordFailed": "Could not record this print. Please try again.",
        "printHistory": "Printed {{count}} time(s).",
        "printHistoryWithActor": "Printed {{count}} time(s). Last printed {{datetime}} by {{actor}}.",
        "printHistoryUnknownActor": "an unknown user"
      },
      "zReadingSample": {
        "documentTitle": "POS Sample Z-Reading",
        "title": "Sample Z-Reading",
        "subtitle": "Preview and print a clearly marked sample Z-Reading to test your printer before any real day-end close.",
        "backToZReading": "Back to Z-Reading",
        "hint": "This uses fictional sample figures only. It is not saved and is not a live reading.",
        "print": "Print sample",
        "printing": "Printing sample…",
        "loadingPreview": "Loading preview…"
      },
      "birReports": {
        "documentTitle": "POS Backend Report",
        "title": "Backend Report",
        "subtitle": "Sales summary, void report, and statutory discount books for a register and date range.",
        "backToHub": "Back to POS",
        "backToReports": "Back to Reports",
        "registerLabel": "Register",
        "startDateLabel": "Start date",
        "endDateLabel": "End date",
        "dateRangeHint": "Uses Philippines business day (Asia/Manila).",
        "preview": "Preview reports",
        "exportCsv": "Export CSV",
        "loadingRegisters": "Loading registers…",
        "loadFailed": "Failed to load BIR reports.",
        "exportFailed": "Failed to export BIR reports.",
        "retry": "Try again",
        "noRegisters": "No active registers. Add a register before generating BIR reports.",
        "manageRegisters": "Add register",
        "salesSummaryTitle": "{{name}} — {{startDate}} to {{endDate}}",
        "grossSales": "Gross sales (count / total)",
        "voids": "Voids (count / total)",
        "refunds": "Refunds (count / total)",
        "netSales": "Net sales (count / total)",
        "vatableSales": "VATable sales",
        "vatAmount": "VAT amount",
        "vatExemptSales": "VAT-exempt sales",
        "invoiceRange": "Invoice range",
        "voidReportTitle": "Void report",
        "noVoids": "No voids in this period.",
        "voidedAt": "Voided at",
        "invoiceNumber": "Invoice",
        "amount": "Amount",
        "reason": "Reason",
        "discountBooksTitle": "Discount books",
        "discountBooksHint": "SC, PWD, NAAC, and Solo Parent entries appear when captured at checkout (receipt hardening).",
        "noDiscountEntries": "No entries in this period.",
        "soldAt": "Sold at",
        "customer": "Customer",
        "discountAmount": "Discount",
        "netAmount": "Net",
        "discountBooks": {
          "sc": "Senior Citizen (SC)",
          "pwd": "Person with Disability (PWD)",
          "naac": "National Athletes and Coaches (NAAC)",
          "soloParent": "Solo Parent"
        }
      },
      "inventory": {
        "documentTitle": "View Inventory",
        "pageTitle": "View Inventory",
        "subtitle": "{{count}} on-hand stock rows across your warehouses",
        "helpLink": {
          "ariaLabel": "Open POS inventory user guide"
        },
        "backToHub": "Back to POS",
        "backToHubAriaLabel": "Back to POS hub",
        "manageProductsLink": "Manage POS products",
        "boundaryNotice": "Inventory shows POS stock on hand (append-only movement ledger). It does not post to the general ledger or use legacy company inventory. Completing a POS sale deducts stock here; combo sales deduct their components. To change quantities, use Receive Stock, transfers, or stock counts.",
        "loading": "Loading inventory…",
        "retry": "Try again",
        "searchPlaceholder": "Search by product or variant…",
        "searchAriaLabel": "Search inventory rows",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "clearFiltersButton": "Clear filters",
        "warehouseFilterLabel": "Warehouse",
        "warehouseFilterAriaLabel": "Filter by warehouse",
        "warehouseFilterAllOption": "All warehouses",
        "supplierFilterLabel": "Supplier",
        "supplierFilterAriaLabel": "Filter by supplier",
        "supplierFilterAllOption": "All suppliers",
        "stockFilterLabel": "Stock filter",
        "outOfStockFilter": "Out of stock",
        "lowStockFilter": "Low stock",
        "stockFilterModeHint": {
          "inactive": "Click to include {{name}}",
          "include": "Including {{name}} — click to exclude",
          "exclude": "Excluding {{name}} — click to clear"
        },
        "lowStockSubtitle": "{{count}} items below their reorder point",
        "lowStockEmpty": "Nothing is below its reorder point right now.",
        "lowStockCardMeta": "{{warehouse}} · {{stock}} · Min {{min}} · Reorder to {{reorderTo}}",
        "receiveStockButton": "Receive",
        "empty": "No stock recorded yet. Receive stock to get started.",
        "emptySearch": "No rows match your filters.",
        "historyRow": "History",
        "historyRowAriaLabel": "View stock history for {{name}}",
        "cardMeta": "{{variant}} · {{stock}}",
        "cardMetaWithWarehouse": "{{warehouse}} · {{variant}} · {{stock}}",
        "table": {
          "name": "Product",
          "variant": "Variant",
          "warehouse": "Warehouse",
          "stock": "On hand / available",
          "minQuantity": "Min",
          "reorderTo": "Reorder to",
          "actions": "Actions"
        },
        "stockUnits": "{{count}} units",
        "history": {
          "documentTitle": "Stock history",
          "title": "{{name}}",
          "titleWithVariant": "{{name}} ({{variant}})",
          "titleFallback": "Stock history",
          "skuLabel": "SKU: {{sku}}",
          "subtitle": "Movement log for this product: who changed stock, by how much, and why.",
          "tabs": {
            "movement": "Movement",
            "history": "History"
          },
          "movement": {
            "dateFrom": "Received from",
            "dateTo": "Received to",
            "receivedAt": "Date & time received",
            "unitCost": "Cost amount per unit",
            "quantityReceived": "Qty received",
            "quantityConsumed": "Qty consumed",
            "remainingStocks": "Remaining stocks",
            "empty": "No inventory receipts match these dates.",
            "outputList": "Output / Usage History",
            "qtyUsed": "Qty Used",
            "outputDateTime": "Date & Time",
            "outputReason": "Reason",
            "outputEmpty": "No consumption recorded for this lot."
          },
          "back": "Back to inventory",
          "backAriaLabel": "Back to inventory",
          "loading": "Loading history…",
          "empty": "No stock movements recorded for this item yet.",
          "loadError": "Failed to load stock history.",
          "retry": "Try again",
          "notAvailable": "—",
          "expandRowAriaLabel": "Show details for {{type}}",
          "collapseRowAriaLabel": "Hide details for {{type}}",
          "table": {
            "type": "Type",
            "change": "Change",
            "total": "Total",
            "when": "Date & time",
            "reason": "Reason",
            "recordedBy": "Recorded by"
          },
          "movementType": {
            "receive": "Receive",
            "adjust": "Adjust",
            "sale": "Sale",
            "saleReversal": "Sale reversal",
            "transferOut": "Transfer out",
            "transferIn": "Transfer in",
            "count": "Stock count"
          }
        }
      },
      "warehouses": {
        "documentTitle": "Warehouses",
        "pageTitle": "Warehouses",
        "subtitle": "{{count}} warehouses",
        "backToHub": "Back to POS",
        "backToHubAriaLabel": "Back to POS hub",
        "loading": "Loading warehouses…",
        "retry": "Try again",
        "loadError": "Failed to load warehouses.",
        "empty": "No warehouses yet. Create one to start receiving stock.",
        "emptySearch": "No warehouses match your filters.",
        "searchPlaceholder": "Search by name or code…",
        "searchAriaLabel": "Search warehouses by name or code",
        "statusFilterAriaLabel": "Filter by warehouse status",
        "statusFilterActive": "Active",
        "statusFilterArchived": "Archived",
        "statusFilterAll": "All statuses",
        "createButton": "Add warehouse",
        "editButton": "Edit",
        "binsButton": "Bins",
        "setDefaultButton": "Set default",
        "archiveButton": "Archive",
        "defaultBadge": "Default",
        "statusActive": "Active",
        "statusArchived": "Archived",
        "actionError": "This action failed. Try again.",
        "table": {
          "name": "Name",
          "code": "Code",
          "status": "Status"
        },
        "form": {
          "createTitle": "Add warehouse",
          "editTitle": "Edit warehouse",
          "nameLabel": "Name",
          "namePlaceholder": "e.g. Main store",
          "codeLabel": "Code",
          "codePlaceholder": "e.g. MAIN",
          "addressLabel": "Address",
          "addressPlaceholder": "Street, city (optional)",
          "isDefaultLabel": "Set as default warehouse",
          "cancel": "Cancel",
          "save": "Save",
          "errors": {
            "nameRequired": "Name is required.",
            "saveFailed": "Failed to save warehouse."
          }
        }
      },
      "reorderRules": {
        "documentTitle": "Reorder rules",
        "pageTitle": "Reorder rules",
        "subtitle": "{{count}} rules",
        "backToHub": "Back to POS",
        "backToHubAriaLabel": "Back to POS hub",
        "loading": "Loading reorder rules…",
        "retry": "Try again",
        "loadError": "Failed to load reorder rules.",
        "actionError": "This action failed. Try again.",
        "empty": "No reorder rules yet. Add one so Low stock can flag products below their minimum.",
        "emptySearch": "No reorder rules match your filters.",
        "searchPlaceholder": "Search by product or warehouse…",
        "searchAriaLabel": "Search reorder rules by product or warehouse",
        "warehouseFilterAriaLabel": "Filter by warehouse",
        "warehouseFilterAll": "All warehouses",
        "createButton": "Add rule",
        "editButton": "Edit",
        "deleteButton": "Delete",
        "deleteConfirmTitle": "Delete reorder rule?",
        "deleteConfirmMessage": "Remove the reorder rule for {{product}} at {{warehouse}}?",
        "deleteConfirmButton": "Delete",
        "deleting": "Deleting…",
        "table": {
          "product": "Product",
          "warehouse": "Warehouse",
          "minQuantity": "Minimum",
          "reorderTo": "Reorder to",
          "actions": "Actions"
        },
        "form": {
          "createTitle": "Add reorder rule",
          "editTitle": "Edit reorder rule",
          "warehouseLabel": "Warehouse",
          "warehousePlaceholder": "Select warehouse",
          "productLabel": "Product",
          "productPlaceholder": "Select product",
          "variantPlaceholder": "All variants / no variant",
          "minQuantityLabel": "Minimum quantity",
          "minQuantityPlaceholder": "e.g. 10",
          "minQuantityHint": "Low stock triggers when on-hand is at or below this amount.",
          "reorderToLabel": "Reorder to (optional)",
          "reorderToPlaceholder": "e.g. 50",
          "reorderToHint": "Suggested restock target shown on low-stock views.",
          "cancel": "Cancel",
          "save": "Save",
          "errors": {
            "warehouseRequired": "Warehouse is required.",
            "productRequired": "Product is required.",
            "minQuantityInvalid": "Enter a minimum quantity greater than zero.",
            "reorderToInvalid": "Reorder-to must be zero or greater.",
            "saveFailed": "Failed to save reorder rule."
          }
        }
      },
      "warehouseBins": {
        "documentTitle": "Warehouse bins",
        "pageTitle": "Bins — {{name}}",
        "subtitle": "{{count}} bins",
        "helpLink": {
          "ariaLabel": "What are warehouse bins?"
        },
        "back": "Back to warehouses",
        "loading": "Loading bins…",
        "loadError": "Failed to load bins.",
        "actionError": "This action failed. Try again.",
        "empty": "No bins yet. Add one below.",
        "archivedBadge": "Archived",
        "archiveButton": "Archive",
        "table": {
          "code": "Code",
          "name": "Name"
        },
        "form": {
          "title": "Add bin",
          "codeLabel": "Code",
          "codePlaceholder": "e.g. A1",
          "nameLabel": "Name",
          "namePlaceholder": "e.g. Aisle A / Shelf 1",
          "addButton": "Add bin",
          "errors": {
            "required": "Code and name are required.",
            "codeRequired": "Code is required.",
            "nameRequired": "Name is required.",
            "saveFailed": "Failed to add bin."
          }
        }
      },
      "inventoryForms": {
        "fieldLengthHint": "{{count}} / {{max}} characters"
      },
      "transfers": {
        "documentTitle": "Transfers",
        "pageTitle": "Transfers",
        "subtitle": "{{count}} transfers",
        "backToHub": "Back to POS",
        "loading": "Loading transfers…",
        "loadError": "Failed to load transfers.",
        "retry": "Try again",
        "empty": "No transfers yet.",
        "createButton": "New transfer",
        "viewButton": "View",
        "status": {
          "draft": "Draft",
          "in_transit": "In transit",
          "received": "Received",
          "voided": "Voided"
        },
        "table": {
          "from": "From",
          "to": "To",
          "status": "Status",
          "createdAt": "Created"
        },
        "form": {
          "documentTitle": "New transfer",
          "title": "New transfer",
          "subtitle": "Ship stock from one warehouse to another.",
          "back": "Back to transfers",
          "fromWarehouseLabel": "From warehouse",
          "fromWarehousePlaceholder": "Select a warehouse",
          "toWarehouseLabel": "To warehouse",
          "toWarehousePlaceholder": "Select a warehouse",
          "notesLabel": "Notes (recommended)",
          "notesPlaceholder": "Transfer reference or notes",
          "linesTitle": "Lines",
          "productLabel": "Product",
          "productPlaceholder": "Select or search a product…",
          "variantPlaceholder": "Select a variant",
          "quantityLabel": "Quantity",
          "quantityPlaceholder": "0",
          "addLine": "Add line",
          "removeLine": "Remove line",
          "shipImmediatelyLabel": "Ship immediately",
          "cancel": "Cancel",
          "create": "Create transfer",
          "emptyNotesModal": {
            "title": "Create without notes?",
            "message": "You are creating this transfer without notes. Do you want to continue?",
            "quickInputLabel": "Add notes (optional)",
            "cancelButton": "Cancel",
            "confirmWithoutNotes": "Confirm create",
            "submitWithNotes": "Create with notes",
            "pending": "Creating…"
          },
          "errors": {
            "fromWarehouseRequired": "Select a source warehouse.",
            "toWarehouseRequired": "Select a destination warehouse.",
            "sameWarehouse": "Source and destination warehouses must differ.",
            "linesRequired": "Add at least one line with a product and quantity.",
            "saveFailed": "Failed to create transfer."
          }
        },
        "detail": {
          "documentTitle": "Transfer",
          "title": "Transfer — {{from}} → {{to}}",
          "back": "Back to transfers",
          "loading": "Loading transfer…",
          "loadError": "Failed to load this transfer.",
          "retry": "Try again",
          "shipButton": "Ship",
          "shipError": "Failed to ship this transfer.",
          "receiveButton": "Receive",
          "receiveError": "Failed to receive this transfer.",
          "returnRemainderButton": "Return remainder",
          "returnRemainderError": "Failed to return the remainder.",
          "cancelButton": "Cancel transfer",
          "cancelError": "Failed to cancel this transfer.",
          "createdAt": "Created",
          "createdBy": "Created by",
          "notes": "Notes",
          "shippedAt": "Shipped",
          "completedAt": "Completed",
          "receiveQuantityLabel": "Quantity to receive",
          "table": {
            "product": "Product",
            "shipped": "Shipped",
            "received": "Received",
            "returned": "Returned"
          }
        }
      },
      "stockCounts": {
        "documentTitle": "Stock Counts",
        "pageTitle": "Stock Counts",
        "subtitle": "{{count}} stock counts",
        "backToHub": "Back to POS",
        "loading": "Loading stock counts…",
        "retry": "Try again",
        "loadError": "Failed to load stock counts.",
        "empty": "No stock counts yet.",
        "createButton": "New stock count",
        "viewButton": "View",
        "editButton": "Edit",
        "discardButton": "Discard",
        "discardConfirm": "Discard this in-progress stock count? Counted quantities will be deleted and no stock will change.",
        "discardConfirmTitle": "Discard stock count?",
        "discardConfirmButton": "Discard",
        "discarding": "Discarding stock count…",
        "discardedToast": "In-progress stock count discarded.",
        "discardFailed": "Failed to discard stock count.",
        "status": {
          "in_progress": "In progress",
          "completed": "Completed",
          "voided": "Voided"
        },
        "table": {
          "warehouse": "Warehouse",
          "status": "Status",
          "createdAt": "Created"
        },
        "form": {
          "documentTitle": "New stock count",
          "editDocumentTitle": "Edit stock count",
          "title": "New stock count",
          "editTitle": "Edit stock count",
          "subtitle": "Enter counted quantities, then save a draft or submit to post stock adjustments.",
          "editSubtitle": "Update counted quantities, then save a draft or submit to post stock adjustments.",
          "back": "Back to stock counts",
          "warehouseLabel": "Warehouse",
          "warehousePlaceholder": "Select a warehouse",
          "binLabel": "Bin (optional)",
          "binPlaceholder": "Entire warehouse",
          "binHint": "Optional. Counts still update warehouse on-hand; bin is a location label for this count.",
          "notesLabel": "Notes (recommended)",
          "notesPlaceholder": "Count reference or notes",
          "linesTitle": "Lines",
          "linesLoadError": "Failed to load stock quantities for this warehouse.",
          "retryLines": "Try again",
          "emptyLines": "No stockable products to count yet. Add POS products with inventory tracking first.",
          "productLabel": "Product",
          "productPlaceholder": "Select a product",
          "variantPlaceholder": "Select a variant",
          "systemQuantityLabel": "System qty",
          "countedQuantityLabel": "Counted qty",
          "countedQuantityPlaceholder": "0",
          "overageSupplierLabel": "Overage supplier",
          "overageSupplierPlaceholder": "Select a supplier for overage",
          "overageSupplierSuggested": "Suggested",
          "addLine": "Add line",
          "removeLine": "Remove line",
          "cancel": "Cancel",
          "create": "Create stock count",
          "save": "Save",
          "saveDraft": "Save Draft",
          "saveAndComplete": "Save and complete",
          "submitStockCount": "Submit Stock Count",
          "loadingEdit": "Loading stock count…",
          "emptyNotesModal": {
            "title": "Submit without notes?",
            "message": "You are submitting this stock count without notes. Do you want to continue?",
            "quickInputLabel": "Add notes (optional)",
            "cancelButton": "Cancel",
            "confirmSubmit": "Confirm submit",
            "submitWithNotes": "Submit with notes",
            "submitting": "Submitting…"
          },
          "errors": {
            "warehouseRequired": "Select a warehouse.",
            "linesRequired": "Add at least one line with a product and counted quantity.",
            "overageSupplierRequired": "Select a supplier for lines with a counted quantity higher than the system quantity.",
            "saveFailed": "Failed to save stock count.",
            "loadFailed": "Failed to load stock count.",
            "completeFailed": "Failed to complete stock count."
          }
        }
      },
      "lowStock": {
        "documentTitle": "Low Stock",
        "pageTitle": "Low Stock",
        "subtitle": "{{count}} items below their reorder point",
        "backToHub": "Back to POS",
        "loading": "Loading low stock items…",
        "retry": "Try again",
        "loadError": "Failed to load low stock items.",
        "empty": "Nothing is below its reorder point right now.",
        "warehouseFilterAriaLabel": "Filter by warehouse",
        "warehouseFilterAllOption": "All warehouses",
        "receiveButton": "Receive stock",
        "table": {
          "product": "Product",
          "warehouse": "Warehouse",
          "quantity": "On hand",
          "minQuantity": "Reorder point",
          "reorderTo": "Reorder to"
        }
      },
      "import": {
        "documentTitle": "Import Stock",
        "pageTitle": "Import Stock",
        "subtitle": "Bulk import opening or additional stock from a CSV file.",
        "backToHub": "Back to POS",
        "instructions": "CSV columns: warehouseId, supplierId, productId, productVariantId (optional), quantity, unitCost, expiryDate (optional). Download the sample CSV for the exact header and example rows.",
        "downloadSampleButton": "Download sample CSV",
        "chooseFileLabel": "Choose CSV file",
        "dryRunButton": "Validate (dry run)",
        "commitButton": "Commit import",
        "startOverButton": "Start over",
        "dryRunSummary": "{{validCount}} of {{rowCount}} rows are valid.",
        "commitSummary": "Imported {{rowCount}} rows into {{receiveCount}} receive(s).",
        "errorsTitle": "Row errors",
        "rowErrorLabel": "Row {{row}}: {{message}}",
        "errors": {
          "noFile": "Choose a CSV file first.",
          "readFailed": "Failed to read the selected file.",
          "dryRunFailed": "Failed to validate the CSV file.",
          "commitFailed": "Failed to commit the import."
        }
      },
      "products": {
        "documentTitle": "POS Products",
        "pageTitle": "Manage Products",
        "subtitle": "{{count}} products available at the register",
        "backToHub": "Back to POS",
        "backToHubAriaLabel": "Back to POS hub",
        "backToInstoreqr": "Back to InStoreQR",
        "backToInstoreqrAriaLabel": "Back to InStoreQR hub",
        "backToShop": "Back to Online Shop",
        "backToShopAriaLabel": "Back to Online Shop hub",
        "openRegister": "Open POS",
        "addProduct": "Add product",
        "add": {
          "documentTitle": "Add product",
          "pageTitle": "Add product",
          "subtitle": "Create an item for the register catalog.",
          "back": "Back",
          "backAriaLabel": "Back"
        },
        "edit": {
          "documentTitle": "Edit product",
          "pageTitle": "Edit product",
          "subtitle": "Update this catalog item.",
          "back": "Back",
          "backAriaLabel": "Back",
          "loadFailed": "Failed to load this product."
        },
        "loading": "Loading products…",
        "retry": "Try again",
        "searchPlaceholder": "Search by name, description, or category…",
        "searchAriaLabel": "Search products",
        "showArchived": "Show archived",
        "empty": "No products yet. Add your first product for the register.",
        "emptySearch": "No products match your search.",
        "table": {
          "name": "Name",
          "category": "Category",
          "price": "Price",
          "variants": "Variants",
          "variantCount": "{{count}} variants",
          "type": "Type",
          "stock": "Stock",
          "status": "Status"
        },
        "type": {
          "product": "Product",
          "service": "Service"
        },
        "badge": {
          "stock": "Stock",
          "archived": "Archived",
          "combo": "Combo",
          "registerReady": "Register"
        },
        "rowAriaLabel": "Open {{name}}",
        "editAriaLabel": "Edit {{name}}",
        "publishAriaLabel": "Publish {{name}}",
        "archiveAriaLabel": "Archive {{name}}",
        "restoreAriaLabel": "Restore {{name}}",
        "actions": {
          "edit": "Edit",
          "orderStocks": "Order stocks",
          "publish": "Publish",
          "archive": "Archive",
          "restore": "Restore"
        },
        "orderStocksAriaLabel": "Order stocks for {{name}}",
        "orderStocks": {
          "modalTitle": "Order stocks",
          "modalMessage": "How do you want to restock “{{name}}”?",
          "receiveOptionTitle": "New receive",
          "receiveOptionDescription": "Record stock you already received from a supplier.",
          "purchaseOrderOptionTitle": "New purchase order",
          "purchaseOrderOptionDescription": "Create a PO first, then receive against it later.",
          "cancel": "Cancel"
        },
        "history": {
          "sectionTitle": "Timeline",
          "sectionSubtitle": "Who changed this product and when.",
          "loading": "Loading history…",
          "empty": "No audit events yet for this product.",
          "loadFailed": "Failed to load product history.",
          "retry": "Try again",
          "by": "By {{name}}",
          "unknownActor": "Unknown",
          "reason": "Reason: {{reason}}",
          "changedFields": "Changed fields",
          "actions": {
            "create": "Created",
            "update": "Updated",
            "archive": "Archived",
            "restore": "Restored",
            "publish": "Published",
            "unpublish": "Unpublished",
            "saveDraft": "Draft saved",
            "updateDraft": "Draft updated",
            "rollback": "Rolled back",
            "unknown": "Action"
          }
        },
        "cardMeta": "{{category}} · {{price}} · {{variants}}",
        "archive": {
          "title": "Archive product?",
          "message": "Archive “{{name}}”? It will be hidden from the register.",
          "reasonLabel": "Reason",
          "reasonPlaceholder": "e.g. Discontinued",
          "cancel": "Cancel",
          "confirm": "Archive",
          "error": "Failed to archive product."
        },
        "publish": {
          "title": "Publish draft?",
          "message": "Publish “{{name}}” so it appears at the register?",
          "cancel": "Cancel",
          "confirm": "Publish",
          "error": "Failed to publish product."
        },
        "restore": {
          "error": "Failed to restore product."
        },
        "form": {
          "createTitle": "Add product",
          "editTitle": "Edit product",
          "nameLabel": "Name",
          "namePlaceholder": "e.g. Iced coffee",
          "suggestedName": "Product {{number}}",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "e.g. 16oz house blend",
          "fieldLengthHint": "{{count}} / {{max}} characters",
          "skuLabel": "SKU",
          "skuPlaceholder": "e.g. COFFEE-16OZ",
          "machineCodeLabel": "Machine code",
          "machineCodePlaceholder": "e.g. P0002",
          "machineCodeHint": "Used for milk-tea machine QR when Machine QR is enabled. Variant codes override this when set.",
          "categoryLabel": "Category",
          "categoryPlaceholder": "e.g. Beverages",
          "media": {
            "label": "Images",
            "hintCreate": "Optional. Up to {{max}} images — JPEG, PNG, WebP, or GIF. Files upload when you create the product.",
            "hintEdit": "Up to {{max}} images. JPEG, PNG, WebP, or GIF.",
            "uploadButton": "Add images",
            "uploadButtonShort": "Add",
            "uploading": "Uploading images…",
            "uploadingShort": "…",
            "loading": "Loading images…",
            "removeAria": "Remove image",
            "invalidType": "Choose a JPEG, PNG, WebP, or GIF image.",
            "maxReached": "This product already has the maximum of {{max}} images.",
            "uploadFailed": "Failed to upload image.",
            "countHint": "{{count}} / {{max}} images"
          },
          "priceLabel": "Price (PHP)",
          "kindLabel": "Product type",
          "kindStandard": "Standard product",
          "kindStandardDescription": "Sell one product with a single price or optional variants.",
          "kindCombo": "Combo (bundle)",
          "kindComboDescription": "Sell a bundle made from multiple existing products.",
          "kindComboUnavailableHint": "You can create combo bundles after you publish this product.",
          "kindLockedHint": "Product type cannot be changed after publishing.",
          "trackInventoryLabel": "Track inventory",
          "trackInventoryHint": "On for physical goods sold from stock. Off for services with no stock limits.",
          "trackInventoryLockedHint": "Stock tracking cannot be changed after publishing. Create a new product to switch between service and stocked item.",
          "trackSerialLabel": "Track serial numbers",
          "trackSerialHint": "Require a unique serial per unit when receiving stock. At the register, scan serials when the register is set to require scan.",
          "initialStockLabel": "Starting stock",
          "initialStockPlaceholder": "e.g. 20",
          "initialStockHint": "How many units you have now. You can add more later with Receive Stock.",
          "comboPriceLabel": "Combo price (PHP)",
          "combo": {
            "sectionTitle": "Combo contents",
            "sectionHint": "Each unit sold deducts these component quantities from POS inventory stock.",
            "productField": "Product",
            "productPlaceholder": "Select a product…",
            "variantField": "Variant",
            "variantPlaceholder": "Select variant…",
            "variantNone": "—",
            "quantityField": "Qty per combo",
            "addButton": "Add product",
            "removeAria": "Remove combo line",
            "catalogLoading": "Loading products…",
            "catalogEmpty": "No published standard products yet. Publish at least one regular product (not a combo), then add it here."
          },
          "variants": {
            "enableLabel": "Sell in variants (size, color, etc.)",
            "lockedHint": "Base and variant selling modes cannot be changed after creation. Create a new product to use the other mode.",
            "sectionTitle": "Variants",
            "sectionHint": "Each variant has its own price at the register. One variant must be the default.",
            "sectionHintOptionDriven": "Combinations are created from variant options above. Edit price, SKU, image, and machine code here — add or remove options to change which combinations appear.",
            "labelField": "Label",
            "labelPlaceholder": "e.g. Large / Red",
            "labelReadOnlyHint": "Generated from options",
            "skuField": "SKU",
            "skuPlaceholder": "e.g. TEE-L-RED",
            "machineCodeField": "Machine code",
            "machineCodePlaceholder": "e.g. P0002L",
            "mediaField": "Variant image",
            "mediaUpload": "Upload image",
            "mediaUploadShort": "Add",
            "mediaReplace": "Replace image",
            "mediaUploading": "Uploading…",
            "mediaUploadingShort": "…",
            "mediaRemoveAria": "Remove variant image",
            "mediaUploadFailed": "Failed to upload variant image.",
            "mediaInvalidType": "Only image files are allowed.",
            "priceField": "Price (PHP)",
            "pricePlaceholder": "0.00",
            "initialStockField": "Starting stock",
            "initialStockPlaceholder": "e.g. 20",
            "defaultLabel": "Default",
            "addButton": "Add variant",
            "removeAria": "Remove variant"
          },
          "options": {
            "title": "Variant options",
            "hint": "Add option names and values. Variant combinations are created automatically.",
            "nameLabel": "Option name",
            "namePlaceholder": "e.g. Size",
            "valuesLabel": "Values",
            "valuePlaceholder": "e.g. Small",
            "valueAria": "Value {{number}} for {{option}}",
            "machineCodePlaceholder": "Machine code",
            "machineCodeAria": "Machine code for value {{number}} of {{option}}",
            "addValue": "Add value",
            "removeValueAria": "Remove value",
            "add": "Add option",
            "remove": "Remove option"
          },
          "addons": {
            "enableLabel": "Offer add-ons (extras customers can choose)",
            "title": "Add-ons",
            "hint": "Optional extras customers can choose at the register.",
            "groupNameLabel": "Group name",
            "groupNamePlaceholder": "e.g. Extras",
            "minSelectLabel": "Minimum",
            "maxSelectLabel": "Maximum",
            "maxSelectPlaceholder": "All",
            "addonNameLabel": "Add-on name",
            "addonNamePlaceholder": "e.g. Free name tag",
            "priceLabel": "Price",
            "machineCodeLabel": "Machine code",
            "machineCodePlaceholder": "e.g. T002",
            "emptyMachineCodeLabel": "Empty-slot code",
            "emptyMachineCodePlaceholder": "e.g. T00",
            "emptyMachineCodeHint": "Printed when no add-on is selected in this group.",
            "addAddon": "Add add-on",
            "removeAddon": "Remove add-on",
            "moveAddonUp": "Move add-on up",
            "moveAddonDown": "Move add-on down",
            "moveGroupUp": "Move add-on group up",
            "moveGroupDown": "Move add-on group down",
            "addGroup": "Add add-on group",
            "removeGroup": "Remove group"
          },
          "typeLabel": "Type",
          "typeProduct": "Product (tracks inventory)",
          "typeService": "Service",
          "typeLockedHint": "Type cannot be changed after publishing.",
          "availableLabel": "Available at register",
          "availableHint": "On: the product is published and can be sold right away. Off: it is saved as a draft you can finish and publish later.",
          "availableEditHint": "Turn off to save as a draft and hide from the register. Turn on to publish and sell at the register.",
          "lockedSettings": "Locked settings",
          "lockedSettingsHint": "Product type and inventory tracking",
          "lockedSettingsExpandAria": "Show locked product settings",
          "lockedSettingsCollapseAria": "Hide locked product settings",
          "moreOptions": "More options",
          "moreOptionsHint": "Description, images, category, variants, and add-ons",
          "moreOptionsExpandAria": "Show more product options",
          "moreOptionsCollapseAria": "Hide more product options",
          "zeroPriceConfirm": {
            "title": "Price is ₱0",
            "message": "This product will sell for ₱0 at the register. If that is intentional, continue. Otherwise go back and set a price.",
            "cancel": "Go back",
            "confirm": "Yes, use ₱0"
          },
          "zeroStockConfirm": {
            "title": "Starting stock is 0",
            "message": "This product will be out of stock at the register until you add stock with Receive Stock. Continue only if that is intentional.",
            "cancel": "Go back",
            "confirm": "Yes, start with 0"
          },
          "cancel": "Cancel",
          "saveDraft": "Save draft",
          "publish": "Publish",
          "create": "Create",
          "saveChanges": "Save changes",
          "noChangesToSave": "No changes to save",
          "errors": {
            "nameRequired": "Name is required.",
            "nameAlreadyExists": "Product name already exists.",
            "priceRequired": "Price is required.",
            "priceInvalid": "Enter a valid price (0 or greater).",
            "initialStockRequired": "Starting stock is required.",
            "initialStockInvalid": "Enter a valid stock quantity (0 or greater).",
            "openingStockFailed": "Product was created, but starting stock could not be saved. Add stock with Receive Stock.",
            "variantsRequired": "Add at least one variant with a label.",
            "variantLabelRequired": "Label is required.",
            "variantPriceRequired": "Price is required.",
            "variantPriceInvalid": "Enter a valid price (0 or greater).",
            "comboRequired": "Add at least one product to the combo.",
            "comboQuantityInvalid": "Each combo line needs a quantity greater than zero.",
            "companyRequired": "Select a company before saving products.",
            "noChangesToSave": "No changes to save.",
            "loadFailed": "Failed to load product details.",
            "saveFailed": "Failed to save product.",
            "itemTypeRequired": "Select an inventory type for inventory tracking.",
            "salesCategoryRequired": "Select a sales category.",
            "expenseCategoryRequired": "Select an expense category.",
            "productGroupRequired": "Select or create a product category."
          },
          "itemTypeLabel": "Inventory Type",
          "itemTypePlaceholder": "Select an inventory type",
          "createItemType": "Create Inventory Type",
          "accountingCategoryLabel": "Sales Category",
          "accountingCategoryPlaceholder": "Select a sales category",
          "createAccountingCategory": "Create Sales Category",
          "expenseCategoryLabel": "Expense Category",
          "expenseCategoryPlaceholder": "Select an expense category",
          "createExpenseCategory": "Create Expense Category",
          "accountingRequiredHint": "Sales and expense categories are required for products that are displayed in the cash register.",
          "expenseCategoryOnlyHint": "Choose the expense category used when this product is posted. Sales category is added when the product is displayed in the cash register.",
          "categoryGroupPlaceholder": "Select a category",
          "createProductGroup": "Create Category",
          "createProductGroupTitle": "Create product category",
          "createProductGroupNameLabel": "Category name",
          "createProductGroupNamePlaceholder": "e.g. Beverages",
          "createProductGroupSave": "Create",
          "sectionBasicInformation": "Basic Information",
          "sectionInventory": "Inventory",
          "sectionAvailability": "Availability",
          "sectionAccounting": "Accounting",
          "sectionVariants": "Variants (Optional)",
          "sectionAddons": "Add-ons (Optional)",
          "sectionStatus": "Status",
          "sectionSummary": "Summary",
          "basicInformation": "Basic Information",
          "inventory": "Inventory",
          "availability": "Availability",
          "accounting": "Accounting",
          "addonsOptional": "Add-ons (Optional)",
          "status": "Status",
          "summary": "Summary",
          "tip": "You can edit all settings anytime after creating the product.",
          "displayInPosLabel": "Display in Cash Register (POS)",
          "availableForSaleLabel": "Available for Sale",
          "summaryPos": "Product will be available in POS",
          "summaryInventory": "Inventory tracking",
          "summarySerialTracking": "Serial number tracking",
          "summaryVariantSelling": "Variant selling",
          "summaryAccounting": "Sales and expense categories required",
          "summaryAddonsOptional": "Add-ons",
          "summaryOptional": "Optional",
          "summaryProductLabel": "Product: {{name}}",
          "summaryCategoryLine": "Category: {{name}}",
          "summaryInventoryTypeLine": "Inventory Type: {{name}}",
          "summaryAccountingCategoryLine": "Sales Category: {{name}}",
          "summaryExpenseCategoryLine": "Expense Category: {{name}}",
          "summaryAmountLabel": "Amount: {{amount}}",
          "summaryAddonLine": "{{name}} : {{amount}}",
          "summaryProductNameFallback": "(Untitled product)",
          "tipText": "Please review your product settings carefully. Product Type and Inventory Tracking cannot be changed after creation.",
          "saveProduct": "Save Product",
          "breadcrumbProducts": "Products",
          "breadcrumbCreate": "Create Product",
          "breadcrumbEdit": "Edit Product"
        }
      },
      "registers": {
        "documentTitle": "POS Registers",
        "pageTitle": "Manage Registers",
        "subtitle": "{{count}} registers ready to open",
        "backToHub": "Back to POS",
        "backToHubAriaLabel": "Back to POS hub",
        "openRegister": "Open POS",
        "addRegister": "Add register",
        "add": {
          "documentTitle": "Add register",
          "pageTitle": "Add register",
          "subtitle": "Create a checkout station for Open POS.",
          "back": "Back to registers",
          "backAriaLabel": "Back to manage registers",
          "cancel": "Cancel"
        },
        "edit": {
          "documentTitle": "Edit register",
          "pageTitle": "Edit register",
          "subtitle": "Update this checkout station's details.",
          "back": "Back to registers",
          "backAriaLabel": "Back to manage registers",
          "cancel": "Cancel",
          "loadFailed": "Failed to load this register."
        },
        "loading": "Loading registers…",
        "loadFailed": "Failed to load registers.",
        "retry": "Try again",
        "searchPlaceholder": "Search by name, code, MIN, machine, or description…",
        "searchAriaLabel": "Search registers",
        "showArchived": "Show archived",
        "empty": "No registers yet. Add your first checkout station.",
        "emptySearch": "No registers match your search.",
        "table": {
          "name": "Name",
          "code": "Code",
          "min": "MIN",
          "status": "Status"
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive",
          "archived": "Archived"
        },
        "badge": {
          "archived": "Archived",
          "inactive": "Inactive",
          "ready": "Ready"
        },
        "editAriaLabel": "Edit {{name}}",
        "viewAriaLabel": "View details for {{name}}",
        "archiveAriaLabel": "Archive {{name}}",
        "restoreAriaLabel": "Restore {{name}}",
        "actions": {
          "view": "View",
          "edit": "Edit",
          "archive": "Archive",
          "restore": "Restore"
        },
        "details": {
          "documentTitle": "POS Register details",
          "documentTitleNamed": "{{name}} · POS Register",
          "subtitle": "Register profile and a history of changes made to this register.",
          "back": "Back to registers",
          "loading": "Loading register…",
          "loadFailed": "Failed to load this register.",
          "retry": "Try again",
          "missingId": "Register id is missing.",
          "overviewTitle": "Register details",
          "historyTitle": "Configuration history",
          "historySubtitle": "Creates, edits, archives, and restores for this register. Operational sales and sessions are not listed here.",
          "historyEmpty": "No configuration changes recorded yet. Edits made after this update will appear here.",
          "historyMeta": "{{when}} · {{action}} · {{performedBy}}",
          "changeFromTo": "{{field}}: {{from}} → {{to}}",
          "changeSetTo": "{{field}}: {{to}}",
          "changeActions": {
            "created": "Created",
            "updated": "Updated",
            "archived": "Archived",
            "restored": "Restored"
          },
          "changeFields": {
            "name": "Name",
            "code": "Code",
            "description": "Description",
            "minNumber": "MIN",
            "permitToUseNumber": "Permit to use",
            "machineSetup": "Machine setup",
            "machineBrand": "Machine brand",
            "machineModel": "Machine model",
            "machineSerialNumber": "Machine serial",
            "invoiceNumberPrefix": "Invoice prefix",
            "invoiceNumberSuffix": "Invoice suffix",
            "isActive": "Active",
            "isVoided": "Archived",
            "voidReason": "Archive reason",
            "restoreReason": "Restore reason"
          },
          "fields": {
            "code": "Code",
            "minNumber": "MIN",
            "permitToUse": "Permit to use",
            "machine": "Machine",
            "description": "Description",
            "invoicePrefix": "Invoice prefix",
            "invoiceSuffix": "Invoice suffix",
            "nextInvoice": "Next invoice sequence",
            "zCounter": "Z-counter",
            "agt": "Accumulated grand total",
            "createdAt": "Created",
            "updatedAt": "Updated",
            "archivedAt": "Archived",
            "archiveReason": "Archive reason"
          }
        },
        "openPosAriaLabel": "Open POS for {{name}}",
        "cardMeta": "Code {{code}} · MIN {{min}}",
        "archive": {
          "title": "Archive register?",
          "message": "Archive “{{name}}”? It will no longer appear when opening POS.",
          "reasonLabel": "Reason",
          "reasonPlaceholder": "e.g. Closed location",
          "cancel": "Cancel",
          "confirm": "Archive",
          "error": "Failed to archive register."
        },
        "restore": {
          "title": "Restore register?",
          "message": "Restore “{{name}}”? It will appear again when opening POS.",
          "reasonLabel": "Reason",
          "reasonPlaceholder": "e.g. Reopened location",
          "cancel": "Cancel",
          "confirm": "Restore",
          "error": "Failed to restore register."
        },
        "form": {
          "createTitle": "Add register",
          "editTitle": "Edit register",
          "sections": {
            "general": "General",
            "invoiceNumber": "Invoice numbering",
            "invoiceNumberHint": "Prefix, suffix, and preview",
            "invoiceNumberExpandAria": "Expand invoice numbering",
            "invoiceNumberCollapseAria": "Collapse invoice numbering",
            "accreditation": "Machine identification & setup",
            "accreditationHint": "MIN, PTU, and lane notes",
            "machineDetails": "Machine details",
            "machineDetailsHint": "Brand, model, and serial",
            "accreditationExpandAria": "Expand machine identification and setup",
            "accreditationCollapseAria": "Collapse machine identification and setup",
            "machineDetailsExpandAria": "Expand machine details",
            "machineDetailsCollapseAria": "Collapse machine details",
            "birCounters": "BIR machine counters",
            "birCountersHint": "Read-only totals for this register",
            "birCountersExpandAria": "Expand BIR machine counters",
            "birCountersCollapseAria": "Collapse BIR machine counters",
            "warehouseStock": "Warehouse & stock"
          },
          "warehouseLabel": "Home warehouse",
          "warehousePlaceholder": "No home warehouse",
          "warehouseHint": "Stock checks at this register use this warehouse's available quantity.",
          "serialSaleModeLabel": "Serial number sale mode",
          "serialSaleModeRequireScan": "Require scan at checkout",
          "serialSaleModeAutoPick": "Auto-pick oldest serial",
          "serialSaleModeHint": "Controls how serialized items are selected when sold at this register.",
          "stockDeductModeLabel": "Stock deduction mode",
          "stockDeductModeHomeOnly": "Home warehouse only",
          "stockDeductModePriorityList": "Priority list of warehouses",
          "stockDeductModeFefo": "FEFO across warehouses",
          "stockDeductModeHint": "Determines which warehouse(s) stock is deducted from on sale.",
          "warehousePriorityLabel": "Warehouse priority order",
          "warehousePriorityHint": "Hold Ctrl/Cmd to select multiple warehouses in fallback order.",
          "invoicePrefixLabel": "Invoice prefix",
          "invoicePrefixPlaceholder": "e.g. SI-",
          "invoiceSuffixLabel": "Invoice suffix",
          "invoiceSuffixPlaceholder": "e.g. -2026",
          "invoiceAffixLengthHint": "{{count}} / {{max}} characters",
          "fieldLengthHint": "{{count}} / {{max}} characters",
          "invoicePreviewLabel": "Next invoice example: {{example}}",
          "invoiceSequenceHint": "Serial numbers are nine digits (000000001–999999999). After the series resets, the invoice reset counter is shown before the serial on each receipt.",
          "invoiceLockedHint": "Invoice prefix and suffix cannot be changed after the first sale or once saved.",
          "birAccumulatedGrandTotal": "Accumulated grand total",
          "birGrandTotalResetCounter": "Grand total reset counter",
          "birZCounter": "Z-counter",
          "birInvoiceResetCounter": "Invoice reset counter",
          "birLastZReadingAt": "Last Z-Reading",
          "birNotYetGenerated": "Not generated yet",
          "birCountersHint": "Counters are maintained automatically. Generate Z-Reading from the register screen when all sessions are closed.",
          "nameLabel": "Name",
          "namePlaceholder": "e.g. Front counter",
          "suggestedName": "Register {{number}}",
          "codeLabel": "Code",
          "codePlaceholder": "e.g. REG-01",
          "codeHint": "Optional short code; must be unique per company when set.",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "e.g. Main counter near the entrance",
          "minLabel": "MIN (machine identification number)",
          "minPlaceholder": "e.g. 12345678901234",
          "minHint": "Optional BIR machine identification number for this terminal.",
          "ptuLabel": "Permit to Use (PTU) number",
          "ptuPlaceholder": "e.g. PTU-1234-5678-9012-3456",
          "machineSetupLabel": "Machine setup",
          "machineSetupPlaceholder": "e.g. Lane 2, receipt printer, drawer",
          "machineBrandLabel": "Brand",
          "machineBrandPlaceholder": "e.g. Acme",
          "machineModelLabel": "Model",
          "machineModelPlaceholder": "e.g. POS-2000",
          "machineSerialLabel": "Serial number",
          "machineSerialPlaceholder": "e.g. SN-ABC-12345",
          "activeLabel": "Active (available when opening POS)",
          "optionalBadge": "Optional",
          "optionalSectionsHint": "Optional details — expand only if you need invoice numbering or BIR machine info.",
          "help": {
            "openAria": "Explain {{field}}",
            "close": "Got it",
            "name": {
              "title": "Name",
              "body": "The display name for this checkout station — for example Front counter or Lane 2.\n\nStaff see this name when choosing a register to open POS, and it appears on register lists and reports. Name is required."
            },
            "code": {
              "title": "Code",
              "body": "An optional short identifier such as REG-01.\n\nUse it when you want a stable shorthand for the register in lists or internal notes. If set, it must be unique within the company."
            },
            "description": {
              "title": "Description",
              "body": "Optional notes about this register — location, shift use, or other reminders for your team.\n\nIt is for staff reference only and does not appear on customer receipts."
            },
            "active": {
              "title": "Active",
              "body": "When Active is on, this register can be selected when opening POS.\n\nTurn it off to keep the register configured but hide it from the Open POS picker (for example a temporarily closed lane). Archived registers are separate from Active."
            },
            "invoiceNumbering": {
              "title": "Invoice numbering",
              "body": "Controls how official invoice / OR numbers look on receipts for this register.\n\nEach sale gets the next serial (nine digits, 000000001–999999999). Optional prefix and suffix wrap that serial. After the first sale (or once saved with values), prefix and suffix are locked so the series stays consistent for BIR compliance."
            },
            "invoicePrefix": {
              "title": "Invoice prefix",
              "body": "Text placed before the invoice serial on receipts — for example SI- or OR-.\n\nOptional. Up to 64 characters. Once locked after the first sale or save, it cannot be changed for this register."
            },
            "invoiceSuffix": {
              "title": "Invoice suffix",
              "body": "Text placed after the invoice serial — for example -2026 or a branch code.\n\nOptional. Up to 64 characters. Once locked after the first sale or save, it cannot be changed for this register."
            },
            "machineIdentification": {
              "title": "Machine identification & setup",
              "body": "Optional BIR and store details for this terminal.\n\nStore the Machine Identification Number (MIN), Permit to Use (PTU), and a short note about how the lane is set up. These support accreditation records and receipts; they are not required to start selling."
            },
            "minNumber": {
              "title": "MIN (machine identification number)",
              "body": "The BIR Machine Identification Number assigned to this POS terminal when accredited.\n\nOptional in Abrafi, but you should enter it if BIR has issued a MIN for this machine so it can appear on compliance-related outputs."
            },
            "permitToUse": {
              "title": "Permit to Use (PTU) number",
              "body": "The Permit to Use number from BIR accreditation for this CRM/POS machine.\n\nOptional to operate the register here, but keep it on file when you have a PTU for audits and machine records."
            },
            "machineSetup": {
              "title": "Machine setup",
              "body": "Free-text notes about this lane’s physical setup — printer, cash drawer, lane number, or accessories.\n\nFor your team’s reference only; not used as a BIR control field."
            },
            "machineDetails": {
              "title": "Machine details",
              "body": "Optional hardware identity for this terminal: brand, model, and serial number.\n\nUseful for asset tracking and matching the physical unit to BIR accreditation paperwork. Not required to open POS or sell."
            },
            "machineBrand": {
              "title": "Brand",
              "body": "Manufacturer or brand of the POS terminal or computer used as this register.\n\nOptional inventory detail for matching hardware to accreditation records."
            },
            "machineModel": {
              "title": "Model",
              "body": "Model name or number of the POS hardware.\n\nOptional; helps identify the exact unit among several registers."
            },
            "machineSerial": {
              "title": "Serial number",
              "body": "The device serial number from the manufacturer.\n\nOptional; useful when BIR or support needs to identify a specific machine."
            }
          },
          "cancel": "Cancel",
          "create": "Create",
          "saveChanges": "Save changes",
          "errors": {
            "nameRequired": "Name is required.",
            "companyRequired": "Select a company before saving registers.",
            "saveFailed": "Failed to save register."
          }
        }
      },
      "register": {
        "documentTitle": "POS Register",
        "loading": "Loading register…",
        "loadError": "Could not load this register.",
        "retry": "Try again",
        "backToRegisters": "Manage registers",
        "backToHub": "Back to POS",
        "placeholderTitle": "POS register",
        "placeholderHint": "Register screen for {{name}}. Sales UI coming soon.",
        "sales": {
          "productsSectionAria": "Products for sale",
          "cartSectionAria": "Current order",
          "searchPlaceholder": "Search products…",
          "categoryAll": "All",
          "catalogLoading": "Loading products…",
          "catalogLoadFailed": "Failed to load products.",
          "catalogEmpty": "No products ready to sell. Add and publish products first.",
          "catalogNoMatches": "No products match your search.",
          "priceFrom": "From {{amount}}",
          "stockRemaining": "{{count}} in stock",
          "serviceItem": "Service",
          "outOfStock": "Out of stock",
          "manageProducts": "Manage products",
          "variantPicker": {
            "title": "Choose variant — {{name}}",
            "intro": "Select a variant to add to the order.",
            "select": "Select variant",
            "unavailable": "This combination is unavailable.",
            "cancel": "Cancel"
          },
          "addons": {
            "title": "Choose add-ons — {{name}}",
            "intro": "Select any extras to include with this item.",
            "cancel": "Cancel",
            "addToCart": "Add to order"
          },
          "cartTitle": "Order",
          "cartItemCount": "{{count}} items",
          "cartEmpty": "Tap a product to add it to the order.",
          "cartUnitPrice": "{{amount}} each",
          "decreaseQtyAria": "Decrease quantity of {{name}}",
          "increaseQtyAria": "Increase quantity of {{name}}",
          "removeLineAria": "Remove {{name}} from order",
          "serials": {
            "label": "Serial numbers",
            "placeholder": "Serial {{index}}",
            "inputAria": "Serial {{index}} for {{name}}",
            "required": "Enter {{count}} serial number(s) for {{name}}.",
            "duplicate": "Duplicate serial numbers on {{name}}."
          },
          "subtotalLabel": "Subtotal",
          "checkoutButton": "Checkout",
          "clearCart": "Clear order",
          "checkoutError": "Failed to complete the sale.",
          "stock": {
            "comboAvailable": "{{count}} available",
            "comboUnavailable": "Not enough component stock to sell \"{{name}}\".",
            "productUnavailable": "No stock left for \"{{name}}\".",
            "insufficientComponent": "Insufficient stock for {{name}} (need {{needed}}, on hand {{onHand}}).",
            "checkoutBlocked": "Not enough component stock for this order. Adjust quantities or restock components."
          },
          "checkout": {
            "title": "Cash payment",
            "intro": "Collect cash for {{count}} line(s) in this order.",
            "subtotal": "Subtotal",
            "discount": "Discount",
            "totalDue": "Total due",
            "cashReceivedLabel": "Cash received (PHP)",
            "cashInvalid": "Enter a valid amount.",
            "cashTooLow": "Cash received must be at least the total due.",
            "changeDue": "Change: {{amount}}",
            "cancel": "Cancel",
            "confirm": "Complete sale",
            "discountTypeLabel": "Statutory discount",
            "discountNone": "None",
            "discountTypes": {
              "sc": "Senior Citizen (20%)",
              "pwd": "PWD (20%)",
              "naac": "NAAC (20%)",
              "solo_parent": "Solo Parent (10%)"
            },
            "customerIdLabel": "Customer ID no.",
            "discountAmountLabel": "Discount amount",
            "discountAmountHint": "Leave blank to apply the statutory rate automatically.",
            "discountCustomerNameRequired": "Customer name is required for statutory discounts.",
            "discountCustomerIdRequired": "Customer ID number is required for statutory discounts.",
            "customerToggle": "Customer details (optional)"
          },
          "sessionList": {
            "title": "Sales this session",
            "summary": "{{count}} sales · {{total}}",
            "loading": "Loading session sales…",
            "loadFailed": "Failed to load session sales.",
            "detailFailed": "Failed to load sale details.",
            "voidFailed": "Failed to void sale.",
            "refundFailed": "Failed to refund sale.",
            "refundNoLines": "Select at least one refund line with quantity.",
            "voidConfirm": "Void invoice {{invoice}}? This creates append-only reversal records.",
            "voidModalTitle": "Void sale",
            "voidReasonLabel": "Reason (optional)",
            "voidReasonPlaceholder": "Enter reason for audit trail",
            "voidCancel": "Cancel",
            "voidConfirmAction": "Void sale",
            "voidAction": "Void",
            "voided": "Voided",
            "voiding": "Voiding…",
            "refundConfirm": "Refund invoice {{invoice}}? This creates append-only refund records.",
            "refundModalTitle": "Refund sale",
            "refundReasonLabel": "Reason (optional)",
            "refundReasonPlaceholder": "Enter refund reason for audit trail",
            "refundCancel": "Cancel",
            "refundConfirmAction": "Refund sale",
            "refundAction": "Refund",
            "refunding": "Refunding…",
            "refundRestock": "Restock",
            "refundMaxQty": "Refundable qty left: {{count}}",
            "refundStatusPartial": "refunded: {{refunded}}/{{total}}",
            "refundStatusFully": "{{name}} is fully refunded",
            "empty": "No sales yet this session.",
            "refreshAria": "Refresh session sales",
            "rowItems": "{{count}} items",
            "rowVoided": "Voided",
            "rowPartiallyRefunded": "Partially refunded",
            "rowFullyRefunded": "Fully refunded",
            "columnTime": "Time",
            "columnInvoice": "Invoice",
            "columnItems": "Items",
            "columnTotal": "Total",
            "viewPage": "Session sales"
          },
          "sessionPage": {
            "documentTitle": "Session sales",
            "backToRegister": "Back to register",
            "subtitle": "Register: {{register}}"
          },
          "complete": {
            "title": "Sale complete",
            "viewTitle": "Sale details",
            "intro": "Sale recorded on {{register}}.",
            "viewIntro": "Sale on {{register}}.",
            "referenceLabel": "Reference",
            "timeLabel": "Time",
            "itemColumn": "Item",
            "qtyColumn": "Qty",
            "amountColumn": "Amount",
            "subtotalLabel": "Subtotal",
            "cashReceivedLabel": "Cash received",
            "changeLabel": "Change",
            "totalLabel": "Total",
            "invoiceLabel": "Invoice",
            "registerLabel": "Register",
            "paymentLabel": "Payment",
            "itemsLabel_one": "{{count}} item",
            "itemsLabel_other": "{{count}} items",
            "changeDue": "Change due {{amount}}",
            "receiptHeading": "Receipt preview",
            "dismiss": "New sale",
            "close": "Close",
            "printMachineQr": "Print machine QR",
            "printingMachineQr": "Printing machine QR…",
            "retryPrintMachineQr": "Retry machine QR",
            "printMachineQrFailed": "Failed to print machine QR.",
            "printMachineQrFailedNote": "Machine QR print failed: {{message}}",
            "printMachineQrEmpty": "No machine QR codes to print for this sale.",
            "printMachineQrPopupBlocked": "Allow pop-ups to print machine QR codes in the browser.",
            "autoPrintHint": "Sending receipt to your printer…",
            "loadingReceipt": "Loading receipt…",
            "printStatus": {
              "idle": "Ready to print",
              "sending": "Printing…",
              "printed": "Printed",
              "failed": "Print failed"
            },
            "eisStatus": {
              "accepted": "EIS: accepted by BIR",
              "exported": "EIS: awaiting BIR Unique ID",
              "duplicate": "EIS: already queued",
              "pending": "EIS: pending transmission",
              "failed": "EIS: transmission failed",
              "skipped": "EIS: not enabled"
            },
            "eisChip": {
              "accepted": "EIS accepted",
              "exported": "EIS awaiting ID",
              "duplicate": "EIS queued",
              "pending": "EIS pending",
              "failed": "EIS failed",
              "skipped": "EIS off"
            },
            "eisUniqueId": "Unique ID: {{id}}",
            "eisVoidStatus": "Void EIS: {{status}}",
            "eisRetry": "Push to EIS",
            "eisPushing": "Pushing to EIS…",
            "eisPushFailed": "Could not push sale data to EIS.",
            "itemsLabel": "ItemsLabel"
          }
        },
        "codeLabel": "Code: {{code}}",
        "minLabel": "MIN",
        "ptuLabel": "Permit to Use",
        "switchRegister": "Switch register",
        "openMore": "More",
        "more": {
          "documentTitle": "POS Register — More",
          "pageTitle": "More options",
          "subtitle": "{{name}} — switch register, printer, session sales, or end session.",
          "subtitleFallback": "Switch register, printer, session sales, or end session.",
          "backToRegister": "Back to register",
          "switchRegister": {
            "title": "Switch register",
            "description": "Choose a different register to open."
          },
          "printerSettings": {
            "title": "Printer settings",
            "description": "Connect or change the receipt printer for this device."
          },
          "sessionSales": {
            "title": "Session sales",
            "description": "Review sales recorded during this open session."
          },
          "endSession": {
            "title": "End session",
            "description": "Close the cashier session and print the X-Reading."
          }
        },
        "goToRegisters": "Add register",
        "receipt": {
          "printButton": "Print receipt",
          "reprintButton": "Reprint receipt",
          "retryPrint": "Retry print",
          "printing": "Printing…",
          "printFailed": "Could not print the receipt.",
          "printFailedNote": "Printing failed: {{message}}",
          "connectPrinterRequired": "Connect or enable a receipt printer before printing.",
          "lineAddon": "+ {{name}}",
          "lineAddonWithPrice": "+ {{name}} ({{price}})",
          "popupBlocked": "Allow pop-ups to print receipts.",
          "browserFallbackInsecure": "Direct printer unavailable. Opened browser print instead.",
          "browserFallbackAfterError": "Direct printer failed ({{reason}}). Opened browser print instead.",
          "documentTitle": "Receipt {{reference}}",
          "salesInvoice": "SALES INVOICE",
          "reference": "Ref.",
          "dateTime": "Date & time",
          "invoiceNo": "SALES INVOICE NUMBER:",
          "cashier": "Cashier",
          "payment": "PAYMENT",
          "paymentCash": "CASH",
          "items": "Items",
          "qtyColumn": "QTY",
          "descriptionColumn": "DESCRIPTION",
          "amountColumn": "AMOUNT",
          "subtotal": "Subtotal",
          "totalDue": "Total due",
          "cashReceived": "Cash",
          "change": "Change",
          "tin": "TIN: {{tin}}",
          "vatRegisteredLabel": "VAT Registered",
          "nonVatRegisteredLabel": "Non-VAT Registered",
          "posSerial": "MSN",
          "registerCode": "Register: {{code}}",
          "machineBrand": "Brand",
          "machineModel": "Model",
          "machineSerial": "MSN",
          "thankYou": "Thank you.",
          "invoiceNote": "Sequential sales invoice number for this register.",
          "invoiceFooter": "This serves as your sales invoice",
          "customerCareLabel": "Customer Care Support",
          "vatableSales": "Vatable sales",
          "vatExemptSales": "VAT-exempt sales",
          "vatZeroRated": "VAT zero-rated sales",
          "vatAmount": "VAT amount (12%)",
          "companyLogoAlt": "Company logo",
          "customerName": "Name",
          "customerAddress": "Address",
          "customerTin": "TIN",
          "customerBusinessStyle": "Business style",
          "discount": "Discount",
          "discountWithType": "Discount ({{type}})",
          "lineVat": "VATable {{vatable}} / VAT {{vat}}",
          "lineVatExempt": "VAT-exempt {{amount}}",
          "reprintLabel": "*** REPRINT ***",
          "reprintNumbered": "*** REPRINT #{{number}} ***",
          "verificationSeal": "Verification seal",
          "customerIdNumber": "ID no.",
          "companyLoadFailed": "Could not load company details for the receipt.",
          "placeholderCompanyName": "Company name not provided",
          "placeholderCompanyAddress": "Address not provided",
          "placeholderCompanyAddressFailed": "Unable to load company address",
          "placeholderTin": "000-000-000-00000",
          "placeholderPosSerial": "POS serial pending registration",
          "placeholderMachineId": "Machine ID pending registration",
          "placeholderPtu": "PTU pending registration",
          "placeholderCashier": "Cashier name not provided",
          "placeholderDateTime": "Date and time not available",
          "placeholderInvoice": "Pending invoice number",
          "placeholderPaymentMethod": "Payment method not provided",
          "verificationSealVerifyLabel": "Verify:",
          "birFinalPtu": "BIR Final PTU",
          "lineQtyUnitPrice": "{{qty}} @ {{price}}",
          "verificationSealBarcodeAlt": "Verification seal barcode",
          "verificationSealQrAlt": "Verification seal QR code",
          "providerPtuDate": "Date issued",
          "amountIncludesVat": "Amount due includes 12% VAT",
          "nonVatInvoiceNote": "Non-VAT Invoice",
          "vatBreakdownHeading": "VAT BREAKDOWN",
          "cashSales": "CASH SALES",
          "chargeSales": "CHARGE SALES",
          "itemsPurchased": "Items purchased"
        },
        "printer": {
          "openSettings": "Printer settings",
          "modalTitle": "Printer settings",
          "statusLabel": "Printer",
          "statusNone": "No printer saved",
          "statusConnected": "{{name}} ({{connection}})",
          "connectionOnline": "connected",
          "connectionOffline": "disconnected",
          "enablePrinting": "Enable printing",
          "autoCut": "Paper cutter (auto-cut)",
          "machineQrSection": "Machine QR",
          "autoPrintMachineQr": "Auto-print machine QR after sale",
          "autoCutMachineQr": "Paper cutter for machine QR (auto-cut)",
          "machineQrHelp": "When enabled, machine QR tickets print automatically after a completed sale (after the receipt, if receipt printing is on).",
          "paperSizeLabel": "Paper size",
          "paperSizeHelp": "Match your physical roll (Paper Width / Page Size). 80mm uses a wider receipt layout than 58mm.",
          "paperSizes": {
            "58mm_receipt": "58mm × Receipt",
            "80mm_receipt": "80mm × Receipt",
            "80x297_roll": "Roll Paper 80 × 297 mm"
          },
          "connectBluetooth": "Connect Bluetooth printer",
          "connectUsb": "Connect USB printer",
          "testPrint": "Test print",
          "testPrinting": "Printing…",
          "testTitle": "TEST PRINT",
          "testBody": "Printer connection OK",
          "testDisclaimer": "THIS IS NOT A SALES INVOICE/OFFICIAL RECEIPT. PLEASE REQUEST FROM SELLER YOUR SALES INVOICE/OFFICIAL RECEIPT.",
          "forget": "Forget printer",
          "close": "Close",
          "help": "Bluetooth uses browser Web Bluetooth (BLE). \"Paired\" in the Chrome dialog often means Windows already owns the printer — Remove VOZY G80 in Windows Bluetooth first, then click Pair here. VOZY G80 is most reliable over USB (Connect USB printer).",
          "bluetoothUnsupported": "Web Bluetooth is not available. Use Chrome or Edge on desktop. On http:// LAN IPs, add this origin in chrome://flags/#unsafely-treat-insecure-origin-as-secure and relaunch Chrome.",
          "usbUnsupported": "WebUSB is not available. Use Chrome or Edge on desktop. On http:// LAN IPs, add this origin in chrome://flags/#unsafely-treat-insecure-origin-as-secure and relaunch Chrome.",
          "connectFailed": "Could not connect to the printer.",
          "bluetoothPairedButUnstable": "Printer selected in Chrome, but the Bluetooth link is unstable (common when Windows still has VOZY G80 paired). Remove/forget it in Windows Bluetooth, power-cycle the printer, then click Test print — or use Connect USB printer.",
          "bluetoothConnectFailed": "Could not connect to Bluetooth printer ({{detail}}). In Windows: Settings → Bluetooth → Remove VOZY G80 (not just Disconnect). Then Connect Bluetooth printer → select VOZY G80 → click Pair. Prefer Connect USB printer.",
          "bluetoothGattFailed": "Bluetooth link dropped ({{detail}}). Chrome shows \"Paired\" but cannot keep GATT open — usually Windows Classic Bluetooth is holding the printer. Remove VOZY G80 in Windows Bluetooth, power-cycle it, Connect again and click Pair. Prefer Connect USB printer.",
          "bluetoothSecurityError": "Chrome blocked Bluetooth for this page. Confirm chrome://flags/#unsafely-treat-insecure-origin-as-secure includes this exact URL (Enabled), then Relaunch Chrome.",
          "bluetoothNoWriteChannel": "Bluetooth connected, but this printer has no Web Bluetooth print channel. Prefer USB (Connect USB printer), or remove the printer from Windows Bluetooth settings and pair again in Chrome.",
          "defaultBluetoothName": "Bluetooth printer",
          "defaultUsbName": "USB printer"
        },
        "session": {
          "loading": "Checking register session…",
          "loadFailed": "Failed to load register session.",
          "start": {
            "title": "Start session — {{name}}",
            "heading": "Start session",
            "subtitle": "Count the cash in the drawer before opening the register. Sales will be recorded against this session.",
            "openingFloatLabel": "Starting cash (PHP)",
            "openingFloatHint": "Optional. How much money is in the drawer when you start.",
            "openingNotesLabel": "Notes (recommended)",
            "openingNotesPlaceholder": "e.g. Verified bills and coins",
            "notesToggle": "Add notes (recommended)",
            "confirm": "Start session",
            "floatInvalid": "Enter a valid amount (0 or greater).",
            "error": "Failed to start session.",
            "blockedOtherRegister": "You already have an open session on {{name}}. End that session before opening this register.",
            "blockedOtherRegisterUnknown": "You already have an open session on another register. End that session before opening this one.",
            "goToOpenSession": "Go to open session",
            "emptyNotesModal": {
              "title": "Start without notes?",
              "message": "You are starting this register session without notes. Do you want to continue?",
              "quickInputLabel": "Add notes (optional)",
              "cancelButton": "Cancel",
              "confirmWithoutNotes": "Confirm start",
              "submitWithNotes": "Start with notes",
              "pending": "Starting…"
            }
          },
          "mySessionLoadFailed": "Failed to check your register sessions.",
          "status": {
            "liveAria": "Register session is open",
            "open": "Open",
            "you": "you",
            "openedBy": "{{name}}",
            "since": "since {{time}}",
            "startingCash": "{{amount}} in drawer",
            "endSession": "End session"
          },
          "banner": {
            "title": "Session open",
            "openedByYou": "You opened this session",
            "openedBy": "Opened by {{name}}",
            "openedAt": "Started {{time}}",
            "openingFloat": "Starting cash {{amount}}",
            "endSession": "End session"
          },
          "close": {
            "title": "End register session?",
            "message": "Close this session when you are done at the register. Count the cash in the drawer before confirming.",
            "closingFloatLabel": "Ending cash (PHP)",
            "closingNotesLabel": "Notes (recommended)",
            "closingNotesPlaceholder": "e.g. Cash count variance explained",
            "sessionId": "Session {{id}}…",
            "cancel": "Cancel",
            "confirm": "End session",
            "floatInvalid": "Enter a valid amount (0 or greater).",
            "error": "Failed to end session.",
            "emptyNotesModal": {
              "title": "End without notes?",
              "message": "You are ending this register session without notes. Do you want to continue?",
              "quickInputLabel": "Add notes (optional)",
              "cancelButton": "Cancel",
              "confirmWithoutNotes": "Confirm end",
              "submitWithNotes": "End with notes",
              "pending": "Ending…"
            }
          }
        },
        "xReading": {
          "modalTitle": "X-Reading",
          "modalIntro": "Cashier accountability report for this session. Print or save a copy before continuing.",
          "title": "X-READING",
          "reportNumber": "Report no.",
          "register": "Register",
          "openedBy": "Opened by",
          "closedBy": "Closed by",
          "openedAt": "Opened",
          "closedAt": "Closed",
          "salesSection": "Sales",
          "grossSales": "Gross sales",
          "voids": "Voids",
          "refunds": "Refunds",
          "netSales": "Net sales",
          "cashSales": "Cash sales",
          "cashSection": "Cash drawer",
          "openingFloat": "Opening float",
          "expectedCash": "Expected cash",
          "closingFloat": "Closing float",
          "overShort": "Over / short",
          "overShortSummary": "Over / short {{amount}}",
          "accumulatedGrandTotal": "Accumulated grand total",
          "footer": "End of X-Reading",
          "sampleBanner": "SAMPLE — TEST PRINT ONLY",
          "sampleFooter": "End of sample X-Reading — not a live report",
          "receiptHeading": "Report preview",
          "loading": "Loading report…",
          "dismiss": "Done",
          "print": "Print",
          "printFailed": "Could not print X-Reading.",
          "printStatus": {
            "idle": "Ready to print",
            "sending": "Printing…",
            "printed": "Printed",
            "failed": "Print failed"
          }
        },
        "zReading": {
          "actionsTitle": "End-of-day (Z-Reading)",
          "actionsHint": "Generate today’s Z-Reading after all sessions are closed, or use Reports → Z-Reading for another business date. Reprint does not advance the Z-counter.",
          "closeDay": {
            "title": "Close business day",
            "hint": "After all sessions are closed, generate today’s Z-Reading here. Past reports and reprints are in Reports.",
            "checking": "Checking whether a Z-Reading is needed…",
            "readyHint": "A Z-Reading is ready for {{date}}. Generating it locks that business day for new sessions.",
            "noActivityHint": "No sales or sessions yet on this register, so there is nothing to include in a Z-Reading.",
            "upToDateHint": "There is no pending Z-Reading. Every day with activity already has one.",
            "errorHint": "Could not check Z-Reading status. You can still open past reports.",
            "openReports": "Past Z-Readings in Reports"
          },
          "confirmGenerate": {
            "title": "Generate Z-Reading?",
            "warningTitle": "Locks {{date}} for selling",
            "warningBody": "After this Z-Reading is generated, you cannot start or open a register session for that business day. New sales must wait until the next business day.",
            "lead": "Only continue when all sessions for this day are closed and the cash drawer has been counted.",
            "cancel": "Cancel",
            "confirm": "Generate Z-Reading"
          },
          "modalTitle": "Z-Reading",
          "modalIntro": "End-of-day report for this register. Print or save a copy before continuing.",
          "title": "Z-READING",
          "zCounter": "Z-counter",
          "zCounterSummary": "Z-counter {{counter}}",
          "businessDate": "Business date",
          "register": "Register",
          "generatedBy": "Generated by",
          "generatedAt": "Generated",
          "invoiceRangeLabel": "OR range",
          "invoiceRange": "{{first}} – {{last}}",
          "agtSection": "Accumulated grand total",
          "previousAgt": "Previous AGT",
          "presentAgt": "Present AGT",
          "grandTotalResetCounter": "Grand total reset counter",
          "invoiceResetCounter": "Invoice reset counter",
          "firstInvoice": "First OR",
          "lastInvoice": "Last OR",
          "salesSection": "Sales",
          "grossSales": "Gross sales",
          "voids": "Voids",
          "refunds": "Refunds",
          "netSales": "Net sales",
          "vatSection": "VAT",
          "vatableSales": "Vatable sales",
          "vatAmount": "VAT amount",
          "vatExemptSales": "VAT-exempt sales",
          "vatZeroRatedSales": "Zero-rated sales",
          "paymentsSection": "Payment modes",
          "paymentMethod": "{{method}}",
          "footer": "End of Z-Reading",
          "sampleBanner": "SAMPLE — TEST PRINT ONLY",
          "sampleFooter": "End of sample Z-Reading — not a live report",
          "reprintBanner": "REPRINT — NOT AN ORIGINAL COPY",
          "reprintedAt": "Reprinted",
          "reprintedBy": "Reprinted by",
          "reprintCopyNumber": "Copy no.",
          "receiptHeading": "Report preview",
          "loading": "Loading report…",
          "dismiss": "Done",
          "print": "Print",
          "printFailed": "Could not print Z-Reading.",
          "printStatus": {
            "idle": "Ready to print",
            "sending": "Printing…",
            "printed": "Printed",
            "failed": "Print failed"
          },
          "generate": "Generate Z-Reading",
          "reprintToday": "Reprint today's Z-Reading",
          "generateFailed": "Failed to generate Z-Reading.",
          "reprintFailed": "No Z-Reading found for today.",
          "dayClosed": {
            "badge": "Business day closed",
            "title": "{{name}} — day locked",
            "lead": "A Z-Reading already closed {{date}}. New sales and sessions are blocked for this business date.",
            "businessDate": "Business date",
            "zCounter": "Report",
            "reportNumber": "Z-Reading #{{number}}",
            "generatedAt": "Generated",
            "netSales": "Net sales",
            "hint": "Further selling must wait until the next business date. Open the Z-Reading to view or print it.",
            "viewZReading": "View Z-Reading",
            "openZReadingList": "View all Z-Readings",
            "loading": "Checking today’s Z-Reading…",
            "summaryAriaLabel": "Z-Reading summary for the closed business day"
          }
        },
        "picker": {
          "title": "Choose a register",
          "subtitle": "Select which checkout station to open.",
          "loading": "Loading registers…",
          "loadFailed": "Failed to load registers.",
          "backToHub": "Back to POS",
          "lastUsedBadge": "Last used",
          "manageRegisters": "Manage registers",
          "emptyTitle": "No registers available",
          "emptyHint": "Add an active register before opening POS."
        }
      },
      "receiptLayout": {
        "documentTitle": "Receipt layout",
        "pageTitle": "Receipt layout",
        "subtitle": "Tune Sales Invoice header and footer sizes. Changes apply to the on-screen preview and thermal print.",
        "backToHub": "Back to POS",
        "controlsAria": "Receipt layout controls",
        "previewAria": "Live receipt preview",
        "previewTitle": "Live preview",
        "sampleVatLabel": "Sample invoice type",
        "sampleVatHint": "Preview and test-print a VAT or Non-VAT Sales Invoice.",
        "sampleVat": "VAT",
        "sampleNonVat": "Non-VAT",
        "paperSizeLabel": "Paper size",
        "paperSizeHint": "Match your thermal roll. Preview width and print columns update together.",
        "companyNameSizeLabel": "Company name size",
        "companyNameSizeHint": "Smaller sizes fit long registered names on 58mm paper.",
        "headerSizeLabel": "Header size",
        "headerSizeHint": "Address, TIN line, and customer care as one block. Size 1 matches the smallest footer; five steps total.",
        "footerSizeLabel": "Footer size",
        "footerSizeHint": "Accreditation and PTU block at the bottom of the invoice.",
        "verificationSealModeLabel": "Verification seal",
        "verificationSealModeHint": "Show/Hide applies to registers that do not yet have full Machine identification & setup and Machine details. Once those fields are complete, the seal is always printed (BIR-accredited lane) and Hide is ignored. QR encodes the AbraFi verify link (/v/r/…). Barcode encodes the short seal and prints the URL underneath. URL mode prints the verify link as text. Symbols scale to the paper size above.",
        "verificationSealEnabledLabel": "Show verification seal",
        "verificationSealEnabledOn": "Show on receipt",
        "verificationSealEnabledOff": "Hide",
        "verificationSealModes": {
          "qr": "QR code",
          "barcode": "Barcode",
          "url": "URL"
        },
        "sizeValue": "Size {{size}}",
        "reset": "Reset defaults",
        "testPrint": "Test print",
        "testPrintPrinting": "Printing…",
        "testPrintSuccess": "Test print sent.",
        "testPrintFailed": "Test print failed."
      },
      "demo": {
        "bannerLabel": "Demo mode",
        "bannerMessage": "Not real sales. Live register sessions are unchanged. Data is stored only on this device.",
        "switchToDemo": "Try demo",
        "switchToLive": "Exit demo",
        "resetButton": "Reset demo data",
        "resetConfirm": "Reset demo data to the sample catalog? Demo sales and sessions on this device will be cleared.",
        "resetConfirmTitle": "Reset demo data?",
        "resetConfirmButton": "Reset",
        "switchingToDemo": "Turning on demo…",
        "switchingToLive": "Switching to live…",
        "demoEnabled": "Demo mode on. Sample products and register are ready.",
        "liveEnabled": "Live mode on. Using your real POS data.",
        "toggleFailed": "Could not switch POS mode.",
        "resetting": "Resetting demo data…",
        "resetDone": "Demo data reset.",
        "resetFailed": "Could not reset demo data.",
        "catalogReadOnly": "Demo catalog is read-only. Exit demo to manage real products and registers.",
        "inventoryV2WriteUnavailable": "This action isn't available in demo mode. Exit demo to manage real inventory.",
        "dbNotReady": "Demo data is still loading. Try again in a moment.",
        "csvExportUnavailable": "CSV export is not available in demo mode.",
        "receiptBanner": "THIS IS NOT A SALES INVOICE/OFFICIAL RECEIPT. PLEASE REQUEST FROM SELLER YOUR SALES INVOICE/OFFICIAL RECEIPT.",
        "invoiceFooter": "THIS IS NOT A SALES INVOICE/OFFICIAL RECEIPT. PLEASE REQUEST FROM SELLER YOUR SALES INVOICE/OFFICIAL RECEIPT.",
        "card": {
          "enterTitle": "Try demo",
          "enterDescription": "Explore POS with sample products and sales. No internet or real data required.",
          "exitTitle": "Exit demo",
          "exitDescription": "Leave demo mode and return to your live registers and products."
        }
      },
      "ordersReceiving": {
        "documentTitle": "Orders & Receiving",
        "pageTitle": "Orders & Receiving",
        "subtitle": "{{count}} orders and receives",
        "backToHub": "Back to POS",
        "loading": "Loading orders and receives…",
        "retry": "Try again",
        "empty": "No purchase orders or receives yet. Create a purchase order or a receive to get started.",
        "createButton": "New receive",
        "newPurchaseOrderButton": "New purchase order",
        "viewButton": "View",
        "viewReceivedButton": "View received",
        "receivesListTitle": "Receives",
        "pendingPoSectionTitle": "Ready to receive from purchase orders",
        "pendingPoSectionHint": "These POs still have stock to receive. Receive here, or open the PO for other actions.",
        "pendingPoLoading": "Loading purchase orders…",
        "pendingPoEmpty": "No purchase orders waiting to be received.",
        "pendingPoLoadError": "Failed to load purchase orders ready to receive.",
        "pendingPoStatus": "PO status",
        "pendingPoReadyBadge": "Not received yet — ready to receive",
        "receivePoButton": "Receive",
        "viewPoButton": "View PO",
        "warehouseFilterAriaLabel": "Filter by warehouse",
        "warehouseFilterAllOption": "All warehouses",
        "statusFilterAriaLabel": "Filter by receive status",
        "statusFilterAllOption": "All statuses",
        "cardMeta": "{{date}} · {{warehouse}}",
        "table": {
          "documentNumber": "PO/IR NUMBER",
          "supplier": "Supplier",
          "warehouse": "Warehouse",
          "status": "Status",
          "createdAt": "Created"
        },
        "purchaseOrder": {
          "status": {
            "draft": "Draft",
            "ordered": "Ordered",
            "partially_received": "Partially received",
            "fully_received": "Fully received",
            "cancelled": "Cancelled"
          },
          "form": {
            "title": "Create purchase order",
            "subtitle": "Order items from your supplier.",
            "back": "Back to orders & receiving",
            "supplierLabel": "Supplier",
            "supplierPlaceholder": "Select or create a supplier…",
            "attachmentLabel": "Proof of billing or payment",
            "attachmentRejected": "Unsupported attachment type: {{files}}",
            "attachmentDeferred": "The order was saved. Attach this proof when the bill or payment record is created.",
            "attachmentUploadFailed": "The order was saved, but the attachment could not be uploaded.",
            "orderDateLabel": "Order date",
            "referenceNumberLabel": "Reference no. (optional)",
            "referenceNumberPlaceholder": "Supplier PO or internal ref",
            "expectedDeliveryLabel": "Expected delivery (optional)",
            "notesLabel": "Notes (optional)",
            "notesPlaceholder": "Delivery instructions or internal notes",
            "paymentSectionTitle": "Payment & billing",
            "paymentMethodCashTitle": "Cash (paid immediately)",
            "paymentMethodCashDescription": "I will pay now in cash.",
            "paymentMethodCashBullet1": "Journal entry is created: ",
            "paymentMethodCashBullet2": "Debit Advances to Suppliers",
            "paymentMethodCashBullet3": "Credit Cash",
            "paymentMethodCashBullet4": "This reflects payment made in advance to the supplier.",
            "paymentMethodCreditTitle": "On credit / pay later",
            "paymentMethodCreditDescription": "I will pay the supplier later.",
            "paymentMethodCreditBullet1": "No journal entry is created.",
            "paymentMethodCreditBullet2": "No Bill transaction is created at the time of ordering.",
            "paymentMethodCreditBullet3": "Bill creation is deferred until delivery or receipt of goods.",
            "cashPaymentTitle": "Cash payment (advance)",
            "cashPaymentBanner": "Record payment now. This will be treated as an advance payment for this order.",
            "paymentDateLabel": "Payment date",
            "paymentAccountLabel": "Payment account",
            "paymentAccountPlaceholder": "Select cash or bank account",
            "paymentReferenceLabel": "Reference (OR / no.)",
            "paymentReferencePlaceholder": "Optional receipt number",
            "paymentRemarksLabel": "Remarks (optional)",
            "paymentRemarksPlaceholder": "Payment notes",
            "summaryTitle": "Purchase order summary",
            "summaryTotalItems": "Total items",
            "summaryTotalQuantity": "Total quantity",
            "summarySubtotal": "Subtotal",
            "summaryEstimatedTotal": "Estimated total",
            "workflowTitle": "What happens next?",
            "workflowCashStep1": "Save order",
            "workflowCashStep2": "Payment recorded",
            "workflowCashStep3": "Receive items (inventory updated)",
            "workflowCreditStep1": "Save order",
            "workflowCreditStep2": "Receive items (inventory updated)",
            "workflowCreditStep3": "Bill created (accounts payable)",
            "workflowCreditStep4": "Pay bill later (settle when due)",
            "linesTitle": "Items to order",
            "addItem": "Add item",
            "linesPrevious": "Previous",
            "linesNext": "Next",
            "linesPageLabel": "Page {{current}} of {{total}}",
            "saveOrder": "Save order",
            "savingOrder": "Saving…",
            "productLabel": "Product",
            "productPlaceholder": "Select or search a product…",
            "productStatusStock": "Stock",
            "productStatusTrackInventory": "Track Inventory",
            "productStatusTrackSerial": "Track serial",
            "variantPlaceholder": "Select a variant",
            "quantityLabel": "Quantity ordered",
            "quantityPlaceholder": "0",
            "unitCostLabel": "Unit cost",
            "unitCostPlaceholder": "0.00",
            "amountLabel": "Amount",
            "amountPlaceholder": "0.00",
            "addLine": "Add line",
            "removeLine": "Remove line",
            "cancel": "Cancel",
            "create": "Create purchase order",
            "emptyNotesModal": {
              "title": "Create without notes?",
              "message": "You are creating this purchase order without notes. Do you want to continue?",
              "quickInputLabel": "Add notes (optional)",
              "cancelButton": "Cancel",
              "confirmWithoutNotes": "Confirm create",
              "submitWithNotes": "Create with notes",
              "pending": "Creating…"
            },
            "errors": {
              "supplierRequired": "Select a supplier.",
              "orderDateRequired": "Select an order date.",
              "expectedDeliveryBeforeOrderDate": "Expected delivery date cannot be earlier than the order date.",
              "linesRequired": "Add at least one line with a product and quantity.",
              "paymentAccountRequired": "Select a payment account for cash orders.",
              "saveFailed": "Failed to create purchase order."
            }
          },
          "detail": {
            "documentTitle": "Purchase order",
            "title": "Purchase order — {{supplier}}",
            "pageHeading": "{{number}}",
            "pageSubtitle": "Review order details, receive stock, or download a printable PDF.",
            "formTitle": "Purchase order",
            "back": "Back to orders & receiving",
            "loading": "Loading purchase order…",
            "loadError": "Failed to load this purchase order.",
            "retry": "Try again",
            "viewPdfButton": "View PDF",
            "receiveButton": "Receive stock",
            "voidButton": "Void",
            "voidError": "Failed to void this purchase order.",
            "voidReasonLabel": "Reason (optional)",
            "voidReasonPlaceholder": "Why are you voiding this PO?",
            "cancel": "Cancel",
            "confirmVoid": "Confirm void",
            "createdAt": "Created",
            "createdBy": "Created by",
            "notes": "Notes",
            "voidedAt": "Voided",
            "paymentMethodLabel": "Payment method",
            "paymentStatusLabel": "Payment status",
            "paymentStatusPaid": "Paid",
            "paymentStatusUnpaid": "Unpaid (bill open)",
            "paymentStatusDeferred": "No bill yet (deferred until receive)",
            "linkedBillLabel": "Linked bill",
            "viewBillButton": "View bill",
            "linkedTransactionLabel": "Linked transaction",
            "viewLinkedTransactionButton": "View linked transaction",
            "proofOfBillingLabel": "Proof of billing",
            "proofOfBillingViewButton": "view",
            "proofOfBillingModalTitle": "Proof of billing",
            "proofOfBillingModalEmpty": "No documents uploaded yet.",
            "proofOfBillingModalLoading": "Loading documents…",
            "proofOfBillingModalLoadError": "Unable to load the uploaded documents.",
            "proofOfBillingModalClose": "Close",
            "referenceNumberLabel": "Reference no.",
            "expectedDeliveryLabel": "Expected delivery",
            "orderDateLabel": "Order date",
            "statusLabel": "Status",
            "vendorLabel": "Vendor / Supplier",
            "shipToLabel": "Ship / Bill to",
            "tinLabel": "TIN: {{tin}}",
            "telLabel": "Tel: {{tel}}",
            "totalLabel": "Total",
            "preparedBy": "Prepared by: {{name}}",
            "authorizedSignature": "Authorized signature",
            "acknowledgedSignature": "Date received / acknowledged",
            "voidedBanner": "This purchase order was voided on {{date}} by {{by}}.",
            "pdfPreview": {
              "title": "Purchase order PDF",
              "description": "Preview the printable purchase order, then download when ready.",
              "download": "Download PDF",
              "generating": "Generating…",
              "close": "Close",
              "closeAriaLabel": "Close PDF preview",
              "iframeTitle": "Purchase order PDF preview",
              "loading": "Loading preview…"
            },
            "table": {
              "index": "#",
              "product": "Description",
              "ordered": "Qty",
              "received": "Received",
              "unitCost": "Unit cost",
              "amount": "Amount"
            }
          }
        },
        "receive": {
          "status": {
            "draft": "Draft",
            "posted": "Posted",
            "voided": "Voided"
          },
          "form": {
            "documentTitle": "New receive",
            "title": "New receive",
            "subtitleFromPo": "Receiving against purchase order from {{supplier}}.",
            "subtitleSelectPo": "Select a purchase order, review the remaining quantities, then enter what you are receiving now.",
            "back": "Back to orders & receiving",
            "loadingPo": "Loading purchase order…",
            "purchaseOrderSummary": {
              "title": "Purchase Order Summary",
              "poNumberLabel": "PO Number",
              "supplierLabel": "Supplier",
              "orderDateLabel": "Order Date",
              "expectedDeliveryLabel": "Expected Delivery Date",
              "statusLabel": "Status",
              "amountToPayLabel": "Amount to Pay",
              "fullyPaid": "Fully Paid"
            },
            "receivingDetails": {
              "title": "Receiving Details",
              "receivingDateLabel": "Receiving Date",
              "warehouseLabel": "Warehouse"
            },
            "purchaseOrderLabel": "Purchase order",
            "purchaseOrderPlaceholder": "Select a purchase order",
            "purchaseOrderOption": "{{supplier}} — {{status}}",
            "purchaseOrderStatus": "Purchase order status",
            "totalOpenItemsLabel": "Open line items",
            "receivingDateLabel": "Receiving date",
            "receivingDatePlaceholder": "Select receiving date",
            "warehouseLabel": "Warehouse",
            "warehousePlaceholder": "Select a warehouse",
            "supplierLabel": "Supplier",
            "supplierPlaceholder": "Supplier will be filled from the purchase order",
            "apBillLabel": "Link AP bill (optional)",
            "apBillPlaceholder": "No bill linked",
            "apBillOption": "{{bookReferenceNumber}} — {{supplier}}",
            "apBillHint": "Links this receive to a bill for the same supplier.",
            "notesLabel": "Notes (recommended)",
            "notesPlaceholder": "Delivery note or reference",
            "linesTitle": "Items to receive",
            "productLabel": "Product",
            "quantityLabel": "Quantity",
            "receiveNowLabel": "Receive now",
            "quantityPlaceholder": "0",
            "unitCostLabel": "Unit cost",
            "unitCostPlaceholder": "0.00",
            "expiryLabel": "Expiry date (optional)",
            "expiryPlaceholder": "Select expiry date",
            "binLabel": "Bin (optional)",
            "binPlaceholder": "No bin",
            "serialNumbersLabel": "Serial numbers",
            "serialNumbersPlaceholder": "One serial per unit (comma or new line)",
            "serialNumbersHint": "Enter exactly as many serials as the quantity.",
            "lineMetrics": "Ordered: {{ordered}} | Previously received: {{received}} | Remaining: {{remaining}}",
            "selectPurchaseOrderHint": "Select a purchase order above to load the remaining items.",
            "scenarioCashSettlement": "Settles this receipt in cash: debit inventory, credit cash/bank. No bill is created or updated.",
            "scenarioPartialDeliveryBill": "Creates a new bill for this receipt only: debit inventory, credit cash/bank for the amount paid now, and credit Trade Accounts Payable for the rest. Earlier bills stay unchanged.",
            "scenarioReceiveOnlyBill": "Receive Only: creates a new open AP bill for this receipt only — debit inventory, credit Trade Accounts Payable. It is not added to an earlier bill, and no cash payment is recorded on receive.",
            "postImmediatelyLabel": "Post immediately (adds stock now)",
            "cancel": "Cancel",
            "create": "Create receive",
            "summary": {
              "totalItems": "Total items",
              "totalQuantity": "Total quantity to receive",
              "totalAmount": "Total amount"
            },
            "emptyNotesModal": {
              "title": "Create without notes?",
              "message": "You are creating this receive without notes. Do you want to continue?",
              "quickInputLabel": "Add notes (optional)",
              "cancelButton": "Cancel",
              "confirmWithoutNotes": "Confirm create",
              "submitWithNotes": "Create with notes",
              "pending": "Creating…"
            },
            "errors": {
              "purchaseOrderRequired": "Select a purchase order.",
              "purchaseOrderListLoadFailed": "Failed to load purchase orders ready to receive.",
              "warehouseRequired": "Select a warehouse.",
              "receivingDateRequired": "Select a receiving date.",
              "receivingDateInvalid": "Use a valid receiving date (YYYY-MM-DD).",
              "receiveNowRequired": "Enter at least one receive now quantity greater than zero.",
              "receiveNowExceeds": "{{product}} cannot exceed the remaining quantity of {{remaining}}.",
              "expiryInvalid": "Use a valid expiry date (YYYY-MM-DD).",
              "serialCount": "{{product}} needs exactly {{expected}} serial number(s) (got {{received}}).",
              "serialDuplicate": "{{product}} has duplicate serial numbers.",
              "purchaseOrderLoadFailed": "Failed to load the purchase order.",
              "saveFailed": "Failed to create receive."
            }
          },
          "detail": {
            "documentTitle": "Receive",
            "title": "Receive — {{supplier}}",
            "back": "Back to orders & receiving",
            "loading": "Loading receive…",
            "loadError": "Failed to load this receive.",
            "retry": "Try again",
            "postButton": "Post",
            "postError": "Failed to post this receive.",
            "voidButton": "Void",
            "voidError": "Failed to void this receive.",
            "voidReasonLabel": "Reason (optional)",
            "voidReasonPlaceholder": "Why are you voiding this receive?",
            "cancel": "Cancel",
            "confirmVoid": "Confirm void",
            "viewLinkedBill": "View Linked Bill",
            "createdAt": "Created",
            "createdBy": "Created by",
            "receivingDate": "Receiving date",
            "notes": "Notes",
            "postedAt": "Posted",
            "voidedAt": "Voided",
            "table": {
              "product": "Product",
              "quantity": "Quantity",
              "unitCost": "Unit cost"
            }
          }
        }
      },
      "inventoryReportsHub": {
        "documentTitle": "Inventory Reports",
        "pageTitle": "Inventory Reports",
        "subtitle": "Stock position, movements, purchasing, and valuation reports for POS inventory.",
        "backToHub": "Back to POS",
        "comingSoon": "Coming soon",
        "groups": {
          "stockPosition": "Stock position",
          "movementControl": "Movement & control",
          "purchasing": "Purchasing",
          "valuationAging": "Valuation & aging",
          "accounting": "Accounting"
        },
        "cards": {
          "stockOnHand": {
            "title": "Stock on hand",
            "description": "Current quantity by product and warehouse."
          },
          "warehouseSummary": {
            "title": "Warehouse stock summary",
            "description": "Compare on-hand stock across warehouses."
          },
          "lowStock": {
            "title": "Low stock / reorder",
            "description": "Items at or below reorder minimum."
          },
          "movementLedger": {
            "title": "Inventory movement ledger",
            "description": "All stock movements for a period."
          },
          "receivingSummary": {
            "title": "Receiving summary",
            "description": "Posted receives by supplier and warehouse."
          },
          "transfers": {
            "title": "Transfers & in-transit",
            "description": "Transfer status and stock still in transit."
          },
          "stockCountVariance": {
            "title": "Stock count variance",
            "description": "System vs counted quantities and adjustments."
          },
          "openPurchaseOrders": {
            "title": "Open purchase orders",
            "description": "POs still ordered or partially received."
          },
          "poFillProgress": {
            "title": "PO fill progress",
            "description": "Ordered vs received by purchase order line."
          },
          "valuation": {
            "title": "Inventory valuation",
            "description": "On-hand quantity × unit cost by product."
          },
          "aging": {
            "title": "Inventory aging",
            "description": "How long stock has been sitting in warehouses."
          },
          "nearExpiry": {
            "title": "Near expiry",
            "description": "Lots approaching or past expiry date."
          },
          "inventoryGeneralLedger": {
            "title": "Inventory General Ledger",
            "description": "Review and post inventory-out cost (COGS) to accounting."
          }
        }
      },
      "inventoryGeneralLedger": {
        "documentTitle": "Inventory General Ledger",
        "title": "Inventory General Ledger",
        "subtitle": "Review inventory-out transactions and post cost of goods sold to the General Ledger.",
        "backToReports": "Back to Inventory Reports",
        "tinLabel": "TIN: {{tin}}",
        "warehouseHeaderLabel": "Warehouse: {{warehouse}}",
        "warehouseLabel": "Warehouse",
        "allWarehouses": "All Warehouses",
        "categoryLabel": "Category",
        "allCategories": "All Categories",
        "dateRangeLabel": "Date Range",
        "dateFromLabel": "From",
        "dateToLabel": "To",
        "datePresetToday": "Today",
        "datePresetThisMonth": "This Month",
        "datePresetLastMonth": "Last Month",
        "datePresetThisYear": "This Year",
        "datePresetCustom": "Custom Range",
        "searchLabel": "Search",
        "searchPlaceholder": "Search reference number or item name…",
        "tabUnposted": "Unposted",
        "tabPosted": "Posted",
        "unpostedSectionTitle": "Unposted Inventory Transactions",
        "postedSectionTitle": "Posted Inventory Transactions",
        "postedSectionHint": "Inventory cost already posted to accounting.",
        "postedByUnknown": "—",
        "selectionSummary": "{{count}} transactions selected · {{amount}}",
        "postButton": "Post to Accounting",
        "posting": "Posting…",
        "selectSalesToPost": "Select at least one transaction to post.",
        "postSuccess": "Posted {{posted}} transaction(s) to accounting.",
        "postSuccessWithSkipped": "Posted {{posted}} transaction(s); skipped {{skipped}}.",
        "postFailed": "Failed to post inventory COGS to accounting.",
        "loading": "Loading…",
        "loadFailed": "Failed to load Inventory General Ledger.",
        "loadProductFailed": "Failed to load product.",
        "retry": "Try again",
        "emptyTitle": "No inventory transactions to show",
        "empty": "No inventory-out transactions match these filters.",
        "pageTotals": "Page totals",
        "totalBalance": "TOTAL BALANCE",
        "selectAllAria": "Select all transactions on this page",
        "selectRowAria": "Select {{ref}}",
        "exportButton": "Export",
        "exportButtonAriaLabel": "Export Inventory General Ledger",
        "exporting": "Exporting…",
        "exportOptionGoogleSheets": "Copy for Google Sheets",
        "exportOptionCsv": "CSV",
        "exportOptionExcel": "Excel",
        "exportOptionPdf": "PDF",
        "copiedForGoogleSheets": "Copied. Paste into a Google Sheet (Ctrl+V / ⌘V).",
        "copyForGoogleSheetsFailed": "Could not copy for Google Sheets. Try CSV or Excel instead.",
        "excelExportFailed": "Failed to export Excel file.",
        "infoTitle": "About the Inventory General Ledger",
        "infoFooter": "Each sale shows a summary description. Expand it to see journal lines: debit each product’s COGS category and credit its inventory asset. Debits are positive; credits show in parentheses. Posting writes the same entries to Accounting.",
        "saleDescription": "POS Inventory Cost (COGS)",
        "expandDescriptionAria": "Expand journal lines for sale {{ref}}",
        "collapseDescriptionAria": "Collapse journal lines for sale {{ref}}",
        "nonLeafCategoryFallback": "parent category",
        "editProductCategoryAria": "Edit product category for {{category}}",
        "nonLeafToastClickHint": "Click to open the product and choose a leaf account.",
        "productChooserTitle": "Choose a product to fix",
        "productChooserHint": "Several products use “{{category}}”. Pick one to reassign.",
        "productChooserCancel": "Cancel",
        "columns": {
          "date": "Date",
          "referenceNumber": "Ref. No.",
          "description": "Description",
          "transactionType": "Transaction Type",
          "warehouse": "Warehouse",
          "amount": "Amount",
          "runningBalance": "Running Balance",
          "postedAt": "Posted Date",
          "postedBy": "Posted By"
        }
      },
      "inventoryReports": {
        "stockOnHand": {
          "documentTitle": "Stock on hand",
          "pageTitle": "Stock on hand",
          "subtitle": "Current on-hand quantity by product, variant, and warehouse.",
          "back": "Back to Inventory Reports",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "searchLabel": "Search product",
          "searchPlaceholder": "Product name…",
          "applySearch": "Search",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Choose filters, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load stock on hand.",
          "empty": "No stock balances match these filters.",
          "summary": "{{lines}} lines · {{quantity}} total units",
          "table": {
            "product": "Product",
            "variant": "Variant",
            "warehouse": "Warehouse",
            "quantity": "Qty"
          },
          "csv": {
            "product": "Product",
            "variant": "Variant",
            "warehouse": "Warehouse",
            "quantity": "Quantity"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Stock on hand?",
            "modalTitle": "About Stock on hand",
            "whatItIsBody": "Stock on hand shows current POS inventory quantities by product and warehouse so you can see what is available right now.",
            "uniqueLiveQty": "Quantities come from live warehouse balances, not from a static snapshot file.",
            "uniqueWarehouseFilter": "Filter by warehouse or search by product name to focus on what you need.",
            "uniqueCsv": "Export CSV when you need a spreadsheet for ordering or stock review.",
            "includesBody": "Product name, optional variant, warehouse, and on-hand quantity for each balance row.",
            "thisPageBody": "Choose filters, generate the report, then export CSV if needed. Use Generate sample report to preview the layout with fictional data."
          }
        },
        "warehouseSummary": {
          "documentTitle": "Warehouse stock summary",
          "pageTitle": "Warehouse stock summary",
          "subtitle": "Compare on-hand stock totals and quantities across warehouses.",
          "back": "Back to Inventory Reports",
          "searchLabel": "Search product",
          "searchPlaceholder": "Product name…",
          "applySearch": "Search",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Generate to see warehouse totals and a product × warehouse matrix.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load warehouse stock summary.",
          "empty": "No stock balances match these filters.",
          "totalsTitle": "Totals by warehouse",
          "matrixTitle": "Quantity by product and warehouse",
          "table": {
            "warehouse": "Warehouse",
            "products": "Products",
            "lines": "Lines",
            "quantity": "Qty",
            "product": "Product",
            "variant": "Variant",
            "total": "Total"
          },
          "csv": {
            "product": "Product",
            "variant": "Variant",
            "total": "Total"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Warehouse stock summary?",
            "modalTitle": "About Warehouse stock summary",
            "whatItIsBody": "Warehouse stock summary rolls on-hand balances into per-warehouse totals and a product-by-warehouse matrix.",
            "uniqueByWarehouse": "See which warehouses hold the most stock at a glance.",
            "uniqueMatrix": "The matrix shows each product across warehouses in one table.",
            "uniqueCsv": "Export the matrix to CSV for planning transfers between locations.",
            "includesBody": "Warehouse totals (lines, products, quantity) plus a matrix of product quantities per warehouse.",
            "thisPageBody": "Optionally search, generate the report, then review totals and the matrix. Sample data shows how both sections look."
          }
        },
        "lowStock": {
          "documentTitle": "Low stock / reorder",
          "pageTitle": "Low stock / reorder",
          "subtitle": "Products at or below reorder minimum, with suggested order quantities.",
          "back": "Back to Inventory Reports",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Choose a warehouse filter, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load low stock report.",
          "empty": "No products are below reorder minimum for these filters.",
          "summary": "{{count}} low-stock items",
          "table": {
            "product": "Product",
            "warehouse": "Warehouse",
            "quantity": "On hand",
            "minQuantity": "Min",
            "reorderTo": "Reorder to",
            "suggestedOrder": "Suggested order"
          },
          "csv": {
            "product": "Product",
            "warehouse": "Warehouse",
            "quantity": "On hand",
            "minQuantity": "Min",
            "reorderTo": "Reorder to",
            "suggestedOrder": "Suggested order"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Low stock / reorder?",
            "modalTitle": "About Low stock / reorder",
            "whatItIsBody": "Low stock / reorder lists products at or below their reorder minimum so you know what to order next.",
            "uniqueReorderRules": "Rows come from reorder rules compared against current on-hand quantity.",
            "uniqueSuggestedOrder": "Suggested order quantity uses reorder-to when set, otherwise the gap to minimum.",
            "uniqueCsv": "Export CSV to share a buying list with purchasing.",
            "includesBody": "Product, warehouse, on-hand quantity, minimum, reorder-to, and suggested order quantity.",
            "thisPageBody": "Filter by warehouse if needed, generate the report, then export. Sample data demonstrates a typical low-stock list."
          }
        },
        "movementLedger": {
          "documentTitle": "Movement ledger",
          "pageTitle": "Movement ledger",
          "subtitle": "Company-wide stock movements by date, warehouse, and type.",
          "back": "Back to Inventory Reports",
          "dateFromLabel": "From",
          "dateToLabel": "To",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "typeLabel": "Movement type",
          "typeAll": "All types",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Set filters, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load movement ledger.",
          "empty": "No movements found for these filters.",
          "summary": "{{count}} movements",
          "table": {
            "when": "When",
            "product": "Product",
            "warehouse": "Warehouse",
            "type": "Type",
            "qtyChange": "Qty change",
            "qtyAfter": "Qty after",
            "reason": "Reason",
            "recordedBy": "Recorded by"
          },
          "csv": {
            "when": "When",
            "product": "Product",
            "warehouse": "Warehouse",
            "type": "Type",
            "qtyChange": "Qty change",
            "qtyAfter": "Qty after",
            "reason": "Reason",
            "recordedBy": "Recorded by"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Movement ledger?",
            "modalTitle": "About Movement ledger",
            "whatItIsBody": "Movement ledger is the company-wide stock movement history—receives, sales, transfers, counts, and adjustments.",
            "uniqueCompanyWide": "Unlike product history, this report covers all products for the company.",
            "uniqueDateFilter": "Filter by date range, warehouse, and movement type.",
            "uniqueCsv": "Export CSV for audit or investigation of stock changes.",
            "includesBody": "When, product, warehouse, movement type, quantity change, quantity after, reason, and who recorded it.",
            "thisPageBody": "Set dates and filters, generate the ledger, then export if needed. Sample data shows example receive and sale rows."
          }
        },
        "openPurchaseOrders": {
          "documentTitle": "Open purchase orders",
          "pageTitle": "Open purchase orders",
          "subtitle": "Purchase orders still waiting to be fully received.",
          "back": "Back to Inventory Reports",
          "statusLabel": "Status",
          "statusAll": "Ordered + partially received",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Choose a status filter, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load open purchase orders.",
          "empty": "No open purchase orders for these filters.",
          "summary": "{{count}} open purchase orders",
          "status": {
            "draft": "Draft",
            "ordered": "Ordered",
            "partiallyReceived": "Partially received",
            "fullyReceived": "Fully received",
            "cancelled": "Cancelled"
          },
          "table": {
            "po": "PO",
            "supplier": "Supplier",
            "status": "Status",
            "created": "Created",
            "lines": "Lines",
            "qtyOrdered": "Ordered",
            "qtyReceived": "Received",
            "qtyRemaining": "Remaining"
          },
          "csv": {
            "poId": "Purchase order ID",
            "supplier": "Supplier",
            "status": "Status",
            "created": "Created",
            "lines": "Lines",
            "qtyOrdered": "Ordered",
            "qtyReceived": "Received",
            "qtyRemaining": "Remaining"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What are Open purchase orders?",
            "modalTitle": "About Open purchase orders",
            "whatItIsBody": "Open purchase orders lists POs that are still ordered or only partially received—work still outstanding with suppliers.",
            "uniqueOpenOnly": "Fully received and cancelled POs are excluded so the list stays actionable.",
            "uniqueRemaining": "Each row shows ordered, received, and remaining quantities.",
            "uniqueCsv": "Export CSV for purchasing follow-up.",
            "includesBody": "PO link, supplier, status, created date, line count, ordered/received/remaining quantities.",
            "thisPageBody": "Optionally narrow by status, generate the report, then open a PO from the table. Sample data shows open and partial POs."
          }
        },
        "receivingSummary": {
          "documentTitle": "Receiving summary",
          "pageTitle": "Receiving summary",
          "subtitle": "Goods receipts by warehouse, status, and date.",
          "back": "Back to Inventory Reports",
          "dateFromLabel": "From",
          "dateToLabel": "To",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "statusLabel": "Status",
          "statusAll": "All statuses",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Set filters, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load receiving summary.",
          "empty": "No receives found for these filters.",
          "summary": "{{count}} receives",
          "status": {
            "draft": "Draft",
            "posted": "Posted",
            "voided": "Voided"
          },
          "table": {
            "receive": "Receive",
            "warehouse": "Warehouse",
            "supplier": "Supplier",
            "status": "Status",
            "date": "Date",
            "lines": "Lines",
            "quantity": "Qty",
            "lineValue": "Line value",
            "po": "PO"
          },
          "csv": {
            "receiveId": "Receive ID",
            "warehouse": "Warehouse",
            "supplier": "Supplier",
            "status": "Status",
            "date": "Date",
            "lines": "Lines",
            "quantity": "Qty",
            "lineValue": "Line value",
            "purchaseOrderId": "Purchase order ID"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Receiving summary?",
            "modalTitle": "About Receiving summary",
            "whatItIsBody": "Receiving summary lists goods receipts for a date range so you can review what arrived and from which suppliers.",
            "uniquePostedReceives": "Defaults to posted receives; you can include draft or voided if needed.",
            "uniqueDateRange": "Filter by posted/created calendar date, warehouse, and status.",
            "uniqueCsv": "Export CSV for receiving audits.",
            "includesBody": "Receive link, warehouse, supplier, status, date, lines, quantity, line value, and linked PO when present.",
            "thisPageBody": "Set date range and filters, generate, then drill into a receive or PO. Sample data shows typical posted receives."
          }
        },
        "transfers": {
          "documentTitle": "Transfers / in-transit",
          "pageTitle": "Transfers / in-transit",
          "subtitle": "Warehouse transfers and quantities still in transit.",
          "back": "Back to Inventory Reports",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "statusLabel": "Status",
          "statusAll": "All statuses",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Set filters, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load transfers report.",
          "empty": "No transfers found for these filters.",
          "summary": "{{count}} transfers",
          "status": {
            "draft": "Draft",
            "inTransit": "In transit",
            "received": "Received",
            "voided": "Voided"
          },
          "table": {
            "transfer": "Transfer",
            "from": "From",
            "to": "To",
            "status": "Status",
            "shipped": "Shipped",
            "qty": "Qty",
            "qtyReceived": "Received",
            "qtyInTransit": "In transit"
          },
          "csv": {
            "transferId": "Transfer ID",
            "fromWarehouse": "From warehouse",
            "toWarehouse": "To warehouse",
            "status": "Status",
            "shipped": "Shipped",
            "qty": "Qty",
            "qtyReceived": "Received",
            "qtyInTransit": "In transit"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Transfers / in-transit?",
            "modalTitle": "About Transfers / in-transit",
            "whatItIsBody": "Transfers / in-transit shows warehouse transfers and how much quantity is still moving between locations.",
            "uniqueInTransit": "Defaults to in-transit transfers so you can see stock that has left but not fully arrived.",
            "uniqueWarehouseFilter": "Filter by warehouse involved in the transfer and by status.",
            "uniqueCsv": "Export CSV for logistics follow-up.",
            "includesBody": "Transfer link, from/to warehouses, status, shipped date, quantity, received, and still in transit.",
            "thisPageBody": "Choose warehouse and status, generate the report, then open a transfer. Sample data includes in-transit and draft examples."
          }
        },
        "stockCountVariance": {
          "documentTitle": "Stock count variance",
          "pageTitle": "Stock count variance",
          "subtitle": "Counted vs system quantities from completed stock counts.",
          "back": "Back to Inventory Reports",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "variancesOnly": "Show variances only",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Set filters, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load stock count variance.",
          "empty": "No variance lines found for these filters.",
          "summary": "{{count}} count lines",
          "table": {
            "count": "Count",
            "warehouse": "Warehouse",
            "completed": "Completed",
            "product": "Product",
            "systemQty": "System",
            "countedQty": "Counted",
            "variance": "Variance"
          },
          "csv": {
            "stockCountId": "Stock count ID",
            "warehouse": "Warehouse",
            "completed": "Completed",
            "product": "Product",
            "systemQty": "System",
            "countedQty": "Counted",
            "variance": "Variance"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Stock count variance?",
            "modalTitle": "About Stock count variance",
            "whatItIsBody": "Stock count variance compares counted quantities to system quantities from completed stock counts.",
            "uniqueCompletedCounts": "Only completed counts are included so variances reflect finished work.",
            "uniqueVariance": "Variance is counted minus system; you can hide zero-variance lines.",
            "uniqueCsv": "Export CSV for shrinkage or overage review.",
            "includesBody": "Count link, warehouse, completed date, product, system qty, counted qty, and variance.",
            "thisPageBody": "Filter by warehouse, optionally show variances only, then generate. Sample data shows over and short lines."
          }
        },
        "poFillProgress": {
          "documentTitle": "PO fill progress",
          "pageTitle": "PO fill progress",
          "subtitle": "How much of each purchase order has been received.",
          "back": "Back to Inventory Reports",
          "statusLabel": "Status",
          "statusAll": "Ordered + partially + fully received",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Choose a status filter, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load PO fill progress.",
          "empty": "No purchase orders found for these filters.",
          "summary": "{{count}} purchase orders",
          "status": {
            "draft": "Draft",
            "ordered": "Ordered",
            "partiallyReceived": "Partially received",
            "fullyReceived": "Fully received",
            "cancelled": "Cancelled"
          },
          "table": {
            "po": "PO",
            "supplier": "Supplier",
            "status": "Status",
            "created": "Created",
            "qtyOrdered": "Ordered",
            "qtyReceived": "Received",
            "fillPercent": "Fill %"
          },
          "csv": {
            "poId": "Purchase order ID",
            "supplier": "Supplier",
            "status": "Status",
            "created": "Created",
            "qtyOrdered": "Ordered",
            "qtyReceived": "Received",
            "fillPercent": "Fill %"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is PO fill progress?",
            "modalTitle": "About PO fill progress",
            "whatItIsBody": "PO fill progress shows how much of each purchase order has been received as a fill percentage.",
            "uniqueFillPercent": "Fill % is received quantity divided by ordered quantity.",
            "uniqueStatusFilter": "Include ordered, partially received, and fully received POs (cancelled excluded by default).",
            "uniqueCsv": "Export CSV to track supplier fulfillment.",
            "includesBody": "PO link, supplier, status, created date, ordered qty, received qty, and fill %.",
            "thisPageBody": "Optionally filter by status, generate, and focus on low fill %. Sample data spans 0% to 100% fill."
          }
        },
        "valuation": {
          "documentTitle": "Inventory valuation",
          "pageTitle": "Inventory valuation",
          "subtitle": "On-hand quantity valued at lot unit cost.",
          "back": "Back to Inventory Reports",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Choose a warehouse filter, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load inventory valuation.",
          "empty": "No remaining lots found for these filters.",
          "summary": "{{count}} product lines · total value {{total}}",
          "table": {
            "product": "Product",
            "warehouse": "Warehouse",
            "quantity": "Qty",
            "value": "Value"
          },
          "csv": {
            "product": "Product",
            "warehouse": "Warehouse",
            "quantity": "Qty",
            "value": "Value"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Inventory valuation?",
            "modalTitle": "About Inventory valuation",
            "whatItIsBody": "Inventory valuation estimates on-hand value using remaining lot quantities times each lot unit cost.",
            "uniqueLotCost": "Value is based on lot unit cost, not a separate GL valuation method.",
            "uniqueWarehouseFilter": "Filter by warehouse to value one location at a time.",
            "uniqueCsv": "Export CSV for management review.",
            "includesBody": "Product, warehouse, remaining quantity, and extended value aggregated from lots.",
            "thisPageBody": "Choose a warehouse if needed, generate the valuation, then export. Sample data shows example valued lines."
          }
        },
        "aging": {
          "documentTitle": "Inventory aging",
          "pageTitle": "Inventory aging",
          "subtitle": "Remaining lot quantity and value by age since received.",
          "back": "Back to Inventory Reports",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Choose a warehouse filter, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load inventory aging.",
          "empty": "No remaining lots found for these filters.",
          "summary": "{{lots}} lots across age buckets",
          "buckets": {
            "d0_30": "0–30 days",
            "d31_60": "31–60 days",
            "d61_90": "61–90 days",
            "d90_plus": "90+ days"
          },
          "table": {
            "bucket": "Age",
            "lots": "Lots",
            "quantity": "Qty",
            "value": "Value"
          },
          "csv": {
            "bucket": "Age",
            "lots": "Lots",
            "quantity": "Qty",
            "value": "Value"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Inventory aging?",
            "modalTitle": "About Inventory aging",
            "whatItIsBody": "Inventory aging buckets remaining lot quantity and value by how long ago stock was received.",
            "uniqueAgeBuckets": "Buckets are 0-30, 31-60, 61-90, and 90+ days since received.",
            "uniqueLotValue": "Each bucket shows lot count, quantity, and value at lot unit cost.",
            "uniqueCsv": "Export CSV to spot slow-moving stock.",
            "includesBody": "Age bucket, number of lots, quantity, and value for remaining stock.",
            "thisPageBody": "Filter by warehouse if needed and generate. Sample data fills every age bucket so you can see the layout."
          }
        },
        "nearExpiry": {
          "documentTitle": "Near expiry",
          "pageTitle": "Near expiry",
          "subtitle": "Lots with an expiry date within the selected window.",
          "back": "Back to Inventory Reports",
          "warehouseLabel": "Warehouse",
          "warehouseAll": "All warehouses",
          "daysAheadLabel": "Days ahead",
          "generate": "Generate report",
          "generating": "Generating…",
          "generateHint": "Set filters, then generate the report.",
          "exportCsv": "Export CSV",
          "retry": "Try again",
          "loadFailed": "Failed to load near-expiry lots.",
          "empty": "No near-expiry lots found for these filters.",
          "summary": "{{count}} lots",
          "table": {
            "product": "Product",
            "warehouse": "Warehouse",
            "expiry": "Expiry",
            "daysLeft": "Days left",
            "quantity": "Qty",
            "unitCost": "Unit cost",
            "supplier": "Supplier"
          },
          "csv": {
            "product": "Product",
            "warehouse": "Warehouse",
            "expiry": "Expiry",
            "daysLeft": "Days left",
            "quantity": "Qty",
            "unitCost": "Unit cost",
            "supplier": "Supplier"
          },
          "help": {
            "close": "Close",
            "whatItIsTitle": "What it is",
            "uniqueTitle": "What makes it unique",
            "includesTitle": "What the report includes",
            "thisPageTitle": "Using this page",
            "generateSample": "Generate sample report",
            "iconAriaLabel": "What is Near expiry?",
            "modalTitle": "About Near expiry",
            "whatItIsBody": "Near expiry lists remaining lots whose expiry date falls within a chosen number of days ahead.",
            "uniqueExpiryWindow": "Set how many days ahead to look; only lots with an expiry date are included.",
            "uniqueDaysLeft": "Days left helps prioritize what to sell or use first.",
            "uniqueCsv": "Export CSV for FEFO planning.",
            "includesBody": "Product, warehouse, expiry date, days left, quantity, unit cost, and supplier when known.",
            "thisPageBody": "Set warehouse and days ahead, generate, then act on soon-to-expire lots. Sample data shows upcoming expiries."
          }
        },
        "shared": {
          "sampleBanner": "Showing sample data so you can see how this report looks. Generate the report to load your real inventory data."
        }
      }
    },
    "notFound": {
      "srTitle": "404",
      "subtitle": "Page not found.",
      "lookedFor": "Looked for: {{path}}",
      "goHome": "Go home",
      "goBack": "Go back"
    },
    "auth": {
      "callback": {
        "authorizationFailed": "Authorization failed",
        "noAuthorizationCode": "No authorization code received",
        "failedToComplete": "Failed to complete authentication",
        "authenticationFailedTitle": "Authentication Failed",
        "tryAgain": "Try Again",
        "goToHome": "Go to Home",
        "redirecting": "Redirecting..."
      }
    },
    "support": {
      "backToHome": "Back to Home",
      "title": "Contact Support",
      "description": "Have questions or need assistance with AbraFi? Our team is here to help. You can reach out to us via email anytime.",
      "emailLabel": "Support Email",
      "copyEmailTitle": "Copy email",
      "sendEmailDirectly": "Send Email Directly",
      "responseTimeNote": "Response time is typically within 24-48 business hours."
    },
    "verifyReceipt": {
      "documentTitle": "Verify POS receipt — AbraFi",
      "brand": "AbraFi",
      "title": "Receipt verification",
      "loading": "Checking this receipt…",
      "validTitle": "Authentic sales invoice",
      "validBody": "This verification seal matches a POS sale recorded in AbraFi.",
      "voidedTitle": "Voided sales invoice",
      "voidedBody": "This seal matches a POS sale that was later voided. It is not a valid sale for payment.",
      "demoTitle": "Demo / training receipt",
      "demoBody": "This seal is from POS demo or layout test mode. It is not an official sales invoice.",
      "notFoundTitle": "Receipt not found",
      "errorTitle": "Could not verify",
      "missingSeal": "No verification seal was provided in the link.",
      "loadFailed": "Failed to verify this receipt. Please try again.",
      "companyLabel": "Business",
      "invoiceLabel": "Invoice no.",
      "soldAtLabel": "Sold at",
      "totalLabel": "Total",
      "sealLabel": "Seal",
      "backHome": "Back to Home"
    },
    "verifyArInvoice": {
      "documentTitle": "Verify invoice — AbraFi",
      "brand": "AbraFi",
      "title": "Invoice verification",
      "loading": "Checking this invoice…",
      "validTitle": "Authentic invoice",
      "validBody": "This verification seal matches an invoice recorded in AbraFi.",
      "voidedTitle": "Cancelled invoice",
      "voidedBody": "This seal matches an invoice that was later cancelled. It is not a valid invoice for payment.",
      "notFoundTitle": "Invoice not found",
      "errorTitle": "Could not verify",
      "missingSeal": "No verification seal was provided in the link.",
      "loadFailed": "Failed to verify this invoice. Please try again.",
      "sellerLabel": "Business",
      "invoiceLabel": "Invoice no.",
      "dateLabel": "Date",
      "documentKindLabel": "Document type",
      "documentKindVat": "VAT Invoice",
      "documentKindNonVat": "Non-VAT Invoice",
      "totalLabel": "Total",
      "backHome": "Back to Home"
    },
    "taxCalculator": {
      "backToHome": "Back to Home",
      "title": "Philippines Income Tax Calculator",
      "subtitle": "Step through BMBE eligibility, income inputs, and VAT (when applicable) to compare 8% flat tax, graduated OSD, itemized deductions, and BMBE itemized (BMBE requires itemized — not OSD).",
      "formHeading": "Tax calculator inputs",
      "classificationLabel": "Taxpayer classification",
      "classificationPurelySelfEmployed": "Purely business income / self-employed / professional",
      "classificationMixedIncome": "Mixed income earner",
      "annualCompensationLabel": "Annual compensation from employment",
      "grossSalesLabel": "Gross annual sales / receipts",
      "expensesWithReceiptsLabel": "Expenses with valid receipts",
      "expensesWithReceiptsHint": "Used for itemized deduction only.",
      "expensesWithoutReceiptsLabel": "Expenses without receipts",
      "expensesWithoutReceiptsHint": "Not deducted in this calculator; shown as a planning guide only.",
      "withoutReceiptsGuide": "You entered {{amount}} in expenses without receipts. OSD may be more practical when many costs lack official receipts.",
      "calculateButton": "Calculate",
      "resultsTitle": "Comparison summary",
      "results": {
        "nextStepsTitle": "Try a different scenario",
        "nextStepsBody": "Use Change on any row in Your inputs to tweak one answer and refresh the comparison, or load a sample below.",
        "browseSamplesLink": "Browse sample scenarios ↓",
        "startFreshLink": "Start Over"
      },
      "summary": {
        "title": "Your inputs",
        "editHint": "Tap Change on any row to update one answer.",
        "changeButton": "Change",
        "fromPreset": "Loaded from sample: {{name}}",
        "toggleShow": "Show your inputs",
        "toggleHide": "Hide your inputs",
        "chipVat": "VAT-registered",
        "chipNonVat": "Below VAT threshold",
        "chipBmbe": "BMBE eligible",
        "chipNonBmbe": "Not BMBE",
        "bmbeSection": "BMBE eligibility answers",
        "bmbeStatusLabel": "BMBE eligibility result",
        "bmbeEligible": "May qualify for BMBE",
        "bmbeIneligible": "Does not qualify for BMBE",
        "bmbeNotAnswered": "No BMBE answers were recorded for this comparison.",
        "incomeSection": "Income tax inputs",
        "vatSection": "VAT inputs",
        "classificationShort": "Classification",
        "annualCompensationShort": "Employment income",
        "grossSalesShort": "Gross sales",
        "expensesWithReceiptsShort": "Expenses with receipts",
        "expensesWithoutReceiptsShort": "Expenses without receipts",
        "outputVatShort": "Output VAT",
        "inputVatShort": "Input VAT credits"
      },
      "insightFlat8Disqualified": "You are not eligible for the 8% flat rate because gross sales exceed the ₱3,000,000 VAT threshold.",
      "insightFlat8Wins": "8% flat tax has the lowest estimated total tax for your inputs.",
      "insightOsdWins": "OSD is recommended because you have significant expenses without receipts. The automatic 40% deduction may cost less than itemizing.",
      "insightOsdWinsGeneric": "Graduated OSD has the lowest estimated total tax for your inputs.",
      "insightItemizedWins": "Itemized is recommended because your documented expenses with official receipts lower taxable income the most.",
      "regimeFlat8Title": "8% Flat Tax",
      "regimeOsdTitle": "Graduated + OSD",
      "regimeItemizedTitle": "Graduated + Itemized",
      "regimeItemizedBmbeTitle": "Graduated + Itemized + BMBE",
      "mostRecommended": "Most recommended",
      "disqualifiedShort": "Disqualified",
      "disqualifyVatThreshold": "Not eligible — gross sales exceed the ₱3,000,000 VAT threshold.",
      "disqualifyBmbeIneligible": "Not eligible — BMBE criteria not met from your answers.",
      "disqualifyBmbeFlat8Conflict": "Not compatible — BMBE income tax exemption cannot be combined with the 8% flat rate.",
      "totalTaxLine": "Total tax: {{amount}}",
      "incomeTaxLine": "Income tax: {{amount}}",
      "employmentIncomeTaxLine": "Employment income tax: {{amount}}",
      "businessIncomeTaxLine": "Business income tax: {{amount}}",
      "businessIncomeTaxExemptBmbeLine": "Business income tax: exempt (BMBE)",
      "combinedIncomeTaxLine": "Combined income tax (employment + business): {{amount}}",
      "mixedIncomeTotalsNote": "Mixed income totals combine graduated tax on your employment compensation with tax on your business income. Under 8% flat tax, employment uses graduated rates and business uses 8% on gross (no ₱250,000 deduction). Under graduated elections, compensation and business net income are taxed together at graduated rates.",
      "incomeTaxExemptBmbeLine": "Income tax: exempt (BMBE)",
      "percentageTaxLine": "Percentage tax ({{rate}}): {{amount}}",
      "percentageTaxExemptLine": "Percentage tax: exempt (8% regime)",
      "outputVatLine": "Output VAT ({{rate}}): {{amount}}",
      "inputVatCreditLine": "Input VAT credit: {{amount}}",
      "netVatLine": "Net VAT payable: {{amount}}",
      "taxableIncomeLine": "Taxable income: {{amount}}",
      "insightVatRegistered": "Your gross sales exceed ₱3,000,000, so VAT registration applies. Percentage tax does not apply in these scenarios.",
      "insightVatBmbeNote": "BMBE can still apply above ₱3,000,000 in sales if total assets stay within the BMBE limit — BMBE exempts income tax, not VAT.",
      "insightBmbeWins": "Graduated itemized with BMBE has the lowest estimated total tax for your inputs.",
      "insightBmbeAlternative": "You may qualify for BMBE — compare the BMBE column for a potentially lower income tax outcome.",
      "insightItemizedBmbeWins": "Graduated itemized with BMBE has the lowest estimated total tax for your inputs.",
      "bmbeEligibleNote": "You answered in line with basic BMBE requirements. BMBE exempts income tax on qualified operations but not VAT or percentage tax. Registered BMBEs must use itemized deductions — OSD is not allowed. Confirm registration with your LGU or a DTI Negosyo Center.",
      "bmbeIneligibleNote": "Based on your BMBE answers, the BMBE columns are shown as not eligible. You can still compare the standard 8%, OSD, and itemized scenarios.",
      "disclaimer": "Estimates use BIR graduated income tax brackets plus 3% percentage tax on gross sales for graduated regimes below the ₱3,000,000 VAT threshold. The 8% regime has no percentage tax. Confirm rates (e.g. 1% CREATE relief) and eligibility with your accountant.",
      "disclaimerVat": "Estimates use BIR graduated income tax brackets plus net VAT (output VAT minus input VAT credits) when gross sales exceed ₱3,000,000. BMBE exempts income tax only — VAT still applies. Confirm rates and registration status with your accountant.",
      "languageToggleLabel": "Language",
      "presets": {
        "title": "Explore Sample Scenarios",
        "titleWithResults": "Try another sample",
        "subtitle": "Skip the questions and load realistic example cases by category — below or above the VAT threshold, with or without BMBE eligibility.",
        "subtitleWithResults": "Load a different example to compare another VAT, BMBE, or income profile without starting from scratch.",
        "sampleLabel": "Sample",
        "usePresetButton": "Use this preset",
        "categories": {
          "nonVatNonBmbe": {
            "title": "Non-VAT without BMBE",
            "description": "Gross sales at or below ₱3,000,000 with answers that do not qualify for BMBE. Compare 8% flat, OSD, and itemized without BMBE columns."
          },
          "nonVatBmbe": {
            "title": "Non-VAT + BMBE",
            "description": "Sales stay under the VAT threshold but BMBE answers pass. Includes graduated + BMBE comparison columns."
          },
          "vatNonBmbe": {
            "title": "VAT-Registered without BMBE",
            "description": "Gross sales above ₱3,000,000 with net VAT and no BMBE eligibility. The 8% flat column is disqualified."
          },
          "vatBmbe": {
            "title": "VAT-Registered + BMBE",
            "description": "Above the VAT threshold yet still BMBE-eligible on assets and activity. Compare VAT plus BMBE income tax exemption."
          }
        },
        "items": {
          "freelancerFlat8": {
            "title": "Freelancer below VAT threshold",
            "description": "Purely self-employed at PHP 600k sales with light documented expenses and some unreceipted costs."
          },
          "foodStallMicro": {
            "title": "Micro food stall",
            "description": "PHP 280k annual sales with minimal receipted and unreceipted costs — a small 8% flat candidate."
          },
          "mixedIncome": {
            "title": "Mixed-income side hustle",
            "description": "Employee with a small business on the side at PHP 450k sales and moderate receipted expenses."
          },
          "serviceOsd": {
            "title": "Service business leaning OSD",
            "description": "PHP 950k sales, modest receipted expenses, and higher unreceipted costs to explore when OSD becomes practical."
          },
          "onlineSellerItemized": {
            "title": "Online seller with strong receipts",
            "description": "PHP 1.85M sales and PHP 1.1M documented expenses — itemized may beat OSD."
          },
          "nearVatThreshold": {
            "title": "Just below VAT registration",
            "description": "PHP 2.95M sales — still percentage tax, not VAT, but close to the threshold."
          },
          "highAssetsNonBmbe": {
            "title": "Assets above BMBE limit",
            "description": "PHP 1.4M sales but total business assets exceed ₱3M, so BMBE columns are disqualified."
          },
          "licensedProfessionalNonBmbe": {
            "title": "Licensed professional practice",
            "description": "PHP 2.2M sales from licensed professional work — BMBE does not apply to this activity."
          },
          "enterpriseBranchNonBmbe": {
            "title": "Branch of a large company",
            "description": "PHP 900k sales from a business controlled by a large enterprise — not BMBE-eligible."
          },
          "outsideBarangayNonBmbe": {
            "title": "Operates outside home barangay",
            "description": "PHP 1.1M sales with main activity outside the barangay or city of residence."
          },
          "retailBmbeItemized": {
            "title": "Retail shop with BMBE potential",
            "description": "PHP 1.2M sales, strong documented expenses, and answers that qualify for BMBE comparisons."
          },
          "sariSariBmbeOsd": {
            "title": "Sari-sari store (BMBE itemized)",
            "description": "PHP 820k neighborhood retail with modest receipts — compare itemized BMBE vs standard regimes (OSD not allowed with BMBE)."
          },
          "homeFoodBmbe": {
            "title": "Home-based food business",
            "description": "PHP 550k home kitchen sales with BMBE-eligible answers and light expenses."
          },
          "barangayServicesBmbe": {
            "title": "Barangay service microbusiness",
            "description": "PHP 680k local services with mixed receipted and unreceipted spending."
          },
          "mixedIncomeBmbe": {
            "title": "Mixed income with BMBE",
            "description": "Employee plus PHP 520k side business that may qualify for BMBE registration."
          },
          "bmbeHeavyItemized": {
            "title": "BMBE with heavy itemized expenses",
            "description": "PHP 1.5M sales and PHP 980k receipted costs — itemized BMBE vs standard graduated options."
          },
          "vatThresholdEdge": {
            "title": "Just crossed VAT threshold",
            "description": "PHP 3.05M sales — newly VAT-registered with moderate input VAT credits."
          },
          "vatStandard": {
            "title": "VAT-registered standard case",
            "description": "PHP 3.8M sales with output VAT and input VAT credits for a normal VAT taxpayer comparison."
          },
          "vatItemizedStrong": {
            "title": "VAT with strong itemized deductions",
            "description": "PHP 3.6M sales and PHP 2.1M receipted expenses — graduated itemized vs OSD under VAT."
          },
          "vatLowInputCredits": {
            "title": "VAT with few input credits",
            "description": "PHP 4.5M sales but only PHP 45k input VAT — higher net VAT payable."
          },
          "vatMixedIncome": {
            "title": "Mixed income above VAT threshold",
            "description": "Employee plus PHP 3.4M business sales with VAT and percentage tax off the table."
          },
          "vatHighVolume": {
            "title": "High-volume VAT retailer",
            "description": "PHP 6M sales with substantial receipted purchases and input VAT credits."
          },
          "vatProfessionalNonBmbe": {
            "title": "VAT professional firm",
            "description": "PHP 4.2M licensed professional revenue — VAT applies, BMBE does not."
          },
          "vatBmbeModerate": {
            "title": "VAT + BMBE (moderate sales)",
            "description": "PHP 3.5M sales with BMBE-eligible answers — income tax exempt, VAT still due."
          },
          "vatBmbe": {
            "title": "VAT taxpayer that may still qualify for BMBE",
            "description": "PHP 4.2M sales, VAT credits, and BMBE-eligible answers to compare VAT plus BMBE outcomes."
          },
          "vatBmbeOsdProfile": {
            "title": "VAT + BMBE with mixed expenses",
            "description": "PHP 4.8M sales, high unreceipted expenses, and BMBE eligibility — itemized BMBE only (not OSD)."
          },
          "vatBmbeStrongCredits": {
            "title": "VAT + BMBE with strong input VAT",
            "description": "PHP 5M sales, PHP 340k input VAT credits, and BMBE-qualified operations."
          },
          "vatBmbeMixedIncome": {
            "title": "VAT + BMBE mixed income",
            "description": "Employee with PHP 3.9M side business, VAT registration, and BMBE-eligible answers."
          }
        }
      },
      "wizard": {
        "formHeading": "Tax calculator wizard",
        "progressQuestion": "Step {{current}} of {{total}}",
        "progressPercent": "{{percent}}% complete",
        "progressAriaLabel": "Tax calculator progress",
        "bmbeSectionLabel": "BMBE eligibility",
        "incomeSectionLabel": "Income tax inputs",
        "vatSectionLabel": "VAT inputs",
        "classificationHint": "Choose purely business/self-employed or mixed income (employment plus business). This affects the 8% flat tax deduction and how employment compensation is taxed.",
        "annualCompensationHint": "Enter your total annual compensation from employment (salary, wages, and other compensation subject to withholding). Business gross sales are entered on the next step.",
        "grossSalesHint": "Enter your total annual gross sales or receipts. Above ₱3,000,000 you are generally VAT-registered.",
        "grossSalesMixedIncomeHint": "Enter your business gross sales or receipts only — not your employment income. Above ₱3,000,000 you are generally VAT-registered.",
        "outputVatLabel": "Estimated annual output VAT",
        "outputVatHint": "Typically 12% of your vatable sales (tax-exclusive). We pre-fill a suggestion from your gross sales — adjust if your invoices differ.",
        "inputVatLabel": "Estimated annual input VAT credits",
        "inputVatHint": "VAT you can claim from purchases with valid VAT invoices (supplies, rent, services, etc.).",
        "startOverButton": "Start Over",
        "editHeading": "Update an answer",
        "cancelEditButton": "Cancel",
        "updateEstimateButton": "Update estimate",
        "enterAmountHint": "Please enter an amount to continue.",
        "jumpToPresets": "Or jump to sample scenarios ↓",
        "intro": {
          "title": "Before we begin",
          "lead": "This short questionnaire walks through your business profile so we can compare Philippine income tax options side by side — including BMBE, 8% flat tax, OSD, and itemized deductions.",
          "steps": {
            "bmbe": "Quick BMBE eligibility check (yes/no questions)",
            "income": "Your classification, gross sales, and expenses",
            "vat": "VAT inputs if your sales are above ₱3,000,000",
            "compare": "A comparison of estimated total tax per regime"
          },
          "note": "You can change any answer later from your results, or load a sample scenario below to skip the questions.",
          "startButton": "Start the questionnaire",
          "presetsLink": "Or explore sample scenarios first ↓"
        }
      },
      "bmbe": {
        "backButton": "Back",
        "nextButton": "Next",
        "pickAnswerHint": "Please choose Yes or No to continue.",
        "answerYes": "Yes",
        "answerNo": "No",
        "criteria": {
          "totalAssets": {
            "headline": "Business size",
            "question": "Do your total business assets exceed ₱3 million or more?",
            "help": "Include things like equipment, inventory, and tools used for your business. Do not count the land under your shop, office, or plant. Answer Yes if the total exceeds ₱3 million.",
            "failureExplain": "BMBE is for micro businesses with total assets of ₱3 million or less (excluding land). Because you answered that your assets exceed this limit, you do not meet this BMBE requirement."
          },
          "barangayBased": {
            "headline": "Local operations",
            "question": "Does your business mainly operate in your barangay or city?",
            "help": "This often means most workers live nearby, you use local skills or materials, or your work stays within your city or municipality (LGU).",
            "failureExplain": "BMBE businesses should be barangay-based—operating mainly in your local area with local workers, skills, or materials. You answered No, so your business may not qualify under this rule."
          },
          "largeEnterprise": {
            "headline": "Independence",
            "question": "Is your business a branch, subsidiary, or office controlled by a large company?",
            "help": "Answer Yes only if a big corporation owns or controls how you run the business. For BMBE, you should usually answer No.",
            "failureExplain": "You answered that a large company controls your business. BMBE registration is for independent micro businesses, not branches, subsidiaries, or offices of big corporations."
          },
          "licensedProfessional": {
            "headline": "Type of service",
            "question": "Does your main source of income come from regulated/licensed professional services (e.g. lawyer, CPA, doctor, pharmacist)?",
            "help": "Answer Yes if your main source of income comes from regulated professions. Many BMBE applicants are shops, traders, or general services and answer No.",
            "failureExplain": "You answered that your main source of income comes from a regulated profession. Businesses centered on law, medicine, accounting, pharmacy, and similar regulated services are generally not eligible for BMBE."
          }
        }
      }
    },
    "legal": {
      "effectiveDateLabel": "Effective Date",
      "lastUpdatedLabel": "Last Updated",
      "backToAbraFi": "Back to AbraFi",
      "footerCopyright": "© {{year}} Abrasoft I.T. Services. All rights reserved.",
      "privacy": {
        "title": "Privacy Policy",
        "scopeHeading": "Scope and Applicable Laws",
        "scopeP1": "This Privacy Policy explains how Abrasoft I.T. Services handles personal data when you use AbraFi and our related services.",
        "scopeP2": "Our privacy practices are aligned with the Data Privacy Act of 2012 (Philippines), ensuring that your accounting data and personal information are handled with the highest level of confidentiality and security.",
        "collectHeading": "Information We Collect",
        "collectB1": "Identity information such as name and business details.",
        "collectB2": "Contact information including email address and phone number.",
        "collectB3": "Financial data provided through receipt uploads and transaction entries.",
        "collectB4": "Technical data such as IP address and session activity for security monitoring.",
        "useHeading": "How We Use Your Data",
        "useB1": "To provide automated bookkeeping services and generate financial reports.",
        "useB2": "To ensure compliance with PFRS (Philippine Financial Reporting Standards).",
        "useB3": "To maintain account security and prevent unauthorized access.",
        "useB4": "To provide customer support and service updates.",
        "securityHeading": "Data Security",
        "securityP1": "We implement industry-standard encryption and security measures to protect your sensitive financial data.",
        "securityP2": "However, you are responsible for maintaining the confidentiality of your login credentials.",
        "contactHeading": "Contact Us",
        "contactP1": "For any privacy-related concerns or requests, please contact us at {{email}}.",
        "npcCertificateLink": "NPC Certificate of Registration"
      },
      "npcCertificate": {
        "title": "NPC Certificate of Registration",
        "backToPrivacyPolicy": "Back to Privacy Policy",
        "viewOnlyNote": "This certificate is provided for viewing only.",
        "documentAriaLabel": "NPC certificate of registration document",
        "pageAlt": "NPC certificate of registration page {{page}}"
      },
      "terms": {
        "title": "Terms of Use and Terms & Conditions",
        "acceptanceHeading": "Acceptance of Terms",
        "acceptanceP1": "By creating an account on AbraFi, you agree to these Terms & Conditions and all applicable laws of the Republic of the Philippines.",
        "responsibilitiesHeading": "User Responsibilities",
        "responsibilitiesB1": "You are responsible for the accuracy and completeness of the data you upload or enter into the system.",
        "responsibilitiesB2": "You must ensure that all uploaded receipts and financial records are authentic and comply with tax regulations.",
        "responsibilitiesB3": "The automated generation of records depends on the quality of your inputs; AbraFi is not liable for errors caused by inaccurate user data.",
        "scopeHeading": "Service Scope",
        "scopeP1": "AbraFi provides automated bookkeeping and financial reporting (Income Statement, Balance Sheet, Cash Flow, etc.) based on Philippine Financial Reporting Standards (PFRS).",
        "scopeP2": "While our system is designed to meet these standards, it is a tool meant to assist you. It does not replace professional auditing or certified public accounting services.",
        "ipHeading": "Intellectual Property",
        "ipP1": "All software, designs, and brand assets related to AbraFi are the exclusive property of Abrasoft I.T. Services.",
        "liabilityHeading": "Limitation of Liability",
        "liabilityP1": "To the maximum extent permitted by law, Abrasoft I.T. Services shall not be liable for any financial losses, tax penalties, or business disruptions arising from the use or inability to use the platform."
      },
      "disclaimer": {
        "title": "Disclaimer",
        "professionalHeading": "Professional Advice Disclaimer",
        "professionalP1": "The information and reports generated by AbraFi are for informational and management purposes only.",
        "professionalP2": "AbraFi is NOT a substitute for professional tax, legal, or financial advice. We strongly recommend consulting with a Certified Public Accountant (CPA) or tax professional for statutory filings and audit requirements.",
        "accuracyHeading": "Accuracy of Data",
        "accuracyP1": "AbraFi automates the recording process based on user-provided inputs. We do not verify the authenticity of uploaded documents. The user bears full responsibility for ensure that their records reflect true and fair business transactions.",
        "pfrsHeading": "PFRS Compliance",
        "pfrsP1": "While AbraFi aims to generate reports in accordance with the Philippine Financial Reporting Standards (PFRS), the final responsibility for the Statement of Management Responsibility and the accuracy of the Accompanying Notes lies with the user/management."
      },
      "cookies": {
        "title": "Cookie Policy",
        "useHeading": "Use of Cookies",
        "useP1": "AbraFi uses essential cookies to manage your session and ensure a secure login experience.",
        "useP2": "By using our platform, you consent to the use of these necessary technologies."
      }
    },
    "user": {
      "companyCreatedSuccess": {
        "title": "Your company is ready",
        "message": "You have successfully set up your company workspace in AbraFi.",
        "editReminder": "You can review and update your company details anytime from the Companies page.",
        "goToDashboard": "Go to dashboard"
      },
      "onboarding": {
        "pageTitle": "Welcome to AbraFi",
        "pageSubtitle": "Tell us your name, then choose whether to create a company or join one.",
        "invitePageSubtitle": "Review and accept your company invitation to get started.",
        "joinPageSubtitle": "Paste the invite link from your company owner to join their workspace.",
        "loadCompanyFailed": "Could not load company details. Try again.",
        "loading": "Loading setup…",
        "progressLabel": "Step {{current}} of {{total}}",
        "questionOf": "Question {{current}} of {{total}}",
        "back": "Back",
        "next": "Next",
        "logout": "Logout",
        "finish": "Finish setup",
        "submitting": "Setting up…",
        "continueToInvite": "Continue to invite",
        "submitFailed": "Could not finish setup. Try again.",
        "completeMode": {
          "pageTitle": "Complete company profile",
          "pageSubtitle": "Review and update your company details. Saved answers are pre-filled so you can change anything.",
          "save": "Save company profile",
          "cancel": "Back to dashboard",
          "backToDashboard": "Back to dashboard"
        },
        "createMode": {
          "pageTitle": "Create a company",
          "pageSubtitle": "Set up a new company workspace. You can install apps and invite teammates after this.",
          "finish": "Create company",
          "cancel": "Back to companies"
        },
        "defaultCompanyDescription": "Company workspace created during onboarding.",
        "common": {
          "yes": "Yes",
          "no": "No"
        },
        "entityTypes": {
          "soleProprietorship": "Sole Proprietorship",
          "opc": "One Person Corporation (OPC)",
          "corporation": "Corporation",
          "partnership": "Partnership (General/Limited)",
          "cooperative": "Cooperative"
        },
        "taxRegimes": {
          "eightPercent": {
            "title": "8% Income Tax",
            "description": "8% tax on gross sales or receipts for eligible taxpayers."
          },
          "graduatedItemized": {
            "title": "Graduated — Itemized Deductions",
            "description": "Graduated income tax rates with itemized allowable deductions."
          },
          "graduatedOsd": {
            "title": "Graduated — Optional Standard Deduction (OSD)",
            "description": "Graduated income tax rates using OSD instead of itemized deductions."
          }
        },
        "steps": {
          "fullName": {
            "title": "What is your full name?",
            "subtitle": "This is how you will appear in the app and on records you create.",
            "fieldLabel": "Full name",
            "placeholder": "Enter your full name",
            "required": "Enter your full name to accept the invitation."
          },
          "companyInvite": {
            "title": "Join your company",
            "subtitle": "Review the invitation below. Enter your name if prompted, then accept to join the workspace.",
            "continueWithoutInvite": "Continue without invite",
            "pasteTitle": "Join a company",
            "pasteSubtitle": "Paste the invite link your company owner sent you. If you do not have one yet, ask them to invite you, then paste it here.",
            "pasteLabel": "Invite link or code",
            "pastePlaceholder": "Paste invite link",
            "pasteRequired": "Paste an invite link or code to continue.",
            "lookupButton": "Continue",
            "tryAnotherLink": "Try another link",
            "createInsteadFromPaste": "Create a company instead",
            "createInsteadAfterInvalidLink": "Create a company instead",
            "createInsteadFromPreview": "Create a company instead"
          },
          "companyPath": {
            "title": "How do you want to get started?",
            "subtitle": "Create a company workspace, or join one you were invited to. You can skip setting up a company if you only need to join.",
            "createTitle": "Create a company",
            "createDescription": "Set up a new workspace for your business. You will be the owner.",
            "joinTitle": "Join a company",
            "joinDescription": "Use an invite link from a company owner to join their workspace."
          },
          "companyName": {
            "title": "What is your company name?",
            "subtitle": "Use the registered or trade name you want on reports and documents.",
            "fieldLabel": "Company name",
            "placeholder": "Enter company name"
          },
          "entityType": {
            "title": "What type of entity is your business?",
            "subtitle": "Choose the legal structure that best matches your registration."
          },
          "soleOwnerName": {
            "title": "Who owns this business?",
            "subtitle": "Enter the full name of the sole proprietor. This is the single owner who holds this business.",
            "fieldLabel": "Owner name",
            "placeholder": "Enter the owner's full name"
          },
          "companyAddress": {
            "title": "What is your company address?",
            "subtitle": "Use the principal place of business shown on your registration.",
            "fieldLabel": "Company address",
            "placeholder": "Street, city, province"
          },
          "companyEmail": {
            "title": "What is your company email?",
            "subtitle": "We use this for company-related notifications and documents.",
            "fieldLabel": "Company email",
            "placeholder": "name@company.com",
            "required": "Company email is required.",
            "invalid": "Enter a valid email address."
          },
          "registrationDate": {
            "title": "When was the company registered?",
            "subtitle": "Reports can start from the first day of this month.",
            "fieldLabel": "Date of registration"
          },
          "bmbeRegistered": {
            "title": "Are you BMBE registered?",
            "subtitle": "Barangay Micro Business Enterprises may qualify for tax incentives.",
            "numberLabel": "BMBE registration number",
            "numberHint": "Optional — add it now or later in company settings.",
            "numberPlaceholder": "Enter BMBE registration number"
          },
          "birRegistered": {
            "title": "Are you registered with the BIR?",
            "subtitle": "If yes, we will ask a few follow-up tax questions."
          },
          "companyTin": {
            "title": "What is your Tax Identification Number (TIN)?",
            "subtitle": "Enter the TIN shown on your Certificate of Registration or BIR forms.",
            "fieldLabel": "Tax Identification Number (TIN)",
            "hint": "Use 9 or 14 digits. We format it as XXX-XXX-XXX-XXXXX.",
            "required": "TIN is required for BIR-registered businesses."
          },
          "birRdo": {
            "title": "What is your BIR Regional District Office (RDO)?",
            "subtitle": "Enter the RDO shown on your Certificate of Registration. It is saved with your company information.",
            "fieldLabel": "BIR Regional District Office (RDO)",
            "placeholder": "e.g. RDO 039"
          },
          "businessStyle": {
            "title": "What is your business style?",
            "subtitle": "The trade name or style printed on BIR receipts and forms.",
            "fieldLabel": "Business style",
            "placeholder": "As shown on your COR or receipts"
          },
          "vatStatus": {
            "title": "What is your VAT status?",
            "subtitle": "Choose the option that matches your BIR registration."
          },
          "taxRegime": {
            "title": "Which income tax regime do you use?",
            "subtitle": "Based on your BIR registration or latest filing."
          },
          "typicalExpenses": {
            "title": "What are your usual expenses?",
            "subtitle": "Select all that apply. This helps categorize future entries."
          },
          "paymentMethods": {
            "title": "How do you usually pay expenses?",
            "subtitle": "Select all payment methods you commonly use."
          }
        },
        "operations": {
          "step2Text": "Step 2 of 3: How You Operate",
          "step3Text": "Step 3 of 3: Bookkeeping Preferences",
          "receiptNamesTitle": "How does your business name appear on receipts?",
          "receiptNamesSubtitle": "Helps us tell your sales receipts from supplier receipts. Select all that apply.",
          "receiptNamesHint": "Select at least one option.",
          "receiptNamesNoteLabel": "Name(s) as printed on receipts",
          "receiptNamesNoteRequired": "Enter the exact name(s) shown on your sales receipts and ORs.",
          "receiptNamesNotePlaceholder": "e.g. trade name, stall name, or owner name on OR/invoice",
          "businessActivityTitle": "What do you mainly do?",
          "businessActivitySubtitle": "Select all that apply.",
          "cogsTitle": "Do you track cost of goods sold (COGS) or inventory?",
          "cogsSubtitle": "For businesses that buy goods to resell, not just day-to-day operating expenses.",
          "cogsNo": "No",
          "cogsNoDesc": "Expenses go straight to expense accounts; no inventory or COGS.",
          "cogsYes": "Yes",
          "cogsYesDesc": "I buy goods to resell and track COGS or inventory.",
          "cogsUnsure": "Not sure yet",
          "cogsUnsureDesc": "We will use simple expense categories until you decide.",
          "vatTitle": "What is your VAT status?",
          "vatSubtitle": "As on your BIR registration or usual supplier invoices.",
          "typicalExpensesTitle": "What are your usual expenses?",
          "typicalExpensesSubtitle": "Select typical costs you see on receipts — improves category suggestions.",
          "typicalExpensesCustomLabel": "Other usual expenses (optional)",
          "typicalExpensesCustomHint": "Add specific expenses you often see on receipts — e.g. software subscriptions, contractor fees.",
          "typicalExpensesCustomPlaceholder": "e.g. Software subscriptions",
          "typicalExpensesCustomAdd": "Add expense",
          "typicalExpensesCustomRemove": "Remove expense",
          "paymentMethodsTitle": "How do you usually pay on receipts?",
          "paymentMethodsSubtitle": "Select all payment methods you commonly use.",
          "customerPaymentTitle": "How do customers usually pay you?",
          "customerPaymentSubtitle": "Helps interpret sales receipts and whether terms apply.",
          "customerMostlyCash": "Mostly cash or immediate payment",
          "customerMostlyCashDesc": "Paid when the sale happens (cash, GCash, card, etc.).",
          "customerMostlyTerms": "Mostly on credit / terms",
          "customerMostlyTermsDesc": "Customers pay later; you track what they owe.",
          "customerMix": "Mix of both",
          "customerMixDesc": "Some pay immediately, some on terms.",
          "foreignCurrencyTitle": "Do any receipts you receive from suppliers show amounts in foreign currency?",
          "foreignCurrencySubtitle": "This covers both sides: bills or invoices from suppliers you pay (expenses), and sales receipts or ORs where customers pay you — when the amount is in USD, EUR, or another currency, not Philippine pesos.",
          "foreignYes": "Yes, regularly",
          "foreignYesDesc": "Often on supplier bills and/or on sales documents — not only peso amounts.",
          "foreignNo": "No — almost always pesos",
          "foreignNoDesc": "Supplier bills and sales receipts are usually in Philippine pesos only.",
          "foreignRare": "Rarely",
          "foreignRareDesc": "Only occasional supplier or sales documents in foreign currency.",
          "receiptNames": {
            "company_name": "Same as company name in abrafi",
            "trade_name": "Trade name / DBA only",
            "owner_personal": "Owner personal name (common for sole proprietors)",
            "other_name": "Another name not listed above"
          },
          "businessActivities": {
            "products": "Sell products",
            "services": "Sell services",
            "other": "Other"
          },
          "typicalExpenses": {
            "utilities": "Utilities (power, water, internet)",
            "rent": "Rent",
            "fuel": "Fuel / transportation",
            "supplies": "Supplies / materials",
            "payroll": "Payroll / wages",
            "professional_fees": "Professional fees",
            "marketing": "Marketing / advertising",
            "freight": "Freight / delivery",
            "food": "Food / meals",
            "insurance": "Insurance",
            "maintenance": "Repairs / maintenance",
            "still_figuring": "Still figuring out"
          },
          "paymentMethods": {
            "cash": "Cash",
            "gcash": "GCash / e-wallet",
            "card": "Credit or debit card",
            "bank_transfer": "Bank transfer",
            "other": "Other"
          },
          "vatStatuses": {
            "vat_registered": "VAT registered",
            "non_vat": "Non-VAT registered",
            "vat_exempt": "VAT exempt",
            "zero_rated": "Zero-rated",
            "not_sure": "Not sure"
          }
        }
      },
      "changePassword": {
        "title": "Change password",
        "subtitle": "Enter your current password, then choose a new one. You will stay signed in on this device.",
        "currentPasswordLabel": "Current password",
        "newPasswordLabel": "New password",
        "confirmPasswordLabel": "Confirm new password",
        "passwordMinLength": "New password must be at least 8 characters.",
        "passwordMismatch": "New password and confirmation do not match.",
        "successToast": "Password updated successfully.",
        "updateFailed": "Could not update password.",
        "updating": "Updating…",
        "submit": "Update password",
        "cancel": "Cancel"
      },
      "profile": {
        "title": "User Profile",
        "loading": "Loading profile...",
        "notFound": "No profile found. Please complete your profile setup.",
        "changePictureAria": "Change profile picture",
        "profileAlt": "Profile",
        "removePictureAria": "Remove profile picture",
        "removePicture": "Remove picture",
        "fullNameLabel": "Full Name",
        "fullNameInputAria": "Full name",
        "saving": "Saving…",
        "save": "Save",
        "cancel": "Cancel",
        "editNameAria": "Edit full name",
        "edit": "Edit",
        "emailLabel": "Email",
        "companiesLabel": "Companies",
        "goToCompanies": "Go to Companies Page",
        "noCompanies": "No companies assigned",
        "memberSince": "Member Since",
        "lastUpdated": "Last Updated",
        "dateNa": "N/A",
        "invalidDate": "Invalid date",
        "selectImageError": "Please select an image file.",
        "pictureUpdated": "Profile picture updated.",
        "uploadFailed": "Failed to upload profile picture.",
        "nameRequired": "Please enter your full name.",
        "nameUpdated": "Name updated successfully.",
        "nameUpdateFailed": "Failed to update name.",
        "removeConfirm": "Remove your profile picture?",
        "removeConfirmTitle": "Remove profile picture?",
        "removeConfirmButton": "Remove",
        "pictureRemoved": "Profile picture removed.",
        "removeFailed": "Failed to remove profile picture."
      }
    },
    "settings": {
      "general": {
        "title": "General",
        "subtitle": "Personal options for your account. These apply to you across all companies.",
        "appearanceHeading": "Appearance",
        "accountHeading": "Account",
        "changePasswordDescription": "Update the password you use to sign in to AbraFi. You will stay signed in on this device after changing it.",
        "changePasswordButton": "Change password",
        "logoutDescription": "Sign out of AbraFi on this device. You will need to sign in again to access your account.",
        "logoutButton": "Log out"
      },
      "notifications": {
        "title": "Notifications",
        "subtitle": "Choose how you want to receive optional alerts. In-app notifications are always available.",
        "emailHeading": "Email Notification Settings",
        "emailGroupAria": "Enable or disable all email notifications",
        "emailTaxCalendarDeadlines": "Tax Calendar Deadlines",
        "emailTaxCalendarDeadlinesDescription": "Sent when a Tax Calendar obligation filing window is opening (3 days before or on the first day), 7 days before the due date, or on the due date.",
        "emailBusinessCalendarUrgency": "Business Calendar Urgency",
        "emailBusinessCalendarUrgencyDescription": "Sent when a Business Calendar permit, license, or employee reminder is within 45 days of expiring or is overdue.",
        "emailInventoryLowStock": "Inventory Low Stock",
        "emailInventoryLowStockDescription": "Sent when a product's stock in a warehouse drops below its minimum quantity.",
        "loading": "Loading notification settings…",
        "loadFailed": "Failed to load which notification settings apply to this company.",
        "retry": "Try again",
        "savingToast": "Saving notification settings…",
        "savedToast": "Notification settings saved.",
        "saveFailedToast": "Failed to save notification settings."
      },
      "company": {
        "title": "Company Settings",
        "subtitle": "Company-wide options for {{companyName}}.",
        "thisCompany": "this company",
        "transactionLockingName": "Transaction Locking",
        "transactionLockingDescription": "Lock date ranges so transactions in closed periods cannot be added, edited, or voided",
        "billingName": "Billing",
        "billingDescription": "View your plan, subscribe, or cancel",
        "currencyHeading": "Currency",
        "dailyFxConvertLabel": "Daily FX convert",
        "dailyFxConvertDescription": "When enabled, manual transactions and receipt uploads can use foreign currencies with BSP reference exchange rates; amounts are stored in PHP on the ledger.",
        "currenciesForTransactionsLabel": "Currencies for transactions",
        "currenciesForTransactionsDescription": "Tap currencies to select them (highlighted), then save. PHP is always the ledger currency.",
        "currentlySavedPrefix": "Currently saved:",
        "noCurrenciesSaved": "No currencies saved yet. Select at least one below.",
        "currenciesSelectorAriaLabel": "Currencies for transactions",
        "savingCurrencies": "Saving…",
        "saveCurrencies": "Save currencies",
        "selectOneCurrencyHint": "Select at least one currency to enable Save.",
        "savedFeedback": "Saved",
        "noChangesToSave": "No changes to save",
        "categoriesHeading": "Categories",
        "categoryAccountNumbersLabel": "Category account numbers",
        "categoryAccountNumbersDescription": "When enabled, categories and financial reports can show account numbers and support inline editing on the Categories page. When disabled, account numbers are hidden and per-page show/hide controls are not shown.",
        "bookOfAccountsHeading": "Book of accounts",
        "bookOfAccountsLabel": "Book of accounts style",
        "bookOfAccountsDescription": "Loose Leaf keeps Cash Receipts and Cash Disbursements as separate lines on the General Journal and General Ledger. Manual consolidates those journals to month-end summary entries on those reports.",
        "bookOfAccountsLooseLeaf": "Loose Leaf",
        "bookOfAccountsManual": "Manual",
        "bookOfAccountsLooseLeafSaved": "Book of accounts set to Loose Leaf.",
        "bookOfAccountsManualSaved": "Book of accounts set to Manual.",
        "bookOfAccountsSaveFailed": "Failed to save book of accounts setting.",
        "returnToUnsavedEntry_1": "You have an unsaved journal entry. After updating currency settings,",
        "returnToUnsavedEntryLink_2": "return to your entry"
      },
      "companyDetails": {
        "title": "Company Information",
        "profileTitle": "Company Profile",
        "subtitle": "Registration and contact information for {{companyName}}.",
        "profileSubtitle": "Manage your business information and printed receipts.",
        "editButton": "Edit company information",
        "editProfileButton": "Edit Profile",
        "editingTitle": "Editing company information",
        "noChangesToast": "No changes to save.",
        "cancelEdit": "Cancel",
        "saveButton": "Save changes",
        "saving": "Saving…",
        "saved": "Changes saved.",
        "saveFailed": "Could not save changes. Please fix any errors and try again.",
        "loading": "Loading company information…",
        "loadFailed": "Failed to load company information.",
        "retry": "Try again",
        "verifiedPosBadge": "Verified POS",
        "storeBioSection": "Store bio",
        "updateLink": "Update",
        "contactSection": "Business & contact",
        "contactSectionMeta": "Primary details",
        "statementsSection": "Company statements",
        "statementsSectionMeta": "Optional notes",
        "otherOwnersSection": "Other company owners",
        "otherOwnersSectionMeta": "Shareholders, nominees, and other owners",
        "otherOwnersEmpty": "No other company owners yet.",
        "otherOwnersAdd": "Add company owner",
        "otherOwnersAddTitle": "Add company owner",
        "otherOwnersEditTitle": "Edit company owner",
        "otherOwnersNameLabel": "Name",
        "otherOwnersNameRequired": "Enter the owner's name.",
        "otherOwnersDesignationLabel": "Designation / position",
        "otherOwnersDesignationPlaceholder": "Shareholder, nominee for OPC, or alternate nominee",
        "otherOwnersAddressLabel": "Address",
        "otherOwnersTinLabel": "TIN",
        "otherOwnersContactNumberLabel": "Contact number",
        "otherOwnersSave": "Save",
        "otherOwnersSaving": "Saving…",
        "otherOwnersRemove": "Remove",
        "otherOwnersSaveFailed": "Could not save the company owner.",
        "registrationSection": "Registration",
        "registrationSectionMeta": "Legal details",
        "documentsSection": "Documents",
        "documentsSectionMeta": "Optional files",
        "registrationNumberGeneric": "Registration number",
        "dtiRegistrationNumber": "DTI registration number",
        "secRegistrationNumber": "SEC registration number",
        "cdaRegistrationNumber": "CDA registration number",
        "registrationNumberFailed": "Could not save the registration number.",
        "storePhotosSection": "Store photos",
        "storePhotosSectionMeta": "Optional pictures of the store",
        "storePhotoFront": "Front of the store",
        "storePhotoLeft": "Left side of the store",
        "storePhotoRight": "Right side of the store",
        "storePhotoInside": "Inside the store",
        "storePhotosLoading": "Loading store photos.",
        "bookStampsSection": "Book of accounts registration",
        "bookStampsSectionMeta": "Optional. Upload the latest stamp or ORUS screenshot for each book you already have.",
        "bookCrj": "Cash Receipts Journal",
        "bookCdj": "Cash Disbursement Journal",
        "bookGj": "General Journal",
        "bookGl": "General Ledger",
        "bookSj": "Sales Journal",
        "bookPj": "Purchases Journal",
        "bookStampsLoading": "Loading book registration stamps.",
        "documentsCor": "BIR Certificate of Registration 2303 (COR)",
        "documentsRegistrationDti": "DTI certificate",
        "documentsRegistrationSec": "SEC registration",
        "documentsRegistrationCda": "CDA registration",
        "documentsRegistrationFallback": "DTI / SEC / CDA registration",
        "documentsMayorsPermit": "Mayor's Permit / Business Permit",
        "documentsBarangayPermit": "Barangay Business Permit",
        "documentsAtp": "Authority to Print (ATP)",
        "documentsAtpHint": "Latest ATP for printed receipts. Upload it when the company has one.",
        "documentsNotUploaded": "Not uploaded",
        "documentsUploaded": "Uploaded",
        "documentsUpload": "Upload",
        "documentsReplace": "Replace",
        "documentsRemove": "Remove",
        "documentsView": "View",
        "documentsUploading": "Uploading…",
        "documentsRemoving": "Removing…",
        "documentsUploadFailed": "Could not upload this document.",
        "documentsRemoveFailed": "Could not remove this document.",
        "documentsViewFailed": "Could not open this document.",
        "documentsRemoveConfirmTitle": "Remove this document?",
        "documentsRemoveConfirm": "The file will be removed from company information. You can upload it again later.",
        "documentsLoading": "Loading documents.",
        "ownerSection": "Owner",
        "ownerSectionMeta": "Sole proprietor",
        "ownerNameLabel": "Owner name",
        "ownerAddressLabel": "Owner address",
        "ownerBirthdayLabel": "Owner date of birth",
        "fiscalSection": "Fiscal year",
        "fiscalSectionMeta": "Accounting period",
        "metaSection": "Membership",
        "metaSectionMeta": "Account",
        "customerCareSection": "Customer Care Support",
        "customerCareSectionMeta": "POS Receipts",
        "customerCarePhonesLabel": "Customer care hotline",
        "customerCareEmailLabel": "Customer care email",
        "customerCareHint": "These details appear on printed POS sales invoices under Customer Care Support.",
        "changeLogoAria": "Change company logo",
        "removeLogo": "Remove logo",
        "removeLogoAria": "Remove company logo",
        "removeLogoConfirm": "Remove this company's logo?",
        "removeLogoConfirmTitle": "Remove company logo?",
        "removeLogoConfirmButton": "Remove",
        "selectImageError": "Please select an image file.",
        "uploadFailed": "Logo upload failed.",
        "logoUpdated": "Company logo updated.",
        "logoUploadFailed": "Failed to upload company logo.",
        "logoRemoved": "Company logo removed.",
        "logoRemoveFailed": "Failed to remove company logo.",
        "invoiceSettingsLoading": "Loading invoice settings…",
        "invoiceSettingsLoadFailed": "Failed to load invoice settings.",
        "invoiceSettingsRetry": "Try again",
        "invoiceSettingsSection": "Invoice settings",
        "invoiceSettingsSectionMeta": "Numbering",
        "invoiceSettingsViewHint": "Invoice numbering and seller details are edited on the company information edit page."
      },
      "billing": {
        "title": "Billing",
        "subtitle": "Pay for your company plan with a one-time PayMongo checkout. Renew manually when your period ends.",
        "loadingMessage": "Loading billing…",
        "loadFailedMessage": "Failed to load billing information.",
        "retryButton": "Retry",
        "ownerOnlyMessage": "Only the company owner can manage billing.",
        "plansHeading": "Plans",
        "statusLabel": "Status",
        "periodEndLabel": "Access ends",
        "freePlanDescription": "Core accounting for your company at no cost.",
        "freePlanStatusValue": "Active",
        "currentPlanBadge": "Current plan",
        "activePlanIndicator": "Active plan",
        "intervalMonthShort": "/ mo",
        "intervalYearShort": "/ yr",
        "upgradeToButton": "Upgrade to {{planName}}",
        "expiredAlertMessage": "Your paid access has ended. Choose a plan below to restore access.",
        "noPlansMessage": "No plans are available right now.",
        "noPaidUpgradePlansMessage": "No paid upgrade plans are available right now.",
        "manualBillingNote": "Payments are one-time through PayMongo. You can hold multiple plans at once; each plan has its own access period.",
        "extendPlanButton": "Extend {{planName}}",
        "cancelPlanButton": "Cancel {{planName}}",
        "purchaseHistoryHeading": "Purchase history",
        "purchaseHistoryLoadingMessage": "Loading purchase history…",
        "purchaseHistoryLoadFailedMessage": "Failed to load purchase history.",
        "purchaseHistoryEmptyMessage": "No completed plan payments yet.",
        "purchaseHistoryPlanColumn": "Plan",
        "purchaseHistoryAmountColumn": "Amount",
        "purchaseHistoryStatusColumn": "Status",
        "purchaseHistoryStatusPaid": "Paid",
        "purchaseHistoryStatusWaived": "Waived",
        "purchaseHistoryPaidColumn": "Paid on",
        "purchaseHistoryReferenceColumn": "Reference",
        "purchaseHistoryCopyReferenceAriaLabel": "Copy reference number",
        "purchaseHistoryCopyFailedToast": "Could not copy reference number.",
        "checkoutStartingButton": "Opening checkout…",
        "checkoutStartingToast": "Opening PayMongo checkout…",
        "cancelButton": "Cancel subscription",
        "cancellingButton": "Cancelling…",
        "cancellingToast": "Cancelling subscription…",
        "cancelledToast": "Subscription cancelled.",
        "checkoutSuccessToast": "Payment completed. Your subscription will update shortly.",
        "checkoutCancelledToast": "Checkout was cancelled.",
        "subscribeConfirmModal": {
          "title": "Subscribe to {{planName}}?",
          "body": "You will be redirected to PayMongo to pay {{price}} for {{planName}}. Access starts after payment is confirmed.",
          "hint": "Payments are one-time. You can extend this plan anytime before access ends.",
          "cancelButton": "Cancel",
          "confirmButton": "Continue to checkout",
          "confirmingButton": "Opening checkout…"
        },
        "extendConfirmModal": {
          "title": "Extend {{planName}}?",
          "body": "You will be redirected to PayMongo to pay {{price}} and add another billing period to {{planName}}.",
          "hint": "If your current period is still active, the new time is added after your current access ends.",
          "cancelButton": "Cancel",
          "confirmButton": "Continue to checkout",
          "confirmingButton": "Opening checkout…"
        },
        "cancelConfirmModal": {
          "title": "Cancel {{planName}}?",
          "body": "This cancels {{planName}}. You keep access until the current period ends.",
          "hint": "You can subscribe or extend again anytime.",
          "cancelButton": "Keep plan",
          "confirmButton": "Cancel plan",
          "confirmingButton": "Cancelling…"
        },
        "billingLinkName": "Billing",
        "billingLinkDescription": "View transaction usage and manage your plan",
        "memberSubtitle": "View this company's monthly transaction usage. Only the owner can change plans or buy top-ups.",
        "usageHeading": "Transaction usage",
        "usageIntro": "Counts every new transaction posted this calendar month (Philippines time). Period: {{periodKey}}.",
        "usageAtLimitMessage": "This company reached its monthly transaction limit. Existing books stay readable, but new transactions are blocked until the owner upgrades or adds more capacity on Billing.",
        "usageUsedLabel": "{{used}} / {{limit}} transactions used",
        "usageIncludedLabel": "Plan includes {{included}} per month",
        "usagePrepaidExtraLabel": " (+{{prepaidExtra}} prepaid this month)",
        "usageRemainingLabel": "{{remaining}} remaining this month",
        "usageProgressAriaLabel": "Monthly transaction usage",
        "usageTopUpHeading": "Add more transactions",
        "usageTopUpHint": "Prepaid top-ups apply to the current month only. Each block adds {{blockSize}} transactions.",
        "usageTopUpBlocksLabel": "{{blocks}} block(s) · {{transactions}} transactions",
        "usageTopUpButton": "Buy top-up",
        "usageTopUpOpeningButton": "Opening checkout…",
        "usageTopUpStartingToast": "Opening PayMongo checkout for transaction top-up…",
        "usageMemberHint": "Ask the company owner to upgrade the plan or buy a transaction top-up if you need to record more entries."
      },
      "customerCare": {
        "title": "Customer Care Support",
        "subtitle": "Phone numbers and email printed on your POS sales invoices (below TIN).",
        "selectCompanyHint": "Select a company to manage Customer Care Support for sales invoices.",
        "contactHeading": "Contact printed on receipts",
        "description": "Enter the phones and email customers should use for your store — matching common sales invoice layouts.",
        "phonesLabel": "Phone numbers",
        "phonesPlaceholder": "(02) 8811-0000 (0977) 811-0000\n(0908) 811-0000",
        "phonesHelp": "One phone line per row. These print under “Customer Care Support”.",
        "emailFieldLabel": "Customer care email",
        "emailPlaceholder": "customercare@example.com",
        "emailLabel": "Support email",
        "loading": "Loading…",
        "loadFailed": "Failed to load customer care details.",
        "retry": "Try again",
        "save": "Save",
        "saving": "Saving…",
        "saved": "Customer care details saved.",
        "receiptHint": "These details appear on printed sales invoices under your TIN.",
        "readOnlyHint": "You can view these details, but you need permission to edit the company to change them.",
        "copyEmailTitle": "Copy email",
        "sendEmail": "Send email",
        "openHelp": "Open Help Center",
        "responseTimeNote": "Response time is typically within 24–48 business hours."
      }
    },
    "superAdminHub": {
      "openAiUsage": {
        "pageTitle": "OpenAI usage",
        "pageSubtitle": "Inspect OpenAI calls for chat, receipt vision, Upload Entry, and COR OCR, including tokens and estimated list-price spend.",
        "daysLabel": "Window",
        "daysAria": "Number of days to include",
        "refreshButton": "Refresh",
        "loading": "Loading OpenAI usage…",
        "retryButton": "Try again",
        "loadFailedToast": "Failed to load OpenAI usage.",
        "totalsTitle": "Logged OpenAI calls (last {{days}} days)",
        "statCalls": "Calls",
        "statTotalTokens": "Total tokens",
        "statPromptTokens": "Prompt tokens",
        "statCompletionTokens": "Completion tokens",
        "statFailed": "Failed calls",
        "statEstimatedCost": "Estimated spend (USD)",
        "noEventsHint": "No token events yet in this window. Events start recording after this deploy; use Upload Entry diagnostics below for current cron risk.",
        "costEstimateHint": "Spend is estimated from logged prompt and completion tokens using OpenAI list prices. Cached-input discounts and invoice adjustments are not included.",
        "uploadEntrySpendTitle": "Spend per Upload Entry file",
        "uploadEntrySpendDescription": "All OpenAI calls tagged to one file (idle preprocess plus Process) are summed. A batch Process call is split across the files in that batch.",
        "statUploadEntryFiles": "Files with AI calls",
        "statUploadEntryAverage": "Average per file",
        "statUploadEntryTotal": "Upload Entry spend",
        "colFile": "File",
        "colUploadEntryCompany": "Company",
        "colUploadEntryCalls": "Calls",
        "colUploadEntryTokens": "Tokens",
        "colUploadEntryCost": "Est. USD",
        "emptyUploadEntryRows": "No Upload Entry AI calls in this window.",
        "colRecentEstimatedCost": "Est. USD",
        "uploadEntryTitle": "Upload Entry AI diagnostics",
        "diagWithDraft": "Files with AI draft",
        "diagWithoutDraft": "Uploaded without draft",
        "diagIdleCandidates": "Idle cron candidates now",
        "diagClaimed": "Currently claimed",
        "diagSkipUntil": "In retry backoff",
        "diagExtractedWindow": "Drafts saved in window",
        "bySourceTitle": "By call source",
        "topCompaniesTitle": "Top companies by tokens",
        "recentTitle": "Recent calls",
        "colSource": "Source",
        "colCalls": "Calls",
        "colTokens": "Tokens",
        "colCompany": "Company",
        "colWhen": "When",
        "colFeature": "Feature",
        "colModel": "Model",
        "colStatus": "Status",
        "emptyRows": "No rows",
        "statusOk": "OK",
        "statusFailed": "Failed"
      },
      "grants": {
        "pageTitle": "Transaction grants",
        "pageSubtitle": "Credit prepaid transaction usage for a company. Grants appear on Billing as waived purchase history at ₱0.",
        "companySectionTitle": "Choose company",
        "companySearchLabel": "Search companies",
        "companySearchPlaceholder": "Company name…",
        "companiesLoading": "Loading companies…",
        "companiesEmpty": "No companies match that search.",
        "usageSectionTitle": "Grant usage — {{companyName}}",
        "usageLoading": "Loading usage…",
        "usageSummary": "Period {{periodKey}}: {{used}} used of {{limit}} ({{included}} included + {{prepaidExtra}} prepaid). {{remaining}} remaining. Plan: {{planCode}}.",
        "blocksLabel": "{{blocks}} block(s) = {{transactions}} transactions ({{blockSize}} per block)",
        "waiveNote": "List price {{listPrice}} will be recorded as waived (₱0) in purchase history.",
        "noteLabel": "Internal note (optional)",
        "notePlaceholder": "Why this grant was issued…",
        "grantButton": "Grant transaction usage",
        "grantingButton": "Granting…",
        "grantSuccessToast": "Granted {{extraTransactions}} transactions to {{companyName}} for {{periodKey}}.",
        "confirmModal": {
          "title": "Confirm transaction grant?",
          "body": "Grant {{extraTransactions}} transactions ({{transactionBlocks}} block(s)) to {{companyName}} ({{companyId}}) for period {{periodKey}}. List price {{listPrice}} will be recorded as waived (₱0).",
          "hint": "This credits prepaid usage immediately and cannot be undone from this screen.",
          "cancelButton": "Cancel",
          "confirmButton": "Grant usage",
          "confirmingButton": "Granting…"
        },
        "viewCompanyInfoButton": "View full company info",
        "companyInfo": {
          "modalTitle": "Company info — {{companyName}}",
          "loading": "Loading company information.",
          "retryButton": "Try again",
          "closeButton": "Close",
          "id": "Company ID",
          "name": "Name",
          "tradeName": "Trade name",
          "tin": "TIN",
          "birRdo": "BIR Regional District Office (RDO)",
          "incomeClassification": "Income classification",
          "email": "Email",
          "tel": "Phone",
          "address": "Address",
          "entityType": "Entity type",
          "vatStatus": "VAT status",
          "registrationNumber": "Registration number",
          "registrationDate": "Registration date",
          "ownerName": "Owner name",
          "ownerEmail": "Owner email",
          "description": "Description",
          "createdAt": "Created",
          "updatedAt": "Updated"
        }
      },
      "paymongoConnection": {
        "title": "PayMongo connection",
        "subtitle": "Connect AbraFi to your PayMongo merchant account (platform-wide).",
        "loadingMessage": "Loading PayMongo connection…",
        "loadFailedMessage": "Failed to load PayMongo connection settings.",
        "retryButton": "Try again",
        "statusHeading": "Connection status",
        "statusConfigured": "API keys configured",
        "statusTestMode": "Test mode",
        "statusWebhook": "Webhook secret configured",
        "yes": "Yes",
        "no": "No",
        "secretKeyHint": "Secret key on file: {{hint}}",
        "lastUpdated": "Last updated by {{email}} on {{date}}.",
        "formHeading": "API credentials",
        "secretKeyLabel": "Secret key",
        "secretKeyPlaceholder": "sk_test_… or sk_live_…",
        "secretKeyKeepPlaceholder": "Leave blank to keep the current secret key",
        "publicKeyLabel": "Public key",
        "publicKeyPlaceholder": "pk_test_… or pk_live_…",
        "webhookSecretLabel": "Webhook secret",
        "webhookSecretPlaceholder": "Leave blank to keep the current webhook secret",
        "apiBaseUrlLabel": "API base URL",
        "saveButton": "Save connection",
        "savingButton": "Saving…",
        "savingToast": "Saving PayMongo connection…",
        "savedToast": "PayMongo connection saved.",
        "noChangesToast": "No connection changes to save.",
        "secretKeyRequiredToast": "Enter a secret key to save the connection.",
        "openPaymentMethodsButton": "Configure payment methods",
        "infoBulletPlatform": "PayMongo is not per company — one AbraFi merchant account handles billing for all tenant companies.",
        "infoBulletPaymentMethods": "After saving API keys, open Payment methods and choose at least one checkout method.",
        "infoBulletOrganizationError": "If PayMongo says payment methods are not configured for your organization, enable methods in the PayMongo Dashboard and in Super Admin Hub → Payment methods."
      },
      "activityLog": {
        "sectionTitle": "Activity log",
        "sectionHint": "Platform-wide audit of changes made on this page (all superadmin users).",
        "loadingMessage": "Loading activity log…",
        "loadFailedMessage": "Failed to load activity log.",
        "emptyMessage": "No changes recorded yet.",
        "columnWhen": "When",
        "columnUser": "User",
        "columnAction": "Action",
        "columnDetails": "Details",
        "viewDetailsButton": "View details",
        "viewDetailsLink": "View",
        "closeDetailsButton": "Close",
        "detailsModalTitle": "Change details",
        "detailsPayloadHeading": "Full change payload",
        "yes": "Yes",
        "no": "No",
        "summary": {
          "connection": "Updated fields: {{fields}}. Test mode: {{testMode}}.",
          "checkoutConfig": "Checkout methods: {{methods}}.",
          "createPlan": "Created plan {{code}} ({{name}}).",
          "updatePlan": "Updated plan {{code}} ({{name}}).",
          "deletePlan": "Deleted plan {{code}} ({{name}}).",
          "syncPlans": "Synced {{count}} plan(s) to PayMongo: {{codes}}."
        }
      },
      "paymentMethods": {
        "title": "Checkout payment methods",
        "subtitle": "Choose which PayMongo payment methods appear on hosted checkout for subscriptions.",
        "methodsHeading": "Enabled methods",
        "activationNoteBeforeLink": "Each method must also be enabled on your PayMongo merchant account (",
        "activationNoteLink": "Dashboard → Settings → Payment Methods",
        "activationNoteAfterLink": "). This API only controls which enabled methods appear on hosted checkout.",
        "selectAtLeastOne": "Select at least one payment method before saving.",
        "selectAtLeastOneToast": "Select at least one payment method before saving.",
        "noChangesToast": "No changes to save.",
        "saveButton": "Save methods",
        "savingButton": "Saving…",
        "savingToast": "Saving payment methods…",
        "savedToast": "Payment methods saved.",
        "loadingMessage": "Loading checkout configuration…",
        "loadFailedMessage": "Failed to load checkout configuration.",
        "retryButton": "Try again",
        "lastUpdated": "Last updated by {{email}} on {{date}}.",
        "openPaymongoConnectionButton": "Set up PayMongo connection",
        "openSubscriptionPlansButton": "Set up subscription plans"
      },
      "subscriptionPlans": {
        "title": "Subscription plans",
        "subtitle": "Manage AbraFi sellable tiers. Billing periods are enforced in AbraFi; PayMongo collects one-time payments only.",
        "infoHeading": "What you can manage here",
        "infoIntro": "Plans live in AbraFi. Company owners pay through PayMongo hosted checkout and renew manually when a period ends.",
        "infoBulletNewTier": "New tier or price for new customers: create a new plan with a new code. Do not change amount or interval on plans that already have subscribers.",
        "infoBulletArchive": "Stop offering a tier: archive the plan. Existing company subscriptions keep their historical plan reference.",
        "infoBulletEdit": "Fix display text: edit name, description, or sort order. Code, amount, and billing interval are fixed after create.",
        "infoBulletDelete": "Delete is only available when a plan has zero company subscriptions and zero checkout sessions.",
        "infoBulletManualBilling": "PayMongo does not auto-charge subscriptions. Each payment extends the company's access for one billing interval.",
        "listHeading": "Plans",
        "emptyList": "No subscription plans yet. Create one below.",
        "codeColumn": "Code",
        "nameColumn": "Name",
        "statusColumn": "Status",
        "amountColumn": "Amount",
        "intervalColumn": "Interval",
        "subscribersColumn": "Subscribers",
        "syncedColumn": "PayMongo",
        "actionsColumn": "Actions",
        "statusActive": "Active",
        "statusArchived": "Archived",
        "syncedYes": "Synced",
        "syncedNo": "Not synced",
        "intervalValue": "{{interval}} × {{count}}",
        "editButton": "Edit",
        "archiveButton": "Archive",
        "restoreButton": "Restore",
        "deleteButton": "Delete",
        "syncButton": "Sync to PayMongo",
        "syncingButton": "Syncing…",
        "syncingToast": "Syncing plans to PayMongo…",
        "syncedToast": "Plans synced to PayMongo.",
        "createHeading": "Create plan",
        "codeLabel": "Plan code",
        "codePlaceholder": "e.g. pro-monthly",
        "nameLabel": "Display name",
        "amountLabel": "Amount (PHP)",
        "intervalLabel": "Billing interval",
        "intervalWeekly": "Weekly",
        "intervalMonthly": "Monthly",
        "intervalYearly": "Yearly",
        "descriptionLabel": "Description (optional)",
        "syncOnCreateLabel": "Sync to PayMongo after create",
        "createButton": "Create plan",
        "creatingButton": "Creating…",
        "creatingToast": "Creating subscription plan…",
        "createdToast": "Subscription plan created.",
        "updatedToast": "Subscription plan updated.",
        "archivedToast": "Plan archived.",
        "restoredToast": "Plan restored.",
        "deletedToast": "Plan deleted.",
        "updateFailedToast": "Failed to update subscription plan.",
        "archiveFailedToast": "Failed to archive subscription plan.",
        "restoreFailedToast": "Failed to restore subscription plan.",
        "deleteFailedToast": "Failed to delete subscription plan.",
        "loadingMessage": "Loading subscription plans…",
        "loadFailedMessage": "Failed to load subscription plans.",
        "retryButton": "Try again",
        "editModal": {
          "title": "Edit plan",
          "codeHint": "Plan code {{code}} cannot be changed.",
          "nameLabel": "Display name",
          "descriptionLabel": "Description",
          "sortOrderLabel": "Sort order",
          "cancelButton": "Cancel",
          "saveButton": "Save changes",
          "savingButton": "Saving…"
        },
        "archiveModal": {
          "title": "Archive plan?",
          "body": "Archive {{name}} ({{code}})? New customers will no longer see this plan.",
          "hint": "Companies already on this plan are not affected.",
          "cancelButton": "Cancel",
          "confirmButton": "Archive plan",
          "archivingButton": "Archiving…"
        },
        "restoreModal": {
          "title": "Restore plan?",
          "body": "Restore {{name}} ({{code}}) for new signups?",
          "confirmButton": "Restore plan",
          "restoringButton": "Restoring…"
        },
        "deleteModal": {
          "title": "Delete plan?",
          "body": "Permanently delete {{name}} ({{code}})? This cannot be undone.",
          "hint": "Only unused plans can be deleted.",
          "cancelButton": "Cancel",
          "confirmButton": "Delete plan",
          "deletingButton": "Deleting…"
        }
      }
    },
    "help": {
      "title": "User Help Center",
      "subtitle": "A quick guide for using AbraFi, including FAQs, troubleshooting, and how-to steps.",
      "faqSectionTitle": "Frequently Asked Questions",
      "howToSectionTitle": "How To",
      "reportBugSectionTitle": "Report a Bug",
      "reportBugDescription": "Found an issue? Send us the details so we can investigate and fix it. Please include steps to reproduce, expected result, and screenshots if available.",
      "reportViaEmail": "Report via Email",
      "reportEmailSubject": "AbraFi Bug Report",
      "reportEmailDefaultBody": "Please describe the issue, steps to reproduce, expected result, and actual result.",
      "reportModalTitle": "Send message to support",
      "reportModalToLabel": "To:",
      "reportModalMessageLabel": "Your message",
      "reportModalMessagePlaceholder": "Describe your issue, steps to reproduce, expected result, and actual result.",
      "reportModalCancel": "Cancel",
      "reportModalOpenEmail": "Open Email App",
      "youtubeBanner": {
        "eyebrow": "Video tutorials",
        "title": "Learn AbraFi on YouTube",
        "description": "Watch step-by-step walkthroughs for categories, transactions, journals, and reports — updated by the Abrasoft team.",
        "cta": "Watch on YouTube"
      },
      "faq": {
        "start": {
          "question": "How do I start using AbraFi?",
          "answer": "Begin from Dashboard, set your active company, then add categories and your first transactions. This builds your financial reports automatically."
        },
        "settings": {
          "question": "Where can I manage my account settings?",
          "answer": "Open Account in the sidebar, then use View Profile or Change Password depending on what you need to update."
        },
        "reports": {
          "question": "How can I view financial reports?",
          "answer": "Open Accounting and choose your report (Income Statement, Balance Sheet, Cash Flow, and others). Adjust filters before exporting or printing."
        }
      },
      "howToSteps": {
        "organizeCategories": "Create and organize categories first so transactions are grouped correctly.",
        "recordTransactions": "Record transactions regularly from the Transactions page.",
        "reviewReportOutputs": "Review report outputs in Accounting and validate totals before sharing.",
        "manageAccountSettings": "Use Profile and password options to keep your account details updated."
      },
      "featureGuidesSectionTitle": "Feature guides",
      "featureGuides": {
        "equipment": "PPE — fixed assets, depreciation, and journal entries",
        "posInventory": "POS inventory — warehouses, receives, transfers, and stock counts",
        "hris": "HRIS — employees, attendance, leave, payroll, and My HR self-service",
        "customerEmailEditor": "Customer email editor — HTML messages and bulk send"
      },
      "posInventory": {
        "title": "POS inventory guide",
        "description": "Manage stock across warehouses: receive from suppliers or purchase orders, sell from the right location, transfer between sites, and keep counts accurate — without free-form stock adjustments.",
        "whyHelpfulTitle": "Why use POS inventory?",
        "whyHelpfulBody": "POS inventory tracks how much you have and where it sits. Stock is company-owned, warehouse by warehouse, with optional supplier lots so you can see what remains from each supplier.",
        "benefit1": "Know on-hand vs available — in-transit stock is not sellable.",
        "benefit2": "Receive with a required supplier (from a PO, from a bill with manual SKUs, or standalone).",
        "benefit3": "Each register sells from its home warehouse (or multi-warehouse settings you configure).",
        "benefit4": "Correct stock with counts and transfers — documents are permanent records (void and recreate, not silent edits).",
        "setupTitle": "Set up warehouses and registers",
        "setupIntro": "Start here before receiving or selling tracked products:",
        "setupStep1": "Open Warehouses. Every company gets a default Main warehouse; add more for other stores or storage sites. Optional bins organize stock inside a warehouse.",
        "setupStep2": "Create or edit each POS register and choose its home warehouse. Optionally set serial sale mode (scan vs auto-pick) and how stock is deducted across warehouses.",
        "setupStep3": "Turn on Track inventory on POS products (and Track serial when you need unique serial numbers).",
        "setupStep4": "Opening stock for a new product uses a standalone receive into your default warehouse (supplier required).",
        "openWarehousesLink": "Open Warehouses",
        "binsTitle": "What are bins?",
        "binsBody": "Bins are optional shelf or location labels inside a warehouse (for example Aisle A / Shelf 2). Use them when your team needs to know where stock sits within a site. Stock quantity is still tracked at the warehouse; bins help organize receives and counts. Skip bins if one location per warehouse is enough.",
        "inboundTitle": "Bring stock in (orders & receiving)",
        "inboundIntro": "All new stock comes through Orders & Receiving. Supplier is always required. Delivery paperwork often differs from the order — use the flow that matches your documents:",
        "inboundStep1": "Purchase order — create an immutable PO with product lines, then receive against it (partial receives OK when delivery is short).",
        "inboundStep2": "From bill — link an AP bill to lock the supplier, then enter SKUs manually when the bill has no product lines.",
        "inboundStep3": "Standalone receive — warehouse + supplier + lines (qty, unit cost in PHP, optional expiry, bin, serials).",
        "inboundStep4": "CSV Import — dry-run then commit drafts; post each draft when ready. Do not use free-form Adjust (removed).",
        "openPurchaseOrdersLink": "Open Orders & Receiving",
        "sellingTitle": "Selling and stock checks",
        "sellingIntro": "When a cashier completes a sale, AbraFi deducts available stock using lots (FEFO when expiry is set, otherwise FIFO). Combos deduct component products, not the combo SKU itself.",
        "sellingBullet1": "Hard block — you cannot sell more than available at the register’s warehouses.",
        "sellingBullet2": "Void or refund restocks the same warehouses and lots that were sold.",
        "sellingBullet3": "Expired lots show a warning but can still sell unless you change product practice.",
        "availableVsOnHand": "On hand is quantity at a warehouse. Available is what you can sell there. Stock that has been shipped on a transfer is no longer available at the source until it is received at the destination or returned.",
        "transferTitle": "Move stock between warehouses",
        "transferIntro": "Transfers use an in-transit status so stock is not sellable while moving:",
        "transferStep1": "Create and ship a transfer from one warehouse to another (lots are picked automatically).",
        "transferStep2": "At the destination, receive all or part of the shipment.",
        "transferStep3": "For any remainder, continue receiving later or return it to the source. Cancel an in-transit transfer to return everything still in transit to the source.",
        "openTransfersLink": "Open Transfers",
        "countTitle": "Stock counts",
        "countBody": "Complete a count in one sitting. Optionally pick a bin for location labeling. The screen shows system on-hand. Shortages reduce lots automatically (FEFO/FIFO). Overage asks you to pick a supplier (a suggestion is shown). Finished counts are permanent — run a new count to correct again. Sales are not blocked during a count (you may see a warning).",
        "openStockCountsLink": "Open Stock counts",
        "lowStockTitle": "Low stock alerts",
        "lowStockBody": "Open Reorder rules to set minimums (and optional reorder-to) per warehouse and product. In View Inventory, turn on Low stock only to see breaches. Members with POS access (plus owners) get an in-app notification once per breach until quantity recovers.",
        "openLowStockLink": "Open View Inventory (low stock)",
        "openReorderRulesLink": "Open Reorder rules",
        "importTitle": "CSV import",
        "importBody": "Use Import for bulk receive or related templates. Always dry-run first. Commits create drafts you review and post — safer for large catalogs.",
        "openImportLink": "Open Import",
        "rulesTitle": "Important rules",
        "rulesIntro": "These rules keep your stock audit trail trustworthy:",
        "rule1": "No free-form Adjust — use receive, count, transfer, or sale only.",
        "rule2": "POs, receives, transfers, and completed counts are not editable after create/post — void (when allowed) and create a new document.",
        "rule3": "Void a posted receive only if none of its lot quantity was sold, transferred out, or counted down.",
        "rule4": "You cannot over-receive against a PO line; extras need a standalone receive or a new PO.",
        "rule5": "You cannot change a register’s warehouse while a session is open, or archive a warehouse that still has on-hand or in-transit stock.",
        "tipsTitle": "Tips",
        "tip1": "Filter View Inventory by warehouse or supplier to see remaining stock from one supplier.",
        "tip2": "Use bins only when your team needs shelf-level locations — they are optional.",
        "tip3": "Prefer real suppliers on receives so “remaining from supplier” reports stay useful.",
        "tip4": "For multi-branch selling, keep each store register on home_only unless you intentionally enable priority or FEFO across warehouses.",
        "tip5": "Check Activity Logs for who posted receives, transferred stock, or completed counts.",
        "openInventoryLink": "Open View Inventory",
        "backToPos": "Back to POS",
        "openOrdersReceivingLink": "Open Orders & Receiving"
      },
      "equipment": {
        "title": "Property, Plant and Equipment (PPE) guide",
        "description": "Track fixed assets, record acquisition and depreciation in your books, and verify that every PPE action posts to the Transactions journal.",
        "whyHelpfulTitle": "Why use PPE?",
        "whyHelpfulBody": "PPE keeps asset purchases and depreciation out of manual spreadsheet work. Each save posts balanced journal entries so your reports stay aligned with what you recorded.",
        "benefit1": "See book value (initial amount minus accumulated depreciation) on every asset.",
        "benefit2": "Record straight-line depreciation by fiscal year with suggested amounts.",
        "benefit3": "Open linked transactions from the asset detail page to audit what was posted.",
        "benefit4": "Export the PPE list and depreciation report for review or sharing.",
        "workflowTitle": "Typical workflow",
        "workflowIntro": "Most teams follow this path from purchase to year-end depreciation:",
        "step1": "Add a PPE asset with name, initial amount, useful life, salvage value, acquisition date, equipment account, and source account (for example Cash).",
        "step2": "AbraFi creates an acquisition transaction: debit the equipment asset account, credit the source account you chose.",
        "step3": "When ready, record depreciation for the fiscal year. AbraFi posts depreciation expense and accumulated depreciation.",
        "step4": "Review book value on the asset detail page and in reports (Balance Sheet, Income Statement, General Journal).",
        "step5": "Use the depreciation report to review entries across all assets, or cancel an entry if you need to reverse it.",
        "journalTitle": "How entries reach Transactions",
        "journalIntro": "PPE actions create standard double-entry transactions in your company ledger. They appear in Transactions and accounting reports like any other journal entry.",
        "bullet1": "Acquisition — Debit equipment asset category, credit source category (same amount as initial amount). Source type: equipment.",
        "bullet2": "Depreciation — Debit depreciation expense, credit accumulated depreciation for the fiscal year amount. Posted on December 31 of that fiscal year. Source type: equipment_depreciation.",
        "bullet3": "Cancel depreciation — Reverses the depreciation entry with opposite debits and credits.",
        "bullet4": "Void PPE — Reverses the acquisition (credit equipment asset, debit source) when the asset is voided.",
        "journalOutro": "Use View transaction on the PPE detail page to jump to the acquisition entry. Depreciation entries use the same Transactions list with descriptions such as \"Depreciation — [asset name] (FY [year])\".",
        "depreciationTitle": "Straight-line depreciation",
        "depreciationBody": "Annual depreciation is (initial amount − salvage value) ÷ useful life years. AbraFi suggests the amount for the pending fiscal year; you confirm before posting. After depreciation is recorded, asset metadata (name, categories, amounts) is locked until you cancel that depreciation entry.",
        "bookValueTitle": "Book value and balances",
        "bookValueBody": "Book value = initial amount − accumulated depreciation. Active depreciation increases accumulated depreciation and reduces book value. Cancelled depreciation entries remain in history but no longer affect balances.",
        "reportsTitle": "Reports and exports",
        "reportsBody": "PPE balances flow into your financial reports through the underlying categories and transactions. Export CSV from the PPE list or depreciation report for offline review. Include voided entries on the depreciation report when you need a full audit trail.",
        "auditTitle": "Activity log",
        "auditBody": "Every create, update, depreciation record, depreciation cancel, and PPE void is listed on the asset detail page with who performed the action and when. Company Activity Logs also capture these events for company-wide audit.",
        "verifyTitle": "Verify in Transactions",
        "verifyBody": "To confirm PPE is reflected correctly in your books:",
        "tip1": "Open the asset detail page and click View transaction for the acquisition.",
        "tip2": "Search Transactions for \"Equipment acquisition\" or \"Depreciation\" and the asset name.",
        "tip3": "Compare General Journal or Trial Balance totals before and after recording depreciation.",
        "tip4": "Check that the PPE asset and accumulated depreciation categories show expected balances on the Balance Sheet.",
        "tip5": "Depreciation expense should appear on the Income Statement for the periods where you recorded depreciation.",
        "openTransactionsLink": "Open Transactions"
      },
      "howToTopic": {
        "notFoundTitle": "How To",
        "notFoundDescription": "This help topic was not found.",
        "backToHelpCenter": "Back to User Help Center",
        "quickStepsTitle": "Quick Steps",
        "organize-categories": {
          "title": "How to Create and organize categories first so transactions are grouped correctly?",
          "description": "Categories are the foundation for clean reports. Set up clear income and expense groups before you add transactions so your summaries and analytics stay accurate.",
          "step1": "Open the Categories page and create top-level groups that match your business workflow.",
          "step2": "Use specific category names to avoid duplicate meanings (for example, separate utilities from office expenses).",
          "step3": "Review your category list monthly and merge or update confusing entries."
        },
        "record-transactions": {
          "title": "How to Record transactions regularly from the Transactions page?",
          "description": "Frequent transaction recording keeps books updated and prevents end-of-month backlog. This also improves report reliability for decision-making.",
          "step1": "Go to Transactions and add entries as soon as sales or expenses happen.",
          "step2": "Include complete details like date, amount, category, and description.",
          "step3": "Review transaction history at least weekly to catch missing or incorrect entries early."
        },
        "review-report-outputs": {
          "title": "How to Review report outputs in Accounting and validate totals before sharing?",
          "description": "Report validation helps you catch posting errors before sending files to stakeholders. Cross-check key totals to ensure confidence in your financial output.",
          "step1": "Open the relevant report in Accounting (Income Statement, Balance Sheet, Cash Flow, etc.).",
          "step2": "Apply the correct date range and filters before reviewing totals.",
          "step3": "Compare totals against recent transactions and only export once values are verified."
        },
        "manage-account-settings": {
          "title": "How to keep your profile and account details updated?",
          "description": "Updated account details improve security, user management, and communication. Keep profile data current so team workflows and recovery options remain reliable.",
          "step1": "Open your Profile and verify your personal information is accurate.",
          "step2": "Use Change Password when you need to rotate credentials.",
          "step3": "Review account details after role or contact changes."
        }
      },
      "customerEmailEditor": {
        "title": "Customer email editor guide",
        "description": "Build HTML messages for Email customers on the Customers page. Use Preview in the compose step to see what recipients will receive.",
        "personalizationTitle": "Personalize with customer names",
        "personalizationBody": "Type {{customerName}} anywhere in the subject or HTML body. AbraFi replaces it with each recipient's name when the email is sent.",
        "htmlBasicsTitle": "HTML basics",
        "htmlBasicsBody": "The message field accepts HTML. Wrap paragraphs in <p> tags, add line breaks with <br>, and use <strong> or <em> for emphasis. Plain text without tags is also sent as a single paragraph in HTML email clients.",
        "examplesTitle": "Links and buttons",
        "examplesIntro": "Copy these examples into the message field and adjust the URL and label text.",
        "exampleGreetingTitle": "Greeting paragraph",
        "exampleGreetingDescription": "Start with a short personalized intro.",
        "exampleGreetingCode": "<p>Hi {{customerName}},</p>\n<p>Thank you for being our customer.</p>",
        "exampleLinkTitle": "Text link",
        "exampleLinkDescription": "Standard hyperlink to any https URL.",
        "exampleLinkCode": "<a href=\"https://abrafi.ph\">Visit AbraFi</a>",
        "exampleButtonTitle": "Button-style link",
        "exampleButtonDescription": "Many email clients render styled anchor tags like buttons. Use inline styles on the <a> tag.",
        "exampleButtonCode": "<a href=\"https://abrafi.ph\" style=\"display:inline-block;padding:12px 24px;background:#2563eb;color:#ffffff;text-decoration:none;border-radius:6px;font-weight:600;\">Get Started</a>",
        "examplePlaceholderTitle": "Personalization placeholders",
        "examplePlaceholderDescription": "These tokens are replaced per recipient when the email is sent.",
        "examplePlaceholderCode": "Hi {{customerName}},\nYour groups: {{groupNames}}\nTIN: {{tinNumber}}",
        "unsubscribeTitle": "Unsubscribe footer",
        "unsubscribeBody": "On the compose step, enable Include unsubscribe footer to append a standard opt-out link. Customers who opt out are excluded from future bulk email selection.",
        "attachmentsTitle": "Attachments",
        "attachmentsBody": "You can attach up to five files (20 MB each). Attachments are sent with every email in the batch. Large sends with attachments may take longer to process.",
        "schedulingTitle": "Scheduling sends",
        "schedulingBody": "Pick a date and time on the compose step to queue emails for later. Scheduled time uses your browser's local timezone. Pending scheduled sends appear at the top of the Email customers page where you can edit or cancel them.",
        "batchLimitsTitle": "Batch size limits",
        "batchLimitsBody": "Each send request supports up to 500 recipients (Gmail daily limits). If you select more than 500 recipients, enable sequential batch scheduling on the review step — each batch of 500 is scheduled one calendar day apart starting from your chosen schedule time.",
        "previewTitle": "Preview before sending",
        "previewBody": "On the Email customers page, click Preview email to render your HTML with a sample customer name. The preview matches the HTML part sent through Gmail.",
        "tip1": "Use full https:// URLs in href attributes.",
        "tip2": "Keep layouts simple — complex CSS may look different across email apps.",
        "tip3": "Preview with the first filtered customer's name when available.",
        "tip4": "Use Review recipients before Send emails to confirm the list.",
        "tip5": "Use the rich text editor toolbar for bold, lists, links, and uploaded images.",
        "tip6": "Save reusable templates with folders to organize newsletters and reminders."
      },
      "replayTour": {
        "title": "Installation tour",
        "description": "Walk through the Dashboard, Apps Store, Cash Books, and Help again whenever you need a refresher. Replay also shows how to uninstall an app.",
        "button": "Replay installation tour"
      }
    },
    "superadmin": {
      "inventoryApk": {
        "title": "Inventory APK",
        "subtitle": "Upload the Android APK that users can download from Downloadables for warehouse devices.",
        "loading": "Loading…",
        "loadFailed": "Failed to load Inventory APK details.",
        "retry": "Try again",
        "currentTitle": "Published APK",
        "empty": "No APK published yet. Upload a release build to make it available on Downloadables.",
        "filename": "File",
        "size": "Size",
        "uploadedAt": "Uploaded",
        "uploadedBy": "Uploaded by",
        "uploadButton": "Upload APK",
        "downloadButton": "Download",
        "removeButton": "Remove",
        "invalidFile": "Please choose an .apk file.",
        "uploading": "Uploading APK…",
        "uploadSuccess": "Inventory APK published.",
        "uploadFailed": "Failed to upload Inventory APK.",
        "preparingDownload": "Preparing download…",
        "downloadStarted": "Download started.",
        "downloadFailed": "Failed to download Inventory APK.",
        "removeConfirm": "Remove the published Inventory APK? Users will no longer be able to download it until you upload again.",
        "removeConfirmTitle": "Remove Inventory APK?",
        "removeConfirmButton": "Remove",
        "removing": "Removing APK…",
        "removeSuccess": "Inventory APK removed.",
        "removeFailed": "Failed to remove Inventory APK."
      }
    },
    "downloadables": {
      "title": "Downloadables",
      "subtitle": "Download files for the apps installed on this company.",
      "loading": "Loading downloadables…",
      "emptyState": "There are no downloadables for the apps installed on this company.",
      "bookLayoutBanner": {
        "title": "Sample books layout: {{bookStyle}}",
        "changeInSettings": "Change in Company settings"
      },
      "bookLayoutNotes": {
        "looseLeaf": "Export columns match Loose Leaf reports: ISO Date (YYYY-MM-DD), no No. or Mon columns — same as General Journal, General Ledger, and Cash Journals on screen and export.",
        "manual": "Export columns match Manual book reports: No., Mon, and day Date columns — same as your live accounting reports when Book of accounts is set to Manual."
      },
      "items": {
        "generalJournalSample": {
          "title": "General Journal (Sample)",
          "description": "Sample General Journal for {{year}} with example transactions and totals. Export uses the same options as the live report (CSV, Excel, Google Sheets, PDF).",
          "sampleNote": "Every transaction description starts with \"Sample:\" and uses fictional amounts for layout reference only.",
          "reportTitle": "General Journal",
          "exportPdfSuccess": "Sample General Journal PDF downloaded.",
          "exportPdfFailed": "Could not generate the sample General Journal PDF. Please try again."
        },
        "cashReceiptsJournalSample": {
          "title": "Cash Receipts Journal (Sample)",
          "description": "Sample Cash Receipts Journal for {{year}} with example receipts and totals. Export uses the same options as the live report (CSV, Excel, Google Sheets, PDF).",
          "sampleNote": "Every description starts with \"Sample:\" and uses fictional OR numbers and amounts for layout reference only.",
          "reportTitle": "Cash Receipts Journal",
          "exportPdfSuccess": "Sample Cash Receipts Journal PDF downloaded.",
          "exportPdfFailed": "Could not generate the sample Cash Receipts Journal PDF. Please try again."
        },
        "cashDisbursementsJournalSample": {
          "title": "Cash Disbursements Journal (Sample)",
          "description": "Sample Cash Disbursements Journal for {{year}} with example expenses and totals. Export uses the same options as the live report (CSV, Excel, Google Sheets, PDF).",
          "sampleNote": "Every description starts with \"Sample:\" and uses fictional CV numbers and amounts for layout reference only.",
          "reportTitle": "Cash Disbursements Journal",
          "exportPdfSuccess": "Sample Cash Disbursements Journal PDF downloaded.",
          "exportPdfFailed": "Could not generate the sample Cash Disbursements Journal PDF. Please try again."
        },
        "generalLedgerSample": {
          "title": "General Ledger (Sample)",
          "description": "Sample General Ledger for {{year}} with multiple example accounts, running balances, and closing totals. Export uses the same options as the all-accounts report (CSV, Excel, Google Sheets, PDF).",
          "sampleNote": "Includes Cash, income, and expense accounts with 23 linked cash-book entries. Descriptions start with \"Sample:\" for layout reference only.",
          "reportTitle": "General Ledger",
          "exportPdfSuccess": "Sample General Ledger PDF downloaded.",
          "exportPdfFailed": "Could not generate the sample General Ledger PDF. Please try again."
        },
        "trialBalanceSample": {
          "title": "Trial Balance (Sample)",
          "description": "Sample Trial Balance for {{year}} derived from the same linked cash-book scenario as the journal samples. Export uses the same options as the live report (CSV, Excel, Google Sheets, PDF).",
          "sampleNote": "Account balances match the sample General Ledger closing nets, with Owner's Capital offsetting the Cash opening balance so the sample stays balanced.",
          "reportTitle": "Trial Balance",
          "exportPdfSuccess": "Sample Trial Balance PDF downloaded.",
          "exportPdfFailed": "Could not generate the sample Trial Balance PDF. Please try again."
        },
        "inventoryApk": {
          "title": "Abrafi Inventory (Android APK)",
          "description": "Install the Abrafi Inventory mobile app on Android warehouse devices for stock inquire, in, out, and take.",
          "note": "Requires an Abrafi account with POS System permission on your company.",
          "publishedMeta": "Published {{uploadedAt}} · {{size}}. Download uses a new file name each publish so phones do not reopen an older APK from Downloads.",
          "unavailable": "The Inventory APK has not been published yet. Check back later.",
          "downloadButton": "Download APK",
          "downloadSuccess": "Inventory APK download started.",
          "downloadFailed": "Could not download the Inventory APK. Please try again.",
          "preparingDownload": "Preparing download…"
        },
        "birForm1900": {
          "title": "BIR Form 1900",
          "description": "Official BIR Form 1900 (October 2024 ENCS) for permit to use loose-leaf books of accounts, invoices, and other accounting records.",
          "note": "Published by the Bureau of Internal Revenue. Accomplish and file with your Revenue District Office per current PTU requirements.",
          "downloadButton": "Download PDF",
          "downloadSuccess": "BIR Form 1900 PDF downloaded.",
          "downloadFailed": "Could not download BIR Form 1900. Please try again."
        }
      }
    },
    "companies": {
      "actions": {
        "deleteAriaLabel": "Delete company",
        "deleteTitle": "Delete company",
        "viewAriaLabel": "View company",
        "viewTitle": "View company",
        "editAriaLabel": "Edit company",
        "editTitle": "Edit company",
        "manageUsersAriaLabel": "Manage users",
        "manageUsersTitle": "Manage users",
        "transferOwnershipAriaLabel": "Transfer ownership",
        "transferOwnershipTitle": "Transfer ownership",
        "leaveAriaLabel": "Leave company",
        "leaveTitle": "Leave company"
      },
      "birProfile": {
        "selectPlaceholder": "Select…",
        "taxRegimeLoading": "Loading BIR tax regime.",
        "taxRegimeLoadFailed": "Could not load BIR tax regime.",
        "taxRegimeEightPercent": "8%",
        "taxRegimeGraduatedItemized": "Graduated itemized",
        "taxRegimeGraduatedOsd": "Graduated OSD",
        "incomeClassificationBusinessOnly": "Business income only",
        "incomeClassificationProfessional": "Professional income",
        "incomeClassificationMixed": "Mixed income"
      },
      "viewModal": {
        "title": "Company Details",
        "emptyValue": "-",
        "fiscalYearCustom": "Custom Fiscal Year",
        "fiscalYearCalendar": "Calendar Year",
        "roleOwner": "Owner",
        "roleMember": "Member",
        "yes": "Yes",
        "no": "No",
        "nameLabel": "Name:",
        "descriptionLabel": "Description:",
        "addressLabel": "Address:",
        "tinLabel": "TIN:",
        "lineOfBusinessLabel": "Line of business:",
        "birRdoLabel": "BIR Regional District Office (RDO):",
        "birTaxRegimeLabel": "BIR tax regime:",
        "incomeClassificationLabel": "Income classification:",
        "telLabel": "Tel:",
        "emailLabel": "Email:",
        "contactPersonNameLabel": "Contact person:",
        "contactNumberLabel": "Contact number:",
        "bestTimeToCallLabel": "Best time to call:",
        "missionLabel": "Mission:",
        "visionLabel": "Vision:",
        "otherInformationLabel": "Other company information:",
        "customerCarePhonesLabel": "Customer care phones:",
        "customerCareEmailLabel": "Customer care email:",
        "vatStatusLabel": "VAT registration:",
        "entityTypeLabel": "Type of Entity:",
        "registrationDateLabel": "Date of Registration:",
        "registrationNumberLabel": "Registration Number:",
        "tradeNameLabel": "Trade Name:",
        "businessStyleLabel": "Business Style:",
        "currencyLabel": "Currency:",
        "bmbeRegisteredLabel": "BMBE Registered:",
        "bmbeNumberLabel": "BMBE Registration No.:",
        "fiscalYearTypeLabel": "Fiscal Year Type:",
        "fiscalYearStartLabel": "Fiscal Year Start:",
        "fiscalYearEndLabel": "Fiscal Year End:",
        "ownershipLabel": "Ownership:",
        "createdAtLabel": "Created At:",
        "updatedAtLabel": "Updated At:",
        "close": "Close"
      },
      "list": {
        "title": "All Companies",
        "createCompany": "Create Company",
        "searchPlaceholder": "Search companies...",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "retry": "Retry",
        "emptySearch": "No companies found matching your search.",
        "emptyDefault": "No companies found. You are not linked to any companies yet.",
        "columnName": "Name",
        "columnDescription": "Description",
        "columnOwnership": "Ownership",
        "columnCreatedAt": "Created At",
        "columnActions": "Actions",
        "loadingOverlay": "Loading...",
        "logoFallback": "Logo",
        "roleOwner": "Owner",
        "roleMember": "Member",
        "viewerClose": "Close",
        "viewLogo": "View logo",
        "uploadingLogo": "Uploading...",
        "uploadLogo": "Upload logo",
        "deletingLogo": "Deleting...",
        "deleteLogo": "Delete logo",
        "switchModalTitle": "Switch Active Company",
        "switchToEditBody": "You are about to switch the active company to {{name}} and edit its details. Proceed?",
        "modalCancel": "Cancel",
        "switching": "Switching...",
        "modalContinue": "Continue",
        "transferModalTitle": "Transfer Ownership",
        "loadingMembers": "Loading members...",
        "transferring": "Transferring...",
        "transfer": "Transfer",
        "deleteModalTitle": "Delete Company",
        "deletingCompany": "Deleting...",
        "leaveModalTitle": "Leave Company",
        "leavingCompany": "Leaving...",
        "loadFailed": "Failed to load companies.",
        "createSuccess": "Company created successfully.",
        "switchFailed": "Failed to switch company.",
        "transferSuccess": "Ownership transferred successfully.",
        "transferFailed": "Failed to transfer ownership.",
        "selectImageError": "Please select an image file.",
        "companyNotFoundUpload": "Company not found. Unable to upload logo.",
        "uploadFailed": "Logo upload failed.",
        "logoUpdated": "Company logo updated.",
        "logoUploadFailed": "Failed to upload company logo.",
        "logoRemoved": "Company logo removed.",
        "logoRemoveFailed": "Failed to remove company logo.",
        "deleteSuccess": "Company deleted successfully.",
        "deleteFailed": "Failed to delete company.",
        "leaveSuccess": "You left the company.",
        "leaveFailed": "Failed to leave company.",
        "updateSuccess": "Company updated successfully."
      },
      "editModal": {
        "title": "Edit Company",
        "profileSection": "Company profile",
        "contactSection": "Contact",
        "registrationSection": "Registration",
        "fiscalSection": "Fiscal year",
        "nameLabel": "Name",
        "descriptionLabel": "Description",
        "addressLabel": "Address",
        "addressPlaceholder": "Enter address",
        "tinLabel": "TIN",
        "birRdoLabel": "BIR Regional District Office (RDO)",
        "birRdoPlaceholder": "Select an RDO",
        "lineOfBusinessLabel": "Line of business",
        "lineOfBusinessPlaceholder": "Retail, professional services, manufacturing",
        "birTaxRegimeLabel": "BIR tax regime",
        "incomeClassificationLabel": "Income classification",
        "telLabel": "Tel",
        "emailLabel": "Email",
        "contactPersonNameLabel": "Contact person",
        "contactPersonNamePlaceholder": "Maria Santos",
        "contactPersonNameHelp": "The person to reach for this company. This is not always the owner.",
        "contactNumberLabel": "Contact number",
        "contactNumberPlaceholder": "0917 000 0000, WhatsApp 0918 000 0000",
        "contactNumberHelp": "Phone numbers, WhatsApp, or other notes. Separate several values with commas or new lines.",
        "bestTimeToCallLabel": "Best time to call",
        "bestTimeToCallPlaceholder": "Weekdays 9:00–11:00. Not available on Mondays.",
        "bestTimeToCallHelp": "When this person is available, so they are not called on a busy day or time.",
        "statementsSection": "Company statements",
        "missionLabel": "Mission",
        "missionPlaceholder": "What the company is here to do.",
        "visionLabel": "Vision",
        "visionPlaceholder": "What the company is working toward.",
        "otherInformationLabel": "Other company information",
        "otherInformationPlaceholder": "Any other notes about this company.",
        "otherInformationHelp": "Use this for notes that are not already covered by the other company information fields.",
        "customerCarePhonesLabel": "Customer care phones",
        "customerCarePhonesPlaceholder": "(02) 8811-0000 (0977) 811-0000",
        "customerCarePhonesHelp": "Printed on sales invoices under Customer Care Support. One line per row.",
        "customerCareEmailLabel": "Customer care email",
        "customerCareEmailPlaceholder": "customercare@example.com",
        "vatStatusLabel": "VAT registration",
        "vatStatusHelp": "Choose VAT Registered or Non-VAT Registered. If VAT Registered, complete TIN and business details so they print on sales invoices.",
        "vatStatusVatHint": "VAT Registered — receipts will include VAT breakdown details.",
        "vatStatusNonVatHint": "Non-VAT Registered — receipts show as NON-VAT (no VAT breakdown).",
        "vatDetailsRequiredHint": "Enter your TIN and business details — they print on sales invoices.",
        "entityTypeLabel": "Type of Entity",
        "entityTypePlaceholder": "Select type of entity",
        "ownerSection": "Owner details",
        "ownerNameLabel": "Owner name",
        "ownerAddressLabel": "Owner address",
        "ownerBirthdayLabel": "Owner date of birth",
        "ownerNameRequired": "Enter the owner's name.",
        "ownerAddressRequired": "Enter the owner's address.",
        "ownerBirthdayRequired": "Enter the owner's date of birth.",
        "registrationDateLabel": "Date of Registration",
        "registrationDateRequired": "Enter the date of registration.",
        "requiredMark": "Required",
        "tradeNameLabel": "Trade Name",
        "businessStyleLabel": "Business Style",
        "bmbeLabel": "Registered as BMBE",
        "bmbeNumberLabel": "BMBE Registration No.",
        "fiscalYearLabel": "Fiscal Year",
        "fiscalYearCalendar": "Calendar Year",
        "fiscalYearCustom": "Custom Fiscal Year",
        "fiscalYearStartLabel": "Fiscal Year Start Date",
        "fiscalYearEndLabel": "Fiscal Year End Date",
        "monthPlaceholder": "Month",
        "dayPlaceholder": "Day",
        "cancel": "Cancel",
        "saving": "Saving...",
        "submit": "Save Changes",
        "defaultDescription": "No description provided.",
        "nameRequired": "Please enter a company name.",
        "invalidEmail": "Enter a valid email address.",
        "fiscalYearInvalid": "Enter valid fiscal year start and end dates.",
        "updateFailed": "Failed to update company. Please try again."
      },
      "Companies": {
        "Companies": {
          "delete_1": "delete",
          "leave_2": "leave",
          "delete_3": "delete",
          "leave_4": "leave"
        }
      },
      "EditCompanyModal": {
        "enter_telephone_number_1": "Enter telephone number",
        "enter_company_email_2": "Enter company email",
        "e_g_operating_under_the_trade_business_name_of_3": "e.g., Operating under the trade/business name of...",
        "e_g_laundry_services_transportation_i_t_services_4": "e.g., Laundry Services, Transportation, I.T. Services",
        "enter_bmbe_registration_number_5": "Enter BMBE registration number",
        "1_day_6": "= 1 && day",
        "optional_7": "(Optional)",
        "optional_8": "(Optional)",
        "optional_9": "(Optional)"
      }
    },
    "company": {
      "invite": {
        "invalidOrExpired": "Invalid or expired invite link",
        "yourAccountFallback": "your account",
        "joinSuccessFlash": "You joined the company successfully.",
        "joinFailed": "Failed to join company",
        "loading": "Loading…",
        "title": "Company invitation",
        "loadingInvitation": "Loading invitation…",
        "inviteLeadPrefix": "You are invited to join this company as",
        "goBackHome": "Go back home",
        "decline": "Decline",
        "joining": "Joining…",
        "accept": "Accept"
      },
      "memberInvite": {
        "title": "Company invitation",
        "inviteLead": "You've been invited by {{inviterName}} to join {{companyName}}.",
        "invalidOrExpired": "Invalid or expired invitation",
        "noLongerPending": "This invitation is no longer pending.",
        "declineSuccess": "Invitation declined.",
        "declineFailed": "Failed to decline invitation."
      },
      "lobby": {
        "welcomeTitle": "Welcome to AbraFi",
        "chooseAccountType": "Choose your account type:",
        "continueAsIndividualAria": "Continue as individual",
        "individualTitle": "I am an Individual",
        "creatingWorkspace": "Creating your workspace...",
        "individualDescription": "Create a personal workspace for managing your own finances.",
        "continueAsCompanyAria": "Continue as company",
        "companyTitle": "I represent a Company",
        "companyDescription": "Set up a business profile and invite your team members.",
        "back": "Back",
        "formTitle": "Create a Company",
        "formDescription": "Enter your organization details to set up your business workspace.",
        "companyNameLabel": "Company Name",
        "companyNamePlaceholder": "e.g., Acme Corporation",
        "additionalDetailsToggle": "Additional Details (Optional)",
        "companyDescriptionLabel": "Company Description",
        "optionalSuffix": "(Optional)",
        "companyDescriptionPlaceholder": "Brief description of your business",
        "addressLabel": "Address",
        "addressPlaceholder": "Business address",
        "tinLabel": "Tax Identification Number (TIN)",
        "vatStatusLabel": "VAT registration",
        "settingUp": "Setting up...",
        "continue": "Continue",
        "createSuccess": "Company created successfully!",
        "createFailed": "Failed to create company. Please try again.",
        "nameRequired": "Please enter a company name",
        "individualCompanyName": "Personal",
        "defaultCompanyDescription": "No description provided."
      },
      "users": {
        "backAria": "Back to companies",
        "titlePrefix": "Company Users",
        "addByEmailLabel": "Add user by email",
        "emailPlaceholder": "user@example.com",
        "linking": "Linking...",
        "linkUser": "Link User",
        "loading": "Loading users...",
        "empty": "No users linked to this company.",
        "columnEmail": "Email",
        "columnName": "Name",
        "columnRole": "Role",
        "columnActions": "Actions",
        "roleOwner": "Owner",
        "roleMember": "Member",
        "rolePending": "Pending invite",
        "manage": "Manage",
        "remove": "Remove",
        "cancelInvite": "Cancel invite",
        "cancelInviteModalTitle": "Cancel invitation",
        "cancelInviteModalLead": "Cancel the pending invitation for {{email}} to {{company}}? They will no longer be able to join with this invite.",
        "thisCompany": "this company",
        "cancellingInvite": "Cancelling…",
        "cancelInviteSuccess": "Invitation cancelled.",
        "cancelInviteFailed": "Failed to cancel invitation.",
        "invitePermissionsModalTitle": "Invite user & set permissions",
        "invitePermissionsIntro": "Choose which modules {{email}} can access after they accept. You can change this later while the invite is still pending.",
        "managePermissionsIntro": "Configure which modules {{name}} can access within this company. Unchecked modules will be completely hidden from their view.",
        "sendInvite": "Send invitation",
        "sendingInvite": "Sending…",
        "inviteSentSaved": "Invitation sent",
        "inviteLinkLabel": "Company invite link",
        "inviteLinkPlaceholder": "Click Generate to create an invite link",
        "generate": "Generate",
        "copy": "Copy",
        "removeModalTitle": "Remove user",
        "modalCancel": "Cancel",
        "removing": "Removing…",
        "generateModalTitle": "Generate invite link",
        "expireAfterLabel": "Expire after",
        "expireNever": "Never",
        "expire1h": "1 hour",
        "expire24h": "24 hours",
        "expire7d": "7 days",
        "expire30d": "30 days",
        "maxUsersLabel": "Max number of users",
        "maxUnlimited": "Unlimited",
        "generating": "Generating...",
        "generateNewLink": "Generate New Link",
        "permissionsModalTitle": "Manage User Permissions",
        "permissionsSearchPlaceholder": "Search pages or paths (e.g. Transactions, reports/income)...",
        "permissionsGrantedFilterAria": "Filter permissions by granted status",
        "permissionsGrantedFilterAll": "All permissions",
        "permissionsGrantedFilterGranted": "Granted only",
        "permissionsGrantedFilterNotGranted": "Not granted",
        "permissionsEmptySearch": "No pages found matching \"{{query}}\".",
        "permissionsEmptyGrantedFilter": "No permissions match this filter.",
        "permissionsSelectAllGroup": "Select all in {{group}}",
        "permissionsGroupActiveCount": "{{active}} / {{total}} active",
        "permissionsSaving": "Saving…",
        "permissionsSaved": "Saved",
        "permissionsSaveSuccess": "Permissions updated successfully for {{name}}.",
        "savePermissions": "Save Changes",
        "loadFailed": "Failed to load users.",
        "generateFirst": "Generate an invite link first.",
        "copySuccess": "Invite link copied.",
        "copyFailed": "Could not copy invite link.",
        "permissionsSaveFailed": "Could not save permissions.",
        "inviteGenerated": "Invite link generated.",
        "inviteGenerateFailed": "Failed to generate invite link.",
        "emailRequired": "Enter an email address.",
        "invalidEmail": "Enter a valid email address.",
        "linkSuccess": "User linked successfully.",
        "invitationSent": "Invitation sent to {{email}}.",
        "inviteEmailSent": "No account for that email yet. We sent an invite link to {{email}}.",
        "linkFailed": "Failed to link user.",
        "removeSuccess": "User removed.",
        "removeFailed": "Failed to remove user."
      },
      "periodLocks": {
        "accessDenied": "You do not have permission to manage transaction locking for this company.",
        "backToSettings": "Back to company settings",
        "backAria": "Back to company settings",
        "title": "Transaction locking",
        "loading": "Loading…",
        "refreshing": "Refreshing…",
        "presetsAria": "Lock presets",
        "quickLockTitle": "Quick lock",
        "startDateLabel": "Start date",
        "optional": "(optional)",
        "endDateLabel": "End date",
        "addMergeRange": "Add / merge range",
        "columnStart": "Start",
        "columnEnd": "End",
        "columnActions": "Actions",
        "noRanges": "No lock ranges.",
        "beginningOfTime": "Beginning of time",
        "remove": "Remove",
        "auditTitle": "Audit log",
        "noAuditEntries": "No audit entries yet.",
        "auditWhen": "When",
        "auditAction": "Action",
        "auditActor": "Actor",
        "auditRange": "Range",
        "entriesPerPage": "Entries per page",
        "prevPage": "‹ Prev",
        "nextPage": "Next ›",
        "goToLabel": "Go to",
        "goButton": "Go",
        "removeModalTitle": "Remove lock range",
        "modalCancel": "Cancel",
        "removing": "Removing…",
        "removeLock": "Remove lock",
        "lockSuccess": "Transactions are now locked for {{range}}.",
        "auditLoadFailed": "Failed to load audit log.",
        "loadFailed": "Failed to load period locks.",
        "endDateRequired": "End date is required.",
        "startBeforeEnd": "Start date must be on or before the end date.",
        "saveFailed": "Failed to save period lock.",
        "confirmMismatch": "Type \"unlock transactions\" to confirm removal.",
        "removeSuccess": "Period lock removed.",
        "removeFailed": "Failed to remove period lock."
      },
      "TransactionPeriodLocks": {
        "TransactionPeriodLocks": {
          "start_date_1": "start date",
          "end_date_2": "end date",
          "audit_csv_downloaded_3": "Audit CSV downloaded."
        }
      },
      "Users": {
        "CompanyUsers": {
          "1_user_1": "1 user",
          "5_users_2": "5 users",
          "10_users_3": "10 users",
          "25_users_4": "25 users",
          "50_users_5": "50 users"
        }
      }
    },
    "apiKeys": {
      "scopes": {
        "create_sale": "Create & Void Sale",
        "create_expense": "Create Expense",
        "create_custom_transaction": "Create Custom Transaction",
        "create_bill": "Create Bill",
        "create_customer": "Create Customer",
        "create_supplier": "Create Supplier",
        "create_api_key": "Create API Key",
        "send_customer_emails": "Send Customer Emails",
        "bill_invoice_settings": "Bill Invoice Settings"
      },
      "ApiKeys": {
        "pageTitle": "API Keys",
        "pageSubtitle": "Generate and manage company API keys for external integrations. Keys can create and void sales, and create other records; they cannot edit financial data in place.",
        "newKey": "New API Key",
        "viewConnectionInfo": "Connection info",
        "viewConnectionInfoAria": "View company ID and API base URL",
        "viewVoided": "View voided",
        "viewActive": "View active",
        "searchPlaceholder": "Search by label…",
        "searchAria": "Search API keys by label",
        "emptySearch": "No API keys match your search.",
        "loading": "Loading…",
        "tryAgain": "Try again",
        "emptyActive": "No active API keys yet.",
        "emptyVoided": "No voided API keys.",
        "colKey": "Key",
        "colStatus": "Status",
        "colCreated": "Created",
        "colActions": "Actions",
        "statusActive": "Active",
        "statusVoided": "Voided",
        "viewAria": "View permissions for {{key}}",
        "revokeAria": "Revoke {{key}}",
        "revokeSuccess": "API key revoked.",
        "accessDenied": "You do not have permission to manage API keys for this company."
      },
      "CreateApiKeyModal": {
        "title": "New API Key",
        "permissionsHint": "Select write permissions for this key. Sales keys can record and void receipts via the API; other updates are not available via API keys.",
        "label": "Label",
        "labelPlaceholder": "e.g. Production integration",
        "labelRequired": "Label is required.",
        "validationBothRequired": "Enter a label and select at least one permission.",
        "permissionsLegend": "Permissions",
        "selectAllButton": "Select all",
        "deselectAllButton": "Deselect all",
        "selectAllAria": "Select all permissions",
        "deselectAllAria": "Deselect all permissions",
        "permissionRequired": "Select at least one permission.",
        "cancel": "Cancel",
        "create": "Create API Key",
        "creating": "Creating…"
      },
      "ApiConnectionInfoModal": {
        "title": "API connection info",
        "hint": "Use these values with your API key when calling the API from an external integration."
      },
      "ApiKeyCreatedModal": {
        "title": "API key created",
        "warning": "Copy this key now. It will not be shown to you ever again for security purposes.",
        "copyKey": "Copy key",
        "keyCopied": "Copied",
        "companyIdLabel": "Company ID",
        "copyCompanyId": "Copy company ID",
        "companyIdCopied": "Copied",
        "apiBaseUrlLabel": "API base URL",
        "copyApiBaseUrl": "Copy API base URL",
        "apiBaseUrlCopied": "Copied",
        "copyFailed": "Could not copy to clipboard. Select the text and copy manually.",
        "done": "Done"
      },
      "ApiKeyDetailsDrawer": {
        "title": "API key details",
        "keyHint": "Key identifier",
        "label": "Label",
        "status": "Status",
        "created": "Created",
        "createdByEmail": "Created by email",
        "createdByName": "Created by name",
        "revoked": "Revoked",
        "revokedByEmail": "Revoked by email",
        "revokedByName": "Revoked by name",
        "notAvailable": "—",
        "permissionsTitle": "Permissions",
        "noPermissions": "No permissions were assigned to this key.",
        "secretNotShown": "The secret key is never shown again after creation."
      },
      "RevokeApiKeyModal": {
        "title": "Revoke API key",
        "body": "Revoke \"{{key}}\"? External systems using this key will stop working immediately.",
        "hint": "Revoked keys remain in the voided list for audit. Create a new key if you need different permissions.",
        "cancel": "Cancel",
        "confirm": "Revoke",
        "revoking": "Revoking…"
      }
    },
    "home": {
      "homepagePopup": {
        "ariaLabel": "Announcement",
        "closeAriaLabel": "Close",
        "dontShowAgain": "Do not show again",
        "closeButton": "Close",
        "birSealAlt": "Bureau of Internal Revenue registered seal badge",
        "npcSealAlt": "National Privacy Commission DPO/DPS registered seal"
      },
      "registrationBanner": {
        "ariaLabel": "Registration notice",
        "text": "Registered with BIR & NPC",
        "view": "View",
        "dismissAriaLabel": "Dismiss registration notice"
      },
      "npcRegistration": {
        "title": "NPC Seal of Registration",
        "body": "AbraFi is registered with the National Privacy Commission under the Data Privacy Act of 2012, its implementing rules and regulations, and related issuances.",
        "learnMore": "Learn More",
        "sealAlt": "National Privacy Commission DPO/DPS registered seal"
      },
      "hero": {
        "sectionAriaLabel": "Hero",
        "badgeAriaLabel": "Brand label",
        "badge": "Abrafi by Abrasoft",
        "signInComplianceNote": "Abrafi by Abrasoft is a Philippine financial management and automated bookkeeping platform for business records and BIR compliance.",
        "titleLine": "Accounting",
        "titleAccent": "Made Simple.",
        "tagline": "Built for Filipinos.",
        "subtitle": "Everything your business needs to stay financially organized. From receipt tracking to PFRS-aligned financial reports, all in one BIR-native workspace.",
        "statsAriaLabel": "Platform highlights",
        "stat1Value": "PFRS",
        "stat1Label": "Standards-Aligned",
        "stat2Value": "1",
        "stat2Label": "Unified Workspace",
        "stat3Value": "Auto",
        "stat3Label": "Records Generation",
        "goToDashboard": "Go to Dashboard",
        "signIn": "Sign In",
        "getStarted": "Get Started",
        "exploreServices": "Explore services",
        "imageAlt": "abrafi command core"
      },
      "navbar": {
        "howItWorks": "How It Works",
        "services": "Services",
        "pricing": "Pricing",
        "faq": "FAQ",
        "brandAriaLabel": "Abrafi by Abrasoft home",
        "brandByline": "by Abrasoft",
        "mainNavAriaLabel": "Main navigation",
        "goToDashboardAriaLabel": "Go to Dashboard",
        "dashboard": "Dashboard",
        "signInAriaLabel": "Sign in",
        "signIn": "Sign In",
        "createAccountAriaLabel": "Create account",
        "getStarted": "Get Started",
        "closeMenuAriaLabel": "Close menu",
        "openMenuAriaLabel": "Open menu",
        "mobileNavAriaLabel": "Mobile navigation",
        "mobileNavLinksAriaLabel": "Mobile navigation links",
        "goToDashboard": "Go to Dashboard"
      },
      "footer": {
        "mainMessage": "Practical bookkeeping automation for growing businesses.",
        "browseMoreTitle": "Browse More",
        "howItWorks": "How It Works",
        "services": "Services",
        "pricing": "Pricing",
        "faq": "FAQ",
        "legalTitle": "Legal & Policies",
        "privacyPolicy": "Privacy Policy",
        "terms": "Terms of Use",
        "cookies": "Cookies",
        "disclaimer": "Disclaimer",
        "birSealBadge": "BIR Seal Badge",
        "companyTitle": "Company",
        "abrasoftOfficial": "Abrasoft Official",
        "contactSupport": "Contact Support",
        "copyrightLine": "© {{year}} Abrasoft I.T. Services. All rights reserved. Powered by Abrasoft",
        "copyright": "© {{year}} Abrasoft I.T. Services. All rights reserved.",
        "poweredByPrefix": "Powered by"
      },
      "pricing": {
        "sectionTag": "Early Access Terms",
        "title": "Plans and Pricing",
        "subtitle": "Start with access during early development.",
        "plansIntro": "Choose the plan that fits your business today. Upgrade as you grow.",
        "mostPopular": "Most Popular",
        "includedHeading": "Every plan includes",
        "included": {
          "birCompliant": "BIR-compliant tools",
          "secureStorage": "Secure cloud storage",
          "support": "Email & chat support",
          "guides": "Guides & resources",
          "mobile": "Mobile-friendly access",
          "updates": "Continuous updates"
        },
        "betaBannerTitle": "FREE during Beta",
        "betaBannerText": "All plans are free while we're in beta. Sign up now — no credit card required.",
        "plans": {
          "free": {
            "name": "Free",
            "price": "₱0",
            "period": "Forever",
            "audience": "Perfect for getting started",
            "feature1": "Up to 100 transactions per month",
            "feature2": "Core ledgers and journals",
            "feature3": "Balance sheet",
            "feature4": "Essential reports",
            "tagline": "Start organizing your books at no cost"
          },
          "startup": {
            "name": "Startup",
            "price": "₱198",
            "period": "/ month",
            "audience": "For teams outgrowing Free",
            "feature1": "1,000 transactions per month",
            "feature2": "Everything in Free",
            "feature3": "Prepaid packs for extra transactions",
            "feature4": "Prepaid top-ups when you need more",
            "tagline": "Record more without slowing down"
          },
          "growth": {
            "name": "Growth",
            "price": "₱891",
            "period": "/ month",
            "audience": "5× Startup transaction volume",
            "feature1": "5,000 transactions per month",
            "feature2": "Everything in Startup",
            "feature3": "Advanced financial reports",
            "feature4": "All Companies dashboard access",
            "tagline": "Built for active books"
          },
          "scale": {
            "name": "Scale",
            "price": "₱3,299",
            "period": "/ month",
            "audience": "20× Startup transaction volume",
            "feature1": "20,000 transactions per month",
            "feature2": "Everything in Growth",
            "feature3": "Multi-user and API access",
            "feature4": "High-volume prepaid top-ups",
            "tagline": "For larger operations"
          },
          "abrafile": {
            "name": "Abrafile",
            "subtitle": "Individual BIR filing (pay-per-file)",
            "feature1": "₱100 for Free users & non-users",
            "feature2": "₱70 for Growth users",
            "feature3": "₱30 for Scale subscribers",
            "tagline": "Pay only when you file"
          }
        },
        "getStarted": "Get Started",
        "ctaNote": "Pricing shown is planned for public launch. During beta, everything is free."
      },
      "cta": {
        "faqTag": "FAQ",
        "faqTitle": "Common questions",
        "faq1Question": "Who is AbraFi for?",
        "faq1Answer": "AbraFi is designed for small business owners, freelancers, and bookkeepers who want a self-service workflow for bookkeeping and report preparation.",
        "faq2Question": "Does AbraFi handle my taxes?",
        "faq2Answer": "AbraFi is a productivity tool that helps prepare records and financial reports. It does not provide legal or tax advice, and final responsibility for filings and accuracy remains with the user.",
        "faq3Question": "How is early access priced?",
        "faq3Answer": "During the active development phase, pricing is managed under early-access terms. Plan terms and pricing may change when subscription plans launch.",
        "finalAuthorityTag": "Final Authority",
        "title": "Ready to amplify your business?",
        "description": "Create your account in minutes and start organizing receipts and reports in one place.",
        "goToDashboard": "Go to Dashboard",
        "signIn": "Sign In",
        "getStarted": "Get Started"
      },
      "taxRegime": {
        "title": "Not sure which regime fits you?",
        "subtitle": "Select a regime to see how Abrafi simplifies your compliance.",
        "regimeGroupAriaLabel": "Philippine income tax regime options",
        "cardFlat8Title": "8% Flat Tax Regime",
        "cardFlat8Description": "Ideal for simplified reporting. No AFS required, no Percentage Tax.",
        "cardOsdTitle": "Graduated with OSD",
        "cardOsdDescription": "Standard deduction approach for those not utilizing full itemization.",
        "cardItemizedTitle": "Itemized Deductions",
        "cardItemizedDescription": "Best for high-expense businesses needing full tax optimization.",
        "promoTitle": "Ready to optimize your taxes?",
        "benefitFlat8ZeroPercentageTax": "Zero Percentage Tax",
        "benefitFlat8NoAudit": "No Audit Required",
        "benefitFlat8LowAdmin": "Low Admin Effort",
        "benefitOsdStandardDeduction": "40% optional standard deduction",
        "benefitOsdGraduatedRates": "Graduated income tax rates",
        "benefitOsdNoItemization": "No itemized expense tracking",
        "benefitItemizedMaxDeductions": "Maximize valid expense deductions",
        "benefitItemizedLowestTax": "Lowest tax when expenses are documented",
        "benefitItemizedFullOptimization": "Full tax optimization with proper records",
        "calculatorCta": "Use Abrafi Tax Calculator"
      },
      "dataFlow": {
        "title": "Your BIR compliance on autopilot.",
        "subtitle": "Running a business in the Philippines is hard enough. Accounting should not be. Abrafi automates the boring stuff so you can focus on growing your revenue.",
        "step1Title": "Snap, Scan, Done.",
        "step1Description": "Turn your pile of receipts into digital records instantly. Our OCR technology extracts the data so you never have to type a reference number again.",
        "step2Title": "BIR Forms, Pre-Filled.",
        "step2Description": "Your organized records flow into supported BIR workflows, prefilling key fields so you spend less time re-keying the same figures across forms.",
        "step3Title": "Real-Time Tax Clarity.",
        "step3Description": "See exactly what you owe in real-time. Generate BIR-ready financial statements with one click and eliminate year-end panic forever."
      },
      "ecosystem": {
        "sectionTag": "The Real Solution",
        "title": "Escape the chaos.",
        "subtitle": "Spend less time stressing over bookkeeping, taxes, and financial reports.",
        "bullet1Strong": "No accounting expertise required.",
        "bullet1Rest": "Forget the stress of balancing debits and credits. AbraFi translates your daily business activities into professional accounting entries automatically.",
        "bullet2Strong": "Beyond the Desktop.",
        "bullet2Rest": "Break free from the limitations of Windows-only filing tools. Manage your taxes and view your financial health on any device, anywhere in the Philippines.",
        "bullet3Strong": "Financial reports generated automatically.",
        "bullet3Rest": "Generate PFRS-aligned financial statements from your recorded transactions in just a few clicks.",
        "service1Title": "Automated Bookkeeping",
        "service1Description": "Upload receipts and expenses to auto-generate records and keep your ledgers up to date in real-time.",
        "service2Title": "PFRS Reports",
        "service2Description": "Generate Income Statements, Balance Sheets, and Cash Flow Statements aligned with Philippine reporting standards.",
        "service3Title": "Accounting Notes",
        "service3Description": "Generate detailed notes to financial statements for better transparency and audit readiness.",
        "service4Title": "Management Responsibility",
        "service4Description": "Draft Statements of Management Responsibility (a commonly requested supporting document) alongside your financial reports."
      }
    },
    "notifications": {
      "pageTitle": "Notifications",
      "subtitle": "Recent alerts and account updates",
      "settingsButton": "Notification settings",
      "settingsButtonAria": "Open notification settings",
      "loading": "Loading notifications…",
      "loadFailed": "Failed to load notifications.",
      "markAsReadFailed": "Failed to mark notification as read.",
      "markAllAsReadFailed": "Failed to mark all notifications as read.",
      "retry": "Try again",
      "emptyUnread": "No unread notifications.",
      "emptyRead": "No read notifications.",
      "emptyAll": "No notifications.",
      "refresh": "Refresh",
      "readFilterLabel": "Filter notifications by read status",
      "readFilterAll": "All",
      "readFilterUnread": "Unread",
      "readFilterRead": "Read",
      "markAsRead": "Mark as read",
      "markSelectedAsRead": "Mark selected as read",
      "bulkMarkAsReadFailed": "Failed to mark notifications as read.",
      "selectAllOnPage": "Select all",
      "selectAllAria": "Select all notifications on this page",
      "selectNotificationAria": "Select notification: {{title}}",
      "selectionSummary": "{{count}} selected",
      "clearSelection": "Clear selection",
      "loadMore": "Load more",
      "dismissError": "Dismiss",
      "detail": {
        "pageTitle": "Notification",
        "loading": "Loading notification…",
        "loadFailed": "Failed to load notification.",
        "notFound": "Notification not found.",
        "backToList": "Back to notifications",
        "viewAllNotifications": "All notifications",
        "viewLowStock": "View low stock",
        "readLabel": "Read"
      }
    },
    "uploadEntry": {
      "title": "Upload Entry",
      "subtitle": "Upload files, then optionally add notes for your bookkeeper before processing.",
      "loading": "Loading uploads…",
      "loadFailed": "Failed to load uploads.",
      "retry": "Try again",
      "upload": {
        "zoneAria": "Upload files",
        "dropText": "Drop or paste files here or",
        "browse": "browse",
        "dropHint": "PDF, CSV, or images · Ctrl+V to paste · 10 MB max each",
        "invalidType": "Each file must be a PDF, CSV, or image.",
        "tooLarge": "{{name}} exceeds the 10 MB limit.",
        "success": "{{name}} uploaded.",
        "failed": "{{name}} could not be uploaded.",
        "compressTooLarge": "{{name}} is over 10 MB and could not be compressed enough to upload.",
        "compressedSuccess": "{{name}} was compressed to fit the 10 MB limit and uploaded.",
        "notesLabel": "Notes",
        "notesPlaceholder": "e.g. Paid in cash, split between two invoices…"
      },
      "list": {
        "title": "Files",
        "empty": "No files yet.",
        "fileColumn": "File",
        "sizeColumn": "Size",
        "uploadedColumn": "Uploaded",
        "statusColumn": "Status",
        "linkedColumn": "Linked",
        "linkedSale": "View sale",
        "linkedExpense": "View expense",
        "linkedTransaction": "View transaction",
        "linkedBill": "View bill",
        "linkedEquipment": "View PPE",
        "errorColumn": "Error",
        "uploadingRow": "Uploading {{name}}…",
        "selectedCount": "{{count}} selected",
        "processButton": "Process",
        "clearSelection": "Clear selection",
        "selectAllAria": "Select all uploaded files",
        "selectRowAria": "Select {{name}}",
        "statusLegendAria": "Filter files by status",
        "filterByStatusAria": "Filter by {{status}}",
        "emptyFiltered": "No files with this status.",
        "actionsColumn": "Actions",
        "viewButton": "View",
        "archiveButton": "Archive",
        "restoreButton": "Restore",
        "previewRowAria": "Open {{name}} in new tab",
        "openLoading": "Opening file…",
        "popupBlocked": "Allow pop-ups to open this file in a new tab.",
        "selectionLimit": "You can process at most {{max}} files at a time.",
        "processLimitHint": "(process up to {{max}} at a time)",
        "archiveSelected": {
          "button": "Archive selected",
          "title": "Archive selected files?",
          "message": "Archive {{count}} selected file(s)? They will no longer be selectable for processing.",
          "hint": "Archived files cannot be restored in place. You can re-upload later as new entries.",
          "cancel": "Cancel",
          "confirm": "Archive selected",
          "loading": "Archiving {{count}} file(s)…",
          "success": "Archived {{count}} file(s).",
          "partial": "{{success}} archived, {{failed}} could not be archived.",
          "allFailed": "Could not archive {{count}} file(s)."
        },
        "archiveRowAria": "Archive {{name}}",
        "reuploadRowAria": "Re-upload {{name}} as a new entry",
        "archiveSuccess": "{{name}} archived.",
        "archiveFailed": "{{name}} could not be archived.",
        "archiveConfirm": {
          "title": "Archive this file?",
          "message": "Archive {{name}}? It will no longer be selectable for processing.",
          "hint": "Archived files cannot be restored in place. You can re-upload later as a new entry.",
          "reasonLabel": "Reason (optional)",
          "reasonPlaceholder": "Why are you archiving this file?",
          "cancel": "Cancel",
          "confirm": "Archive"
        },
        "rejectSelected": {
          "button": "Reject selected",
          "title": "Reject selected uploads?",
          "message": "Reject {{count}} selected file(s)? They will be marked rejected and removed from processing.",
          "hint": "Provide a rejection reason. Rejected uploads use a separate flag and reason field from archive.",
          "cancel": "Cancel",
          "confirm": "Reject selected",
          "loading": "Rejecting {{count}} file(s)…",
          "success": "Rejected {{count}} file(s).",
          "partial": "{{success}} rejected, {{failed}} could not be rejected.",
          "allFailed": "Could not reject {{count}} file(s)."
        },
        "rejectRowAria": "Reject {{name}}",
        "rejectSuccess": "{{name}} rejected.",
        "rejectFailed": "{{name}} could not be rejected.",
        "rejectConfirm": {
          "title": "Reject this upload?",
          "message": "Reject {{name}}? It will be marked rejected and removed from processing.",
          "hint": "Rejections are saved with a required reason in a separate field from archive.",
          "reasonLabel": "Rejection reason",
          "reasonPlaceholder": "Why is this upload being rejected?",
          "reasonRequiredToast": "Enter a rejection reason before confirming.",
          "cancel": "Cancel",
          "confirm": "Reject upload"
        },
        "rejectReasonPreview": "Rejection reason: {{reason}}",
        "reuploadSuccess": "{{name}} re-uploaded as a new entry.",
        "reuploadFailed": "{{name}} could not be re-uploaded.",
        "reuploadLoading": "Re-uploading {{name}}…",
        "reuploadConfirm": {
          "title": "Re-upload archived file?",
          "message": "Archived files cannot be restored in place. Continuing downloads {{name}} and creates a new upload entry.",
          "hint": "The archived entry stays archived.",
          "cancel": "Cancel",
          "confirm": "Re-upload as new entry"
        },
        "editNotesAria": "Edit notes for {{name}}",
        "archiveReasonPreview": "Archive reason: {{reason}}",
        "notesSaved": "Notes saved for {{name}}.",
        "notesEdit": {
          "title": "Edit notes",
          "addTitle": "Add notes?",
          "addHint": "Optional notes help bookkeepers when processing this file.",
          "preview": "Preview",
          "batchProgress": "{{current}} of {{total}}",
          "batchProgressAria": "Notes progress: file {{current}} of {{total}}",
          "skip": "Skip",
          "skipAll": "Skip all",
          "cancel": "Cancel",
          "save": "Save notes",
          "imageQualityHint": "Choose HD to keep the original image, or SD to store a compressed copy. Preview below to confirm text is still readable.",
          "imageQualityRequiredCompression": "This image was over 10 MB and was uploaded compressed. SD is required — preview below to confirm text is still readable.",
          "imageQualityToggleAria": "Image quality",
          "imagePreviewLoading": "Preparing image previews…",
          "imagePreviewFailed": "Could not prepare image previews.",
          "imagePreviewCaption": "Preview — {{mode}} (click to open in a new tab)",
          "imagePreviewAlt": "Preview of {{name}}",
          "imagePreviewOpenTitle": "Open preview in a new tab",
          "imagePreviewOpenAria": "Open preview of {{name}} in a new tab",
          "compressedSaved": "{{name}} saved with SD compression.",
          "imageMode": {
            "hd": {
              "label": "HD",
              "description": "Original quality",
              "unavailableTitle": "Original exceeds 10 MB and cannot be uploaded"
            },
            "sd": {
              "label": "SD",
              "description": "Compressed"
            }
          }
        }
      },
      "status": {
        "pending": "Pending",
        "uploaded": "Uploaded",
        "failed": "Failed",
        "completed": "Complete",
        "archived": "Archived",
        "rejected": "Rejected"
      },
      "process": {
        "title": "Process uploads",
        "subtitle": "Choose where to attach {{count}} file(s), then complete the entry.",
        "filesHeading": "Selected files",
        "chooseTypeHeading": "Attach as",
        "chooseTypeHint": "Create a new entry with these files attached, or attach them to an existing record. Uploads are marked complete after you save or attach.",
        "encoding": {
          "heading": "Receipt details",
          "hint": "Check that these fields match the receipt. Leave blank anything that is not printed or written on it.",
          "reading": "Reading the receipt…",
          "readingToast": "Reading the receipt…",
          "readAgain": "Read again",
          "readUpdatedToast": "Receipt details were read from the file.",
          "save": "Save receipt details",
          "saving": "Saving…",
          "savingToast": "Saving…",
          "savedToast": "Receipt details saved.",
          "loadFailed": "Could not load the receipt details.",
          "retry": "Try again",
          "transcriptionFailed": "The receipt could not be read. Fill in what you can see, and leave the rest blank.",
          "transcriptionFailedAgain": "The receipt could not be read. Fill in what you can see, and leave the rest blank.",
          "addLine": "Add line",
          "removeLine": "Remove line",
          "lineItemsHeading": "Line items",
          "entryHeading": "Receipt entry",
          "sellerHeading": "Seller",
          "sellerTinInvalid": "Seller TIN must be exactly 9 digits.",
          "sellerBranchCodeInvalid": "Seller branch code must be exactly 5 digits.",
          "buyerHeading": "Buyer",
          "receiptHeading": "Receipt",
          "amountsHeading": "Amounts",
          "sellerName": "Seller name",
          "sellerBusinessName": "Seller business name",
          "sellerTin": "Seller TIN",
          "sellerBranchCode": "Seller branch code",
          "sellerAddress": "Seller address",
          "sellerContact": "Seller contact",
          "buyerName": "Buyer name",
          "buyerTin": "Buyer TIN",
          "buyerAddress": "Buyer address",
          "receiptTypeAsPrinted": "Receipt type as printed",
          "receiptNumber": "Receipt number",
          "dateAsWritten": "Date as written",
          "receiptDate": "Receipt date",
          "currency": "Currency",
          "vatableSales": "VATable sales",
          "vatExemptSales": "VAT-exempt sales",
          "zeroRatedSales": "Zero-rated sales",
          "vatAmount": "VAT amount",
          "discountAmount": "Discount",
          "subtotalAmount": "Subtotal",
          "totalAmount": "Total",
          "paymentMethod": "Payment method",
          "lineDescription": "Description",
          "quantity": "Quantity",
          "unit": "Unit",
          "unitPrice": "Unit price",
          "amount": "Amount",
          "lineAmountMismatchTotal": "Line amounts add up to {{sum}}, which does not match the total {{target}}. Check the lines against the receipt.",
          "lineAmountMismatchSubtotal": "Line amounts add up to {{sum}}, which does not match the subtotal {{target}}. Check the lines against the receipt."
        },
        "noTargetsAvailable": "You do not have permission to record any of the supported entry types.",
        "cancelButton": "Back to uploads",
        "noSelection": "No files were selected.",
        "back": "Back to Upload Entry",
        "backToUploads": "Back to uploads",
        "missingEntries": "One or more selected files could not be found.",
        "notAttachable": "Only uploaded files can be attached to an entry.",
        "tooManySelected": "Too many files selected ({{count}}). Process at most {{max}} at a time.",
        "loadingAttachments": "Loading file attachments…",
        "attachmentsFailed": "Failed to load file attachments.",
        "salesFormHint": "These files are attached as receipt documents. Save this sale to finish processing the uploads.",
        "expenseFormHint": "These files are attached as receipt documents. Save this expense to finish processing the uploads.",
        "analyzingFiles": "Analyzing files…",
        "analyzingFilesHint": "Reading your documents to suggest field values. This may take a moment.",
        "suggestionsUnavailable": "Could not read suggestions from these files. You can still fill the form manually.",
        "useAiSuggestion": "Use from file: {{value}}",
        "aiSuggestionsBanner": "Suggestions from your attached files — tap a pill or link to fill a field.",
        "aiDatePill": "From file: {{date}}",
        "aiDateCandidatePill": "Also: {{date}}",
        "aiSupplierPill": "From file: {{name}}",
        "aiCreateSupplierPill": "Find supplier: {{name}}",
        "aiCustomerPill": "From file: {{name}}",
        "aiCreateCustomerPill": "Find customer: {{name}}",
        "aiTagPill": "Similar expense: {{name}}",
        "attachExisting": {
          "title": "Attach to an existing record",
          "description": "Attach {{count}} file(s) as receipt documents on an existing Sales, Expense, custom entry, Bill, or PPE record.",
          "recordTypeLabel": "Record type",
          "searchLabel": "Find record",
          "searchPlaceholder": "Search by reference, name, or description",
          "resultsLabel": "Matching records",
          "loading": "Loading records…",
          "noResults": "No matching records found.",
          "selectRequired": "Select a record to attach these files to.",
          "cancel": "Cancel",
          "confirm": "Attach files",
          "attaching": "Attaching files…",
          "attachingButton": "Attaching…",
          "success": "Attached {{count}} file(s) to the selected record."
        },
        "confirmTarget": {
          "title": "Attach files as this entry type?",
          "message": "Attach {{count}} file(s) as {{target}} and analyze them for field suggestions?",
          "hint": "You will leave this page while files are analyzed, then open the entry form with attachments.",
          "multiLineHint": "Sales, expenses, and bills can have multiple deposit or expense lines. Review line splits on the next screen — AI may suggest one combined line when it cannot split reliably.",
          "cancel": "Cancel",
          "confirm": "Continue"
        },
        "unprocessablePrompt": {
          "title": "Could not read suggestions",
          "message": "You can still continue and fill the entry form manually with the files attached. Continue anyway?",
          "cancel": "Stay here",
          "continue": "Continue anyway"
        },
        "targets": {
          "sales": {
            "title": "Sales",
            "description": "Cash receipt with attached documents"
          },
          "expense": {
            "title": "Expense",
            "description": "Cash disbursement with attached documents"
          },
          "custom": {
            "title": "Custom entry",
            "description": "Journal entry with attached documents"
          },
          "bills": {
            "title": "Bill",
            "description": "New vendor bill with attached documents"
          },
          "equipment": {
            "title": "PPE",
            "description": "New PPE record with attached documents"
          },
          "attachExisting": {
            "title": "Attach to existing",
            "description": "Add these files to an existing Sales, Expense, entry, Bill, or PPE"
          }
        }
      }
    },
    "qap": {
      "title": "Quarterly Alphalist of Payees",
      "subtitle": "Review expanded withholding tax totals before exporting the 1601EQ file.",
      "year": "Year",
      "quarter": "Quarter",
      "quarterOption": "Q{{quarter}}",
      "refresh": "Refresh",
      "download": "Download QAP ZIP",
      "downloading": "Downloading…",
      "period": "{{from}} – {{to}} · {{count}} payees",
      "tin": "TIN",
      "registeredName": "Registered name",
      "atc": "ATC",
      "grossIncome": "Gross income payment",
      "taxWithheld": "Tax withheld",
      "validationWarning": "Run every DAT file through the official BIR Alphalist Data Entry and Validation Module before submission.",
      "openButton": "Open QAP 1601EQ",
      "loadError": "Unable to load QAP data.",
      "downloadError": "Unable to download QAP."
    },
    "bir2307": {
      "title": "Issue BIR Form 2307",
      "subtitle": "Review the certificate details before downloading the printable form.",
      "printPaperNote": "Print on legal-size paper (8.5 × 14 in, portrait). Use the legal tray—not Letter or A4.",
      "loadErrorTitle": "Unable to load Form 2307 details",
      "loadErrorTitleWithPage": "Unable to load Form 2307 details — missing on {{page}}",
      "missingPageExpense": "Expense",
      "missingPageCompanyProfile": "Company BIR profile",
      "loadError": "Unable to load Form 2307 details.",
      "downloadError": "Unable to download Form 2307.",
      "tryAgain": "Try again",
      "editExpense": "Edit expense",
      "editCompanyProfile": "Edit company BIR profile",
      "back": "Back",
      "exportButtonAriaLabel": "Export Form 2307",
      "exportOptionExcel": "Excel",
      "excelSheetName": "Form 2307",
      "excelColumnField": "Field",
      "excelColumnValue": "Value",
      "monthIncome": "Month {{month}} income payment",
      "monthTax": "Month {{month}} tax withheld",
      "downloading": "Downloading…",
      "payee": "Payee",
      "payeeTin": "Payee TIN",
      "payeeAddress": "Payee address",
      "payor": "Payor",
      "payorTin": "Payor TIN",
      "payorAddress": "Payor address",
      "zipCode": "ZIP code",
      "branchCode": "Branch",
      "notAvailable": "—",
      "periodRange": "{{from}} – {{to}}",
      "period": "Quarter",
      "atc": "ATC",
      "grossIncome": "Gross income payment",
      "taxWithheld": "Tax withheld"
    },
    "birTaxpayerProfile": {
      "title": "Company BIR taxpayer profile",
      "subtitle": "Keep the payor information used on BIR forms up to date.",
      "back": "Back to tax compliance",
      "taxpayerType": "Taxpayer type",
      "individual": "Individual",
      "nonIndividual": "Non-individual",
      "tin": "Taxpayer TIN",
      "rdoCode": "RDO code",
      "lineOfBusiness": "Line of business",
      "taxpayerOrRegisteredName": "Taxpayer or registered name",
      "registeredAddress": "Registered address",
      "zipCode": "ZIP code",
      "telephoneNumber": "Telephone number",
      "emailAddress": "Email address",
      "save": "Save profile",
      "saving": "Saving…",
      "saved": "Company BIR profile saved.",
      "requiredFieldsToast": "Complete all required BIR taxpayer profile fields.",
      "loadErrorTitle": "Unable to load company BIR profile",
      "loadError": "Unable to load company BIR profile.",
      "noCompany": "Select a company before editing its BIR profile.",
      "tryAgain": "Try again"
    },
    "taxCompliance": {
      "TaxComplianceAddTaxTypeModal": {
        "add_tax_type_4": "Add tax type",
        "search_tax_types_1": "Search tax types",
        "search_tax_types_to_add_2": "Search tax types to add",
        "clear_search_3": "Clear search"
      },
      "TaxComplianceCorDetectedModal": {
        "tax_types_match_1": "Tax types match",
        "apply_tax_types_from_cor_2": "Apply tax types from cor",
        "detected_on_cor_5": "Detected on cor"
      },
      "TaxComplianceDashboard": {
        "supporting_documents_attached_4": "Supporting documents attached",
        "loading_tax_calendar_1": "Loading tax calendar",
        "tax_calendar_2": "Tax calendar",
        "refreshing_3": "Refreshing"
      },
      "TaxComplianceDeadlinesCalendar": {
        "today_start_3": "Today start",
        "today_beststart_4": "Today beststart",
        "no_deadlines_on_the_calendar_yet_6": "No deadlines on the calendar yet",
        "previous_month_1": "Previous month",
        "next_month_2": "Next month"
      },
      "TaxComplianceDeadlinesSection": {
        "promise_12": "Promise",
        "sectionSubtitle": "Ignore deadlines to hide them from the default list. Toggle View ignored deadlines to review or restore them. Saved tax types are unchanged—use Change tax types to remove a form from your setup.",
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "filter_deadlines_by_tax_year_2": "Filter deadlines by tax year",
        "search_form_code_e_g_2551q_1601c_1": "Search form code e g 2551q 1601c",
        "filter_deadlines_by_form_code_4": "Filter deadlines by form code",
        "clear_form_code_search_5": "Clear form code search",
        "select_all_deadlines_on_this_page_6": "Select all deadlines on this page",
        "showCompletedButton": "Show completed ({{count}})",
        "hideCompletedButton": "Hide completed",
        "showIgnoredButton": "View ignored deadlines ({{count}})",
        "hideIgnoredButton": "Hide ignored deadlines",
        "ignoreSelectedButton": "Ignore deadlines ({{count}})",
        "restoreSelectedButton": "Restore deadlines ({{count}})",
        "allIgnoredHiddenTitle": "All deadlines in this view are ignored",
        "allIgnoredHiddenHint": "Use View ignored deadlines ({{count}}) above to review ignored filings.",
        "ignoredSingleToast": "Deadline ignored.",
        "ignoredBulkToast": "{{count}} deadlines ignored.",
        "ignoreErrorToast": "Failed to ignore deadlines.",
        "restoredSingleToast": "Deadline restored.",
        "restoredBulkToast": "{{count}} deadlines restored.",
        "restoreErrorToast": "Failed to restore deadlines.",
        "no_overdue_deadlines_15": "No overdue deadlines",
        "no_matching_form_codes_16": "No matching form codes",
        "no_matching_tag_filters_17": "No deadlines match the selected tags",
        "no_matching_tag_filters_hint_18": "Try selecting fewer tag filters or clear the filter to see all deadlines.",
        "clear_tag_filters_19": "Clear tag filters",
        "completeSelectedChecklistBlocked": "Check every filing checklist item on each selected deadline before completing.",
        "submitFormSelectedButton": "Submit form ({{count}})",
        "tax_filing_deadlines_pagination_7": "Tax filing deadlines pagination",
        "deadlines_per_page_8": "Deadlines per page",
        "previous_page_of_deadlines_9": "Previous page of deadlines",
        "deadline_list_pages_10": "Deadline list pages",
        "next_page_of_deadlines_11": "Next page of deadlines"
      },
      "TaxComplianceDeadlinesTable": {
        "no_filing_deadlines_to_show_yet_2": "No filing deadlines to show yet",
        "select_all_visible_deadlines_1": "Select all visible deadlines",
        "tax_form_3": "Tax form",
        "filing_start_date_4": "Filing start date",
        "filing_due_date_5": "Filing due date",
        "due_in_6": "Due in",
        "status_7": "Status",
        "actions_8": "Actions",
        "tags_9": "Tags",
        "completeButton": "Update Status",
        "viewFilesButton": "View files",
        "noFilesButton": "No Files",
        "noFilesAttachedToast": "No files attached",
        "notStartedButton": "Not Started",
        "viewDetailsButton": "View Details"
      },
      "TaxComplianceDeadlinesMobileList": {
        "selectRowAriaLabel": "Select {{formCode}} {{periodLabel}}",
        "duePrefix": "Due"
      },
      "TaxComplianceRemoveDeadlinesModal": {
        "ignoreTitleOne": "Ignore deadline?",
        "ignoreTitleMany": "Ignore deadlines?",
        "ignoreBody": "Selected periods will be hidden from the default list. Saved tax types are unchanged.",
        "ignoreHint": "Turn on View ignored deadlines to review or restore them later.",
        "restoreTitleOne": "Restore deadline?",
        "restoreTitleMany": "Restore deadlines?",
        "restoreBody": "Selected ignored periods will return to the open deadlines list.",
        "cancelButton": "Cancel",
        "ignoringButton": "Ignoring…",
        "ignoreButton": "Ignore deadlines",
        "restoringButton": "Restoring…",
        "restoreButton": "Restore deadlines"
      },
      "TaxComplianceLegacy0619ECleanupModal": {
        "title": "Update 0619E schedules",
        "body": "These 0619E quarter-end months are no longer needed (they are covered by 1601-EQ) and will be deleted from your tax calendar.",
        "deletingButton": "Deleting…",
        "deleteButton": "Delete 0619E schedules",
        "successToast": "0619E quarter-end schedules deleted.",
        "errorToast": "Failed to delete 0619E schedules."
      },
      "TaxComplianceObligationDetailModal": {
        "promise_3": "Promise",
        "loading_preview_5": "Loading preview",
        "close_proof_preview_1": "Close proof preview",
        "filing_start_date_6": "Filing start date",
        "filing_due_date_7": "Filing due date",
        "schedule_8": "Schedule",
        "status_9": "Status",
        "supporting_documents_10": "Supporting documents",
        "no_files_attached_yet_11": "No files attached yet",
        "proofUploadHint": "Optional. PDF, JPEG, or PNG up to 5MB each. You can add multiple files.",
        "uploadButton": "Upload",
        "attachFilesButton": "Attach files",
        "attachingButton": "Attaching…",
        "completeButton": "Submit Form",
        "closeButton": "Close",
        "completionChecklistTitle": "Filing checklist",
        "completionChecklistHint": "Open the filing form to complete each checklist section.",
        "completionChecklistBlockedOnClick": "{{message}}"
      },
      "slsp": {
        "progress": "SLSP: {{filed}} of 2 filed",
        "datTitle": "DAT / ZIP file",
        "datDescription": "Upload the validated Summary List DAT or ZIP file for this quarter.",
        "acknowledgmentTitle": "BIR acknowledgment",
        "acknowledgmentDescription": "Upload the BIR eSubmission acknowledgment (the confirmation email).",
        "markFiledButton": "Mark as Filed",
        "filedButton": "Filed",
        "filesRequiredToast": "Upload the DAT/ZIP file and the BIR acknowledgment before marking this list as filed.",
        "alreadyFiledToast": "This list is already marked as filed.",
        "markedFiledToast": "Marked as filed.",
        "datFileTypeError": "Upload a .dat or .zip file.",
        "acknowledgmentFileTypeError": "Upload a PDF, image, or email file (.pdf, .png, .jpg, .eml, .msg).",
        "fileTooLarge": "File must be 20MB or smaller."
      },
      "obligationTags": {
        "badgePaid": "Paid",
        "badgeUnpaid": "Unpaid",
        "badgeNoAmountDue": "NAD",
        "badgeBirFormUploaded": "BFU",
        "badgeTrrcConfirmed": "TRRC"
      },
      "filingWorkspace": {
        "modalTitle": "Manage Filing Progress",
        "viewFilesModalTitle": "Uploaded files",
        "viewFilesEmpty": "No files have been uploaded for this deadline yet.",
        "sharedBusinessPermitLabel": "Mayor's Permit / Business Permit",
        "dueDateLabel": "Due date",
        "savingHint": "Saving…",
        "closeButton": "Close",
        "birFormsTitle": "BIR forms",
        "birFormsDescription": "Upload your filed BIR forms or mark complete if already submitted elsewhere.",
        "trrcTitle": "Tax return receipt (TRRC)",
        "trrcDescription": "Upload your TRRC or confirm receipt without uploading.",
        "skipUploadLabel": "Skip upload (mark complete without file)",
        "uploadButton": "Upload files",
        "uploadingButton": "Uploading…",
        "viewFileButton": "View",
        "archiveFileButton": "Archive",
        "archiveConfirmTitle": "Archive file",
        "archiveConfirmBody": "Archive {{filename}}? It leaves this filing's file list. The stored file is kept.",
        "archiveCancelButton": "Cancel",
        "archiveConfirmButton": "Archive",
        "archivingButton": "Archiving…",
        "archivedToast": "File archived.",
        "showArchivedFilesButton": "Archived files",
        "hideArchivedFilesButton": "Hide archived files",
        "archivedFilesEmpty": "No archived files for this filing.",
        "restoreFileButton": "Restore",
        "restoringButton": "Restoring…",
        "restoredToast": "File restored.",
        "paymentTitle": "Payment",
        "paymentDescription": "Choose Unpaid until payment is settled, then select Paid or No Amount Due (NAD). You can upload proof of payment or skip upload.",
        "paymentSkipUploadLabel": "Skip upload (no proof of payment file)",
        "paymentStatusLabel": "Payment status",
        "paymentStatusUnpaid": "Unpaid",
        "sectionCompleteAria": "Section complete",
        "paymentStatusPaid": "Paid",
        "paymentStatusNad": "No Amount Due (NAD)",
        "openFilingFormButton": "Open filing form"
      },
      "downloadFilingPdf": {
        "button": "Download all as PDF",
        "downloadingButton": "Downloading…",
        "downloadingToast": "Preparing PDF…",
        "noFilesTitle": "This filing has no files to download.",
        "skippedToast": "Skipped files that could not be added to the PDF: {{files}}"
      },
      "TaxComplianceDeadlineTagFilterDropdown": {
        "filterPlaceholder": "Filter",
        "filterPlaceholderActive": "Filter ({{count}})",
        "filterDropdownAria": "Filter deadlines by tags",
        "filterBirFormsUploaded": "BIR FORMS UPLOADED",
        "filterPaid": "PAID",
        "filterUnpaid": "UNPAID",
        "filterNoAmountDue": "NO AMOUNT DUE",
        "filterTrrcConfirmed": "TAX RETURN RECEIPT CONFIRM"
      },
      "TaxComplianceDeadlineTagDropdowns": {
        "statusPlaceholder": "Status",
        "statusDropdownAria": "Apply payment status tag to selected deadlines",
        "statusPaid": "Paid",
        "statusUnpaid": "Unpaid",
        "statusNoAmountDue": "No Amount Due",
        "documentsPlaceholder": "Documents",
        "documentsDropdownAria": "Apply document tags to selected deadlines",
        "documentBirFormUploaded": "BIR Form Uploaded",
        "documentTrrcConfirmed": "Tax Return Receipt Confirmed",
        "selectRowsHint": "Select one or more deadlines first"
      },
      "TaxComplianceFilingCompletionChecklist": {
        "bir_form_uploaded": "BIR forms attached (optional upload recommended)",
        "payment_settled": "Payment status is Paid or No Amount Due (proof of payment optional when Paid)",
        "trrc_confirmed": "Tax return receipt confirmed — TRRC (optional upload recommended)"
      },
      "obligationFilingCompletion": {
        "submitBlockedNoneMessage": "Check at least one filing checklist item before submitting.",
        "submitBlockedNoneModalMessage": "Check at least one filing checklist item on the deadlines list before submitting.",
        "submitBlockedBulkMessage": "{{blocked}} of {{total}} selected deadlines have no checklist items checked. Use Status and Documents on each row.",
        "submitBlockedModalBulkMessage": "{{blocked}} of {{total}} selected have no checklist items checked.",
        "uploadTagsRequiredMessage": "Check at least one filing checklist item on the deadlines list before uploading proof.",
        "freshTagsRequiredMessage": "Check a new filing checklist item on the deadlines list before uploading or submitting. Tags from your last submission do not count.",
        "filingWindowNotStartedMessage": "This filing period has not started yet. You can update status once the filing window opens.",
        "submittedCompleteSingle": "Form submitted and marked as completed.",
        "submittedIncompleteSingle": "Form submitted. Status is incomplete until all checklist items are checked.",
        "submittedCompleteBulk": "{{count}} deadlines marked as completed.",
        "submittedIncompleteBulk": "{{count}} deadlines submitted with incomplete status.",
        "submittedMixedBulk": "{{complete}} completed and {{incomplete}} submitted as incomplete."
      },
      "obligationTagToasts": {
        "paymentTagApplied": "{{tagLabel}} tag applied.",
        "paymentTagAppliedBulk": "{{tagLabel}} tag applied to {{count}} deadlines.",
        "documentTagChecked": "{{tagLabel}} checked.",
        "documentTagCheckedBulk": "{{tagLabel}} checked on {{count}} deadlines.",
        "documentTagUnchecked": "{{tagLabel}} unchecked.",
        "documentTagUncheckedBulk": "{{tagLabel}} unchecked on {{count}} deadlines."
      },
      "obligationStatus": {
        "incomplete": "Incomplete",
        "ignored": "Ignored",
        "filedPaid": "Completed & Paid",
        "filed": "Completed",
        "overdue": "Overdue",
        "started": "Started",
        "upcoming": "Upcoming"
      },
      "TaxComplianceQuickInsights": {
        "quick_insights_1": "Quick insights",
        "compliance_score_2": "Compliance score",
        "next_urgent_deadline_3": "Next urgent deadline",
        "completedOfTotal": "{{completed}} of {{total}} completed",
        "pendingActions": "{{count}} pending actions",
        "ignoredActions": "{{count}} ignored"
      },
      "TaxComplianceSetupCard": {
        "reading_cor_2": "Reading cor",
        "reading_cor_7": "Reading cor",
        "void_promise_8": "Void promise",
        "saved_tax_types_9": "Saved tax types",
        "loading_preview_10": "Loading preview",
        "close_cor_preview_3": "Close cor preview",
        "tax_types_11": "Tax types",
        "tax_types_12": "Tax types",
        "replace_certificate_of_registration_4": "Replace certificate of registration",
        "replace_14": "Replace",
        "reevaluate_15": "Reevaluate",
        "or_17": "Or",
        "remove_18": "Remove",
        "remove_certificate_of_registration_5": "Remove certificate of registration",
        "generate_schedule_6": "Generate schedule",
        "select_date_1": "Select date",
        "aiExtractionFailedWarning": "We couldn't read this COR automatically. It was uploaded — please fill in the details manually.",
        "noPreview": "No preview available.",
        "downloadFileAria": "Download {{filename}}"
      },
      "formatDaysUntilDue": {
        "daysLeft": "{{count}} days left",
        "oneDayLeft": "1 day left",
        "dueToday": "Due today",
        "oneDayOverdue": "1 day overdue",
        "daysOverdue": "{{count}} days overdue"
      },
      "corApplySuccess": {
        "updatedBoth": "Updated saved tax types ({{addedCount}} added, {{removedCount}} removed).",
        "addedOne": "1 tax type added.",
        "addedMany": "{{count}} tax types added.",
        "removedOne": "1 tax type removed.",
        "removedMany": "{{count}} tax types removed.",
        "savedFromCor": "Saved tax types from COR."
      }
    },
    "portal": {
      "title": "Employee Portal",
      "subtitle": "Your self-service view — leave, attendance, payslips, and profile.",
      "leaveTitle": "My Leave",
      "payslipsTitle": "My Payslips",
      "profileTitle": "My Profile",
      "attendanceTitle": "My Attendance",
      "backToPortal": "Back to portal",
      "openAttendanceButton": "Attendance",
      "clockedInStatus": "Clocked In",
      "clockedOutStatus": "Clocked Out",
      "clockedInElapsedAria": "Elapsed time since clock-in: {{elapsed}}",
      "emptyValue": "—",
      "cards": {
        "leave": {
          "title": "Leave",
          "description": "Request time off and view your leave balances and requests."
        },
        "attendance": {
          "title": "Attendance",
          "description": "Clock in/out and view your recent clock events."
        },
        "payslips": {
          "title": "Payslips",
          "description": "View your pay periods, gross pay, and net pay."
        },
        "profile": {
          "title": "Profile",
          "description": "View your employee profile and contact details."
        }
      },
      "profile": {
        "identityTitle": "Your details",
        "jobTitle": "Job",
        "contactTitle": "Contact",
        "emergencyTitle": "Emergency contact",
        "fullName": "Full name",
        "employmentType": "Employment type",
        "emergencyContactName": "Emergency contact name",
        "emergencyContactPhone": "Emergency contact phone",
        "emergencyContactRelationship": "Relationship"
      }
    },
    "hris": {
      "attendance": {
        "clockingInToast": "Clocking in…",
        "clockedInToast": "Clocked in.",
        "clockingOutToast": "Clocking out…",
        "clockedOutToast": "Clocked out.",
        "reviewSavedToast": "Timesheet review saved.",
        "holidaySavedToast": "Holiday saved.",
        "scheduleSavedToast": "Work schedule saved.",
        "title": "Attendance",
        "filterEmployee": "Filter by employee",
        "allEmployees": "All employees",
        "clockInButton": "Clock in",
        "clockOutButton": "Clock out",
        "columns": {
          "employee": "Employee",
          "type": "Type",
          "time": "Time",
          "workDate": "Work date",
          "scheduled": "Scheduled",
          "hours": "Hours",
          "firstIn": "First In",
          "lastOut": "Last Out",
          "actual": "Actual",
          "status": "Status",
          "name": "Name",
          "date": "Date",
          "shift": "Shift"
        },
        "sections": {
          "clock": "Clock events",
          "timesheets": "Timesheets",
          "holidays": "Holidays",
          "schedules": "Work schedules"
        },
        "addHolidayButton": "Add holiday",
        "addScheduleButton": "Add schedule",
        "holidayNameRequiredToast": "Enter a holiday name.",
        "scheduleNameRequiredToast": "Enter a schedule name.",
        "scheduleStart": "Start time",
        "scheduleEnd": "End time",
        "scheduleBreakMinutes": "Break (minutes)"
      },
      "common": {
        "backToHris": "Back to HRIS",
        "backToEmployees": "Back to Employees",
        "actions": "Actions",
        "approve": "Approve",
        "reject": "Reject",
        "save": "Save",
        "edit": "Edit",
        "tryAgain": "Try again",
        "selectPlaceholder": "Select…",
        "saving": "Saving…",
        "download": "Download",
        "delete": "Delete",
        "search": "Search",
        "view": "View",
        "editDraft": "Edit Draft",
        "cancel": "Cancel",
        "submit": "Submit",
        "create": "Create"
      },
      "validation": {
        "required": "This field is required.",
        "invalidEmail": "Enter a valid email address.",
        "maxLength": "Must be at most {{max}} characters.",
        "invalidNumber": "Enter a valid number.",
        "numberMin": "Must be at least {{min}}.",
        "numberMax": "Must be at most {{max}}.",
        "probationaryPeriodMax": "Probationary period cannot exceed {{max}} months.",
        "invalidDateRange": "End date must be on or after the start date.",
        "invalidTime": "Enter a valid time (HH:mm).",
        "selectRequired": "Select an option.",
        "fileTooLarge": "File must be {{maxMb}} MB or smaller."
      },
      "placeholders": {
        "employeeNumber": "e.g. EMP-001",
        "firstName": "First name",
        "middleName": "Middle name",
        "lastName": "Last name",
        "email": "name@example.com",
        "phone": "09xx xxx xxxx",
        "placeOfBirth": "e.g. Manila, Philippines",
        "nationality": "e.g. Filipino",
        "maidenName": "e.g. Dela Cruz",
        "address": "Unit/House No., Street, Barangay, City, Province",
        "emergencyContactName": "Full name",
        "relationship": "e.g. Spouse, Parent",
        "numericMonths": "e.g. 6",
        "weeklyHours": "e.g. 40",
        "projectDetails": "Describe the project scope and fulfillment conditions",
        "benefitType": "Select benefit",
        "benefitDescription": "Coverage, vesting, subsidy, or other benefit details",
        "allowanceLabel": "Allowance label",
        "allowanceAmount": "Amount",
        "tin": "000-000-000-00000",
        "govId": "ID or membership number",
        "monthlyBasic": "e.g. 25,000.00",
        "holidayName": "Holiday name",
        "scheduleName": "Schedule name",
        "employerId": "Employer registration number",
        "leaveReason": "Optional reason for leave",
        "payrollNotes": "Optional notes for this payroll run"
      },
      "employees": {
        "detail": {
          "savingToast": "Saving employee…",
          "savedToast": "Employee saved.",
          "noDataToast": "No employee data to save.",
          "unlinkingToast": "Unlinking AbraFi login…",
          "unlinkedToast": "AbraFi login unlinked.",
          "unlinkingAndRemovingToast": "Unlinking and removing company access…",
          "unlinkedAndRemovedToast": "AbraFi login unlinked and company access removed.",
          "unlinkFailedToast": "Could not unlink AbraFi login.",
          "linkingToast": "Linking AbraFi login…",
          "linkedToast": "AbraFi login linked.",
          "linkFailedToast": "Could not link AbraFi login.",
          "separatingToast": "Separating employee…",
          "separatedToast": "Employee separated.",
          "reactivatingToast": "Reactivating employee…",
          "reactivatedToast": "Employee reactivated.",
          "backButton": "Back to employees",
          "title": "Employee",
          "tabs": {
            "profile": "Profile",
            "documents": "201 file",
            "events": "Employment history"
          },
          "profileSection": "Employee profile",
          "reportingLineLegacyWarning": "The recorded approver no longer meets the department and ranking rules. Pick a different approver or update the department or job title.",
          "noBenefits": "No benefits recorded."
        },
        "create": {
          "nameRequiredToast": "First and last name are required.",
          "savingToast": "Creating employee…",
          "savedToast": "Employee created.",
          "saveDraft": "Save as draft",
          "draftSavedToast": "Draft saved.",
          "editDraftTitle": "Edit draft",
          "employeeNumberRequiredToast": "Employee number is required.",
          "useSuggestedEmployeeNumber": "Use {{value}}",
          "title": "Add employee",
          "subtitle": "Create a new employee record with employment details and optional 201-file documents.",
          "removePendingDocument": "Remove",
          "sameAsCurrentAddress": "Same as current address",
          "targetRegularizationDateHint": "Auto-calculated: hire date + 6 months (adjustable)",
          "contractEndDateHint": "Auto-calculated: hire date + contract length",
          "endDateHint": "Not required for project-based employees",
          "addAllowance": "+ Add Allowance",
          "allowancesEmpty": "No allowances added yet.",
          "addBenefit": "+ Add Benefit",
          "benefitsEmpty": "No benefits added yet.",
          "benefitRowIncomplete": "Select a benefit and enter a description for each row, or remove the row.",
          "addJobTitleOption": "+ Add new job title…",
          "addJobTitleTitle": "Add job title",
          "jobTitleNameRequiredToast": "Enter a job title name.",
          "jobTitleDepartmentRequiredToast": "Select a department.",
          "jobTitleSavingToast": "Saving job title…",
          "jobTitleSavedToast": "Job title saved.",
          "addDepartmentOption": "+ Add new department…",
          "addDepartmentTitle": "Add department",
          "departmentNameRequiredToast": "Enter a department name.",
          "departmentSavingToast": "Saving department…",
          "departmentSavedToast": "Department saved.",
          "sections": {
            "personalInformation": "1. Personal Information",
            "employmentDetails": "2. Employment & Organizational Details",
            "compensationBenefits": "3. Compensation & Benefits",
            "accountsLinking": "4. Accounts & Linking"
          },
          "groups": {
            "basicIdentity": "Basic Identity",
            "contactDetails": "Contact Details",
            "addressDetails": "Address Details",
            "emergencyContact": "Emergency Contact",
            "organizationalAssignment": "Organizational Assignment",
            "employmentStatusTimeline": "Employment Status & Timeline",
            "statusSpecificRules": "Status-Specific Rules",
            "basicSalary": "Basic Salary",
            "governmentIds": "Government IDs",
            "allowancesPerks": "Allowances & Perks"
          },
          "jobTitleDuplicateToast": "A job title with this name already exists in the selected department.",
          "departmentDuplicateToast": "A department with this name already exists.",
          "createDepartmentFirstHint": "Create a department first in Role Manager."
        },
        "documents": {
          "uploadingToast": "Uploading document…",
          "uploadedToast": "Document uploaded.",
          "deletingToast": "Deleting document…",
          "deletedToast": "Document deleted.",
          "deleteConfirmTitle": "Delete document?",
          "deleteConfirmMessage": "Delete {{filename}}? This cannot be undone.",
          "deleteConfirmButton": "Delete",
          "deletingButton": "Deleting…",
          "title": "201-file documents",
          "uploadButton": "Upload document",
          "empty": "No documents uploaded yet.",
          "requiredHint": "Provide the following 201-file documents. All fields are optional. You may also skip and provide them later.",
          "requiredDocumentsMissing": "Upload a file for the required documents: {{documents}}.",
          "optionalDocumentNeedsFile": "Every added document needs a file — attach one or remove the row.",
          "selectTypeBeforeSave": "Select a document type for every attached file before saving.",
          "uploadFailedToast": "Documents failed to upload. The employee record was not created — please retry.",
          "uploadFailedWarningTitle": "Documents failed to upload",
          "uploadFailedWarningBody": "The employee record was not created. Check the files below and click Save again to retry.",
          "noFileSelected": "No file selected",
          "chooseFile": "Choose file",
          "selectType": "Select document type",
          "addButton": "Add document",
          "removeFile": "Remove file",
          "removeRow": "Remove document",
          "required": {
            "sss": {
              "title": "SSS",
              "subtitle": "Social Security System"
            },
            "phic": {
              "title": "PHIC",
              "subtitle": "PhilHealth"
            },
            "hdmf": {
              "title": "HDMF",
              "subtitle": "Pag-IBIG Fund"
            },
            "tin": {
              "title": "TIN",
              "subtitle": "Tax Identification Number"
            },
            "signedJo": {
              "title": "Signed JO",
              "subtitle": "Signed job offer / employment contract"
            }
          },
          "columns": {
            "type": "Document type",
            "file": "File",
            "uploaded": "Uploaded"
          },
          "types": {
            "employment_contract": "Employment contract",
            "nbi_clearance": "NBI clearance",
            "medical": "Medical certificate",
            "sss_id": "SSS ID",
            "phic": "PhilHealth (PHIC)",
            "hdmf": "Pag-IBIG (HDMF)",
            "tin": "TIN",
            "bir_2316": "BIR Form 2316",
            "tor": "Transcript of records",
            "resume": "Resume / CV",
            "police_clearance": "Police Clearance",
            "barangay_clearance": "Barangay Clearance",
            "signed_jo": "Signed JO / Employment Contract",
            "other": "Other"
          }
        },
        "fields": {
          "employeeNumber": "Employee number",
          "firstName": "First name",
          "middleName": "Middle name",
          "lastName": "Last name",
          "suffix": "Suffix (Optional)",
          "gender": "Gender (Sex Assigned at Birth)",
          "birthDate": "Date of birth",
          "placeOfBirth": "Place of birth",
          "nationality": "Nationality / Citizenship",
          "civilStatus": "Civil status",
          "maidenName": "Maiden name (if applicable)",
          "addressLine1": "Current / Residential address",
          "permanentAddress": "Permanent address",
          "emergencyContactName": "Emergency contact person",
          "emergencyContactRelationship": "Relationship to employee",
          "emergencyContactPhone": "Emergency contact number",
          "emergencyContactAddress": "Primary address",
          "directReportingLine": "Direct reporting line / Approver",
          "employeeStatus": "Employee status",
          "targetRegularizationDate": "Target regularization date",
          "probationaryPeriodMonths": "Probationary period (months)",
          "contractDurationMonths": "Contract length (months)",
          "contractEndDate": "End date",
          "projectDetails": "Description",
          "weeklyHours": "Weekly hours",
          "monetaryAllowances": "Monetary allowances",
          "otherBenefits": "Other benefits",
          "email": "Email address",
          "phone": "Contact number",
          "tin": "TIN",
          "sssNumber": "SSS number",
          "philhealthNumber": "PhilHealth number",
          "pagibigNumber": "Pag-IBIG number",
          "department": "Department",
          "jobTitle": "Job title",
          "ranking": "Job ranking",
          "rankingMissingHint": "No job ranking set. Assign one so reporting lines can be resolved.",
          "hireDate": "Hire date",
          "separationDate": "Separation date",
          "employmentCategory": "Employment category",
          "employmentStatus": "Employment status",
          "benefitType": "Benefit type",
          "benefitDescription": "Description",
          "removeBenefit": "Remove benefit",
          "allowanceType": "Allowance type",
          "allowanceAmount": "Amount",
          "monthlyBasic": "Monthly basic pay (PHP)",
          "linkedAbrafiLogin": "Linked AbraFi login",
          "linkedAbrafiLoginHint": "Enter an email to link an existing AbraFi user, or invite a new one with permissions so they can use My HR (clock in, leave, payslips). Existing accounts link immediately — manage permissions anytime after.",
          "linkedAbrafiLoginRecordHint": "We’ll send the invite link to them automatically here so they can gain access after you save the employee form.",
          "linkedAbrafiLoginDraftHint": "Finalize this draft employee before linking an AbraFi login.",
          "employeeNumberEditableHint": "Editable until {{date}} (once). After you change it or the window ends, it becomes read-only again."
        },
        "suffixOptions": {
          "jr": "Jr.",
          "sr": "Sr.",
          "ii": "II",
          "iii": "III",
          "iv": "IV",
          "v": "V"
        },
        "benefitTypes": {
          "hmo": "HMO",
          "health_insurance": "Health insurance",
          "life_insurance": "Life insurance",
          "car_plan": "Car plan",
          "retirement_plan": "Retirement plan",
          "housing_loan": "Housing loan",
          "education_support": "Education support",
          "gym_membership": "Gym membership",
          "meal_subsidy": "Meal subsidy",
          "fuel_subsidy": "Fuel subsidy",
          "communication_subsidy": "Communication subsidy",
          "equipment": "Equipment",
          "stock_options": "Stock options",
          "other": "Other benefit"
        },
        "genderOptions": {
          "male": "Male",
          "female": "Female"
        },
        "civilStatusOptions": {
          "single": "Single",
          "married": "Married",
          "widowed": "Widowed",
          "separated": "Separated",
          "solo_parent": "Solo Parent"
        },
        "employeeStatusOptions": {
          "probationary": "Probationary",
          "regular": "Regular",
          "project_based": "Project Based",
          "seasonal": "Seasonal",
          "casual": "Casual",
          "contractual": "Contractual",
          "part_time": "Part-time"
        },
        "separateButton": "Separate",
        "reactivateButton": "Reactivate",
        "separateConfirmTitle": "Separate this employee?",
        "separateConfirmMessage": "Separating this employee sets their status to Separated. If they are reactivated later, you will choose a new hire (rehire) date. Are you sure?",
        "separateConfirmButton": "Separate employee",
        "separatingButton": "Separating…",
        "reactivateConfirmTitle": "Reactivate this employee?",
        "reactivateConfirmMessage": "Reactivating sets status to Active and unlocks the employee number for 7 days (change once). Choose the hire (rehire) date below.",
        "reactivateHireDateLabel": "Hire date (rehire)",
        "reactivateHireDateRequiredToast": "Choose a hire date to reactivate this employee.",
        "reactivateConfirmButton": "Reactivate employee",
        "reactivatingButton": "Reactivating…",
        "statusSeparatedReadonly": "Separated",
        "linkedAbrafiUser": "Linked to {{email}}",
        "linkedAbrafiAccessRemoved": "Account no longer has company access",
        "linkedAbrafiAccessRemovedNote": "This login was removed from Company Users, so the employee link is being reset. Link a login below if they need access again.",
        "linkedAbrafiPendingBadge": "Pending invite",
        "linkedAbrafiPendingInviteValue": "Pending invitation",
        "linkedAbrafiPendingNote": "This AbraFi account is linked to the employee, but they still need to accept the company invitation before they can use My HR.",
        "linkedAbrafiPendingInviteNote": "An invitation is pending for {{email}}. The employee will be linked to that AbraFi login automatically once they accept the invite and sign in.",
        "unlinkAbrafiLogin": "Unlink",
        "unlinkConfirmTitle": "Unlink AbraFi login?",
        "unlinkConfirmThisAccount": "this account",
        "unlinkConfirmLead": "Unlink {{email}} from this employee record?",
        "unlinkConfirmNote": "This only removes the employee ↔ login link. Their company access and permissions stay unless you also remove access.",
        "unlinkConfirmOwnerNote": "This login is the company owner, so company access cannot be removed from here.",
        "unlinkConfirmCancel": "Cancel",
        "unlinkConfirmJustUnlink": "No, just unlink",
        "unlinkConfirmRemoveAccess": "Yes, remove access too",
        "linkedAbrafiEmailPlaceholder": "user@example.com",
        "addAbrafiUserByEmail": "Add or change AbraFi user by email",
        "manageAbrafiPermissions": "Manage permissions",
        "manageAbrafiPermissionsUnavailable": "This linked login is not available in company users yet. Refresh and try again.",
        "abrafiAccountAlreadyRegistered": "This AbraFi account is already registered. Linked to this employee — manage permissions anytime.",
        "linkAbrafiUserSave": "Link & save permissions",
        "linkMyLoginButton": "Link my login",
        "employmentCategory": {
          "probationary": "Probationary",
          "regular": "Regular",
          "project_based": "Project-based",
          "seasonal": "Seasonal",
          "casual": "Casual",
          "contractual": "Contractual",
          "part_time": "Part-time",
          "fixed_term": "Fixed term",
          "intern": "Intern"
        },
        "events": {
          "title": "Employment history",
          "empty": "No employment events recorded yet.",
          "columns": {
            "date": "Date",
            "change": "Change",
            "changedBy": "Changed by"
          },
          "hiredChange": "Hired",
          "documentDownloaded": "Downloaded 201 file: {{type}} ({{filename}})",
          "documentDeleted": "Deleted 201 file: {{type}} ({{filename}})",
          "changeSummary": "{{field}}: {{from}} → {{to}}",
          "emptyValue": "—",
          "unknownField": "Field"
        },
        "title": "Employees",
        "subtitle": "Manage employee records, 201-file documents, and employment details.",
        "addButton": "Add employee",
        "roleManagerButton": "Role Manager",
        "searchPlaceholder": "Search by name or employee number",
        "includeInactive": "Include inactive employees",
        "filterDepartment": "Department",
        "filterJobTitle": "Job title",
        "allDepartments": "All departments",
        "allJobTitles": "All job titles",
        "empty": "No employees found.",
        "listCount_one": "{{count}} employee",
        "listCount_other": "{{count}} employees",
        "employmentStatuses": {
          "active": "Active",
          "on_leave": "On leave",
          "separated": "Separated",
          "draft": "Draft"
        },
        "columns": {
          "number": "No.",
          "name": "Name",
          "department": "Department",
          "jobTitle": "Job title",
          "ranking": "Job ranking",
          "status": "Status",
          "hireDate": "Hire date"
        }
      },
      "roleManager": {
        "title": "Role Manager",
        "subtitle": "Manage job titles, departments, and role responsibilities.",
        "backButton": "Back to Employees",
        "addJobTitleButton": "Add Job Title",
        "addDepartmentButton": "Add Department",
        "tabs": {
          "jobTitles": "Job Titles",
          "departments": "Departments"
        },
        "searchJobTitlePlaceholder": "Search by job title…",
        "searchDepartmentPlaceholder": "Search by department…",
        "departmentFilter": "Department",
        "allDepartments": "All departments",
        "statusFilter": "Status",
        "statusAll": "All",
        "statusActive": "Active",
        "statusInactive": "Inactive",
        "jobTitlesEmpty": "No job titles found.",
        "departmentsEmpty": "No departments found.",
        "columns": {
          "jobTitle": "Job Title",
          "department": "Department",
          "scopeOfWork": "Scope of Work",
          "employees": "Employees",
          "status": "Status",
          "actions": "Actions",
          "description": "Description",
          "jobTitles": "Job Titles"
        },
        "editButton": "Edit",
        "deactivateButton": "Deactivate",
        "employeeCountLabel": "{{count}} Employees",
        "jobTitleCountLabel": "{{count}} Job Titles",
        "addDepartmentTitle": "Add department",
        "editDepartmentTitle": "Edit department",
        "addJobTitleTitle": "Add job title",
        "editJobTitleTitle": "Edit job title",
        "fields": {
          "name": "Name",
          "code": "Code",
          "description": "Description",
          "jobTitle": "Job title",
          "department": "Department",
          "scopeOfWork": "Scope of work"
        },
        "rankingOptions": {
          "managerialEmployees": "Managerial Employees",
          "managerialStaff": "Managerial Staff",
          "supervisoryEmployees": "Supervisory Employees",
          "rankAndFileEmployees": "Rank-and-File Employees"
        },
        "departmentNameRequiredToast": "Enter a department name.",
        "jobTitleNameRequiredToast": "Enter a job title name.",
        "jobTitleDepartmentRequiredToast": "Select a department.",
        "departmentSavingToast": "Saving department…",
        "departmentSavedToast": "Department saved.",
        "departmentDeactivatingToast": "Deactivating department…",
        "departmentDeactivatedToast": "Department deactivated.",
        "departmentActivatingToast": "Activating department…",
        "departmentActivatedToast": "Department activated.",
        "jobTitleSavingToast": "Saving job title…",
        "jobTitleSavedToast": "Job title saved.",
        "jobTitleDeactivatingToast": "Deactivating job title…",
        "jobTitleDeactivatedToast": "Job title deactivated.",
        "jobTitleActivatingToast": "Activating job title…",
        "jobTitleActivatedToast": "Job title activated.",
        "activateButton": "Activate",
        "cannotDeactivateDepartmentOccupiedTooltip": "Cannot Deactivate: This Department is currently assigned to active employees",
        "cannotDeactivateDepartmentOccupiedToast": "Cannot Deactivate: Please remove all assigned employees from this Department first",
        "cannotDeactivateJobTitleOccupiedTooltip": "Cannot Deactivate: This Job Title is currently assigned to active employees",
        "cannotDeactivateJobTitleOccupiedToast": "Cannot Deactivate: Please remove all assigned employees from this Job Title first"
      },
      "index": {
        "title": "HRIS",
        "subtitle": "People operations for your company — employees, attendance, leave, payroll, and reports.",
        "selfServiceButton": "My HR",
        "stats": {
          "activeEmployees": "Active employees",
          "pendingTimesheets": "Pending timesheets",
          "pendingLeave": "Pending leave requests",
          "payrollRuns": "Recent payroll runs"
        },
        "cards": {
          "employees": {
            "title": "Employees",
            "description": "Employee master list, profiles, and 201-file documents."
          },
          "attendance": {
            "title": "Attendance",
            "description": "Clock in/out, timesheets, holidays, and work schedules."
          },
          "leave": {
            "title": "Leave",
            "description": "Leave balances, requests, and approvals."
          },
          "payroll": {
            "title": "Payroll",
            "description": "Payroll runs, payslips, and PH statutory deductions."
          },
          "reports": {
            "title": "Reports",
            "description": "Headcount, attendance summary, leave summary, and payroll register."
          },
          "settings": {
            "title": "HR settings",
            "description": "Employer registration numbers and pay schedule defaults."
          },
          "selfService": {
            "title": "My HR",
            "description": "View your profile, clock events, leave, and payslips."
          }
        }
      },
      "leave": {
        "requestSavedToast": "Leave request saved.",
        "reviewSavedToast": "Leave review saved.",
        "title": "Leave Management",
        "subtitle": "Track leave requests and remaining balances.",
        "newRequestButton": "New leave request",
        "filterEmployee": "Filter by employee",
        "filterLeaveType": "Leave type",
        "filterStatus": "Status",
        "searchPlaceholder": "Search by employee or date range…",
        "allLeaveTypes": "All leave types",
        "allStatuses": "All statuses",
        "sections": {
          "overview": "Overview",
          "requests": "Leave requests"
        },
        "overviewTitle": "Leave balance overview",
        "overviewEmpty": "No leave balances to show yet.",
        "balancesTitle": "Leave balances",
        "balanceDaysUnit": "days remaining",
        "remainingTooltip": "Remaining = total credits minus used and pending days.",
        "pendingTooltip": "Days applied in leave requests that are still pending approval.",
        "usedTooltip": "Days from approved paid leave requests only.",
        "totalCreditsTooltip": "Annual paid leave credits (10). Does not change when leave is approved.",
        "unknownType": "Leave",
        "requestsTitle": "Leave requests",
        "summaryTitle": "Leave summary",
        "summaryApproved": "Total approved",
        "summaryPending": "Total pending",
        "summaryRejected": "Total rejected",
        "statusOptions": {
          "pending": "Pending",
          "approved": "Approved",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "cancelSavedToast": "Leave request cancelled.",
        "approveConfirmTitle": "Approve leave request?",
        "approveConfirmMessage": "Approve the leave request for {{name}}? This will count against their used leave credits.",
        "rejectConfirmTitle": "Reject leave request?",
        "rejectConfirmMessage": "Reject the leave request for {{name}}? They will keep their remaining credits.",
        "cancelConfirmTitle": "Cancel leave request?",
        "cancelConfirmMessage": "Cancel the leave request for {{name}}? This cannot be undone from this screen.",
        "cancelRequestConfirmButton": "Cancel request",
        "columns": {
          "employee": "Employee",
          "type": "Leave type",
          "dates": "Dates",
          "days": "Days",
          "status": "Status",
          "totalCredits": "Total credits",
          "pending": "Pending",
          "used": "Used",
          "remaining": "Remaining"
        },
        "leaveTypeRequiredToast": "Select a leave type.",
        "selfEmployeeOption": "My record (self-service)",
        "startDate": "Start date",
        "endDate": "End date",
        "reason": "Reason (optional)"
      },
      "me": {
        "title": "My HR",
        "requestLeaveButton": "Request leave",
        "recentClockEvents": "Recent clock events",
        "leaveBalancesTitle": "Leave balances",
        "leaveBalancesEmpty": "No leave balances yet for this year.",
        "leavePoolTitle": "Annual leave credits",
        "leavePoolUsed": "{{used}} used · {{pending}} pending · {{entitled}} total",
        "leaveRequestsTitle": "My leave requests",
        "payslipsTitle": "My payslips",
        "notLinked": {
          "title": "Set up My HR",
          "whatIsThis": "My HR is the employee self-service view — clock in and out, request leave, and view your payslips. It shows data for one employee record in this company.",
          "whyEmpty": "Nothing appears here because your AbraFi login is not linked to an employee record yet. Company owner or HR admin access alone does not create that link automatically.",
          "ownerStepsTitle": "As company owner or HR admin, you can set this up:",
          "ownerStep1": "Open Employees and add yourself (or open your existing employee profile).",
          "ownerStep2": "On that profile, set Linked AbraFi login to your account (or choose Link my login).",
          "ownerStep3": "Save the employee profile, then return to My HR.",
          "ownerNote": "After linking, this page shows your clock events, leave balances, requests, and payslips — the same view your team members use for themselves.",
          "goToEmployeesButton": "Go to Employees",
          "memberMessage": "Ask your company owner or HR administrator to add you as an employee and link your AbraFi login on that employee profile. Once linked, you can use My HR without admin permissions."
        },
        "loadError": "Could not load My HR. Check your connection and try again."
      },
      "payroll": {
        "columns": {
          "period": "Period",
          "gross": "Gross pay",
          "net": "Net pay",
          "status": "Status",
          "employee": "Employee",
          "deductions": "Deductions",
          "employees": "Employees",
          "netPay": "Total net pay"
        },
        "runCreatedToast": "Payroll run created.",
        "computingToast": "Computing payroll…",
        "computedToast": "Payroll computed.",
        "finalizingToast": "Finalizing payroll…",
        "finalizedToast": "Payroll finalized.",
        "title": "Payroll",
        "newRunButton": "New payroll run",
        "runsTitle": "Payroll runs",
        "detailTitle": "Payroll run details",
        "backToPayroll": "Back to payroll",
        "runNotFound": "Payroll run not found.",
        "emptyLines": "No employee lines yet. Use Compute to generate payroll for this run.",
        "computeButton": "Compute",
        "finalizeButton": "Finalize",
        "periodStart": "Period start",
        "periodEnd": "Period end",
        "payDate": "Pay date",
        "notes": "Notes (optional)"
      },
      "reports": {
        "title": "HR reports",
        "headcountTitle": "Headcount summary",
        "activeEmployees": "Active employees",
        "separatedEmployees": "Separated employees",
        "department": "Department",
        "jobTitle": "Job title",
        "count": "Count",
        "pendingTimesheets": "Pending timesheets",
        "pendingLeave": "Pending leave",
        "payrollRegisterTitle": "Payroll register"
      },
      "settings": {
        "savingToast": "Saving HR settings…",
        "savedToast": "HR settings saved.",
        "noDataToast": "No settings loaded yet.",
        "title": "HR settings",
        "employerSection": "Employer registration",
        "fields": {
          "employerTin": "Employer TIN",
          "employerSssNumber": "Employer SSS number",
          "employerPhilhealthNumber": "Employer PhilHealth number",
          "employerPagibigNumber": "Employer Pag-IBIG number",
          "paySchedule": "Pay schedule",
          "defaultWorkHoursPerDay": "Default work hours per day"
        }
      },
      "help": {
        "guideLink": "For more information, view the <link>HRIS guide</link>.",
        "index": {
          "iconAriaLabel": "How to use the HRIS hub",
          "modalTitle": "HRIS hub",
          "intro": "This is your HR home page. Use the cards below to open each area of people operations for the active company.",
          "step1": "Check the summary cards for active headcount, pending timesheets, pending leave, and finalized payroll runs.",
          "step2": "Open Employees to add staff, maintain profiles, and store 201-file documents.",
          "step3": "Use Attendance for clock events, timesheet review, holidays, and work schedules.",
          "step4": "Use Leave and Payroll when you are ready to track time off and run pay periods.",
          "step5": "Open My HR if your login is linked to an employee record — clock in, request leave, and view payslips there.",
          "outro": "Only sections you are allowed to access appear here. Switch companies from the sidebar if you manage more than one."
        },
        "employees": {
          "iconAriaLabel": "How to use the Employees page",
          "modalTitle": "Employees",
          "intro": "Maintain your company’s employee master list — names, job details, pay basics, and links to AbraFi logins.",
          "step1": "Use Search and Include inactive to find people in the table. Pagination loads more rows from the server.",
          "step2": "Click Add employee to create a record. Use the suggested employee number pill if one appears.",
          "step3": "Click View on a row to open the employee profile, 201-file documents, and employment history.",
          "step4": "On the profile tab you can update department, job title, government IDs, monthly basic pay, and employment status.",
          "step5": "Link an AbraFi login on the profile so that person can use My HR (owners can use Link my login on their own record).",
          "step6": "Upload contracts and clearance files on the 201 file tab; downloads use signed URLs.",
          "outro": "Inactive or separated employees stay in the system for audit history — filter them in when you need to review past staff."
        },
        "roleManager": {
          "iconAriaLabel": "How to use Role Manager",
          "modalTitle": "Role Manager",
          "intro": "Create departments and job titles so employees can be categorized correctly.",
          "step1": "Use the Job Titles and Departments tabs to switch lists.",
          "step2": "Add a department first, then add job titles and assign each title to a department.",
          "step3": "Edit rows to update names, descriptions, or scope of work; deactivate when unused.",
          "step4": "Search and filter by department or status to find roles quickly.",
          "step5": "Return to Employees — the job title dropdown shows Title — Department for selection.",
          "outro": "You cannot deactivate a department or job title that still has active employees."
        },
        "employeeDetail": {
          "iconAriaLabel": "How to use the employee detail page",
          "modalTitle": "Employee detail",
          "intro": "One employee record with three tabs: profile fields, uploaded documents, and employment events.",
          "step1": "Profile — edit core HR data and Save. Required fields show inline errors; the Save button always explains what is missing.",
          "step2": "Link my login (owners only) connects your AbraFi account to this employee for My HR self-service.",
          "step3": "201 file — pick a document type, upload a file, then refresh the list. Use Download to open a secure link.",
          "step4": "Employment history — read-only timeline of status or role changes recorded for this person.",
          "step5": "Use Back to employees to return to the list without losing company context.",
          "step6": "Document uploads go to company storage; confirm step must succeed before the file appears in the table.",
          "outro": "Changes here affect payroll and leave for this employee — double-check employee number and pay type before saving."
        },
        "attendance": {
          "iconAriaLabel": "How to use the Attendance page",
          "modalTitle": "Attendance",
          "intro": "Track time through clock events, review timesheets, and configure company calendars and shifts.",
          "step1": "Filter by employee or leave All employees to see company-wide data.",
          "step2": "Clock events — use Clock in / Clock out for the selected employee (or yourself when using My HR). Recent punches appear in the table below.",
          "step3": "Timesheets — review pending rows and Approve or Reject. Approved hours can feed payroll computation.",
          "step4": "Holidays — add regular or special non-working days that payroll may treat as paid holidays.",
          "step5": "Work schedules — define named shifts (start, end, break) used as reference for attendance rules.",
          "step6": "Switch sections with the tabs at the top; each table is paginated separately.",
          "outro": "Refresh reloads the active section. If clock actions fail, confirm the employee exists and is active."
        },
        "leave": {
          "iconAriaLabel": "How to use the Leave page",
          "modalTitle": "Leave",
          "intro": "Manage leave types, balances, and approval workflow for your team.",
          "step1": "Filter by employee to focus on one person, or leave All employees to see every request.",
          "step2": "When an employee is selected, balance cards show remaining days per leave type for the current year.",
          "step3": "Click New leave request to file time off — pick type, dates, and an optional reason.",
          "step4": "Pending requests show Approve and Reject actions for HR users; status updates immediately in the list.",
          "step5": "The requests table is paginated — use the controls at the bottom to see older entries.",
          "outro": "Employees with a linked login can also submit requests from My HR; approvals done here apply to those requests too."
        },
        "payroll": {
          "iconAriaLabel": "How to use the Payroll page",
          "modalTitle": "Payroll runs",
          "intro": "Create pay periods, compute gross-to-net amounts, and finalize payslips for the company.",
          "step1": "Click New payroll run and enter period start, period end, and optional pay date and notes.",
          "step2": "After creating a run, open it with View to see the detail page.",
          "step3": "On the detail page, click Compute to generate lines for active employees (draft run only).",
          "step4": "Review gross, deductions, and net pay per employee, then click Finalize when totals are correct.",
          "step5": "Finalized runs appear in reports and employee payslip history; draft runs can be recomputed.",
          "outro": "Statutory deductions use company HR settings and configured tables — verify settings before your first live run."
        },
        "payrollRunDetail": {
          "iconAriaLabel": "How to use the payroll run detail page",
          "modalTitle": "Payroll run detail",
          "intro": "Work on one pay period: review status, compute lines, and finalize when ready.",
          "step1": "The header shows the pay period dates and current status (draft, computed, or finalized).",
          "step2": "Draft — click Compute to build or refresh employee lines from attendance and pay settings.",
          "step3": "Computed — review each row’s gross, deductions, and net pay; paginate if you have many employees.",
          "step4": "Computed — click Finalize to lock the run and mark payslips as finalized.",
          "step5": "Use Back to payroll to return to the list, or Refresh to reload after compute or finalize.",
          "outro": "You cannot edit lines manually after compute — adjust source data or recompute while the run is still a draft."
        },
        "reports": {
          "iconAriaLabel": "How to use the HR reports page",
          "modalTitle": "HR reports",
          "intro": "Read-only summaries for headcount, attendance, leave, and payroll register.",
          "step1": "Headcount — active and separated totals plus employees per department (paginated table).",
          "step2": "Pending timesheets and pending leave show counts that need HR action on Attendance and Leave pages.",
          "step3": "Payroll register — one row per finalized payroll run with employee count and total net pay.",
          "step4": "Use Refresh to reload all sections after you finalize payroll or approve leave.",
          "step5": "Paginate long department or register lists with the controls under each table.",
          "outro": "These reports reflect the active company only — switch company in the sidebar for another entity."
        },
        "settings": {
          "iconAriaLabel": "How to use the HR settings page",
          "modalTitle": "HR settings",
          "intro": "Company-level defaults used by payroll and statutory reporting.",
          "step1": "Enter employer TIN, SSS, PhilHealth, and Pag-IBIG registration numbers as they appear on government forms.",
          "step2": "Choose a pay schedule (e.g. semi-monthly) and cutoff days that match how you run payroll.",
          "step3": "Set default work hours per day for attendance and pay calculations when no schedule override exists.",
          "step4": "Click Save — validation runs before anything is stored; fix any highlighted fields and try again.",
          "step5": "Changes apply to new payroll runs and reports; they do not retroactively change finalized payslips.",
          "outro": "Complete these before your first payroll compute so deductions and employer shares calculate correctly."
        },
        "me": {
          "iconAriaLabel": "How to use My HR",
          "modalTitle": "My HR",
          "intro": "Self-service for employees whose AbraFi login is linked to an HR record in this company.",
          "step1": "If you see a setup message instead of data, your account is not linked yet — ask HR or use Employees to link your login.",
          "step2": "Clock in and Clock out record your attendance for today; recent punches appear in the table below.",
          "step3": "Leave balances show remaining days per leave type; click Request leave to submit dates for approval.",
          "step4": "Track leave request status in the list; approved time off updates your balances after HR acts.",
          "step5": "Payslips list finalized payroll periods with gross and net amounts — paginate to see older runs.",
          "outro": "You only see your own data here. HR staff use the main HRIS sections to manage the whole company."
        }
      },
      "guide": {
        "title": "HRIS guide",
        "description": "How HRIS in AbraFi helps you manage employees — from hiring and attendance through leave, payroll, and reports — in one place inside your company.",
        "whyTitle": "Why use HRIS?",
        "whyIntro": "HRIS is your people operations layer in the same company you use for accounting. It does not replace your books — it gives you one workflow instead of spreadsheets, chat threads, and scattered files.",
        "why1": "One official roster per company — names, job details, government IDs, and 201-file documents.",
        "why2": "Attendance and leave tied to employee records, not a separate logbook or group chat.",
        "why3": "Payroll runs built from employee pay settings and approved time, with PH statutory context.",
        "why4": "Owners and HR see the whole company; linked staff use My HR for self-service.",
        "modulesTitle": "How the areas fit together",
        "modulesIntro": "Think of HRIS as a pipeline: employees → attendance → leave → payroll → reports. HR settings feed payroll; My HR lets staff clock in, request leave, and view payslips.",
        "moduleEmployeesTitle": "Employees",
        "moduleEmployeesBody": "Add each person once: department, job title, monthly basic pay, TIN/SSS/PhilHealth/Pag-IBIG, employment status, and uploaded 201-file documents.",
        "moduleEmployeesLink": "Open Employees",
        "moduleAttendanceTitle": "Attendance",
        "moduleAttendanceBody": "Clock in/out, review timesheets, and configure holidays and work schedules. Approved hours can feed payroll.",
        "moduleAttendanceLink": "Open Attendance",
        "moduleLeaveTitle": "Leave",
        "moduleLeaveBody": "See balances, file and approve requests, and avoid payroll surprises when someone was on unpaid leave.",
        "moduleLeaveLink": "Open Leave",
        "modulePayrollTitle": "Payroll",
        "modulePayrollBody": "Create a pay period, compute gross-to-net lines, then finalize locked payslips for the company.",
        "modulePayrollLink": "Open Payroll",
        "moduleReportsTitle": "Reports",
        "moduleReportsBody": "Headcount by department, pending timesheets and leave, and a payroll register of finalized runs.",
        "moduleReportsLink": "Open HR reports",
        "moduleSettingsTitle": "HR settings",
        "moduleSettingsBody": "Employer registration numbers, pay schedule, and default work hours — set these before your first payroll compute.",
        "moduleSettingsLink": "Open HR settings",
        "moduleMeTitle": "My HR",
        "moduleMeBody": "Self-service for linked employees: clock in/out, request leave, and view payslips without full HR admin access.",
        "moduleMeLink": "Open My HR",
        "rolesTitle": "Who does what",
        "ownerRoleTitle": "Company owner or HR admin:",
        "owner1": "Complete HR settings first (employer IDs, pay schedule, default hours).",
        "owner2": "Add employees and link each person’s AbraFi login so they can use My HR.",
        "owner3": "Approve timesheets and leave requests on Attendance and Leave.",
        "owner4": "Run payroll each cutoff: new run → Compute → review → Finalize.",
        "owner5": "Use Reports and the HRIS hub summary cards for headcount and pending work.",
        "employeeRoleTitle": "Employees with a linked login:",
        "employee1": "Use My HR to clock in/out, request leave, and view payslips.",
        "employee2": "They do not see the full company employee list unless you grant HR permissions.",
        "employee3": "If My HR is empty, HR must link their AbraFi account on their employee profile.",
        "setupTitle": "First-time setup order",
        "setupIntro": "Follow this sequence when turning HRIS on for a company:",
        "setup1": "HR settings — employer TIN, SSS, PhilHealth, Pag-IBIG, pay schedule, default work hours.",
        "setup2": "Employees — add active staff; set department, job title, and monthly basic pay.",
        "setup3": "Link logins — connect AbraFi accounts for self-service (owners can use Link my login on their own record).",
        "setup4": "Attendance — add holidays and schedules; start clocking or reviewing timesheets.",
        "setup5": "Leave — file test requests and approve or reject so balances look correct.",
        "setup6": "Payroll — create a run, open detail, Compute, review lines, then Finalize.",
        "setup7": "Reports — confirm headcount and payroll register match what you expect.",
        "benefitsTitle": "Day-to-day business benefits",
        "benefit1": "Onboarding — one employee record and document uploads instead of folders per person.",
        "benefit2": "Compliance readiness — government IDs and employer numbers in one place for PH payroll context.",
        "benefit3": "Less payroll guesswork — compute from pay settings and time data instead of retyping every cutoff.",
        "benefit4": "Visibility — pending timesheets and leave on the hub before payday surprises.",
        "benefit5": "History — inactive or separated employees stay in the system for audit without cluttering active payroll.",
        "expectTitle": "Important expectations",
        "expect1": "HRIS is operational HR and payroll runs — you still own correct rates, allowances, and government remittance filing with your accountant.",
        "expect2": "My HR stays empty until the right AbraFi user is linked to the right employee record.",
        "expect3": "Review compute output before Finalize — finalized runs are meant to be locked.",
        "troubleTitle": "Common issues",
        "trouble1": "My HR is empty — open Employees, edit the profile, and link the AbraFi login.",
        "trouble2": "Payroll compute looks wrong — check monthly basic on the employee, HR settings, and attendance/leave for that period.",
        "trouble3": "Staff cannot clock in — they need My HR access and a linked employee record.",
        "trouble4": "A menu item is missing — owners see everything; other members need HR permissions assigned in Settings → Users."
      }
    },
    "businessCalendar": {
      "formatDaysUntilExpiration": {
        "noDate": "No expiration date",
        "overdue": "{{count}} days overdue",
        "today": "Expires today",
        "oneDay": "1 day left",
        "daysLeft": "{{count}} days left"
      },
      "BusinessCalendarPage": {
        "title": "Business Calendar",
        "subtitle": "Track permits, renewals, and employee contribution due dates.",
        "loading": "Loading business calendar…",
        "loadFailed": "Failed to load business calendar.",
        "retry": "Try again",
        "refreshing": "Refreshing…",
        "createSchedule": "Create schedule",
        "employeeReminders": "Employee reminders",
        "summaryCritical": "Critical",
        "summaryWarning": "Warning",
        "summarySecure": "Secure",
        "summaryExpiring": "Expiring this month",
        "calendarTitle": "Calendar",
        "actionsTitle": "Action items",
        "scheduleCreatedSuccess": "Schedule created.",
        "confirmSuccess": "Expiration date confirmed.",
        "renewSuccess": "Document renewed.",
        "attachSuccess": "Document file saved.",
        "reminderEnabledSuccess": "Reminder enabled.",
        "reminderSavedSuccess": "Reminder saved.",
        "filedSuccess": "Document marked as filed.",
        "deleteSuccess": "Document removed.",
        "reminderCreatedSuccess": "Employee reminder added.",
        "reminderUpdatedSuccess": "Employee reminder updated.",
        "reminderDeletedSuccess": "Employee reminder removed."
      },
      "BusinessCalendarActionItemsPage": {
        "title": "Action items",
        "subtitle": "All critical, warning, and secure documents.",
        "back": "Back to calendar",
        "loading": "Loading action items…",
        "loadFailed": "Failed to load action items.",
        "retry": "Try again",
        "refreshing": "Refreshing…"
      },
      "BusinessCalendarActionItemsList": {
        "documentColumn": "Document",
        "expirationColumn": "Expiration",
        "daysLeftColumn": "Days left",
        "urgencyColumn": "Urgency",
        "reminderColumn": "Reminder",
        "actionsColumn": "Actions",
        "urgencyLegendAria": "Filter by urgency",
        "filterByUrgencyAria": "Filter by {{urgency}} documents",
        "viewRowAria": "View details for {{name}}",
        "remindRowAria": "Set reminder for {{name}}",
        "editRemindRowAria": "Edit reminder for {{name}}",
        "renewRowAria": "Renew {{name}}",
        "markFiledRowAria": "Mark {{name}} as filed",
        "empty": "No action items yet. Create a schedule from the calendar page.",
        "emptyFiltered": "No documents match this urgency filter."
      },
      "BusinessCalendarCalendar": {
        "previousMonth": "Previous month",
        "nextMonth": "Next month",
        "legendCritical": "Critical",
        "legendWarning": "Warning",
        "legendSecure": "Secure",
        "empty": "No events on the calendar yet. Upload a document or add employee reminders.",
        "weekdays": {
          "sun": "Sun",
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat"
        }
      },
      "BusinessCalendarActionPanel": {
        "criticalTitle": "Critical",
        "warningTitle": "Warning",
        "secureTitle": "Secure",
        "sectionEmpty": "No documents in this section.",
        "noExpirationDate": "No expiration date",
        "viewDetails": "Details",
        "renewNow": "Renew",
        "setReminder": "Remind",
        "editReminder": "Remind",
        "markFiled": "Mark filed",
        "reminderActive": "Reminder {{days}} days before",
        "seeAll": "See all",
        "sectionHeaderLinkAria": "View all {{section}} action items"
      },
      "BusinessCalendarSetReminderModal": {
        "title": "Set reminder",
        "editTitle": "Edit reminder",
        "message": "Choose how many days before expiration to be reminded for {{name}}.",
        "expiration": "Expiration date: {{date}}",
        "noExpirationDate": "No expiration date",
        "daysBefore": "Days before expiration",
        "cancel": "Cancel",
        "save": "Save reminder",
        "saving": "Saving…"
      },
      "BusinessCalendarMarkFiledConfirmModal": {
        "title": "Mark as filed",
        "message": "Mark {{name}} as filed?",
        "documentType": "Document type",
        "unknownType": "Unknown type",
        "hint": "This updates the document status to filed. You can renew it later when applicable.",
        "cancel": "Cancel",
        "confirm": "Mark filed",
        "filing": "Marking filed…"
      },
      "BusinessCalendarRenewConfirmModal": {
        "title": "Confirm renewal",
        "message": "Renew {{name}} and update its expiration tracking?",
        "documentType": "Document type",
        "renewalAnchor": "Renewal anchor",
        "renewalLogic": "Renewal rule",
        "currentExpiration": "Current expiration",
        "nextExpiration": "New expiration after renewal",
        "noExpirationDate": "None set",
        "unableToCompute": "Could not compute — confirm the expiration date first.",
        "unknownType": "Unknown type",
        "hint": "Renewal clears the filed status and sets the next expiration using the rule above.",
        "cancel": "Cancel",
        "confirm": "Renew",
        "renewing": "Renewing…",
        "logic": {
          "none": "This schedule does not repeat. Renewal clears the filed status only.",
          "daily": "Advances the expiration date by 1 day using the Repeat schedule.",
          "weekly": "Advances the expiration date by 1 week using the Repeat schedule.",
          "monthly": "Advances the expiration date by 1 month using the Repeat schedule.",
          "yearly": "Advances the expiration date by 1 year using the Repeat schedule.",
          "custom": "Advances the expiration date by {{interval}} {{unit}} using the custom Repeat schedule.",
          "customMonthly": "Advances monthly from the saved anchor date — same day each month (e.g. Jan 20 → Feb 20).",
          "customYearly": "Advances yearly from the saved anchor date — same month and day next year (e.g. Jan 20, 2026 → Jan 20, 2027).",
          "customEvery2Years": "Advances every 2 years from the saved anchor date — same month and day (e.g. Jan 20, 2026 → Jan 20, 2028).",
          "customNone": "No expiry rule. Renewal clears the filed status only."
        }
      },
      "BusinessCalendarSelectDocumentTypeModal": {
        "title": "Select document type",
        "documentType": "Document type",
        "customName": "Document name",
        "customNamePlaceholder": "e.g. Quarterly compliance report",
        "expirationDate": "Expiration date",
        "noExpiryRule": "This schedule does not track an expiration date.",
        "expirationRequired": "Expiration date is required for this schedule.",
        "cancel": "Cancel",
        "create": "Create schedule",
        "creating": "Creating…",
        "customNameRequired": "Document name is required for other document types."
      },
      "BusinessCalendarRecurrence": {
        "repeatLabel": "Repeat",
        "customPanelAria": "Custom recurrence",
        "repeatsEvery": "Repeats every",
        "repeatsOn": "Repeats on",
        "ends": "Ends",
        "endNever": "Never",
        "endOn": "On",
        "endAfter": "After",
        "endOccurrences": "occurrence",
        "presets": {
          "none": "Does not repeat",
          "daily": "Every day",
          "weekly": "Every week",
          "monthly": "Every month",
          "yearly": "Every year",
          "custom": "Custom…"
        },
        "units": {
          "day": "day",
          "day_other": "days",
          "week": "week",
          "week_other": "weeks",
          "month": "month",
          "month_other": "months",
          "year": "year",
          "year_other": "years"
        },
        "weekdayShort": {
          "sun": "S",
          "mon": "M",
          "tue": "T",
          "wed": "W",
          "thu": "T",
          "fri": "F",
          "sat": "S"
        },
        "weekdays": {
          "sun": "Sunday",
          "mon": "Monday",
          "tue": "Tuesday",
          "wed": "Wednesday",
          "thu": "Thursday",
          "fri": "Friday",
          "sat": "Saturday"
        },
        "validation": {
          "recurrenceUnitRequired": "Choose a repeat unit for the custom schedule.",
          "recurrenceIntervalRequired": "Repeat interval must be at least 1.",
          "recurrenceEndDateRequired": "Choose an end date.",
          "recurrenceEndOccurrencesRequired": "Enter how many times the schedule should repeat."
        }
      },
      "BusinessCalendarConfirmDateModal": {
        "title": "Confirm expiration date",
        "message": "Please review and confirm the expiration date to ensure all information is correct.",
        "noExpiryMessage": "Confirm {{name}} with no expiration tracking.",
        "noExpiryRule": "This document type has no expiration tracking. You can renew it later without changing an expiration date.",
        "ocrDetected": "OCR detected expiration: {{date}}",
        "expirationDate": "Expiration date",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "saving": "Saving…"
      },
      "BusinessCalendarDetailsModal": {
        "status": "Status",
        "expiration": "Expiration",
        "filename": "Filename",
        "noExpirationDate": "No expiration date",
        "previewLoading": "Loading preview…",
        "previewFailed": "Could not load attachment.",
        "reminder": "Reminder",
        "reminderActive": "{{days}} days before expiration",
        "uploadFile": "Upload file",
        "replaceFile": "Replace file",
        "download": "Download",
        "renew": "Renew",
        "markFiled": "Mark filed",
        "delete": "Delete"
      },
      "BusinessCalendarFileUpload": {
        "hint": "Supported formats: PDF, JPEG, PNG. Maximum file size: 5 MB.",
        "chooseFile": "Choose file",
        "replaceFile": "Replace file",
        "download": "Download",
        "clear": "Clear",
        "uploading": "Uploading…",
        "invalidType": "Supported formats: PDF, JPEG, PNG.",
        "tooLarge": "File must be 5 MB or smaller.",
        "storageFailed": "File could not be saved to storage ({{status}})."
      },
      "BusinessCalendarDocumentAttachment": {
        "attachmentTitle": "Uploaded document",
        "unavailable": "Attachment is not available.",
        "viewFullSize": "View full size"
      },
      "BusinessCalendarEmployeeRemindersModal": {
        "title": "Employee reminders",
        "description": "PhilHealth, SSS, Pag-IBIG, and payroll reminders on your calendar.",
        "empty": "No employee reminders configured yet.",
        "daySummary": "Day {{day}} of the month",
        "statusEnabled": "Enabled",
        "statusDisabled": "Disabled",
        "edit": "Edit",
        "delete": "Delete",
        "addReminder": "Add reminder",
        "close": "Close"
      },
      "BusinessCalendarEditEmployeeReminderModal": {
        "title": "Edit employee reminder",
        "message": "Update settings for {{name}}.",
        "reminderType": "Reminder type",
        "dayOfMonth": "Day of month",
        "enabled": "Enabled",
        "cancel": "Cancel",
        "save": "Save",
        "saving": "Saving…"
      },
      "BusinessCalendarAddEmployeeReminderModal": {
        "title": "Add employee reminder",
        "description": "Choose a reminder type and the day of the month it should appear on your calendar.",
        "allTypesAdded": "All reminder types are already configured.",
        "type": "Reminder type",
        "dayOfMonth": "Day of month",
        "invalidDayOfMonth": "Enter a day between 1 and 31.",
        "cancel": "Cancel",
        "add": "Add reminder",
        "adding": "Adding…",
        "types": {
          "philhealth": "PhilHealth",
          "sss": "SSS",
          "pagibig": "Pag-IBIG",
          "payroll": "Payroll"
        }
      }
    },
    "reserve": {
      "placeStatus": {
        "active": "Active",
        "inactive": "Inactive",
        "maintenance": "Maintenance"
      },
      "reservationStatus": {
        "pending": "Pending",
        "review_payment": "Review payment",
        "confirmed": "Confirmed",
        "cancelled": "Cancelled",
        "completed": "Completed"
      },
      "weekdays": {
        "short": {
          "1": "Mon",
          "2": "Tue",
          "3": "Wed",
          "4": "Thu",
          "5": "Fri",
          "6": "Sat",
          "7": "Sun"
        }
      },
      "calendar": {
        "prevMonth": "Previous month",
        "nextMonth": "Next month",
        "fullyBookedDayAria": "Day {{day}}, fully booked"
      },
      "slots": {
        "dayClosed": "This place is closed on the selected day.",
        "empty": "No slots for this day.",
        "status": {
          "available": "Available",
          "pending": "Pending confirmation",
          "booked": "Booked",
          "blocked": "Blocked",
          "past": "Past"
        }
      },
      "places": {
        "pageTitle": "Reserve",
        "pageSubtitle": "Manage bookable places and share your public booking link.",
        "newPlaceButton": "New place",
        "reservationsButton": "Reservations",
        "reservationsCardTitle": "Reservations",
        "reservationsCardDescription": "Confirm, cancel, or reschedule bookings across your places.",
        "calendarCardTitle": "Calendar",
        "calendarCardDescription": "Browse availability for each place in a read-only calendar view.",
        "authorizeCardTitle": "Authorize",
        "authorizeCardDescription": "Manage authorized persons with unique codes and printable QR badges.",
        "emailCardTitle": "Email notifications",
        "emailCardDescription": "See who gets alerts and how booking emails look.",
        "paymentCardTitle": "Payment setup",
        "paymentCardDescription": "Upload a GCash or bank QR guests can scan when they pay now.",
        "publicLinkLabel": "Public booking link",
        "handleLoading": "Loading public link…",
        "handleLoadFailed": "Failed to load your public booking handle.",
        "copyLinkButton": "Copy link",
        "linkCopiedButton": "Copied",
        "showQrButtonAria": "Show booking QR code",
        "qrModalTitle": "Public booking QR code",
        "qrModalHint": "Guests can scan this code to open your public booking page.",
        "qrModalCloseButton": "Close",
        "qrModalPrintButton": "Print",
        "noHandleToast": "No public handle is configured yet.",
        "linkCopiedToast": "Public link copied.",
        "linkCopyFailedToast": "Could not copy the link.",
        "handle": {
          "urlLabel": "Booking URL",
          "edit": "Edit",
          "inputLabel": "Public handle",
          "placeholder": "your-venue",
          "checking": "Checking availability…",
          "available": "Available",
          "unavailableGeneric": "This handle is not available.",
          "helperText": "Guests open this link to book your places.",
          "rulesHint": "3–63 characters. Lowercase letters, numbers and single hyphens; must start and end with a letter or number.",
          "cancel": "Cancel",
          "save": "Save handle",
          "saving": "Saving…",
          "saveFailed": "Failed to save handle.",
          "saved": "Reserve handle saved.",
          "requiredToast": "Enter a public handle.",
          "noChangesToast": "No changes to save.",
          "stillCheckingToast": "Still checking if that handle is available."
        },
        "loading": "Loading places…",
        "loadFailed": "Failed to load places.",
        "retryButton": "Try again",
        "empty": "No places yet. Create your first place to start taking bookings.",
        "pricePerSlot": "₱{{price}} / {{minutes}} min",
        "priceBoth": "₱{{price30}} / 30 min · ₱{{price60}} / 1 hr",
        "open24Hours": "Open 24 hours",
        "addOnsCardTitle": "Add-ons",
        "addOnsCardDescription": "Create add-ons guests can select when booking."
      },
      "calendarPage": {
        "pageTitle": "Calendar",
        "pageSubtitle": "Choose a place to view its availability calendar. This view is read-only.",
        "backButton": "Back to places",
        "backToHubAriaLabel": "Back to places",
        "loading": "Loading places…",
        "loadFailed": "Failed to load places.",
        "empty": "No places yet. Create a place first to view its calendar.",
        "noLocation": "No location set",
        "placeLoading": "Loading place calendar…",
        "placeLoadFailed": "Failed to load this place.",
        "placePageTitle": "{{name}} calendar",
        "placePageSubtitle": "Browse any date and tap a time to see who booked it. You cannot book or edit from this view.",
        "backToCalendarButton": "Back to calendar",
        "backToCalendarAriaLabel": "Back to calendar places",
        "slotsLabel": "Times for {{date}}",
        "readOnlyHint": "Tap any date to browse. Tap a time to see who booked it — this view is read-only.",
        "slotsLoading": "Loading times…",
        "slotsLoadFailed": "Failed to load availability for this day.",
        "slotNoBookingToast": "No booking for this time.",
        "slotDetailTitle": "Booking details",
        "slotDetailSubtitle": "{{date}} · {{time}}",
        "slotDetailReference": "Reference",
        "slotDetailGuest": "Guest",
        "slotDetailEmail": "Email",
        "slotDetailPhone": "Phone",
        "slotDetailStatus": "Status",
        "slotDetailNotAvailable": "—",
        "slotDetailCloseButton": "Close"
      },
      "authorize": {
        "pageTitle": "Authorize",
        "pageSubtitle": "Create authorized persons with unique codes and printable QR badges.",
        "backButton": "Back to places",
        "loading": "Loading authorized persons…",
        "loadFailed": "Failed to load authorized persons.",
        "empty": "No authorized persons yet. Add someone to generate a unique code and QR badge.",
        "newButton": "Add person",
        "colName": "Name",
        "colCode": "Unique code",
        "colCreated": "Created",
        "colActions": "Actions",
        "nameLabel": "Name",
        "namePlaceholder": "Full name",
        "nameRequiredToast": "Enter a name.",
        "createTitle": "Add authorized person",
        "editTitle": "Edit authorized person",
        "saveButton": "Save",
        "savingButton": "Saving…",
        "cancelButton": "Cancel",
        "createdToast": "Authorized person created.",
        "updatedToast": "Authorized person updated.",
        "deletedToast": "Authorized person deleted.",
        "saveFailedToast": "Could not save authorized person.",
        "deleteFailedToast": "Could not delete authorized person.",
        "deleteConfirmTitle": "Delete {{name}}?",
        "deleteConfirmBody": "Remove authorized person {{name}} ({{code}})? This cannot be undone.",
        "deleteConfirmButton": "Delete",
        "deleteConfirmDismissButton": "Keep",
        "qrButtonAria": "Show QR badge",
        "editButtonAria": "Edit",
        "deleteButtonAria": "Delete",
        "qrModalTitle": "Authorized person QR",
        "qrModalHint": "Print this badge so staff can scan the unique code.",
        "qrModalNameLabel": "Name",
        "qrModalCodeLabel": "Code",
        "qrModalCloseButton": "Close",
        "qrModalPrintButton": "Print",
        "actionLoadingToast": "Updating…"
      },
      "placeForm": {
        "createTitle": "New place",
        "editTitle": "Edit place",
        "backButton": "Back to places",
        "blocksButton": "Unavailable blocks",
        "nameLabel": "Name",
        "locationLabel": "Location",
        "mapLabel": "Map pin",
        "mapHint": "Open the map preview to drop a pin. Guests will see this location when they book.",
        "pricingSectionLabel": "Slot pricing",
        "pricingHint": "Enter a price for 30 minutes, 1 hour, or both. Leave a price blank to not offer that length.",
        "price30Label": "Price for 30 minutes",
        "price60Label": "Price for 1 hour",
        "slotDurationLabel": "Slot length",
        "slot60": "1 hour",
        "slot30": "30 minutes",
        "priceLabel": "Price per slot",
        "openTimeLabel": "Opens",
        "closeTimeLabel": "Closes",
        "open24HoursLabel": "Allow 24 hours",
        "open24HoursHint": "Guests can book any time of day, including 11:00pm–12:00am.",
        "hoursHint": "Closing at 12:00am with a later open means until midnight. Or turn on Allow 24 hours.",
        "bookableFromLabel": "Bookable from",
        "bookableToLabel": "Bookable to",
        "weekdaysLabel": "Bookable weekdays",
        "addOns": {
          "openAddButton": "Add add-on",
          "createTitle": "Add add-on",
          "editTitle": "Edit add-on",
          "addButton": "Add add-on",
          "addingButton": "Adding…",
          "saveButton": "Save add-on",
          "savingButton": "Saving…",
          "cancelButton": "Cancel",
          "nameLabel": "Add-on name",
          "namePlaceholder": "e.g. Extra racket",
          "nameRequiredToast": "Enter an add-on name.",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Optional details guests will see",
          "pricingTypeLabel": "Pricing type",
          "pricingTypeHint": "You can select per 30 minutes and per hour together. Choosing fixed payment hides the rate options.",
          "pricingTypeRequiredToast": "Select per 30 minutes, per hour, and/or fixed payment.",
          "pricingType": {
            "per_30_minutes": "Per 30 minutes",
            "per_hour": "Per hour",
            "fixed": "Fixed payment"
          },
          "pricePer30MinutesLabel": "Price per 30 minutes",
          "pricePerHourLabel": "Price per hour",
          "priceFixedLabel": "Fixed price",
          "pricePlaceholder": "0.00",
          "price30MinutesRequiredToast": "Enter a price per 30 minutes.",
          "hourPriceRequiredToast": "Enter a price per hour.",
          "fixedPriceRequiredToast": "Enter a fixed price.",
          "priceDisplay30Minutes": "₱{{price}} / 30 min",
          "priceDisplayHour": "₱{{price}} / hr",
          "priceDisplayFixed": "₱{{price}} fixed",
          "includeAria": "Include {{name}} on this place",
          "editButtonAria": "Edit add-on",
          "deleteButtonAria": "Delete add-on",
          "removeButtonAria": "Remove {{name}} from this place",
          "useExistingLabel": "Use an existing add-on on this place",
          "useExistingPlaceholder": "Use existing add-on…",
          "deletedToast": "Add-on deleted.",
          "deleteFailedToast": "Could not delete add-on.",
          "deleteConfirmTitle": "Delete {{name}}?",
          "deleteConfirmBody": "Remove add-on {{name}}? Guests will no longer be able to select it.",
          "deleteConfirmButton": "Delete",
          "deleteConfirmDismissButton": "Keep",
          "createdToast": "Add-on added.",
          "updatedToast": "Add-on updated.",
          "saveFailedToast": "Could not save add-on.",
          "actionLoadingToast": "Saving add-on…",
          "retryButton": "Try again"
        },
        "weekdayPreset": {
          "mon-sun": "Mon–Sun",
          "mon-fri": "Mon–Fri",
          "fri-mon": "Fri–Mon",
          "sat-sun": "Sat–Sun",
          "custom": "Custom"
        },
        "statusLabel": "Status",
        "saveButton": "Save place",
        "savingButton": "Saving…",
        "loading": "Loading place…",
        "loadFailed": "Failed to load place.",
        "nameRequiredToast": "Enter a place name.",
        "weekdaysRequiredToast": "Select at least one weekday.",
        "dateRangeInvalidToast": "Bookable to must be on or after bookable from.",
        "priceRequiredToast": "Enter a price for 30 minutes, 1 hour, or both.",
        "priceInvalidToast": "Enter a valid price (0 or greater).",
        "hoursInvalidToast": "Close time must be after open time, or the same time for 24-hour places.",
        "savingToast": "Saving place…",
        "createdToast": "Place created.",
        "updatedToast": "Place saved.",
        "saveFailedToast": "Could not save place.",
        "deleteButton": "Delete place",
        "deletingButton": "Deleting…",
        "deletingToast": "Deleting place…",
        "deletedToast": "Place deleted.",
        "deleteFailedToast": "Could not delete place.",
        "images": {
          "label": "Photos",
          "hintCreate": "Add as many photos as you need. Guests will see them on Book a place. You can also add more after saving.",
          "hintEdit": "Add as many photos as you need. Guests see these immediately on Book a place.",
          "uploadButton": "Add photos",
          "uploadButtonShort": "Add",
          "uploadingShort": "…",
          "uploadingToast": "Uploading photos…",
          "uploadedToast": "Photos uploaded.",
          "uploadFailedToast": "Could not upload photos.",
          "invalidTypeToast": "Use JPEG, PNG, WebP, or GIF images.",
          "removingToast": "Removing photo…",
          "removedToast": "Photo removed.",
          "removeFailedToast": "Could not remove photo.",
          "removeAria": "Remove photo",
          "loading": "Loading photos…",
          "countHint": "{{count}} photos",
          "countHint_one": "{{count}} photo",
          "countHint_other": "{{count}} photos"
        },
        "addOnsLabel": "Add-ons",
        "addOnsHint": "Add extras guests can select when booking this place. New places start with none — create one or reuse an existing add-on.",
        "addOnsLoading": "Loading add-ons…",
        "addOnsLoadFailed": "Could not load add-ons.",
        "addOnsEmpty": "No add-ons on this place yet. Add one below."
      },
      "reservations": {
        "pageTitle": "Reservations",
        "pageSubtitle": "Confirm, cancel, or reschedule bookings across your places.",
        "backButton": "Back to places",
        "filterPlace": "Place",
        "filterPlaceAll": "All places",
        "filterStatus": "Status",
        "filterStatusAll": "All statuses",
        "filterDateFrom": "From",
        "filterDateTo": "To",
        "loading": "Loading reservations…",
        "loadFailed": "Failed to load reservations.",
        "empty": "No reservations match these filters.",
        "colReference": "Reference",
        "colPlace": "Place",
        "colCustomer": "Customer",
        "colWhen": "When",
        "colCreatedAt": "Created",
        "colStatus": "Status",
        "colActions": "Actions",
        "confirmButton": "Confirm",
        "cancelButton": "Cancel",
        "rescheduleButton": "Reschedule",
        "proofModalTitle": "Payment proof · {{reference}}",
        "proofModalHint": "Review the payment proof image, then confirm to accept the booking.",
        "proofModalEditHint": "Replace the payment proof or update the paid-to account if needed.",
        "proofModalViewHint": "Payment proof for this booking.",
        "proofModalReplaceUploadHint": "Choose a new payment proof image and paid-to account, then save.",
        "proofPaidToLabel": "Guest paid to",
        "proofPaidToBankLabel": "Bank",
        "proofPaidToAccountNameLabel": "Account name",
        "proofPaidToAccountNumberLabel": "Account number",
        "proofPaidToSelectLabel": "Paid to account",
        "proofPaidToSelectPlaceholder": "Select account",
        "proofPaidToCashOption": "Cash",
        "proofPaidToRequiredToast": "Select which account the guest paid to.",
        "proofRemarksLabel": "Remarks",
        "proofRemarksDefault": "Thank you for booking with us — your reservation is confirmed. We look forward to seeing you.",
        "proofRemarksRequiredToast": "Enter remarks before confirming.",
        "proofPaidToSaveFailedToast": "Could not save paid-to account.",
        "proofPaidToSavingToast": "Saving paid-to account…",
        "proofPaidToSavedToast": "Paid-to account updated.",
        "proofNoChangesToast": "No payment proof changes to save.",
        "proofModalUploadHint": "Choose a payment proof image, then confirm the booking.",
        "proofModalCashUploadHint": "Select Cash (or upload proof), add remarks, then confirm.",
        "proofLoading": "Loading proof…",
        "proofMissing": "No proof image is available.",
        "proofImageAlt": "Proof of payment",
        "proofUploadLabel": "Proof of payment",
        "proofUploadButton": "Upload proof",
        "proofUploadingButton": "Uploading…",
        "proofReplaceButton": "Replace proof",
        "proofReplaceSaveButton": "Save new proof",
        "proofReplaceCancelButton": "Keep current",
        "proofEditPaidToButton": "Change paid-to",
        "proofEditPaidToCancelButton": "Keep current account",
        "proofSavePaidToButton": "Save paid-to",
        "viewProofButton": "View payment proof",
        "proofUploadRequiredToast": "Choose a proof of payment image.",
        "proofUploadImageRequiredToast": "Proof of payment must be an image file.",
        "proofUploadingToast": "Uploading payment proof…",
        "proofUploadedToast": "Payment proof uploaded.",
        "proofUploadFailedToast": "Could not upload payment proof.",
        "proofRequiredBeforeConfirmToast": "Choose a proof of payment image before confirming.",
        "proofCloseButton": "Close",
        "proofLoadFailedToast": "Could not load payment proof.",
        "rescheduleTitle": "Reschedule {{reference}}",
        "rescheduleModalHint": "Pick a new date and consecutive time slots, then save.",
        "rescheduleMultiSelectHint": "Tap consecutive times to select. Tap a selected time again to unselect or shrink the range.",
        "rescheduleSlotsLoading": "Loading available times…",
        "reschedulePlaceMissingToast": "Could not load this place for reschedule.",
        "saveRescheduleButton": "Save new time",
        "cancelRescheduleButton": "Close",
        "cancelConfirmTitle": "Cancel {{reference}}?",
        "cancelConfirmBody": "Cancel booking {{reference}} for {{place}} ({{when}})? This cannot be undone.",
        "cancelConfirmButton": "Cancel booking",
        "cancelConfirmDismissButton": "Keep booking",
        "rescheduleConfirmTitle": "Confirm new time · {{reference}}",
        "rescheduleConfirmBody": "Move {{reference}} to {{when}} ({{minutes}} min)?",
        "rescheduleConfirmButton": "Save new time",
        "rescheduleConfirmDismissButton": "Go back",
        "actionLoadingToast": "Updating reservation…",
        "confirmedToast": "Reservation confirmed.",
        "confirmedWithCancelledToast": "Reservation confirmed. {{count}} overlapping pending request(s) cancelled.",
        "cancelledToast": "Reservation cancelled.",
        "rescheduledToast": "Reservation rescheduled.",
        "rescheduleSlotRequiredToast": "Select a date and consecutive available times.",
        "rescheduleContiguousRequiredToast": "Select consecutive available times only.",
        "actionFailedToast": "Could not update reservation."
      },
      "payment": {
        "pageTitle": "Payment setup",
        "pageSubtitle": "Add multiple payment methods guests can use when they choose Pay now on the public booking page.",
        "backButton": "Back to places",
        "loading": "Loading payment setup…",
        "loadFailed": "Failed to load payment setup.",
        "statusQrReady": "QR ready",
        "statusQrMissing": "QR needed",
        "statusBankReady": "Bank details ready",
        "statusBankMissing": "Bank details needed",
        "statusMethodsReady": "{{count}} payment method(s) ready",
        "statusCashEnabled": "Cash payment enabled",
        "statusCashDisabled": "Cash payment disabled",
        "cashPaymentTitle": "Cash",
        "cashPaymentEditTitle": "Cash payment",
        "cashPaymentHint": "Built-in option. Guests can request a booking and pay cash on-site.",
        "cashPaymentEnabledLabel": "Enable cash payment",
        "cashPaymentEnabledHelp": "When enabled, guests can choose Cash inside Pay now. When disabled, only bank accounts are available.",
        "cashPaymentEditAria": "Edit cash payment",
        "cashPaymentOpenAria": "Cash payment settings",
        "cashPaymentBadgeEnabled": "Enabled",
        "cashPaymentBadgeDisabled": "Disabled",
        "cashPaymentSaveButton": "Save",
        "cashPaymentSavingButton": "Saving…",
        "cashPaymentCancelButton": "Cancel",
        "cashPaymentSavingToast": "Saving cash payment…",
        "cashPaymentSavedToast": "Cash payment updated.",
        "cashPaymentSaveFailedToast": "Could not save cash payment.",
        "cashPaymentNoChangesToast": "No changes to save.",
        "cashPaymentLoadFailed": "Failed to load cash payment settings.",
        "addMethodButton": "Add payment method",
        "addMethodTitle": "Add payment method",
        "editMethodTitle": "Edit payment method",
        "createPaymentForTitle": "Create payment for {{bank}}",
        "selectBankTitle": "Your banks",
        "selectBankHint": "Add a bank with your own logo and name. Tap a bank to manage its payment methods.",
        "addBankButton": "Add bank",
        "statusBanksReady": "{{count}} bank(s)",
        "banksLoadFailed": "Failed to load banks.",
        "backToBanksButton": "Back to banks",
        "backToBankMethodsButton": "Back to payment list",
        "backToBankSelectButton": "Back to banks",
        "bankMethodsTitle": "{{bank}} payment methods",
        "bankMethodsHint": "Tap a card to edit. Add another account anytime.",
        "emptyBankMethods": "No payment methods for this bank yet. Add one so guests can pay.",
        "openBankPaymentAria": "Open payment methods for {{name}}",
        "addBankTitle": "Add bank",
        "editBankTitle": "Edit bank",
        "addBankHint": "Enter the bank name. Logo is optional.",
        "selectBankLogoButton": "Add logo",
        "banksLoading": "Loading banks…",
        "emptyBanks": "No banks yet. Add one with a logo and name, then create payment for it.",
        "bankLogoRequiredToast": "Upload a bank logo.",
        "bankLogoUploadFailedToast": "Could not upload bank logo.",
        "bankCatalogSavingToast": "Saving bank…",
        "bankCatalogSavedToast": "Bank saved.",
        "bankCatalogSaveFailedToast": "Could not save bank.",
        "bankDeletingToast": "Deleting bank…",
        "bankDeletedToast": "Bank deleted.",
        "bankDeleteFailedToast": "Could not delete bank.",
        "bankDeleteHasAccountsToast": "Remove all accounts in this bank before deleting it.",
        "bankDeletingButton": "Deleting…",
        "bankDeleteConfirmTitle": "Delete bank?",
        "bankDeleteConfirmBody": "Delete “{{name}}”? This only removes the bank from your catalog.",
        "bankDeleteConfirmButton": "Delete bank",
        "backToListButton": "Back to methods",
        "methodFormHint": "Guests see the method name with bank details and optional QR.",
        "methodNameLabel": "Method name",
        "methodNamePlaceholder": "e.g. GCash, BDO, Maya",
        "nameRequiredToast": "Enter the payment method name.",
        "emptyMethods": "No payment methods yet. Add one so guests can pay after booking.",
        "qrSaveFirstHint": "Save the bank details first, then you can upload a QR for this method.",
        "methodSavingToast": "Saving payment method…",
        "methodSavedToast": "Payment method saved.",
        "methodSaveFailedToast": "Could not save payment method.",
        "methodSavedQrFailedToast": "Payment method saved, but the QR could not be uploaded. Edit the method to try again.",
        "methodDeleteButton": "Delete",
        "methodDeleteConfirmTitle": "Delete payment method?",
        "methodDeleteConfirmBody": "Delete “{{name}}”? Guests will no longer see this option when they choose Pay now.",
        "methodDeleteConfirmButton": "Delete method",
        "methodDeletingButton": "Deleting…",
        "methodDeletingToast": "Deleting payment method…",
        "methodDeletedToast": "Payment method deleted.",
        "methodDeleteFailedToast": "Could not delete payment method.",
        "removeQrButton": "Remove QR",
        "bankDetailsTitle": "Bank account details",
        "bankDetailsHint": "Guests see these next to the payment QR so they know where to send payment.",
        "bankNameLabel": "Bank name",
        "accountNameLabel": "Account name",
        "accountNumberLabel": "Account number",
        "bankNamePlaceholder": "e.g. BDO, BPI, GCash",
        "accountNamePlaceholder": "Account holder name",
        "accountNumberPlaceholder": "Account or mobile number",
        "bankEditButton": "Edit",
        "bankEditAria": "Edit {{name}}",
        "bankDeleteAria": "Delete {{name}}",
        "methodEditAria": "Edit payment method {{name}}",
        "methodDeleteAria": "Delete payment method {{name}}",
        "bankSaveButton": "Save",
        "bankSavingButton": "Saving…",
        "bankCancelEditButton": "Cancel",
        "bankNameRequiredToast": "Enter the bank name.",
        "accountNameRequiredToast": "Enter the account name.",
        "accountNumberRequiredToast": "Enter the account number.",
        "bankSavingToast": "Saving bank details…",
        "bankSavedToast": "Bank details saved.",
        "bankSaveFailedToast": "Could not save bank details.",
        "qrTitle": "Payment QR",
        "qrHint": "Use a clear GCash, Maya, or bank QR screenshot.",
        "qrEmpty": "No payment QR uploaded yet. Guests can still pay cash on-site when Cash is enabled.",
        "qrDropTitle": "Drop QR image here",
        "qrDropHint": "or click to browse · PNG, JPG, or WebP",
        "qrImageAlt": "Payment QR code",
        "uploadButton": "Upload QR",
        "replaceButton": "Replace QR",
        "uploadingButton": "Uploading…",
        "removeButton": "Remove",
        "removingButton": "Removing…",
        "payNowPreviewButton": "Preview",
        "payNowPreviewTitle": "Guest Pay now preview",
        "payNowPreviewHint": "This is how guests see your QR and bank details when they choose Pay now.",
        "payNowPreviewCloseButton": "Close",
        "payNowPreviewUnavailableToast": "Payment QR preview is not available yet. Try refresh.",
        "guestPreviewTitle": "What guests see",
        "guestPreviewHint": "Live preview of the Pay now panel on the public booking page.",
        "guestPreviewQrEmpty": "QR not set",
        "guestPreviewValueEmpty": "Not set yet",
        "selectImageToast": "Choose an image file.",
        "uploadingToast": "Uploading payment QR…",
        "savedToast": "Payment QR saved.",
        "uploadFailedToast": "Could not upload payment QR.",
        "removingToast": "Removing payment QR…",
        "removedToast": "Payment QR removed.",
        "removeFailedToast": "Could not remove payment QR."
      },
      "email": {
        "pageTitle": "Email notifications",
        "pageSubtitle": "Choose who gets booking alerts, and preview sample message formats.",
        "backButton": "Back to places",
        "loading": "Loading email settings…",
        "loadFailed": "Failed to load email settings.",
        "staffRecipientsTitle": "Staff who receive alerts",
        "staffRecipientsHint": "Company owner and members with the Reserve permission get notified when a guest books.",
        "staffRecipientsEditableHint": "Add the email addresses that should get booking alerts from the system. Save to apply.",
        "addEmailLabel": "Notify email",
        "addEmailPlaceholder": "user@example.com",
        "addEmailButton": "Add",
        "removeEmailAria": "Remove {{email}}",
        "configuredEmailsEmpty": "No notify emails yet. Add at least one address above, then Save.",
        "fallbackRecipientsHint": "Until you save notify emails, alerts fall back to:",
        "emailRequiredToast": "Enter an email address.",
        "emailInvalidToast": "Enter a valid email address.",
        "emailDuplicateToast": "That email is already in the list.",
        "saveButton": "Save notify emails",
        "savingButton": "Saving…",
        "savingToast": "Saving notify emails…",
        "savedToast": "Notify emails saved.",
        "saveFailedToast": "Could not save notify emails.",
        "staffRecipientsEmpty": "No staff emails found yet. Ensure the company owner has an email, or grant Reserve to members.",
        "staffRole": {
          "owner": "Owner",
          "member": "Member (Reserve)",
          "configured": "Notify list"
        },
        "customerPreviewTitle": "Customer email format (pending)",
        "customerPreviewHint": "Guests receive mail at the email they enter on the public booking form.",
        "customerCancelPreviewTitle": "Customer email format (cancelled)",
        "customerCancelPreviewHint": "Sent when staff cancels a booking, or when another request is confirmed for the same time.",
        "staffPreviewTitle": "Staff email format (new pending)",
        "staffPreviewHint": "Each staff recipient above gets a separate alert like this.",
        "subjectLabel": "Subject",
        "bodyLabel": "Body",
        "customerPendingSubjectSample": "Booking request RSV-9ZFPT — Cover Court",
        "customerPendingBodySample": "Hi TEST1,\n\nWe received your booking request.\n\nReference: RSV-9ZFPT\nPlace: Cover Court\nWhen: Sep 3, 2026 · 7:30–9:00pm\nPrice: ₱140.00\nStatus: Pending\n\nPay cash on-site when you arrive. Your request is held until the venue confirms it.\nAnother guest may request the same time; confirmation is first-come from staff.\n\nView or check status:\nhttps://app.example.com/public/reserve/shopshop/confirmation/RSV-9ZFPT\n\nThank you,\nYour Company",
        "customerCancelSubjectSample": "Update on RSV-9ZFPT — Cover Court",
        "customerCancelBodySample": "Hi TEST1,\n\nYour booking RSV-9ZFPT for Cover Court on Sep 3, 2026 · 7:30–9:00pm was cancelled.\n\nBook another time:\nhttps://app.example.com/public/reserve/shopshop\n\nThank you,\nYour Company",
        "staffPendingSubjectSample": "[Reserve] New pending RSV-9ZFPT — Cover Court",
        "staffPendingBodySample": "New booking request for Your Company.\n\nReference: RSV-9ZFPT\nPlace: Cover Court\nWhen: Sep 3, 2026 · 7:30–9:00pm\nPrice: ₱140.00\nStatus: Pending\n\nCustomer\nName: TEST1\nEmail: test@gmail.com\nPhone: 9876543245654\n\nOpen Reservations in Abrafi:\nhttps://app.example.com/reserve/reservations"
      },
      "blocks": {
        "pageTitle": "Blocks — {{name}}",
        "pageSubtitle": "Mark date and time ranges as unavailable with a required note.",
        "backButton": "Back to place",
        "slotsLabel": "Slots for {{date}}",
        "multiSelectHint": "Tap consecutive times to select a block range. Tap again to unselect or shrink.",
        "selectedRangeSummary": "Selected: {{range}}",
        "noteLabel": "Note (required)",
        "saveButton": "Add block",
        "savingButton": "Saving…",
        "listTitle": "Existing blocks",
        "loading": "Loading…",
        "loadFailed": "Failed to load place.",
        "empty": "No blocks yet.",
        "colDate": "Date",
        "colTime": "Time",
        "colNote": "Note",
        "colActions": "Actions",
        "deleteButton": "Delete",
        "selectSlotToast": "Select a date and at least one slot range.",
        "noteRequiredToast": "Enter a note for this block.",
        "savingToast": "Saving block…",
        "createdToast": "Block created.",
        "saveFailedToast": "Could not save block.",
        "deletingToast": "Deleting block…",
        "deletedToast": "Block deleted.",
        "deleteFailedToast": "Could not delete block."
      },
      "addOns": {
        "pageTitle": "Add-ons",
        "pageSubtitle": "Create pricing add-ons guests can select when booking.",
        "backButton": "Back to places",
        "loading": "Loading add-ons…",
        "loadFailed": "Failed to load add-ons.",
        "empty": "No add-ons yet. Add an add-on with per-30-minutes and/or per-hour rates, or a fixed payment.",
        "newButton": "Add add-on",
        "colName": "Name",
        "colPricing": "Pricing",
        "colCreated": "Created",
        "colActions": "Actions",
        "nameLabel": "Name",
        "namePlaceholder": "e.g. Extra racket",
        "nameRequiredToast": "Enter an add-on name.",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Optional details guests will see",
        "pricingTypeLabel": "Pricing type",
        "pricingTypeHint": "You can select per 30 minutes and per hour together. Choosing fixed payment hides the rate options.",
        "pricingTypeRequiredToast": "Select per 30 minutes, per hour, and/or fixed payment.",
        "pricingType": {
          "per_30_minutes": "Per 30 minutes",
          "per_hour": "Per hour",
          "fixed": "Fixed payment"
        },
        "pricePer30MinutesLabel": "Price per 30 minutes",
        "pricePerHourLabel": "Price per hour",
        "priceFixedLabel": "Fixed price",
        "pricePlaceholder": "0.00",
        "price30MinutesRequiredToast": "Enter a price per 30 minutes.",
        "hourPriceRequiredToast": "Enter a price per hour.",
        "fixedPriceRequiredToast": "Enter a fixed price.",
        "priceDisplay30Minutes": "₱{{price}} / 30 min",
        "priceDisplayHour": "₱{{price}} / hr",
        "priceDisplayFixed": "₱{{price}} fixed",
        "createTitle": "Add add-on",
        "editTitle": "Edit add-on",
        "saveButton": "Save",
        "savingButton": "Saving…",
        "cancelButton": "Cancel",
        "createdToast": "Add-on created.",
        "updatedToast": "Add-on updated.",
        "deletedToast": "Add-on deleted.",
        "saveFailedToast": "Could not save add-on.",
        "deleteFailedToast": "Could not delete add-on.",
        "deleteConfirmTitle": "Delete {{name}}?",
        "deleteConfirmBody": "Remove add-on {{name}}? Guests will no longer be able to select it.",
        "deleteConfirmButton": "Delete",
        "deleteConfirmDismissButton": "Keep",
        "editButtonAria": "Edit",
        "deleteButtonAria": "Delete",
        "actionLoadingToast": "Updating…",
        "image": {
          "label": "Photo",
          "hintCreate": "Optional. Guests will see this photo when choosing add-ons. It uploads after you save.",
          "hintEdit": "Optional. Guests see this photo when choosing add-ons.",
          "uploadButton": "Upload photo",
          "uploadButtonShort": "Add photo",
          "replaceButton": "Replace photo",
          "replaceButtonShort": "Replace",
          "uploadingShort": "Uploading…",
          "uploadingToast": "Uploading photo…",
          "uploadedToast": "Photo uploaded.",
          "uploadFailedToast": "Could not upload photo.",
          "removingToast": "Removing photo…",
          "removedToast": "Photo removed.",
          "removeFailedToast": "Could not remove photo.",
          "removeAria": "Remove photo",
          "invalidTypeToast": "Use a JPEG, PNG, WebP, or GIF image."
        },
        "photoAlt": "Add-on photo"
      }
    },
    "publicReserve": {
      "places": {
        "title": "Book a place",
        "subtitle": "Choose a venue or room to reserve.",
        "lookupLink": "Check my reservation",
        "loading": "Loading places…",
        "loadFailed": "Failed to load places.",
        "retryButton": "Try again",
        "empty": "No places are available to book right now.",
        "pricePerSlot": "₱{{price}} / {{minutes}} min",
        "priceBoth": "₱{{price30}} / 30 min · ₱{{price60}} / 1 hr",
        "open24Hours": "Open 24 hours",
        "priceFromLabel": "From",
        "priceAmount": "₱{{price}}",
        "priceUnit": "per {{minutes}} min",
        "priceFromPerSlot": "From ₱{{price}} / {{minutes}} min",
        "bookCta": "Book",
        "photoCounter": "{{current}}/{{total}}",
        "prevPhotoAria": "Previous photo",
        "nextPhotoAria": "Next photo",
        "noPhoto": "No photo",
        "locationFallback": "Location",
        "mapAvailable": "Map",
        "mapAvailableTitle": "Map pin available on the booking page",
        "addOnsTeaser": "{{names}}",
        "addOnsTeaserMore": "{{names}} +{{count}} more",
        "weekdayPreset": {
          "mon-sun": "Mon–Sun",
          "mon-fri": "Mon–Fri",
          "fri-mon": "Fri–Mon",
          "sat-sun": "Sat–Sun"
        }
      },
      "place": {
        "loading": "Loading place…",
        "loadFailed": "Failed to load place.",
        "backButton": "All places",
        "venueTimeHint": "Times follow the venue's local calendar day.",
        "noPhotos": "No photos yet",
        "photoAlt": "{{name}} photo {{current}} of {{total}}",
        "photoStripAria": "Place photos",
        "seeAllPhotos": "See all photos",
        "morePhotos": "+{{count}} more",
        "closePhotosAria": "Close photo gallery",
        "bookingCardTitle": "Your booking",
        "asideEmptyTitle": "Select date & time",
        "asidePickHint": "Choose a day and consecutive slots to see your total here.",
        "pickDateLabel": "Pick a date",
        "pickDateHint": "Only open days for this place are selectable.",
        "slotsLabel": "Available times · {{date}}",
        "durationLabel": "Slot length",
        "ratesNoteLabel": "Rates",
        "stepLabel": "{{step}}",
        "addOnsChooseLabel": "Add-ons",
        "addOnsChooseHint": "Optional extras for this booking. Your total updates when you select any.",
        "addOnsChooseAria": "Available add-ons for this place",
        "addOnsNoneSelected": "No add-ons — place fee only.",
        "addOnsSelectedCount": "{{count}} add-ons selected",
        "addOnsSelectedCount_one": "{{count}} add-on selected",
        "addOnsSelectedCount_other": "{{count}} add-ons selected",
        "multiSelectHint": "Tap consecutive times to book a range. Tap again to shrink or clear.",
        "continueButton": "Continue",
        "addOnPriceFixed": "₱{{price}} fixed",
        "addOnPriceBoth": "₱{{price30}} / 30 min · ₱{{price60}} / 60 min",
        "addOnPrice30Minutes": "₱{{price}} / 30 min",
        "addOnPriceHour": "₱{{price}} / 60 min",
        "addOnPriceForDuration": "₱{{price}} for {{duration}}",
        "addOnPriceFree": "Free",
        "addOnPriceMetaDuration": "for {{duration}}",
        "addOnPriceMetaFixed": "fixed",
        "mapSectionTitle": "Where to go",
        "mapSectionAria": "Place location on map"
      },
      "book": {
        "title": "Your details",
        "subtitle": "We'll use these to confirm your booking.",
        "subtitleWithPay": "We'll use these to confirm your booking, then you choose how to pay.",
        "subtitlePayOnly": "We'll use these to confirm your booking, then you pay now.",
        "subtitleUnavailable": "Online payment is not set up yet, and cash booking is disabled. Please contact the venue.",
        "bookingUnavailableToast": "Booking is unavailable right now. Please contact the venue.",
        "nameLabel": "Full name",
        "namePlaceholder": "Juan Dela Cruz",
        "emailLabel": "Email",
        "emailPlaceholder": "you@example.com",
        "phoneLabel": "Phone number",
        "phonePlaceholder": "09XX XXX XXXX",
        "submitButton": "Request booking",
        "payNowButton": "Pay now",
        "payNowCashOnlyButton": "Continue",
        "trustNote": "You'll review payment on the next step. No charge until you confirm.",
        "trustNoteCashOnly": "You'll confirm your cash booking on the next step.",
        "mobileBarHint": "Complete date, time, and your details above.",
        "submittingButton": "Submitting…",
        "nameRequiredToast": "Enter your name.",
        "emailRequiredToast": "Enter your email.",
        "phoneRequiredToast": "Enter your phone number.",
        "slotRequiredToast": "Select a date and available time slot.",
        "contiguousRequiredToast": "Select consecutive available times only.",
        "summaryDateLabel": "Date",
        "summaryTimeLabel": "Time",
        "summaryDurationLabel": "Duration",
        "summaryBaseLabel": "Place fee",
        "summaryTotalLabel": "Total",
        "durationSummary": "{{duration}}",
        "totalSummary": "₱{{price}}",
        "submittingToast": "Submitting booking…",
        "successToast": "Booking requested.",
        "failedToast": "Could not submit booking.",
        "payNowUnavailableToast": "Online payment is not available right now.",
        "payMethodRequiredToast": "Select a payment account before submitting.",
        "payModalTitle": "Pay now",
        "payModalHint": "Scan the QR or transfer using the details below, then upload your receipt.",
        "payModalHintTransferOnly": "Transfer using the details below, then upload your receipt.",
        "payModalSelectTitle": "Choose payment",
        "payModalSelectHint": "Select cash or a bank, then follow the next steps.",
        "payModalSelectHintBanksOnly": "Select the bank you will pay to, then upload your receipt.",
        "payModalAccountTitle": "Choose account",
        "payModalAccountHint": "Select which {{bank}} account you will pay to.",
        "payModalAccountLabel": "Account",
        "payModalAccountChooseAria": "Pay to {{account}} on {{bank}}",
        "payModalMethodLabel": "Payment method",
        "payModalBankLabel": "Bank",
        "payModalPaymentLabel": "Payment",
        "payModalCashName": "Cash",
        "payModalCashChooseAria": "Pay with cash on-site",
        "payModalCashTitle": "Cash payment",
        "payModalCashHint": "Pay cash on-site when you arrive. No receipt upload needed.",
        "payModalCashConfirmButton": "Confirm cash booking",
        "payModalComingSoon": "Coming soon",
        "payModalBankChooseAria": "Pay with {{bank}}",
        "payModalBankComingSoonAria": "{{bank}} is coming soon",
        "payModalChangeMethodButton": "Change",
        "payModalBackToMethodsButton": "Back",
        "payModalBackToBanksButton": "Back",
        "payModalCloseAria": "Close payment dialog",
        "payModalScanLabel": "Scan to pay",
        "payModalTransferLabel": "Or transfer to",
        "payModalTransferLabelOnly": "Transfer to",
        "payQrAlt": "Payment QR code",
        "bankNameLabel": "Bank",
        "accountNameLabel": "Account name",
        "accountNumberLabel": "Account number",
        "amountToPayLabel": "Amount to pay",
        "payComputationLabel": "Computation",
        "payComputationPlaceLabel": "Place fee",
        "payComputationAddOnLabel": "Add-on",
        "payComputationPlaceLine": "₱{{price}} for {{duration}}",
        "copyAccountNameAria": "Copy account name",
        "copyAccountNumberAria": "Copy account number",
        "copyAmountToPayAria": "Copy amount to pay",
        "copiedToast": "Copied.",
        "copyFailedToast": "Could not copy. Try again.",
        "proofLabel": "Proof of payment",
        "proofChooseButton": "Add receipt photo",
        "proofDropzoneHint": "Take a photo with your camera or choose a PNG/JPG file.",
        "proofTakePhotoButton": "Take photo",
        "proofChooseFileButton": "Choose file",
        "cameraStartingButton": "Starting camera…",
        "cameraCaptureButton": "Capture",
        "cameraCapturingButton": "Capturing…",
        "cameraCancelButton": "Cancel camera",
        "cameraPermissionToast": "Camera access was denied. Allow camera permission, or choose a file instead.",
        "cameraCaptureFailedToast": "Could not capture photo. Try again or choose a file.",
        "cameraPopupBlockedToast": "Camera window was blocked. Allow popups, or choose a file instead.",
        "proofChangeButton": "Change",
        "proofPreviewAlt": "Selected proof of payment",
        "proofRequiredToast": "Upload a proof of payment image.",
        "proofImageRequiredToast": "Proof of payment must be an image file.",
        "proofUploadFailedToast": "Could not upload proof of payment.",
        "payConfirmButton": "Submit payment proof",
        "paySubmittingButton": "Submitting…",
        "payModalCancelButton": "Cancel",
        "paySubmittingToast": "Submitting payment proof…",
        "paySuccessToast": "Payment proof submitted. Staff will review it.",
        "payFailedToast": "Could not submit payment proof.",
        "missingSlot": "Select a date and time before continuing.",
        "backButton": "Back",
        "summaryAddOnsLabel": "Add-ons",
        "addOnLine": "{{name}} · ₱{{price}}",
        "addOnLineFixed": "{{name}} · ₱{{total}} (fixed)",
        "addOnLinePer30": "{{name}} · ₱{{total}} (₱{{rate}} / 30 min × {{blocks}} for {{duration}})",
        "addOnLinePerHour": "{{name}} · ₱{{total}} (₱{{rate}} / hr × {{hours}} for {{duration}})",
        "addOnLineMixed": "{{name}} · ₱{{total}} (₱{{rate60}} / hr + ₱{{rate30}} / 30 min for {{duration}})",
        "payComputationAddOnLine": "{{name}} · ₱{{price}}",
        "payComputationAddOnLineFixed": "{{name}} · ₱{{total}} (fixed)",
        "payComputationAddOnLinePer30": "{{name}} · ₱{{total}} (₱{{rate}} / 30 min × {{blocks}} for {{duration}})",
        "payComputationAddOnLinePerHour": "{{name}} · ₱{{total}} (₱{{rate}} / hr × {{hours}} for {{duration}})",
        "payComputationAddOnLineMixed": "{{name}} · ₱{{total}} (₱{{rate60}} / hr + ₱{{rate30}} / 30 min for {{duration}})"
      },
      "cameraCapture": {
        "title": "Take receipt photo",
        "closeAria": "Close camera",
        "starting": "Starting camera…",
        "captureButton": "Capture",
        "capturingButton": "Capturing…",
        "cancelButton": "Cancel",
        "permissionDenied": "Camera access was denied. Close this window and choose a file instead.",
        "captureFailed": "Could not capture photo. Try again.",
        "openerMissing": "Open this camera from the Pay now dialog."
      },
      "authorizedScanCapture": {
        "title": "Scan authorized person",
        "closeAria": "Close scanner",
        "starting": "Starting camera…",
        "hint": "Point at the authorized person QR. This window closes when scanned.",
        "cancelButton": "Cancel",
        "permissionDenied": "Camera access was denied. Close this window and try again.",
        "openerMissing": "Open this scanner from the booking confirmation page."
      },
      "confirmation": {
        "title": "Booking requested",
        "titleConfirmed": "Booking confirmed",
        "titleReviewPayment": "Payment under review",
        "titleCancelled": "Booking cancelled",
        "subtitle": "We'll update this page when staff confirms your booking.",
        "subtitleConfirmed": "Your reservation is ready. You can print this confirmation letter.",
        "subtitleReviewPayment": "Staff is reviewing your payment. This page updates when they decide.",
        "subtitleCancelled": "This booking is no longer active.",
        "referenceLabel": "Booking reference",
        "placeLabel": "Place",
        "locationLabel": "Location",
        "whenLabel": "When",
        "priceLabel": "Place fee",
        "placeFeeLine": "₱{{price}} for {{duration}}",
        "totalLabel": "Total",
        "statusLabel": "Status",
        "remarksLabel": "Message from the venue",
        "letterEyebrow": "Reservation confirmation",
        "companyLogoAlt": "Company logo",
        "letterGreeting": "Dear guest,",
        "letterGreetingNamed": "Dear {{name}},",
        "letterIntro": "This letter confirms your booking. Please keep a copy for your visit.",
        "letterIntroWithCompany": "This letter confirms your booking with {{company}}. Please keep a copy for your visit.",
        "letterClosing": "Warm regards,",
        "qrTitle": "Open this confirmation online",
        "qrHint": "Scan this QR code to open this booking confirmation page.",
        "printButton": "Print confirmation",
        "cashOnSite": "Pay cash on-site when you arrive. Your request stays pending until staff confirms.",
        "cashScanHint": "Pay cash on-site, then tap Scan to complete and scan an authorized person QR to confirm.",
        "scanToCompleteButton": "Scan to complete",
        "scanModalTitle": "Scan authorized person",
        "scanModalHint": "Point the camera at the authorized person QR. Confirmation happens automatically when scanned.",
        "scanPopupHint": "A camera window opened on this computer. Point it at the authorized person QR.",
        "scanPopupWaiting": "Waiting for scan in the camera window…",
        "scanPopupBlockedToast": "Allow pop-ups for this site so the camera window can open.",
        "scanCancelButton": "Cancel",
        "scanConfirmingButton": "Confirming…",
        "scanCloseAria": "Close scanner",
        "scanVideoAria": "Camera preview for QR scan",
        "scanCameraStarting": "Starting camera…",
        "scanUnsupportedToast": "Could not start the camera scanner. Try again or use another browser.",
        "scanCameraToast": "Could not open the camera. Check permissions and try again.",
        "scanSuccessToast": "Booking confirmed.",
        "scanFailedToast": "Could not confirm with that code.",
        "scanSubmittingToast": "Confirming booking…",
        "reviewPaymentHint": "Your proof was received. You'll see Confirmed here once staff approves it.",
        "confirmedHint": "Show this reference at the venue if asked.",
        "cancelledHint": "Browse places to book another time.",
        "browseButton": "Browse places",
        "statusIconConfirmedAria": "Confirmed",
        "statusIconPendingAria": "Pending",
        "statusIconReviewAria": "Under review",
        "statusIconCancelledAria": "Cancelled",
        "loading": "Loading booking…",
        "notFound": "Booking not found.",
        "payNowButton": "Pay now",
        "payNowUnavailableToast": "Online payment QR is not available right now.",
        "payMethodRequiredToast": "Select a payment account before submitting.",
        "proofRequiredToast": "Upload a proof of payment image.",
        "proofImageRequiredToast": "Proof of payment must be an image file.",
        "proofUploadFailedToast": "Could not upload proof of payment.",
        "paySubmittingToast": "Submitting payment proof…",
        "paySuccessToast": "Payment proof submitted. Staff will review it.",
        "payFailedToast": "Could not submit payment proof.",
        "addOnsLabel": "Add-ons",
        "addOnLine": "{{name}} · ₱{{price}}",
        "addOnLineFixed": "{{name}} · ₱{{total}} (fixed)",
        "addOnLinePer30": "{{name}} · ₱{{total}} (₱{{rate}} / 30 min × {{blocks}} for {{duration}})",
        "addOnLinePerHour": "{{name}} · ₱{{total}} (₱{{rate}} / hr × {{hours}} for {{duration}})",
        "addOnLineMixed": "{{name}} · ₱{{total}} (₱{{rate60}} / hr + ₱{{rate30}} / 30 min for {{duration}})"
      },
      "lookup": {
        "title": "Check my reservation",
        "subtitle": "Look up by email and booking reference.",
        "subtitleWithRecent": "Open a saved booking, or search with email and reference.",
        "backButton": "Browse places",
        "emailLabel": "Email",
        "referenceLabel": "Booking reference",
        "searchTitle": "Search booking",
        "searchHint": "Enter both email and booking reference.",
        "submitButton": "Search",
        "loading": "Searching…",
        "empty": "No reservations found.",
        "loadFailed": "Lookup failed.",
        "criteriaRequiredToast": "Enter both email and booking reference.",
        "recentOnDeviceTitle": "Recent on this device",
        "recentOnDeviceHint": "Tap a booking to open its details.",
        "viewReservationButton": "View reservation",
        "payNowButton": "Pay now",
        "payNowUnavailableToast": "Online payment QR is not available right now.",
        "payMethodRequiredToast": "Select a payment account before submitting.",
        "proofRequiredToast": "Upload a proof of payment image.",
        "proofImageRequiredToast": "Proof of payment must be an image file.",
        "proofUploadFailedToast": "Could not upload proof of payment.",
        "paySubmittingToast": "Submitting payment proof…",
        "paySuccessToast": "Payment proof submitted. Staff will review it.",
        "payFailedToast": "Could not submit payment proof."
      }
    },
    "onboardingTour": {
      "skipButton": "Skip tour",
      "nextButton": "Next",
      "doneButton": "Done",
      "continueWithoutInstallingButton": "Continue without installing",
      "stepCounter": "Step {{current}} of {{total}}",
      "cashBooksBadge": "Essential",
      "steps": {
        "dashboard": {
          "title": "Start on your Dashboard",
          "body": "This is your home base — track performance, see what’s due, and jump into daily work from here. Click Next to continue."
        },
        "appsStoreNav": {
          "title": "Install apps from Apps Store",
          "body": "Open Apps Store in the sidebar to add the tools your business needs. Essential apps live here. Click Apps Store to continue."
        },
        "appsStoreCatalog": {
          "title": "Browse and install apps",
          "body": "Pick apps that match how you work. You can install more anytime as your business grows. Click Next when you’re ready to continue."
        },
        "cashBooks": {
          "title": "Install Cash Books first",
          "body": "Cash Books is the foundation for tracking money in and out — the basic need for every business. Owners can click Install, or click Next to continue without installing."
        },
        "uninstall": {
          "title": "Optional: uninstall later",
          "body": "Owners can remove an installed app anytime with Uninstall. You do not need to uninstall anything now — click Next to continue."
        },
        "helpNav": {
          "title": "Open the Help center",
          "body": "Use the Help icon in the sidebar footer anytime you need FAQs, guides, or to replay this walkthrough. Click Help to continue."
        },
        "help": {
          "title": "Replay the walkthrough here",
          "body": "This Help center section lets you replay the tour whenever you want. Click the highlighted area to finish."
        }
      }
    }
  },
  "components": {
    "abrafiDashboardBackLink": {
      "label": "Back to Abrafi Dashboard",
      "ariaLabel": "Back to Abrafi Dashboard"
    },
    "InlineDescriptionField": {
      "emptyRequiredToast": "Description cannot be empty.",
      "unchangedToast": "Description is unchanged.",
      "savingToast": "Saving description…",
      "savedToast": "Description saved.",
      "savingButton": "Saving description…",
      "saveButton": "Save description",
      "cancelButton": "Cancel"
    },
    "reserveProofImagePicker": {
      "label": "Proof of payment",
      "title": "Add receipt photo",
      "hint": "Take a photo with your camera or choose a PNG/JPG file.",
      "takePhotoButton": "Take photo",
      "chooseFileButton": "Choose file",
      "cameraStartingButton": "Starting camera…",
      "cameraCaptureButton": "Capture",
      "cameraCapturingButton": "Capturing…",
      "cameraCancelButton": "Cancel camera",
      "cameraCaptureFailedToast": "Could not capture photo. Try again or choose a file.",
      "cameraPopupBlockedToast": "Camera window was blocked. Allow popups, or choose a file instead.",
      "previewAlt": "Selected proof of payment"
    },
    "placeLocationMap": {
      "editableAria": "Map: click to set place location",
      "readonlyAria": "Place location map",
      "clickHint": "Paste a Google Maps link, or click the map to set the pin.",
      "clickHintShort": "Or click the map to place the pin.",
      "pasteLinkLabel": "Paste Maps link",
      "pasteLinkPlaceholder": "https://maps.google.com/... or lat, lng",
      "pasteLinkAria": "Paste a Google Maps link or latitude and longitude",
      "pasteLinkHelper": "Paste the full URL from the browser address bar (short maps.app.goo.gl links will not work), then press Enter.",
      "pasteLinkSuccessToast": "Pin moved to the pasted location.",
      "pasteLinkFailedToast": "Could not read that link. Paste the full Google Maps URL from the address bar (not maps.app.goo.gl), or lat, lng.",
      "coordsLabel": "{{latitude}}, {{longitude}}",
      "openInMaps": "Open in Google Maps",
      "clearPinButton": "Clear pin",
      "markerTitle": "Place location",
      "missingKeyHint": "Add VITE_GOOGLE_MAPS_API_KEY to abrafi/.env (Maps JavaScript API), then restart the Vite dev server.",
      "loadFailedHint": "Could not load Google Maps. Check the API key and that Maps JavaScript API is enabled.",
      "previewOpenEditableAria": "Open map to set or adjust place location",
      "previewOpenReadonlyAria": "Open enlarged place location map",
      "previewEmptyEditableTitle": "No pin yet",
      "previewEmptyReadonlyTitle": "Location",
      "previewPinnedStatus": "Pinned",
      "previewCtaSet": "Set location",
      "previewCtaAdjust": "Adjust pin",
      "previewCtaView": "View map",
      "previewMetaHint": "Open the map to drop a pin for guests.",
      "modalTitleEditable": "Set place location",
      "modalTitleReadonly": "Place location",
      "modalCoordsLabel": "{{latitude}}, {{longitude}}",
      "modalOpenInMaps": "Open in Google Maps",
      "modalClearPinButton": "Clear pin",
      "modalDoneButton": "Done"
    },
    "formField": {
      "fieldLengthHint": "{{count}} / {{max}} characters",
      "datePlaceholder": "MM/DD/YYYY"
    },
    "saveAnimatedButton": {
      "saving": "Saving…",
      "saved": "Saved"
    },
    "nativeMultiSelect": {
      "NativeMultiSelect": {
        "selectedCount": "{{count}} selected",
        "toggleOptionAria": "Toggle option"
      }
    },
    "premiumUpgrade": {
      "crownLabel": "Paid plan feature",
      "modalTitle": "Upgrade to unlock this feature",
      "modalBody": "{{featureName}} is included in paid plans.",
      "ownerHint": "Choose a plan on Billing — checkout takes about a minute, and you can return here right after payment.",
      "memberHint": "Ask your company owner to upgrade on Settings → Billing. You will get access as soon as the company plan is active.",
      "viewPlansButton": "View plans",
      "notNowButton": "Not now",
      "genericFeatureName": "This feature"
    },
    "salesTags": {
      "SalesTagMultiSelect": {
        "noTagsYet": "No tags yet. Type a name and press Enter to add one.",
        "addTagPlaceholder": "Search or add tags…",
        "addTagButton": "Add tag",
        "removePendingTagAria": "Remove tag {{name}}",
        "removeTagAria": "Remove tag {{name}}",
        "createTagOption": "Add \"{{name}}\""
      }
    },
    "expenseTags": {
      "ExpenseTagMultiSelect": {
        "noTagsYet": "No tags yet. Type a name and press Enter to add one.",
        "addTagPlaceholder": "Search or add tags…",
        "addTagButton": "Add tag",
        "removePendingTagAria": "Remove tag {{name}}",
        "removeTagAria": "Remove tag {{name}}",
        "createTagOption": "Add \"{{name}}\""
      }
    },
    "equipmentTags": {
      "EquipmentTagMultiSelect": {
        "noTagsYet": "No tags yet. Type a name and press Enter to add one.",
        "addTagPlaceholder": "Search or add tags…",
        "addTagButton": "Add tag",
        "removePendingTagAria": "Remove tag {{name}}",
        "removeTagAria": "Remove tag {{name}}",
        "createTagOption": "Add \"{{name}}\""
      }
    },
    "billTags": {
      "BillTagMultiSelect": {
        "noTagsYet": "No tags yet. Type a name and press Enter to add one.",
        "addTagPlaceholder": "Search or add tags…",
        "addTagButton": "Add tag",
        "removePendingTagAria": "Remove tag {{name}}",
        "removeTagAria": "Remove tag {{name}}",
        "createTagOption": "Add \"{{name}}\""
      }
    },
    "contactGroups": {
      "ContactGroupMultiSelect": {
        "noGroups": "No groups yet. Create one from Manage groups."
      },
      "CreateGroupFirstModal": {
        "title": "Add to group",
        "message": "You need to create a group first.",
        "cancel": "Cancel",
        "manageGroups": "Manage groups"
      },
      "ContactGroupFilterBar": {
        "filtersButton": "Filters",
        "filtersActiveLabel": "Active",
        "quickRangesLabel": "Groups",
        "label": "Filter by group",
        "clear": "Clear filters",
        "modeHint": {
          "inactive": "Click to include {{name}}",
          "include": "Including {{name}} — click to exclude",
          "exclude": "Excluding {{name}} — click to clear"
        }
      },
      "BulkAddToGroupModal": {
        "title": "Add to groups",
        "summary": "Add {{count}} selected contacts to a new or existing group.",
        "newGroupLabel": "New group name",
        "newGroupPlaceholder": "e.g. Promo Participants",
        "orExisting": "Or add to existing groups",
        "selectOrCreate": "Enter a new group name or select at least one existing group.",
        "selectAtLeastOne": "Select at least one group.",
        "cancel": "Cancel",
        "add": "Add to groups",
        "adding": "Adding…"
      },
      "ManageContactGroupsModal": {
        "title": "Manage groups",
        "createTitle": "Create group",
        "listTitle": "Your groups",
        "nameLabel": "Name",
        "descriptionLabel": "Description (optional)",
        "createButton": "Create group",
        "empty": "No groups yet.",
        "nameRequired": "Group name is required.",
        "save": "Save",
        "cancelEdit": "Cancel",
        "close": "Close",
        "editAria": "Edit {{name}}",
        "deleteAria": "Delete {{name}}"
      },
      "DeleteContactGroupConfirmModal": {
        "title": "Delete group",
        "message": "Delete the group \"{{name}}\"? Contacts stay in the list; only the group and its assignments are removed.",
        "cancel": "Cancel",
        "confirm": "Delete group",
        "deleting": "Deleting…"
      }
    },
    "NewFeatureIndicator": {
      "defaultLabel": "New"
    },
    "FeatureTipHelp": {
      "close": "Got it"
    },
    "notificationBell": {
      "trigger": {
        "ariaLabel": "Open notifications"
      },
      "panel": {
        "ariaLabel": "Notifications panel",
        "title": "Notifications",
        "loading": "Loading…",
        "retry": "Try again",
        "empty": "No notifications yet.",
        "markAsRead": "Mark as read",
        "markAllAsRead": "Mark all as read",
        "markAllAsReadConfirmTitle": "Mark all as read?",
        "markAllAsReadConfirmMessage": "All unread notifications will be marked as read. This cannot be undone.",
        "markAllAsReadConfirmButton": "Mark all as read",
        "markAllAsReadPending": "Marking…",
        "viewAll": "View All"
      },
      "taxDeadlineActions": {
        "howToFile": "How to File",
        "checkReports": "Check Reports",
        "finishNow": "Finish Now",
        "submitNow": "Submit Right Now",
        "getAssistance": "Get Assistance"
      }
    },
    "companySharedFileNote": {
      "text": "This is the company's one shared file. Updating it here updates it everywhere."
    },
    "companySharedDocument": {
      "loading": "Loading file…",
      "notUploaded": "Not uploaded",
      "upload": "Upload",
      "replace": "Replace",
      "uploading": "Uploading…",
      "uploaded": "Saved. This file is now the one shown everywhere.",
      "uploadFailed": "Could not upload the file.",
      "loadFailed": "Could not load the shared file.",
      "view": "View",
      "viewFailed": "Could not open the file.",
      "retry": "Try again"
    },
    "companyInfoButton": {
      "ariaLabel": "View company information",
      "noCompany": "Select a company to view its information.",
      "title": "Company information",
      "loading": "Loading company information.",
      "loadFailed": "Could not load company information.",
      "retry": "Try again",
      "close": "Close",
      "viewAllCompanyInformation": "View all company information",
      "emptyValue": "—",
      "owners": {
        "sectionTitle": "Owners",
        "empty": "No owner recorded",
        "sharePercent": "{{percent}}%",
        "name": "Owner name",
        "address": "Owner address",
        "birthday": "Birthday",
        "designation": "Designation",
        "otherAddress": "Address",
        "tin": "TIN",
        "contactNumber": "Contact number"
      },
      "documents": {
        "notUploaded": "Not uploaded",
        "view": "View",
        "viewFailed": "Could not open this document.",
        "openNamed": "View {{label}}"
      },
      "notes": {
        "sectionTitle": "Notes",
        "loading": "Loading notes.",
        "loadFailed": "Could not load notes.",
        "retry": "Try again",
        "empty": "No notes yet.",
        "editButton": "Edit",
        "saveButton": "Save",
        "savingButton": "Saving…",
        "cancelButton": "Cancel",
        "saveFailed": "Could not save notes.",
        "placeholder": "Write a note.",
        "editorLabel": "Company notes"
      },
      "temporaryUploads": {
        "sectionTitle": "Temporary uploads",
        "notice": "These files are not audited, do not appear in company history, and may be removed at any time.",
        "uploadButton": "Upload files",
        "uploadingButton": "Uploading…",
        "empty": "No temporary uploads.",
        "viewButton": "View",
        "deleteButton": "Delete",
        "confirmDelete": "Delete this file?",
        "confirmDeleteButton": "Delete file",
        "cancelDeleteButton": "Keep file",
        "deletingButton": "Deleting…",
        "loadFailed": "Could not load temporary uploads.",
        "retry": "Try again",
        "uploadFailed": "Could not upload those files.",
        "deleteFailed": "Could not delete that file.",
        "viewFailed": "Could not open that file.",
        "loading": "Loading temporary uploads.",
        "fileSizeBytes": "{{count}} B",
        "fileSizeKilobytes": "{{count}} KB",
        "fileSizeMegabytes": "{{count}} MB"
      },
      "groups": {
        "basic": "Basic information",
        "tax": "Tax registration",
        "contact": "Contact and address",
        "other": "Other company information"
      },
      "fields": {
        "name": "Company name",
        "tradeName": "Trade name",
        "lineOfBusiness": "Line of business",
        "address": "Company address",
        "tin": "Company TIN",
        "email": "Company email",
        "tel": "Company tel",
        "contactPersonName": "Contact person",
        "contactNumber": "Contact number",
        "bestTimeToCall": "Best time to call",
        "mission": "Mission",
        "vision": "Vision",
        "otherInformation": "Other company information",
        "rdo": "RDO",
        "taxRegime": "Tax regime",
        "incomeClassification": "Income classification",
        "vatRegistration": "VAT registration",
        "entityType": "Type of entity",
        "bmbeRegistrationNo": "BMBE registration no.",
        "documents": "Documents",
        "storePhotos": "Store photos",
        "bookStamps": "Book of accounts registration"
      },
      "entityTypes": {
        "soleProprietorship": "Sole Proprietorship",
        "opc": "One Person Corporation (OPC)",
        "corporation": "Corporation (Stock/Non-Stock)",
        "partnership": "Partnership (General/Limited)",
        "cooperative": "Cooperative"
      }
    },
    "sidebar": {
      "logoButton": {
        "ariaLabel": "Go to dashboard"
      },
      "closeButton": {
        "ariaLabel": "Close sidebar"
      },
      "mainNav": {
        "shortcuts": {
          "label": "Shortcuts"
        },
        "dashboard": {
          "label": "Dashboard",
          "hint": "Company overview and KPIs"
        },
        "superDashboard": {
          "label": "Super Dashboard",
          "hint": "Cross-company overview"
        },
        "superDashboardHealthChecks": {
          "label": "Health Checks",
          "hint": "Health of each company"
        },
        "superDashboardTaxReminders": {
          "label": "Tax reminders",
          "hint": "Upcoming filings across companies"
        },
        "superDashboardUploadEntries": {
          "label": "Upload Entries",
          "hint": "Receipts across companies"
        },
        "superDashboardUploadedEntriesEmail": {
          "label": "Uploaded Entries Email",
          "hint": "Daily digest settings"
        },
        "superDashboardActivityLogs": {
          "label": "Activity Logs",
          "hint": "Audit activity across companies"
        },
        "newTransactionSection": {
          "label": "New transaction"
        },
        "newSales": {
          "label": "New Sales",
          "hint": "Cash Receipts Journal"
        },
        "newExpense": {
          "label": "New Expense",
          "hint": "Cash Disbursement Journal"
        },
        "newCashVoucher": {
          "label": "New Cash Voucher",
          "hint": "Petty cash and vouchers"
        },
        "uploadEntry": {
          "label": "Upload Entry",
          "hint": "Upload receipts, encode later"
        },
        "newInvoice": {
          "label": "New Invoice",
          "hint": "Accounts Receivable"
        },
        "newBill": {
          "label": "New Bills",
          "hint": "Accounts Payable"
        },
        "newEquipment": {
          "label": "New PPE",
          "hint": "Property, Plant and Equipment"
        },
        "newCapital": {
          "label": "New Capital",
          "hint": "Manage Capital Entries"
        },
        "customEntry": {
          "label": "New Custom Entry",
          "hint": "General Journal"
        },
        "advancedSection": {
          "label": "Advanced"
        },
        "healthCheck": {
          "label": "Health Check",
          "hint": "Points for this company"
        },
        "taxCalendar": {
          "label": "Tax Calendar",
          "hint": "BIR deadlines and filings"
        },
        "journals": {
          "label": "Journals",
          "hint": "List of transactions"
        },
        "nonVatBooks": {
          "label": "Cash Books"
        },
        "reports": {
          "label": "Reports",
          "hint": "See the state of your business"
        },
        "billerManagement": {
          "label": "Bills"
        },
        "arInvoices": {
          "label": "Invoices"
        },
        "posSystem": {
          "label": "POS System",
          "hint": "Registers, sales, and inventory"
        },
        "equipmentManagement": {
          "label": "PPE"
        },
        "hris": {
          "label": "HRIS",
          "hint": "Employees, attendance, payroll"
        },
        "employeePortal": {
          "label": "Employee Portal",
          "hint": "My profile, leave, and attendance"
        },
        "capitalManagement": {
          "label": "Capitals"
        },
        "shop": {
          "label": "Online Shop",
          "hint": "Catalog, orders, and storefront"
        },
        "instoreqr": {
          "label": "InStoreQR",
          "hint": "QR channel ordering & kitchen display"
        },
        "appsStore": {
          "label": "Apps Store",
          "hint": "Browse and install apps"
        },
        "requests": {
          "label": "Requests",
          "hint": "Client requests and the company timeline"
        },
        "activityLogs": {
          "label": "Activity Logs",
          "hint": "Company audit trail"
        },
        "downloadables": {
          "label": "Downloadables",
          "hint": "Files for your installed apps"
        },
        "systemSection": {
          "label": "System"
        },
        "settings": {
          "label": "Settings",
          "hint": "Company and account preferences"
        },
        "superAdminHub": {
          "label": "Super Admin Hub"
        },
        "apiKeys": {
          "label": "API Keys",
          "hint": "Integrations and automations"
        },
        "fullScreen": {
          "label": "Full Screen"
        },
        "exitFullscreen": {
          "label": "Exit Fullscreen"
        },
        "businessCalendar": {
          "label": "Business Calendar",
          "hint": "Renewals and due dates"
        },
        "events": {
          "label": "Events",
          "hint": "Registration and check-in"
        },
        "reserve": {
          "label": "Reserve",
          "hint": "Places and bookings"
        },
        "fileManager": {
          "label": "File Manager",
          "hint": "Company files and folders"
        }
      },
      "settingsNav": {
        "backToMainMenu": {
          "label": "Back to main menu"
        },
        "sectionTitle": {
          "label": "Settings"
        },
        "general": {
          "label": "General"
        },
        "notifications": {
          "label": "Notifications"
        },
        "profile": {
          "label": "Profile"
        },
        "users": {
          "label": "Users"
        },
        "billing": {
          "label": "Billing"
        },
        "companySettings": {
          "label": "Company Settings"
        },
        "companyDetails": {
          "label": "Company Information"
        },
        "companies": {
          "label": "All Companies"
        },
        "customerCare": {
          "label": "Customer Care Support"
        },
        "appearance": {
          "label": "Appearance"
        },
        "logout": {
          "label": "Log out"
        },
        "installApp": {
          "label": "Install app"
        }
      },
      "superadminNav": {
        "backToMainMenu": {
          "label": "Back to main menu"
        },
        "sectionTitle": {
          "label": "Super Admin Hub"
        },
        "inventoryApk": {
          "label": "Inventory APK"
        },
        "openAiUsage": {
          "label": "OpenAI usage"
        },
        "grants": {
          "label": "Transaction grants"
        },
        "paymongoSettings": {
          "label": "PayMongo settings",
          "sectionTitle": {
            "label": "PayMongo settings"
          }
        },
        "backToSuperAdminHub": {
          "label": "Back to Super Admin Hub"
        },
        "paymentMethods": {
          "label": "Payment methods"
        },
        "paymongoConnection": {
          "label": "PayMongo connection"
        },
        "subscriptionPlans": {
          "label": "Subscription plans"
        }
      },
      "helpCard": {
        "ariaLabel": "Need help? See help options.",
        "title": "Need help?",
        "subtitle": "See help options."
      },
      "footer": {
        "helpAria": "Help",
        "themeLightAria": "Color theme: light. Activate to switch to dark mode.",
        "themeDarkAria": "Color theme: dark. Activate to switch to light mode.",
        "logoutAria": "Log out"
      }
    },
    "superadminGuard": {
      "loadingMessage": "Loading your account…",
      "loadFailedTitle": "Could not verify access",
      "loadFailedMessage": "We could not load your profile. Try again later or return to the dashboard.",
      "backToDashboardButton": "Go to dashboard"
    },
    "logoutConfirmModal": {
      "title": "Log out?",
      "body": "You will need to sign in again to access your account.",
      "cancelButton": "Cancel",
      "confirmButton": "Log out",
      "confirmButtonLoggingOut": "Logging out…"
    },
    "pageTitle": {
      "appName": "AbraFi",
      "metaDescription": {
        "default": "AbraFi helps businesses manage bookkeeping workflows and generate financial reports in one workspace.",
        "home": "AbraFi helps you manage bookkeeping workflows, upload receipts, and generate business-ready financial reports.",
        "taxCalculator": "Free Philippine income tax calculator: compare 8% flat tax, OSD, and itemized deductions before you sign up for AbraFi.",
        "dashboard": "Your command center in AbraFi: quickly review key service activity and keep operations moving.",
        "categories": "Organize master data in AbraFi with categories to structure transactions and reporting consistently.",
        "journals": "Open General Journal, General Ledger, and Cash Receipts Journal from one place in AbraFi.",
        "cashReceiptsJournal": "Record and review daily cash receipts in AbraFi—your digital cash receipts journal with official receipt (OR#) numbers.",
        "cashDisbursementJournal": "Record and review cash disbursements in AbraFi—your digital cash disbursements journal with check voucher (CV#) numbers.",
        "transactions": "Manage day-to-day activity in AbraFi: create, review, and organize transactions with receipts and expenses processing.",
        "inventory": "Manage inventory in AbraFi, including stock sources and product-level inventory views tied to your operations.",
        "reports": "Generate business reports in AbraFi, including income statements, balance sheets, cash flow, and general ledger reports.",
        "taxCompliance": "Track BIR filing deadlines, upload your COR, and manage tax types in AbraFi's tax calendar.",
        "equipment": "Track property, plant, and equipment (PPE), book value, and straight-line depreciation in AbraFi.",
        "hris": "Manage employees, attendance, leave, payroll, and HR reports for your company in AbraFi.",
        "reserve": "Manage bookable places, reservations, and public booking links for venues and rooms in AbraFi.",
        "posInventory": "Learn how to manage POS warehouses, receives, transfers, stock counts, and low-stock alerts in AbraFi.",
        "userProfile": "Update your profile in AbraFi to keep account details and company access accurate.",
        "company": "Create and manage companies in AbraFi to organize services, access, and collaboration for your team."
      },
      "routes": {
        "home": {
          "title": "Automated Bookkeeping"
        },
        "taxCalculator": {
          "title": "Tax Calculator"
        },
        "dashboard": {
          "title": "Dashboard"
        },
        "superDashboard": {
          "title": "Super Dashboard"
        },
        "superDashboardHealthChecks": {
          "title": "Health Checks"
        },
        "healthCheck": {
          "title": "Health Check"
        },
        "superDashboardTaxReminders": {
          "title": "Tax reminders"
        },
        "superDashboardUploadEntries": {
          "title": "Upload Entries"
        },
        "categories": {
          "title": "Categories"
        },
        "journals": {
          "title": "Journals"
        },
        "nonVatBooks": {
          "title": "Cash Books"
        },
        "customers": {
          "title": "Customers"
        },
        "customerEmail": {
          "title": "Email Customers"
        },
        "customerEmailRecentSends": {
          "title": "Recent Customer Emails"
        },
        "billInvoiceSettings": {
          "title": "Bill Invoice"
        },
        "suppliers": {
          "title": "Suppliers"
        },
        "transactions": {
          "title": "All Transactions"
        },
        "transactionsAdd": {
          "title": "Add Transaction"
        },
        "cashReceiptsJournal": {
          "title": "Cash Received List"
        },
        "cashDisbursementJournal": {
          "title": "Expenses List"
        },
        "reports": {
          "title": "Reports"
        },
        "incomeStatement": {
          "title": "Income Statement"
        },
        "balanceSheet": {
          "title": "Balance Sheet"
        },
        "cashFlowStatement": {
          "title": "Cash Flow"
        },
        "statementOfChangesInEquity": {
          "title": "Changes in Equity"
        },
        "generalLedger": {
          "title": "General Ledger"
        },
        "itemsSoldLedger": {
          "title": "Items Sold Ledger"
        },
        "trialBalance": {
          "title": "Trial Balance"
        },
        "generalJournal": {
          "title": "General Journal"
        },
        "cashReceiptsJournalReport": {
          "title": "Cash Receipts Journal"
        },
        "cashDisbursementJournalReport": {
          "title": "Cash Disbursements Journal"
        },
        "financialStatementGeneration": {
          "title": "Financial Statements"
        },
        "inventoryReport": {
          "title": "Inventory Report"
        },
        "inventory": {
          "title": "Inventory"
        },
        "inventoryAdd": {
          "title": "Add Inventory"
        },
        "inventorySources": {
          "title": "Inventory Sources"
        },
        "companies": {
          "title": "All Companies"
        },
        "settingsCompanyDetails": {
          "title": "Company Information"
        },
        "settingsCompanyDetailsEdit": {
          "title": "Edit Company Information"
        },
        "settingsCustomerCare": {
          "title": "Customer Care Support"
        },
        "companyLobby": {
          "title": "Select Company"
        },
        "taxCompliance": {
          "title": "Tax Calendar"
        },
        "billsLedgerNew": {
          "title": "New bill"
        },
        "equipment": {
          "title": "Property, Plant and Equipment (PPE)"
        },
        "equipmentNew": {
          "title": "New PPE"
        },
        "capitalManagement": {
          "title": "Capitals"
        },
        "equipmentDepreciationReport": {
          "title": "PPE Depreciation Report"
        },
        "hris": {
          "title": "HRIS"
        },
        "hrisEmployees": {
          "title": "Employees"
        },
        "hrisEmployeeCreate": {
          "title": "Add employee"
        },
        "hrisRoleManager": {
          "title": "Role Manager"
        },
        "hrisAttendance": {
          "title": "Attendance"
        },
        "hrisLeave": {
          "title": "Leave"
        },
        "hrisPayroll": {
          "title": "Payroll"
        },
        "hrisPayrollRun": {
          "title": "Payroll run"
        },
        "hrisReports": {
          "title": "HR Reports"
        },
        "hrisSettings": {
          "title": "HR Settings"
        },
        "hrisSelfService": {
          "title": "My HR"
        },
        "employeePortal": {
          "title": "Employee Portal"
        },
        "employeePortalAttendance": {
          "title": "My Attendance"
        },
        "employeePortalLeave": {
          "title": "My Leave"
        },
        "employeePortalPayslips": {
          "title": "My Payslips"
        },
        "employeePortalProfile": {
          "title": "My Profile"
        },
        "hrisGuide": {
          "title": "HRIS guide"
        },
        "reserve": {
          "title": "Reserve"
        },
        "reservePlacesNew": {
          "title": "New Place"
        },
        "reserveReservations": {
          "title": "Reservations"
        },
        "reserveEmail": {
          "title": "Reserve Email"
        },
        "reservePayment": {
          "title": "Reserve Payment"
        },
        "equipmentHelp": {
          "title": "Property, Plant and Equipment (PPE) Guide"
        },
        "posInventoryHelp": {
          "title": "POS Inventory Guide"
        },
        "downloadables": {
          "title": "Downloadables"
        },
        "settingsGeneral": {
          "title": "General Settings"
        },
        "settingsNotifications": {
          "title": "Notification Settings"
        },
        "settingsChangePassword": {
          "title": "Change Password"
        },
        "settingsCompany": {
          "title": "Company Settings"
        },
        "settingsProfile": {
          "title": "Profile"
        },
        "superAdminPaymentMethods": {
          "title": "Checkout payment methods"
        },
        "superAdminPaymongoConnection": {
          "title": "PayMongo connection"
        },
        "superAdminSubscriptionPlans": {
          "title": "Subscription plans"
        },
        "superAdminOpenAiUsage": {
          "title": "OpenAI usage"
        },
        "userProfile": {
          "title": "Profile"
        },
        "userChangePassword": {
          "title": "Change Password"
        }
      },
      "dynamic": {
        "transactionsEdit": {
          "title": "Edit Transaction"
        },
        "transactionsView": {
          "title": "View Transaction"
        },
        "cashReceiptsJournalNew": {
          "title": "Record Sales"
        },
        "cashReceiptsJournalEdit": {
          "title": "Edit Cash Receipt"
        },
        "cashReceiptsJournalView": {
          "title": "Cash Received Details"
        },
        "cashDisbursementJournalNew": {
          "title": "Record Expense"
        },
        "cashDisbursementJournalEdit": {
          "title": "Edit Expense"
        },
        "cashDisbursementJournalView": {
          "title": "Expense Details"
        },
        "productInventory": {
          "title": "Product Inventory"
        },
        "equipmentView": {
          "title": "PPE Details"
        },
        "equipmentEdit": {
          "title": "Edit PPE"
        },
        "hrisEmployee": {
          "title": "Employee Details"
        },
        "reservePlaceEdit": {
          "title": "Edit Place"
        },
        "reservePlaceBlocks": {
          "title": "Unavailable Blocks"
        }
      },
      "fallback": {
        "appName": "AbraFi"
      }
    },
    "JournalsHubBackLink": {
      "label": "Back"
    },
    "ModalSelectInput": {
      "addNamed": "Add \"{{name}}\"",
      "creating": "Creating…",
      "seeMore": "See more",
      "showingCount": "Showing {{shown}} of {{total}}",
      "noResults": "No results found."
    },
    "CategoryModalInput": {
      "CategoryModalInput": {
        "search_categories_1": "Search categories",
        "category_options_2": "Category options",
        "no_categories_found_3": "No categories found",
        "suggestedSectionLabel": "Suggested"
      }
    },
    "CustomerModalInput": {
      "CustomerModalInput": {
        "searchPlaceholder": "Search by name or account number",
        "optionsAria": "Customer options",
        "addNamed": "Add \"{{name}}\"",
        "recentLabel": "Recently used",
        "suggestedSectionLabel": "Suggested",
        "clear": "Clear",
        "clearCustomerAria": "Clear customer",
        "seeMore": "See more"
      }
    },
    "DescriptionModalInput": {
      "DescriptionModalInput": {
        "searchPlaceholder": "Search past descriptions",
        "optionsAria": "Description options",
        "useNamed": "Use \"{{name}}\"",
        "recentLabel": "Recently used",
        "suggestionsLabel": "Suggested",
        "seeMore": "See more",
        "loading": "Loading suggestions…",
        "emptySearchHint": "Type to search past descriptions or enter a new one.",
        "clearDescription": "Clear description"
      }
    },
    "SupplierModalInput": {
      "SupplierModalInput": {
        "searchPlaceholder": "Search by name or account number",
        "optionsAria": "Supplier options",
        "addLabel": "Add",
        "addNamed": "Add \"{{name}}\"",
        "recentLabel": "Recently used",
        "suggestionsLabel": "Suggested",
        "suggestedSectionLabel": "Suggested",
        "seeMore": "See more"
      }
    },
    "ProductModalInput": {
      "ProductModalInput": {
        "searchPlaceholder": "Search by name, SKU, or description",
        "optionsAria": "Product options",
        "noProductsFound": "No products found",
        "createNewProduct": "Create new product",
        "addNamed": "Create \"{{name}}\"",
        "seeMore": "See more"
      }
    },
    "CategorySearchInput": {
      "CategorySearchInput": {
        "search_categories_1": "Search categories",
        "loading_categories_3": "Loading categories",
        "category_options_2": "Category options",
        "no_categories_found_4": "No categories found",
        "locked_cash_parent_search_note_5": "Cash cannot be used as a parent. It is the system cash anchor for receipts and disbursements. Add bank accounts, petty cash, and e-wallets under Cash and Cash Equivalents instead."
      }
    },
    "ComingSoonStandalone": {
      "ComingSoonStandalone": {
        "coming_soon_1": "Coming soon",
        "simplify_the_work_2": "Simplify the work",
        "amplify_the_output_3": "Amplify the output"
      }
    },
    "companyOnboardingPrompt": {
      "ariaLabel": "Complete company profile reminder",
      "title": "Complete your company profile",
      "message": "Add or update your business details so AbraFi can tailor bookkeeping and tax settings for your company.",
      "registrationDateMissing": "Date of registration is missing.",
      "completeButton": "Complete company info",
      "addRegistrationDateButton": "Add date of registration"
    },
    "dashboardOverdueTaxPrompt": {
      "ariaLabel": "Overdue tax filing reminder",
      "title": "You have overdue tax filings",
      "message_one": "1 tax deadline is past due. Review your tax calendar and complete or update filing status.",
      "message_other": "{{count}} tax deadlines are past due. Review your tax calendar and complete or update filing status.",
      "viewButton": "View tax calendar",
      "message": "Message"
    },
    "dashboardBooksFreshnessPrompt": {
      "ariaLabelNever": "Books have never been updated",
      "ariaLabelToday": "Books last updated today",
      "ariaLabelDays_one": "Books last updated 1 day ago",
      "ariaLabelDays_other": "Books last updated {{count}} days ago",
      "ariaLabelDays": "Books freshness: last posting {{count}} days ago",
      "eyebrow": "Books last updated",
      "heroToday": "Today",
      "heroNever": "Never",
      "heroDaysAgo_one": "day ago",
      "heroDaysAgo_other": "days ago",
      "heroDaysAgo": "days ago",
      "supportNever": "No posted transactions yet. Start recording so your reports stay accurate.",
      "supportStale": "Last posting {{date}}. Catch up so reports stay current.",
      "supportCurrent": "Last posting {{date}}. Keep recording as new activity comes in.",
      "updateButton": "Update books"
    },
    "companyGuard": {
      "permissionDeniedTitle": "Access Denied",
      "permissionDeniedMessage": "You do not have permission to view this page. Please contact your company administrator or owner to request access.",
      "permissionDeniedGoBack": "Go Back",
      "permissionDeniedDashboard": "Dashboard",
      "profileLoadFailedTitle": "Could not load your account",
      "profileLoadFailedMessage": "We could not load your company access. Check your connection and try again.",
      "profileLoadFailedRetry": "Try again"
    },
    "CompanyGuard": {
      "CompanyGuard": {
        "access_denied_1": "Access denied",
        "loading_company_access_2": "Loading company access"
      }
    },
    "DatePicker": {
      "DatePicker": {
        "12_dd_4": "12 dd",
        "open_calendar_1": "Open calendar",
        "previous_2": "Previous",
        "next_3": "Next"
      }
    },
    "reportDateRangeFilter": {
      "registeredHint": "Registered: {{period}}",
      "loadErrorHint": "Couldn't load the registration date."
    },
    "DesktopAppHeader": {
      "DesktopAppHeader": {
        "app_header_1": "App header"
      }
    },
    "errorBoundary": {
      "title": "Something went wrong",
      "unexpectedMessage": "An unexpected error occurred.",
      "reloadButton": "Reload page"
    },
    "fx": {
      "FxFeatureSetupHint": {
        "enable_daily_fx_1": "You can record foreign-currency amounts using BSP exchange rates. Turn on Daily FX convert in",
        "add_currencies_2": "You can record foreign-currency amounts using BSP exchange rates. Choose at least one currency in",
        "company_settings_link_3": "Company Settings → Currency"
      },
      "BspCurrencySearchModal": {
        "search_currency_3": "Search currency",
        "currency_code_5": "Currency code",
        "e_g_sgd_1": "E g sgd",
        "loading_bsp_bulletin_currencies_6": "Loading bsp bulletin currencies",
        "bsp_currencies_2": "Bsp currencies"
      },
      "FxConversionFields": {
        "suggestions_1": "Suggested",
        "reference_rate_from_3": "Reference rate is from",
        "exchange_rate_inline_4": "Exchange rate (1 {{currencyCode}} -> {{rate}} {{ledgerCurrency}})",
        "editRate": "Edit / Change",
        "manualRateLabel": "Exchange rate (1 {{currencyCode}} -> {{ledgerCurrency}})",
        "bspRateAsOf": "BSP reference rate · as of {{date}}",
        "manualRateAsOf": "Manual exchange rate · as of {{date}}",
        "manualRateSource": "Manual exchange rate",
        "staleBulletinSuffix": "(last saved bulletin)"
      },
      "FxRateEditModal": {
        "title": "Change exchange rate",
        "historicalTitle": "Option A — Historical date fetch",
        "historicalDateLabel": "Select date",
        "historicalHint": "Fetches the BSP reference rate for the selected date when available.",
        "historicalLoading": "Loading BSP rate for this date…",
        "historicalPreview": "BSP rate: 1 {{currencyCode}} → {{rate}} {{ledgerCurrency}} · as of {{date}}",
        "historicalStaleSuffix": "(from saved archive)",
        "historicalNoRate": "No BSP rate is available for {{date}}. Enter the rate manually below.",
        "applyHistorical": "Apply historical rate",
        "historicalUnavailable": "Historical BSP lookup is not available yet. Enter the rate manually for backdated entries (Option B).",
        "manualTitle": "Option B — Manual customize",
        "manualRateLabel": "Exchange rate (1 {{currencyCode}} -> {{ledgerCurrency}})",
        "rateAsOfLabel": "Rate as of",
        "manualHint": "Use your bank rate or the BSP bulletin for the date you selected.",
        "cancel": "Cancel",
        "apply": "Apply rate"
      },
      "ForeignCurrencyEntrySection": {
        "searchCurrency": "Search currency"
      }
    },
    "Header": {
      "Header": {
        "search_ctrl_k_1": "Search ctrl k",
        "search_ctrl_k_3": "Search ctrl k",
        "companies_2": "Companies",
        "create_company_4": "Create company"
      }
    },
    "MobileAppHeader": {
      "MobileAppHeader": {
        "go_to_dashboard_1": "Go to dashboard"
      }
    },
    "Pagination": {
      "Pagination": {
        "1_pagenumber_1": "1 pagenumber",
        "rows_per_page_2": "Rows per page",
        "rows_3": "Rows",
        "go_to_page_4": "Go to page",
        "page_5": "Page"
      }
    },
    "ProductSearchInput": {
      "ProductSearchInput": {
        "clear_selection_1": "Clear selection"
      }
    },
    "ProtectedRoute": {
      "ProtectedRoute": {
        "loading_authentication_1": "Loading authentication"
      }
    },
    "ReceiptImageStrip": {
      "ReceiptImageStrip": {
        "delete_attachment_4": "Delete attachment",
        "open_attachment_in_new_tab_1": "Open attachment in new tab",
        "open_in_new_tab_5": "Open in new tab",
        "download_attachment_2": "Download attachment",
        "download_6": "Download",
        "close_attachment_viewer_3": "Close attachment viewer"
      }
    },
    "ReadonlyTransactionReceiptAttachments": {
      "sectionTitle": "Attachments",
      "imageStripTitleSingle": "attachment ({{count}})",
      "imageStripTitleMultiple": "attachments ({{count}})",
      "documentsTitle": "Documents",
      "addButton": "Add attachments",
      "addingButton": "Uploading…",
      "emptyState": "No attachments yet.",
      "attachedAt": "Attached {{date}}",
      "uploadingLabel": "Uploading",
      "uploadingStatus": "Uploading… {{percent}}%",
      "progressAriaLabel": "Upload progress for {{name}}: {{percent}} percent",
      "uploadFailedLabel": "Upload failed"
    },
    "TransactionReceiptAttachmentField": {
      "existingImageStripTitleSingle": "attachment ({{count}})",
      "existingImageStripTitleMultiple": "attachments ({{count}})",
      "addDocumentsButton": "Add",
      "addDocumentsHint": "Add one or more images or documents"
    },
    "RefreshButton": {
      "RefreshButton": {
        "refresh_1": "Refresh"
      }
    },
    "RouteChunkErrorBoundary": {
      "RouteChunkErrorBoundary": {
        "a_new_version_is_available_1": "A new version is available",
        "something_went_wrong_2": "Something went wrong"
      }
    },
    "RouteLoadingFallback": {
      "RouteLoadingFallback": {
        "loading_1": "Loading"
      }
    },
    "ScrollToTopButton": {
      "ScrollToTopButton": {
        "scroll_to_top_1": "Scroll to top"
      }
    },
    "SearchInput": {
      "SearchInput": {
        "0_highlightedindex_2": "0 highlightedindex",
        "clear_selection_1": "Clear selection"
      }
    },
    "SearchOverlay": {
      "SearchOverlay": {
        "search_1": "Search",
        "close_2": "Close",
        "clear_search_4": "Clear search"
      }
    },
    "Sidebar": {
      "SidebarCompanySwitcher": {
        "company_2": "Company",
        "companies_1": "Companies",
        "allCompanies": {
          "label": "All Companies",
          "upgradeModalBody": "{{featureName}} is available when at least one company you belong to has a paid plan.",
          "upgradeModalOwnerHint": "You already belong to at least one company. Switch to a company you own, open Settings → Billing, and upgrade it to a paid plan. Once any of your companies is paid, you can use All Companies here.",
          "upgradeModalMemberHint": "You already belong to at least one company, but none are on a paid plan yet. Ask a company owner to upgrade on Settings → Billing — you will get access as soon as one of your companies is paid."
        },
        "selectCompany": {
          "label": "Select company"
        },
        "createCompany": {
          "label": "Create Company"
        },
        "searchPlaceholder": "Search by name or TIN",
        "seeMore": "See more",
        "showingCount": "Showing {{shown}} of {{total}}",
        "noResults": "No companies found.",
        "booksFreshness": {
          "tooltip": "Books last updated {{date}} ({{code}}). Click for legend.",
          "neverTooltip": "Books never updated. Click for legend.",
          "helpTitle": "Books freshness badge",
          "helpLead": "This badge shows how long ago this company’s books were last updated (latest journal activity).",
          "helpLastPosted": "Last posting date: {{date}}",
          "helpNeverPosted": "No posted transactions yet.",
          "statusCurrent": "Status: up to date (within {{currentMax}} days).",
          "statusWarn": "Status: falling behind ({{currentMax}}–{{warnMax}} days).",
          "statusStale": "Status: overdue (more than {{warnMax}} days).",
          "statusNever": "Status: never updated.",
          "helpLegendTitle": "Badge codes",
          "legendSeconds": "Seconds ago (under 1 minute)",
          "legendMinutes": "Minutes ago (under 1 hour)",
          "legendHours": "Hours ago (under 1 day)",
          "legendDaysCurrent": "Days ago — green when within {{currentMax}} days",
          "legendDaysWarn": "Days ago — amber when {{currentMax}}–{{warnMax}} days",
          "legendMonths": "Months ago (approximate)",
          "legendYears": "Years ago (approximate)",
          "legendNever": "Never posted",
          "helpColorsTitle": "Colors",
          "colorCurrent": "Green — current (≤ {{currentMax}} days)",
          "colorWarn": "Amber — warning ({{currentMax}}–{{warnMax}} days)",
          "colorStale": "Red — stale (over {{warnMax}} days) or never posted",
          "helpClose": "Got it"
        }
      }
    },
    "Toast": {
      "Toast": {
        "close_1": "Close"
      }
    },
    "TransactionWizard": {
      "TransactionWizard": {
        "each_category_can_only_be_used_once_per_transact_25": "Each category can only be used once per transact",
        "please_enter_a_valid_amount_26": "Please enter a valid amount",
        "exchange_rate_is_not_available_yet_27": "Exchange rate is not available yet",
        "each_category_can_only_be_used_once_per_transact_28": "Each category can only be used once per transact",
        "category_created_and_applied_to_this_line_29": "Category created and applied to this line",
        "category_created_successfully_30": "Category created successfully",
        "back_5": "Back",
        "backToTransactions": "Back",
        "editing_entry_9": "Editing entry",
        "category_10": "Category",
        "search_for_a_category_1": "Search for a category",
        "type_12": "Type",
        "amount_15": "Amount",
        "date_16": "Date",
        "dateRequired": "Select a transaction date before saving.",
        "dateSuggestedLabel": "Suggested",
        "dateToday": "Today",
        "dateYesterday": "Yesterday",
        "attachment_8": "Attachment",
        "no_entries_yet_add_your_first_entry_to_get_start_17": "No entries yet add your first entry to get start",
        "emptyStateMessage": "No entries yet. Add your first entry to get started.",
        "addEntryButton": "Add Line Item",
        "debit_19": "Debit",
        "credit_20": "Credit",
        "edit_entry_6": "Edit entry",
        "remove_entry_7": "Remove entry",
        "total_debit_21": "Total debit",
        "total_credit_22": "Total credit",
        "difference_23": "Difference",
        "balanced_24": "Balanced",
        "enter_description_4": "Enter description",
        "addAttachmentLabel": "Add attachment",
        "documentAttachmentsTitle": "Documents",
        "openAttachmentInNewTab": "Open in new tab",
        "downloadAttachment": "Download file",
        "attachmentActionView": "View",
        "attachmentActionDownload": "Download",
        "openAttachmentName": "View {{name}} in a new tab",
        "downloadAttachmentName": "Download {{name}}",
        "removeAttachmentButton": "Remove",
        "attachmentRejectedToast": "Not added (unsupported type): {{files}}",
        "updateEntryButton": "Update Line Item",
        "draftLabel": "Draft",
        "validationNoEntries": "Please add at least one entry",
        "validationNotBalanced": "Transaction is not balanced",
        "eachCategoryOnce": "Each category can only be used once per transaction.",
        "editCategory": "Edit Category",
        "selectCategory": "Select Category",
        "debitOrCredit": "Debit or Credit",
        "enterAmount": "Enter Amount",
        "reviewTransaction": "Review Transaction",
        "titleSubtitle": "Manually record debit or credit transactions with customizable categories and amounts.",
        "entryCountOne": "{{count}} entry added",
        "entryCountMany": "{{count}} entries added",
        "skipToReview": "Skip to Review",
        "addAnother": "Add Another",
        "review": "Review",
        "suggestions": "Suggestions",
        "useForeignCurrency": "Use foreign currency",
        "searchCurrency": "Search currency",
        "reviewTransactions": "Review Transactions",
        "addDebitQuickRow": "Add Debit",
        "addCreditQuickRow": "Add Credit",
        "quickAddLineHint": "Start a new line as a debit or credit.",
        "noEntriesYetHint": "No entries yet. Add your first line to get started.",
        "quickAddCloseAriaLabel": "Close quick add",
        "quickAddChangeCategory": "Change",
        "quickAddDiscardButton": "Cancel",
        "quickAddCancelButton": "Done",
        "underParent": "Under {{parent}}",
        "createCategory": "Create category",
        "noDate": "No date",
        "description": "Description",
        "optional": "optional",
        "noDescription": "-",
        "editDescriptionAriaLabel": "Edit description",
        "saveDescriptionButton": "Save description",
        "cancelDescriptionButton": "Cancel",
        "savingDescription": "Saving description…",
        "savingDescriptionButton": "Saving description…",
        "descriptionSavedToast": "Description saved.",
        "descriptionUnchangedToast": "Description is unchanged.",
        "attachmentCountOne": "attachment (1)",
        "attachmentCountMany": "attachments ({{count}})",
        "saving": "Saving..."
      }
    },
    "periodLockBannerMessage": {
      "receiptLockedContactAdmin": "This receipt is locked for the selected period. Contact your company owner to unlock transactions.",
      "transactionLockedContactAdmin": "This transaction is locked for the selected period. Contact your company owner to unlock transactions.",
      "receiptLockedUnlockPrefix": "This receipt is locked for the selected period. Manage unlock rules in ",
      "transactionLockedUnlockPrefix": "This transaction is locked for the selected period. Manage unlock rules in ",
      "transactionLockingLink": "Transaction locking"
    },
    "routeChunkErrorBoundary": {
      "chunkTitle": "A new version is available",
      "chunkMessage": "The app was updated while this tab was open. Reload to load the latest version.",
      "reloadButton": "Reload page",
      "errorTitle": "Something went wrong",
      "errorMessage": "This page could not be displayed. Try reloading, or go back and try again."
    },
    "themePreferencePicker": {
      "appearanceLabel": "Color theme",
      "optionLight": "Light",
      "optionDark": "Dark",
      "optionSystem": "System",
      "helperText": "Choose light, dark, or match your device. Saved on this browser only."
    },
    "confirmActionModal": {
      "cancelButton": "Cancel"
    },
    "duplicateCategoryMergeModal": {
      "title": "Duplicate Categories Detected",
      "bodyLead": "Some categories appear more than once.",
      "bodyMerge": "When you save, duplicate categories will be automatically merged and their amounts combined.",
      "bodyReview": "Review the summary below to confirm this is what you intended.",
      "mergeAndSave": "Merge & Save",
      "reviewEntries": "Review Entries",
      "saving": "Saving…"
    },
    "ArInvoiceLineItemInput": {
      "ArInvoiceLineItemInput": {
        "placeholder": "Select product or sales category…",
        "searchPlaceholder": "Search products or sales categories…",
        "listboxLabel": "Invoice line items",
        "productsSectionLabel": "Products",
        "salesCategoriesSectionLabel": "Sales",
        "noResults": "No matching products or sales categories.",
        "clearSelection": "Clear selection"
      }
    },
    "reversalDateField": {
      "label": "Reversal date",
      "tooEarly": "Reversal date cannot be earlier than the transaction date.",
      "required": "Reversal date is required.",
      "today": "Today",
      "yesterday": "Yesterday",
      "originalDate": "Original date ({{date}})",
      "originalDateUnavailable": "Original date",
      "periodLocked": "Period is locked",
      "quickPicksLabel": "Reversal date shortcuts"
    },
    "confirmReplaceWithReversalModal": {
      "title": "Confirm save",
      "body": "Saving will reverse the original entry and post a replacement. Choose a reversal date for the reversing journal entry (required).",
      "cancelButton": "Cancel",
      "confirmButton": "Confirm",
      "confirmButtonPending": "Saving…"
    }
  },
  "utils": {
    "appPermissions": {
      "groups": {
        "journals": "Journals",
        "dashboard": "Dashboard",
        "reports": "Reports",
        "pos": "POS",
        "shop": "Online Shop",
        "instoreqr": "InStoreQR",
        "events": "Events",
        "reserve": "Reserve",
        "fileManager": "File Manager",
        "healthCheck": "Health Check",
        "taxCalendar": "Tax Calendar",
        "settings": "Settings",
        "hris": "HRIS",
        "employeePortal": "Employee Portal"
      },
      "subgroups": {
        "financialStatements": "Financial Statements",
        "journals": "Journals",
        "companySettings": "Company Settings",
        "companyManagement": "Company Management",
        "system": "System"
      },
      "permissions": {
        "record_income": "Record Income",
        "record_expenses": "Record Expenses",
        "biller_management": "Bills",
        "ar_invoices": "Invoices",
        "equipment_management": "PPE",
        "capital_management": "Capitals",
        "record_custom_transactions": "Record Custom Transactions",
        "categories": "Categories",
        "customers": "Customers",
        "send_customer_emails": "Send Customer Emails",
        "bill_invoice_settings": "Bill Invoice Settings",
        "suppliers": "Suppliers",
        "upload_entry": "Upload Entry",
        "upload_entry_upload_only": "Upload Entry (upload only)",
        "tax_calendar": "Tax Calendar",
        "tax_calendar_view_only": "Tax Calendar (View files only)",
        "withholding_tax_reports": "Withholding Tax Certificates and QAP",
        "dashboard_tax_reminders": "Tax Reminders (Dashboard)",
        "dashboard_total_income": "Total Income (Dashboard)",
        "dashboard_total_expenses": "Total Expenses (Dashboard)",
        "dashboard_total_profit": "Total Profit (Dashboard)",
        "dashboard_revenue_expenses_chart": "Revenue vs Operating Expenses Chart (Dashboard)",
        "dashboard_pnl_summary": "Profit & Loss Summary (Dashboard)",
        "dashboard_recent_transactions": "Recent Transactions (Dashboard)",
        "dashboard_expense_breakdown": "Expense Breakdown (Dashboard)",
        "reports_income_statement": "Statement of Comprehensive Income",
        "reports_trial_balance": "Trial Balance",
        "reports_balance_sheet": "Statement of Financial Position",
        "reports_cash_flow": "Statement of Cash Flow",
        "reports_equity": "Statement of Changes in Equity",
        "reports_fs": "Financial Statement Generation",
        "reports_cash_receipts_journal": "Cash Receipts Journal",
        "reports_cash_disbursement_journal": "Cash Disbursements Journal",
        "reports_ledger": "General Ledger",
        "reports_general_journal": "General Journal",
        "pos_system": "POS System",
        "shop": "Online Shop",
        "instoreqr": "InStoreQR",
        "settings_period_locks": "Transaction Period Locks",
        "settings_currency": "Currency",
        "settings_category_account_numbers": "Category Account Numbers",
        "view_companies": "View Company Information",
        "edit_company": "Edit Company Information",
        "api_keys": "API Keys",
        "requests": "Requests",
        "activity_logs": "Activity Logs",
        "apps_store": "Apps Store",
        "health_check": "Health Check",
        "hris": "HRIS (all modules)",
        "hris_employees": "HRIS Employees",
        "hris_attendance": "HRIS Attendance",
        "hris_leave": "HRIS Leave",
        "hris_payroll": "HRIS Payroll",
        "hris_settings": "HRIS Settings",
        "hris_reports": "HRIS Reports",
        "hris_self_service": "HRIS Self-Service",
        "employee_portal": "Employee (All Access)",
        "employee_portal_attendance": "Employee Attendance",
        "business_calendar": "Business Calendar",
        "events_management": "Events",
        "reserve": "Reserve",
        "file_manager": "File Manager"
      }
    },
    "posRegistersToasts": {
      "created": "Register created.",
      "updated": "Register saved.",
      "archived": "Register archived.",
      "restored": "Register restored."
    },
    "posRegisterSessionToasts": {
      "opened": "Register session started.",
      "closed": "Register session ended."
    },
    "posRegisterSaleToasts": {
      "insufficientStock": "Not enough stock for this product.",
      "completed": "Sale complete. Change: {{amount}}.",
      "refunded": "Products refunded successfully."
    },
    "posInventoryToasts": {
      "loadFailed": "Failed to load inventory.",
      "adjustSuccess": "Stock updated.",
      "adjustFailed": "Failed to adjust stock."
    },
    "posProductsToasts": {
      "created": "Product created.",
      "updated": "Product saved.",
      "draftSaved": "Draft saved.",
      "published": "Product published to the register.",
      "unpublished": "Product removed from the register.",
      "archived": "Product archived.",
      "restored": "Product restored.",
      "mediaUploaded": "Image added.",
      "mediaRemoved": "Image removed.",
      "noChangesToSave": "No changes to save."
    },
    "categoryActionAvailability": {
      "historyNoChanges": "This category has no change history to view.",
      "rootCannotDelete": "Root categories cannot be deleted.",
      "lockedCannotDelete": "This category is locked and cannot be deleted.",
      "alreadyDeleted": "This category has already been deleted.",
      "editAccountNumber": "Edit account number",
      "editCategory": "Edit category",
      "editNumberShort": "Edit number",
      "editShort": "Edit"
    },
    "duplicatePostingWarning": {
      "duplicateOrTitle": "Duplicate OR#",
      "similarTransactionTitle": "Similar transaction",
      "forceSubmit": "Force submit",
      "postAnyway": "Post anyway"
    },
    "transactionPeriodLockErrors": {
      "transactionPrecheckOwner": "This transaction date is locked. Unlock the range first in Transaction locking.",
      "transactionPrecheckMember": "This transaction is in a locked period. Contact your company administrator if you need changes.",
      "receiptPrecheckOwner": "This receipt date is in a locked period. Unlock the range first in Transaction locking.",
      "receiptPrecheckMember": "This receipt is in a locked period. Contact your company administrator if you need changes.",
      "paymentPrecheckOwner": "This payment date is in a locked period. Unlock the range first in Transaction locking.",
      "paymentPrecheckMember": "This payment is in a locked period. Contact your company administrator if you need changes.",
      "disbursementPrecheckOwner": "This disbursement date is in a locked period. Unlock the range first in Transaction locking.",
      "disbursementPrecheckMember": "This disbursement is in a locked period. Contact your company administrator if you need changes.",
      "apiLockedTransactionOwner": "This transaction is in a locked period.",
      "openTransactionLocking": "Open transaction locking",
      "apiLockedTransactionMember": "This transaction is in a locked period. Contact your company administrator if you need changes."
    },
    "themeCycle": {
      "lightAria": "Color theme: light. Activate to switch to dark mode.",
      "darkAria": "Color theme: dark. Activate to switch to system theme.",
      "systemAria": "Color theme: system (follows device). Activate to switch to light mode.",
      "changeAria": "Change color theme"
    },
    "cashReceiptsJournalToasts": {
      "salesRecorded": "Sales recorded. OR#: {{orNumber}}.",
      "salesRecordedWithAttachmentWarning": "Sales recorded (see attachment warning above). OR#: {{orNumber}}.",
      "attachmentsSkippedUnsupported": "Unsupported file type: {{files}}",
      "someAttachmentsSkipped": "Some attachments were skipped ({{details}}).",
      "receiptUpdated": "Sale updated.",
      "receiptUpdatedWithAttachmentWarning": "Sale updated (see attachment warning above).",
      "saleVoided": "Sale voided successfully.",
      "saleReposted": "New sale recorded from voided sale.",
      "saleRestored": "New sale recorded from voided sale.",
      "attachmentsAdded": "Attachment(s) added.",
      "attachmentsAddedWithSkipped": "Attachment(s) added. Skipped unsupported: {{names}}",
      "attachmentsAddFailed": "Failed to upload attachments."
    },
    "cashDisbursementJournalToasts": {
      "disbursementRecorded": "Expense recorded. OR#: {{orNumber}}.",
      "disbursementRecordedWithAttachmentWarning": "Expense recorded (see attachment warning above). OR#: {{orNumber}}.",
      "attachmentsSkippedUnsupported": "Unsupported file type: {{files}}",
      "someAttachmentsSkipped": "Some attachments were skipped ({{details}}).",
      "disbursementUpdated": "Expense updated.",
      "disbursementUpdatedWithAttachmentWarning": "Expense updated (see attachment warning above).",
      "expenseVoided": "Expense voided successfully.",
      "expenseRestored": "Expense restored successfully.",
      "expenseReposted": "New expense recorded from voided expense.",
      "attachmentsAdded": "Attachment(s) added.",
      "attachmentsAddedWithSkipped": "Attachment(s) added. Skipped unsupported: {{names}}",
      "attachmentsAddFailed": "Failed to upload attachments."
    },
    "transactionToasts": {
      "attachmentsAdded": "Attachment(s) added.",
      "attachmentsAddedWithSkipped": "Attachment(s) added. Skipped unsupported: {{names}}",
      "attachmentsAddFailed": "Failed to upload attachments."
    },
    "equipmentToasts": {
      "saving": "Saving PPE…",
      "saved": "PPE saved.",
      "recordingDepreciation": "Recording depreciation…",
      "depreciationRecorded": "Depreciation recorded.",
      "cancelling": "Cancelling…",
      "cancelled": "Voided successfully.",
      "someAttachmentsSkipped": "Some attachments were skipped ({{details}}).",
      "attachmentsSkippedUnsupported": "Unsupported file type: {{files}}"
    },
    "journalEntryFormDraft": {
      "draft_restored_1": "Your unsaved entry was restored."
    }
  }
}
